var rv = Object.defineProperty;
var av = (t, e, n) => e in t ? rv(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var X = (t, e, n) => av(t, typeof e != "symbol" ? e + "" : e, n);
import { createElementBlock as R, openBlock as O, renderSlot as te, computed as Z, normalizeClass as me, createVNode as Ce, withCtx as be, createCommentVNode as U, defineAsyncComponent as ov, createBlock as Se, resolveDynamicComponent as Js, watch as ct, Transition as Bn, mergeProps as bt, ref as ee, Fragment as ye, createElementVNode as J, Teleport as hp, shallowRef as xi, getCurrentScope as bc, onScopeDispose as wc, shallowReadonly as gs, unref as C, normalizeStyle as tt, createTextVNode as He, toDisplayString as ve, renderList as Te, defineComponent as Rt, onMounted as _t, onUnmounted as us, toRaw as _u, nextTick as Gt, h as ku, isProxy as mp, version as lv, reactive as er, mergeModels as Mn, useModel as Hn, withDirectives as Tt, vShow as sn, vModelCheckbox as Mu, withModifiers as et, vModelDynamic as uv, createSlots as It, normalizeProps as Pt, guardReactiveProps as jt, getCurrentInstance as _o, hasInjectionContext as pp, inject as cv, toValue as Zi, watchEffect as dv, useSlots as cs, toRef as Nr, isRef as Ed, render as $d, useAttrs as fv, onBeforeUpdate as hv, withKeys as cn, vModelRadio as gp, resolveComponent as mv } from "vue";
const pn = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [i, s] of e)
    n[i] = s;
  return n;
}, pv = {}, gv = { class: "whitespace-nowrap font-medium" };
function yv(t, e) {
  return O(), R("div", gv, [
    te(t.$slots, "default")
  ]);
}
const As = /* @__PURE__ */ pn(pv, [["render", yv]]), fE = {
  __name: "BaseBadge",
  props: {
    color: {
      type: String,
      default: "primary",
      validator: (t) => ["primary", "gray", "success", "danger", "info"].includes(t)
    }
  },
  setup(t) {
    const e = t, n = Z(() => {
      switch (e.color) {
        case "gray":
          return "bg-gray-100 text-gray-900";
        case "success":
          return "bg-success-50 text-success-900";
        case "info":
          return "bg-info-50 text-info-900";
        case "danger":
          return "bg-danger-50 text-danger-900";
        default:
          return "bg-primary-50 text-primary-900";
      }
    });
    return (i, s) => (O(), R("div", {
      class: me(["flex h-5 w-fit items-center rounded-md px-1", n.value])
    }, [
      Ce(As, { class: "flex items-center text-xs" }, {
        default: be(() => [
          te(i.$slots, "default")
        ]),
        _: 3
      })
    ], 2));
  }
}, vv = ["disabled"], bv = {
  key: 0,
  class: "loader"
}, wv = {
  __name: "BaseButton",
  props: {
    color: {
      type: String,
      default: "primary",
      validator: (t) => [
        "primary",
        "secondary",
        "subtle",
        "subtle-light",
        "outline-dark",
        "minimal-primary"
      ].includes(t)
    },
    disabled: Boolean,
    active: Boolean,
    flat: {
      type: String,
      default: "",
      validator: (t) => ["", "left", "right", "all"].includes(t)
    },
    small: {
      type: Boolean,
      default: !1
    },
    narrow: {
      type: Boolean,
      default: !1
    },
    square: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = Z(() => {
      const s = () => {
        if (e.disabled)
          return "bg-gray-200 text-gray-400 cursor-default";
        if (e.loading)
          return "bg-gray-200 text-transparent cursor-wait";
        switch (e.color) {
          case "secondary":
            return `bg-white border-gray-200 border box-border hover:bg-gray-100 ${e.active ? "bg-gray-200" : ""} active:bg-gray-200`;
          case "subtle":
            return `bg-gray-900 bg-opacity-0 hover:bg-opacity-10 ${e.active ? "bg-opacity-20" : ""} active:bg-opacity-20`;
          case "subtle-light":
            return `bg-gray-50 bg-opacity-0 hover:bg-opacity-10 ${e.active ? "bg-opacity-20" : ""} active:bg-opacity-20`;
          case "outline-dark":
            return `bg-transparant border-gray-900 border box-border hover:bg-gray-900 hover:text-white ${e.active ? "bg-gray-600 text-white" : ""} active:bg-gray-600 active:text-white`;
          case "minimal-primary":
            return `bg-transparant text-primary-500 box-border hover:bg-primary-500 hover:text-white ${e.active ? "bg-primary-200 text-white" : ""} active:bg-primary-200 active:text-white`;
          default:
            return `bg-primary text-white hover:bg-primary-600 ${e.active ? "bg-primary-700" : ""} active:bg-primary-700`;
        }
      }, r = () => {
        switch (e.flat) {
          case "left":
            return "rounded-r-lg";
          case "right":
            return "border-r-0 rounded-l-lg";
          case "all":
            return "border-r-0";
          default:
            return "rounded-lg";
        }
      }, a = () => e.small || e.narrow ? "px-2" : "px-4", o = () => e.small ? "h-8 text-sm" : "h-10 text-base", l = () => e.square ? e.small ? "w-8" : "w-10" : "";
      return [
        s(),
        r(),
        a(),
        o(),
        l()
      ];
    }), i = Z(() => e.disabled ? !0 : !!e.loading);
    return (s, r) => (O(), R("button", {
      class: me([n.value, "relative flex items-center justify-center"]),
      disabled: i.value
    }, [
      !t.disabled && t.loading ? (O(), R("span", bv)) : U("", !0),
      Ce(As, { class: "flex items-center" }, {
        default: be(() => [
          te(s.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      })
    ], 10, vv));
  }
}, Vs = /* @__PURE__ */ pn(wv, [["__scopeId", "data-v-8a290931"]]), yp = {
  __name: "BaseCard",
  props: {
    inner: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    return (e, n) => (O(), R("div", {
      class: me(["border border-gray-100 bg-white shadow", t.inner ? "rounded-lg" : "rounded-2xl"])
    }, [
      te(e.$slots, "default")
    ], 2));
  }
}, xv = {}, _v = { class: "border-b border-gray-100" };
function kv(t, e) {
  return O(), R("div", _v);
}
const Mv = /* @__PURE__ */ pn(xv, [["render", kv]]), Sv = (t, e, n) => {
  const i = t[e];
  return i ? typeof i == "function" ? i() : Promise.resolve(i) : new Promise((s, r) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      r.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + e + (e.split("/").length !== n ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, Xt = {
  __name: "BaseIcon",
  props: {
    name: {
      type: String,
      required: !0
    },
    filled: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = Z(() => {
      const i = e.filled ? "fill" : "line", s = e.name;
      return ov(
        () => Sv(/* @__PURE__ */ Object.assign({ "../../assets/icons/account-circle-fill.svg": () => import("./account-circle-fill-Cvy855TE.js"), "../../assets/icons/account-circle-line.svg": () => import("./account-circle-line-iY-Etbpo.js"), "../../assets/icons/add-fill.svg": () => import("./add-fill-BpOy_9Cn.js"), "../../assets/icons/add-line.svg": () => import("./add-line-DGffyUoa.js"), "../../assets/icons/align-vertically-fill.svg": () => import("./align-vertically-fill-Co3SBdM0.js"), "../../assets/icons/align-vertically-line.svg": () => import("./align-vertically-line-aHSsZyL_.js"), "../../assets/icons/arrow-down-double-fill.svg": () => import("./arrow-down-double-fill-C9j9dJqo.js"), "../../assets/icons/arrow-down-double-line.svg": () => import("./arrow-down-double-line-B5c7RZ4h.js"), "../../assets/icons/arrow-down-fill.svg": () => import("./arrow-down-fill-BBb9Rbsz.js"), "../../assets/icons/arrow-down-line.svg": () => import("./arrow-down-line-CNbvZSDa.js"), "../../assets/icons/arrow-down-s-fill.svg": () => import("./arrow-down-s-fill-ZCfW7mTE.js"), "../../assets/icons/arrow-down-s-line.svg": () => import("./arrow-down-s-line-B1nieTdB.js"), "../../assets/icons/arrow-left-down-fill.svg": () => import("./arrow-left-down-fill-34HDf76w.js"), "../../assets/icons/arrow-left-down-line.svg": () => import("./arrow-left-down-line-UgZWNb_W.js"), "../../assets/icons/arrow-left-fill.svg": () => import("./arrow-left-fill-BG-UNlxI.js"), "../../assets/icons/arrow-left-line.svg": () => import("./arrow-left-line-CGOBbv9D.js"), "../../assets/icons/arrow-left-s-fill.svg": () => import("./arrow-left-s-fill-DVQPy_fz.js"), "../../assets/icons/arrow-left-s-line.svg": () => import("./arrow-left-s-line-BhNNlEh_.js"), "../../assets/icons/arrow-left-up-fill.svg": () => import("./arrow-left-up-fill-DIQKR71u.js"), "../../assets/icons/arrow-left-up-line.svg": () => import("./arrow-left-up-line-BjzF6x0N.js"), "../../assets/icons/arrow-right-down-fill.svg": () => import("./arrow-right-down-fill-DQPpJgcq.js"), "../../assets/icons/arrow-right-down-line.svg": () => import("./arrow-right-down-line-DEZ8Zh8Z.js"), "../../assets/icons/arrow-right-fill.svg": () => import("./arrow-right-fill-DEDqzgKS.js"), "../../assets/icons/arrow-right-line.svg": () => import("./arrow-right-line-CDw3-oTH.js"), "../../assets/icons/arrow-right-s-fill.svg": () => import("./arrow-right-s-fill-DuiqanTr.js"), "../../assets/icons/arrow-right-s-line.svg": () => import("./arrow-right-s-line-B0f95yKc.js"), "../../assets/icons/arrow-right-up-fill.svg": () => import("./arrow-right-up-fill-Bi2phOAP.js"), "../../assets/icons/arrow-right-up-line.svg": () => import("./arrow-right-up-line-UMY-TFMl.js"), "../../assets/icons/arrow-up-down-fill.svg": () => import("./arrow-up-down-fill-CROgZKT-.js"), "../../assets/icons/arrow-up-down-line.svg": () => import("./arrow-up-down-line-CYHexelj.js"), "../../assets/icons/arrow-up-fill.svg": () => import("./arrow-up-fill-BIIG_Pm4.js"), "../../assets/icons/arrow-up-line.svg": () => import("./arrow-up-line-BqMUenPe.js"), "../../assets/icons/arrow-up-s-fill.svg": () => import("./arrow-up-s-fill-le-488t-.js"), "../../assets/icons/arrow-up-s-line.svg": () => import("./arrow-up-s-line-D2LhviTd.js"), "../../assets/icons/article-fill.svg": () => import("./article-fill-CJ3kyfs-.js"), "../../assets/icons/article-line.svg": () => import("./article-line-C_YmCM8M.js"), "../../assets/icons/bar-chart-2-fill.svg": () => import("./bar-chart-2-fill-BMePmXpE.js"), "../../assets/icons/bar-chart-2-line.svg": () => import("./bar-chart-2-line-B0lQiiuQ.js"), "../../assets/icons/barricade-fill.svg": () => import("./barricade-fill-DqaIQk2c.js"), "../../assets/icons/barricade-line.svg": () => import("./barricade-line-Du2do8rC.js"), "../../assets/icons/battery-fill.svg": () => import("./battery-fill-nyvAr8XG.js"), "../../assets/icons/battery-line.svg": () => import("./battery-line-W2VmyGZc.js"), "../../assets/icons/briefcase-4-fill.svg": () => import("./briefcase-4-fill--w9KPEh7.js"), "../../assets/icons/briefcase-4-line.svg": () => import("./briefcase-4-line-S0KdGKPM.js"), "../../assets/icons/calendar-fill.svg": () => import("./calendar-fill-DqiPYyhw.js"), "../../assets/icons/calendar-line.svg": () => import("./calendar-line-Bp90vVO6.js"), "../../assets/icons/check-fill.svg": () => import("./check-fill-CYgEGkJb.js"), "../../assets/icons/check-line.svg": () => import("./check-line-B4zKpv1C.js"), "../../assets/icons/checkbox-blank-circle-fill.svg": () => import("./checkbox-blank-circle-fill-tsGJb4oy.js"), "../../assets/icons/checkbox-blank-circle-line.svg": () => import("./checkbox-blank-circle-line-CfGuuYNg.js"), "../../assets/icons/checkbox-blank-fill.svg": () => import("./checkbox-blank-fill-CAzaa_8t.js"), "../../assets/icons/checkbox-blank-line.svg": () => import("./checkbox-blank-line-BQRJGW8D.js"), "../../assets/icons/checkbox-circle-fill.svg": () => import("./checkbox-circle-fill-XWUCUaW2.js"), "../../assets/icons/checkbox-circle-line.svg": () => import("./checkbox-circle-line-Bh5dWND3.js"), "../../assets/icons/checkbox-fill.svg": () => import("./checkbox-fill-DNiDYWT-.js"), "../../assets/icons/checkbox-indeterminate-fill.svg": () => import("./checkbox-indeterminate-fill-DCIXQtu2.js"), "../../assets/icons/checkbox-indeterminate-line.svg": () => import("./checkbox-indeterminate-line-B-LGCWzm.js"), "../../assets/icons/checkbox-line.svg": () => import("./checkbox-line-CnjBAAwq.js"), "../../assets/icons/circle-fill.svg": () => import("./circle-fill-BQkAjjON.js"), "../../assets/icons/circle-line.svg": () => import("./circle-line-CWMkrB-h.js"), "../../assets/icons/close-circle-fill.svg": () => import("./close-circle-fill-DJDVUL3J.js"), "../../assets/icons/close-circle-line.svg": () => import("./close-circle-line-Da-Bnq8z.js"), "../../assets/icons/close-fill.svg": () => import("./close-fill-B5DcxmOR.js"), "../../assets/icons/close-line.svg": () => import("./close-line-UIi0gUSd.js"), "../../assets/icons/community-fill.svg": () => import("./community-fill-TId0KJQ_.js"), "../../assets/icons/community-line.svg": () => import("./community-line-svvk54y7.js"), "../../assets/icons/contract-up-down-fill.svg": () => import("./contract-up-down-fill-DYFhOzfO.js"), "../../assets/icons/contract-up-down-line.svg": () => import("./contract-up-down-line-CZu-XRng.js"), "../../assets/icons/customer-service-2-fill.svg": () => import("./customer-service-2-fill-C88KLUMx.js"), "../../assets/icons/customer-service-2-line.svg": () => import("./customer-service-2-line-CWh12Frn.js"), "../../assets/icons/dashboard-3-fill.svg": () => import("./dashboard-3-fill-Cp8Km1BK.js"), "../../assets/icons/dashboard-3-line.svg": () => import("./dashboard-3-line-jM4Y9AJj.js"), "../../assets/icons/database-fill.svg": () => import("./database-fill-DJin56JW.js"), "../../assets/icons/database-line.svg": () => import("./database-line-CTfriF8n.js"), "../../assets/icons/delete-bin-fill.svg": () => import("./delete-bin-fill-CgwBOQMw.js"), "../../assets/icons/delete-bin-line.svg": () => import("./delete-bin-line-CvtyKyJZ.js"), "../../assets/icons/download-2-fill.svg": () => import("./download-2-fill-Bqx0t9AP.js"), "../../assets/icons/download-2-line.svg": () => import("./download-2-line-Duke6GU8.js"), "../../assets/icons/earth-fill.svg": () => import("./earth-fill-Dxrls7ga.js"), "../../assets/icons/earth-line.svg": () => import("./earth-line-XNtHshl2.js"), "../../assets/icons/equal-fill.svg": () => import("./equal-fill-BI9SmrYV.js"), "../../assets/icons/equal-line.svg": () => import("./equal-line-DBk0X-Hw.js"), "../../assets/icons/error-warning-fill.svg": () => import("./error-warning-fill-Dd75ngs1.js"), "../../assets/icons/error-warning-line.svg": () => import("./error-warning-line-ks5gYUst.js"), "../../assets/icons/euro-fill.svg": () => import("./euro-fill-BPLQ60rz.js"), "../../assets/icons/euro-line.svg": () => import("./euro-line-B0Y62vkX.js"), "../../assets/icons/expand-up-down-fill.svg": () => import("./expand-up-down-fill-qNvwM9qi.js"), "../../assets/icons/expand-up-down-line.svg": () => import("./expand-up-down-line-C1IWNhHf.js"), "../../assets/icons/external-link-fill.svg": () => import("./external-link-fill-Y2iHrTaV.js"), "../../assets/icons/external-link-line.svg": () => import("./external-link-line-Bl58jX7S.js"), "../../assets/icons/eye-fill.svg": () => import("./eye-fill-DVKxGJ9U.js"), "../../assets/icons/eye-line.svg": () => import("./eye-line-DFBduE1w.js"), "../../assets/icons/eye-off-fill.svg": () => import("./eye-off-fill-ChUL2odR.js"), "../../assets/icons/eye-off-line.svg": () => import("./eye-off-line-BtSzNdc-.js"), "../../assets/icons/file-chart-fill.svg": () => import("./file-chart-fill-DaroHyz-.js"), "../../assets/icons/file-chart-line.svg": () => import("./file-chart-line-aLyzP6xm.js"), "../../assets/icons/file-copy-fill.svg": () => import("./file-copy-fill-lLiJOolI.js"), "../../assets/icons/file-copy-line.svg": () => import("./file-copy-line-vVCfwDAd.js"), "../../assets/icons/file-excel-2-fill.svg": () => import("./file-excel-2-fill-Dgz5g5Cx.js"), "../../assets/icons/file-excel-2-line.svg": () => import("./file-excel-2-line-BVmMTJWg.js"), "../../assets/icons/file-settings-fill.svg": () => import("./file-settings-fill-CqConam9.js"), "../../assets/icons/file-settings-line.svg": () => import("./file-settings-line-CcJ6BDwf.js"), "../../assets/icons/filter-fill.svg": () => import("./filter-fill--tqcYxBQ.js"), "../../assets/icons/filter-line.svg": () => import("./filter-line-BsS47KfI.js"), "../../assets/icons/flashlight-fill.svg": () => import("./flashlight-fill-BkbSVACI.js"), "../../assets/icons/flashlight-line.svg": () => import("./flashlight-line-DHMeGOo6.js"), "../../assets/icons/git-repository-fill.svg": () => import("./git-repository-fill-7O2wS3dK.js"), "../../assets/icons/git-repository-line.svg": () => import("./git-repository-line-DTcOdqzR.js"), "../../assets/icons/history-fill.svg": () => import("./history-fill-Cc3GXeND.js"), "../../assets/icons/history-line.svg": () => import("./history-line-BfC3inss.js"), "../../assets/icons/information-fill.svg": () => import("./information-fill-CC0pLxfn.js"), "../../assets/icons/information-line.svg": () => import("./information-line-DcSJ3Zxs.js"), "../../assets/icons/input-field-fill.svg": () => import("./input-field-fill-k1oBjxNe.js"), "../../assets/icons/input-field-line.svg": () => import("./input-field-line-CW96ohtG.js"), "../../assets/icons/line-chart-fill.svg": () => import("./line-chart-fill-BMqeJCKj.js"), "../../assets/icons/line-chart-line.svg": () => import("./line-chart-line-D7HbPjR1.js"), "../../assets/icons/logout-box-fill.svg": () => import("./logout-box-fill-CJZ62pfm.js"), "../../assets/icons/logout-box-line.svg": () => import("./logout-box-line-CgZy0O_3.js"), "../../assets/icons/megaphone-fill.svg": () => import("./megaphone-fill-DI3p48os.js"), "../../assets/icons/megaphone-line.svg": () => import("./megaphone-line-D9BNXnV8.js"), "../../assets/icons/menu-fill.svg": () => import("./menu-fill-Cr8K_Npg.js"), "../../assets/icons/menu-line.svg": () => import("./menu-line-BJ6Cy6jV.js"), "../../assets/icons/money-euro-circle-fill.svg": () => import("./money-euro-circle-fill-Dze-EOhi.js"), "../../assets/icons/money-euro-circle-line.svg": () => import("./money-euro-circle-line-eXf72nVh.js"), "../../assets/icons/more-fill.svg": () => import("./more-fill-BLXLWy_A.js"), "../../assets/icons/more-line.svg": () => import("./more-line-jyCMspqE.js"), "../../assets/icons/notification-2-fill.svg": () => import("./notification-2-fill-DrF5M41T.js"), "../../assets/icons/notification-2-line.svg": () => import("./notification-2-line-DC519599.js"), "../../assets/icons/notification-fill.svg": () => import("./notification-fill-DrF5M41T.js"), "../../assets/icons/notification-line.svg": () => import("./notification-line-DC519599.js"), "../../assets/icons/pencil-fill.svg": () => import("./pencil-fill-1jkkXz6V.js"), "../../assets/icons/pencil-line.svg": () => import("./pencil-line-CGt-vSxL.js"), "../../assets/icons/plug-fill.svg": () => import("./plug-fill-BdiRYMV6.js"), "../../assets/icons/plug-line.svg": () => import("./plug-line-SsK57y9h.js"), "../../assets/icons/question-fill.svg": () => import("./question-fill-CiYKtxnA.js"), "../../assets/icons/question-line.svg": () => import("./question-line-DInD6S50.js"), "../../assets/icons/refresh-fill.svg": () => import("./refresh-fill-RdoQNO95.js"), "../../assets/icons/refresh-line.svg": () => import("./refresh-line-DPcbq7AG.js"), "../../assets/icons/scales-fill.svg": () => import("./scales-fill-BWA7q9nE.js"), "../../assets/icons/scales-line.svg": () => import("./scales-line-nJiuPD1T.js"), "../../assets/icons/search-fill.svg": () => import("./search-fill-C2PYrWG2.js"), "../../assets/icons/search-line.svg": () => import("./search-line-BES59_82.js"), "../../assets/icons/settings-3-fill.svg": () => import("./settings-3-fill-BxkD6PM6.js"), "../../assets/icons/settings-3-line.svg": () => import("./settings-3-line-BAsBeY6Z.js"), "../../assets/icons/shield-user-fill.svg": () => import("./shield-user-fill-CAaViBbw.js"), "../../assets/icons/shield-user-line.svg": () => import("./shield-user-line-CZoPXJgj.js"), "../../assets/icons/slideshow-2-fill.svg": () => import("./slideshow-2-fill-mf95RmQC.js"), "../../assets/icons/slideshow-2-line.svg": () => import("./slideshow-2-line-CCN5hS3V.js"), "../../assets/icons/stack-fill.svg": () => import("./stack-fill-ClJGA3lG.js"), "../../assets/icons/stack-line.svg": () => import("./stack-line-BgsaPC5l.js"), "../../assets/icons/stock-fill.svg": () => import("./stock-fill-PCw_Vx3t.js"), "../../assets/icons/stock-line.svg": () => import("./stock-line-DcdJpEE3.js"), "../../assets/icons/sun-fill.svg": () => import("./sun-fill-BBNqk6cz.js"), "../../assets/icons/sun-line.svg": () => import("./sun-line-Bo2oQZLh.js"), "../../assets/icons/time-fill.svg": () => import("./time-fill-yYP1K8vd.js"), "../../assets/icons/time-line.svg": () => import("./time-line-YhEJFBng.js"), "../../assets/icons/upload-2-fill.svg": () => import("./upload-2-fill-DADy9v9F.js"), "../../assets/icons/upload-2-line.svg": () => import("./upload-2-line-DY1UKOe2.js"), "../../assets/icons/user-fill.svg": () => import("./user-fill-dK9mc9FS.js"), "../../assets/icons/user-line.svg": () => import("./user-line-C8Sd030X.js"), "../../assets/icons/windy-fill.svg": () => import("./windy-fill-DB2ILyNu.js"), "../../assets/icons/windy-line.svg": () => import("./windy-line-C6ElW5ey.js") }), `../../assets/icons/${s}-${i}.svg`, 5)
      );
    });
    return (i, s) => (O(), Se(Js(n.value), {
      class: "inline-block h-[1em] w-[1em] fill-current",
      role: "img"
    }));
  }
}, Ov = { key: 1 }, Dv = /* @__PURE__ */ Object.assign({
  inheritAttrs: !1
}, {
  __name: "EscapeOverlay",
  props: {
    active: {
      type: Boolean,
      default: !1
    },
    shaded: {
      type: Boolean,
      default: !1
    }
  },
  emits: {
    escape: null
  },
  setup(t, { emit: e }) {
    const n = t, i = e;
    function s(r) {
      r.key === "Escape" && i("escape");
    }
    return ct(
      () => n.active,
      (r) => {
        r ? addEventListener("keyup", s) : removeEventListener("keyup", s);
      }
    ), (r, a) => t.shaded ? (O(), Se(Bn, { key: 0 }, {
      default: be(() => [
        t.active ? (O(), R("div", {
          key: 0,
          class: "fixed inset-0 bg-black bg-opacity-40",
          onClick: a[0] || (a[0] = (o) => r.$emit("escape"))
        })) : U("", !0)
      ]),
      _: 1
    })) : (O(), R("div", Ov, [
      t.active ? (O(), R("div", bt({ key: 0 }, r.$attrs, {
        class: "fixed inset-0",
        onClick: a[1] || (a[1] = (o) => r.$emit("escape"))
      }), null, 16)) : U("", !0)
    ]));
  }
}), Tv = /* @__PURE__ */ pn(Dv, [["__scopeId", "data-v-94a704f8"]]), Pv = {
  key: 0,
  class: "scrollbar-hide fixed inset-y-0 right-0 z-10 w-96 overflow-auto bg-white text-left shadow-xl"
}, Cv = {
  __name: "BaseDrawer",
  setup(t) {
    const e = ee(!1);
    function n() {
      e.value = !0;
    }
    function i() {
      e.value = !1;
    }
    return (s, r) => (O(), R(ye, null, [
      J("div", {
        class: "inline-block cursor-pointer",
        onClick: n
      }, [
        te(s.$slots, "trigger", {}, void 0, !0)
      ]),
      (O(), Se(hp, { to: "body" }, [
        Ce(Tv, {
          active: e.value,
          shaded: "",
          class: "z-10",
          onEscape: i
        }, null, 8, ["active"]),
        Ce(Bn, { name: "slide" }, {
          default: be(() => [
            e.value ? (O(), R("aside", Pv, [
              Ce(Vs, {
                color: "subtle",
                square: "",
                class: "!fixed right-2 top-2",
                onClick: i
              }, {
                default: be(() => [
                  Ce(Xt, {
                    name: "close",
                    class: "text-xl"
                  })
                ]),
                _: 1
              }),
              te(s.$slots, "content", {}, void 0, !0)
            ])) : U("", !0)
          ]),
          _: 3
        })
      ]))
    ], 64));
  }
}, hE = /* @__PURE__ */ pn(Cv, [["__scopeId", "data-v-1c7ff216"]]), Ns = Math.min, Ki = Math.max, Ja = Math.round, ya = Math.floor, Ti = (t) => ({
  x: t,
  y: t
}), Av = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Ev = {
  start: "end",
  end: "start"
};
function Su(t, e, n) {
  return Ki(t, Ns(e, n));
}
function Kr(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function ns(t) {
  return t.split("-")[0];
}
function Qr(t) {
  return t.split("-")[1];
}
function vp(t) {
  return t === "x" ? "y" : "x";
}
function xc(t) {
  return t === "y" ? "height" : "width";
}
function Bs(t) {
  return ["top", "bottom"].includes(ns(t)) ? "y" : "x";
}
function _c(t) {
  return vp(Bs(t));
}
function $v(t, e, n) {
  n === void 0 && (n = !1);
  const i = Qr(t), s = _c(t), r = xc(s);
  let a = s === "x" ? i === (n ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (a = eo(a)), [a, eo(a)];
}
function Rv(t) {
  const e = eo(t);
  return [Ou(t), e, Ou(e)];
}
function Ou(t) {
  return t.replace(/start|end/g, (e) => Ev[e]);
}
function Lv(t, e, n) {
  const i = ["left", "right"], s = ["right", "left"], r = ["top", "bottom"], a = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? s : i : e ? i : s;
    case "left":
    case "right":
      return e ? r : a;
    default:
      return [];
  }
}
function Iv(t, e, n, i) {
  const s = Qr(t);
  let r = Lv(ns(t), n === "start", i);
  return s && (r = r.map((a) => a + "-" + s), e && (r = r.concat(r.map(Ou)))), r;
}
function eo(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Av[e]);
}
function Fv(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function bp(t) {
  return typeof t != "number" ? Fv(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function to(t) {
  const {
    x: e,
    y: n,
    width: i,
    height: s
  } = t;
  return {
    width: i,
    height: s,
    top: n,
    left: e,
    right: e + i,
    bottom: n + s,
    x: e,
    y: n
  };
}
function Rd(t, e, n) {
  let {
    reference: i,
    floating: s
  } = t;
  const r = Bs(e), a = _c(e), o = xc(a), l = ns(e), u = r === "y", c = i.x + i.width / 2 - s.width / 2, d = i.y + i.height / 2 - s.height / 2, f = i[o] / 2 - s[o] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: c,
        y: i.y - s.height
      };
      break;
    case "bottom":
      h = {
        x: c,
        y: i.y + i.height
      };
      break;
    case "right":
      h = {
        x: i.x + i.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: i.x - s.width,
        y: d
      };
      break;
    default:
      h = {
        x: i.x,
        y: i.y
      };
  }
  switch (Qr(e)) {
    case "start":
      h[a] -= f * (n && u ? -1 : 1);
      break;
    case "end":
      h[a] += f * (n && u ? -1 : 1);
      break;
  }
  return h;
}
const Vv = async (t, e, n) => {
  const {
    placement: i = "bottom",
    strategy: s = "absolute",
    middleware: r = [],
    platform: a
  } = n, o = r.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(e));
  let u = await a.getElementRects({
    reference: t,
    floating: e,
    strategy: s
  }), {
    x: c,
    y: d
  } = Rd(u, i, l), f = i, h = {}, m = 0;
  for (let p = 0; p < o.length; p++) {
    const {
      name: g,
      fn: y
    } = o[p], {
      x: v,
      y: b,
      data: _,
      reset: M
    } = await y({
      x: c,
      y: d,
      initialPlacement: i,
      placement: f,
      strategy: s,
      middlewareData: h,
      rects: u,
      platform: a,
      elements: {
        reference: t,
        floating: e
      }
    });
    c = v ?? c, d = b ?? d, h = {
      ...h,
      [g]: {
        ...h[g],
        ..._
      }
    }, M && m <= 50 && (m++, typeof M == "object" && (M.placement && (f = M.placement), M.rects && (u = M.rects === !0 ? await a.getElementRects({
      reference: t,
      floating: e,
      strategy: s
    }) : M.rects), {
      x: c,
      y: d
    } = Rd(u, f, l)), p = -1);
  }
  return {
    x: c,
    y: d,
    placement: f,
    strategy: s,
    middlewareData: h
  };
};
async function wp(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: i,
    y: s,
    platform: r,
    rects: a,
    elements: o,
    strategy: l
  } = t, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = Kr(e, t), m = bp(h), g = o[f ? d === "floating" ? "reference" : "floating" : d], y = to(await r.getClippingRect({
    element: (n = await (r.isElement == null ? void 0 : r.isElement(g))) == null || n ? g : g.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(o.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: l
  })), v = d === "floating" ? {
    x: i,
    y: s,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, b = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(o.floating)), _ = await (r.isElement == null ? void 0 : r.isElement(b)) ? await (r.getScale == null ? void 0 : r.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, M = to(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: v,
    offsetParent: b,
    strategy: l
  }) : v);
  return {
    top: (y.top - M.top + m.top) / _.y,
    bottom: (M.bottom - y.bottom + m.bottom) / _.y,
    left: (y.left - M.left + m.left) / _.x,
    right: (M.right - y.right + m.right) / _.x
  };
}
const Nv = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: i,
      placement: s,
      rects: r,
      platform: a,
      elements: o,
      middlewareData: l
    } = e, {
      element: u,
      padding: c = 0
    } = Kr(t, e) || {};
    if (u == null)
      return {};
    const d = bp(c), f = {
      x: n,
      y: i
    }, h = _c(s), m = xc(h), p = await a.getDimensions(u), g = h === "y", y = g ? "top" : "left", v = g ? "bottom" : "right", b = g ? "clientHeight" : "clientWidth", _ = r.reference[m] + r.reference[h] - f[h] - r.floating[m], M = f[h] - r.reference[h], A = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(u));
    let E = A ? A[b] : 0;
    (!E || !await (a.isElement == null ? void 0 : a.isElement(A))) && (E = o.floating[b] || r.floating[m]);
    const I = _ / 2 - M / 2, S = E / 2 - p[m] / 2 - 1, $ = Ns(d[y], S), B = Ns(d[v], S), V = $, G = E - p[m] - B, P = E / 2 - p[m] / 2 + I, x = Su(V, P, G), k = !l.arrow && Qr(s) != null && P !== x && r.reference[m] / 2 - (P < V ? $ : B) - p[m] / 2 < 0, D = k ? P < V ? P - V : P - G : 0;
    return {
      [h]: f[h] + D,
      data: {
        [h]: x,
        centerOffset: P - x - D,
        ...k && {
          alignmentOffset: D
        }
      },
      reset: k
    };
  }
}), Bv = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, i;
      const {
        placement: s,
        middlewareData: r,
        rects: a,
        initialPlacement: o,
        platform: l,
        elements: u
      } = e, {
        mainAxis: c = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: p = !0,
        ...g
      } = Kr(t, e);
      if ((n = r.arrow) != null && n.alignmentOffset)
        return {};
      const y = ns(s), v = Bs(o), b = ns(o) === o, _ = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), M = f || (b || !p ? [eo(o)] : Rv(o)), A = m !== "none";
      !f && A && M.push(...Iv(o, p, m, _));
      const E = [o, ...M], I = await wp(e, g), S = [];
      let $ = ((i = r.flip) == null ? void 0 : i.overflows) || [];
      if (c && S.push(I[y]), d) {
        const P = $v(s, a, _);
        S.push(I[P[0]], I[P[1]]);
      }
      if ($ = [...$, {
        placement: s,
        overflows: S
      }], !S.every((P) => P <= 0)) {
        var B, V;
        const P = (((B = r.flip) == null ? void 0 : B.index) || 0) + 1, x = E[P];
        if (x)
          return {
            data: {
              index: P,
              overflows: $
            },
            reset: {
              placement: x
            }
          };
        let k = (V = $.filter((D) => D.overflows[0] <= 0).sort((D, N) => D.overflows[1] - N.overflows[1])[0]) == null ? void 0 : V.placement;
        if (!k)
          switch (h) {
            case "bestFit": {
              var G;
              const D = (G = $.filter((N) => {
                if (A) {
                  const L = Bs(N.placement);
                  return L === v || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  L === "y";
                }
                return !0;
              }).map((N) => [N.placement, N.overflows.filter((L) => L > 0).reduce((L, z) => L + z, 0)]).sort((N, L) => N[1] - L[1])[0]) == null ? void 0 : G[0];
              D && (k = D);
              break;
            }
            case "initialPlacement":
              k = o;
              break;
          }
        if (s !== k)
          return {
            reset: {
              placement: k
            }
          };
      }
      return {};
    }
  };
};
async function zv(t, e) {
  const {
    placement: n,
    platform: i,
    elements: s
  } = t, r = await (i.isRTL == null ? void 0 : i.isRTL(s.floating)), a = ns(n), o = Qr(n), l = Bs(n) === "y", u = ["left", "top"].includes(a) ? -1 : 1, c = r && l ? -1 : 1, d = Kr(e, t);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return o && typeof m == "number" && (h = o === "end" ? m * -1 : m), l ? {
    x: h * c,
    y: f * u
  } : {
    x: f * u,
    y: h * c
  };
}
const Wv = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, i;
      const {
        x: s,
        y: r,
        placement: a,
        middlewareData: o
      } = e, l = await zv(e, t);
      return a === ((n = o.offset) == null ? void 0 : n.placement) && (i = o.arrow) != null && i.alignmentOffset ? {} : {
        x: s + l.x,
        y: r + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, Hv = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: i,
        placement: s
      } = e, {
        mainAxis: r = !0,
        crossAxis: a = !1,
        limiter: o = {
          fn: (g) => {
            let {
              x: y,
              y: v
            } = g;
            return {
              x: y,
              y: v
            };
          }
        },
        ...l
      } = Kr(t, e), u = {
        x: n,
        y: i
      }, c = await wp(e, l), d = Bs(ns(s)), f = vp(d);
      let h = u[f], m = u[d];
      if (r) {
        const g = f === "y" ? "top" : "left", y = f === "y" ? "bottom" : "right", v = h + c[g], b = h - c[y];
        h = Su(v, h, b);
      }
      if (a) {
        const g = d === "y" ? "top" : "left", y = d === "y" ? "bottom" : "right", v = m + c[g], b = m - c[y];
        m = Su(v, m, b);
      }
      const p = o.fn({
        ...e,
        [f]: h,
        [d]: m
      });
      return {
        ...p,
        data: {
          x: p.x - n,
          y: p.y - i
        }
      };
    }
  };
};
function tr(t) {
  return xp(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function an(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function ii(t) {
  var e;
  return (e = (xp(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function xp(t) {
  return t instanceof Node || t instanceof an(t).Node;
}
function zn(t) {
  return t instanceof Element || t instanceof an(t).Element;
}
function Wn(t) {
  return t instanceof HTMLElement || t instanceof an(t).HTMLElement;
}
function Ld(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof an(t).ShadowRoot;
}
function Jr(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: i,
    display: s
  } = Sn(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && !["inline", "contents"].includes(s);
}
function Yv(t) {
  return ["table", "td", "th"].includes(tr(t));
}
function ko(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function kc(t) {
  const e = Mc(), n = Sn(t);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((i) => (n.willChange || "").includes(i)) || ["paint", "layout", "strict", "content"].some((i) => (n.contain || "").includes(i));
}
function jv(t) {
  let e = Pi(t);
  for (; Wn(e) && !zs(e); ) {
    if (ko(e))
      return null;
    if (kc(e))
      return e;
    e = Pi(e);
  }
  return null;
}
function Mc() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function zs(t) {
  return ["html", "body", "#document"].includes(tr(t));
}
function Sn(t) {
  return an(t).getComputedStyle(t);
}
function Mo(t) {
  return zn(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function Pi(t) {
  if (tr(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Ld(t) && t.host || // Fallback.
    ii(t)
  );
  return Ld(e) ? e.host : e;
}
function _p(t) {
  const e = Pi(t);
  return zs(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Wn(e) && Jr(e) ? e : _p(e);
}
function Br(t, e, n) {
  var i;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const s = _p(t), r = s === ((i = t.ownerDocument) == null ? void 0 : i.body), a = an(s);
  return r ? e.concat(a, a.visualViewport || [], Jr(s) ? s : [], a.frameElement && n ? Br(a.frameElement) : []) : e.concat(s, Br(s, [], n));
}
function kp(t) {
  const e = Sn(t);
  let n = parseFloat(e.width) || 0, i = parseFloat(e.height) || 0;
  const s = Wn(t), r = s ? t.offsetWidth : n, a = s ? t.offsetHeight : i, o = Ja(n) !== r || Ja(i) !== a;
  return o && (n = r, i = a), {
    width: n,
    height: i,
    $: o
  };
}
function Sc(t) {
  return zn(t) ? t : t.contextElement;
}
function Es(t) {
  const e = Sc(t);
  if (!Wn(e))
    return Ti(1);
  const n = e.getBoundingClientRect(), {
    width: i,
    height: s,
    $: r
  } = kp(e);
  let a = (r ? Ja(n.width) : n.width) / i, o = (r ? Ja(n.height) : n.height) / s;
  return (!a || !Number.isFinite(a)) && (a = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: a,
    y: o
  };
}
const qv = /* @__PURE__ */ Ti(0);
function Mp(t) {
  const e = an(t);
  return !Mc() || !e.visualViewport ? qv : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Uv(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== an(t) ? !1 : e;
}
function is(t, e, n, i) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const s = t.getBoundingClientRect(), r = Sc(t);
  let a = Ti(1);
  e && (i ? zn(i) && (a = Es(i)) : a = Es(t));
  const o = Uv(r, n, i) ? Mp(r) : Ti(0);
  let l = (s.left + o.x) / a.x, u = (s.top + o.y) / a.y, c = s.width / a.x, d = s.height / a.y;
  if (r) {
    const f = an(r), h = i && zn(i) ? an(i) : i;
    let m = f, p = m.frameElement;
    for (; p && i && h !== m; ) {
      const g = Es(p), y = p.getBoundingClientRect(), v = Sn(p), b = y.left + (p.clientLeft + parseFloat(v.paddingLeft)) * g.x, _ = y.top + (p.clientTop + parseFloat(v.paddingTop)) * g.y;
      l *= g.x, u *= g.y, c *= g.x, d *= g.y, l += b, u += _, m = an(p), p = m.frameElement;
    }
  }
  return to({
    width: c,
    height: d,
    x: l,
    y: u
  });
}
function Xv(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: i,
    strategy: s
  } = t;
  const r = s === "fixed", a = ii(i), o = e ? ko(e.floating) : !1;
  if (i === a || o && r)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Ti(1);
  const c = Ti(0), d = Wn(i);
  if ((d || !d && !r) && ((tr(i) !== "body" || Jr(a)) && (l = Mo(i)), Wn(i))) {
    const f = is(i);
    u = Es(i), c.x = f.x + i.clientLeft, c.y = f.y + i.clientTop;
  }
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + c.x,
    y: n.y * u.y - l.scrollTop * u.y + c.y
  };
}
function Gv(t) {
  return Array.from(t.getClientRects());
}
function Sp(t) {
  return is(ii(t)).left + Mo(t).scrollLeft;
}
function Zv(t) {
  const e = ii(t), n = Mo(t), i = t.ownerDocument.body, s = Ki(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), r = Ki(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
  let a = -n.scrollLeft + Sp(t);
  const o = -n.scrollTop;
  return Sn(i).direction === "rtl" && (a += Ki(e.clientWidth, i.clientWidth) - s), {
    width: s,
    height: r,
    x: a,
    y: o
  };
}
function Kv(t, e) {
  const n = an(t), i = ii(t), s = n.visualViewport;
  let r = i.clientWidth, a = i.clientHeight, o = 0, l = 0;
  if (s) {
    r = s.width, a = s.height;
    const u = Mc();
    (!u || u && e === "fixed") && (o = s.offsetLeft, l = s.offsetTop);
  }
  return {
    width: r,
    height: a,
    x: o,
    y: l
  };
}
function Qv(t, e) {
  const n = is(t, !0, e === "fixed"), i = n.top + t.clientTop, s = n.left + t.clientLeft, r = Wn(t) ? Es(t) : Ti(1), a = t.clientWidth * r.x, o = t.clientHeight * r.y, l = s * r.x, u = i * r.y;
  return {
    width: a,
    height: o,
    x: l,
    y: u
  };
}
function Id(t, e, n) {
  let i;
  if (e === "viewport")
    i = Kv(t, n);
  else if (e === "document")
    i = Zv(ii(t));
  else if (zn(e))
    i = Qv(e, n);
  else {
    const s = Mp(t);
    i = {
      ...e,
      x: e.x - s.x,
      y: e.y - s.y
    };
  }
  return to(i);
}
function Op(t, e) {
  const n = Pi(t);
  return n === e || !zn(n) || zs(n) ? !1 : Sn(n).position === "fixed" || Op(n, e);
}
function Jv(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let i = Br(t, [], !1).filter((o) => zn(o) && tr(o) !== "body"), s = null;
  const r = Sn(t).position === "fixed";
  let a = r ? Pi(t) : t;
  for (; zn(a) && !zs(a); ) {
    const o = Sn(a), l = kc(a);
    !l && o.position === "fixed" && (s = null), (r ? !l && !s : !l && o.position === "static" && !!s && ["absolute", "fixed"].includes(s.position) || Jr(a) && !l && Op(t, a)) ? i = i.filter((c) => c !== a) : s = o, a = Pi(a);
  }
  return e.set(t, i), i;
}
function eb(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: i,
    strategy: s
  } = t;
  const a = [...n === "clippingAncestors" ? ko(e) ? [] : Jv(e, this._c) : [].concat(n), i], o = a[0], l = a.reduce((u, c) => {
    const d = Id(e, c, s);
    return u.top = Ki(d.top, u.top), u.right = Ns(d.right, u.right), u.bottom = Ns(d.bottom, u.bottom), u.left = Ki(d.left, u.left), u;
  }, Id(e, o, s));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function tb(t) {
  const {
    width: e,
    height: n
  } = kp(t);
  return {
    width: e,
    height: n
  };
}
function nb(t, e, n) {
  const i = Wn(e), s = ii(e), r = n === "fixed", a = is(t, !0, r, e);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Ti(0);
  if (i || !i && !r)
    if ((tr(e) !== "body" || Jr(s)) && (o = Mo(e)), i) {
      const d = is(e, !0, r, e);
      l.x = d.x + e.clientLeft, l.y = d.y + e.clientTop;
    } else s && (l.x = Sp(s));
  const u = a.left + o.scrollLeft - l.x, c = a.top + o.scrollTop - l.y;
  return {
    x: u,
    y: c,
    width: a.width,
    height: a.height
  };
}
function Qo(t) {
  return Sn(t).position === "static";
}
function Fd(t, e) {
  return !Wn(t) || Sn(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function Dp(t, e) {
  const n = an(t);
  if (ko(t))
    return n;
  if (!Wn(t)) {
    let s = Pi(t);
    for (; s && !zs(s); ) {
      if (zn(s) && !Qo(s))
        return s;
      s = Pi(s);
    }
    return n;
  }
  let i = Fd(t, e);
  for (; i && Yv(i) && Qo(i); )
    i = Fd(i, e);
  return i && zs(i) && Qo(i) && !kc(i) ? n : i || jv(t) || n;
}
const ib = async function(t) {
  const e = this.getOffsetParent || Dp, n = this.getDimensions, i = await n(t.floating);
  return {
    reference: nb(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: i.width,
      height: i.height
    }
  };
};
function sb(t) {
  return Sn(t).direction === "rtl";
}
const rb = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Xv,
  getDocumentElement: ii,
  getClippingRect: eb,
  getOffsetParent: Dp,
  getElementRects: ib,
  getClientRects: Gv,
  getDimensions: tb,
  getScale: Es,
  isElement: zn,
  isRTL: sb
};
function ab(t, e) {
  let n = null, i;
  const s = ii(t);
  function r() {
    var o;
    clearTimeout(i), (o = n) == null || o.disconnect(), n = null;
  }
  function a(o, l) {
    o === void 0 && (o = !1), l === void 0 && (l = 1), r();
    const {
      left: u,
      top: c,
      width: d,
      height: f
    } = t.getBoundingClientRect();
    if (o || e(), !d || !f)
      return;
    const h = ya(c), m = ya(s.clientWidth - (u + d)), p = ya(s.clientHeight - (c + f)), g = ya(u), v = {
      rootMargin: -h + "px " + -m + "px " + -p + "px " + -g + "px",
      threshold: Ki(0, Ns(1, l)) || 1
    };
    let b = !0;
    function _(M) {
      const A = M[0].intersectionRatio;
      if (A !== l) {
        if (!b)
          return a();
        A ? a(!1, A) : i = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      b = !1;
    }
    try {
      n = new IntersectionObserver(_, {
        ...v,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(_, v);
    }
    n.observe(t);
  }
  return a(!0), r;
}
function Oc(t, e, n, i) {
  i === void 0 && (i = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: r = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = i, u = Sc(t), c = s || r ? [...u ? Br(u) : [], ...Br(e)] : [];
  c.forEach((y) => {
    s && y.addEventListener("scroll", n, {
      passive: !0
    }), r && y.addEventListener("resize", n);
  });
  const d = u && o ? ab(u, n) : null;
  let f = -1, h = null;
  a && (h = new ResizeObserver((y) => {
    let [v] = y;
    v && v.target === u && h && (h.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var b;
      (b = h) == null || b.observe(e);
    })), n();
  }), u && !l && h.observe(u), h.observe(e));
  let m, p = l ? is(t) : null;
  l && g();
  function g() {
    const y = is(t);
    p && (y.x !== p.x || y.y !== p.y || y.width !== p.width || y.height !== p.height) && n(), p = y, m = requestAnimationFrame(g);
  }
  return n(), () => {
    var y;
    c.forEach((v) => {
      s && v.removeEventListener("scroll", n), r && v.removeEventListener("resize", n);
    }), d == null || d(), (y = h) == null || y.disconnect(), h = null, l && cancelAnimationFrame(m);
  };
}
const Dc = Wv, Tp = Hv, Tc = Bv, ob = Nv, lb = (t, e, n) => {
  const i = /* @__PURE__ */ new Map(), s = {
    platform: rb,
    ...n
  }, r = {
    ...s.platform,
    _c: i
  };
  return Vv(t, e, {
    ...s,
    platform: r
  });
};
function ub() {
  return typeof window < "u";
}
function cb(t) {
  return Pp(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function db(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Pp(t) {
  return ub() ? t instanceof Node || t instanceof db(t).Node : !1;
}
function fb(t) {
  return t != null && typeof t == "object" && "$el" in t;
}
function Du(t) {
  if (fb(t)) {
    const e = t.$el;
    return Pp(e) && cb(e) === "#comment" ? null : e;
  }
  return t;
}
function Os(t) {
  return typeof t == "function" ? t() : C(t);
}
function hb(t) {
  return {
    name: "arrow",
    options: t,
    fn(e) {
      const n = Du(Os(t.element));
      return n == null ? {} : ob({
        element: n,
        padding: t.padding
      }).fn(e);
    }
  };
}
function Cp(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Vd(t, e) {
  const n = Cp(t);
  return Math.round(e * n) / n;
}
function Pc(t, e, n) {
  n === void 0 && (n = {});
  const i = n.whileElementsMounted, s = Z(() => {
    var E;
    return (E = Os(n.open)) != null ? E : !0;
  }), r = Z(() => Os(n.middleware)), a = Z(() => {
    var E;
    return (E = Os(n.placement)) != null ? E : "bottom";
  }), o = Z(() => {
    var E;
    return (E = Os(n.strategy)) != null ? E : "absolute";
  }), l = Z(() => {
    var E;
    return (E = Os(n.transform)) != null ? E : !0;
  }), u = Z(() => Du(t.value)), c = Z(() => Du(e.value)), d = ee(0), f = ee(0), h = ee(o.value), m = ee(a.value), p = xi({}), g = ee(!1), y = Z(() => {
    const E = {
      position: h.value,
      left: "0",
      top: "0"
    };
    if (!c.value)
      return E;
    const I = Vd(c.value, d.value), S = Vd(c.value, f.value);
    return l.value ? {
      ...E,
      transform: "translate(" + I + "px, " + S + "px)",
      ...Cp(c.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: h.value,
      left: I + "px",
      top: S + "px"
    };
  });
  let v;
  function b() {
    if (u.value == null || c.value == null)
      return;
    const E = s.value;
    lb(u.value, c.value, {
      middleware: r.value,
      placement: a.value,
      strategy: o.value
    }).then((I) => {
      d.value = I.x, f.value = I.y, h.value = I.strategy, m.value = I.placement, p.value = I.middlewareData, g.value = E !== !1;
    });
  }
  function _() {
    typeof v == "function" && (v(), v = void 0);
  }
  function M() {
    if (_(), i === void 0) {
      b();
      return;
    }
    if (u.value != null && c.value != null) {
      v = i(u.value, c.value, b);
      return;
    }
  }
  function A() {
    s.value || (g.value = !1);
  }
  return ct([r, a, o, s], b, {
    flush: "sync"
  }), ct([u, c], M, {
    flush: "sync"
  }), ct(s, A, {
    flush: "sync"
  }), bc() && wc(_), {
    x: gs(d),
    y: gs(f),
    strategy: gs(h),
    placement: gs(m),
    middlewareData: gs(p),
    isPositioned: gs(g),
    floatingStyles: y,
    update: b
  };
}
const mE = {
  __name: "BaseTooltip",
  props: {
    description: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: "gray"
    }
  },
  setup(t) {
    const e = ee(!1), n = ee(), i = ee(), s = ee(), { floatingStyles: r, middlewareData: a, placement: o } = Pc(
      n,
      i,
      {
        whileElementsMounted: Oc,
        placement: "top",
        middleware: [
          Dc(6),
          Tc({ padding: 50 }),
          Tp({ padding: 12 }),
          hb({ element: s })
        ]
      }
    );
    return (l, u) => {
      var c;
      return O(), R(ye, null, [
        J("div", bt({
          ref_key: "anchorRef",
          ref: n,
          class: "w-fit"
        }, l.$attrs, {
          onMouseover: u[0] || (u[0] = (d) => e.value = !0),
          onMouseleave: u[1] || (u[1] = (d) => e.value = !1)
        }), [
          te(l.$slots, "default", {}, () => [
            Ce(Xt, {
              name: "information",
              filled: "",
              class: me(`cursor-help text-${t.color}-300 hover:text-${t.color}-700`)
            }, null, 8, ["class"])
          ])
        ], 16),
        e.value ? (O(), R("div", {
          key: 0,
          ref_key: "tooltipRef",
          ref: i,
          class: "absolute left-0 top-0 z-50 w-[150px] whitespace-normal rounded-lg bg-gray-800 p-2 text-center text-xs font-normal text-white",
          style: tt(C(r))
        }, [
          te(l.$slots, "content", {}, () => [
            He(ve(t.description), 1)
          ]),
          J("div", {
            ref_key: "arrowRef",
            ref: s,
            class: me(["absolute size-2 rotate-45 bg-gray-800", C(o) === "top" ? "-bottom-1" : "-top-1"]),
            style: tt({
              left: ((c = C(a).arrow) == null ? void 0 : c.x) + "px"
            })
          }, null, 6)
        ], 4)) : U("", !0)
      ], 64);
    };
  }
};
function zr(t, e) {
  let n = { style: "decimal" };
  return e !== void 0 && (n.minimumFractionDigits = e, n.maximumFractionDigits = e), new Intl.NumberFormat(navigator.language, n).format(t);
}
const mb = [
  { value: 1e15, symbol: "P" },
  { value: 1e12, symbol: "T" },
  { value: 1e9, symbol: "G" },
  { value: 1e6, symbol: "M" },
  { value: 1e3, symbol: "k" }
], pb = 10;
function Ap(t, e) {
  let n = 1, i = e;
  for (const s of mb)
    if (Math.abs(t) >= s.value * pb) {
      n /= s.value, i = s.symbol + e;
      break;
    }
  return [n, i];
}
function gb(t, e, n) {
  const [i, s] = Ap(t, e);
  return `${zr(t * i, n)} ${s}`;
}
const yb = { class: "w-full table-auto border-separate border-spacing-0" }, vb = { class: "sticky top-0" }, bb = { key: 0 }, wb = {
  key: 0,
  class: "border-b border-gray-100"
}, xb = ["colspan"], _b = {
  key: 0,
  class: "border-b border-gray-100 bg-white"
}, kb = { class: "hover:bg-primary-50" }, Mb = {
  key: 0,
  class: "my-auto w-0 whitespace-nowrap border-b border-gray-100 pl-2 text-lg text-gray-900"
}, Sb = {
  key: 0,
  class: "border-b border-gray-100"
}, pE = {
  __name: "BaseTable",
  props: {
    /**
     * Object specifying the column specifications for each key. Keys correspond
     * with those in the `rows` prop. The order of the keys also dictates the
     * order of the columns. Missing keys are not displayed in the table.
     *
     * Can have the following properties:
     * - label (string): The label to display in the header for this column.
     * - classes (string): Additional classes to apply to this column's cells.
     * - rawNumbers (bool): Disable default number formatting for this column.
     * - group (string): Applies an additional group header to this and other
     *   columns with the same group. Columns without a group are are collected
     *   in a nameless group.
     *
     * Example:
     * {
     *   key1: {
     *     label: "Key 1",
     *     classes: "text-right",
     *     rawNumbers: true,
     *     group: "Group 1",
     *   },
     *   key2: ...
     * }
     */
    columns: {
      required: !0,
      type: Object
    },
    /**
     * Array of objects specifying the data for each row. Each object can contain
     * any number of keys, but only those that are also present in the `columns`
     * prop will be displayed in the table.
     *
     * Some special keys offer extra functionality:
     * - _id (string): An identifier that makes a named slot available for every
     *   cell in this row. The slot name is formatted as `<key>-<_id>`.
     * - _subtable (array): An array of objects that will be displayed as a
     *   subtable when the row is expanded. Same structure as the `rows` prop.
     */
    rows: {
      type: Array,
      required: !0
    },
    /**
     * Number of decimal places to display for numbers. Defaults to 0.
     */
    precision: {
      type: Number,
      default: 0
    },
    /**
     * Whether to show a button to expand/collapse rows with a subtable.
     */
    expandable: Boolean,
    /**
     * Whether to show the empty group at the end of the table instead of the
     * beginning.
     */
    emptyGroupLast: Boolean
  },
  setup(t) {
    const e = t, n = ee([]), i = Z(() => {
      const a = [], o = {};
      for (const [u, c] of Object.entries(e.columns))
        c.group ? a.includes(c.group) || a.push(c.group) : o[u] = c;
      const l = {};
      for (const u of a)
        for (const [c, d] of Object.entries(e.columns))
          d.group === u && (l[c] = d);
      return e.emptyGroupLast ? { ...l, ...o } : { ...o, ...l };
    }), s = Z(() => {
      const a = Object.values(i.value);
      let o = !0;
      const l = a.reduce((u, { group: c }) => (c && (o = !1), c = c ?? "", u[c] = (u[c] ?? 0) + 1, u), {});
      return o ? !1 : l;
    });
    function r(a) {
      n.value.includes(a) ? n.value = n.value.filter((o) => o !== a) : n.value.push(a);
    }
    return (a, o) => (O(), R("table", yb, [
      J("thead", vb, [
        s.value ? (O(), R("tr", bb, [
          t.expandable ? (O(), R("th", wb)) : U("", !0),
          (O(!0), R(ye, null, Te(s.value, (l, u) => (O(), R("th", {
            key: u,
            class: "border-b border-r border-gray-100 bg-white px-4 py-2.5 text-center text-xs font-medium uppercase tracking-widest text-gray-300 last:border-r-0",
            colspan: l
          }, [
            te(a.$slots, `group-${u}`, { groupHeader: u }, () => [
              He(ve(u), 1)
            ])
          ], 8, xb))), 128))
        ])) : U("", !0),
        J("tr", null, [
          t.expandable ? (O(), R("th", _b)) : U("", !0),
          (O(!0), R(ye, null, Te(i.value, ({ label: l, classes: u }, c) => (O(), R("th", {
            key: `column-${c}`,
            class: me(["border-b border-gray-100 bg-white px-4 py-4 text-left text-xs", u])
          }, [
            te(a.$slots, c, { header: l }, () => [
              He(ve(l), 1)
            ])
          ], 2))), 128))
        ])
      ]),
      J("tbody", null, [
        (O(!0), R(ye, null, Te(t.rows, (l, u) => (O(), R(ye, { key: u }, [
          J("tr", kb, [
            t.expandable ? (O(), R("td", Mb, [
              l._subtable ? (O(), Se(Vs, {
                key: 0,
                color: "subtle",
                narrow: "",
                onClick: (c) => r(u)
              }, {
                default: be(() => [
                  Ce(Xt, {
                    name: `${n.value.includes(u) ? "contract" : "expand"}-up-down`
                  }, null, 8, ["name"])
                ]),
                _: 2
              }, 1032, ["onClick"])) : U("", !0)
            ])) : U("", !0),
            (O(!0), R(ye, null, Te(i.value, ({ classes: c, rawNumbers: d }, f) => (O(), R("td", {
              key: f,
              class: me(["whitespace-nowrap border-b border-gray-100 px-4 py-4 text-sm text-gray-900", c])
            }, [
              te(a.$slots, `${f}-${l._id}`, { row: l }, () => [
                He(ve(typeof l[f] == "number" && !d ? C(zr)(l[f], l[f] === 0 ? 0 : t.precision) : l[f]), 1)
              ])
            ], 2))), 128))
          ]),
          l._subtable && n.value.includes(u) ? (O(!0), R(ye, { key: 0 }, Te(l._subtable, (c, d) => (O(), R("tr", {
            key: d,
            class: "bg-gray-50 hover:bg-primary-100"
          }, [
            t.expandable ? (O(), R("td", Sb)) : U("", !0),
            (O(!0), R(ye, null, Te(i.value, ({ classes: f, rawNumbers: h }, m) => (O(), R("td", {
              key: m,
              class: me(["whitespace-nowrap border-b border-gray-100 px-4 py-4 text-sm text-gray-900", f])
            }, [
              te(a.$slots, `${m}-${c._id}`, { row: c }, () => [
                He(ve(typeof c[m] == "number" && !h ? C(zr)(
                  c[m],
                  c[m] === 0 ? 0 : t.precision
                ) : c[m]), 1)
              ])
            ], 2))), 128))
          ]))), 128)) : U("", !0)
        ], 64))), 128))
      ])
    ]));
  }
}, Ob = { class: "mr-1 text-xl font-medium" }, Db = {
  key: 0,
  class: "text-xs font-normal"
}, Tb = { class: "font text-sm" }, gE = {
  __name: "MetricDisplay",
  props: {
    title: {
      type: [String, Number],
      required: !0
    },
    titleSuffix: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    return (e, n) => (O(), R("div", null, [
      J("div", null, [
        J("span", Ob, ve(t.title), 1),
        t.titleSuffix ? (O(), R("span", Db, ve(t.titleSuffix), 1)) : U("", !0)
      ]),
      J("p", Tb, [
        He(ve(t.content) + " ", 1),
        te(e.$slots, "contentSuffix")
      ])
    ]));
  }
}, Pb = { class: "mr-1 text-xl font-medium" }, Cb = {
  key: 0,
  class: "text-xs font-normal"
}, Ab = { class: "font flex items-center gap-1 text-sm" }, yE = {
  __name: "StatDisplayHorizontal",
  props: {
    title: {
      type: [String, Number],
      required: !0
    },
    titleSuffix: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    return (e, n) => (O(), R("div", null, [
      J("div", null, [
        J("span", Pb, ve(t.title), 1),
        t.titleSuffix ? (O(), R("span", Cb, ve(t.titleSuffix), 1)) : U("", !0)
      ]),
      J("p", Ab, [
        He(ve(t.content) + " ", 1),
        te(e.$slots, "contentSuffix")
      ])
    ]));
  }
};
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function ea(t) {
  return t + 0.5 | 0;
}
const pi = (t, e, n) => Math.max(Math.min(t, n), e);
function wr(t) {
  return pi(ea(t * 2.55), 0, 255);
}
function _i(t) {
  return pi(ea(t * 255), 0, 255);
}
function Xn(t) {
  return pi(ea(t / 2.55) / 100, 0, 1);
}
function Nd(t) {
  return pi(ea(t * 100), 0, 100);
}
const ln = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, Tu = [..."0123456789ABCDEF"], Eb = (t) => Tu[t & 15], $b = (t) => Tu[(t & 240) >> 4] + Tu[t & 15], va = (t) => (t & 240) >> 4 === (t & 15), Rb = (t) => va(t.r) && va(t.g) && va(t.b) && va(t.a);
function Lb(t) {
  var e = t.length, n;
  return t[0] === "#" && (e === 4 || e === 5 ? n = {
    r: 255 & ln[t[1]] * 17,
    g: 255 & ln[t[2]] * 17,
    b: 255 & ln[t[3]] * 17,
    a: e === 5 ? ln[t[4]] * 17 : 255
  } : (e === 7 || e === 9) && (n = {
    r: ln[t[1]] << 4 | ln[t[2]],
    g: ln[t[3]] << 4 | ln[t[4]],
    b: ln[t[5]] << 4 | ln[t[6]],
    a: e === 9 ? ln[t[7]] << 4 | ln[t[8]] : 255
  })), n;
}
const Ib = (t, e) => t < 255 ? e(t) : "";
function Fb(t) {
  var e = Rb(t) ? Eb : $b;
  return t ? "#" + e(t.r) + e(t.g) + e(t.b) + Ib(t.a, e) : void 0;
}
const Vb = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function Ep(t, e, n) {
  const i = e * Math.min(n, 1 - n), s = (r, a = (r + t / 30) % 12) => n - i * Math.max(Math.min(a - 3, 9 - a, 1), -1);
  return [s(0), s(8), s(4)];
}
function Nb(t, e, n) {
  const i = (s, r = (s + t / 60) % 6) => n - n * e * Math.max(Math.min(r, 4 - r, 1), 0);
  return [i(5), i(3), i(1)];
}
function Bb(t, e, n) {
  const i = Ep(t, 1, 0.5);
  let s;
  for (e + n > 1 && (s = 1 / (e + n), e *= s, n *= s), s = 0; s < 3; s++)
    i[s] *= 1 - e - n, i[s] += e;
  return i;
}
function zb(t, e, n, i, s) {
  return t === s ? (e - n) / i + (e < n ? 6 : 0) : e === s ? (n - t) / i + 2 : (t - e) / i + 4;
}
function Cc(t) {
  const n = t.r / 255, i = t.g / 255, s = t.b / 255, r = Math.max(n, i, s), a = Math.min(n, i, s), o = (r + a) / 2;
  let l, u, c;
  return r !== a && (c = r - a, u = o > 0.5 ? c / (2 - r - a) : c / (r + a), l = zb(n, i, s, c, r), l = l * 60 + 0.5), [l | 0, u || 0, o];
}
function Ac(t, e, n, i) {
  return (Array.isArray(e) ? t(e[0], e[1], e[2]) : t(e, n, i)).map(_i);
}
function Ec(t, e, n) {
  return Ac(Ep, t, e, n);
}
function Wb(t, e, n) {
  return Ac(Bb, t, e, n);
}
function Hb(t, e, n) {
  return Ac(Nb, t, e, n);
}
function $p(t) {
  return (t % 360 + 360) % 360;
}
function Yb(t) {
  const e = Vb.exec(t);
  let n = 255, i;
  if (!e)
    return;
  e[5] !== i && (n = e[6] ? wr(+e[5]) : _i(+e[5]));
  const s = $p(+e[2]), r = +e[3] / 100, a = +e[4] / 100;
  return e[1] === "hwb" ? i = Wb(s, r, a) : e[1] === "hsv" ? i = Hb(s, r, a) : i = Ec(s, r, a), {
    r: i[0],
    g: i[1],
    b: i[2],
    a: n
  };
}
function jb(t, e) {
  var n = Cc(t);
  n[0] = $p(n[0] + e), n = Ec(n), t.r = n[0], t.g = n[1], t.b = n[2];
}
function qb(t) {
  if (!t)
    return;
  const e = Cc(t), n = e[0], i = Nd(e[1]), s = Nd(e[2]);
  return t.a < 255 ? `hsla(${n}, ${i}%, ${s}%, ${Xn(t.a)})` : `hsl(${n}, ${i}%, ${s}%)`;
}
const Bd = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, zd = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function Ub() {
  const t = {}, e = Object.keys(zd), n = Object.keys(Bd);
  let i, s, r, a, o;
  for (i = 0; i < e.length; i++) {
    for (a = o = e[i], s = 0; s < n.length; s++)
      r = n[s], o = o.replace(r, Bd[r]);
    r = parseInt(zd[a], 16), t[o] = [r >> 16 & 255, r >> 8 & 255, r & 255];
  }
  return t;
}
let ba;
function Xb(t) {
  ba || (ba = Ub(), ba.transparent = [0, 0, 0, 0]);
  const e = ba[t.toLowerCase()];
  return e && {
    r: e[0],
    g: e[1],
    b: e[2],
    a: e.length === 4 ? e[3] : 255
  };
}
const Gb = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function Zb(t) {
  const e = Gb.exec(t);
  let n = 255, i, s, r;
  if (e) {
    if (e[7] !== i) {
      const a = +e[7];
      n = e[8] ? wr(a) : pi(a * 255, 0, 255);
    }
    return i = +e[1], s = +e[3], r = +e[5], i = 255 & (e[2] ? wr(i) : pi(i, 0, 255)), s = 255 & (e[4] ? wr(s) : pi(s, 0, 255)), r = 255 & (e[6] ? wr(r) : pi(r, 0, 255)), {
      r: i,
      g: s,
      b: r,
      a: n
    };
  }
}
function Kb(t) {
  return t && (t.a < 255 ? `rgba(${t.r}, ${t.g}, ${t.b}, ${Xn(t.a)})` : `rgb(${t.r}, ${t.g}, ${t.b})`);
}
const Jo = (t) => t <= 31308e-7 ? t * 12.92 : Math.pow(t, 1 / 2.4) * 1.055 - 0.055, ys = (t) => t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
function Qb(t, e, n) {
  const i = ys(Xn(t.r)), s = ys(Xn(t.g)), r = ys(Xn(t.b));
  return {
    r: _i(Jo(i + n * (ys(Xn(e.r)) - i))),
    g: _i(Jo(s + n * (ys(Xn(e.g)) - s))),
    b: _i(Jo(r + n * (ys(Xn(e.b)) - r))),
    a: t.a + n * (e.a - t.a)
  };
}
function wa(t, e, n) {
  if (t) {
    let i = Cc(t);
    i[e] = Math.max(0, Math.min(i[e] + i[e] * n, e === 0 ? 360 : 1)), i = Ec(i), t.r = i[0], t.g = i[1], t.b = i[2];
  }
}
function Rp(t, e) {
  return t && Object.assign(e || {}, t);
}
function Wd(t) {
  var e = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(t) ? t.length >= 3 && (e = { r: t[0], g: t[1], b: t[2], a: 255 }, t.length > 3 && (e.a = _i(t[3]))) : (e = Rp(t, { r: 0, g: 0, b: 0, a: 1 }), e.a = _i(e.a)), e;
}
function Jb(t) {
  return t.charAt(0) === "r" ? Zb(t) : Yb(t);
}
class Wr {
  constructor(e) {
    if (e instanceof Wr)
      return e;
    const n = typeof e;
    let i;
    n === "object" ? i = Wd(e) : n === "string" && (i = Lb(e) || Xb(e) || Jb(e)), this._rgb = i, this._valid = !!i;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var e = Rp(this._rgb);
    return e && (e.a = Xn(e.a)), e;
  }
  set rgb(e) {
    this._rgb = Wd(e);
  }
  rgbString() {
    return this._valid ? Kb(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? Fb(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? qb(this._rgb) : void 0;
  }
  mix(e, n) {
    if (e) {
      const i = this.rgb, s = e.rgb;
      let r;
      const a = n === r ? 0.5 : n, o = 2 * a - 1, l = i.a - s.a, u = ((o * l === -1 ? o : (o + l) / (1 + o * l)) + 1) / 2;
      r = 1 - u, i.r = 255 & u * i.r + r * s.r + 0.5, i.g = 255 & u * i.g + r * s.g + 0.5, i.b = 255 & u * i.b + r * s.b + 0.5, i.a = a * i.a + (1 - a) * s.a, this.rgb = i;
    }
    return this;
  }
  interpolate(e, n) {
    return e && (this._rgb = Qb(this._rgb, e._rgb, n)), this;
  }
  clone() {
    return new Wr(this.rgb);
  }
  alpha(e) {
    return this._rgb.a = _i(e), this;
  }
  clearer(e) {
    const n = this._rgb;
    return n.a *= 1 - e, this;
  }
  greyscale() {
    const e = this._rgb, n = ea(e.r * 0.3 + e.g * 0.59 + e.b * 0.11);
    return e.r = e.g = e.b = n, this;
  }
  opaquer(e) {
    const n = this._rgb;
    return n.a *= 1 + e, this;
  }
  negate() {
    const e = this._rgb;
    return e.r = 255 - e.r, e.g = 255 - e.g, e.b = 255 - e.b, this;
  }
  lighten(e) {
    return wa(this._rgb, 2, e), this;
  }
  darken(e) {
    return wa(this._rgb, 2, -e), this;
  }
  saturate(e) {
    return wa(this._rgb, 1, e), this;
  }
  desaturate(e) {
    return wa(this._rgb, 1, -e), this;
  }
  rotate(e) {
    return jb(this._rgb, e), this;
  }
}
/*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
function jn() {
}
const ew = /* @__PURE__ */ (() => {
  let t = 0;
  return () => t++;
})();
function Ie(t) {
  return t == null;
}
function Ue(t) {
  if (Array.isArray && Array.isArray(t))
    return !0;
  const e = Object.prototype.toString.call(t);
  return e.slice(0, 7) === "[object" && e.slice(-6) === "Array]";
}
function Ae(t) {
  return t !== null && Object.prototype.toString.call(t) === "[object Object]";
}
function ot(t) {
  return (typeof t == "number" || t instanceof Number) && isFinite(+t);
}
function tn(t, e) {
  return ot(t) ? t : e;
}
function De(t, e) {
  return typeof t > "u" ? e : t;
}
const tw = (t, e) => typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 : +t / e, Lp = (t, e) => typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 * e : +t;
function Ze(t, e, n) {
  if (t && typeof t.call == "function")
    return t.apply(n, e);
}
function Ke(t, e, n, i) {
  let s, r, a;
  if (Ue(t))
    for (r = t.length, s = 0; s < r; s++)
      e.call(n, t[s], s);
  else if (Ae(t))
    for (a = Object.keys(t), r = a.length, s = 0; s < r; s++)
      e.call(n, t[a[s]], a[s]);
}
function no(t, e) {
  let n, i, s, r;
  if (!t || !e || t.length !== e.length)
    return !1;
  for (n = 0, i = t.length; n < i; ++n)
    if (s = t[n], r = e[n], s.datasetIndex !== r.datasetIndex || s.index !== r.index)
      return !1;
  return !0;
}
function io(t) {
  if (Ue(t))
    return t.map(io);
  if (Ae(t)) {
    const e = /* @__PURE__ */ Object.create(null), n = Object.keys(t), i = n.length;
    let s = 0;
    for (; s < i; ++s)
      e[n[s]] = io(t[n[s]]);
    return e;
  }
  return t;
}
function Ip(t) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(t) === -1;
}
function nw(t, e, n, i) {
  if (!Ip(t))
    return;
  const s = e[t], r = n[t];
  Ae(s) && Ae(r) ? Hr(s, r, i) : e[t] = io(r);
}
function Hr(t, e, n) {
  const i = Ue(e) ? e : [
    e
  ], s = i.length;
  if (!Ae(t))
    return t;
  n = n || {};
  const r = n.merger || nw;
  let a;
  for (let o = 0; o < s; ++o) {
    if (a = i[o], !Ae(a))
      continue;
    const l = Object.keys(a);
    for (let u = 0, c = l.length; u < c; ++u)
      r(l[u], t, a, n);
  }
  return t;
}
function Cr(t, e) {
  return Hr(t, e, {
    merger: iw
  });
}
function iw(t, e, n) {
  if (!Ip(t))
    return;
  const i = e[t], s = n[t];
  Ae(i) && Ae(s) ? Cr(i, s) : Object.prototype.hasOwnProperty.call(e, t) || (e[t] = io(s));
}
const Hd = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (t) => t,
  // default resolvers
  x: (t) => t.x,
  y: (t) => t.y
};
function sw(t) {
  const e = t.split("."), n = [];
  let i = "";
  for (const s of e)
    i += s, i.endsWith("\\") ? i = i.slice(0, -1) + "." : (n.push(i), i = "");
  return n;
}
function rw(t) {
  const e = sw(t);
  return (n) => {
    for (const i of e) {
      if (i === "")
        break;
      n = n && n[i];
    }
    return n;
  };
}
function Ci(t, e) {
  return (Hd[e] || (Hd[e] = rw(e)))(t);
}
function $c(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
const en = (t) => typeof t < "u", Qt = (t) => typeof t == "function", Yd = (t, e) => {
  if (t.size !== e.size)
    return !1;
  for (const n of t)
    if (!e.has(n))
      return !1;
  return !0;
};
function aw(t) {
  return t.type === "mouseup" || t.type === "click" || t.type === "contextmenu";
}
const Ne = Math.PI, nt = 2 * Ne, ow = nt + Ne, so = Number.POSITIVE_INFINITY, Rc = Ne / 180, rt = Ne / 2, dn = Ne / 4, ro = Ne * 2 / 3, gi = Math.log10, Nn = Math.sign;
function Ar(t, e, n) {
  return Math.abs(t - e) < n;
}
function jd(t) {
  const e = Math.round(t);
  t = Ar(t, e, t / 1e3) ? e : t;
  const n = Math.pow(10, Math.floor(gi(t))), i = t / n;
  return (i <= 1 ? 1 : i <= 2 ? 2 : i <= 5 ? 5 : 10) * n;
}
function lw(t) {
  const e = [], n = Math.sqrt(t);
  let i;
  for (i = 1; i < n; i++)
    t % i === 0 && (e.push(i), e.push(t / i));
  return n === (n | 0) && e.push(n), e.sort((s, r) => s - r).pop(), e;
}
function uw(t) {
  return typeof t == "symbol" || typeof t == "object" && t !== null && !(Symbol.toPrimitive in t || "toString" in t || "valueOf" in t);
}
function Ai(t) {
  return !uw(t) && !isNaN(parseFloat(t)) && isFinite(t);
}
function cw(t, e) {
  const n = Math.round(t);
  return n - e <= t && n + e >= t;
}
function Fp(t, e, n) {
  let i, s, r;
  for (i = 0, s = t.length; i < s; i++)
    r = t[i][n], isNaN(r) || (e.min = Math.min(e.min, r), e.max = Math.max(e.max, r));
}
function St(t) {
  return t * (Ne / 180);
}
function So(t) {
  return t * (180 / Ne);
}
function qd(t) {
  if (!ot(t))
    return;
  let e = 1, n = 0;
  for (; Math.round(t * e) / e !== t; )
    e *= 10, n++;
  return n;
}
function ao(t, e) {
  const n = e.x - t.x, i = e.y - t.y, s = Math.sqrt(n * n + i * i);
  let r = Math.atan2(i, n);
  return r < -0.5 * Ne && (r += nt), {
    angle: r,
    distance: s
  };
}
function Ws(t, e) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function dw(t, e) {
  return (t - e + ow) % nt - Ne;
}
function nn(t) {
  return (t % nt + nt) % nt;
}
function Yr(t, e, n, i) {
  const s = nn(t), r = nn(e), a = nn(n), o = nn(r - s), l = nn(a - s), u = nn(s - r), c = nn(s - a);
  return s === r || s === a || i && r === a || o > l && u < c;
}
function Et(t, e, n) {
  return Math.max(e, Math.min(n, t));
}
function fw(t) {
  return Et(t, -32768, 32767);
}
function Zn(t, e, n, i = 1e-6) {
  return t >= Math.min(e, n) - i && t <= Math.max(e, n) + i;
}
function Lc(t, e, n) {
  n = n || ((a) => t[a] < e);
  let i = t.length - 1, s = 0, r;
  for (; i - s > 1; )
    r = s + i >> 1, n(r) ? s = r : i = r;
  return {
    lo: s,
    hi: i
  };
}
const Kn = (t, e, n, i) => Lc(t, n, i ? (s) => {
  const r = t[s][e];
  return r < n || r === n && t[s + 1][e] === n;
} : (s) => t[s][e] < n), hw = (t, e, n) => Lc(t, n, (i) => t[i][e] >= n);
function mw(t, e, n) {
  let i = 0, s = t.length;
  for (; i < s && t[i] < e; )
    i++;
  for (; s > i && t[s - 1] > n; )
    s--;
  return i > 0 || s < t.length ? t.slice(i, s) : t;
}
const Vp = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function pw(t, e) {
  if (t._chartjs) {
    t._chartjs.listeners.push(e);
    return;
  }
  Object.defineProperty(t, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        e
      ]
    }
  }), Vp.forEach((n) => {
    const i = "_onData" + $c(n), s = t[n];
    Object.defineProperty(t, n, {
      configurable: !0,
      enumerable: !1,
      value(...r) {
        const a = s.apply(this, r);
        return t._chartjs.listeners.forEach((o) => {
          typeof o[i] == "function" && o[i](...r);
        }), a;
      }
    });
  });
}
function Ud(t, e) {
  const n = t._chartjs;
  if (!n)
    return;
  const i = n.listeners, s = i.indexOf(e);
  s !== -1 && i.splice(s, 1), !(i.length > 0) && (Vp.forEach((r) => {
    delete t[r];
  }), delete t._chartjs);
}
function Np(t) {
  const e = new Set(t);
  return e.size === t.length ? t : Array.from(e);
}
const Bp = function() {
  return typeof window > "u" ? function(t) {
    return t();
  } : window.requestAnimationFrame;
}();
function zp(t, e) {
  let n = [], i = !1;
  return function(...s) {
    n = s, i || (i = !0, Bp.call(window, () => {
      i = !1, t.apply(e, n);
    }));
  };
}
function gw(t, e) {
  let n;
  return function(...i) {
    return e ? (clearTimeout(n), n = setTimeout(t, e, i)) : t.apply(this, i), e;
  };
}
const Ic = (t) => t === "start" ? "left" : t === "end" ? "right" : "center", Vt = (t, e, n) => t === "start" ? e : t === "end" ? n : (e + n) / 2, yw = (t, e, n, i) => t === (i ? "left" : "right") ? n : t === "center" ? (e + n) / 2 : e;
function Wp(t, e, n) {
  const i = e.length;
  let s = 0, r = i;
  if (t._sorted) {
    const { iScale: a, vScale: o, _parsed: l } = t, u = t.dataset && t.dataset.options ? t.dataset.options.spanGaps : null, c = a.axis, { min: d, max: f, minDefined: h, maxDefined: m } = a.getUserBounds();
    if (h) {
      if (s = Math.min(
        // @ts-expect-error Need to type _parsed
        Kn(l, c, d).lo,
        // @ts-expect-error Need to fix types on _lookupByKey
        n ? i : Kn(e, c, a.getPixelForValue(d)).lo
      ), u) {
        const p = l.slice(0, s + 1).reverse().findIndex((g) => !Ie(g[o.axis]));
        s -= Math.max(0, p);
      }
      s = Et(s, 0, i - 1);
    }
    if (m) {
      let p = Math.max(
        // @ts-expect-error Need to type _parsed
        Kn(l, a.axis, f, !0).hi + 1,
        // @ts-expect-error Need to fix types on _lookupByKey
        n ? 0 : Kn(e, c, a.getPixelForValue(f), !0).hi + 1
      );
      if (u) {
        const g = l.slice(p - 1).findIndex((y) => !Ie(y[o.axis]));
        p += Math.max(0, g);
      }
      r = Et(p, s, i) - s;
    } else
      r = i - s;
  }
  return {
    start: s,
    count: r
  };
}
function Hp(t) {
  const { xScale: e, yScale: n, _scaleRanges: i } = t, s = {
    xmin: e.min,
    xmax: e.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!i)
    return t._scaleRanges = s, !0;
  const r = i.xmin !== e.min || i.xmax !== e.max || i.ymin !== n.min || i.ymax !== n.max;
  return Object.assign(i, s), r;
}
const xa = (t) => t === 0 || t === 1, Xd = (t, e, n) => -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * nt / n)), Gd = (t, e, n) => Math.pow(2, -10 * t) * Math.sin((t - e) * nt / n) + 1, Er = {
  linear: (t) => t,
  easeInQuad: (t) => t * t,
  easeOutQuad: (t) => -t * (t - 2),
  easeInOutQuad: (t) => (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
  easeInCubic: (t) => t * t * t,
  easeOutCubic: (t) => (t -= 1) * t * t + 1,
  easeInOutCubic: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
  easeInQuart: (t) => t * t * t * t,
  easeOutQuart: (t) => -((t -= 1) * t * t * t - 1),
  easeInOutQuart: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
  easeInQuint: (t) => t * t * t * t * t,
  easeOutQuint: (t) => (t -= 1) * t * t * t * t + 1,
  easeInOutQuint: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
  easeInSine: (t) => -Math.cos(t * rt) + 1,
  easeOutSine: (t) => Math.sin(t * rt),
  easeInOutSine: (t) => -0.5 * (Math.cos(Ne * t) - 1),
  easeInExpo: (t) => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: (t) => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: (t) => xa(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
  easeInCirc: (t) => t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: (t) => Math.sqrt(1 - (t -= 1) * t),
  easeInOutCirc: (t) => (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeInElastic: (t) => xa(t) ? t : Xd(t, 0.075, 0.3),
  easeOutElastic: (t) => xa(t) ? t : Gd(t, 0.075, 0.3),
  easeInOutElastic(t) {
    return xa(t) ? t : t < 0.5 ? 0.5 * Xd(t * 2, 0.1125, 0.45) : 0.5 + 0.5 * Gd(t * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(t) {
    return t * t * ((1.70158 + 1) * t - 1.70158);
  },
  easeOutBack(t) {
    return (t -= 1) * t * ((1.70158 + 1) * t + 1.70158) + 1;
  },
  easeInOutBack(t) {
    let e = 1.70158;
    return (t /= 0.5) < 1 ? 0.5 * (t * t * (((e *= 1.525) + 1) * t - e)) : 0.5 * ((t -= 2) * t * (((e *= 1.525) + 1) * t + e) + 2);
  },
  easeInBounce: (t) => 1 - Er.easeOutBounce(1 - t),
  easeOutBounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + 0.75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375 : 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
  },
  easeInOutBounce: (t) => t < 0.5 ? Er.easeInBounce(t * 2) * 0.5 : Er.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function Fc(t) {
  if (t && typeof t == "object") {
    const e = t.toString();
    return e === "[object CanvasPattern]" || e === "[object CanvasGradient]";
  }
  return !1;
}
function Zd(t) {
  return Fc(t) ? t : new Wr(t);
}
function el(t) {
  return Fc(t) ? t : new Wr(t).saturate(0.5).darken(0.1).hexString();
}
const vw = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], bw = [
  "color",
  "borderColor",
  "backgroundColor"
];
function ww(t) {
  t.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), t.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (e) => e !== "onProgress" && e !== "onComplete" && e !== "fn"
  }), t.set("animations", {
    colors: {
      type: "color",
      properties: bw
    },
    numbers: {
      type: "number",
      properties: vw
    }
  }), t.describe("animations", {
    _fallback: "animation"
  }), t.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (e) => e | 0
        }
      }
    }
  });
}
function xw(t) {
  t.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const Kd = /* @__PURE__ */ new Map();
function _w(t, e) {
  e = e || {};
  const n = t + JSON.stringify(e);
  let i = Kd.get(n);
  return i || (i = new Intl.NumberFormat(t, e), Kd.set(n, i)), i;
}
function ta(t, e, n) {
  return _w(e, n).format(t);
}
const Yp = {
  values(t) {
    return Ue(t) ? t : "" + t;
  },
  numeric(t, e, n) {
    if (t === 0)
      return "0";
    const i = this.chart.options.locale;
    let s, r = t;
    if (n.length > 1) {
      const u = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (u < 1e-4 || u > 1e15) && (s = "scientific"), r = kw(t, n);
    }
    const a = gi(Math.abs(r)), o = isNaN(a) ? 1 : Math.max(Math.min(-1 * Math.floor(a), 20), 0), l = {
      notation: s,
      minimumFractionDigits: o,
      maximumFractionDigits: o
    };
    return Object.assign(l, this.options.ticks.format), ta(t, i, l);
  },
  logarithmic(t, e, n) {
    if (t === 0)
      return "0";
    const i = n[e].significand || t / Math.pow(10, Math.floor(gi(t)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(i) || e > 0.8 * n.length ? Yp.numeric.call(this, t, e, n) : "";
  }
};
function kw(t, e) {
  let n = e.length > 3 ? e[2].value - e[1].value : e[1].value - e[0].value;
  return Math.abs(n) >= 1 && t !== Math.floor(t) && (n = t - Math.floor(t)), n;
}
var Oo = {
  formatters: Yp
};
function Mw(t) {
  t.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (e, n) => n.lineWidth,
      tickColor: (e, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Oo.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), t.route("scale.ticks", "color", "", "color"), t.route("scale.grid", "color", "", "borderColor"), t.route("scale.border", "color", "", "borderColor"), t.route("scale.title", "color", "", "color"), t.describe("scale", {
    _fallback: !1,
    _scriptable: (e) => !e.startsWith("before") && !e.startsWith("after") && e !== "callback" && e !== "parser",
    _indexable: (e) => e !== "borderDash" && e !== "tickBorderDash" && e !== "dash"
  }), t.describe("scales", {
    _fallback: "scale"
  }), t.describe("scale.ticks", {
    _scriptable: (e) => e !== "backdropPadding" && e !== "callback",
    _indexable: (e) => e !== "backdropPadding"
  });
}
const ss = /* @__PURE__ */ Object.create(null), Pu = /* @__PURE__ */ Object.create(null);
function $r(t, e) {
  if (!e)
    return t;
  const n = e.split(".");
  for (let i = 0, s = n.length; i < s; ++i) {
    const r = n[i];
    t = t[r] || (t[r] = /* @__PURE__ */ Object.create(null));
  }
  return t;
}
function tl(t, e, n) {
  return typeof e == "string" ? Hr($r(t, e), n) : Hr($r(t, ""), e);
}
class Sw {
  constructor(e, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (i) => i.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (i, s) => el(s.backgroundColor), this.hoverBorderColor = (i, s) => el(s.borderColor), this.hoverColor = (i, s) => el(s.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(e), this.apply(n);
  }
  set(e, n) {
    return tl(this, e, n);
  }
  get(e) {
    return $r(this, e);
  }
  describe(e, n) {
    return tl(Pu, e, n);
  }
  override(e, n) {
    return tl(ss, e, n);
  }
  route(e, n, i, s) {
    const r = $r(this, e), a = $r(this, i), o = "_" + n;
    Object.defineProperties(r, {
      [o]: {
        value: r[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const l = this[o], u = a[s];
          return Ae(l) ? Object.assign({}, u, l) : De(l, u);
        },
        set(l) {
          this[o] = l;
        }
      }
    });
  }
  apply(e) {
    e.forEach((n) => n(this));
  }
}
var at = /* @__PURE__ */ new Sw({
  _scriptable: (t) => !t.startsWith("on"),
  _indexable: (t) => t !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  ww,
  xw,
  Mw
]);
function Ow(t) {
  return !t || Ie(t.size) || Ie(t.family) ? null : (t.style ? t.style + " " : "") + (t.weight ? t.weight + " " : "") + t.size + "px " + t.family;
}
function oo(t, e, n, i, s) {
  let r = e[s];
  return r || (r = e[s] = t.measureText(s).width, n.push(s)), r > i && (i = r), i;
}
function Dw(t, e, n, i) {
  i = i || {};
  let s = i.data = i.data || {}, r = i.garbageCollect = i.garbageCollect || [];
  i.font !== e && (s = i.data = {}, r = i.garbageCollect = [], i.font = e), t.save(), t.font = e;
  let a = 0;
  const o = n.length;
  let l, u, c, d, f;
  for (l = 0; l < o; l++)
    if (d = n[l], d != null && !Ue(d))
      a = oo(t, s, r, a, d);
    else if (Ue(d))
      for (u = 0, c = d.length; u < c; u++)
        f = d[u], f != null && !Ue(f) && (a = oo(t, s, r, a, f));
  t.restore();
  const h = r.length / 2;
  if (h > n.length) {
    for (l = 0; l < h; l++)
      delete s[r[l]];
    r.splice(0, h);
  }
  return a;
}
function Ni(t, e, n) {
  const i = t.currentDevicePixelRatio, s = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((e - s) * i) / i + s;
}
function Qd(t, e) {
  !e && !t || (e = e || t.getContext("2d"), e.save(), e.resetTransform(), e.clearRect(0, 0, t.width, t.height), e.restore());
}
function Cu(t, e, n, i) {
  jp(t, e, n, i, null);
}
function jp(t, e, n, i, s) {
  let r, a, o, l, u, c, d, f;
  const h = e.pointStyle, m = e.rotation, p = e.radius;
  let g = (m || 0) * Rc;
  if (h && typeof h == "object" && (r = h.toString(), r === "[object HTMLImageElement]" || r === "[object HTMLCanvasElement]")) {
    t.save(), t.translate(n, i), t.rotate(g), t.drawImage(h, -h.width / 2, -h.height / 2, h.width, h.height), t.restore();
    return;
  }
  if (!(isNaN(p) || p <= 0)) {
    switch (t.beginPath(), h) {
      // Default includes circle
      default:
        s ? t.ellipse(n, i, s / 2, p, 0, 0, nt) : t.arc(n, i, p, 0, nt), t.closePath();
        break;
      case "triangle":
        c = s ? s / 2 : p, t.moveTo(n + Math.sin(g) * c, i - Math.cos(g) * p), g += ro, t.lineTo(n + Math.sin(g) * c, i - Math.cos(g) * p), g += ro, t.lineTo(n + Math.sin(g) * c, i - Math.cos(g) * p), t.closePath();
        break;
      case "rectRounded":
        u = p * 0.516, l = p - u, a = Math.cos(g + dn) * l, d = Math.cos(g + dn) * (s ? s / 2 - u : l), o = Math.sin(g + dn) * l, f = Math.sin(g + dn) * (s ? s / 2 - u : l), t.arc(n - d, i - o, u, g - Ne, g - rt), t.arc(n + f, i - a, u, g - rt, g), t.arc(n + d, i + o, u, g, g + rt), t.arc(n - f, i + a, u, g + rt, g + Ne), t.closePath();
        break;
      case "rect":
        if (!m) {
          l = Math.SQRT1_2 * p, c = s ? s / 2 : l, t.rect(n - c, i - l, 2 * c, 2 * l);
          break;
        }
        g += dn;
      /* falls through */
      case "rectRot":
        d = Math.cos(g) * (s ? s / 2 : p), a = Math.cos(g) * p, o = Math.sin(g) * p, f = Math.sin(g) * (s ? s / 2 : p), t.moveTo(n - d, i - o), t.lineTo(n + f, i - a), t.lineTo(n + d, i + o), t.lineTo(n - f, i + a), t.closePath();
        break;
      case "crossRot":
        g += dn;
      /* falls through */
      case "cross":
        d = Math.cos(g) * (s ? s / 2 : p), a = Math.cos(g) * p, o = Math.sin(g) * p, f = Math.sin(g) * (s ? s / 2 : p), t.moveTo(n - d, i - o), t.lineTo(n + d, i + o), t.moveTo(n + f, i - a), t.lineTo(n - f, i + a);
        break;
      case "star":
        d = Math.cos(g) * (s ? s / 2 : p), a = Math.cos(g) * p, o = Math.sin(g) * p, f = Math.sin(g) * (s ? s / 2 : p), t.moveTo(n - d, i - o), t.lineTo(n + d, i + o), t.moveTo(n + f, i - a), t.lineTo(n - f, i + a), g += dn, d = Math.cos(g) * (s ? s / 2 : p), a = Math.cos(g) * p, o = Math.sin(g) * p, f = Math.sin(g) * (s ? s / 2 : p), t.moveTo(n - d, i - o), t.lineTo(n + d, i + o), t.moveTo(n + f, i - a), t.lineTo(n - f, i + a);
        break;
      case "line":
        a = s ? s / 2 : Math.cos(g) * p, o = Math.sin(g) * p, t.moveTo(n - a, i - o), t.lineTo(n + a, i + o);
        break;
      case "dash":
        t.moveTo(n, i), t.lineTo(n + Math.cos(g) * (s ? s / 2 : p), i + Math.sin(g) * p);
        break;
      case !1:
        t.closePath();
        break;
    }
    t.fill(), e.borderWidth > 0 && t.stroke();
  }
}
function Qn(t, e, n) {
  return n = n || 0.5, !e || t && t.x > e.left - n && t.x < e.right + n && t.y > e.top - n && t.y < e.bottom + n;
}
function na(t, e) {
  t.save(), t.beginPath(), t.rect(e.left, e.top, e.right - e.left, e.bottom - e.top), t.clip();
}
function ia(t) {
  t.restore();
}
function Tw(t, e, n, i, s) {
  if (!e)
    return t.lineTo(n.x, n.y);
  if (s === "middle") {
    const r = (e.x + n.x) / 2;
    t.lineTo(r, e.y), t.lineTo(r, n.y);
  } else s === "after" != !!i ? t.lineTo(e.x, n.y) : t.lineTo(n.x, e.y);
  t.lineTo(n.x, n.y);
}
function Pw(t, e, n, i) {
  if (!e)
    return t.lineTo(n.x, n.y);
  t.bezierCurveTo(i ? e.cp1x : e.cp2x, i ? e.cp1y : e.cp2y, i ? n.cp2x : n.cp1x, i ? n.cp2y : n.cp1y, n.x, n.y);
}
function Cw(t, e) {
  e.translation && t.translate(e.translation[0], e.translation[1]), Ie(e.rotation) || t.rotate(e.rotation), e.color && (t.fillStyle = e.color), e.textAlign && (t.textAlign = e.textAlign), e.textBaseline && (t.textBaseline = e.textBaseline);
}
function Aw(t, e, n, i, s) {
  if (s.strikethrough || s.underline) {
    const r = t.measureText(i), a = e - r.actualBoundingBoxLeft, o = e + r.actualBoundingBoxRight, l = n - r.actualBoundingBoxAscent, u = n + r.actualBoundingBoxDescent, c = s.strikethrough ? (l + u) / 2 : u;
    t.strokeStyle = t.fillStyle, t.beginPath(), t.lineWidth = s.decorationWidth || 2, t.moveTo(a, c), t.lineTo(o, c), t.stroke();
  }
}
function Ew(t, e) {
  const n = t.fillStyle;
  t.fillStyle = e.color, t.fillRect(e.left, e.top, e.width, e.height), t.fillStyle = n;
}
function rs(t, e, n, i, s, r = {}) {
  const a = Ue(e) ? e : [
    e
  ], o = r.strokeWidth > 0 && r.strokeColor !== "";
  let l, u;
  for (t.save(), t.font = s.string, Cw(t, r), l = 0; l < a.length; ++l)
    u = a[l], r.backdrop && Ew(t, r.backdrop), o && (r.strokeColor && (t.strokeStyle = r.strokeColor), Ie(r.strokeWidth) || (t.lineWidth = r.strokeWidth), t.strokeText(u, n, i, r.maxWidth)), t.fillText(u, n, i, r.maxWidth), Aw(t, n, i, u, r), i += Number(s.lineHeight);
  t.restore();
}
function Hs(t, e) {
  const { x: n, y: i, w: s, h: r, radius: a } = e;
  t.arc(n + a.topLeft, i + a.topLeft, a.topLeft, 1.5 * Ne, Ne, !0), t.lineTo(n, i + r - a.bottomLeft), t.arc(n + a.bottomLeft, i + r - a.bottomLeft, a.bottomLeft, Ne, rt, !0), t.lineTo(n + s - a.bottomRight, i + r), t.arc(n + s - a.bottomRight, i + r - a.bottomRight, a.bottomRight, rt, 0, !0), t.lineTo(n + s, i + a.topRight), t.arc(n + s - a.topRight, i + a.topRight, a.topRight, 0, -rt, !0), t.lineTo(n + a.topLeft, i);
}
const $w = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, Rw = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function Lw(t, e) {
  const n = ("" + t).match($w);
  if (!n || n[1] === "normal")
    return e * 1.2;
  switch (t = +n[2], n[3]) {
    case "px":
      return t;
    case "%":
      t /= 100;
      break;
  }
  return e * t;
}
const Iw = (t) => +t || 0;
function Vc(t, e) {
  const n = {}, i = Ae(e), s = i ? Object.keys(e) : e, r = Ae(t) ? i ? (a) => De(t[a], t[e[a]]) : (a) => t[a] : () => t;
  for (const a of s)
    n[a] = Iw(r(a));
  return n;
}
function qp(t) {
  return Vc(t, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function ki(t) {
  return Vc(t, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function Ot(t) {
  const e = qp(t);
  return e.width = e.left + e.right, e.height = e.top + e.bottom, e;
}
function mt(t, e) {
  t = t || {}, e = e || at.font;
  let n = De(t.size, e.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let i = De(t.style, e.style);
  i && !("" + i).match(Rw) && (console.warn('Invalid font style specified: "' + i + '"'), i = void 0);
  const s = {
    family: De(t.family, e.family),
    lineHeight: Lw(De(t.lineHeight, e.lineHeight), n),
    size: n,
    style: i,
    weight: De(t.weight, e.weight),
    string: ""
  };
  return s.string = Ow(s), s;
}
function xr(t, e, n, i) {
  let s, r, a;
  for (s = 0, r = t.length; s < r; ++s)
    if (a = t[s], a !== void 0 && a !== void 0)
      return a;
}
function Fw(t, e, n) {
  const { min: i, max: s } = t, r = Lp(e, (s - i) / 2), a = (o, l) => n && o === 0 ? 0 : o + l;
  return {
    min: a(i, -Math.abs(r)),
    max: a(s, r)
  };
}
function Li(t, e) {
  return Object.assign(Object.create(t), e);
}
function Nc(t, e = [
  ""
], n, i, s = () => t[0]) {
  const r = n || t;
  typeof i > "u" && (i = Zp("_fallback", t));
  const a = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: t,
    _rootScopes: r,
    _fallback: i,
    _getTarget: s,
    override: (o) => Nc([
      o,
      ...t
    ], e, r, i)
  };
  return new Proxy(a, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(o, l) {
      return delete o[l], delete o._keys, delete t[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(o, l) {
      return Xp(o, l, () => jw(l, e, t, o));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(o, l) {
      return Reflect.getOwnPropertyDescriptor(o._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(o, l) {
      return ef(o).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(o) {
      return ef(o);
    },
    /**
    * A trap for setting property values.
    */
    set(o, l, u) {
      const c = o._storage || (o._storage = s());
      return o[l] = c[l] = u, delete o._keys, !0;
    }
  });
}
function Ys(t, e, n, i) {
  const s = {
    _cacheable: !1,
    _proxy: t,
    _context: e,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: Up(t, i),
    setContext: (r) => Ys(t, r, n, i),
    override: (r) => Ys(t.override(r), e, n, i)
  };
  return new Proxy(s, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(r, a) {
      return delete r[a], delete t[a], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(r, a, o) {
      return Xp(r, a, () => Nw(r, a, o));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(r, a) {
      return r._descriptors.allKeys ? Reflect.has(t, a) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(t, a);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t);
    },
    /**
    * A trap for the in operator.
    */
    has(r, a) {
      return Reflect.has(t, a);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(t);
    },
    /**
    * A trap for setting property values.
    */
    set(r, a, o) {
      return t[a] = o, delete r[a], !0;
    }
  });
}
function Up(t, e = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = e.scriptable, _indexable: i = e.indexable, _allKeys: s = e.allKeys } = t;
  return {
    allKeys: s,
    scriptable: n,
    indexable: i,
    isScriptable: Qt(n) ? n : () => n,
    isIndexable: Qt(i) ? i : () => i
  };
}
const Vw = (t, e) => t ? t + $c(e) : e, Bc = (t, e) => Ae(e) && t !== "adapters" && (Object.getPrototypeOf(e) === null || e.constructor === Object);
function Xp(t, e, n) {
  if (Object.prototype.hasOwnProperty.call(t, e) || e === "constructor")
    return t[e];
  const i = n();
  return t[e] = i, i;
}
function Nw(t, e, n) {
  const { _proxy: i, _context: s, _subProxy: r, _descriptors: a } = t;
  let o = i[e];
  return Qt(o) && a.isScriptable(e) && (o = Bw(e, o, t, n)), Ue(o) && o.length && (o = zw(e, o, t, a.isIndexable)), Bc(e, o) && (o = Ys(o, s, r && r[e], a)), o;
}
function Bw(t, e, n, i) {
  const { _proxy: s, _context: r, _subProxy: a, _stack: o } = n;
  if (o.has(t))
    throw new Error("Recursion detected: " + Array.from(o).join("->") + "->" + t);
  o.add(t);
  let l = e(r, a || i);
  return o.delete(t), Bc(t, l) && (l = zc(s._scopes, s, t, l)), l;
}
function zw(t, e, n, i) {
  const { _proxy: s, _context: r, _subProxy: a, _descriptors: o } = n;
  if (typeof r.index < "u" && i(t))
    return e[r.index % e.length];
  if (Ae(e[0])) {
    const l = e, u = s._scopes.filter((c) => c !== l);
    e = [];
    for (const c of l) {
      const d = zc(u, s, t, c);
      e.push(Ys(d, r, a && a[t], o));
    }
  }
  return e;
}
function Gp(t, e, n) {
  return Qt(t) ? t(e, n) : t;
}
const Ww = (t, e) => t === !0 ? e : typeof t == "string" ? Ci(e, t) : void 0;
function Hw(t, e, n, i, s) {
  for (const r of e) {
    const a = Ww(n, r);
    if (a) {
      t.add(a);
      const o = Gp(a._fallback, n, s);
      if (typeof o < "u" && o !== n && o !== i)
        return o;
    } else if (a === !1 && typeof i < "u" && n !== i)
      return null;
  }
  return !1;
}
function zc(t, e, n, i) {
  const s = e._rootScopes, r = Gp(e._fallback, n, i), a = [
    ...t,
    ...s
  ], o = /* @__PURE__ */ new Set();
  o.add(i);
  let l = Jd(o, a, n, r || n, i);
  return l === null || typeof r < "u" && r !== n && (l = Jd(o, a, r, l, i), l === null) ? !1 : Nc(Array.from(o), [
    ""
  ], s, r, () => Yw(e, n, i));
}
function Jd(t, e, n, i, s) {
  for (; n; )
    n = Hw(t, e, n, i, s);
  return n;
}
function Yw(t, e, n) {
  const i = t._getTarget();
  e in i || (i[e] = {});
  const s = i[e];
  return Ue(s) && Ae(n) ? n : s || {};
}
function jw(t, e, n, i) {
  let s;
  for (const r of e)
    if (s = Zp(Vw(r, t), n), typeof s < "u")
      return Bc(t, s) ? zc(n, i, t, s) : s;
}
function Zp(t, e) {
  for (const n of e) {
    if (!n)
      continue;
    const i = n[t];
    if (typeof i < "u")
      return i;
  }
}
function ef(t) {
  let e = t._keys;
  return e || (e = t._keys = qw(t._scopes)), e;
}
function qw(t) {
  const e = /* @__PURE__ */ new Set();
  for (const n of t)
    for (const i of Object.keys(n).filter((s) => !s.startsWith("_")))
      e.add(i);
  return Array.from(e);
}
function Kp(t, e, n, i) {
  const { iScale: s } = t, { key: r = "r" } = this._parsing, a = new Array(i);
  let o, l, u, c;
  for (o = 0, l = i; o < l; ++o)
    u = o + n, c = e[u], a[o] = {
      r: s.parse(Ci(c, r), u)
    };
  return a;
}
const Uw = Number.EPSILON || 1e-14, js = (t, e) => e < t.length && !t[e].skip && t[e], Qp = (t) => t === "x" ? "y" : "x";
function Xw(t, e, n, i) {
  const s = t.skip ? e : t, r = e, a = n.skip ? e : n, o = Ws(r, s), l = Ws(a, r);
  let u = o / (o + l), c = l / (o + l);
  u = isNaN(u) ? 0 : u, c = isNaN(c) ? 0 : c;
  const d = i * u, f = i * c;
  return {
    previous: {
      x: r.x - d * (a.x - s.x),
      y: r.y - d * (a.y - s.y)
    },
    next: {
      x: r.x + f * (a.x - s.x),
      y: r.y + f * (a.y - s.y)
    }
  };
}
function Gw(t, e, n) {
  const i = t.length;
  let s, r, a, o, l, u = js(t, 0);
  for (let c = 0; c < i - 1; ++c)
    if (l = u, u = js(t, c + 1), !(!l || !u)) {
      if (Ar(e[c], 0, Uw)) {
        n[c] = n[c + 1] = 0;
        continue;
      }
      s = n[c] / e[c], r = n[c + 1] / e[c], o = Math.pow(s, 2) + Math.pow(r, 2), !(o <= 9) && (a = 3 / Math.sqrt(o), n[c] = s * a * e[c], n[c + 1] = r * a * e[c]);
    }
}
function Zw(t, e, n = "x") {
  const i = Qp(n), s = t.length;
  let r, a, o, l = js(t, 0);
  for (let u = 0; u < s; ++u) {
    if (a = o, o = l, l = js(t, u + 1), !o)
      continue;
    const c = o[n], d = o[i];
    a && (r = (c - a[n]) / 3, o[`cp1${n}`] = c - r, o[`cp1${i}`] = d - r * e[u]), l && (r = (l[n] - c) / 3, o[`cp2${n}`] = c + r, o[`cp2${i}`] = d + r * e[u]);
  }
}
function Kw(t, e = "x") {
  const n = Qp(e), i = t.length, s = Array(i).fill(0), r = Array(i);
  let a, o, l, u = js(t, 0);
  for (a = 0; a < i; ++a)
    if (o = l, l = u, u = js(t, a + 1), !!l) {
      if (u) {
        const c = u[e] - l[e];
        s[a] = c !== 0 ? (u[n] - l[n]) / c : 0;
      }
      r[a] = o ? u ? Nn(s[a - 1]) !== Nn(s[a]) ? 0 : (s[a - 1] + s[a]) / 2 : s[a - 1] : s[a];
    }
  Gw(t, s, r), Zw(t, r, e);
}
function _a(t, e, n) {
  return Math.max(Math.min(t, n), e);
}
function Qw(t, e) {
  let n, i, s, r, a, o = Qn(t[0], e);
  for (n = 0, i = t.length; n < i; ++n)
    a = r, r = o, o = n < i - 1 && Qn(t[n + 1], e), r && (s = t[n], a && (s.cp1x = _a(s.cp1x, e.left, e.right), s.cp1y = _a(s.cp1y, e.top, e.bottom)), o && (s.cp2x = _a(s.cp2x, e.left, e.right), s.cp2y = _a(s.cp2y, e.top, e.bottom)));
}
function Jw(t, e, n, i, s) {
  let r, a, o, l;
  if (e.spanGaps && (t = t.filter((u) => !u.skip)), e.cubicInterpolationMode === "monotone")
    Kw(t, s);
  else {
    let u = i ? t[t.length - 1] : t[0];
    for (r = 0, a = t.length; r < a; ++r)
      o = t[r], l = Xw(u, o, t[Math.min(r + 1, a - (i ? 0 : 1)) % a], e.tension), o.cp1x = l.previous.x, o.cp1y = l.previous.y, o.cp2x = l.next.x, o.cp2y = l.next.y, u = o;
  }
  e.capBezierPoints && Qw(t, n);
}
function Wc() {
  return typeof window < "u" && typeof document < "u";
}
function Hc(t) {
  let e = t.parentNode;
  return e && e.toString() === "[object ShadowRoot]" && (e = e.host), e;
}
function lo(t, e, n) {
  let i;
  return typeof t == "string" ? (i = parseInt(t, 10), t.indexOf("%") !== -1 && (i = i / 100 * e.parentNode[n])) : i = t, i;
}
const Do = (t) => t.ownerDocument.defaultView.getComputedStyle(t, null);
function e1(t, e) {
  return Do(t).getPropertyValue(e);
}
const t1 = [
  "top",
  "right",
  "bottom",
  "left"
];
function Qi(t, e, n) {
  const i = {};
  n = n ? "-" + n : "";
  for (let s = 0; s < 4; s++) {
    const r = t1[s];
    i[r] = parseFloat(t[e + "-" + r + n]) || 0;
  }
  return i.width = i.left + i.right, i.height = i.top + i.bottom, i;
}
const n1 = (t, e, n) => (t > 0 || e > 0) && (!n || !n.shadowRoot);
function i1(t, e) {
  const n = t.touches, i = n && n.length ? n[0] : t, { offsetX: s, offsetY: r } = i;
  let a = !1, o, l;
  if (n1(s, r, t.target))
    o = s, l = r;
  else {
    const u = e.getBoundingClientRect();
    o = i.clientX - u.left, l = i.clientY - u.top, a = !0;
  }
  return {
    x: o,
    y: l,
    box: a
  };
}
function di(t, e) {
  if ("native" in t)
    return t;
  const { canvas: n, currentDevicePixelRatio: i } = e, s = Do(n), r = s.boxSizing === "border-box", a = Qi(s, "padding"), o = Qi(s, "border", "width"), { x: l, y: u, box: c } = i1(t, n), d = a.left + (c && o.left), f = a.top + (c && o.top);
  let { width: h, height: m } = e;
  return r && (h -= a.width + o.width, m -= a.height + o.height), {
    x: Math.round((l - d) / h * n.width / i),
    y: Math.round((u - f) / m * n.height / i)
  };
}
function s1(t, e, n) {
  let i, s;
  if (e === void 0 || n === void 0) {
    const r = t && Hc(t);
    if (!r)
      e = t.clientWidth, n = t.clientHeight;
    else {
      const a = r.getBoundingClientRect(), o = Do(r), l = Qi(o, "border", "width"), u = Qi(o, "padding");
      e = a.width - u.width - l.width, n = a.height - u.height - l.height, i = lo(o.maxWidth, r, "clientWidth"), s = lo(o.maxHeight, r, "clientHeight");
    }
  }
  return {
    width: e,
    height: n,
    maxWidth: i || so,
    maxHeight: s || so
  };
}
const ka = (t) => Math.round(t * 10) / 10;
function r1(t, e, n, i) {
  const s = Do(t), r = Qi(s, "margin"), a = lo(s.maxWidth, t, "clientWidth") || so, o = lo(s.maxHeight, t, "clientHeight") || so, l = s1(t, e, n);
  let { width: u, height: c } = l;
  if (s.boxSizing === "content-box") {
    const f = Qi(s, "border", "width"), h = Qi(s, "padding");
    u -= h.width + f.width, c -= h.height + f.height;
  }
  return u = Math.max(0, u - r.width), c = Math.max(0, i ? u / i : c - r.height), u = ka(Math.min(u, a, l.maxWidth)), c = ka(Math.min(c, o, l.maxHeight)), u && !c && (c = ka(u / 2)), (e !== void 0 || n !== void 0) && i && l.height && c > l.height && (c = l.height, u = ka(Math.floor(c * i))), {
    width: u,
    height: c
  };
}
function tf(t, e, n) {
  const i = e || 1, s = Math.floor(t.height * i), r = Math.floor(t.width * i);
  t.height = Math.floor(t.height), t.width = Math.floor(t.width);
  const a = t.canvas;
  return a.style && (n || !a.style.height && !a.style.width) && (a.style.height = `${t.height}px`, a.style.width = `${t.width}px`), t.currentDevicePixelRatio !== i || a.height !== s || a.width !== r ? (t.currentDevicePixelRatio = i, a.height = s, a.width = r, t.ctx.setTransform(i, 0, 0, i, 0, 0), !0) : !1;
}
const a1 = function() {
  let t = !1;
  try {
    const e = {
      get passive() {
        return t = !0, !1;
      }
    };
    Wc() && (window.addEventListener("test", null, e), window.removeEventListener("test", null, e));
  } catch {
  }
  return t;
}();
function nf(t, e) {
  const n = e1(t, e), i = n && n.match(/^(\d+)(\.\d+)?px$/);
  return i ? +i[1] : void 0;
}
function Yi(t, e, n, i) {
  return {
    x: t.x + n * (e.x - t.x),
    y: t.y + n * (e.y - t.y)
  };
}
function o1(t, e, n, i) {
  return {
    x: t.x + n * (e.x - t.x),
    y: i === "middle" ? n < 0.5 ? t.y : e.y : i === "after" ? n < 1 ? t.y : e.y : n > 0 ? e.y : t.y
  };
}
function l1(t, e, n, i) {
  const s = {
    x: t.cp2x,
    y: t.cp2y
  }, r = {
    x: e.cp1x,
    y: e.cp1y
  }, a = Yi(t, s, n), o = Yi(s, r, n), l = Yi(r, e, n), u = Yi(a, o, n), c = Yi(o, l, n);
  return Yi(u, c, n);
}
const u1 = function(t, e) {
  return {
    x(n) {
      return t + t + e - n;
    },
    setWidth(n) {
      e = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, i) {
      return n - i;
    },
    leftForLtr(n, i) {
      return n - i;
    }
  };
}, c1 = function() {
  return {
    x(t) {
      return t;
    },
    setWidth(t) {
    },
    textAlign(t) {
      return t;
    },
    xPlus(t, e) {
      return t + e;
    },
    leftForLtr(t, e) {
      return t;
    }
  };
};
function $s(t, e, n) {
  return t ? u1(e, n) : c1();
}
function Jp(t, e) {
  let n, i;
  (e === "ltr" || e === "rtl") && (n = t.canvas.style, i = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", e, "important"), t.prevTextDirection = i);
}
function eg(t, e) {
  e !== void 0 && (delete t.prevTextDirection, t.canvas.style.setProperty("direction", e[0], e[1]));
}
function tg(t) {
  return t === "angle" ? {
    between: Yr,
    compare: dw,
    normalize: nn
  } : {
    between: Zn,
    compare: (e, n) => e - n,
    normalize: (e) => e
  };
}
function sf({ start: t, end: e, count: n, loop: i, style: s }) {
  return {
    start: t % n,
    end: e % n,
    loop: i && (e - t + 1) % n === 0,
    style: s
  };
}
function d1(t, e, n) {
  const { property: i, start: s, end: r } = n, { between: a, normalize: o } = tg(i), l = e.length;
  let { start: u, end: c, loop: d } = t, f, h;
  if (d) {
    for (u += l, c += l, f = 0, h = l; f < h && a(o(e[u % l][i]), s, r); ++f)
      u--, c--;
    u %= l, c %= l;
  }
  return c < u && (c += l), {
    start: u,
    end: c,
    loop: d,
    style: t.style
  };
}
function ng(t, e, n) {
  if (!n)
    return [
      t
    ];
  const { property: i, start: s, end: r } = n, a = e.length, { compare: o, between: l, normalize: u } = tg(i), { start: c, end: d, loop: f, style: h } = d1(t, e, n), m = [];
  let p = !1, g = null, y, v, b;
  const _ = () => l(s, b, y) && o(s, b) !== 0, M = () => o(r, y) === 0 || l(r, b, y), A = () => p || _(), E = () => !p || M();
  for (let I = c, S = c; I <= d; ++I)
    v = e[I % a], !v.skip && (y = u(v[i]), y !== b && (p = l(y, s, r), g === null && A() && (g = o(y, s) === 0 ? I : S), g !== null && E() && (m.push(sf({
      start: g,
      end: I,
      loop: f,
      count: a,
      style: h
    })), g = null), S = I, b = y));
  return g !== null && m.push(sf({
    start: g,
    end: d,
    loop: f,
    count: a,
    style: h
  })), m;
}
function ig(t, e) {
  const n = [], i = t.segments;
  for (let s = 0; s < i.length; s++) {
    const r = ng(i[s], t.points, e);
    r.length && n.push(...r);
  }
  return n;
}
function f1(t, e, n, i) {
  let s = 0, r = e - 1;
  if (n && !i)
    for (; s < e && !t[s].skip; )
      s++;
  for (; s < e && t[s].skip; )
    s++;
  for (s %= e, n && (r += s); r > s && t[r % e].skip; )
    r--;
  return r %= e, {
    start: s,
    end: r
  };
}
function h1(t, e, n, i) {
  const s = t.length, r = [];
  let a = e, o = t[e], l;
  for (l = e + 1; l <= n; ++l) {
    const u = t[l % s];
    u.skip || u.stop ? o.skip || (i = !1, r.push({
      start: e % s,
      end: (l - 1) % s,
      loop: i
    }), e = a = u.stop ? l : null) : (a = l, o.skip && (e = l)), o = u;
  }
  return a !== null && r.push({
    start: e % s,
    end: a % s,
    loop: i
  }), r;
}
function m1(t, e) {
  const n = t.points, i = t.options.spanGaps, s = n.length;
  if (!s)
    return [];
  const r = !!t._loop, { start: a, end: o } = f1(n, s, r, i);
  if (i === !0)
    return rf(t, [
      {
        start: a,
        end: o,
        loop: r
      }
    ], n, e);
  const l = o < a ? o + s : o, u = !!t._fullLoop && a === 0 && o === s - 1;
  return rf(t, h1(n, a, l, u), n, e);
}
function rf(t, e, n, i) {
  return !i || !i.setContext || !n ? e : p1(t, e, n, i);
}
function p1(t, e, n, i) {
  const s = t._chart.getContext(), r = af(t.options), { _datasetIndex: a, options: { spanGaps: o } } = t, l = n.length, u = [];
  let c = r, d = e[0].start, f = d;
  function h(m, p, g, y) {
    const v = o ? -1 : 1;
    if (m !== p) {
      for (m += l; n[m % l].skip; )
        m -= v;
      for (; n[p % l].skip; )
        p += v;
      m % l !== p % l && (u.push({
        start: m % l,
        end: p % l,
        loop: g,
        style: y
      }), c = y, d = p % l);
    }
  }
  for (const m of e) {
    d = o ? d : m.start;
    let p = n[d % l], g;
    for (f = d + 1; f <= m.end; f++) {
      const y = n[f % l];
      g = af(i.setContext(Li(s, {
        type: "segment",
        p0: p,
        p1: y,
        p0DataIndex: (f - 1) % l,
        p1DataIndex: f % l,
        datasetIndex: a
      }))), g1(g, c) && h(d, f - 1, m.loop, c), p = y, c = g;
    }
    d < f - 1 && h(d, f - 1, m.loop, c);
  }
  return u;
}
function af(t) {
  return {
    backgroundColor: t.backgroundColor,
    borderCapStyle: t.borderCapStyle,
    borderDash: t.borderDash,
    borderDashOffset: t.borderDashOffset,
    borderJoinStyle: t.borderJoinStyle,
    borderWidth: t.borderWidth,
    borderColor: t.borderColor
  };
}
function g1(t, e) {
  if (!e)
    return !1;
  const n = [], i = function(s, r) {
    return Fc(r) ? (n.includes(r) || n.push(r), n.indexOf(r)) : r;
  };
  return JSON.stringify(t, i) !== JSON.stringify(e, i);
}
function Ma(t, e, n) {
  return t.options.clip ? t[n] : e[n];
}
function y1(t, e) {
  const { xScale: n, yScale: i } = t;
  return n && i ? {
    left: Ma(n, e, "left"),
    right: Ma(n, e, "right"),
    top: Ma(i, e, "top"),
    bottom: Ma(i, e, "bottom")
  } : e;
}
function sg(t, e) {
  const n = e._clip;
  if (n.disabled)
    return !1;
  const i = y1(e, t.chartArea);
  return {
    left: n.left === !1 ? 0 : i.left - (n.left === !0 ? 0 : n.left),
    right: n.right === !1 ? t.width : i.right + (n.right === !0 ? 0 : n.right),
    top: n.top === !1 ? 0 : i.top - (n.top === !0 ? 0 : n.top),
    bottom: n.bottom === !1 ? t.height : i.bottom + (n.bottom === !0 ? 0 : n.bottom)
  };
}
/*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
class v1 {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(e, n, i, s) {
    const r = n.listeners[s], a = n.duration;
    r.forEach((o) => o({
      chart: e,
      initial: n.initial,
      numSteps: a,
      currentStep: Math.min(i - n.start, a)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = Bp.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(e = Date.now()) {
    let n = 0;
    this._charts.forEach((i, s) => {
      if (!i.running || !i.items.length)
        return;
      const r = i.items;
      let a = r.length - 1, o = !1, l;
      for (; a >= 0; --a)
        l = r[a], l._active ? (l._total > i.duration && (i.duration = l._total), l.tick(e), o = !0) : (r[a] = r[r.length - 1], r.pop());
      o && (s.draw(), this._notify(s, i, e, "progress")), r.length || (i.running = !1, this._notify(s, i, e, "complete"), i.initial = !1), n += r.length;
    }), this._lastDate = e, n === 0 && (this._running = !1);
  }
  _getAnims(e) {
    const n = this._charts;
    let i = n.get(e);
    return i || (i = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(e, i)), i;
  }
  listen(e, n, i) {
    this._getAnims(e).listeners[n].push(i);
  }
  add(e, n) {
    !n || !n.length || this._getAnims(e).items.push(...n);
  }
  has(e) {
    return this._getAnims(e).items.length > 0;
  }
  start(e) {
    const n = this._charts.get(e);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((i, s) => Math.max(i, s._duration), 0), this._refresh());
  }
  running(e) {
    if (!this._running)
      return !1;
    const n = this._charts.get(e);
    return !(!n || !n.running || !n.items.length);
  }
  stop(e) {
    const n = this._charts.get(e);
    if (!n || !n.items.length)
      return;
    const i = n.items;
    let s = i.length - 1;
    for (; s >= 0; --s)
      i[s].cancel();
    n.items = [], this._notify(e, n, Date.now(), "complete");
  }
  remove(e) {
    return this._charts.delete(e);
  }
}
var qn = /* @__PURE__ */ new v1();
const of = "transparent", b1 = {
  boolean(t, e, n) {
    return n > 0.5 ? e : t;
  },
  color(t, e, n) {
    const i = Zd(t || of), s = i.valid && Zd(e || of);
    return s && s.valid ? s.mix(i, n).hexString() : e;
  },
  number(t, e, n) {
    return t + (e - t) * n;
  }
};
class w1 {
  constructor(e, n, i, s) {
    const r = n[i];
    s = xr([
      e.to,
      s,
      r,
      e.from
    ]);
    const a = xr([
      e.from,
      r,
      s
    ]);
    this._active = !0, this._fn = e.fn || b1[e.type || typeof a], this._easing = Er[e.easing] || Er.linear, this._start = Math.floor(Date.now() + (e.delay || 0)), this._duration = this._total = Math.floor(e.duration), this._loop = !!e.loop, this._target = n, this._prop = i, this._from = a, this._to = s, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(e, n, i) {
    if (this._active) {
      this._notify(!1);
      const s = this._target[this._prop], r = i - this._start, a = this._duration - r;
      this._start = i, this._duration = Math.floor(Math.max(a, e.duration)), this._total += r, this._loop = !!e.loop, this._to = xr([
        e.to,
        n,
        s,
        e.from
      ]), this._from = xr([
        e.from,
        s,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(e) {
    const n = e - this._start, i = this._duration, s = this._prop, r = this._from, a = this._loop, o = this._to;
    let l;
    if (this._active = r !== o && (a || n < i), !this._active) {
      this._target[s] = o, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[s] = r;
      return;
    }
    l = n / i % 2, l = a && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[s] = this._fn(r, o, l);
  }
  wait() {
    const e = this._promises || (this._promises = []);
    return new Promise((n, i) => {
      e.push({
        res: n,
        rej: i
      });
    });
  }
  _notify(e) {
    const n = e ? "res" : "rej", i = this._promises || [];
    for (let s = 0; s < i.length; s++)
      i[s][n]();
  }
}
class Yc {
  constructor(e, n) {
    this._chart = e, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(e) {
    if (!Ae(e))
      return;
    const n = Object.keys(at.animation), i = this._properties;
    Object.getOwnPropertyNames(e).forEach((s) => {
      const r = e[s];
      if (!Ae(r))
        return;
      const a = {};
      for (const o of n)
        a[o] = r[o];
      (Ue(r.properties) && r.properties || [
        s
      ]).forEach((o) => {
        (o === s || !i.has(o)) && i.set(o, a);
      });
    });
  }
  _animateOptions(e, n) {
    const i = n.options, s = _1(e, i);
    if (!s)
      return [];
    const r = this._createAnimations(s, i);
    return i.$shared && x1(e.options.$animations, i).then(() => {
      e.options = i;
    }, () => {
    }), r;
  }
  _createAnimations(e, n) {
    const i = this._properties, s = [], r = e.$animations || (e.$animations = {}), a = Object.keys(n), o = Date.now();
    let l;
    for (l = a.length - 1; l >= 0; --l) {
      const u = a[l];
      if (u.charAt(0) === "$")
        continue;
      if (u === "options") {
        s.push(...this._animateOptions(e, n));
        continue;
      }
      const c = n[u];
      let d = r[u];
      const f = i.get(u);
      if (d)
        if (f && d.active()) {
          d.update(f, c, o);
          continue;
        } else
          d.cancel();
      if (!f || !f.duration) {
        e[u] = c;
        continue;
      }
      r[u] = d = new w1(f, e, u, c), s.push(d);
    }
    return s;
  }
  update(e, n) {
    if (this._properties.size === 0) {
      Object.assign(e, n);
      return;
    }
    const i = this._createAnimations(e, n);
    if (i.length)
      return qn.add(this._chart, i), !0;
  }
}
function x1(t, e) {
  const n = [], i = Object.keys(e);
  for (let s = 0; s < i.length; s++) {
    const r = t[i[s]];
    r && r.active() && n.push(r.wait());
  }
  return Promise.all(n);
}
function _1(t, e) {
  if (!e)
    return;
  let n = t.options;
  if (!n) {
    t.options = e;
    return;
  }
  return n.$shared && (t.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function lf(t, e) {
  const n = t && t.options || {}, i = n.reverse, s = n.min === void 0 ? e : 0, r = n.max === void 0 ? e : 0;
  return {
    start: i ? r : s,
    end: i ? s : r
  };
}
function k1(t, e, n) {
  if (n === !1)
    return !1;
  const i = lf(t, n), s = lf(e, n);
  return {
    top: s.end,
    right: i.end,
    bottom: s.start,
    left: i.start
  };
}
function M1(t) {
  let e, n, i, s;
  return Ae(t) ? (e = t.top, n = t.right, i = t.bottom, s = t.left) : e = n = i = s = t, {
    top: e,
    right: n,
    bottom: i,
    left: s,
    disabled: t === !1
  };
}
function rg(t, e) {
  const n = [], i = t._getSortedDatasetMetas(e);
  let s, r;
  for (s = 0, r = i.length; s < r; ++s)
    n.push(i[s].index);
  return n;
}
function uf(t, e, n, i = {}) {
  const s = t.keys, r = i.mode === "single";
  let a, o, l, u;
  if (e === null)
    return;
  let c = !1;
  for (a = 0, o = s.length; a < o; ++a) {
    if (l = +s[a], l === n) {
      if (c = !0, i.all)
        continue;
      break;
    }
    u = t.values[l], ot(u) && (r || e === 0 || Nn(e) === Nn(u)) && (e += u);
  }
  return !c && !i.all ? 0 : e;
}
function S1(t, e) {
  const { iScale: n, vScale: i } = e, s = n.axis === "x" ? "x" : "y", r = i.axis === "x" ? "x" : "y", a = Object.keys(t), o = new Array(a.length);
  let l, u, c;
  for (l = 0, u = a.length; l < u; ++l)
    c = a[l], o[l] = {
      [s]: c,
      [r]: t[c]
    };
  return o;
}
function nl(t, e) {
  const n = t && t.options.stacked;
  return n || n === void 0 && e.stack !== void 0;
}
function O1(t, e, n) {
  return `${t.id}.${e.id}.${n.stack || n.type}`;
}
function D1(t) {
  const { min: e, max: n, minDefined: i, maxDefined: s } = t.getUserBounds();
  return {
    min: i ? e : Number.NEGATIVE_INFINITY,
    max: s ? n : Number.POSITIVE_INFINITY
  };
}
function T1(t, e, n) {
  const i = t[e] || (t[e] = {});
  return i[n] || (i[n] = {});
}
function cf(t, e, n, i) {
  for (const s of e.getMatchingVisibleMetas(i).reverse()) {
    const r = t[s.index];
    if (n && r > 0 || !n && r < 0)
      return s.index;
  }
  return null;
}
function df(t, e) {
  const { chart: n, _cachedMeta: i } = t, s = n._stacks || (n._stacks = {}), { iScale: r, vScale: a, index: o } = i, l = r.axis, u = a.axis, c = O1(r, a, i), d = e.length;
  let f;
  for (let h = 0; h < d; ++h) {
    const m = e[h], { [l]: p, [u]: g } = m, y = m._stacks || (m._stacks = {});
    f = y[u] = T1(s, c, p), f[o] = g, f._top = cf(f, a, !0, i.type), f._bottom = cf(f, a, !1, i.type);
    const v = f._visualValues || (f._visualValues = {});
    v[o] = g;
  }
}
function il(t, e) {
  const n = t.scales;
  return Object.keys(n).filter((i) => n[i].axis === e).shift();
}
function P1(t, e) {
  return Li(t, {
    active: !1,
    dataset: void 0,
    datasetIndex: e,
    index: e,
    mode: "default",
    type: "dataset"
  });
}
function C1(t, e, n) {
  return Li(t, {
    active: !1,
    dataIndex: e,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: e,
    mode: "default",
    type: "data"
  });
}
function dr(t, e) {
  const n = t.controller.index, i = t.vScale && t.vScale.axis;
  if (i) {
    e = e || t._parsed;
    for (const s of e) {
      const r = s._stacks;
      if (!r || r[i] === void 0 || r[i][n] === void 0)
        return;
      delete r[i][n], r[i]._visualValues !== void 0 && r[i]._visualValues[n] !== void 0 && delete r[i]._visualValues[n];
    }
  }
}
const sl = (t) => t === "reset" || t === "none", ff = (t, e) => e ? t : Object.assign({}, t), A1 = (t, e, n) => t && !e.hidden && e._stacked && {
  keys: rg(n, !0),
  values: null
};
class _n {
  constructor(e, n) {
    this.chart = e, this._ctx = e.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const e = this._cachedMeta;
    this.configure(), this.linkScales(), e._stacked = nl(e.vScale, e), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(e) {
    this.index !== e && dr(this._cachedMeta), this.index = e;
  }
  linkScales() {
    const e = this.chart, n = this._cachedMeta, i = this.getDataset(), s = (d, f, h, m) => d === "x" ? f : d === "r" ? m : h, r = n.xAxisID = De(i.xAxisID, il(e, "x")), a = n.yAxisID = De(i.yAxisID, il(e, "y")), o = n.rAxisID = De(i.rAxisID, il(e, "r")), l = n.indexAxis, u = n.iAxisID = s(l, r, a, o), c = n.vAxisID = s(l, a, r, o);
    n.xScale = this.getScaleForId(r), n.yScale = this.getScaleForId(a), n.rScale = this.getScaleForId(o), n.iScale = this.getScaleForId(u), n.vScale = this.getScaleForId(c);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(e) {
    return this.chart.scales[e];
  }
  _getOtherScale(e) {
    const n = this._cachedMeta;
    return e === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const e = this._cachedMeta;
    this._data && Ud(this._data, this), e._stacked && dr(e);
  }
  _dataCheck() {
    const e = this.getDataset(), n = e.data || (e.data = []), i = this._data;
    if (Ae(n)) {
      const s = this._cachedMeta;
      this._data = S1(n, s);
    } else if (i !== n) {
      if (i) {
        Ud(i, this);
        const s = this._cachedMeta;
        dr(s), s._parsed = [];
      }
      n && Object.isExtensible(n) && pw(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const e = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (e.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(e) {
    const n = this._cachedMeta, i = this.getDataset();
    let s = !1;
    this._dataCheck();
    const r = n._stacked;
    n._stacked = nl(n.vScale, n), n.stack !== i.stack && (s = !0, dr(n), n.stack = i.stack), this._resyncElements(e), (s || r !== n._stacked) && (df(this, n._parsed), n._stacked = nl(n.vScale, n));
  }
  configure() {
    const e = this.chart.config, n = e.datasetScopeKeys(this._type), i = e.getOptionScopes(this.getDataset(), n, !0);
    this.options = e.createResolver(i, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(e, n) {
    const { _cachedMeta: i, _data: s } = this, { iScale: r, _stacked: a } = i, o = r.axis;
    let l = e === 0 && n === s.length ? !0 : i._sorted, u = e > 0 && i._parsed[e - 1], c, d, f;
    if (this._parsing === !1)
      i._parsed = s, i._sorted = !0, f = s;
    else {
      Ue(s[e]) ? f = this.parseArrayData(i, s, e, n) : Ae(s[e]) ? f = this.parseObjectData(i, s, e, n) : f = this.parsePrimitiveData(i, s, e, n);
      const h = () => d[o] === null || u && d[o] < u[o];
      for (c = 0; c < n; ++c)
        i._parsed[c + e] = d = f[c], l && (h() && (l = !1), u = d);
      i._sorted = l;
    }
    a && df(this, f);
  }
  parsePrimitiveData(e, n, i, s) {
    const { iScale: r, vScale: a } = e, o = r.axis, l = a.axis, u = r.getLabels(), c = r === a, d = new Array(s);
    let f, h, m;
    for (f = 0, h = s; f < h; ++f)
      m = f + i, d[f] = {
        [o]: c || r.parse(u[m], m),
        [l]: a.parse(n[m], m)
      };
    return d;
  }
  parseArrayData(e, n, i, s) {
    const { xScale: r, yScale: a } = e, o = new Array(s);
    let l, u, c, d;
    for (l = 0, u = s; l < u; ++l)
      c = l + i, d = n[c], o[l] = {
        x: r.parse(d[0], c),
        y: a.parse(d[1], c)
      };
    return o;
  }
  parseObjectData(e, n, i, s) {
    const { xScale: r, yScale: a } = e, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, u = new Array(s);
    let c, d, f, h;
    for (c = 0, d = s; c < d; ++c)
      f = c + i, h = n[f], u[c] = {
        x: r.parse(Ci(h, o), f),
        y: a.parse(Ci(h, l), f)
      };
    return u;
  }
  getParsed(e) {
    return this._cachedMeta._parsed[e];
  }
  getDataElement(e) {
    return this._cachedMeta.data[e];
  }
  applyStack(e, n, i) {
    const s = this.chart, r = this._cachedMeta, a = n[e.axis], o = {
      keys: rg(s, !0),
      values: n._stacks[e.axis]._visualValues
    };
    return uf(o, a, r.index, {
      mode: i
    });
  }
  updateRangeFromParsed(e, n, i, s) {
    const r = i[n.axis];
    let a = r === null ? NaN : r;
    const o = s && i._stacks[n.axis];
    s && o && (s.values = o, a = uf(s, r, this._cachedMeta.index)), e.min = Math.min(e.min, a), e.max = Math.max(e.max, a);
  }
  getMinMax(e, n) {
    const i = this._cachedMeta, s = i._parsed, r = i._sorted && e === i.iScale, a = s.length, o = this._getOtherScale(e), l = A1(n, i, this.chart), u = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: c, max: d } = D1(o);
    let f, h;
    function m() {
      h = s[f];
      const p = h[o.axis];
      return !ot(h[e.axis]) || c > p || d < p;
    }
    for (f = 0; f < a && !(!m() && (this.updateRangeFromParsed(u, e, h, l), r)); ++f)
      ;
    if (r) {
      for (f = a - 1; f >= 0; --f)
        if (!m()) {
          this.updateRangeFromParsed(u, e, h, l);
          break;
        }
    }
    return u;
  }
  getAllParsedValues(e) {
    const n = this._cachedMeta._parsed, i = [];
    let s, r, a;
    for (s = 0, r = n.length; s < r; ++s)
      a = n[s][e.axis], ot(a) && i.push(a);
    return i;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, i = n.iScale, s = n.vScale, r = this.getParsed(e);
    return {
      label: i ? "" + i.getLabelForValue(r[i.axis]) : "",
      value: s ? "" + s.getLabelForValue(r[s.axis]) : ""
    };
  }
  _update(e) {
    const n = this._cachedMeta;
    this.update(e || "default"), n._clip = M1(De(this.options.clip, k1(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(e) {
  }
  draw() {
    const e = this._ctx, n = this.chart, i = this._cachedMeta, s = i.data || [], r = n.chartArea, a = [], o = this._drawStart || 0, l = this._drawCount || s.length - o, u = this.options.drawActiveElementsOnTop;
    let c;
    for (i.dataset && i.dataset.draw(e, r, o, l), c = o; c < o + l; ++c) {
      const d = s[c];
      d.hidden || (d.active && u ? a.push(d) : d.draw(e, r));
    }
    for (c = 0; c < a.length; ++c)
      a[c].draw(e, r);
  }
  getStyle(e, n) {
    const i = n ? "active" : "default";
    return e === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(i) : this.resolveDataElementOptions(e || 0, i);
  }
  getContext(e, n, i) {
    const s = this.getDataset();
    let r;
    if (e >= 0 && e < this._cachedMeta.data.length) {
      const a = this._cachedMeta.data[e];
      r = a.$context || (a.$context = C1(this.getContext(), e, a)), r.parsed = this.getParsed(e), r.raw = s.data[e], r.index = r.dataIndex = e;
    } else
      r = this.$context || (this.$context = P1(this.chart.getContext(), this.index)), r.dataset = s, r.index = r.datasetIndex = this.index;
    return r.active = !!n, r.mode = i, r;
  }
  resolveDatasetElementOptions(e) {
    return this._resolveElementOptions(this.datasetElementType.id, e);
  }
  resolveDataElementOptions(e, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, e);
  }
  _resolveElementOptions(e, n = "default", i) {
    const s = n === "active", r = this._cachedDataOpts, a = e + "-" + n, o = r[a], l = this.enableOptionSharing && en(i);
    if (o)
      return ff(o, l);
    const u = this.chart.config, c = u.datasetElementScopeKeys(this._type, e), d = s ? [
      `${e}Hover`,
      "hover",
      e,
      ""
    ] : [
      e,
      ""
    ], f = u.getOptionScopes(this.getDataset(), c), h = Object.keys(at.elements[e]), m = () => this.getContext(i, s, n), p = u.resolveNamedOptions(f, h, m, d);
    return p.$shared && (p.$shared = l, r[a] = Object.freeze(ff(p, l))), p;
  }
  _resolveAnimations(e, n, i) {
    const s = this.chart, r = this._cachedDataOpts, a = `animation-${n}`, o = r[a];
    if (o)
      return o;
    let l;
    if (s.options.animation !== !1) {
      const c = this.chart.config, d = c.datasetAnimationScopeKeys(this._type, n), f = c.getOptionScopes(this.getDataset(), d);
      l = c.createResolver(f, this.getContext(e, i, n));
    }
    const u = new Yc(s, l && l.animations);
    return l && l._cacheable && (r[a] = Object.freeze(u)), u;
  }
  getSharedOptions(e) {
    if (e.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, e));
  }
  includeOptions(e, n) {
    return !n || sl(e) || this.chart._animationsDisabled;
  }
  _getSharedOptions(e, n) {
    const i = this.resolveDataElementOptions(e, n), s = this._sharedOptions, r = this.getSharedOptions(i), a = this.includeOptions(n, r) || r !== s;
    return this.updateSharedOptions(r, n, i), {
      sharedOptions: r,
      includeOptions: a
    };
  }
  updateElement(e, n, i, s) {
    sl(s) ? Object.assign(e, i) : this._resolveAnimations(n, s).update(e, i);
  }
  updateSharedOptions(e, n, i) {
    e && !sl(n) && this._resolveAnimations(void 0, n).update(e, i);
  }
  _setStyle(e, n, i, s) {
    e.active = s;
    const r = this.getStyle(n, s);
    this._resolveAnimations(n, i, s).update(e, {
      options: !s && this.getSharedOptions(r) || r
    });
  }
  removeHoverStyle(e, n, i) {
    this._setStyle(e, i, "active", !1);
  }
  setHoverStyle(e, n, i) {
    this._setStyle(e, i, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !0);
  }
  _resyncElements(e) {
    const n = this._data, i = this._cachedMeta.data;
    for (const [o, l, u] of this._syncList)
      this[o](l, u);
    this._syncList = [];
    const s = i.length, r = n.length, a = Math.min(r, s);
    a && this.parse(0, a), r > s ? this._insertElements(s, r - s, e) : r < s && this._removeElements(r, s - r);
  }
  _insertElements(e, n, i = !0) {
    const s = this._cachedMeta, r = s.data, a = e + n;
    let o;
    const l = (u) => {
      for (u.length += n, o = u.length - 1; o >= a; o--)
        u[o] = u[o - n];
    };
    for (l(r), o = e; o < a; ++o)
      r[o] = new this.dataElementType();
    this._parsing && l(s._parsed), this.parse(e, n), i && this.updateElements(r, e, n, "reset");
  }
  updateElements(e, n, i, s) {
  }
  _removeElements(e, n) {
    const i = this._cachedMeta;
    if (this._parsing) {
      const s = i._parsed.splice(e, n);
      i._stacked && dr(i, s);
    }
    i.data.splice(e, n);
  }
  _sync(e) {
    if (this._parsing)
      this._syncList.push(e);
    else {
      const [n, i, s] = e;
      this[n](i, s);
    }
    this.chart._dataChanges.push([
      this.index,
      ...e
    ]);
  }
  _onDataPush() {
    const e = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - e,
      e
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(e, n) {
    n && this._sync([
      "_removeElements",
      e,
      n
    ]);
    const i = arguments.length - 2;
    i && this._sync([
      "_insertElements",
      e,
      i
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
X(_n, "defaults", {}), X(_n, "datasetElementType", null), X(_n, "dataElementType", null);
function E1(t, e) {
  if (!t._cache.$bar) {
    const n = t.getMatchingVisibleMetas(e);
    let i = [];
    for (let s = 0, r = n.length; s < r; s++)
      i = i.concat(n[s].controller.getAllParsedValues(t));
    t._cache.$bar = Np(i.sort((s, r) => s - r));
  }
  return t._cache.$bar;
}
function $1(t) {
  const e = t.iScale, n = E1(e, t.type);
  let i = e._length, s, r, a, o;
  const l = () => {
    a === 32767 || a === -32768 || (en(o) && (i = Math.min(i, Math.abs(a - o) || i)), o = a);
  };
  for (s = 0, r = n.length; s < r; ++s)
    a = e.getPixelForValue(n[s]), l();
  for (o = void 0, s = 0, r = e.ticks.length; s < r; ++s)
    a = e.getPixelForTick(s), l();
  return i;
}
function R1(t, e, n, i) {
  const s = n.barThickness;
  let r, a;
  return Ie(s) ? (r = e.min * n.categoryPercentage, a = n.barPercentage) : (r = s * i, a = 1), {
    chunk: r / i,
    ratio: a,
    start: e.pixels[t] - r / 2
  };
}
function L1(t, e, n, i) {
  const s = e.pixels, r = s[t];
  let a = t > 0 ? s[t - 1] : null, o = t < s.length - 1 ? s[t + 1] : null;
  const l = n.categoryPercentage;
  a === null && (a = r - (o === null ? e.end - e.start : o - r)), o === null && (o = r + r - a);
  const u = r - (r - Math.min(a, o)) / 2 * l;
  return {
    chunk: Math.abs(o - a) / 2 * l / i,
    ratio: n.barPercentage,
    start: u
  };
}
function I1(t, e, n, i) {
  const s = n.parse(t[0], i), r = n.parse(t[1], i), a = Math.min(s, r), o = Math.max(s, r);
  let l = a, u = o;
  Math.abs(a) > Math.abs(o) && (l = o, u = a), e[n.axis] = u, e._custom = {
    barStart: l,
    barEnd: u,
    start: s,
    end: r,
    min: a,
    max: o
  };
}
function ag(t, e, n, i) {
  return Ue(t) ? I1(t, e, n, i) : e[n.axis] = n.parse(t, i), e;
}
function hf(t, e, n, i) {
  const s = t.iScale, r = t.vScale, a = s.getLabels(), o = s === r, l = [];
  let u, c, d, f;
  for (u = n, c = n + i; u < c; ++u)
    f = e[u], d = {}, d[s.axis] = o || s.parse(a[u], u), l.push(ag(f, d, r, u));
  return l;
}
function rl(t) {
  return t && t.barStart !== void 0 && t.barEnd !== void 0;
}
function F1(t, e, n) {
  return t !== 0 ? Nn(t) : (e.isHorizontal() ? 1 : -1) * (e.min >= n ? 1 : -1);
}
function V1(t) {
  let e, n, i, s, r;
  return t.horizontal ? (e = t.base > t.x, n = "left", i = "right") : (e = t.base < t.y, n = "bottom", i = "top"), e ? (s = "end", r = "start") : (s = "start", r = "end"), {
    start: n,
    end: i,
    reverse: e,
    top: s,
    bottom: r
  };
}
function N1(t, e, n, i) {
  let s = e.borderSkipped;
  const r = {};
  if (!s) {
    t.borderSkipped = r;
    return;
  }
  if (s === !0) {
    t.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: a, end: o, reverse: l, top: u, bottom: c } = V1(t);
  s === "middle" && n && (t.enableBorderRadius = !0, (n._top || 0) === i ? s = u : (n._bottom || 0) === i ? s = c : (r[mf(c, a, o, l)] = !0, s = u)), r[mf(s, a, o, l)] = !0, t.borderSkipped = r;
}
function mf(t, e, n, i) {
  return i ? (t = B1(t, e, n), t = pf(t, n, e)) : t = pf(t, e, n), t;
}
function B1(t, e, n) {
  return t === e ? n : t === n ? e : t;
}
function pf(t, e, n) {
  return t === "start" ? e : t === "end" ? n : t;
}
function z1(t, { inflateAmount: e }, n) {
  t.inflateAmount = e === "auto" ? n === 1 ? 0.33 : 0 : e;
}
class Wa extends _n {
  parsePrimitiveData(e, n, i, s) {
    return hf(e, n, i, s);
  }
  parseArrayData(e, n, i, s) {
    return hf(e, n, i, s);
  }
  parseObjectData(e, n, i, s) {
    const { iScale: r, vScale: a } = e, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, u = r.axis === "x" ? o : l, c = a.axis === "x" ? o : l, d = [];
    let f, h, m, p;
    for (f = i, h = i + s; f < h; ++f)
      p = n[f], m = {}, m[r.axis] = r.parse(Ci(p, u), f), d.push(ag(Ci(p, c), m, a, f));
    return d;
  }
  updateRangeFromParsed(e, n, i, s) {
    super.updateRangeFromParsed(e, n, i, s);
    const r = i._custom;
    r && n === this._cachedMeta.vScale && (e.min = Math.min(e.min, r.min), e.max = Math.max(e.max, r.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, { iScale: i, vScale: s } = n, r = this.getParsed(e), a = r._custom, o = rl(a) ? "[" + a.start + ", " + a.end + "]" : "" + s.getLabelForValue(r[s.axis]);
    return {
      label: "" + i.getLabelForValue(r[i.axis]),
      value: o
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const e = this._cachedMeta;
    e.stack = this.getDataset().stack;
  }
  update(e) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, e);
  }
  updateElements(e, n, i, s) {
    const r = s === "reset", { index: a, _cachedMeta: { vScale: o } } = this, l = o.getBasePixel(), u = o.isHorizontal(), c = this._getRuler(), { sharedOptions: d, includeOptions: f } = this._getSharedOptions(n, s);
    for (let h = n; h < n + i; h++) {
      const m = this.getParsed(h), p = r || Ie(m[o.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(h), g = this._calculateBarIndexPixels(h, c), y = (m._stacks || {})[o.axis], v = {
        horizontal: u,
        base: p.base,
        enableBorderRadius: !y || rl(m._custom) || a === y._top || a === y._bottom,
        x: u ? p.head : g.center,
        y: u ? g.center : p.head,
        height: u ? g.size : Math.abs(p.size),
        width: u ? Math.abs(p.size) : g.size
      };
      f && (v.options = d || this.resolveDataElementOptions(h, e[h].active ? "active" : s));
      const b = v.options || e[h].options;
      N1(v, b, y, a), z1(v, b, c.ratio), this.updateElement(e[h], h, v, s);
    }
  }
  _getStacks(e, n) {
    const { iScale: i } = this._cachedMeta, s = i.getMatchingVisibleMetas(this._type).filter((c) => c.controller.options.grouped), r = i.options.stacked, a = [], o = this._cachedMeta.controller.getParsed(n), l = o && o[i.axis], u = (c) => {
      const d = c._parsed.find((h) => h[i.axis] === l), f = d && d[c.vScale.axis];
      if (Ie(f) || isNaN(f))
        return !0;
    };
    for (const c of s)
      if (!(n !== void 0 && u(c)) && ((r === !1 || a.indexOf(c.stack) === -1 || r === void 0 && c.stack === void 0) && a.push(c.stack), c.index === e))
        break;
    return a.length || a.push(void 0), a;
  }
  _getStackCount(e) {
    return this._getStacks(void 0, e).length;
  }
  _getStackIndex(e, n, i) {
    const s = this._getStacks(e, i), r = n !== void 0 ? s.indexOf(n) : -1;
    return r === -1 ? s.length - 1 : r;
  }
  _getRuler() {
    const e = this.options, n = this._cachedMeta, i = n.iScale, s = [];
    let r, a;
    for (r = 0, a = n.data.length; r < a; ++r)
      s.push(i.getPixelForValue(this.getParsed(r)[i.axis], r));
    const o = e.barThickness;
    return {
      min: o || $1(n),
      pixels: s,
      start: i._startPixel,
      end: i._endPixel,
      stackCount: this._getStackCount(),
      scale: i,
      grouped: e.grouped,
      ratio: o ? 1 : e.categoryPercentage * e.barPercentage
    };
  }
  _calculateBarValuePixels(e) {
    const { _cachedMeta: { vScale: n, _stacked: i, index: s }, options: { base: r, minBarLength: a } } = this, o = r || 0, l = this.getParsed(e), u = l._custom, c = rl(u);
    let d = l[n.axis], f = 0, h = i ? this.applyStack(n, l, i) : d, m, p;
    h !== d && (f = h - d, h = d), c && (d = u.barStart, h = u.barEnd - u.barStart, d !== 0 && Nn(d) !== Nn(u.barEnd) && (f = 0), f += d);
    const g = !Ie(r) && !c ? r : f;
    let y = n.getPixelForValue(g);
    if (this.chart.getDataVisibility(e) ? m = n.getPixelForValue(f + h) : m = y, p = m - y, Math.abs(p) < a) {
      p = F1(p, n, o) * a, d === o && (y -= p / 2);
      const v = n.getPixelForDecimal(0), b = n.getPixelForDecimal(1), _ = Math.min(v, b), M = Math.max(v, b);
      y = Math.max(Math.min(y, M), _), m = y + p, i && !c && (l._stacks[n.axis]._visualValues[s] = n.getValueForPixel(m) - n.getValueForPixel(y));
    }
    if (y === n.getPixelForValue(o)) {
      const v = Nn(p) * n.getLineWidthForValue(o) / 2;
      y += v, p -= v;
    }
    return {
      size: p,
      base: y,
      head: m,
      center: m + p / 2
    };
  }
  _calculateBarIndexPixels(e, n) {
    const i = n.scale, s = this.options, r = s.skipNull, a = De(s.maxBarThickness, 1 / 0);
    let o, l;
    if (n.grouped) {
      const u = r ? this._getStackCount(e) : n.stackCount, c = s.barThickness === "flex" ? L1(e, n, s, u) : R1(e, n, s, u), d = this._getStackIndex(this.index, this._cachedMeta.stack, r ? e : void 0);
      o = c.start + c.chunk * d + c.chunk / 2, l = Math.min(a, c.chunk * c.ratio);
    } else
      o = i.getPixelForValue(this.getParsed(e)[i.axis], e), l = Math.min(a, n.min * n.ratio);
    return {
      base: o - l / 2,
      head: o + l / 2,
      center: o,
      size: l
    };
  }
  draw() {
    const e = this._cachedMeta, n = e.vScale, i = e.data, s = i.length;
    let r = 0;
    for (; r < s; ++r)
      this.getParsed(r)[n.axis] !== null && !i[r].hidden && i[r].draw(this._ctx);
  }
}
X(Wa, "id", "bar"), X(Wa, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), X(Wa, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
class Ha extends _n {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(e, n, i, s) {
    const r = super.parsePrimitiveData(e, n, i, s);
    for (let a = 0; a < r.length; a++)
      r[a]._custom = this.resolveDataElementOptions(a + i).radius;
    return r;
  }
  parseArrayData(e, n, i, s) {
    const r = super.parseArrayData(e, n, i, s);
    for (let a = 0; a < r.length; a++) {
      const o = n[i + a];
      r[a]._custom = De(o[2], this.resolveDataElementOptions(a + i).radius);
    }
    return r;
  }
  parseObjectData(e, n, i, s) {
    const r = super.parseObjectData(e, n, i, s);
    for (let a = 0; a < r.length; a++) {
      const o = n[i + a];
      r[a]._custom = De(o && o.r && +o.r, this.resolveDataElementOptions(a + i).radius);
    }
    return r;
  }
  getMaxOverflow() {
    const e = this._cachedMeta.data;
    let n = 0;
    for (let i = e.length - 1; i >= 0; --i)
      n = Math.max(n, e[i].size(this.resolveDataElementOptions(i)) / 2);
    return n > 0 && n;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, i = this.chart.data.labels || [], { xScale: s, yScale: r } = n, a = this.getParsed(e), o = s.getLabelForValue(a.x), l = r.getLabelForValue(a.y), u = a._custom;
    return {
      label: i[e] || "",
      value: "(" + o + ", " + l + (u ? ", " + u : "") + ")"
    };
  }
  update(e) {
    const n = this._cachedMeta.data;
    this.updateElements(n, 0, n.length, e);
  }
  updateElements(e, n, i, s) {
    const r = s === "reset", { iScale: a, vScale: o } = this._cachedMeta, { sharedOptions: l, includeOptions: u } = this._getSharedOptions(n, s), c = a.axis, d = o.axis;
    for (let f = n; f < n + i; f++) {
      const h = e[f], m = !r && this.getParsed(f), p = {}, g = p[c] = r ? a.getPixelForDecimal(0.5) : a.getPixelForValue(m[c]), y = p[d] = r ? o.getBasePixel() : o.getPixelForValue(m[d]);
      p.skip = isNaN(g) || isNaN(y), u && (p.options = l || this.resolveDataElementOptions(f, h.active ? "active" : s), r && (p.options.radius = 0)), this.updateElement(h, f, p, s);
    }
  }
  resolveDataElementOptions(e, n) {
    const i = this.getParsed(e);
    let s = super.resolveDataElementOptions(e, n);
    s.$shared && (s = Object.assign({}, s, {
      $shared: !1
    }));
    const r = s.radius;
    return n !== "active" && (s.radius = 0), s.radius += De(i && i._custom, r), s;
  }
}
X(Ha, "id", "bubble"), X(Ha, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "borderWidth",
        "radius"
      ]
    }
  }
}), X(Ha, "overrides", {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function W1(t, e, n) {
  let i = 1, s = 1, r = 0, a = 0;
  if (e < nt) {
    const o = t, l = o + e, u = Math.cos(o), c = Math.sin(o), d = Math.cos(l), f = Math.sin(l), h = (b, _, M) => Yr(b, o, l, !0) ? 1 : Math.max(_, _ * n, M, M * n), m = (b, _, M) => Yr(b, o, l, !0) ? -1 : Math.min(_, _ * n, M, M * n), p = h(0, u, d), g = h(rt, c, f), y = m(Ne, u, d), v = m(Ne + rt, c, f);
    i = (p - y) / 2, s = (g - v) / 2, r = -(p + y) / 2, a = -(g + v) / 2;
  }
  return {
    ratioX: i,
    ratioY: s,
    offsetX: r,
    offsetY: a
  };
}
class yi extends _n {
  constructor(e, n) {
    super(e, n), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(e, n) {
    const i = this.getDataset().data, s = this._cachedMeta;
    if (this._parsing === !1)
      s._parsed = i;
    else {
      let r = (l) => +i[l];
      if (Ae(i[e])) {
        const { key: l = "value" } = this._parsing;
        r = (u) => +Ci(i[u], l);
      }
      let a, o;
      for (a = e, o = e + n; a < o; ++a)
        s._parsed[a] = r(a);
    }
  }
  _getRotation() {
    return St(this.options.rotation - 90);
  }
  _getCircumference() {
    return St(this.options.circumference);
  }
  _getRotationExtents() {
    let e = nt, n = -nt;
    for (let i = 0; i < this.chart.data.datasets.length; ++i)
      if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
        const s = this.chart.getDatasetMeta(i).controller, r = s._getRotation(), a = s._getCircumference();
        e = Math.min(e, r), n = Math.max(n, r + a);
      }
    return {
      rotation: e,
      circumference: n - e
    };
  }
  update(e) {
    const n = this.chart, { chartArea: i } = n, s = this._cachedMeta, r = s.data, a = this.getMaxBorderWidth() + this.getMaxOffset(r) + this.options.spacing, o = Math.max((Math.min(i.width, i.height) - a) / 2, 0), l = Math.min(tw(this.options.cutout, o), 1), u = this._getRingWeight(this.index), { circumference: c, rotation: d } = this._getRotationExtents(), { ratioX: f, ratioY: h, offsetX: m, offsetY: p } = W1(d, c, l), g = (i.width - a) / f, y = (i.height - a) / h, v = Math.max(Math.min(g, y) / 2, 0), b = Lp(this.options.radius, v), _ = Math.max(b * l, 0), M = (b - _) / this._getVisibleDatasetWeightTotal();
    this.offsetX = m * b, this.offsetY = p * b, s.total = this.calculateTotal(), this.outerRadius = b - M * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - M * u, 0), this.updateElements(r, 0, r.length, e);
  }
  _circumference(e, n) {
    const i = this.options, s = this._cachedMeta, r = this._getCircumference();
    return n && i.animation.animateRotate || !this.chart.getDataVisibility(e) || s._parsed[e] === null || s.data[e].hidden ? 0 : this.calculateCircumference(s._parsed[e] * r / nt);
  }
  updateElements(e, n, i, s) {
    const r = s === "reset", a = this.chart, o = a.chartArea, u = a.options.animation, c = (o.left + o.right) / 2, d = (o.top + o.bottom) / 2, f = r && u.animateScale, h = f ? 0 : this.innerRadius, m = f ? 0 : this.outerRadius, { sharedOptions: p, includeOptions: g } = this._getSharedOptions(n, s);
    let y = this._getRotation(), v;
    for (v = 0; v < n; ++v)
      y += this._circumference(v, r);
    for (v = n; v < n + i; ++v) {
      const b = this._circumference(v, r), _ = e[v], M = {
        x: c + this.offsetX,
        y: d + this.offsetY,
        startAngle: y,
        endAngle: y + b,
        circumference: b,
        outerRadius: m,
        innerRadius: h
      };
      g && (M.options = p || this.resolveDataElementOptions(v, _.active ? "active" : s)), y += b, this.updateElement(_, v, M, s);
    }
  }
  calculateTotal() {
    const e = this._cachedMeta, n = e.data;
    let i = 0, s;
    for (s = 0; s < n.length; s++) {
      const r = e._parsed[s];
      r !== null && !isNaN(r) && this.chart.getDataVisibility(s) && !n[s].hidden && (i += Math.abs(r));
    }
    return i;
  }
  calculateCircumference(e) {
    const n = this._cachedMeta.total;
    return n > 0 && !isNaN(e) ? nt * (Math.abs(e) / n) : 0;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, i = this.chart, s = i.data.labels || [], r = ta(n._parsed[e], i.options.locale);
    return {
      label: s[e] || "",
      value: r
    };
  }
  getMaxBorderWidth(e) {
    let n = 0;
    const i = this.chart;
    let s, r, a, o, l;
    if (!e) {
      for (s = 0, r = i.data.datasets.length; s < r; ++s)
        if (i.isDatasetVisible(s)) {
          a = i.getDatasetMeta(s), e = a.data, o = a.controller;
          break;
        }
    }
    if (!e)
      return 0;
    for (s = 0, r = e.length; s < r; ++s)
      l = o.resolveDataElementOptions(s), l.borderAlign !== "inner" && (n = Math.max(n, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return n;
  }
  getMaxOffset(e) {
    let n = 0;
    for (let i = 0, s = e.length; i < s; ++i) {
      const r = this.resolveDataElementOptions(i);
      n = Math.max(n, r.offset || 0, r.hoverOffset || 0);
    }
    return n;
  }
  _getRingWeightOffset(e) {
    let n = 0;
    for (let i = 0; i < e; ++i)
      this.chart.isDatasetVisible(i) && (n += this._getRingWeight(i));
    return n;
  }
  _getRingWeight(e) {
    return Math.max(De(this.chart.data.datasets[e].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
X(yi, "id", "doughnut"), X(yi, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), X(yi, "descriptors", {
  _scriptable: (e) => e !== "spacing",
  _indexable: (e) => e !== "spacing" && !e.startsWith("borderDash") && !e.startsWith("hoverBorderDash")
}), X(yi, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const n = e.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: i, color: s } } = e.legend.options;
            return n.labels.map((r, a) => {
              const l = e.getDatasetMeta(0).controller.getStyle(a);
              return {
                text: r,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: s,
                lineWidth: l.borderWidth,
                pointStyle: i,
                hidden: !e.getDataVisibility(a),
                index: a
              };
            });
          }
          return [];
        }
      },
      onClick(e, n, i) {
        i.chart.toggleDataVisibility(n.index), i.chart.update();
      }
    }
  }
});
class Ya extends _n {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(e) {
    const n = this._cachedMeta, { dataset: i, data: s = [], _dataset: r } = n, a = this.chart._animationsDisabled;
    let { start: o, count: l } = Wp(n, s, a);
    this._drawStart = o, this._drawCount = l, Hp(n) && (o = 0, l = s.length), i._chart = this.chart, i._datasetIndex = this.index, i._decimated = !!r._decimated, i.points = s;
    const u = this.resolveDatasetElementOptions(e);
    this.options.showLine || (u.borderWidth = 0), u.segment = this.options.segment, this.updateElement(i, void 0, {
      animated: !a,
      options: u
    }, e), this.updateElements(s, o, l, e);
  }
  updateElements(e, n, i, s) {
    const r = s === "reset", { iScale: a, vScale: o, _stacked: l, _dataset: u } = this._cachedMeta, { sharedOptions: c, includeOptions: d } = this._getSharedOptions(n, s), f = a.axis, h = o.axis, { spanGaps: m, segment: p } = this.options, g = Ai(m) ? m : Number.POSITIVE_INFINITY, y = this.chart._animationsDisabled || r || s === "none", v = n + i, b = e.length;
    let _ = n > 0 && this.getParsed(n - 1);
    for (let M = 0; M < b; ++M) {
      const A = e[M], E = y ? A : {};
      if (M < n || M >= v) {
        E.skip = !0;
        continue;
      }
      const I = this.getParsed(M), S = Ie(I[h]), $ = E[f] = a.getPixelForValue(I[f], M), B = E[h] = r || S ? o.getBasePixel() : o.getPixelForValue(l ? this.applyStack(o, I, l) : I[h], M);
      E.skip = isNaN($) || isNaN(B) || S, E.stop = M > 0 && Math.abs(I[f] - _[f]) > g, p && (E.parsed = I, E.raw = u.data[M]), d && (E.options = c || this.resolveDataElementOptions(M, A.active ? "active" : s)), y || this.updateElement(A, M, E, s), _ = I;
    }
  }
  getMaxOverflow() {
    const e = this._cachedMeta, n = e.dataset, i = n.options && n.options.borderWidth || 0, s = e.data || [];
    if (!s.length)
      return i;
    const r = s[0].size(this.resolveDataElementOptions(0)), a = s[s.length - 1].size(this.resolveDataElementOptions(s.length - 1));
    return Math.max(i, r, a) / 2;
  }
  draw() {
    const e = this._cachedMeta;
    e.dataset.updateControlPoints(this.chart.chartArea, e.iScale.axis), super.draw();
  }
}
X(Ya, "id", "line"), X(Ya, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), X(Ya, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
class Rr extends _n {
  constructor(e, n) {
    super(e, n), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, i = this.chart, s = i.data.labels || [], r = ta(n._parsed[e].r, i.options.locale);
    return {
      label: s[e] || "",
      value: r
    };
  }
  parseObjectData(e, n, i, s) {
    return Kp.bind(this)(e, n, i, s);
  }
  update(e) {
    const n = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(n, 0, n.length, e);
  }
  getMinMax() {
    const e = this._cachedMeta, n = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    return e.data.forEach((i, s) => {
      const r = this.getParsed(s).r;
      !isNaN(r) && this.chart.getDataVisibility(s) && (r < n.min && (n.min = r), r > n.max && (n.max = r));
    }), n;
  }
  _updateRadius() {
    const e = this.chart, n = e.chartArea, i = e.options, s = Math.min(n.right - n.left, n.bottom - n.top), r = Math.max(s / 2, 0), a = Math.max(i.cutoutPercentage ? r / 100 * i.cutoutPercentage : 1, 0), o = (r - a) / e.getVisibleDatasetCount();
    this.outerRadius = r - o * this.index, this.innerRadius = this.outerRadius - o;
  }
  updateElements(e, n, i, s) {
    const r = s === "reset", a = this.chart, l = a.options.animation, u = this._cachedMeta.rScale, c = u.xCenter, d = u.yCenter, f = u.getIndexAngle(0) - 0.5 * Ne;
    let h = f, m;
    const p = 360 / this.countVisibleElements();
    for (m = 0; m < n; ++m)
      h += this._computeAngle(m, s, p);
    for (m = n; m < n + i; m++) {
      const g = e[m];
      let y = h, v = h + this._computeAngle(m, s, p), b = a.getDataVisibility(m) ? u.getDistanceFromCenterForValue(this.getParsed(m).r) : 0;
      h = v, r && (l.animateScale && (b = 0), l.animateRotate && (y = v = f));
      const _ = {
        x: c,
        y: d,
        innerRadius: 0,
        outerRadius: b,
        startAngle: y,
        endAngle: v,
        options: this.resolveDataElementOptions(m, g.active ? "active" : s)
      };
      this.updateElement(g, m, _, s);
    }
  }
  countVisibleElements() {
    const e = this._cachedMeta;
    let n = 0;
    return e.data.forEach((i, s) => {
      !isNaN(this.getParsed(s).r) && this.chart.getDataVisibility(s) && n++;
    }), n;
  }
  _computeAngle(e, n, i) {
    return this.chart.getDataVisibility(e) ? St(this.resolveDataElementOptions(e, n).angle || i) : 0;
  }
}
X(Rr, "id", "polarArea"), X(Rr, "defaults", {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "startAngle",
        "endAngle",
        "innerRadius",
        "outerRadius"
      ]
    }
  },
  indexAxis: "r",
  startAngle: 0
}), X(Rr, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const n = e.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: i, color: s } } = e.legend.options;
            return n.labels.map((r, a) => {
              const l = e.getDatasetMeta(0).controller.getStyle(a);
              return {
                text: r,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: s,
                lineWidth: l.borderWidth,
                pointStyle: i,
                hidden: !e.getDataVisibility(a),
                index: a
              };
            });
          }
          return [];
        }
      },
      onClick(e, n, i) {
        i.chart.toggleDataVisibility(n.index), i.chart.update();
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
});
class Au extends yi {
}
X(Au, "id", "pie"), X(Au, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
});
class ja extends _n {
  getLabelAndValue(e) {
    const n = this._cachedMeta.vScale, i = this.getParsed(e);
    return {
      label: n.getLabels()[e],
      value: "" + n.getLabelForValue(i[n.axis])
    };
  }
  parseObjectData(e, n, i, s) {
    return Kp.bind(this)(e, n, i, s);
  }
  update(e) {
    const n = this._cachedMeta, i = n.dataset, s = n.data || [], r = n.iScale.getLabels();
    if (i.points = s, e !== "resize") {
      const a = this.resolveDatasetElementOptions(e);
      this.options.showLine || (a.borderWidth = 0);
      const o = {
        _loop: !0,
        _fullLoop: r.length === s.length,
        options: a
      };
      this.updateElement(i, void 0, o, e);
    }
    this.updateElements(s, 0, s.length, e);
  }
  updateElements(e, n, i, s) {
    const r = this._cachedMeta.rScale, a = s === "reset";
    for (let o = n; o < n + i; o++) {
      const l = e[o], u = this.resolveDataElementOptions(o, l.active ? "active" : s), c = r.getPointPositionForValue(o, this.getParsed(o).r), d = a ? r.xCenter : c.x, f = a ? r.yCenter : c.y, h = {
        x: d,
        y: f,
        angle: c.angle,
        skip: isNaN(d) || isNaN(f),
        options: u
      };
      this.updateElement(l, o, h, s);
    }
  }
}
X(ja, "id", "radar"), X(ja, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
}), X(ja, "overrides", {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
});
class qa extends _n {
  getLabelAndValue(e) {
    const n = this._cachedMeta, i = this.chart.data.labels || [], { xScale: s, yScale: r } = n, a = this.getParsed(e), o = s.getLabelForValue(a.x), l = r.getLabelForValue(a.y);
    return {
      label: i[e] || "",
      value: "(" + o + ", " + l + ")"
    };
  }
  update(e) {
    const n = this._cachedMeta, { data: i = [] } = n, s = this.chart._animationsDisabled;
    let { start: r, count: a } = Wp(n, i, s);
    if (this._drawStart = r, this._drawCount = a, Hp(n) && (r = 0, a = i.length), this.options.showLine) {
      this.datasetElementType || this.addElements();
      const { dataset: o, _dataset: l } = n;
      o._chart = this.chart, o._datasetIndex = this.index, o._decimated = !!l._decimated, o.points = i;
      const u = this.resolveDatasetElementOptions(e);
      u.segment = this.options.segment, this.updateElement(o, void 0, {
        animated: !s,
        options: u
      }, e);
    } else this.datasetElementType && (delete n.dataset, this.datasetElementType = !1);
    this.updateElements(i, r, a, e);
  }
  addElements() {
    const { showLine: e } = this.options;
    !this.datasetElementType && e && (this.datasetElementType = this.chart.registry.getElement("line")), super.addElements();
  }
  updateElements(e, n, i, s) {
    const r = s === "reset", { iScale: a, vScale: o, _stacked: l, _dataset: u } = this._cachedMeta, c = this.resolveDataElementOptions(n, s), d = this.getSharedOptions(c), f = this.includeOptions(s, d), h = a.axis, m = o.axis, { spanGaps: p, segment: g } = this.options, y = Ai(p) ? p : Number.POSITIVE_INFINITY, v = this.chart._animationsDisabled || r || s === "none";
    let b = n > 0 && this.getParsed(n - 1);
    for (let _ = n; _ < n + i; ++_) {
      const M = e[_], A = this.getParsed(_), E = v ? M : {}, I = Ie(A[m]), S = E[h] = a.getPixelForValue(A[h], _), $ = E[m] = r || I ? o.getBasePixel() : o.getPixelForValue(l ? this.applyStack(o, A, l) : A[m], _);
      E.skip = isNaN(S) || isNaN($) || I, E.stop = _ > 0 && Math.abs(A[h] - b[h]) > y, g && (E.parsed = A, E.raw = u.data[_]), f && (E.options = d || this.resolveDataElementOptions(_, M.active ? "active" : s)), v || this.updateElement(M, _, E, s), b = A;
    }
    this.updateSharedOptions(d, s, c);
  }
  getMaxOverflow() {
    const e = this._cachedMeta, n = e.data || [];
    if (!this.options.showLine) {
      let o = 0;
      for (let l = n.length - 1; l >= 0; --l)
        o = Math.max(o, n[l].size(this.resolveDataElementOptions(l)) / 2);
      return o > 0 && o;
    }
    const i = e.dataset, s = i.options && i.options.borderWidth || 0;
    if (!n.length)
      return s;
    const r = n[0].size(this.resolveDataElementOptions(0)), a = n[n.length - 1].size(this.resolveDataElementOptions(n.length - 1));
    return Math.max(s, r, a) / 2;
  }
}
X(qa, "id", "scatter"), X(qa, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
}), X(qa, "overrides", {
  interaction: {
    mode: "point"
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
var H1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController: Wa,
  BubbleController: Ha,
  DoughnutController: yi,
  LineController: Ya,
  PieController: Au,
  PolarAreaController: Rr,
  RadarController: ja,
  ScatterController: qa
});
function Bi() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class jc {
  constructor(e) {
    X(this, "options");
    this.options = e || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(e) {
    Object.assign(jc.prototype, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return Bi();
  }
  parse() {
    return Bi();
  }
  format() {
    return Bi();
  }
  add() {
    return Bi();
  }
  diff() {
    return Bi();
  }
  startOf() {
    return Bi();
  }
  endOf() {
    return Bi();
  }
}
var og = {
  _date: jc
};
function Y1(t, e, n, i) {
  const { controller: s, data: r, _sorted: a } = t, o = s._cachedMeta.iScale, l = t.dataset && t.dataset.options ? t.dataset.options.spanGaps : null;
  if (o && e === o.axis && e !== "r" && a && r.length) {
    const u = o._reversePixels ? hw : Kn;
    if (i) {
      if (s._sharedOptions) {
        const c = r[0], d = typeof c.getRange == "function" && c.getRange(e);
        if (d) {
          const f = u(r, e, n - d), h = u(r, e, n + d);
          return {
            lo: f.lo,
            hi: h.hi
          };
        }
      }
    } else {
      const c = u(r, e, n);
      if (l) {
        const { vScale: d } = s._cachedMeta, { _parsed: f } = t, h = f.slice(0, c.lo + 1).reverse().findIndex((p) => !Ie(p[d.axis]));
        c.lo -= Math.max(0, h);
        const m = f.slice(c.hi).findIndex((p) => !Ie(p[d.axis]));
        c.hi += Math.max(0, m);
      }
      return c;
    }
  }
  return {
    lo: 0,
    hi: r.length - 1
  };
}
function sa(t, e, n, i, s) {
  const r = t.getSortedVisibleDatasetMetas(), a = n[e];
  for (let o = 0, l = r.length; o < l; ++o) {
    const { index: u, data: c } = r[o], { lo: d, hi: f } = Y1(r[o], e, a, s);
    for (let h = d; h <= f; ++h) {
      const m = c[h];
      m.skip || i(m, u, h);
    }
  }
}
function j1(t) {
  const e = t.indexOf("x") !== -1, n = t.indexOf("y") !== -1;
  return function(i, s) {
    const r = e ? Math.abs(i.x - s.x) : 0, a = n ? Math.abs(i.y - s.y) : 0;
    return Math.sqrt(Math.pow(r, 2) + Math.pow(a, 2));
  };
}
function al(t, e, n, i, s) {
  const r = [];
  return !s && !t.isPointInArea(e) || sa(t, n, e, function(o, l, u) {
    !s && !Qn(o, t.chartArea, 0) || o.inRange(e.x, e.y, i) && r.push({
      element: o,
      datasetIndex: l,
      index: u
    });
  }, !0), r;
}
function q1(t, e, n, i) {
  let s = [];
  function r(a, o, l) {
    const { startAngle: u, endAngle: c } = a.getProps([
      "startAngle",
      "endAngle"
    ], i), { angle: d } = ao(a, {
      x: e.x,
      y: e.y
    });
    Yr(d, u, c) && s.push({
      element: a,
      datasetIndex: o,
      index: l
    });
  }
  return sa(t, n, e, r), s;
}
function U1(t, e, n, i, s, r) {
  let a = [];
  const o = j1(n);
  let l = Number.POSITIVE_INFINITY;
  function u(c, d, f) {
    const h = c.inRange(e.x, e.y, s);
    if (i && !h)
      return;
    const m = c.getCenterPoint(s);
    if (!(!!r || t.isPointInArea(m)) && !h)
      return;
    const g = o(e, m);
    g < l ? (a = [
      {
        element: c,
        datasetIndex: d,
        index: f
      }
    ], l = g) : g === l && a.push({
      element: c,
      datasetIndex: d,
      index: f
    });
  }
  return sa(t, n, e, u), a;
}
function ol(t, e, n, i, s, r) {
  return !r && !t.isPointInArea(e) ? [] : n === "r" && !i ? q1(t, e, n, s) : U1(t, e, n, i, s, r);
}
function gf(t, e, n, i, s) {
  const r = [], a = n === "x" ? "inXRange" : "inYRange";
  let o = !1;
  return sa(t, n, e, (l, u, c) => {
    l[a] && l[a](e[n], s) && (r.push({
      element: l,
      datasetIndex: u,
      index: c
    }), o = o || l.inRange(e.x, e.y, s));
  }), i && !o ? [] : r;
}
var Eu = {
  evaluateInteractionItems: sa,
  modes: {
    index(t, e, n, i) {
      const s = di(e, t), r = n.axis || "x", a = n.includeInvisible || !1, o = n.intersect ? al(t, s, r, i, a) : ol(t, s, r, !1, i, a), l = [];
      return o.length ? (t.getSortedVisibleDatasetMetas().forEach((u) => {
        const c = o[0].index, d = u.data[c];
        d && !d.skip && l.push({
          element: d,
          datasetIndex: u.index,
          index: c
        });
      }), l) : [];
    },
    dataset(t, e, n, i) {
      const s = di(e, t), r = n.axis || "xy", a = n.includeInvisible || !1;
      let o = n.intersect ? al(t, s, r, i, a) : ol(t, s, r, !1, i, a);
      if (o.length > 0) {
        const l = o[0].datasetIndex, u = t.getDatasetMeta(l).data;
        o = [];
        for (let c = 0; c < u.length; ++c)
          o.push({
            element: u[c],
            datasetIndex: l,
            index: c
          });
      }
      return o;
    },
    point(t, e, n, i) {
      const s = di(e, t), r = n.axis || "xy", a = n.includeInvisible || !1;
      return al(t, s, r, i, a);
    },
    nearest(t, e, n, i) {
      const s = di(e, t), r = n.axis || "xy", a = n.includeInvisible || !1;
      return ol(t, s, r, n.intersect, i, a);
    },
    x(t, e, n, i) {
      const s = di(e, t);
      return gf(t, s, "x", n.intersect, i);
    },
    y(t, e, n, i) {
      const s = di(e, t);
      return gf(t, s, "y", n.intersect, i);
    }
  }
};
const lg = [
  "left",
  "top",
  "right",
  "bottom"
];
function fr(t, e) {
  return t.filter((n) => n.pos === e);
}
function yf(t, e) {
  return t.filter((n) => lg.indexOf(n.pos) === -1 && n.box.axis === e);
}
function hr(t, e) {
  return t.sort((n, i) => {
    const s = e ? i : n, r = e ? n : i;
    return s.weight === r.weight ? s.index - r.index : s.weight - r.weight;
  });
}
function X1(t) {
  const e = [];
  let n, i, s, r, a, o;
  for (n = 0, i = (t || []).length; n < i; ++n)
    s = t[n], { position: r, options: { stack: a, stackWeight: o = 1 } } = s, e.push({
      index: n,
      box: s,
      pos: r,
      horizontal: s.isHorizontal(),
      weight: s.weight,
      stack: a && r + a,
      stackWeight: o
    });
  return e;
}
function G1(t) {
  const e = {};
  for (const n of t) {
    const { stack: i, pos: s, stackWeight: r } = n;
    if (!i || !lg.includes(s))
      continue;
    const a = e[i] || (e[i] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    a.count++, a.weight += r;
  }
  return e;
}
function Z1(t, e) {
  const n = G1(t), { vBoxMaxWidth: i, hBoxMaxHeight: s } = e;
  let r, a, o;
  for (r = 0, a = t.length; r < a; ++r) {
    o = t[r];
    const { fullSize: l } = o.box, u = n[o.stack], c = u && o.stackWeight / u.weight;
    o.horizontal ? (o.width = c ? c * i : l && e.availableWidth, o.height = s) : (o.width = i, o.height = c ? c * s : l && e.availableHeight);
  }
  return n;
}
function K1(t) {
  const e = X1(t), n = hr(e.filter((u) => u.box.fullSize), !0), i = hr(fr(e, "left"), !0), s = hr(fr(e, "right")), r = hr(fr(e, "top"), !0), a = hr(fr(e, "bottom")), o = yf(e, "x"), l = yf(e, "y");
  return {
    fullSize: n,
    leftAndTop: i.concat(r),
    rightAndBottom: s.concat(l).concat(a).concat(o),
    chartArea: fr(e, "chartArea"),
    vertical: i.concat(s).concat(l),
    horizontal: r.concat(a).concat(o)
  };
}
function vf(t, e, n, i) {
  return Math.max(t[n], e[n]) + Math.max(t[i], e[i]);
}
function ug(t, e) {
  t.top = Math.max(t.top, e.top), t.left = Math.max(t.left, e.left), t.bottom = Math.max(t.bottom, e.bottom), t.right = Math.max(t.right, e.right);
}
function Q1(t, e, n, i) {
  const { pos: s, box: r } = n, a = t.maxPadding;
  if (!Ae(s)) {
    n.size && (t[s] -= n.size);
    const d = i[n.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, n.horizontal ? r.height : r.width), n.size = d.size / d.count, t[s] += n.size;
  }
  r.getPadding && ug(a, r.getPadding());
  const o = Math.max(0, e.outerWidth - vf(a, t, "left", "right")), l = Math.max(0, e.outerHeight - vf(a, t, "top", "bottom")), u = o !== t.w, c = l !== t.h;
  return t.w = o, t.h = l, n.horizontal ? {
    same: u,
    other: c
  } : {
    same: c,
    other: u
  };
}
function J1(t) {
  const e = t.maxPadding;
  function n(i) {
    const s = Math.max(e[i] - t[i], 0);
    return t[i] += s, s;
  }
  t.y += n("top"), t.x += n("left"), n("right"), n("bottom");
}
function ex(t, e) {
  const n = e.maxPadding;
  function i(s) {
    const r = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return s.forEach((a) => {
      r[a] = Math.max(e[a], n[a]);
    }), r;
  }
  return i(t ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function _r(t, e, n, i) {
  const s = [];
  let r, a, o, l, u, c;
  for (r = 0, a = t.length, u = 0; r < a; ++r) {
    o = t[r], l = o.box, l.update(o.width || e.w, o.height || e.h, ex(o.horizontal, e));
    const { same: d, other: f } = Q1(e, n, o, i);
    u |= d && s.length, c = c || f, l.fullSize || s.push(o);
  }
  return u && _r(s, e, n, i) || c;
}
function Sa(t, e, n, i, s) {
  t.top = n, t.left = e, t.right = e + i, t.bottom = n + s, t.width = i, t.height = s;
}
function bf(t, e, n, i) {
  const s = n.padding;
  let { x: r, y: a } = e;
  for (const o of t) {
    const l = o.box, u = i[o.stack] || {
      placed: 0,
      weight: 1
    }, c = o.stackWeight / u.weight || 1;
    if (o.horizontal) {
      const d = e.w * c, f = u.size || l.height;
      en(u.start) && (a = u.start), l.fullSize ? Sa(l, s.left, a, n.outerWidth - s.right - s.left, f) : Sa(l, e.left + u.placed, a, d, f), u.start = a, u.placed += d, a = l.bottom;
    } else {
      const d = e.h * c, f = u.size || l.width;
      en(u.start) && (r = u.start), l.fullSize ? Sa(l, r, s.top, f, n.outerHeight - s.bottom - s.top) : Sa(l, r, e.top + u.placed, f, d), u.start = r, u.placed += d, r = l.right;
    }
  }
  e.x = r, e.y = a;
}
var Wt = {
  addBox(t, e) {
    t.boxes || (t.boxes = []), e.fullSize = e.fullSize || !1, e.position = e.position || "top", e.weight = e.weight || 0, e._layers = e._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            e.draw(n);
          }
        }
      ];
    }, t.boxes.push(e);
  },
  removeBox(t, e) {
    const n = t.boxes ? t.boxes.indexOf(e) : -1;
    n !== -1 && t.boxes.splice(n, 1);
  },
  configure(t, e, n) {
    e.fullSize = n.fullSize, e.position = n.position, e.weight = n.weight;
  },
  update(t, e, n, i) {
    if (!t)
      return;
    const s = Ot(t.options.layout.padding), r = Math.max(e - s.width, 0), a = Math.max(n - s.height, 0), o = K1(t.boxes), l = o.vertical, u = o.horizontal;
    Ke(t.boxes, (p) => {
      typeof p.beforeLayout == "function" && p.beforeLayout();
    });
    const c = l.reduce((p, g) => g.box.options && g.box.options.display === !1 ? p : p + 1, 0) || 1, d = Object.freeze({
      outerWidth: e,
      outerHeight: n,
      padding: s,
      availableWidth: r,
      availableHeight: a,
      vBoxMaxWidth: r / 2 / c,
      hBoxMaxHeight: a / 2
    }), f = Object.assign({}, s);
    ug(f, Ot(i));
    const h = Object.assign({
      maxPadding: f,
      w: r,
      h: a,
      x: s.left,
      y: s.top
    }, s), m = Z1(l.concat(u), d);
    _r(o.fullSize, h, d, m), _r(l, h, d, m), _r(u, h, d, m) && _r(l, h, d, m), J1(h), bf(o.leftAndTop, h, d, m), h.x += h.w, h.y += h.h, bf(o.rightAndBottom, h, d, m), t.chartArea = {
      left: h.left,
      top: h.top,
      right: h.left + h.w,
      bottom: h.top + h.h,
      height: h.h,
      width: h.w
    }, Ke(o.chartArea, (p) => {
      const g = p.box;
      Object.assign(g, t.chartArea), g.update(h.w, h.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class cg {
  acquireContext(e, n) {
  }
  releaseContext(e) {
    return !1;
  }
  addEventListener(e, n, i) {
  }
  removeEventListener(e, n, i) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(e, n, i, s) {
    return n = Math.max(0, n || e.width), i = i || e.height, {
      width: n,
      height: Math.max(0, s ? Math.floor(n / s) : i)
    };
  }
  isAttached(e) {
    return !0;
  }
  updateConfig(e) {
  }
}
class tx extends cg {
  acquireContext(e) {
    return e && e.getContext && e.getContext("2d") || null;
  }
  updateConfig(e) {
    e.options.animation = !1;
  }
}
const Ua = "$chartjs", nx = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, wf = (t) => t === null || t === "";
function ix(t, e) {
  const n = t.style, i = t.getAttribute("height"), s = t.getAttribute("width");
  if (t[Ua] = {
    initial: {
      height: i,
      width: s,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", wf(s)) {
    const r = nf(t, "width");
    r !== void 0 && (t.width = r);
  }
  if (wf(i))
    if (t.style.height === "")
      t.height = t.width / (e || 2);
    else {
      const r = nf(t, "height");
      r !== void 0 && (t.height = r);
    }
  return t;
}
const dg = a1 ? {
  passive: !0
} : !1;
function sx(t, e, n) {
  t && t.addEventListener(e, n, dg);
}
function rx(t, e, n) {
  t && t.canvas && t.canvas.removeEventListener(e, n, dg);
}
function ax(t, e) {
  const n = nx[t.type] || t.type, { x: i, y: s } = di(t, e);
  return {
    type: n,
    chart: e,
    native: t,
    x: i !== void 0 ? i : null,
    y: s !== void 0 ? s : null
  };
}
function uo(t, e) {
  for (const n of t)
    if (n === e || n.contains(e))
      return !0;
}
function ox(t, e, n) {
  const i = t.canvas, s = new MutationObserver((r) => {
    let a = !1;
    for (const o of r)
      a = a || uo(o.addedNodes, i), a = a && !uo(o.removedNodes, i);
    a && n();
  });
  return s.observe(document, {
    childList: !0,
    subtree: !0
  }), s;
}
function lx(t, e, n) {
  const i = t.canvas, s = new MutationObserver((r) => {
    let a = !1;
    for (const o of r)
      a = a || uo(o.removedNodes, i), a = a && !uo(o.addedNodes, i);
    a && n();
  });
  return s.observe(document, {
    childList: !0,
    subtree: !0
  }), s;
}
const jr = /* @__PURE__ */ new Map();
let xf = 0;
function fg() {
  const t = window.devicePixelRatio;
  t !== xf && (xf = t, jr.forEach((e, n) => {
    n.currentDevicePixelRatio !== t && e();
  }));
}
function ux(t, e) {
  jr.size || window.addEventListener("resize", fg), jr.set(t, e);
}
function cx(t) {
  jr.delete(t), jr.size || window.removeEventListener("resize", fg);
}
function dx(t, e, n) {
  const i = t.canvas, s = i && Hc(i);
  if (!s)
    return;
  const r = zp((o, l) => {
    const u = s.clientWidth;
    n(o, l), u < s.clientWidth && n();
  }, window), a = new ResizeObserver((o) => {
    const l = o[0], u = l.contentRect.width, c = l.contentRect.height;
    u === 0 && c === 0 || r(u, c);
  });
  return a.observe(s), ux(t, r), a;
}
function ll(t, e, n) {
  n && n.disconnect(), e === "resize" && cx(t);
}
function fx(t, e, n) {
  const i = t.canvas, s = zp((r) => {
    t.ctx !== null && n(ax(r, t));
  }, t);
  return sx(i, e, s), s;
}
class hx extends cg {
  acquireContext(e, n) {
    const i = e && e.getContext && e.getContext("2d");
    return i && i.canvas === e ? (ix(e, n), i) : null;
  }
  releaseContext(e) {
    const n = e.canvas;
    if (!n[Ua])
      return !1;
    const i = n[Ua].initial;
    [
      "height",
      "width"
    ].forEach((r) => {
      const a = i[r];
      Ie(a) ? n.removeAttribute(r) : n.setAttribute(r, a);
    });
    const s = i.style || {};
    return Object.keys(s).forEach((r) => {
      n.style[r] = s[r];
    }), n.width = n.width, delete n[Ua], !0;
  }
  addEventListener(e, n, i) {
    this.removeEventListener(e, n);
    const s = e.$proxies || (e.$proxies = {}), a = {
      attach: ox,
      detach: lx,
      resize: dx
    }[n] || fx;
    s[n] = a(e, n, i);
  }
  removeEventListener(e, n) {
    const i = e.$proxies || (e.$proxies = {}), s = i[n];
    if (!s)
      return;
    ({
      attach: ll,
      detach: ll,
      resize: ll
    }[n] || rx)(e, n, s), i[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(e, n, i, s) {
    return r1(e, n, i, s);
  }
  isAttached(e) {
    const n = e && Hc(e);
    return !!(n && n.isConnected);
  }
}
function mx(t) {
  return !Wc() || typeof OffscreenCanvas < "u" && t instanceof OffscreenCanvas ? tx : hx;
}
var za;
let Ht = (za = class {
  constructor() {
    X(this, "x");
    X(this, "y");
    X(this, "active", !1);
    X(this, "options");
    X(this, "$animations");
  }
  tooltipPosition(e) {
    const { x: n, y: i } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: n,
      y: i
    };
  }
  hasValue() {
    return Ai(this.x) && Ai(this.y);
  }
  getProps(e, n) {
    const i = this.$animations;
    if (!n || !i)
      return this;
    const s = {};
    return e.forEach((r) => {
      s[r] = i[r] && i[r].active() ? i[r]._to : this[r];
    }), s;
  }
}, X(za, "defaults", {}), X(za, "defaultRoutes"), za);
function px(t, e) {
  const n = t.options.ticks, i = gx(t), s = Math.min(n.maxTicksLimit || i, i), r = n.major.enabled ? vx(e) : [], a = r.length, o = r[0], l = r[a - 1], u = [];
  if (a > s)
    return bx(e, u, r, a / s), u;
  const c = yx(r, e, s);
  if (a > 0) {
    let d, f;
    const h = a > 1 ? Math.round((l - o) / (a - 1)) : null;
    for (Oa(e, u, c, Ie(h) ? 0 : o - h, o), d = 0, f = a - 1; d < f; d++)
      Oa(e, u, c, r[d], r[d + 1]);
    return Oa(e, u, c, l, Ie(h) ? e.length : l + h), u;
  }
  return Oa(e, u, c), u;
}
function gx(t) {
  const e = t.options.offset, n = t._tickSize(), i = t._length / n + (e ? 0 : 1), s = t._maxLength / n;
  return Math.floor(Math.min(i, s));
}
function yx(t, e, n) {
  const i = wx(t), s = e.length / n;
  if (!i)
    return Math.max(s, 1);
  const r = lw(i);
  for (let a = 0, o = r.length - 1; a < o; a++) {
    const l = r[a];
    if (l > s)
      return l;
  }
  return Math.max(s, 1);
}
function vx(t) {
  const e = [];
  let n, i;
  for (n = 0, i = t.length; n < i; n++)
    t[n].major && e.push(n);
  return e;
}
function bx(t, e, n, i) {
  let s = 0, r = n[0], a;
  for (i = Math.ceil(i), a = 0; a < t.length; a++)
    a === r && (e.push(t[a]), s++, r = n[s * i]);
}
function Oa(t, e, n, i, s) {
  const r = De(i, 0), a = Math.min(De(s, t.length), t.length);
  let o = 0, l, u, c;
  for (n = Math.ceil(n), s && (l = s - i, n = l / Math.floor(l / n)), c = r; c < 0; )
    o++, c = Math.round(r + o * n);
  for (u = Math.max(r, 0); u < a; u++)
    u === c && (e.push(t[u]), o++, c = Math.round(r + o * n));
}
function wx(t) {
  const e = t.length;
  let n, i;
  if (e < 2)
    return !1;
  for (i = t[0], n = 1; n < e; ++n)
    if (t[n] - t[n - 1] !== i)
      return !1;
  return i;
}
const xx = (t) => t === "left" ? "right" : t === "right" ? "left" : t, _f = (t, e, n) => e === "top" || e === "left" ? t[e] + n : t[e] - n, kf = (t, e) => Math.min(e || t, t);
function Mf(t, e) {
  const n = [], i = t.length / e, s = t.length;
  let r = 0;
  for (; r < s; r += i)
    n.push(t[Math.floor(r)]);
  return n;
}
function _x(t, e, n) {
  const i = t.ticks.length, s = Math.min(e, i - 1), r = t._startPixel, a = t._endPixel, o = 1e-6;
  let l = t.getPixelForTick(s), u;
  if (!(n && (i === 1 ? u = Math.max(l - r, a - l) : e === 0 ? u = (t.getPixelForTick(1) - l) / 2 : u = (l - t.getPixelForTick(s - 1)) / 2, l += s < e ? u : -u, l < r - o || l > a + o)))
    return l;
}
function kx(t, e) {
  Ke(t, (n) => {
    const i = n.gc, s = i.length / 2;
    let r;
    if (s > e) {
      for (r = 0; r < s; ++r)
        delete n.data[i[r]];
      i.splice(0, s);
    }
  });
}
function mr(t) {
  return t.drawTicks ? t.tickLength : 0;
}
function Sf(t, e) {
  if (!t.display)
    return 0;
  const n = mt(t.font, e), i = Ot(t.padding);
  return (Ue(t.text) ? t.text.length : 1) * n.lineHeight + i.height;
}
function Mx(t, e) {
  return Li(t, {
    scale: e,
    type: "scale"
  });
}
function Sx(t, e, n) {
  return Li(t, {
    tick: n,
    index: e,
    type: "tick"
  });
}
function Ox(t, e, n) {
  let i = Ic(t);
  return (n && e !== "right" || !n && e === "right") && (i = xx(i)), i;
}
function Dx(t, e, n, i) {
  const { top: s, left: r, bottom: a, right: o, chart: l } = t, { chartArea: u, scales: c } = l;
  let d = 0, f, h, m;
  const p = a - s, g = o - r;
  if (t.isHorizontal()) {
    if (h = Vt(i, r, o), Ae(n)) {
      const y = Object.keys(n)[0], v = n[y];
      m = c[y].getPixelForValue(v) + p - e;
    } else n === "center" ? m = (u.bottom + u.top) / 2 + p - e : m = _f(t, n, e);
    f = o - r;
  } else {
    if (Ae(n)) {
      const y = Object.keys(n)[0], v = n[y];
      h = c[y].getPixelForValue(v) - g + e;
    } else n === "center" ? h = (u.left + u.right) / 2 - g + e : h = _f(t, n, e);
    m = Vt(i, a, s), d = n === "left" ? -rt : rt;
  }
  return {
    titleX: h,
    titleY: m,
    maxWidth: f,
    rotation: d
  };
}
class ds extends Ht {
  constructor(e) {
    super(), this.id = e.id, this.type = e.type, this.options = void 0, this.ctx = e.ctx, this.chart = e.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(e) {
    this.options = e.setContext(this.getContext()), this.axis = e.axis, this._userMin = this.parse(e.min), this._userMax = this.parse(e.max), this._suggestedMin = this.parse(e.suggestedMin), this._suggestedMax = this.parse(e.suggestedMax);
  }
  parse(e, n) {
    return e;
  }
  getUserBounds() {
    let { _userMin: e, _userMax: n, _suggestedMin: i, _suggestedMax: s } = this;
    return e = tn(e, Number.POSITIVE_INFINITY), n = tn(n, Number.NEGATIVE_INFINITY), i = tn(i, Number.POSITIVE_INFINITY), s = tn(s, Number.NEGATIVE_INFINITY), {
      min: tn(e, i),
      max: tn(n, s),
      minDefined: ot(e),
      maxDefined: ot(n)
    };
  }
  getMinMax(e) {
    let { min: n, max: i, minDefined: s, maxDefined: r } = this.getUserBounds(), a;
    if (s && r)
      return {
        min: n,
        max: i
      };
    const o = this.getMatchingVisibleMetas();
    for (let l = 0, u = o.length; l < u; ++l)
      a = o[l].controller.getMinMax(this, e), s || (n = Math.min(n, a.min)), r || (i = Math.max(i, a.max));
    return n = r && n > i ? i : n, i = s && n > i ? n : i, {
      min: tn(n, tn(i, n)),
      max: tn(i, tn(n, i))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const e = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? e.xLabels : e.yLabels) || e.labels || [];
  }
  getLabelItems(e = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(e));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    Ze(this.options.beforeUpdate, [
      this
    ]);
  }
  update(e, n, i) {
    const { beginAtZero: s, grace: r, ticks: a } = this.options, o = a.sampleSize;
    this.beforeUpdate(), this.maxWidth = e, this.maxHeight = n, this._margins = i = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, i), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + i.left + i.right : this.height + i.top + i.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = Fw(this, r, s), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = o < this.ticks.length;
    this._convertTicksToLabels(l ? Mf(this.ticks, o) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), a.display && (a.autoSkip || a.source === "auto") && (this.ticks = px(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let e = this.options.reverse, n, i;
    this.isHorizontal() ? (n = this.left, i = this.right) : (n = this.top, i = this.bottom, e = !e), this._startPixel = n, this._endPixel = i, this._reversePixels = e, this._length = i - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    Ze(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    Ze(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    Ze(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(e) {
    this.chart.notifyPlugins(e, this.getContext()), Ze(this.options[e], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    Ze(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(e) {
    const n = this.options.ticks;
    let i, s, r;
    for (i = 0, s = e.length; i < s; i++)
      r = e[i], r.label = Ze(n.callback, [
        r.value,
        i,
        e
      ], this);
  }
  afterTickToLabelConversion() {
    Ze(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    Ze(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const e = this.options, n = e.ticks, i = kf(this.ticks.length, e.ticks.maxTicksLimit), s = n.minRotation || 0, r = n.maxRotation;
    let a = s, o, l, u;
    if (!this._isVisible() || !n.display || s >= r || i <= 1 || !this.isHorizontal()) {
      this.labelRotation = s;
      return;
    }
    const c = this._getLabelSizes(), d = c.widest.width, f = c.highest.height, h = Et(this.chart.width - d, 0, this.maxWidth);
    o = e.offset ? this.maxWidth / i : h / (i - 1), d + 6 > o && (o = h / (i - (e.offset ? 0.5 : 1)), l = this.maxHeight - mr(e.grid) - n.padding - Sf(e.title, this.chart.options.font), u = Math.sqrt(d * d + f * f), a = So(Math.min(Math.asin(Et((c.highest.height + 6) / o, -1, 1)), Math.asin(Et(l / u, -1, 1)) - Math.asin(Et(f / u, -1, 1)))), a = Math.max(s, Math.min(r, a))), this.labelRotation = a;
  }
  afterCalculateLabelRotation() {
    Ze(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    Ze(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const e = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: i, title: s, grid: r } } = this, a = this._isVisible(), o = this.isHorizontal();
    if (a) {
      const l = Sf(s, n.options.font);
      if (o ? (e.width = this.maxWidth, e.height = mr(r) + l) : (e.height = this.maxHeight, e.width = mr(r) + l), i.display && this.ticks.length) {
        const { first: u, last: c, widest: d, highest: f } = this._getLabelSizes(), h = i.padding * 2, m = St(this.labelRotation), p = Math.cos(m), g = Math.sin(m);
        if (o) {
          const y = i.mirror ? 0 : g * d.width + p * f.height;
          e.height = Math.min(this.maxHeight, e.height + y + h);
        } else {
          const y = i.mirror ? 0 : p * d.width + g * f.height;
          e.width = Math.min(this.maxWidth, e.width + y + h);
        }
        this._calculatePadding(u, c, g, p);
      }
    }
    this._handleMargins(), o ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = e.height) : (this.width = e.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(e, n, i, s) {
    const { ticks: { align: r, padding: a }, position: o } = this.options, l = this.labelRotation !== 0, u = o !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const c = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let f = 0, h = 0;
      l ? u ? (f = s * e.width, h = i * n.height) : (f = i * e.height, h = s * n.width) : r === "start" ? h = n.width : r === "end" ? f = e.width : r !== "inner" && (f = e.width / 2, h = n.width / 2), this.paddingLeft = Math.max((f - c + a) * this.width / (this.width - c), 0), this.paddingRight = Math.max((h - d + a) * this.width / (this.width - d), 0);
    } else {
      let c = n.height / 2, d = e.height / 2;
      r === "start" ? (c = 0, d = e.height) : r === "end" && (c = n.height, d = 0), this.paddingTop = c + a, this.paddingBottom = d + a;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    Ze(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: e, position: n } = this.options;
    return n === "top" || n === "bottom" || e === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(e) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(e);
    let n, i;
    for (n = 0, i = e.length; n < i; n++)
      Ie(e[n].label) && (e.splice(n, 1), i--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let e = this._labelSizes;
    if (!e) {
      const n = this.options.ticks.sampleSize;
      let i = this.ticks;
      n < i.length && (i = Mf(i, n)), this._labelSizes = e = this._computeLabelSizes(i, i.length, this.options.ticks.maxTicksLimit);
    }
    return e;
  }
  _computeLabelSizes(e, n, i) {
    const { ctx: s, _longestTextCache: r } = this, a = [], o = [], l = Math.floor(n / kf(n, i));
    let u = 0, c = 0, d, f, h, m, p, g, y, v, b, _, M;
    for (d = 0; d < n; d += l) {
      if (m = e[d].label, p = this._resolveTickFontOptions(d), s.font = g = p.string, y = r[g] = r[g] || {
        data: {},
        gc: []
      }, v = p.lineHeight, b = _ = 0, !Ie(m) && !Ue(m))
        b = oo(s, y.data, y.gc, b, m), _ = v;
      else if (Ue(m))
        for (f = 0, h = m.length; f < h; ++f)
          M = m[f], !Ie(M) && !Ue(M) && (b = oo(s, y.data, y.gc, b, M), _ += v);
      a.push(b), o.push(_), u = Math.max(b, u), c = Math.max(_, c);
    }
    kx(r, n);
    const A = a.indexOf(u), E = o.indexOf(c), I = (S) => ({
      width: a[S] || 0,
      height: o[S] || 0
    });
    return {
      first: I(0),
      last: I(n - 1),
      widest: I(A),
      highest: I(E),
      widths: a,
      heights: o
    };
  }
  getLabelForValue(e) {
    return e;
  }
  getPixelForValue(e, n) {
    return NaN;
  }
  getValueForPixel(e) {
  }
  getPixelForTick(e) {
    const n = this.ticks;
    return e < 0 || e > n.length - 1 ? null : this.getPixelForValue(n[e].value);
  }
  getPixelForDecimal(e) {
    this._reversePixels && (e = 1 - e);
    const n = this._startPixel + e * this._length;
    return fw(this._alignToPixels ? Ni(this.chart, n, 0) : n);
  }
  getDecimalForPixel(e) {
    const n = (e - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: e, max: n } = this;
    return e < 0 && n < 0 ? n : e > 0 && n > 0 ? e : 0;
  }
  getContext(e) {
    const n = this.ticks || [];
    if (e >= 0 && e < n.length) {
      const i = n[e];
      return i.$context || (i.$context = Sx(this.getContext(), e, i));
    }
    return this.$context || (this.$context = Mx(this.chart.getContext(), this));
  }
  _tickSize() {
    const e = this.options.ticks, n = St(this.labelRotation), i = Math.abs(Math.cos(n)), s = Math.abs(Math.sin(n)), r = this._getLabelSizes(), a = e.autoSkipPadding || 0, o = r ? r.widest.width + a : 0, l = r ? r.highest.height + a : 0;
    return this.isHorizontal() ? l * i > o * s ? o / i : l / s : l * s < o * i ? l / i : o / s;
  }
  _isVisible() {
    const e = this.options.display;
    return e !== "auto" ? !!e : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(e) {
    const n = this.axis, i = this.chart, s = this.options, { grid: r, position: a, border: o } = s, l = r.offset, u = this.isHorizontal(), d = this.ticks.length + (l ? 1 : 0), f = mr(r), h = [], m = o.setContext(this.getContext()), p = m.display ? m.width : 0, g = p / 2, y = function(k) {
      return Ni(i, k, p);
    };
    let v, b, _, M, A, E, I, S, $, B, V, G;
    if (a === "top")
      v = y(this.bottom), E = this.bottom - f, S = v - g, B = y(e.top) + g, G = e.bottom;
    else if (a === "bottom")
      v = y(this.top), B = e.top, G = y(e.bottom) - g, E = v + g, S = this.top + f;
    else if (a === "left")
      v = y(this.right), A = this.right - f, I = v - g, $ = y(e.left) + g, V = e.right;
    else if (a === "right")
      v = y(this.left), $ = e.left, V = y(e.right) - g, A = v + g, I = this.left + f;
    else if (n === "x") {
      if (a === "center")
        v = y((e.top + e.bottom) / 2 + 0.5);
      else if (Ae(a)) {
        const k = Object.keys(a)[0], D = a[k];
        v = y(this.chart.scales[k].getPixelForValue(D));
      }
      B = e.top, G = e.bottom, E = v + g, S = E + f;
    } else if (n === "y") {
      if (a === "center")
        v = y((e.left + e.right) / 2);
      else if (Ae(a)) {
        const k = Object.keys(a)[0], D = a[k];
        v = y(this.chart.scales[k].getPixelForValue(D));
      }
      A = v - g, I = A - f, $ = e.left, V = e.right;
    }
    const P = De(s.ticks.maxTicksLimit, d), x = Math.max(1, Math.ceil(d / P));
    for (b = 0; b < d; b += x) {
      const k = this.getContext(b), D = r.setContext(k), N = o.setContext(k), L = D.lineWidth, z = D.color, W = N.dash || [], ae = N.dashOffset, F = D.tickWidth, H = D.tickColor, Q = D.tickBorderDash || [], ne = D.tickBorderDashOffset;
      _ = _x(this, b, l), _ !== void 0 && (M = Ni(i, _, L), u ? A = I = $ = V = M : E = S = B = G = M, h.push({
        tx1: A,
        ty1: E,
        tx2: I,
        ty2: S,
        x1: $,
        y1: B,
        x2: V,
        y2: G,
        width: L,
        color: z,
        borderDash: W,
        borderDashOffset: ae,
        tickWidth: F,
        tickColor: H,
        tickBorderDash: Q,
        tickBorderDashOffset: ne
      }));
    }
    return this._ticksLength = d, this._borderValue = v, h;
  }
  _computeLabelItems(e) {
    const n = this.axis, i = this.options, { position: s, ticks: r } = i, a = this.isHorizontal(), o = this.ticks, { align: l, crossAlign: u, padding: c, mirror: d } = r, f = mr(i.grid), h = f + c, m = d ? -c : h, p = -St(this.labelRotation), g = [];
    let y, v, b, _, M, A, E, I, S, $, B, V, G = "middle";
    if (s === "top")
      A = this.bottom - m, E = this._getXAxisLabelAlignment();
    else if (s === "bottom")
      A = this.top + m, E = this._getXAxisLabelAlignment();
    else if (s === "left") {
      const x = this._getYAxisLabelAlignment(f);
      E = x.textAlign, M = x.x;
    } else if (s === "right") {
      const x = this._getYAxisLabelAlignment(f);
      E = x.textAlign, M = x.x;
    } else if (n === "x") {
      if (s === "center")
        A = (e.top + e.bottom) / 2 + h;
      else if (Ae(s)) {
        const x = Object.keys(s)[0], k = s[x];
        A = this.chart.scales[x].getPixelForValue(k) + h;
      }
      E = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (s === "center")
        M = (e.left + e.right) / 2 - h;
      else if (Ae(s)) {
        const x = Object.keys(s)[0], k = s[x];
        M = this.chart.scales[x].getPixelForValue(k);
      }
      E = this._getYAxisLabelAlignment(f).textAlign;
    }
    n === "y" && (l === "start" ? G = "top" : l === "end" && (G = "bottom"));
    const P = this._getLabelSizes();
    for (y = 0, v = o.length; y < v; ++y) {
      b = o[y], _ = b.label;
      const x = r.setContext(this.getContext(y));
      I = this.getPixelForTick(y) + r.labelOffset, S = this._resolveTickFontOptions(y), $ = S.lineHeight, B = Ue(_) ? _.length : 1;
      const k = B / 2, D = x.color, N = x.textStrokeColor, L = x.textStrokeWidth;
      let z = E;
      a ? (M = I, E === "inner" && (y === v - 1 ? z = this.options.reverse ? "left" : "right" : y === 0 ? z = this.options.reverse ? "right" : "left" : z = "center"), s === "top" ? u === "near" || p !== 0 ? V = -B * $ + $ / 2 : u === "center" ? V = -P.highest.height / 2 - k * $ + $ : V = -P.highest.height + $ / 2 : u === "near" || p !== 0 ? V = $ / 2 : u === "center" ? V = P.highest.height / 2 - k * $ : V = P.highest.height - B * $, d && (V *= -1), p !== 0 && !x.showLabelBackdrop && (M += $ / 2 * Math.sin(p))) : (A = I, V = (1 - B) * $ / 2);
      let W;
      if (x.showLabelBackdrop) {
        const ae = Ot(x.backdropPadding), F = P.heights[y], H = P.widths[y];
        let Q = V - ae.top, ne = 0 - ae.left;
        switch (G) {
          case "middle":
            Q -= F / 2;
            break;
          case "bottom":
            Q -= F;
            break;
        }
        switch (E) {
          case "center":
            ne -= H / 2;
            break;
          case "right":
            ne -= H;
            break;
          case "inner":
            y === v - 1 ? ne -= H : y > 0 && (ne -= H / 2);
            break;
        }
        W = {
          left: ne,
          top: Q,
          width: H + ae.width,
          height: F + ae.height,
          color: x.backdropColor
        };
      }
      g.push({
        label: _,
        font: S,
        textOffset: V,
        options: {
          rotation: p,
          color: D,
          strokeColor: N,
          strokeWidth: L,
          textAlign: z,
          textBaseline: G,
          translation: [
            M,
            A
          ],
          backdrop: W
        }
      });
    }
    return g;
  }
  _getXAxisLabelAlignment() {
    const { position: e, ticks: n } = this.options;
    if (-St(this.labelRotation))
      return e === "top" ? "left" : "right";
    let s = "center";
    return n.align === "start" ? s = "left" : n.align === "end" ? s = "right" : n.align === "inner" && (s = "inner"), s;
  }
  _getYAxisLabelAlignment(e) {
    const { position: n, ticks: { crossAlign: i, mirror: s, padding: r } } = this.options, a = this._getLabelSizes(), o = e + r, l = a.widest.width;
    let u, c;
    return n === "left" ? s ? (c = this.right + r, i === "near" ? u = "left" : i === "center" ? (u = "center", c += l / 2) : (u = "right", c += l)) : (c = this.right - o, i === "near" ? u = "right" : i === "center" ? (u = "center", c -= l / 2) : (u = "left", c = this.left)) : n === "right" ? s ? (c = this.left + r, i === "near" ? u = "right" : i === "center" ? (u = "center", c -= l / 2) : (u = "left", c -= l)) : (c = this.left + o, i === "near" ? u = "left" : i === "center" ? (u = "center", c += l / 2) : (u = "right", c = this.right)) : u = "right", {
      textAlign: u,
      x: c
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const e = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: e.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: e.width
      };
  }
  drawBackground() {
    const { ctx: e, options: { backgroundColor: n }, left: i, top: s, width: r, height: a } = this;
    n && (e.save(), e.fillStyle = n, e.fillRect(i, s, r, a), e.restore());
  }
  getLineWidthForValue(e) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const s = this.ticks.findIndex((r) => r.value === e);
    return s >= 0 ? n.setContext(this.getContext(s)).lineWidth : 0;
  }
  drawGrid(e) {
    const n = this.options.grid, i = this.ctx, s = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(e));
    let r, a;
    const o = (l, u, c) => {
      !c.width || !c.color || (i.save(), i.lineWidth = c.width, i.strokeStyle = c.color, i.setLineDash(c.borderDash || []), i.lineDashOffset = c.borderDashOffset, i.beginPath(), i.moveTo(l.x, l.y), i.lineTo(u.x, u.y), i.stroke(), i.restore());
    };
    if (n.display)
      for (r = 0, a = s.length; r < a; ++r) {
        const l = s[r];
        n.drawOnChartArea && o({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), n.drawTicks && o({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: e, ctx: n, options: { border: i, grid: s } } = this, r = i.setContext(this.getContext()), a = i.display ? r.width : 0;
    if (!a)
      return;
    const o = s.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let u, c, d, f;
    this.isHorizontal() ? (u = Ni(e, this.left, a) - a / 2, c = Ni(e, this.right, o) + o / 2, d = f = l) : (d = Ni(e, this.top, a) - a / 2, f = Ni(e, this.bottom, o) + o / 2, u = c = l), n.save(), n.lineWidth = r.width, n.strokeStyle = r.color, n.beginPath(), n.moveTo(u, d), n.lineTo(c, f), n.stroke(), n.restore();
  }
  drawLabels(e) {
    if (!this.options.ticks.display)
      return;
    const i = this.ctx, s = this._computeLabelArea();
    s && na(i, s);
    const r = this.getLabelItems(e);
    for (const a of r) {
      const o = a.options, l = a.font, u = a.label, c = a.textOffset;
      rs(i, u, 0, c, l, o);
    }
    s && ia(i);
  }
  drawTitle() {
    const { ctx: e, options: { position: n, title: i, reverse: s } } = this;
    if (!i.display)
      return;
    const r = mt(i.font), a = Ot(i.padding), o = i.align;
    let l = r.lineHeight / 2;
    n === "bottom" || n === "center" || Ae(n) ? (l += a.bottom, Ue(i.text) && (l += r.lineHeight * (i.text.length - 1))) : l += a.top;
    const { titleX: u, titleY: c, maxWidth: d, rotation: f } = Dx(this, l, n, o);
    rs(e, i.text, 0, 0, r, {
      color: i.color,
      maxWidth: d,
      rotation: f,
      textAlign: Ox(o, n, s),
      textBaseline: "middle",
      translation: [
        u,
        c
      ]
    });
  }
  draw(e) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(e), this.drawBorder(), this.drawTitle(), this.drawLabels(e));
  }
  _layers() {
    const e = this.options, n = e.ticks && e.ticks.z || 0, i = De(e.grid && e.grid.z, -1), s = De(e.border && e.border.z, 0);
    return !this._isVisible() || this.draw !== ds.prototype.draw ? [
      {
        z: n,
        draw: (r) => {
          this.draw(r);
        }
      }
    ] : [
      {
        z: i,
        draw: (r) => {
          this.drawBackground(), this.drawGrid(r), this.drawTitle();
        }
      },
      {
        z: s,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (r) => {
          this.drawLabels(r);
        }
      }
    ];
  }
  getMatchingVisibleMetas(e) {
    const n = this.chart.getSortedVisibleDatasetMetas(), i = this.axis + "AxisID", s = [];
    let r, a;
    for (r = 0, a = n.length; r < a; ++r) {
      const o = n[r];
      o[i] === this.id && (!e || o.type === e) && s.push(o);
    }
    return s;
  }
  _resolveTickFontOptions(e) {
    const n = this.options.ticks.setContext(this.getContext(e));
    return mt(n.font);
  }
  _maxDigits() {
    const e = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / e;
  }
}
class Da {
  constructor(e, n, i) {
    this.type = e, this.scope = n, this.override = i, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(e) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, e.prototype);
  }
  register(e) {
    const n = Object.getPrototypeOf(e);
    let i;
    Cx(n) && (i = this.register(n));
    const s = this.items, r = e.id, a = this.scope + "." + r;
    if (!r)
      throw new Error("class does not have id: " + e);
    return r in s || (s[r] = e, Tx(e, a, i), this.override && at.override(e.id, e.overrides)), a;
  }
  get(e) {
    return this.items[e];
  }
  unregister(e) {
    const n = this.items, i = e.id, s = this.scope;
    i in n && delete n[i], s && i in at[s] && (delete at[s][i], this.override && delete ss[i]);
  }
}
function Tx(t, e, n) {
  const i = Hr(/* @__PURE__ */ Object.create(null), [
    n ? at.get(n) : {},
    at.get(e),
    t.defaults
  ]);
  at.set(e, i), t.defaultRoutes && Px(e, t.defaultRoutes), t.descriptors && at.describe(e, t.descriptors);
}
function Px(t, e) {
  Object.keys(e).forEach((n) => {
    const i = n.split("."), s = i.pop(), r = [
      t
    ].concat(i).join("."), a = e[n].split("."), o = a.pop(), l = a.join(".");
    at.route(r, s, l, o);
  });
}
function Cx(t) {
  return "id" in t && "defaults" in t;
}
class Ax {
  constructor() {
    this.controllers = new Da(_n, "datasets", !0), this.elements = new Da(Ht, "elements"), this.plugins = new Da(Object, "plugins"), this.scales = new Da(ds, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...e) {
    this._each("register", e);
  }
  remove(...e) {
    this._each("unregister", e);
  }
  addControllers(...e) {
    this._each("register", e, this.controllers);
  }
  addElements(...e) {
    this._each("register", e, this.elements);
  }
  addPlugins(...e) {
    this._each("register", e, this.plugins);
  }
  addScales(...e) {
    this._each("register", e, this.scales);
  }
  getController(e) {
    return this._get(e, this.controllers, "controller");
  }
  getElement(e) {
    return this._get(e, this.elements, "element");
  }
  getPlugin(e) {
    return this._get(e, this.plugins, "plugin");
  }
  getScale(e) {
    return this._get(e, this.scales, "scale");
  }
  removeControllers(...e) {
    this._each("unregister", e, this.controllers);
  }
  removeElements(...e) {
    this._each("unregister", e, this.elements);
  }
  removePlugins(...e) {
    this._each("unregister", e, this.plugins);
  }
  removeScales(...e) {
    this._each("unregister", e, this.scales);
  }
  _each(e, n, i) {
    [
      ...n
    ].forEach((s) => {
      const r = i || this._getRegistryForType(s);
      i || r.isForType(s) || r === this.plugins && s.id ? this._exec(e, r, s) : Ke(s, (a) => {
        const o = i || this._getRegistryForType(a);
        this._exec(e, o, a);
      });
    });
  }
  _exec(e, n, i) {
    const s = $c(e);
    Ze(i["before" + s], [], i), n[e](i), Ze(i["after" + s], [], i);
  }
  _getRegistryForType(e) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const i = this._typedRegistries[n];
      if (i.isForType(e))
        return i;
    }
    return this.plugins;
  }
  _get(e, n, i) {
    const s = n.get(e);
    if (s === void 0)
      throw new Error('"' + e + '" is not a registered ' + i + ".");
    return s;
  }
}
var $n = /* @__PURE__ */ new Ax();
class Ex {
  constructor() {
    this._init = [];
  }
  notify(e, n, i, s) {
    n === "beforeInit" && (this._init = this._createDescriptors(e, !0), this._notify(this._init, e, "install"));
    const r = s ? this._descriptors(e).filter(s) : this._descriptors(e), a = this._notify(r, e, n, i);
    return n === "afterDestroy" && (this._notify(r, e, "stop"), this._notify(this._init, e, "uninstall")), a;
  }
  _notify(e, n, i, s) {
    s = s || {};
    for (const r of e) {
      const a = r.plugin, o = a[i], l = [
        n,
        s,
        r.options
      ];
      if (Ze(o, l, a) === !1 && s.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    Ie(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(e) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(e);
    return this._notifyStateChanges(e), n;
  }
  _createDescriptors(e, n) {
    const i = e && e.config, s = De(i.options && i.options.plugins, {}), r = $x(i);
    return s === !1 && !n ? [] : Lx(e, r, s, n);
  }
  _notifyStateChanges(e) {
    const n = this._oldCache || [], i = this._cache, s = (r, a) => r.filter((o) => !a.some((l) => o.plugin.id === l.plugin.id));
    this._notify(s(n, i), e, "stop"), this._notify(s(i, n), e, "start");
  }
}
function $x(t) {
  const e = {}, n = [], i = Object.keys($n.plugins.items);
  for (let r = 0; r < i.length; r++)
    n.push($n.getPlugin(i[r]));
  const s = t.plugins || [];
  for (let r = 0; r < s.length; r++) {
    const a = s[r];
    n.indexOf(a) === -1 && (n.push(a), e[a.id] = !0);
  }
  return {
    plugins: n,
    localIds: e
  };
}
function Rx(t, e) {
  return !e && t === !1 ? null : t === !0 ? {} : t;
}
function Lx(t, { plugins: e, localIds: n }, i, s) {
  const r = [], a = t.getContext();
  for (const o of e) {
    const l = o.id, u = Rx(i[l], s);
    u !== null && r.push({
      plugin: o,
      options: Ix(t.config, {
        plugin: o,
        local: n[l]
      }, u, a)
    });
  }
  return r;
}
function Ix(t, { plugin: e, local: n }, i, s) {
  const r = t.pluginScopeKeys(e), a = t.getOptionScopes(i, r);
  return n && e.defaults && a.push(e.defaults), t.createResolver(a, s, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function $u(t, e) {
  const n = at.datasets[t] || {};
  return ((e.datasets || {})[t] || {}).indexAxis || e.indexAxis || n.indexAxis || "x";
}
function Fx(t, e) {
  let n = t;
  return t === "_index_" ? n = e : t === "_value_" && (n = e === "x" ? "y" : "x"), n;
}
function Vx(t, e) {
  return t === e ? "_index_" : "_value_";
}
function Of(t) {
  if (t === "x" || t === "y" || t === "r")
    return t;
}
function Nx(t) {
  if (t === "top" || t === "bottom")
    return "x";
  if (t === "left" || t === "right")
    return "y";
}
function Ru(t, ...e) {
  if (Of(t))
    return t;
  for (const n of e) {
    const i = n.axis || Nx(n.position) || t.length > 1 && Of(t[0].toLowerCase());
    if (i)
      return i;
  }
  throw new Error(`Cannot determine type of '${t}' axis. Please provide 'axis' or 'position' option.`);
}
function Df(t, e, n) {
  if (n[e + "AxisID"] === t)
    return {
      axis: e
    };
}
function Bx(t, e) {
  if (e.data && e.data.datasets) {
    const n = e.data.datasets.filter((i) => i.xAxisID === t || i.yAxisID === t);
    if (n.length)
      return Df(t, "x", n[0]) || Df(t, "y", n[0]);
  }
  return {};
}
function zx(t, e) {
  const n = ss[t.type] || {
    scales: {}
  }, i = e.scales || {}, s = $u(t.type, e), r = /* @__PURE__ */ Object.create(null);
  return Object.keys(i).forEach((a) => {
    const o = i[a];
    if (!Ae(o))
      return console.error(`Invalid scale configuration for scale: ${a}`);
    if (o._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${a}`);
    const l = Ru(a, o, Bx(a, t), at.scales[o.type]), u = Vx(l, s), c = n.scales || {};
    r[a] = Cr(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      o,
      c[l],
      c[u]
    ]);
  }), t.data.datasets.forEach((a) => {
    const o = a.type || t.type, l = a.indexAxis || $u(o, e), c = (ss[o] || {}).scales || {};
    Object.keys(c).forEach((d) => {
      const f = Fx(d, l), h = a[f + "AxisID"] || f;
      r[h] = r[h] || /* @__PURE__ */ Object.create(null), Cr(r[h], [
        {
          axis: f
        },
        i[h],
        c[d]
      ]);
    });
  }), Object.keys(r).forEach((a) => {
    const o = r[a];
    Cr(o, [
      at.scales[o.type],
      at.scale
    ]);
  }), r;
}
function hg(t) {
  const e = t.options || (t.options = {});
  e.plugins = De(e.plugins, {}), e.scales = zx(t, e);
}
function mg(t) {
  return t = t || {}, t.datasets = t.datasets || [], t.labels = t.labels || [], t;
}
function Wx(t) {
  return t = t || {}, t.data = mg(t.data), hg(t), t;
}
const Tf = /* @__PURE__ */ new Map(), pg = /* @__PURE__ */ new Set();
function Ta(t, e) {
  let n = Tf.get(t);
  return n || (n = e(), Tf.set(t, n), pg.add(n)), n;
}
const pr = (t, e, n) => {
  const i = Ci(e, n);
  i !== void 0 && t.add(i);
};
class Hx {
  constructor(e) {
    this._config = Wx(e), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(e) {
    this._config.type = e;
  }
  get data() {
    return this._config.data;
  }
  set data(e) {
    this._config.data = mg(e);
  }
  get options() {
    return this._config.options;
  }
  set options(e) {
    this._config.options = e;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const e = this._config;
    this.clearCache(), hg(e);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(e) {
    return Ta(e, () => [
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(e, n) {
    return Ta(`${e}.transition.${n}`, () => [
      [
        `datasets.${e}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(e, n) {
    return Ta(`${e}-${n}`, () => [
      [
        `datasets.${e}.elements.${n}`,
        `datasets.${e}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(e) {
    const n = e.id, i = this.type;
    return Ta(`${i}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...e.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(e, n) {
    const i = this._scopeCache;
    let s = i.get(e);
    return (!s || n) && (s = /* @__PURE__ */ new Map(), i.set(e, s)), s;
  }
  getOptionScopes(e, n, i) {
    const { options: s, type: r } = this, a = this._cachedScopes(e, i), o = a.get(n);
    if (o)
      return o;
    const l = /* @__PURE__ */ new Set();
    n.forEach((c) => {
      e && (l.add(e), c.forEach((d) => pr(l, e, d))), c.forEach((d) => pr(l, s, d)), c.forEach((d) => pr(l, ss[r] || {}, d)), c.forEach((d) => pr(l, at, d)), c.forEach((d) => pr(l, Pu, d));
    });
    const u = Array.from(l);
    return u.length === 0 && u.push(/* @__PURE__ */ Object.create(null)), pg.has(n) && a.set(n, u), u;
  }
  chartOptionScopes() {
    const { options: e, type: n } = this;
    return [
      e,
      ss[n] || {},
      at.datasets[n] || {},
      {
        type: n
      },
      at,
      Pu
    ];
  }
  resolveNamedOptions(e, n, i, s = [
    ""
  ]) {
    const r = {
      $shared: !0
    }, { resolver: a, subPrefixes: o } = Pf(this._resolverCache, e, s);
    let l = a;
    if (jx(a, n)) {
      r.$shared = !1, i = Qt(i) ? i() : i;
      const u = this.createResolver(e, i, o);
      l = Ys(a, i, u);
    }
    for (const u of n)
      r[u] = l[u];
    return r;
  }
  createResolver(e, n, i = [
    ""
  ], s) {
    const { resolver: r } = Pf(this._resolverCache, e, i);
    return Ae(n) ? Ys(r, n, void 0, s) : r;
  }
}
function Pf(t, e, n) {
  let i = t.get(e);
  i || (i = /* @__PURE__ */ new Map(), t.set(e, i));
  const s = n.join();
  let r = i.get(s);
  return r || (r = {
    resolver: Nc(e, n),
    subPrefixes: n.filter((o) => !o.toLowerCase().includes("hover"))
  }, i.set(s, r)), r;
}
const Yx = (t) => Ae(t) && Object.getOwnPropertyNames(t).some((e) => Qt(t[e]));
function jx(t, e) {
  const { isScriptable: n, isIndexable: i } = Up(t);
  for (const s of e) {
    const r = n(s), a = i(s), o = (a || r) && t[s];
    if (r && (Qt(o) || Yx(o)) || a && Ue(o))
      return !0;
  }
  return !1;
}
var qx = "4.4.9";
const Ux = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function Cf(t, e) {
  return t === "top" || t === "bottom" || Ux.indexOf(t) === -1 && e === "x";
}
function Af(t, e) {
  return function(n, i) {
    return n[t] === i[t] ? n[e] - i[e] : n[t] - i[t];
  };
}
function Ef(t) {
  const e = t.chart, n = e.options.animation;
  e.notifyPlugins("afterRender"), Ze(n && n.onComplete, [
    t
  ], e);
}
function Xx(t) {
  const e = t.chart, n = e.options.animation;
  Ze(n && n.onProgress, [
    t
  ], e);
}
function gg(t) {
  return Wc() && typeof t == "string" ? t = document.getElementById(t) : t && t.length && (t = t[0]), t && t.canvas && (t = t.canvas), t;
}
const Xa = {}, $f = (t) => {
  const e = gg(t);
  return Object.values(Xa).filter((n) => n.canvas === e).pop();
};
function Gx(t, e, n) {
  const i = Object.keys(t);
  for (const s of i) {
    const r = +s;
    if (r >= e) {
      const a = t[s];
      delete t[s], (n > 0 || r > e) && (t[r + n] = a);
    }
  }
}
function Zx(t, e, n, i) {
  return !n || t.type === "mouseout" ? null : i ? e : t;
}
var ui;
let Ji = (ui = class {
  static register(...e) {
    $n.add(...e), Rf();
  }
  static unregister(...e) {
    $n.remove(...e), Rf();
  }
  constructor(e, n) {
    const i = this.config = new Hx(n), s = gg(e), r = $f(s);
    if (r)
      throw new Error("Canvas is already in use. Chart with ID '" + r.id + "' must be destroyed before the canvas with ID '" + r.canvas.id + "' can be reused.");
    const a = i.createResolver(i.chartOptionScopes(), this.getContext());
    this.platform = new (i.platform || mx(s))(), this.platform.updateConfig(i);
    const o = this.platform.acquireContext(s, a.aspectRatio), l = o && o.canvas, u = l && l.height, c = l && l.width;
    if (this.id = ew(), this.ctx = o, this.canvas = l, this.width = c, this.height = u, this._options = a, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new Ex(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = gw((d) => this.update(d), a.resizeDelay || 0), this._dataChanges = [], Xa[this.id] = this, !o || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    qn.listen(this, "complete", Ef), qn.listen(this, "progress", Xx), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: e, maintainAspectRatio: n }, width: i, height: s, _aspectRatio: r } = this;
    return Ie(e) ? n && r ? r : s ? i / s : null : e;
  }
  get data() {
    return this.config.data;
  }
  set data(e) {
    this.config.data = e;
  }
  get options() {
    return this._options;
  }
  set options(e) {
    this.config.options = e;
  }
  get registry() {
    return $n;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : tf(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return Qd(this.canvas, this.ctx), this;
  }
  stop() {
    return qn.stop(this), this;
  }
  resize(e, n) {
    qn.running(this) ? this._resizeBeforeDraw = {
      width: e,
      height: n
    } : this._resize(e, n);
  }
  _resize(e, n) {
    const i = this.options, s = this.canvas, r = i.maintainAspectRatio && this.aspectRatio, a = this.platform.getMaximumSize(s, e, n, r), o = i.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = a.width, this.height = a.height, this._aspectRatio = this.aspectRatio, tf(this, o, !0) && (this.notifyPlugins("resize", {
      size: a
    }), Ze(i.onResize, [
      this,
      a
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    Ke(n, (i, s) => {
      i.id = s;
    });
  }
  buildOrUpdateScales() {
    const e = this.options, n = e.scales, i = this.scales, s = Object.keys(i).reduce((a, o) => (a[o] = !1, a), {});
    let r = [];
    n && (r = r.concat(Object.keys(n).map((a) => {
      const o = n[a], l = Ru(a, o), u = l === "r", c = l === "x";
      return {
        options: o,
        dposition: u ? "chartArea" : c ? "bottom" : "left",
        dtype: u ? "radialLinear" : c ? "category" : "linear"
      };
    }))), Ke(r, (a) => {
      const o = a.options, l = o.id, u = Ru(l, o), c = De(o.type, a.dtype);
      (o.position === void 0 || Cf(o.position, u) !== Cf(a.dposition)) && (o.position = a.dposition), s[l] = !0;
      let d = null;
      if (l in i && i[l].type === c)
        d = i[l];
      else {
        const f = $n.getScale(c);
        d = new f({
          id: l,
          type: c,
          ctx: this.ctx,
          chart: this
        }), i[d.id] = d;
      }
      d.init(o, e);
    }), Ke(s, (a, o) => {
      a || delete i[o];
    }), Ke(i, (a) => {
      Wt.configure(this, a, a.options), Wt.addBox(this, a);
    });
  }
  _updateMetasets() {
    const e = this._metasets, n = this.data.datasets.length, i = e.length;
    if (e.sort((s, r) => s.index - r.index), i > n) {
      for (let s = n; s < i; ++s)
        this._destroyDatasetMeta(s);
      e.splice(n, i - n);
    }
    this._sortedMetasets = e.slice(0).sort(Af("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: e, data: { datasets: n } } = this;
    e.length > n.length && delete this._stacks, e.forEach((i, s) => {
      n.filter((r) => r === i._dataset).length === 0 && this._destroyDatasetMeta(s);
    });
  }
  buildOrUpdateControllers() {
    const e = [], n = this.data.datasets;
    let i, s;
    for (this._removeUnreferencedMetasets(), i = 0, s = n.length; i < s; i++) {
      const r = n[i];
      let a = this.getDatasetMeta(i);
      const o = r.type || this.config.type;
      if (a.type && a.type !== o && (this._destroyDatasetMeta(i), a = this.getDatasetMeta(i)), a.type = o, a.indexAxis = r.indexAxis || $u(o, this.options), a.order = r.order || 0, a.index = i, a.label = "" + r.label, a.visible = this.isDatasetVisible(i), a.controller)
        a.controller.updateIndex(i), a.controller.linkScales();
      else {
        const l = $n.getController(o), { datasetElementType: u, dataElementType: c } = at.datasets[o];
        Object.assign(l, {
          dataElementType: $n.getElement(c),
          datasetElementType: u && $n.getElement(u)
        }), a.controller = new l(this, i), e.push(a.controller);
      }
    }
    return this._updateMetasets(), e;
  }
  _resetElements() {
    Ke(this.data.datasets, (e, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(e) {
    const n = this.config;
    n.update();
    const i = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), s = this._animationsDisabled = !i.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: e,
      cancelable: !0
    }) === !1)
      return;
    const r = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let a = 0;
    for (let u = 0, c = this.data.datasets.length; u < c; u++) {
      const { controller: d } = this.getDatasetMeta(u), f = !s && r.indexOf(d) === -1;
      d.buildOrUpdateElements(f), a = Math.max(+d.getMaxOverflow(), a);
    }
    a = this._minPadding = i.layout.autoPadding ? a : 0, this._updateLayout(a), s || Ke(r, (u) => {
      u.reset();
    }), this._updateDatasets(e), this.notifyPlugins("afterUpdate", {
      mode: e
    }), this._layers.sort(Af("z", "_idx"));
    const { _active: o, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : o.length && this._updateHoverStyles(o, o, !0), this.render();
  }
  _updateScales() {
    Ke(this.scales, (e) => {
      Wt.removeBox(this, e);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const e = this.options, n = new Set(Object.keys(this._listeners)), i = new Set(e.events);
    (!Yd(n, i) || !!this._responsiveListeners !== e.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: e } = this, n = this._getUniformDataChanges() || [];
    for (const { method: i, start: s, count: r } of n) {
      const a = i === "_removeElements" ? -r : r;
      Gx(e, s, a);
    }
  }
  _getUniformDataChanges() {
    const e = this._dataChanges;
    if (!e || !e.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, i = (r) => new Set(e.filter((a) => a[0] === r).map((a, o) => o + "," + a.splice(1).join(","))), s = i(0);
    for (let r = 1; r < n; r++)
      if (!Yd(s, i(r)))
        return;
    return Array.from(s).map((r) => r.split(",")).map((r) => ({
      method: r[1],
      start: +r[2],
      count: +r[3]
    }));
  }
  _updateLayout(e) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    Wt.update(this, this.width, this.height, e);
    const n = this.chartArea, i = n.width <= 0 || n.height <= 0;
    this._layers = [], Ke(this.boxes, (s) => {
      i && s.position === "chartArea" || (s.configure && s.configure(), this._layers.push(...s._layers()));
    }, this), this._layers.forEach((s, r) => {
      s._idx = r;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(e) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: e,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, i = this.data.datasets.length; n < i; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, i = this.data.datasets.length; n < i; ++n)
        this._updateDataset(n, Qt(e) ? e({
          datasetIndex: n
        }) : e);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: e
      });
    }
  }
  _updateDataset(e, n) {
    const i = this.getDatasetMeta(e), s = {
      meta: i,
      index: e,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", s) !== !1 && (i.controller._update(n), s.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", s));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (qn.has(this) ? this.attached && !qn.running(this) && qn.start(this) : (this.draw(), Ef({
      chart: this
    })));
  }
  draw() {
    let e;
    if (this._resizeBeforeDraw) {
      const { width: i, height: s } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(i, s);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (e = 0; e < n.length && n[e].z <= 0; ++e)
      n[e].draw(this.chartArea);
    for (this._drawDatasets(); e < n.length; ++e)
      n[e].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(e) {
    const n = this._sortedMetasets, i = [];
    let s, r;
    for (s = 0, r = n.length; s < r; ++s) {
      const a = n[s];
      (!e || a.visible) && i.push(a);
    }
    return i;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this.getSortedVisibleDatasetMetas();
    for (let n = e.length - 1; n >= 0; --n)
      this._drawDataset(e[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(e) {
    const n = this.ctx, i = {
      meta: e,
      index: e.index,
      cancelable: !0
    }, s = sg(this, e);
    this.notifyPlugins("beforeDatasetDraw", i) !== !1 && (s && na(n, s), e.controller.draw(), s && ia(n), i.cancelable = !1, this.notifyPlugins("afterDatasetDraw", i));
  }
  isPointInArea(e) {
    return Qn(e, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e, n, i, s) {
    const r = Eu.modes[n];
    return typeof r == "function" ? r(this, e, i, s) : [];
  }
  getDatasetMeta(e) {
    const n = this.data.datasets[e], i = this._metasets;
    let s = i.filter((r) => r && r._dataset === n).pop();
    return s || (s = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: e,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, i.push(s)), s;
  }
  getContext() {
    return this.$context || (this.$context = Li(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(e) {
    const n = this.data.datasets[e];
    if (!n)
      return !1;
    const i = this.getDatasetMeta(e);
    return typeof i.hidden == "boolean" ? !i.hidden : !n.hidden;
  }
  setDatasetVisibility(e, n) {
    const i = this.getDatasetMeta(e);
    i.hidden = !n;
  }
  toggleDataVisibility(e) {
    this._hiddenIndices[e] = !this._hiddenIndices[e];
  }
  getDataVisibility(e) {
    return !this._hiddenIndices[e];
  }
  _updateVisibility(e, n, i) {
    const s = i ? "show" : "hide", r = this.getDatasetMeta(e), a = r.controller._resolveAnimations(void 0, s);
    en(n) ? (r.data[n].hidden = !i, this.update()) : (this.setDatasetVisibility(e, i), a.update(r, {
      visible: i
    }), this.update((o) => o.datasetIndex === e ? s : void 0));
  }
  hide(e, n) {
    this._updateVisibility(e, n, !1);
  }
  show(e, n) {
    this._updateVisibility(e, n, !0);
  }
  _destroyDatasetMeta(e) {
    const n = this._metasets[e];
    n && n.controller && n.controller._destroy(), delete this._metasets[e];
  }
  _stop() {
    let e, n;
    for (this.stop(), qn.remove(this), e = 0, n = this.data.datasets.length; e < n; ++e)
      this._destroyDatasetMeta(e);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: e, ctx: n } = this;
    this._stop(), this.config.clearCache(), e && (this.unbindEvents(), Qd(e, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete Xa[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...e) {
    return this.canvas.toDataURL(...e);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const e = this._listeners, n = this.platform, i = (r, a) => {
      n.addEventListener(this, r, a), e[r] = a;
    }, s = (r, a, o) => {
      r.offsetX = a, r.offsetY = o, this._eventHandler(r);
    };
    Ke(this.options.events, (r) => i(r, s));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const e = this._responsiveListeners, n = this.platform, i = (l, u) => {
      n.addEventListener(this, l, u), e[l] = u;
    }, s = (l, u) => {
      e[l] && (n.removeEventListener(this, l, u), delete e[l]);
    }, r = (l, u) => {
      this.canvas && this.resize(l, u);
    };
    let a;
    const o = () => {
      s("attach", o), this.attached = !0, this.resize(), i("resize", r), i("detach", a);
    };
    a = () => {
      this.attached = !1, s("resize", r), this._stop(), this._resize(0, 0), i("attach", o);
    }, n.isAttached(this.canvas) ? o() : a();
  }
  unbindEvents() {
    Ke(this._listeners, (e, n) => {
      this.platform.removeEventListener(this, n, e);
    }), this._listeners = {}, Ke(this._responsiveListeners, (e, n) => {
      this.platform.removeEventListener(this, n, e);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(e, n, i) {
    const s = i ? "set" : "remove";
    let r, a, o, l;
    for (n === "dataset" && (r = this.getDatasetMeta(e[0].datasetIndex), r.controller["_" + s + "DatasetHoverStyle"]()), o = 0, l = e.length; o < l; ++o) {
      a = e[o];
      const u = a && this.getDatasetMeta(a.datasetIndex).controller;
      u && u[s + "HoverStyle"](a.element, a.datasetIndex, a.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e) {
    const n = this._active || [], i = e.map(({ datasetIndex: r, index: a }) => {
      const o = this.getDatasetMeta(r);
      if (!o)
        throw new Error("No dataset found at index " + r);
      return {
        datasetIndex: r,
        element: o.data[a],
        index: a
      };
    });
    !no(i, n) && (this._active = i, this._lastEvent = null, this._updateHoverStyles(i, n));
  }
  notifyPlugins(e, n, i) {
    return this._plugins.notify(this, e, n, i);
  }
  isPluginEnabled(e) {
    return this._plugins._cache.filter((n) => n.plugin.id === e).length === 1;
  }
  _updateHoverStyles(e, n, i) {
    const s = this.options.hover, r = (l, u) => l.filter((c) => !u.some((d) => c.datasetIndex === d.datasetIndex && c.index === d.index)), a = r(n, e), o = i ? e : r(e, n);
    a.length && this.updateHoverStyle(a, s.mode, !1), o.length && s.mode && this.updateHoverStyle(o, s.mode, !0);
  }
  _eventHandler(e, n) {
    const i = {
      event: e,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(e)
    }, s = (a) => (a.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins("beforeEvent", i, s) === !1)
      return;
    const r = this._handleEvent(e, n, i.inChartArea);
    return i.cancelable = !1, this.notifyPlugins("afterEvent", i, s), (r || i.changed) && this.render(), this;
  }
  _handleEvent(e, n, i) {
    const { _active: s = [], options: r } = this, a = n, o = this._getActiveElements(e, s, i, a), l = aw(e), u = Zx(e, this._lastEvent, i, l);
    i && (this._lastEvent = null, Ze(r.onHover, [
      e,
      o,
      this
    ], this), l && Ze(r.onClick, [
      e,
      o,
      this
    ], this));
    const c = !no(o, s);
    return (c || n) && (this._active = o, this._updateHoverStyles(o, s, n)), this._lastEvent = u, c;
  }
  _getActiveElements(e, n, i, s) {
    if (e.type === "mouseout")
      return [];
    if (!i)
      return n;
    const r = this.options.hover;
    return this.getElementsAtEventForMode(e, r.mode, r, s);
  }
}, X(ui, "defaults", at), X(ui, "instances", Xa), X(ui, "overrides", ss), X(ui, "registry", $n), X(ui, "version", qx), X(ui, "getChart", $f), ui);
function Rf() {
  return Ke(Ji.instances, (t) => t._plugins.invalidate());
}
function Kx(t, e, n) {
  const { startAngle: i, pixelMargin: s, x: r, y: a, outerRadius: o, innerRadius: l } = e;
  let u = s / o;
  t.beginPath(), t.arc(r, a, o, i - u, n + u), l > s ? (u = s / l, t.arc(r, a, l, n + u, i - u, !0)) : t.arc(r, a, s, n + rt, i - rt), t.closePath(), t.clip();
}
function Qx(t) {
  return Vc(t, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function Jx(t, e, n, i) {
  const s = Qx(t.options.borderRadius), r = (n - e) / 2, a = Math.min(r, i * e / 2), o = (l) => {
    const u = (n - Math.min(r, l)) * i / 2;
    return Et(l, 0, Math.min(r, u));
  };
  return {
    outerStart: o(s.outerStart),
    outerEnd: o(s.outerEnd),
    innerStart: Et(s.innerStart, 0, a),
    innerEnd: Et(s.innerEnd, 0, a)
  };
}
function vs(t, e, n, i) {
  return {
    x: n + t * Math.cos(e),
    y: i + t * Math.sin(e)
  };
}
function co(t, e, n, i, s, r) {
  const { x: a, y: o, startAngle: l, pixelMargin: u, innerRadius: c } = e, d = Math.max(e.outerRadius + i + n - u, 0), f = c > 0 ? c + i + n + u : 0;
  let h = 0;
  const m = s - l;
  if (i) {
    const x = c > 0 ? c - i : 0, k = d > 0 ? d - i : 0, D = (x + k) / 2, N = D !== 0 ? m * D / (D + i) : m;
    h = (m - N) / 2;
  }
  const p = Math.max(1e-3, m * d - n / Ne) / d, g = (m - p) / 2, y = l + g + h, v = s - g - h, { outerStart: b, outerEnd: _, innerStart: M, innerEnd: A } = Jx(e, f, d, v - y), E = d - b, I = d - _, S = y + b / E, $ = v - _ / I, B = f + M, V = f + A, G = y + M / B, P = v - A / V;
  if (t.beginPath(), r) {
    const x = (S + $) / 2;
    if (t.arc(a, o, d, S, x), t.arc(a, o, d, x, $), _ > 0) {
      const L = vs(I, $, a, o);
      t.arc(L.x, L.y, _, $, v + rt);
    }
    const k = vs(V, v, a, o);
    if (t.lineTo(k.x, k.y), A > 0) {
      const L = vs(V, P, a, o);
      t.arc(L.x, L.y, A, v + rt, P + Math.PI);
    }
    const D = (v - A / f + (y + M / f)) / 2;
    if (t.arc(a, o, f, v - A / f, D, !0), t.arc(a, o, f, D, y + M / f, !0), M > 0) {
      const L = vs(B, G, a, o);
      t.arc(L.x, L.y, M, G + Math.PI, y - rt);
    }
    const N = vs(E, y, a, o);
    if (t.lineTo(N.x, N.y), b > 0) {
      const L = vs(E, S, a, o);
      t.arc(L.x, L.y, b, y - rt, S);
    }
  } else {
    t.moveTo(a, o);
    const x = Math.cos(S) * d + a, k = Math.sin(S) * d + o;
    t.lineTo(x, k);
    const D = Math.cos($) * d + a, N = Math.sin($) * d + o;
    t.lineTo(D, N);
  }
  t.closePath();
}
function e_(t, e, n, i, s) {
  const { fullCircles: r, startAngle: a, circumference: o } = e;
  let l = e.endAngle;
  if (r) {
    co(t, e, n, i, l, s);
    for (let u = 0; u < r; ++u)
      t.fill();
    isNaN(o) || (l = a + (o % nt || nt));
  }
  return co(t, e, n, i, l, s), t.fill(), l;
}
function t_(t, e, n, i, s) {
  const { fullCircles: r, startAngle: a, circumference: o, options: l } = e, { borderWidth: u, borderJoinStyle: c, borderDash: d, borderDashOffset: f } = l, h = l.borderAlign === "inner";
  if (!u)
    return;
  t.setLineDash(d || []), t.lineDashOffset = f, h ? (t.lineWidth = u * 2, t.lineJoin = c || "round") : (t.lineWidth = u, t.lineJoin = c || "bevel");
  let m = e.endAngle;
  if (r) {
    co(t, e, n, i, m, s);
    for (let p = 0; p < r; ++p)
      t.stroke();
    isNaN(o) || (m = a + (o % nt || nt));
  }
  h && Kx(t, e, m), r || (co(t, e, n, i, m, s), t.stroke());
}
class kr extends Ht {
  constructor(n) {
    super();
    X(this, "circumference");
    X(this, "endAngle");
    X(this, "fullCircles");
    X(this, "innerRadius");
    X(this, "outerRadius");
    X(this, "pixelMargin");
    X(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, n && Object.assign(this, n);
  }
  inRange(n, i, s) {
    const r = this.getProps([
      "x",
      "y"
    ], s), { angle: a, distance: o } = ao(r, {
      x: n,
      y: i
    }), { startAngle: l, endAngle: u, innerRadius: c, outerRadius: d, circumference: f } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], s), h = (this.options.spacing + this.options.borderWidth) / 2, m = De(f, u - l), p = Yr(a, l, u) && l !== u, g = m >= nt || p, y = Zn(o, c + h, d + h);
    return g && y;
  }
  getCenterPoint(n) {
    const { x: i, y: s, startAngle: r, endAngle: a, innerRadius: o, outerRadius: l } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], n), { offset: u, spacing: c } = this.options, d = (r + a) / 2, f = (o + l + c + u) / 2;
    return {
      x: i + Math.cos(d) * f,
      y: s + Math.sin(d) * f
    };
  }
  tooltipPosition(n) {
    return this.getCenterPoint(n);
  }
  draw(n) {
    const { options: i, circumference: s } = this, r = (i.offset || 0) / 4, a = (i.spacing || 0) / 2, o = i.circular;
    if (this.pixelMargin = i.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = s > nt ? Math.floor(s / nt) : 0, s === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    n.save();
    const l = (this.startAngle + this.endAngle) / 2;
    n.translate(Math.cos(l) * r, Math.sin(l) * r);
    const u = 1 - Math.sin(Math.min(Ne, s || 0)), c = r * u;
    n.fillStyle = i.backgroundColor, n.strokeStyle = i.borderColor, e_(n, this, c, a, o), t_(n, this, c, a, o), n.restore();
  }
}
X(kr, "id", "arc"), X(kr, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), X(kr, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), X(kr, "descriptors", {
  _scriptable: !0,
  _indexable: (n) => n !== "borderDash"
});
function yg(t, e, n = e) {
  t.lineCap = De(n.borderCapStyle, e.borderCapStyle), t.setLineDash(De(n.borderDash, e.borderDash)), t.lineDashOffset = De(n.borderDashOffset, e.borderDashOffset), t.lineJoin = De(n.borderJoinStyle, e.borderJoinStyle), t.lineWidth = De(n.borderWidth, e.borderWidth), t.strokeStyle = De(n.borderColor, e.borderColor);
}
function n_(t, e, n) {
  t.lineTo(n.x, n.y);
}
function i_(t) {
  return t.stepped ? Tw : t.tension || t.cubicInterpolationMode === "monotone" ? Pw : n_;
}
function vg(t, e, n = {}) {
  const i = t.length, { start: s = 0, end: r = i - 1 } = n, { start: a, end: o } = e, l = Math.max(s, a), u = Math.min(r, o), c = s < a && r < a || s > o && r > o;
  return {
    count: i,
    start: l,
    loop: e.loop,
    ilen: u < l && !c ? i + u - l : u - l
  };
}
function s_(t, e, n, i) {
  const { points: s, options: r } = e, { count: a, start: o, loop: l, ilen: u } = vg(s, n, i), c = i_(r);
  let { move: d = !0, reverse: f } = i || {}, h, m, p;
  for (h = 0; h <= u; ++h)
    m = s[(o + (f ? u - h : h)) % a], !m.skip && (d ? (t.moveTo(m.x, m.y), d = !1) : c(t, p, m, f, r.stepped), p = m);
  return l && (m = s[(o + (f ? u : 0)) % a], c(t, p, m, f, r.stepped)), !!l;
}
function r_(t, e, n, i) {
  const s = e.points, { count: r, start: a, ilen: o } = vg(s, n, i), { move: l = !0, reverse: u } = i || {};
  let c = 0, d = 0, f, h, m, p, g, y;
  const v = (_) => (a + (u ? o - _ : _)) % r, b = () => {
    p !== g && (t.lineTo(c, g), t.lineTo(c, p), t.lineTo(c, y));
  };
  for (l && (h = s[v(0)], t.moveTo(h.x, h.y)), f = 0; f <= o; ++f) {
    if (h = s[v(f)], h.skip)
      continue;
    const _ = h.x, M = h.y, A = _ | 0;
    A === m ? (M < p ? p = M : M > g && (g = M), c = (d * c + _) / ++d) : (b(), t.lineTo(_, M), m = A, d = 0, p = g = M), y = M;
  }
  b();
}
function Lu(t) {
  const e = t.options, n = e.borderDash && e.borderDash.length;
  return !t._decimated && !t._loop && !e.tension && e.cubicInterpolationMode !== "monotone" && !e.stepped && !n ? r_ : s_;
}
function a_(t) {
  return t.stepped ? o1 : t.tension || t.cubicInterpolationMode === "monotone" ? l1 : Yi;
}
function o_(t, e, n, i) {
  let s = e._path;
  s || (s = e._path = new Path2D(), e.path(s, n, i) && s.closePath()), yg(t, e.options), t.stroke(s);
}
function l_(t, e, n, i) {
  const { segments: s, options: r } = e, a = Lu(e);
  for (const o of s)
    yg(t, r, o.style), t.beginPath(), a(t, e, o, {
      start: n,
      end: n + i - 1
    }) && t.closePath(), t.stroke();
}
const u_ = typeof Path2D == "function";
function c_(t, e, n, i) {
  u_ && !e.options.segment ? o_(t, e, n, i) : l_(t, e, n, i);
}
class vi extends Ht {
  constructor(e) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, e && Object.assign(this, e);
  }
  updateControlPoints(e, n) {
    const i = this.options;
    if ((i.tension || i.cubicInterpolationMode === "monotone") && !i.stepped && !this._pointsUpdated) {
      const s = i.spanGaps ? this._loop : this._fullLoop;
      Jw(this._points, i, e, s, n), this._pointsUpdated = !0;
    }
  }
  set points(e) {
    this._points = e, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = m1(this, this.options.segment));
  }
  first() {
    const e = this.segments, n = this.points;
    return e.length && n[e[0].start];
  }
  last() {
    const e = this.segments, n = this.points, i = e.length;
    return i && n[e[i - 1].end];
  }
  interpolate(e, n) {
    const i = this.options, s = e[n], r = this.points, a = ig(this, {
      property: n,
      start: s,
      end: s
    });
    if (!a.length)
      return;
    const o = [], l = a_(i);
    let u, c;
    for (u = 0, c = a.length; u < c; ++u) {
      const { start: d, end: f } = a[u], h = r[d], m = r[f];
      if (h === m) {
        o.push(h);
        continue;
      }
      const p = Math.abs((s - h[n]) / (m[n] - h[n])), g = l(h, m, p, i.stepped);
      g[n] = e[n], o.push(g);
    }
    return o.length === 1 ? o[0] : o;
  }
  pathSegment(e, n, i) {
    return Lu(this)(e, this, n, i);
  }
  path(e, n, i) {
    const s = this.segments, r = Lu(this);
    let a = this._loop;
    n = n || 0, i = i || this.points.length - n;
    for (const o of s)
      a &= r(e, this, o, {
        start: n,
        end: n + i - 1
      });
    return !!a;
  }
  draw(e, n, i, s) {
    const r = this.options || {};
    (this.points || []).length && r.borderWidth && (e.save(), c_(e, this, i, s), e.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
X(vi, "id", "line"), X(vi, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), X(vi, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), X(vi, "descriptors", {
  _scriptable: !0,
  _indexable: (e) => e !== "borderDash" && e !== "fill"
});
function Lf(t, e, n, i) {
  const s = t.options, { [n]: r } = t.getProps([
    n
  ], i);
  return Math.abs(e - r) < s.radius + s.hitRadius;
}
class Ga extends Ht {
  constructor(n) {
    super();
    X(this, "parsed");
    X(this, "skip");
    X(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, n && Object.assign(this, n);
  }
  inRange(n, i, s) {
    const r = this.options, { x: a, y: o } = this.getProps([
      "x",
      "y"
    ], s);
    return Math.pow(n - a, 2) + Math.pow(i - o, 2) < Math.pow(r.hitRadius + r.radius, 2);
  }
  inXRange(n, i) {
    return Lf(this, n, "x", i);
  }
  inYRange(n, i) {
    return Lf(this, n, "y", i);
  }
  getCenterPoint(n) {
    const { x: i, y: s } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: i,
      y: s
    };
  }
  size(n) {
    n = n || this.options || {};
    let i = n.radius || 0;
    i = Math.max(i, i && n.hoverRadius || 0);
    const s = i && n.borderWidth || 0;
    return (i + s) * 2;
  }
  draw(n, i) {
    const s = this.options;
    this.skip || s.radius < 0.1 || !Qn(this, i, this.size(s) / 2) || (n.strokeStyle = s.borderColor, n.lineWidth = s.borderWidth, n.fillStyle = s.backgroundColor, Cu(n, s, this.x, this.y));
  }
  getRange() {
    const n = this.options || {};
    return n.radius + n.hitRadius;
  }
}
X(Ga, "id", "point"), /**
* @type {any}
*/
X(Ga, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
X(Ga, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function bg(t, e) {
  const { x: n, y: i, base: s, width: r, height: a } = t.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], e);
  let o, l, u, c, d;
  return t.horizontal ? (d = a / 2, o = Math.min(n, s), l = Math.max(n, s), u = i - d, c = i + d) : (d = r / 2, o = n - d, l = n + d, u = Math.min(i, s), c = Math.max(i, s)), {
    left: o,
    top: u,
    right: l,
    bottom: c
  };
}
function bi(t, e, n, i) {
  return t ? 0 : Et(e, n, i);
}
function d_(t, e, n) {
  const i = t.options.borderWidth, s = t.borderSkipped, r = qp(i);
  return {
    t: bi(s.top, r.top, 0, n),
    r: bi(s.right, r.right, 0, e),
    b: bi(s.bottom, r.bottom, 0, n),
    l: bi(s.left, r.left, 0, e)
  };
}
function f_(t, e, n) {
  const { enableBorderRadius: i } = t.getProps([
    "enableBorderRadius"
  ]), s = t.options.borderRadius, r = ki(s), a = Math.min(e, n), o = t.borderSkipped, l = i || Ae(s);
  return {
    topLeft: bi(!l || o.top || o.left, r.topLeft, 0, a),
    topRight: bi(!l || o.top || o.right, r.topRight, 0, a),
    bottomLeft: bi(!l || o.bottom || o.left, r.bottomLeft, 0, a),
    bottomRight: bi(!l || o.bottom || o.right, r.bottomRight, 0, a)
  };
}
function h_(t) {
  const e = bg(t), n = e.right - e.left, i = e.bottom - e.top, s = d_(t, n / 2, i / 2), r = f_(t, n / 2, i / 2);
  return {
    outer: {
      x: e.left,
      y: e.top,
      w: n,
      h: i,
      radius: r
    },
    inner: {
      x: e.left + s.l,
      y: e.top + s.t,
      w: n - s.l - s.r,
      h: i - s.t - s.b,
      radius: {
        topLeft: Math.max(0, r.topLeft - Math.max(s.t, s.l)),
        topRight: Math.max(0, r.topRight - Math.max(s.t, s.r)),
        bottomLeft: Math.max(0, r.bottomLeft - Math.max(s.b, s.l)),
        bottomRight: Math.max(0, r.bottomRight - Math.max(s.b, s.r))
      }
    }
  };
}
function ul(t, e, n, i) {
  const s = e === null, r = n === null, o = t && !(s && r) && bg(t, i);
  return o && (s || Zn(e, o.left, o.right)) && (r || Zn(n, o.top, o.bottom));
}
function m_(t) {
  return t.topLeft || t.topRight || t.bottomLeft || t.bottomRight;
}
function p_(t, e) {
  t.rect(e.x, e.y, e.w, e.h);
}
function cl(t, e, n = {}) {
  const i = t.x !== n.x ? -e : 0, s = t.y !== n.y ? -e : 0, r = (t.x + t.w !== n.x + n.w ? e : 0) - i, a = (t.y + t.h !== n.y + n.h ? e : 0) - s;
  return {
    x: t.x + i,
    y: t.y + s,
    w: t.w + r,
    h: t.h + a,
    radius: t.radius
  };
}
class Za extends Ht {
  constructor(e) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, e && Object.assign(this, e);
  }
  draw(e) {
    const { inflateAmount: n, options: { borderColor: i, backgroundColor: s } } = this, { inner: r, outer: a } = h_(this), o = m_(a.radius) ? Hs : p_;
    e.save(), (a.w !== r.w || a.h !== r.h) && (e.beginPath(), o(e, cl(a, n, r)), e.clip(), o(e, cl(r, -n, a)), e.fillStyle = i, e.fill("evenodd")), e.beginPath(), o(e, cl(r, n)), e.fillStyle = s, e.fill(), e.restore();
  }
  inRange(e, n, i) {
    return ul(this, e, n, i);
  }
  inXRange(e, n) {
    return ul(this, e, null, n);
  }
  inYRange(e, n) {
    return ul(this, null, e, n);
  }
  getCenterPoint(e) {
    const { x: n, y: i, base: s, horizontal: r } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], e);
    return {
      x: r ? (n + s) / 2 : n,
      y: r ? i : (i + s) / 2
    };
  }
  getRange(e) {
    return e === "x" ? this.width / 2 : this.height / 2;
  }
}
X(Za, "id", "bar"), X(Za, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), X(Za, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
var g_ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement: kr,
  BarElement: Za,
  LineElement: vi,
  PointElement: Ga
});
const Iu = [
  "rgb(54, 162, 235)",
  "rgb(255, 99, 132)",
  "rgb(255, 159, 64)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)"
  // grey
], If = /* @__PURE__ */ Iu.map((t) => t.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function wg(t) {
  return Iu[t % Iu.length];
}
function xg(t) {
  return If[t % If.length];
}
function y_(t, e) {
  return t.borderColor = wg(e), t.backgroundColor = xg(e), ++e;
}
function v_(t, e) {
  return t.backgroundColor = t.data.map(() => wg(e++)), e;
}
function b_(t, e) {
  return t.backgroundColor = t.data.map(() => xg(e++)), e;
}
function w_(t) {
  let e = 0;
  return (n, i) => {
    const s = t.getDatasetMeta(i).controller;
    s instanceof yi ? e = v_(n, e) : s instanceof Rr ? e = b_(n, e) : s && (e = y_(n, e));
  };
}
function Ff(t) {
  let e;
  for (e in t)
    if (t[e].borderColor || t[e].backgroundColor)
      return !0;
  return !1;
}
function x_(t) {
  return t && (t.borderColor || t.backgroundColor);
}
function __() {
  return at.borderColor !== "rgba(0,0,0,0.1)" || at.backgroundColor !== "rgba(0,0,0,0.1)";
}
var k_ = {
  id: "colors",
  defaults: {
    enabled: !0,
    forceOverride: !1
  },
  beforeLayout(t, e, n) {
    if (!n.enabled)
      return;
    const { data: { datasets: i }, options: s } = t.config, { elements: r } = s, a = Ff(i) || x_(s) || r && Ff(r) || __();
    if (!n.forceOverride && a)
      return;
    const o = w_(t);
    i.forEach(o);
  }
};
function M_(t, e, n, i, s) {
  const r = s.samples || i;
  if (r >= n)
    return t.slice(e, e + n);
  const a = [], o = (n - 2) / (r - 2);
  let l = 0;
  const u = e + n - 1;
  let c = e, d, f, h, m, p;
  for (a[l++] = t[c], d = 0; d < r - 2; d++) {
    let g = 0, y = 0, v;
    const b = Math.floor((d + 1) * o) + 1 + e, _ = Math.min(Math.floor((d + 2) * o) + 1, n) + e, M = _ - b;
    for (v = b; v < _; v++)
      g += t[v].x, y += t[v].y;
    g /= M, y /= M;
    const A = Math.floor(d * o) + 1 + e, E = Math.min(Math.floor((d + 1) * o) + 1, n) + e, { x: I, y: S } = t[c];
    for (h = m = -1, v = A; v < E; v++)
      m = 0.5 * Math.abs((I - g) * (t[v].y - S) - (I - t[v].x) * (y - S)), m > h && (h = m, f = t[v], p = v);
    a[l++] = f, c = p;
  }
  return a[l++] = t[u], a;
}
function S_(t, e, n, i) {
  let s = 0, r = 0, a, o, l, u, c, d, f, h, m, p;
  const g = [], y = e + n - 1, v = t[e].x, _ = t[y].x - v;
  for (a = e; a < e + n; ++a) {
    o = t[a], l = (o.x - v) / _ * i, u = o.y;
    const M = l | 0;
    if (M === c)
      u < m ? (m = u, d = a) : u > p && (p = u, f = a), s = (r * s + o.x) / ++r;
    else {
      const A = a - 1;
      if (!Ie(d) && !Ie(f)) {
        const E = Math.min(d, f), I = Math.max(d, f);
        E !== h && E !== A && g.push({
          ...t[E],
          x: s
        }), I !== h && I !== A && g.push({
          ...t[I],
          x: s
        });
      }
      a > 0 && A !== h && g.push(t[A]), g.push(o), c = M, r = 0, m = p = u, d = f = h = a;
    }
  }
  return g;
}
function _g(t) {
  if (t._decimated) {
    const e = t._data;
    delete t._decimated, delete t._data, Object.defineProperty(t, "data", {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: e
    });
  }
}
function Vf(t) {
  t.data.datasets.forEach((e) => {
    _g(e);
  });
}
function O_(t, e) {
  const n = e.length;
  let i = 0, s;
  const { iScale: r } = t, { min: a, max: o, minDefined: l, maxDefined: u } = r.getUserBounds();
  return l && (i = Et(Kn(e, r.axis, a).lo, 0, n - 1)), u ? s = Et(Kn(e, r.axis, o).hi + 1, i, n) - i : s = n - i, {
    start: i,
    count: s
  };
}
var D_ = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: !1
  },
  beforeElementsUpdate: (t, e, n) => {
    if (!n.enabled) {
      Vf(t);
      return;
    }
    const i = t.width;
    t.data.datasets.forEach((s, r) => {
      const { _data: a, indexAxis: o } = s, l = t.getDatasetMeta(r), u = a || s.data;
      if (xr([
        o,
        t.options.indexAxis
      ]) === "y" || !l.controller.supportsDecimation)
        return;
      const c = t.scales[l.xAxisID];
      if (c.type !== "linear" && c.type !== "time" || t.options.parsing)
        return;
      let { start: d, count: f } = O_(l, u);
      const h = n.threshold || 4 * i;
      if (f <= h) {
        _g(s);
        return;
      }
      Ie(a) && (s._data = u, delete s.data, Object.defineProperty(s, "data", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return this._decimated;
        },
        set: function(p) {
          this._data = p;
        }
      }));
      let m;
      switch (n.algorithm) {
        case "lttb":
          m = M_(u, d, f, i, n);
          break;
        case "min-max":
          m = S_(u, d, f, i);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${n.algorithm}'`);
      }
      s._decimated = m;
    });
  },
  destroy(t) {
    Vf(t);
  }
};
function T_(t, e, n) {
  const i = t.segments, s = t.points, r = e.points, a = [];
  for (const o of i) {
    let { start: l, end: u } = o;
    u = qc(l, u, s);
    const c = Fu(n, s[l], s[u], o.loop);
    if (!e.segments) {
      a.push({
        source: o,
        target: c,
        start: s[l],
        end: s[u]
      });
      continue;
    }
    const d = ig(e, c);
    for (const f of d) {
      const h = Fu(n, r[f.start], r[f.end], f.loop), m = ng(o, s, h);
      for (const p of m)
        a.push({
          source: p,
          target: f,
          start: {
            [n]: Nf(c, h, "start", Math.max)
          },
          end: {
            [n]: Nf(c, h, "end", Math.min)
          }
        });
    }
  }
  return a;
}
function Fu(t, e, n, i) {
  if (i)
    return;
  let s = e[t], r = n[t];
  return t === "angle" && (s = nn(s), r = nn(r)), {
    property: t,
    start: s,
    end: r
  };
}
function P_(t, e) {
  const { x: n = null, y: i = null } = t || {}, s = e.points, r = [];
  return e.segments.forEach(({ start: a, end: o }) => {
    o = qc(a, o, s);
    const l = s[a], u = s[o];
    i !== null ? (r.push({
      x: l.x,
      y: i
    }), r.push({
      x: u.x,
      y: i
    })) : n !== null && (r.push({
      x: n,
      y: l.y
    }), r.push({
      x: n,
      y: u.y
    }));
  }), r;
}
function qc(t, e, n) {
  for (; e > t; e--) {
    const i = n[e];
    if (!isNaN(i.x) && !isNaN(i.y))
      break;
  }
  return e;
}
function Nf(t, e, n, i) {
  return t && e ? i(t[n], e[n]) : t ? t[n] : e ? e[n] : 0;
}
function kg(t, e) {
  let n = [], i = !1;
  return Ue(t) ? (i = !0, n = t) : n = P_(t, e), n.length ? new vi({
    points: n,
    options: {
      tension: 0
    },
    _loop: i,
    _fullLoop: i
  }) : null;
}
function Bf(t) {
  return t && t.fill !== !1;
}
function C_(t, e, n) {
  let s = t[e].fill;
  const r = [
    e
  ];
  let a;
  if (!n)
    return s;
  for (; s !== !1 && r.indexOf(s) === -1; ) {
    if (!ot(s))
      return s;
    if (a = t[s], !a)
      return !1;
    if (a.visible)
      return s;
    r.push(s), s = a.fill;
  }
  return !1;
}
function A_(t, e, n) {
  const i = L_(t);
  if (Ae(i))
    return isNaN(i.value) ? !1 : i;
  let s = parseFloat(i);
  return ot(s) && Math.floor(s) === s ? E_(i[0], e, s, n) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(i) >= 0 && i;
}
function E_(t, e, n, i) {
  return (t === "-" || t === "+") && (n = e + n), n === e || n < 0 || n >= i ? !1 : n;
}
function $_(t, e) {
  let n = null;
  return t === "start" ? n = e.bottom : t === "end" ? n = e.top : Ae(t) ? n = e.getPixelForValue(t.value) : e.getBasePixel && (n = e.getBasePixel()), n;
}
function R_(t, e, n) {
  let i;
  return t === "start" ? i = n : t === "end" ? i = e.options.reverse ? e.min : e.max : Ae(t) ? i = t.value : i = e.getBaseValue(), i;
}
function L_(t) {
  const e = t.options, n = e.fill;
  let i = De(n && n.target, n);
  return i === void 0 && (i = !!e.backgroundColor), i === !1 || i === null ? !1 : i === !0 ? "origin" : i;
}
function I_(t) {
  const { scale: e, index: n, line: i } = t, s = [], r = i.segments, a = i.points, o = F_(e, n);
  o.push(kg({
    x: null,
    y: e.bottom
  }, i));
  for (let l = 0; l < r.length; l++) {
    const u = r[l];
    for (let c = u.start; c <= u.end; c++)
      V_(s, a[c], o);
  }
  return new vi({
    points: s,
    options: {}
  });
}
function F_(t, e) {
  const n = [], i = t.getMatchingVisibleMetas("line");
  for (let s = 0; s < i.length; s++) {
    const r = i[s];
    if (r.index === e)
      break;
    r.hidden || n.unshift(r.dataset);
  }
  return n;
}
function V_(t, e, n) {
  const i = [];
  for (let s = 0; s < n.length; s++) {
    const r = n[s], { first: a, last: o, point: l } = N_(r, e, "x");
    if (!(!l || a && o)) {
      if (a)
        i.unshift(l);
      else if (t.push(l), !o)
        break;
    }
  }
  t.push(...i);
}
function N_(t, e, n) {
  const i = t.interpolate(e, n);
  if (!i)
    return {};
  const s = i[n], r = t.segments, a = t.points;
  let o = !1, l = !1;
  for (let u = 0; u < r.length; u++) {
    const c = r[u], d = a[c.start][n], f = a[c.end][n];
    if (Zn(s, d, f)) {
      o = s === d, l = s === f;
      break;
    }
  }
  return {
    first: o,
    last: l,
    point: i
  };
}
class Mg {
  constructor(e) {
    this.x = e.x, this.y = e.y, this.radius = e.radius;
  }
  pathSegment(e, n, i) {
    const { x: s, y: r, radius: a } = this;
    return n = n || {
      start: 0,
      end: nt
    }, e.arc(s, r, a, n.end, n.start, !0), !i.bounds;
  }
  interpolate(e) {
    const { x: n, y: i, radius: s } = this, r = e.angle;
    return {
      x: n + Math.cos(r) * s,
      y: i + Math.sin(r) * s,
      angle: r
    };
  }
}
function B_(t) {
  const { chart: e, fill: n, line: i } = t;
  if (ot(n))
    return z_(e, n);
  if (n === "stack")
    return I_(t);
  if (n === "shape")
    return !0;
  const s = W_(t);
  return s instanceof Mg ? s : kg(s, i);
}
function z_(t, e) {
  const n = t.getDatasetMeta(e);
  return n && t.isDatasetVisible(e) ? n.dataset : null;
}
function W_(t) {
  return (t.scale || {}).getPointPositionForValue ? Y_(t) : H_(t);
}
function H_(t) {
  const { scale: e = {}, fill: n } = t, i = $_(n, e);
  if (ot(i)) {
    const s = e.isHorizontal();
    return {
      x: s ? i : null,
      y: s ? null : i
    };
  }
  return null;
}
function Y_(t) {
  const { scale: e, fill: n } = t, i = e.options, s = e.getLabels().length, r = i.reverse ? e.max : e.min, a = R_(n, e, r), o = [];
  if (i.grid.circular) {
    const l = e.getPointPositionForValue(0, r);
    return new Mg({
      x: l.x,
      y: l.y,
      radius: e.getDistanceFromCenterForValue(a)
    });
  }
  for (let l = 0; l < s; ++l)
    o.push(e.getPointPositionForValue(l, a));
  return o;
}
function dl(t, e, n) {
  const i = B_(e), { chart: s, index: r, line: a, scale: o, axis: l } = e, u = a.options, c = u.fill, d = u.backgroundColor, { above: f = d, below: h = d } = c || {}, m = s.getDatasetMeta(r), p = sg(s, m);
  i && a.points.length && (na(t, n), j_(t, {
    line: a,
    target: i,
    above: f,
    below: h,
    area: n,
    scale: o,
    axis: l,
    clip: p
  }), ia(t));
}
function j_(t, e) {
  const { line: n, target: i, above: s, below: r, area: a, scale: o, clip: l } = e, u = n._loop ? "angle" : e.axis;
  t.save(), u === "x" && r !== s && (zf(t, i, a.top), Wf(t, {
    line: n,
    target: i,
    color: s,
    scale: o,
    property: u,
    clip: l
  }), t.restore(), t.save(), zf(t, i, a.bottom)), Wf(t, {
    line: n,
    target: i,
    color: r,
    scale: o,
    property: u,
    clip: l
  }), t.restore();
}
function zf(t, e, n) {
  const { segments: i, points: s } = e;
  let r = !0, a = !1;
  t.beginPath();
  for (const o of i) {
    const { start: l, end: u } = o, c = s[l], d = s[qc(l, u, s)];
    r ? (t.moveTo(c.x, c.y), r = !1) : (t.lineTo(c.x, n), t.lineTo(c.x, c.y)), a = !!e.pathSegment(t, o, {
      move: a
    }), a ? t.closePath() : t.lineTo(d.x, n);
  }
  t.lineTo(e.first().x, n), t.closePath(), t.clip();
}
function Wf(t, e) {
  const { line: n, target: i, property: s, color: r, scale: a, clip: o } = e, l = T_(n, i, s);
  for (const { source: u, target: c, start: d, end: f } of l) {
    const { style: { backgroundColor: h = r } = {} } = u, m = i !== !0;
    t.save(), t.fillStyle = h, q_(t, a, o, m && Fu(s, d, f)), t.beginPath();
    const p = !!n.pathSegment(t, u);
    let g;
    if (m) {
      p ? t.closePath() : Hf(t, i, f, s);
      const y = !!i.pathSegment(t, c, {
        move: p,
        reverse: !0
      });
      g = p && y, g || Hf(t, i, d, s);
    }
    t.closePath(), t.fill(g ? "evenodd" : "nonzero"), t.restore();
  }
}
function q_(t, e, n, i) {
  const s = e.chart.chartArea, { property: r, start: a, end: o } = i || {};
  if (r === "x" || r === "y") {
    let l, u, c, d;
    r === "x" ? (l = a, u = s.top, c = o, d = s.bottom) : (l = s.left, u = a, c = s.right, d = o), t.beginPath(), n && (l = Math.max(l, n.left), c = Math.min(c, n.right), u = Math.max(u, n.top), d = Math.min(d, n.bottom)), t.rect(l, u, c - l, d - u), t.clip();
  }
}
function Hf(t, e, n, i) {
  const s = e.interpolate(n, i);
  s && t.lineTo(s.x, s.y);
}
var U_ = {
  id: "filler",
  afterDatasetsUpdate(t, e, n) {
    const i = (t.data.datasets || []).length, s = [];
    let r, a, o, l;
    for (a = 0; a < i; ++a)
      r = t.getDatasetMeta(a), o = r.dataset, l = null, o && o.options && o instanceof vi && (l = {
        visible: t.isDatasetVisible(a),
        index: a,
        fill: A_(o, a, i),
        chart: t,
        axis: r.controller.options.indexAxis,
        scale: r.vScale,
        line: o
      }), r.$filler = l, s.push(l);
    for (a = 0; a < i; ++a)
      l = s[a], !(!l || l.fill === !1) && (l.fill = C_(s, a, n.propagate));
  },
  beforeDraw(t, e, n) {
    const i = n.drawTime === "beforeDraw", s = t.getSortedVisibleDatasetMetas(), r = t.chartArea;
    for (let a = s.length - 1; a >= 0; --a) {
      const o = s[a].$filler;
      o && (o.line.updateControlPoints(r, o.axis), i && o.fill && dl(t.ctx, o, r));
    }
  },
  beforeDatasetsDraw(t, e, n) {
    if (n.drawTime !== "beforeDatasetsDraw")
      return;
    const i = t.getSortedVisibleDatasetMetas();
    for (let s = i.length - 1; s >= 0; --s) {
      const r = i[s].$filler;
      Bf(r) && dl(t.ctx, r, t.chartArea);
    }
  },
  beforeDatasetDraw(t, e, n) {
    const i = e.meta.$filler;
    !Bf(i) || n.drawTime !== "beforeDatasetDraw" || dl(t.ctx, i, t.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const Yf = (t, e) => {
  let { boxHeight: n = e, boxWidth: i = e } = t;
  return t.usePointStyle && (n = Math.min(n, e), i = t.pointStyleWidth || Math.min(i, e)), {
    boxWidth: i,
    boxHeight: n,
    itemHeight: Math.max(e, n)
  };
}, X_ = (t, e) => t !== null && e !== null && t.datasetIndex === e.datasetIndex && t.index === e.index;
class jf extends Ht {
  constructor(e) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(e, n, i) {
    this.maxWidth = e, this.maxHeight = n, this._margins = i, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const e = this.options.labels || {};
    let n = Ze(e.generateLabels, [
      this.chart
    ], this) || [];
    e.filter && (n = n.filter((i) => e.filter(i, this.chart.data))), e.sort && (n = n.sort((i, s) => e.sort(i, s, this.chart.data))), this.options.reverse && n.reverse(), this.legendItems = n;
  }
  fit() {
    const { options: e, ctx: n } = this;
    if (!e.display) {
      this.width = this.height = 0;
      return;
    }
    const i = e.labels, s = mt(i.font), r = s.size, a = this._computeTitleHeight(), { boxWidth: o, itemHeight: l } = Yf(i, r);
    let u, c;
    n.font = s.string, this.isHorizontal() ? (u = this.maxWidth, c = this._fitRows(a, r, o, l) + 10) : (c = this.maxHeight, u = this._fitCols(a, s, o, l) + 10), this.width = Math.min(u, e.maxWidth || this.maxWidth), this.height = Math.min(c, e.maxHeight || this.maxHeight);
  }
  _fitRows(e, n, i, s) {
    const { ctx: r, maxWidth: a, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], u = this.lineWidths = [
      0
    ], c = s + o;
    let d = e;
    r.textAlign = "left", r.textBaseline = "middle";
    let f = -1, h = -c;
    return this.legendItems.forEach((m, p) => {
      const g = i + n / 2 + r.measureText(m.text).width;
      (p === 0 || u[u.length - 1] + g + 2 * o > a) && (d += c, u[u.length - (p > 0 ? 0 : 1)] = 0, h += c, f++), l[p] = {
        left: 0,
        top: h,
        row: f,
        width: g,
        height: s
      }, u[u.length - 1] += g + o;
    }), d;
  }
  _fitCols(e, n, i, s) {
    const { ctx: r, maxHeight: a, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], u = this.columnSizes = [], c = a - e;
    let d = o, f = 0, h = 0, m = 0, p = 0;
    return this.legendItems.forEach((g, y) => {
      const { itemWidth: v, itemHeight: b } = G_(i, n, r, g, s);
      y > 0 && h + b + 2 * o > c && (d += f + o, u.push({
        width: f,
        height: h
      }), m += f + o, p++, f = h = 0), l[y] = {
        left: m,
        top: h,
        col: p,
        width: v,
        height: b
      }, f = Math.max(f, v), h += b + o;
    }), d += f, u.push({
      width: f,
      height: h
    }), d;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const e = this._computeTitleHeight(), { legendHitBoxes: n, options: { align: i, labels: { padding: s }, rtl: r } } = this, a = $s(r, this.left, this.width);
    if (this.isHorizontal()) {
      let o = 0, l = Vt(i, this.left + s, this.right - this.lineWidths[o]);
      for (const u of n)
        o !== u.row && (o = u.row, l = Vt(i, this.left + s, this.right - this.lineWidths[o])), u.top += this.top + e + s, u.left = a.leftForLtr(a.x(l), u.width), l += u.width + s;
    } else {
      let o = 0, l = Vt(i, this.top + e + s, this.bottom - this.columnSizes[o].height);
      for (const u of n)
        u.col !== o && (o = u.col, l = Vt(i, this.top + e + s, this.bottom - this.columnSizes[o].height)), u.top = l, u.left += this.left + s, u.left = a.leftForLtr(a.x(u.left), u.width), l += u.height + s;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const e = this.ctx;
      na(e, this), this._draw(), ia(e);
    }
  }
  _draw() {
    const { options: e, columnSizes: n, lineWidths: i, ctx: s } = this, { align: r, labels: a } = e, o = at.color, l = $s(e.rtl, this.left, this.width), u = mt(a.font), { padding: c } = a, d = u.size, f = d / 2;
    let h;
    this.drawTitle(), s.textAlign = l.textAlign("left"), s.textBaseline = "middle", s.lineWidth = 0.5, s.font = u.string;
    const { boxWidth: m, boxHeight: p, itemHeight: g } = Yf(a, d), y = function(A, E, I) {
      if (isNaN(m) || m <= 0 || isNaN(p) || p < 0)
        return;
      s.save();
      const S = De(I.lineWidth, 1);
      if (s.fillStyle = De(I.fillStyle, o), s.lineCap = De(I.lineCap, "butt"), s.lineDashOffset = De(I.lineDashOffset, 0), s.lineJoin = De(I.lineJoin, "miter"), s.lineWidth = S, s.strokeStyle = De(I.strokeStyle, o), s.setLineDash(De(I.lineDash, [])), a.usePointStyle) {
        const $ = {
          radius: p * Math.SQRT2 / 2,
          pointStyle: I.pointStyle,
          rotation: I.rotation,
          borderWidth: S
        }, B = l.xPlus(A, m / 2), V = E + f;
        jp(s, $, B, V, a.pointStyleWidth && m);
      } else {
        const $ = E + Math.max((d - p) / 2, 0), B = l.leftForLtr(A, m), V = ki(I.borderRadius);
        s.beginPath(), Object.values(V).some((G) => G !== 0) ? Hs(s, {
          x: B,
          y: $,
          w: m,
          h: p,
          radius: V
        }) : s.rect(B, $, m, p), s.fill(), S !== 0 && s.stroke();
      }
      s.restore();
    }, v = function(A, E, I) {
      rs(s, I.text, A, E + g / 2, u, {
        strikethrough: I.hidden,
        textAlign: l.textAlign(I.textAlign)
      });
    }, b = this.isHorizontal(), _ = this._computeTitleHeight();
    b ? h = {
      x: Vt(r, this.left + c, this.right - i[0]),
      y: this.top + c + _,
      line: 0
    } : h = {
      x: this.left + c,
      y: Vt(r, this.top + _ + c, this.bottom - n[0].height),
      line: 0
    }, Jp(this.ctx, e.textDirection);
    const M = g + c;
    this.legendItems.forEach((A, E) => {
      s.strokeStyle = A.fontColor, s.fillStyle = A.fontColor;
      const I = s.measureText(A.text).width, S = l.textAlign(A.textAlign || (A.textAlign = a.textAlign)), $ = m + f + I;
      let B = h.x, V = h.y;
      l.setWidth(this.width), b ? E > 0 && B + $ + c > this.right && (V = h.y += M, h.line++, B = h.x = Vt(r, this.left + c, this.right - i[h.line])) : E > 0 && V + M > this.bottom && (B = h.x = B + n[h.line].width + c, h.line++, V = h.y = Vt(r, this.top + _ + c, this.bottom - n[h.line].height));
      const G = l.x(B);
      if (y(G, V, A), B = yw(S, B + m + f, b ? B + $ : this.right, e.rtl), v(l.x(B), V, A), b)
        h.x += $ + c;
      else if (typeof A.text != "string") {
        const P = u.lineHeight;
        h.y += Sg(A, P) + c;
      } else
        h.y += M;
    }), eg(this.ctx, e.textDirection);
  }
  drawTitle() {
    const e = this.options, n = e.title, i = mt(n.font), s = Ot(n.padding);
    if (!n.display)
      return;
    const r = $s(e.rtl, this.left, this.width), a = this.ctx, o = n.position, l = i.size / 2, u = s.top + l;
    let c, d = this.left, f = this.width;
    if (this.isHorizontal())
      f = Math.max(...this.lineWidths), c = this.top + u, d = Vt(e.align, d, this.right - f);
    else {
      const m = this.columnSizes.reduce((p, g) => Math.max(p, g.height), 0);
      c = u + Vt(e.align, this.top, this.bottom - m - e.labels.padding - this._computeTitleHeight());
    }
    const h = Vt(o, d, d + f);
    a.textAlign = r.textAlign(Ic(o)), a.textBaseline = "middle", a.strokeStyle = n.color, a.fillStyle = n.color, a.font = i.string, rs(a, n.text, h, c, i);
  }
  _computeTitleHeight() {
    const e = this.options.title, n = mt(e.font), i = Ot(e.padding);
    return e.display ? n.lineHeight + i.height : 0;
  }
  _getLegendItemAt(e, n) {
    let i, s, r;
    if (Zn(e, this.left, this.right) && Zn(n, this.top, this.bottom)) {
      for (r = this.legendHitBoxes, i = 0; i < r.length; ++i)
        if (s = r[i], Zn(e, s.left, s.left + s.width) && Zn(n, s.top, s.top + s.height))
          return this.legendItems[i];
    }
    return null;
  }
  handleEvent(e) {
    const n = this.options;
    if (!Q_(e.type, n))
      return;
    const i = this._getLegendItemAt(e.x, e.y);
    if (e.type === "mousemove" || e.type === "mouseout") {
      const s = this._hoveredItem, r = X_(s, i);
      s && !r && Ze(n.onLeave, [
        e,
        s,
        this
      ], this), this._hoveredItem = i, i && !r && Ze(n.onHover, [
        e,
        i,
        this
      ], this);
    } else i && Ze(n.onClick, [
      e,
      i,
      this
    ], this);
  }
}
function G_(t, e, n, i, s) {
  const r = Z_(i, t, e, n), a = K_(s, i, e.lineHeight);
  return {
    itemWidth: r,
    itemHeight: a
  };
}
function Z_(t, e, n, i) {
  let s = t.text;
  return s && typeof s != "string" && (s = s.reduce((r, a) => r.length > a.length ? r : a)), e + n.size / 2 + i.measureText(s).width;
}
function K_(t, e, n) {
  let i = t;
  return typeof e.text != "string" && (i = Sg(e, n)), i;
}
function Sg(t, e) {
  const n = t.text ? t.text.length : 0;
  return e * n;
}
function Q_(t, e) {
  return !!((t === "mousemove" || t === "mouseout") && (e.onHover || e.onLeave) || e.onClick && (t === "click" || t === "mouseup"));
}
var J_ = {
  id: "legend",
  _element: jf,
  start(t, e, n) {
    const i = t.legend = new jf({
      ctx: t.ctx,
      options: n,
      chart: t
    });
    Wt.configure(t, i, n), Wt.addBox(t, i);
  },
  stop(t) {
    Wt.removeBox(t, t.legend), delete t.legend;
  },
  beforeUpdate(t, e, n) {
    const i = t.legend;
    Wt.configure(t, i, n), i.options = n;
  },
  afterUpdate(t) {
    const e = t.legend;
    e.buildLabels(), e.adjustHitBoxes();
  },
  afterEvent(t, e) {
    e.replay || t.legend.handleEvent(e.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(t, e, n) {
      const i = e.datasetIndex, s = n.chart;
      s.isDatasetVisible(i) ? (s.hide(i), e.hidden = !0) : (s.show(i), e.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (t) => t.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(t) {
        const e = t.data.datasets, { labels: { usePointStyle: n, pointStyle: i, textAlign: s, color: r, useBorderRadius: a, borderRadius: o } } = t.legend.options;
        return t._getSortedDatasetMetas().map((l) => {
          const u = l.controller.getStyle(n ? 0 : void 0), c = Ot(u.borderWidth);
          return {
            text: e[l.index].label,
            fillStyle: u.backgroundColor,
            fontColor: r,
            hidden: !l.visible,
            lineCap: u.borderCapStyle,
            lineDash: u.borderDash,
            lineDashOffset: u.borderDashOffset,
            lineJoin: u.borderJoinStyle,
            lineWidth: (c.width + c.height) / 4,
            strokeStyle: u.borderColor,
            pointStyle: i || u.pointStyle,
            rotation: u.rotation,
            textAlign: s || u.textAlign,
            borderRadius: a && (o || u.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (t) => t.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (t) => !t.startsWith("on"),
    labels: {
      _scriptable: (t) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(t)
    }
  }
};
class Uc extends Ht {
  constructor(e) {
    super(), this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(e, n) {
    const i = this.options;
    if (this.left = 0, this.top = 0, !i.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = e, this.height = this.bottom = n;
    const s = Ue(i.text) ? i.text.length : 1;
    this._padding = Ot(i.padding);
    const r = s * mt(i.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = r : this.width = r;
  }
  isHorizontal() {
    const e = this.options.position;
    return e === "top" || e === "bottom";
  }
  _drawArgs(e) {
    const { top: n, left: i, bottom: s, right: r, options: a } = this, o = a.align;
    let l = 0, u, c, d;
    return this.isHorizontal() ? (c = Vt(o, i, r), d = n + e, u = r - i) : (a.position === "left" ? (c = i + e, d = Vt(o, s, n), l = Ne * -0.5) : (c = r - e, d = Vt(o, n, s), l = Ne * 0.5), u = s - n), {
      titleX: c,
      titleY: d,
      maxWidth: u,
      rotation: l
    };
  }
  draw() {
    const e = this.ctx, n = this.options;
    if (!n.display)
      return;
    const i = mt(n.font), r = i.lineHeight / 2 + this._padding.top, { titleX: a, titleY: o, maxWidth: l, rotation: u } = this._drawArgs(r);
    rs(e, n.text, 0, 0, i, {
      color: n.color,
      maxWidth: l,
      rotation: u,
      textAlign: Ic(n.align),
      textBaseline: "middle",
      translation: [
        a,
        o
      ]
    });
  }
}
function ek(t, e) {
  const n = new Uc({
    ctx: t.ctx,
    options: e,
    chart: t
  });
  Wt.configure(t, n, e), Wt.addBox(t, n), t.titleBlock = n;
}
var tk = {
  id: "title",
  _element: Uc,
  start(t, e, n) {
    ek(t, n);
  },
  stop(t) {
    const e = t.titleBlock;
    Wt.removeBox(t, e), delete t.titleBlock;
  },
  beforeUpdate(t, e, n) {
    const i = t.titleBlock;
    Wt.configure(t, i, n), i.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Pa = /* @__PURE__ */ new WeakMap();
var nk = {
  id: "subtitle",
  start(t, e, n) {
    const i = new Uc({
      ctx: t.ctx,
      options: n,
      chart: t
    });
    Wt.configure(t, i, n), Wt.addBox(t, i), Pa.set(t, i);
  },
  stop(t) {
    Wt.removeBox(t, Pa.get(t)), Pa.delete(t);
  },
  beforeUpdate(t, e, n) {
    const i = Pa.get(t);
    Wt.configure(t, i, n), i.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "normal"
    },
    fullSize: !0,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Mr = {
  average(t) {
    if (!t.length)
      return !1;
    let e, n, i = /* @__PURE__ */ new Set(), s = 0, r = 0;
    for (e = 0, n = t.length; e < n; ++e) {
      const o = t[e].element;
      if (o && o.hasValue()) {
        const l = o.tooltipPosition();
        i.add(l.x), s += l.y, ++r;
      }
    }
    return r === 0 || i.size === 0 ? !1 : {
      x: [
        ...i
      ].reduce((o, l) => o + l) / i.size,
      y: s / r
    };
  },
  nearest(t, e) {
    if (!t.length)
      return !1;
    let n = e.x, i = e.y, s = Number.POSITIVE_INFINITY, r, a, o;
    for (r = 0, a = t.length; r < a; ++r) {
      const l = t[r].element;
      if (l && l.hasValue()) {
        const u = l.getCenterPoint(), c = Ws(e, u);
        c < s && (s = c, o = l);
      }
    }
    if (o) {
      const l = o.tooltipPosition();
      n = l.x, i = l.y;
    }
    return {
      x: n,
      y: i
    };
  }
};
function En(t, e) {
  return e && (Ue(e) ? Array.prototype.push.apply(t, e) : t.push(e)), t;
}
function Un(t) {
  return (typeof t == "string" || t instanceof String) && t.indexOf(`
`) > -1 ? t.split(`
`) : t;
}
function ik(t, e) {
  const { element: n, datasetIndex: i, index: s } = e, r = t.getDatasetMeta(i).controller, { label: a, value: o } = r.getLabelAndValue(s);
  return {
    chart: t,
    label: a,
    parsed: r.getParsed(s),
    raw: t.data.datasets[i].data[s],
    formattedValue: o,
    dataset: r.getDataset(),
    dataIndex: s,
    datasetIndex: i,
    element: n
  };
}
function qf(t, e) {
  const n = t.chart.ctx, { body: i, footer: s, title: r } = t, { boxWidth: a, boxHeight: o } = e, l = mt(e.bodyFont), u = mt(e.titleFont), c = mt(e.footerFont), d = r.length, f = s.length, h = i.length, m = Ot(e.padding);
  let p = m.height, g = 0, y = i.reduce((_, M) => _ + M.before.length + M.lines.length + M.after.length, 0);
  if (y += t.beforeBody.length + t.afterBody.length, d && (p += d * u.lineHeight + (d - 1) * e.titleSpacing + e.titleMarginBottom), y) {
    const _ = e.displayColors ? Math.max(o, l.lineHeight) : l.lineHeight;
    p += h * _ + (y - h) * l.lineHeight + (y - 1) * e.bodySpacing;
  }
  f && (p += e.footerMarginTop + f * c.lineHeight + (f - 1) * e.footerSpacing);
  let v = 0;
  const b = function(_) {
    g = Math.max(g, n.measureText(_).width + v);
  };
  return n.save(), n.font = u.string, Ke(t.title, b), n.font = l.string, Ke(t.beforeBody.concat(t.afterBody), b), v = e.displayColors ? a + 2 + e.boxPadding : 0, Ke(i, (_) => {
    Ke(_.before, b), Ke(_.lines, b), Ke(_.after, b);
  }), v = 0, n.font = c.string, Ke(t.footer, b), n.restore(), g += m.width, {
    width: g,
    height: p
  };
}
function sk(t, e) {
  const { y: n, height: i } = e;
  return n < i / 2 ? "top" : n > t.height - i / 2 ? "bottom" : "center";
}
function rk(t, e, n, i) {
  const { x: s, width: r } = i, a = n.caretSize + n.caretPadding;
  if (t === "left" && s + r + a > e.width || t === "right" && s - r - a < 0)
    return !0;
}
function ak(t, e, n, i) {
  const { x: s, width: r } = n, { width: a, chartArea: { left: o, right: l } } = t;
  let u = "center";
  return i === "center" ? u = s <= (o + l) / 2 ? "left" : "right" : s <= r / 2 ? u = "left" : s >= a - r / 2 && (u = "right"), rk(u, t, e, n) && (u = "center"), u;
}
function Uf(t, e, n) {
  const i = n.yAlign || e.yAlign || sk(t, n);
  return {
    xAlign: n.xAlign || e.xAlign || ak(t, e, n, i),
    yAlign: i
  };
}
function ok(t, e) {
  let { x: n, width: i } = t;
  return e === "right" ? n -= i : e === "center" && (n -= i / 2), n;
}
function lk(t, e, n) {
  let { y: i, height: s } = t;
  return e === "top" ? i += n : e === "bottom" ? i -= s + n : i -= s / 2, i;
}
function Xf(t, e, n, i) {
  const { caretSize: s, caretPadding: r, cornerRadius: a } = t, { xAlign: o, yAlign: l } = n, u = s + r, { topLeft: c, topRight: d, bottomLeft: f, bottomRight: h } = ki(a);
  let m = ok(e, o);
  const p = lk(e, l, u);
  return l === "center" ? o === "left" ? m += u : o === "right" && (m -= u) : o === "left" ? m -= Math.max(c, f) + s : o === "right" && (m += Math.max(d, h) + s), {
    x: Et(m, 0, i.width - e.width),
    y: Et(p, 0, i.height - e.height)
  };
}
function Ca(t, e, n) {
  const i = Ot(n.padding);
  return e === "center" ? t.x + t.width / 2 : e === "right" ? t.x + t.width - i.right : t.x + i.left;
}
function Gf(t) {
  return En([], Un(t));
}
function uk(t, e, n) {
  return Li(t, {
    tooltip: e,
    tooltipItems: n,
    type: "tooltip"
  });
}
function Zf(t, e) {
  const n = e && e.dataset && e.dataset.tooltip && e.dataset.tooltip.callbacks;
  return n ? t.override(n) : t;
}
const Og = {
  beforeTitle: jn,
  title(t) {
    if (t.length > 0) {
      const e = t[0], n = e.chart.data.labels, i = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return e.dataset.label || "";
      if (e.label)
        return e.label;
      if (i > 0 && e.dataIndex < i)
        return n[e.dataIndex];
    }
    return "";
  },
  afterTitle: jn,
  beforeBody: jn,
  beforeLabel: jn,
  label(t) {
    if (this && this.options && this.options.mode === "dataset")
      return t.label + ": " + t.formattedValue || t.formattedValue;
    let e = t.dataset.label || "";
    e && (e += ": ");
    const n = t.formattedValue;
    return Ie(n) || (e += n), e;
  },
  labelColor(t) {
    const n = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(t) {
    const n = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: jn,
  afterBody: jn,
  beforeFooter: jn,
  footer: jn,
  afterFooter: jn
};
function Zt(t, e, n, i) {
  const s = t[e].call(n, i);
  return typeof s > "u" ? Og[e].call(n, i) : s;
}
class Vu extends Ht {
  constructor(e) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = e.chart, this.options = e.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(e) {
    this.options = e, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const e = this._cachedAnimations;
    if (e)
      return e;
    const n = this.chart, i = this.options.setContext(this.getContext()), s = i.enabled && n.options.animation && i.animations, r = new Yc(this.chart, s);
    return s._cacheable && (this._cachedAnimations = Object.freeze(r)), r;
  }
  getContext() {
    return this.$context || (this.$context = uk(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(e, n) {
    const { callbacks: i } = n, s = Zt(i, "beforeTitle", this, e), r = Zt(i, "title", this, e), a = Zt(i, "afterTitle", this, e);
    let o = [];
    return o = En(o, Un(s)), o = En(o, Un(r)), o = En(o, Un(a)), o;
  }
  getBeforeBody(e, n) {
    return Gf(Zt(n.callbacks, "beforeBody", this, e));
  }
  getBody(e, n) {
    const { callbacks: i } = n, s = [];
    return Ke(e, (r) => {
      const a = {
        before: [],
        lines: [],
        after: []
      }, o = Zf(i, r);
      En(a.before, Un(Zt(o, "beforeLabel", this, r))), En(a.lines, Zt(o, "label", this, r)), En(a.after, Un(Zt(o, "afterLabel", this, r))), s.push(a);
    }), s;
  }
  getAfterBody(e, n) {
    return Gf(Zt(n.callbacks, "afterBody", this, e));
  }
  getFooter(e, n) {
    const { callbacks: i } = n, s = Zt(i, "beforeFooter", this, e), r = Zt(i, "footer", this, e), a = Zt(i, "afterFooter", this, e);
    let o = [];
    return o = En(o, Un(s)), o = En(o, Un(r)), o = En(o, Un(a)), o;
  }
  _createItems(e) {
    const n = this._active, i = this.chart.data, s = [], r = [], a = [];
    let o = [], l, u;
    for (l = 0, u = n.length; l < u; ++l)
      o.push(ik(this.chart, n[l]));
    return e.filter && (o = o.filter((c, d, f) => e.filter(c, d, f, i))), e.itemSort && (o = o.sort((c, d) => e.itemSort(c, d, i))), Ke(o, (c) => {
      const d = Zf(e.callbacks, c);
      s.push(Zt(d, "labelColor", this, c)), r.push(Zt(d, "labelPointStyle", this, c)), a.push(Zt(d, "labelTextColor", this, c));
    }), this.labelColors = s, this.labelPointStyles = r, this.labelTextColors = a, this.dataPoints = o, o;
  }
  update(e, n) {
    const i = this.options.setContext(this.getContext()), s = this._active;
    let r, a = [];
    if (!s.length)
      this.opacity !== 0 && (r = {
        opacity: 0
      });
    else {
      const o = Mr[i.position].call(this, s, this._eventPosition);
      a = this._createItems(i), this.title = this.getTitle(a, i), this.beforeBody = this.getBeforeBody(a, i), this.body = this.getBody(a, i), this.afterBody = this.getAfterBody(a, i), this.footer = this.getFooter(a, i);
      const l = this._size = qf(this, i), u = Object.assign({}, o, l), c = Uf(this.chart, i, u), d = Xf(i, u, c, this.chart);
      this.xAlign = c.xAlign, this.yAlign = c.yAlign, r = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: l.width,
        height: l.height,
        caretX: o.x,
        caretY: o.y
      };
    }
    this._tooltipItems = a, this.$context = void 0, r && this._resolveAnimations().update(this, r), e && i.external && i.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(e, n, i, s) {
    const r = this.getCaretPosition(e, i, s);
    n.lineTo(r.x1, r.y1), n.lineTo(r.x2, r.y2), n.lineTo(r.x3, r.y3);
  }
  getCaretPosition(e, n, i) {
    const { xAlign: s, yAlign: r } = this, { caretSize: a, cornerRadius: o } = i, { topLeft: l, topRight: u, bottomLeft: c, bottomRight: d } = ki(o), { x: f, y: h } = e, { width: m, height: p } = n;
    let g, y, v, b, _, M;
    return r === "center" ? (_ = h + p / 2, s === "left" ? (g = f, y = g - a, b = _ + a, M = _ - a) : (g = f + m, y = g + a, b = _ - a, M = _ + a), v = g) : (s === "left" ? y = f + Math.max(l, c) + a : s === "right" ? y = f + m - Math.max(u, d) - a : y = this.caretX, r === "top" ? (b = h, _ = b - a, g = y - a, v = y + a) : (b = h + p, _ = b + a, g = y + a, v = y - a), M = b), {
      x1: g,
      x2: y,
      x3: v,
      y1: b,
      y2: _,
      y3: M
    };
  }
  drawTitle(e, n, i) {
    const s = this.title, r = s.length;
    let a, o, l;
    if (r) {
      const u = $s(i.rtl, this.x, this.width);
      for (e.x = Ca(this, i.titleAlign, i), n.textAlign = u.textAlign(i.titleAlign), n.textBaseline = "middle", a = mt(i.titleFont), o = i.titleSpacing, n.fillStyle = i.titleColor, n.font = a.string, l = 0; l < r; ++l)
        n.fillText(s[l], u.x(e.x), e.y + a.lineHeight / 2), e.y += a.lineHeight + o, l + 1 === r && (e.y += i.titleMarginBottom - o);
    }
  }
  _drawColorBox(e, n, i, s, r) {
    const a = this.labelColors[i], o = this.labelPointStyles[i], { boxHeight: l, boxWidth: u } = r, c = mt(r.bodyFont), d = Ca(this, "left", r), f = s.x(d), h = l < c.lineHeight ? (c.lineHeight - l) / 2 : 0, m = n.y + h;
    if (r.usePointStyle) {
      const p = {
        radius: Math.min(u, l) / 2,
        pointStyle: o.pointStyle,
        rotation: o.rotation,
        borderWidth: 1
      }, g = s.leftForLtr(f, u) + u / 2, y = m + l / 2;
      e.strokeStyle = r.multiKeyBackground, e.fillStyle = r.multiKeyBackground, Cu(e, p, g, y), e.strokeStyle = a.borderColor, e.fillStyle = a.backgroundColor, Cu(e, p, g, y);
    } else {
      e.lineWidth = Ae(a.borderWidth) ? Math.max(...Object.values(a.borderWidth)) : a.borderWidth || 1, e.strokeStyle = a.borderColor, e.setLineDash(a.borderDash || []), e.lineDashOffset = a.borderDashOffset || 0;
      const p = s.leftForLtr(f, u), g = s.leftForLtr(s.xPlus(f, 1), u - 2), y = ki(a.borderRadius);
      Object.values(y).some((v) => v !== 0) ? (e.beginPath(), e.fillStyle = r.multiKeyBackground, Hs(e, {
        x: p,
        y: m,
        w: u,
        h: l,
        radius: y
      }), e.fill(), e.stroke(), e.fillStyle = a.backgroundColor, e.beginPath(), Hs(e, {
        x: g,
        y: m + 1,
        w: u - 2,
        h: l - 2,
        radius: y
      }), e.fill()) : (e.fillStyle = r.multiKeyBackground, e.fillRect(p, m, u, l), e.strokeRect(p, m, u, l), e.fillStyle = a.backgroundColor, e.fillRect(g, m + 1, u - 2, l - 2));
    }
    e.fillStyle = this.labelTextColors[i];
  }
  drawBody(e, n, i) {
    const { body: s } = this, { bodySpacing: r, bodyAlign: a, displayColors: o, boxHeight: l, boxWidth: u, boxPadding: c } = i, d = mt(i.bodyFont);
    let f = d.lineHeight, h = 0;
    const m = $s(i.rtl, this.x, this.width), p = function(I) {
      n.fillText(I, m.x(e.x + h), e.y + f / 2), e.y += f + r;
    }, g = m.textAlign(a);
    let y, v, b, _, M, A, E;
    for (n.textAlign = a, n.textBaseline = "middle", n.font = d.string, e.x = Ca(this, g, i), n.fillStyle = i.bodyColor, Ke(this.beforeBody, p), h = o && g !== "right" ? a === "center" ? u / 2 + c : u + 2 + c : 0, _ = 0, A = s.length; _ < A; ++_) {
      for (y = s[_], v = this.labelTextColors[_], n.fillStyle = v, Ke(y.before, p), b = y.lines, o && b.length && (this._drawColorBox(n, e, _, m, i), f = Math.max(d.lineHeight, l)), M = 0, E = b.length; M < E; ++M)
        p(b[M]), f = d.lineHeight;
      Ke(y.after, p);
    }
    h = 0, f = d.lineHeight, Ke(this.afterBody, p), e.y -= r;
  }
  drawFooter(e, n, i) {
    const s = this.footer, r = s.length;
    let a, o;
    if (r) {
      const l = $s(i.rtl, this.x, this.width);
      for (e.x = Ca(this, i.footerAlign, i), e.y += i.footerMarginTop, n.textAlign = l.textAlign(i.footerAlign), n.textBaseline = "middle", a = mt(i.footerFont), n.fillStyle = i.footerColor, n.font = a.string, o = 0; o < r; ++o)
        n.fillText(s[o], l.x(e.x), e.y + a.lineHeight / 2), e.y += a.lineHeight + i.footerSpacing;
    }
  }
  drawBackground(e, n, i, s) {
    const { xAlign: r, yAlign: a } = this, { x: o, y: l } = e, { width: u, height: c } = i, { topLeft: d, topRight: f, bottomLeft: h, bottomRight: m } = ki(s.cornerRadius);
    n.fillStyle = s.backgroundColor, n.strokeStyle = s.borderColor, n.lineWidth = s.borderWidth, n.beginPath(), n.moveTo(o + d, l), a === "top" && this.drawCaret(e, n, i, s), n.lineTo(o + u - f, l), n.quadraticCurveTo(o + u, l, o + u, l + f), a === "center" && r === "right" && this.drawCaret(e, n, i, s), n.lineTo(o + u, l + c - m), n.quadraticCurveTo(o + u, l + c, o + u - m, l + c), a === "bottom" && this.drawCaret(e, n, i, s), n.lineTo(o + h, l + c), n.quadraticCurveTo(o, l + c, o, l + c - h), a === "center" && r === "left" && this.drawCaret(e, n, i, s), n.lineTo(o, l + d), n.quadraticCurveTo(o, l, o + d, l), n.closePath(), n.fill(), s.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(e) {
    const n = this.chart, i = this.$animations, s = i && i.x, r = i && i.y;
    if (s || r) {
      const a = Mr[e.position].call(this, this._active, this._eventPosition);
      if (!a)
        return;
      const o = this._size = qf(this, e), l = Object.assign({}, a, this._size), u = Uf(n, e, l), c = Xf(e, l, u, n);
      (s._to !== c.x || r._to !== c.y) && (this.xAlign = u.xAlign, this.yAlign = u.yAlign, this.width = o.width, this.height = o.height, this.caretX = a.x, this.caretY = a.y, this._resolveAnimations().update(this, c));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(e) {
    const n = this.options.setContext(this.getContext());
    let i = this.opacity;
    if (!i)
      return;
    this._updateAnimationTarget(n);
    const s = {
      width: this.width,
      height: this.height
    }, r = {
      x: this.x,
      y: this.y
    };
    i = Math.abs(i) < 1e-3 ? 0 : i;
    const a = Ot(n.padding), o = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && o && (e.save(), e.globalAlpha = i, this.drawBackground(r, e, s, n), Jp(e, n.textDirection), r.y += a.top, this.drawTitle(r, e, n), this.drawBody(r, e, n), this.drawFooter(r, e, n), eg(e, n.textDirection), e.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e, n) {
    const i = this._active, s = e.map(({ datasetIndex: o, index: l }) => {
      const u = this.chart.getDatasetMeta(o);
      if (!u)
        throw new Error("Cannot find a dataset at index " + o);
      return {
        datasetIndex: o,
        element: u.data[l],
        index: l
      };
    }), r = !no(i, s), a = this._positionChanged(s, n);
    (r || a) && (this._active = s, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(e, n, i = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const s = this.options, r = this._active || [], a = this._getActiveElements(e, r, n, i), o = this._positionChanged(a, e), l = n || !no(a, r) || o;
    return l && (this._active = a, (s.enabled || s.external) && (this._eventPosition = {
      x: e.x,
      y: e.y
    }, this.update(!0, n))), l;
  }
  _getActiveElements(e, n, i, s) {
    const r = this.options;
    if (e.type === "mouseout")
      return [];
    if (!s)
      return n.filter((o) => this.chart.data.datasets[o.datasetIndex] && this.chart.getDatasetMeta(o.datasetIndex).controller.getParsed(o.index) !== void 0);
    const a = this.chart.getElementsAtEventForMode(e, r.mode, r, i);
    return r.reverse && a.reverse(), a;
  }
  _positionChanged(e, n) {
    const { caretX: i, caretY: s, options: r } = this, a = Mr[r.position].call(this, e, n);
    return a !== !1 && (i !== a.x || s !== a.y);
  }
}
X(Vu, "positioners", Mr);
var ck = {
  id: "tooltip",
  _element: Vu,
  positioners: Mr,
  afterInit(t, e, n) {
    n && (t.tooltip = new Vu({
      chart: t,
      options: n
    }));
  },
  beforeUpdate(t, e, n) {
    t.tooltip && t.tooltip.initialize(n);
  },
  reset(t, e, n) {
    t.tooltip && t.tooltip.initialize(n);
  },
  afterDraw(t) {
    const e = t.tooltip;
    if (e && e._willRender()) {
      const n = {
        tooltip: e
      };
      if (t.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      e.draw(t.ctx), t.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(t, e) {
    if (t.tooltip) {
      const n = e.replay;
      t.tooltip.handleEvent(e.event, n, e.inChartArea) && (e.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (t, e) => e.bodyFont.size,
    boxWidth: (t, e) => e.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: Og
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (t) => t !== "filter" && t !== "itemSort" && t !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
}, dk = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Colors: k_,
  Decimation: D_,
  Filler: U_,
  Legend: J_,
  SubTitle: nk,
  Title: tk,
  Tooltip: ck
});
const fk = (t, e, n, i) => (typeof e == "string" ? (n = t.push(e) - 1, i.unshift({
  index: n,
  label: e
})) : isNaN(e) && (n = null), n);
function hk(t, e, n, i) {
  const s = t.indexOf(e);
  if (s === -1)
    return fk(t, e, n, i);
  const r = t.lastIndexOf(e);
  return s !== r ? n : s;
}
const mk = (t, e) => t === null ? null : Et(Math.round(t), 0, e);
function Kf(t) {
  const e = this.getLabels();
  return t >= 0 && t < e.length ? e[t] : t;
}
class Nu extends ds {
  constructor(e) {
    super(e), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(e) {
    const n = this._addedLabels;
    if (n.length) {
      const i = this.getLabels();
      for (const { index: s, label: r } of n)
        i[s] === r && i.splice(s, 1);
      this._addedLabels = [];
    }
    super.init(e);
  }
  parse(e, n) {
    if (Ie(e))
      return null;
    const i = this.getLabels();
    return n = isFinite(n) && i[n] === e ? n : hk(i, e, De(n, e), this._addedLabels), mk(n, i.length - 1);
  }
  determineDataLimits() {
    const { minDefined: e, maxDefined: n } = this.getUserBounds();
    let { min: i, max: s } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (e || (i = 0), n || (s = this.getLabels().length - 1)), this.min = i, this.max = s;
  }
  buildTicks() {
    const e = this.min, n = this.max, i = this.options.offset, s = [];
    let r = this.getLabels();
    r = e === 0 && n === r.length - 1 ? r : r.slice(e, n + 1), this._valueRange = Math.max(r.length - (i ? 0 : 1), 1), this._startValue = this.min - (i ? 0.5 : 0);
    for (let a = e; a <= n; a++)
      s.push({
        value: a
      });
    return s;
  }
  getLabelForValue(e) {
    return Kf.call(this, e);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(e) {
    return typeof e != "number" && (e = this.parse(e)), e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getPixelForTick(e) {
    const n = this.ticks;
    return e < 0 || e > n.length - 1 ? null : this.getPixelForValue(n[e].value);
  }
  getValueForPixel(e) {
    return Math.round(this._startValue + this.getDecimalForPixel(e) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
X(Nu, "id", "category"), X(Nu, "defaults", {
  ticks: {
    callback: Kf
  }
});
function pk(t, e) {
  const n = [], { bounds: s, step: r, min: a, max: o, precision: l, count: u, maxTicks: c, maxDigits: d, includeBounds: f } = t, h = r || 1, m = c - 1, { min: p, max: g } = e, y = !Ie(a), v = !Ie(o), b = !Ie(u), _ = (g - p) / (d + 1);
  let M = jd((g - p) / m / h) * h, A, E, I, S;
  if (M < 1e-14 && !y && !v)
    return [
      {
        value: p
      },
      {
        value: g
      }
    ];
  S = Math.ceil(g / M) - Math.floor(p / M), S > m && (M = jd(S * M / m / h) * h), Ie(l) || (A = Math.pow(10, l), M = Math.ceil(M * A) / A), s === "ticks" ? (E = Math.floor(p / M) * M, I = Math.ceil(g / M) * M) : (E = p, I = g), y && v && r && cw((o - a) / r, M / 1e3) ? (S = Math.round(Math.min((o - a) / M, c)), M = (o - a) / S, E = a, I = o) : b ? (E = y ? a : E, I = v ? o : I, S = u - 1, M = (I - E) / S) : (S = (I - E) / M, Ar(S, Math.round(S), M / 1e3) ? S = Math.round(S) : S = Math.ceil(S));
  const $ = Math.max(qd(M), qd(E));
  A = Math.pow(10, Ie(l) ? $ : l), E = Math.round(E * A) / A, I = Math.round(I * A) / A;
  let B = 0;
  for (y && (f && E !== a ? (n.push({
    value: a
  }), E < a && B++, Ar(Math.round((E + B * M) * A) / A, a, Qf(a, _, t)) && B++) : E < a && B++); B < S; ++B) {
    const V = Math.round((E + B * M) * A) / A;
    if (v && V > o)
      break;
    n.push({
      value: V
    });
  }
  return v && f && I !== o ? n.length && Ar(n[n.length - 1].value, o, Qf(o, _, t)) ? n[n.length - 1].value = o : n.push({
    value: o
  }) : (!v || I === o) && n.push({
    value: I
  }), n;
}
function Qf(t, e, { horizontal: n, minRotation: i }) {
  const s = St(i), r = (n ? Math.sin(s) : Math.cos(s)) || 1e-3, a = 0.75 * e * ("" + t).length;
  return Math.min(e / r, a);
}
class fo extends ds {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(e, n) {
    return Ie(e) || (typeof e == "number" || e instanceof Number) && !isFinite(+e) ? null : +e;
  }
  handleTickRangeOptions() {
    const { beginAtZero: e } = this.options, { minDefined: n, maxDefined: i } = this.getUserBounds();
    let { min: s, max: r } = this;
    const a = (l) => s = n ? s : l, o = (l) => r = i ? r : l;
    if (e) {
      const l = Nn(s), u = Nn(r);
      l < 0 && u < 0 ? o(0) : l > 0 && u > 0 && a(0);
    }
    if (s === r) {
      let l = r === 0 ? 1 : Math.abs(r * 0.05);
      o(r + l), e || a(s - l);
    }
    this.min = s, this.max = r;
  }
  getTickLimit() {
    const e = this.options.ticks;
    let { maxTicksLimit: n, stepSize: i } = e, s;
    return i ? (s = Math.ceil(this.max / i) - Math.floor(this.min / i) + 1, s > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${i} would result generating up to ${s} ticks. Limiting to 1000.`), s = 1e3)) : (s = this.computeTickLimit(), n = n || 11), n && (s = Math.min(n, s)), s;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const e = this.options, n = e.ticks;
    let i = this.getTickLimit();
    i = Math.max(2, i);
    const s = {
      maxTicks: i,
      bounds: e.bounds,
      min: e.min,
      max: e.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, r = this._range || this, a = pk(s, r);
    return e.bounds === "ticks" && Fp(a, this, "value"), e.reverse ? (a.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), a;
  }
  configure() {
    const e = this.ticks;
    let n = this.min, i = this.max;
    if (super.configure(), this.options.offset && e.length) {
      const s = (i - n) / Math.max(e.length - 1, 1) / 2;
      n -= s, i += s;
    }
    this._startValue = n, this._endValue = i, this._valueRange = i - n;
  }
  getLabelForValue(e) {
    return ta(e, this.chart.options.locale, this.options.ticks.format);
  }
}
class Bu extends fo {
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!0);
    this.min = ot(e) ? e : 0, this.max = ot(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const e = this.isHorizontal(), n = e ? this.width : this.height, i = St(this.options.ticks.minRotation), s = (e ? Math.sin(i) : Math.cos(i)) || 1e-3, r = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, r.lineHeight / s));
  }
  getPixelForValue(e) {
    return e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    return this._startValue + this.getDecimalForPixel(e) * this._valueRange;
  }
}
X(Bu, "id", "linear"), X(Bu, "defaults", {
  ticks: {
    callback: Oo.formatters.numeric
  }
});
const qr = (t) => Math.floor(gi(t)), zi = (t, e) => Math.pow(10, qr(t) + e);
function Jf(t) {
  return t / Math.pow(10, qr(t)) === 1;
}
function eh(t, e, n) {
  const i = Math.pow(10, n), s = Math.floor(t / i);
  return Math.ceil(e / i) - s;
}
function gk(t, e) {
  const n = e - t;
  let i = qr(n);
  for (; eh(t, e, i) > 10; )
    i++;
  for (; eh(t, e, i) < 10; )
    i--;
  return Math.min(i, qr(t));
}
function yk(t, { min: e, max: n }) {
  e = tn(t.min, e);
  const i = [], s = qr(e);
  let r = gk(e, n), a = r < 0 ? Math.pow(10, Math.abs(r)) : 1;
  const o = Math.pow(10, r), l = s > r ? Math.pow(10, s) : 0, u = Math.round((e - l) * a) / a, c = Math.floor((e - l) / o / 10) * o * 10;
  let d = Math.floor((u - c) / Math.pow(10, r)), f = tn(t.min, Math.round((l + c + d * Math.pow(10, r)) * a) / a);
  for (; f < n; )
    i.push({
      value: f,
      major: Jf(f),
      significand: d
    }), d >= 10 ? d = d < 15 ? 15 : 20 : d++, d >= 20 && (r++, d = 2, a = r >= 0 ? 1 : a), f = Math.round((l + c + d * Math.pow(10, r)) * a) / a;
  const h = tn(t.max, f);
  return i.push({
    value: h,
    major: Jf(h),
    significand: d
  }), i;
}
class zu extends ds {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(e, n) {
    const i = fo.prototype.parse.apply(this, [
      e,
      n
    ]);
    if (i === 0) {
      this._zero = !0;
      return;
    }
    return ot(i) && i > 0 ? i : null;
  }
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!0);
    this.min = ot(e) ? Math.max(0, e) : null, this.max = ot(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !ot(this._userMin) && (this.min = e === zi(this.min, 0) ? zi(this.min, -1) : zi(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: e, maxDefined: n } = this.getUserBounds();
    let i = this.min, s = this.max;
    const r = (o) => i = e ? i : o, a = (o) => s = n ? s : o;
    i === s && (i <= 0 ? (r(1), a(10)) : (r(zi(i, -1)), a(zi(s, 1)))), i <= 0 && r(zi(s, -1)), s <= 0 && a(zi(i, 1)), this.min = i, this.max = s;
  }
  buildTicks() {
    const e = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, i = yk(n, this);
    return e.bounds === "ticks" && Fp(i, this, "value"), e.reverse ? (i.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), i;
  }
  getLabelForValue(e) {
    return e === void 0 ? "0" : ta(e, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const e = this.min;
    super.configure(), this._startValue = gi(e), this._valueRange = gi(this.max) - gi(e);
  }
  getPixelForValue(e) {
    return (e === void 0 || e === 0) && (e = this.min), e === null || isNaN(e) ? NaN : this.getPixelForDecimal(e === this.min ? 0 : (gi(e) - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    const n = this.getDecimalForPixel(e);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
X(zu, "id", "logarithmic"), X(zu, "defaults", {
  ticks: {
    callback: Oo.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function Wu(t) {
  const e = t.ticks;
  if (e.display && t.display) {
    const n = Ot(e.backdropPadding);
    return De(e.font && e.font.size, at.font.size) + n.height;
  }
  return 0;
}
function vk(t, e, n) {
  return n = Ue(n) ? n : [
    n
  ], {
    w: Dw(t, e.string, n),
    h: n.length * e.lineHeight
  };
}
function th(t, e, n, i, s) {
  return t === i || t === s ? {
    start: e - n / 2,
    end: e + n / 2
  } : t < i || t > s ? {
    start: e - n,
    end: e
  } : {
    start: e,
    end: e + n
  };
}
function bk(t) {
  const e = {
    l: t.left + t._padding.left,
    r: t.right - t._padding.right,
    t: t.top + t._padding.top,
    b: t.bottom - t._padding.bottom
  }, n = Object.assign({}, e), i = [], s = [], r = t._pointLabels.length, a = t.options.pointLabels, o = a.centerPointLabels ? Ne / r : 0;
  for (let l = 0; l < r; l++) {
    const u = a.setContext(t.getPointLabelContext(l));
    s[l] = u.padding;
    const c = t.getPointPosition(l, t.drawingArea + s[l], o), d = mt(u.font), f = vk(t.ctx, d, t._pointLabels[l]);
    i[l] = f;
    const h = nn(t.getIndexAngle(l) + o), m = Math.round(So(h)), p = th(m, c.x, f.w, 0, 180), g = th(m, c.y, f.h, 90, 270);
    wk(n, e, h, p, g);
  }
  t.setCenterPoint(e.l - n.l, n.r - e.r, e.t - n.t, n.b - e.b), t._pointLabelItems = kk(t, i, s);
}
function wk(t, e, n, i, s) {
  const r = Math.abs(Math.sin(n)), a = Math.abs(Math.cos(n));
  let o = 0, l = 0;
  i.start < e.l ? (o = (e.l - i.start) / r, t.l = Math.min(t.l, e.l - o)) : i.end > e.r && (o = (i.end - e.r) / r, t.r = Math.max(t.r, e.r + o)), s.start < e.t ? (l = (e.t - s.start) / a, t.t = Math.min(t.t, e.t - l)) : s.end > e.b && (l = (s.end - e.b) / a, t.b = Math.max(t.b, e.b + l));
}
function xk(t, e, n) {
  const i = t.drawingArea, { extra: s, additionalAngle: r, padding: a, size: o } = n, l = t.getPointPosition(e, i + s + a, r), u = Math.round(So(nn(l.angle + rt))), c = Ok(l.y, o.h, u), d = Mk(u), f = Sk(l.x, o.w, d);
  return {
    visible: !0,
    x: l.x,
    y: c,
    textAlign: d,
    left: f,
    top: c,
    right: f + o.w,
    bottom: c + o.h
  };
}
function _k(t, e) {
  if (!e)
    return !0;
  const { left: n, top: i, right: s, bottom: r } = t;
  return !(Qn({
    x: n,
    y: i
  }, e) || Qn({
    x: n,
    y: r
  }, e) || Qn({
    x: s,
    y: i
  }, e) || Qn({
    x: s,
    y: r
  }, e));
}
function kk(t, e, n) {
  const i = [], s = t._pointLabels.length, r = t.options, { centerPointLabels: a, display: o } = r.pointLabels, l = {
    extra: Wu(r) / 2,
    additionalAngle: a ? Ne / s : 0
  };
  let u;
  for (let c = 0; c < s; c++) {
    l.padding = n[c], l.size = e[c];
    const d = xk(t, c, l);
    i.push(d), o === "auto" && (d.visible = _k(d, u), d.visible && (u = d));
  }
  return i;
}
function Mk(t) {
  return t === 0 || t === 180 ? "center" : t < 180 ? "left" : "right";
}
function Sk(t, e, n) {
  return n === "right" ? t -= e : n === "center" && (t -= e / 2), t;
}
function Ok(t, e, n) {
  return n === 90 || n === 270 ? t -= e / 2 : (n > 270 || n < 90) && (t -= e), t;
}
function Dk(t, e, n) {
  const { left: i, top: s, right: r, bottom: a } = n, { backdropColor: o } = e;
  if (!Ie(o)) {
    const l = ki(e.borderRadius), u = Ot(e.backdropPadding);
    t.fillStyle = o;
    const c = i - u.left, d = s - u.top, f = r - i + u.width, h = a - s + u.height;
    Object.values(l).some((m) => m !== 0) ? (t.beginPath(), Hs(t, {
      x: c,
      y: d,
      w: f,
      h,
      radius: l
    }), t.fill()) : t.fillRect(c, d, f, h);
  }
}
function Tk(t, e) {
  const { ctx: n, options: { pointLabels: i } } = t;
  for (let s = e - 1; s >= 0; s--) {
    const r = t._pointLabelItems[s];
    if (!r.visible)
      continue;
    const a = i.setContext(t.getPointLabelContext(s));
    Dk(n, a, r);
    const o = mt(a.font), { x: l, y: u, textAlign: c } = r;
    rs(n, t._pointLabels[s], l, u + o.lineHeight / 2, o, {
      color: a.color,
      textAlign: c,
      textBaseline: "middle"
    });
  }
}
function Dg(t, e, n, i) {
  const { ctx: s } = t;
  if (n)
    s.arc(t.xCenter, t.yCenter, e, 0, nt);
  else {
    let r = t.getPointPosition(0, e);
    s.moveTo(r.x, r.y);
    for (let a = 1; a < i; a++)
      r = t.getPointPosition(a, e), s.lineTo(r.x, r.y);
  }
}
function Pk(t, e, n, i, s) {
  const r = t.ctx, a = e.circular, { color: o, lineWidth: l } = e;
  !a && !i || !o || !l || n < 0 || (r.save(), r.strokeStyle = o, r.lineWidth = l, r.setLineDash(s.dash || []), r.lineDashOffset = s.dashOffset, r.beginPath(), Dg(t, n, a, i), r.closePath(), r.stroke(), r.restore());
}
function Ck(t, e, n) {
  return Li(t, {
    label: n,
    index: e,
    type: "pointLabel"
  });
}
class Sr extends fo {
  constructor(e) {
    super(e), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const e = this._padding = Ot(Wu(this.options) / 2), n = this.width = this.maxWidth - e.width, i = this.height = this.maxHeight - e.height;
    this.xCenter = Math.floor(this.left + n / 2 + e.left), this.yCenter = Math.floor(this.top + i / 2 + e.top), this.drawingArea = Math.floor(Math.min(n, i) / 2);
  }
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!1);
    this.min = ot(e) && !isNaN(e) ? e : 0, this.max = ot(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / Wu(this.options));
  }
  generateTickLabels(e) {
    fo.prototype.generateTickLabels.call(this, e), this._pointLabels = this.getLabels().map((n, i) => {
      const s = Ze(this.options.pointLabels.callback, [
        n,
        i
      ], this);
      return s || s === 0 ? s : "";
    }).filter((n, i) => this.chart.getDataVisibility(i));
  }
  fit() {
    const e = this.options;
    e.display && e.pointLabels.display ? bk(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(e, n, i, s) {
    this.xCenter += Math.floor((e - n) / 2), this.yCenter += Math.floor((i - s) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(e, n, i, s));
  }
  getIndexAngle(e) {
    const n = nt / (this._pointLabels.length || 1), i = this.options.startAngle || 0;
    return nn(e * n + St(i));
  }
  getDistanceFromCenterForValue(e) {
    if (Ie(e))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - e) * n : (e - this.min) * n;
  }
  getValueForDistanceFromCenter(e) {
    if (Ie(e))
      return NaN;
    const n = e / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(e) {
    const n = this._pointLabels || [];
    if (e >= 0 && e < n.length) {
      const i = n[e];
      return Ck(this.getContext(), e, i);
    }
  }
  getPointPosition(e, n, i = 0) {
    const s = this.getIndexAngle(e) - rt + i;
    return {
      x: Math.cos(s) * n + this.xCenter,
      y: Math.sin(s) * n + this.yCenter,
      angle: s
    };
  }
  getPointPositionForValue(e, n) {
    return this.getPointPosition(e, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(e) {
    return this.getPointPositionForValue(e || 0, this.getBaseValue());
  }
  getPointLabelPosition(e) {
    const { left: n, top: i, right: s, bottom: r } = this._pointLabelItems[e];
    return {
      left: n,
      top: i,
      right: s,
      bottom: r
    };
  }
  drawBackground() {
    const { backgroundColor: e, grid: { circular: n } } = this.options;
    if (e) {
      const i = this.ctx;
      i.save(), i.beginPath(), Dg(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), i.closePath(), i.fillStyle = e, i.fill(), i.restore();
    }
  }
  drawGrid() {
    const e = this.ctx, n = this.options, { angleLines: i, grid: s, border: r } = n, a = this._pointLabels.length;
    let o, l, u;
    if (n.pointLabels.display && Tk(this, a), s.display && this.ticks.forEach((c, d) => {
      if (d !== 0 || d === 0 && this.min < 0) {
        l = this.getDistanceFromCenterForValue(c.value);
        const f = this.getContext(d), h = s.setContext(f), m = r.setContext(f);
        Pk(this, h, l, a, m);
      }
    }), i.display) {
      for (e.save(), o = a - 1; o >= 0; o--) {
        const c = i.setContext(this.getPointLabelContext(o)), { color: d, lineWidth: f } = c;
        !f || !d || (e.lineWidth = f, e.strokeStyle = d, e.setLineDash(c.borderDash), e.lineDashOffset = c.borderDashOffset, l = this.getDistanceFromCenterForValue(n.reverse ? this.min : this.max), u = this.getPointPosition(o, l), e.beginPath(), e.moveTo(this.xCenter, this.yCenter), e.lineTo(u.x, u.y), e.stroke());
      }
      e.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const e = this.ctx, n = this.options, i = n.ticks;
    if (!i.display)
      return;
    const s = this.getIndexAngle(0);
    let r, a;
    e.save(), e.translate(this.xCenter, this.yCenter), e.rotate(s), e.textAlign = "center", e.textBaseline = "middle", this.ticks.forEach((o, l) => {
      if (l === 0 && this.min >= 0 && !n.reverse)
        return;
      const u = i.setContext(this.getContext(l)), c = mt(u.font);
      if (r = this.getDistanceFromCenterForValue(this.ticks[l].value), u.showLabelBackdrop) {
        e.font = c.string, a = e.measureText(o.label).width, e.fillStyle = u.backdropColor;
        const d = Ot(u.backdropPadding);
        e.fillRect(-a / 2 - d.left, -r - c.size / 2 - d.top, a + d.width, c.size + d.height);
      }
      rs(e, o.label, 0, -r, c, {
        color: u.color,
        strokeColor: u.textStrokeColor,
        strokeWidth: u.textStrokeWidth
      });
    }), e.restore();
  }
  drawTitle() {
  }
}
X(Sr, "id", "radialLinear"), X(Sr, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Oo.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(e) {
      return e;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), X(Sr, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), X(Sr, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const To = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, Kt = /* @__PURE__ */ Object.keys(To);
function nh(t, e) {
  return t - e;
}
function ih(t, e) {
  if (Ie(e))
    return null;
  const n = t._adapter, { parser: i, round: s, isoWeekday: r } = t._parseOpts;
  let a = e;
  return typeof i == "function" && (a = i(a)), ot(a) || (a = typeof i == "string" ? n.parse(a, i) : n.parse(a)), a === null ? null : (s && (a = s === "week" && (Ai(r) || r === !0) ? n.startOf(a, "isoWeek", r) : n.startOf(a, s)), +a);
}
function sh(t, e, n, i) {
  const s = Kt.length;
  for (let r = Kt.indexOf(t); r < s - 1; ++r) {
    const a = To[Kt[r]], o = a.steps ? a.steps : Number.MAX_SAFE_INTEGER;
    if (a.common && Math.ceil((n - e) / (o * a.size)) <= i)
      return Kt[r];
  }
  return Kt[s - 1];
}
function Ak(t, e, n, i, s) {
  for (let r = Kt.length - 1; r >= Kt.indexOf(n); r--) {
    const a = Kt[r];
    if (To[a].common && t._adapter.diff(s, i, a) >= e - 1)
      return a;
  }
  return Kt[n ? Kt.indexOf(n) : 0];
}
function Ek(t) {
  for (let e = Kt.indexOf(t) + 1, n = Kt.length; e < n; ++e)
    if (To[Kt[e]].common)
      return Kt[e];
}
function rh(t, e, n) {
  if (!n)
    t[e] = !0;
  else if (n.length) {
    const { lo: i, hi: s } = Lc(n, e), r = n[i] >= e ? n[i] : n[s];
    t[r] = !0;
  }
}
function $k(t, e, n, i) {
  const s = t._adapter, r = +s.startOf(e[0].value, i), a = e[e.length - 1].value;
  let o, l;
  for (o = r; o <= a; o = +s.add(o, 1, i))
    l = n[o], l >= 0 && (e[l].major = !0);
  return e;
}
function ah(t, e, n) {
  const i = [], s = {}, r = e.length;
  let a, o;
  for (a = 0; a < r; ++a)
    o = e[a], s[o] = a, i.push({
      value: o,
      major: !1
    });
  return r === 0 || !n ? i : $k(t, i, s, n);
}
class Ur extends ds {
  constructor(e) {
    super(e), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(e, n = {}) {
    const i = e.time || (e.time = {}), s = this._adapter = new og._date(e.adapters.date);
    s.init(n), Cr(i.displayFormats, s.formats()), this._parseOpts = {
      parser: i.parser,
      round: i.round,
      isoWeekday: i.isoWeekday
    }, super.init(e), this._normalized = n.normalized;
  }
  parse(e, n) {
    return e === void 0 ? null : ih(this, e);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const e = this.options, n = this._adapter, i = e.time.unit || "day";
    let { min: s, max: r, minDefined: a, maxDefined: o } = this.getUserBounds();
    function l(u) {
      !a && !isNaN(u.min) && (s = Math.min(s, u.min)), !o && !isNaN(u.max) && (r = Math.max(r, u.max));
    }
    (!a || !o) && (l(this._getLabelBounds()), (e.bounds !== "ticks" || e.ticks.source !== "labels") && l(this.getMinMax(!1))), s = ot(s) && !isNaN(s) ? s : +n.startOf(Date.now(), i), r = ot(r) && !isNaN(r) ? r : +n.endOf(Date.now(), i) + 1, this.min = Math.min(s, r - 1), this.max = Math.max(s + 1, r);
  }
  _getLabelBounds() {
    const e = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, i = Number.NEGATIVE_INFINITY;
    return e.length && (n = e[0], i = e[e.length - 1]), {
      min: n,
      max: i
    };
  }
  buildTicks() {
    const e = this.options, n = e.time, i = e.ticks, s = i.source === "labels" ? this.getLabelTimestamps() : this._generate();
    e.bounds === "ticks" && s.length && (this.min = this._userMin || s[0], this.max = this._userMax || s[s.length - 1]);
    const r = this.min, a = this.max, o = mw(s, r, a);
    return this._unit = n.unit || (i.autoSkip ? sh(n.minUnit, this.min, this.max, this._getLabelCapacity(r)) : Ak(this, o.length, n.minUnit, this.min, this.max)), this._majorUnit = !i.major.enabled || this._unit === "year" ? void 0 : Ek(this._unit), this.initOffsets(s), e.reverse && o.reverse(), ah(this, o, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((e) => +e.value));
  }
  initOffsets(e = []) {
    let n = 0, i = 0, s, r;
    this.options.offset && e.length && (s = this.getDecimalForValue(e[0]), e.length === 1 ? n = 1 - s : n = (this.getDecimalForValue(e[1]) - s) / 2, r = this.getDecimalForValue(e[e.length - 1]), e.length === 1 ? i = r : i = (r - this.getDecimalForValue(e[e.length - 2])) / 2);
    const a = e.length < 3 ? 0.5 : 0.25;
    n = Et(n, 0, a), i = Et(i, 0, a), this._offsets = {
      start: n,
      end: i,
      factor: 1 / (n + 1 + i)
    };
  }
  _generate() {
    const e = this._adapter, n = this.min, i = this.max, s = this.options, r = s.time, a = r.unit || sh(r.minUnit, n, i, this._getLabelCapacity(n)), o = De(s.ticks.stepSize, 1), l = a === "week" ? r.isoWeekday : !1, u = Ai(l) || l === !0, c = {};
    let d = n, f, h;
    if (u && (d = +e.startOf(d, "isoWeek", l)), d = +e.startOf(d, u ? "day" : a), e.diff(i, n, a) > 1e5 * o)
      throw new Error(n + " and " + i + " are too far apart with stepSize of " + o + " " + a);
    const m = s.ticks.source === "data" && this.getDataTimestamps();
    for (f = d, h = 0; f < i; f = +e.add(f, o, a), h++)
      rh(c, f, m);
    return (f === i || s.bounds === "ticks" || h === 1) && rh(c, f, m), Object.keys(c).sort(nh).map((p) => +p);
  }
  getLabelForValue(e) {
    const n = this._adapter, i = this.options.time;
    return i.tooltipFormat ? n.format(e, i.tooltipFormat) : n.format(e, i.displayFormats.datetime);
  }
  format(e, n) {
    const s = this.options.time.displayFormats, r = this._unit, a = n || s[r];
    return this._adapter.format(e, a);
  }
  _tickFormatFunction(e, n, i, s) {
    const r = this.options, a = r.ticks.callback;
    if (a)
      return Ze(a, [
        e,
        n,
        i
      ], this);
    const o = r.time.displayFormats, l = this._unit, u = this._majorUnit, c = l && o[l], d = u && o[u], f = i[n], h = u && d && f && f.major;
    return this._adapter.format(e, s || (h ? d : c));
  }
  generateTickLabels(e) {
    let n, i, s;
    for (n = 0, i = e.length; n < i; ++n)
      s = e[n], s.label = this._tickFormatFunction(s.value, n, e);
  }
  getDecimalForValue(e) {
    return e === null ? NaN : (e - this.min) / (this.max - this.min);
  }
  getPixelForValue(e) {
    const n = this._offsets, i = this.getDecimalForValue(e);
    return this.getPixelForDecimal((n.start + i) * n.factor);
  }
  getValueForPixel(e) {
    const n = this._offsets, i = this.getDecimalForPixel(e) / n.factor - n.end;
    return this.min + i * (this.max - this.min);
  }
  _getLabelSize(e) {
    const n = this.options.ticks, i = this.ctx.measureText(e).width, s = St(this.isHorizontal() ? n.maxRotation : n.minRotation), r = Math.cos(s), a = Math.sin(s), o = this._resolveTickFontOptions(0).size;
    return {
      w: i * r + o * a,
      h: i * a + o * r
    };
  }
  _getLabelCapacity(e) {
    const n = this.options.time, i = n.displayFormats, s = i[n.unit] || i.millisecond, r = this._tickFormatFunction(e, 0, ah(this, [
      e
    ], this._majorUnit), s), a = this._getLabelSize(r), o = Math.floor(this.isHorizontal() ? this.width / a.w : this.height / a.h) - 1;
    return o > 0 ? o : 1;
  }
  getDataTimestamps() {
    let e = this._cache.data || [], n, i;
    if (e.length)
      return e;
    const s = this.getMatchingVisibleMetas();
    if (this._normalized && s.length)
      return this._cache.data = s[0].controller.getAllParsedValues(this);
    for (n = 0, i = s.length; n < i; ++n)
      e = e.concat(s[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(e);
  }
  getLabelTimestamps() {
    const e = this._cache.labels || [];
    let n, i;
    if (e.length)
      return e;
    const s = this.getLabels();
    for (n = 0, i = s.length; n < i; ++n)
      e.push(ih(this, s[n]));
    return this._cache.labels = this._normalized ? e : this.normalize(e);
  }
  normalize(e) {
    return Np(e.sort(nh));
  }
}
X(Ur, "id", "time"), X(Ur, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function Aa(t, e, n) {
  let i = 0, s = t.length - 1, r, a, o, l;
  n ? (e >= t[i].pos && e <= t[s].pos && ({ lo: i, hi: s } = Kn(t, "pos", e)), { pos: r, time: o } = t[i], { pos: a, time: l } = t[s]) : (e >= t[i].time && e <= t[s].time && ({ lo: i, hi: s } = Kn(t, "time", e)), { time: r, pos: o } = t[i], { time: a, pos: l } = t[s]);
  const u = a - r;
  return u ? o + (l - o) * (e - r) / u : o;
}
class Hu extends Ur {
  constructor(e) {
    super(e), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const e = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(e);
    this._minPos = Aa(n, this.min), this._tableRange = Aa(n, this.max) - this._minPos, super.initOffsets(e);
  }
  buildLookupTable(e) {
    const { min: n, max: i } = this, s = [], r = [];
    let a, o, l, u, c;
    for (a = 0, o = e.length; a < o; ++a)
      u = e[a], u >= n && u <= i && s.push(u);
    if (s.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: i,
          pos: 1
        }
      ];
    for (a = 0, o = s.length; a < o; ++a)
      c = s[a + 1], l = s[a - 1], u = s[a], Math.round((c + l) / 2) !== u && r.push({
        time: u,
        pos: a / (o - 1)
      });
    return r;
  }
  _generate() {
    const e = this.min, n = this.max;
    let i = super.getDataTimestamps();
    return (!i.includes(e) || !i.length) && i.splice(0, 0, e), (!i.includes(n) || i.length === 1) && i.push(n), i.sort((s, r) => s - r);
  }
  _getTimestampsForTable() {
    let e = this._cache.all || [];
    if (e.length)
      return e;
    const n = this.getDataTimestamps(), i = this.getLabelTimestamps();
    return n.length && i.length ? e = this.normalize(n.concat(i)) : e = n.length ? n : i, e = this._cache.all = e, e;
  }
  getDecimalForValue(e) {
    return (Aa(this._table, e) - this._minPos) / this._tableRange;
  }
  getValueForPixel(e) {
    const n = this._offsets, i = this.getDecimalForPixel(e) / n.factor - n.end;
    return Aa(this._table, i * this._tableRange + this._minPos, !0);
  }
}
X(Hu, "id", "timeseries"), X(Hu, "defaults", Ur.defaults);
var Rk = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale: Nu,
  LinearScale: Bu,
  LogarithmicScale: zu,
  RadialLinearScale: Sr,
  TimeScale: Ur,
  TimeSeriesScale: Hu
});
const Lk = [
  H1,
  g_,
  dk,
  Rk
], Ik = {
  data: {
    type: Object,
    required: !0
  },
  options: {
    type: Object,
    default: () => ({})
  },
  plugins: {
    type: Array,
    default: () => []
  },
  datasetIdKey: {
    type: String,
    default: "label"
  },
  updateMode: {
    type: String,
    default: void 0
  }
}, Fk = {
  ariaLabel: {
    type: String
  },
  ariaDescribedby: {
    type: String
  }
}, Vk = {
  type: {
    type: String,
    required: !0
  },
  destroyDelay: {
    type: Number,
    default: 0
    // No delay by default
  },
  ...Ik,
  ...Fk
};
lv[0];
function bs(t) {
  return mp(t) ? _u(t) : t;
}
function Nk(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t;
  return mp(e) ? new Proxy(t, {}) : t;
}
function Bk(t, e) {
  const n = t.options;
  n && e && Object.assign(n, e);
}
function Tg(t, e) {
  t.labels = e;
}
function Pg(t, e, n) {
  const i = [];
  t.datasets = e.map((s) => {
    const r = t.datasets.find((a) => a[n] === s[n]);
    return !r || !s.data || i.includes(r) ? {
      ...s
    } : (i.push(r), Object.assign(r, s), r);
  });
}
function zk(t, e) {
  const n = {
    labels: [],
    datasets: []
  };
  return Tg(n, t.labels), Pg(n, t.datasets, e), n;
}
const oh = Rt({
  props: Vk,
  setup(t, e) {
    let { expose: n, slots: i } = e;
    const s = ee(null), r = xi(null);
    n({
      chart: r
    });
    const a = () => {
      if (!s.value) return;
      const { type: u, data: c, options: d, plugins: f, datasetIdKey: h } = t, m = zk(c, h), p = Nk(m, c);
      r.value = new Ji(s.value, {
        type: u,
        data: p,
        options: {
          ...d
        },
        plugins: f
      });
    }, o = () => {
      const u = _u(r.value);
      u && (t.destroyDelay > 0 ? setTimeout(() => {
        u.destroy(), r.value = null;
      }, t.destroyDelay) : (u.destroy(), r.value = null));
    }, l = (u) => {
      u.update(t.updateMode);
    };
    return _t(a), us(o), ct([
      () => t.options,
      () => t.data
    ], (u, c) => {
      let [d, f] = u, [h, m] = c;
      const p = _u(r.value);
      if (!p)
        return;
      let g = !1;
      if (d) {
        const y = bs(d), v = bs(h);
        y && y !== v && (Bk(p, y), g = !0);
      }
      if (f) {
        const y = bs(f.labels), v = bs(m.labels), b = bs(f.datasets), _ = bs(m.datasets);
        y !== v && (Tg(p.config.data, y), g = !0), b && b !== _ && (Pg(p.config.data, b, t.datasetIdKey), g = !0);
      }
      g && Gt(() => {
        l(p);
      });
    }, {
      deep: !0
    }), () => ku("canvas", {
      role: "img",
      ariaLabel: t.ariaLabel,
      ariaDescribedby: t.ariaDescribedby,
      ref: s
    }, [
      ku("p", {}, [
        i.default ? i.default() : ""
      ])
    ]);
  }
});
Ji.register(...Lk);
class fs extends Error {
}
class Wk extends fs {
  constructor(e) {
    super(`Invalid DateTime: ${e.toMessage()}`);
  }
}
class Hk extends fs {
  constructor(e) {
    super(`Invalid Interval: ${e.toMessage()}`);
  }
}
class Yk extends fs {
  constructor(e) {
    super(`Invalid Duration: ${e.toMessage()}`);
  }
}
class Ts extends fs {
}
class Cg extends fs {
  constructor(e) {
    super(`Invalid unit ${e}`);
  }
}
class Nt extends fs {
}
class ri extends fs {
  constructor() {
    super("Zone is an abstract class");
  }
}
const pe = "numeric", On = "short", on = "long", ho = {
  year: pe,
  month: pe,
  day: pe
}, Ag = {
  year: pe,
  month: On,
  day: pe
}, jk = {
  year: pe,
  month: On,
  day: pe,
  weekday: On
}, Eg = {
  year: pe,
  month: on,
  day: pe
}, $g = {
  year: pe,
  month: on,
  day: pe,
  weekday: on
}, Rg = {
  hour: pe,
  minute: pe
}, Lg = {
  hour: pe,
  minute: pe,
  second: pe
}, Ig = {
  hour: pe,
  minute: pe,
  second: pe,
  timeZoneName: On
}, Fg = {
  hour: pe,
  minute: pe,
  second: pe,
  timeZoneName: on
}, Vg = {
  hour: pe,
  minute: pe,
  hourCycle: "h23"
}, Ng = {
  hour: pe,
  minute: pe,
  second: pe,
  hourCycle: "h23"
}, Bg = {
  hour: pe,
  minute: pe,
  second: pe,
  hourCycle: "h23",
  timeZoneName: On
}, zg = {
  hour: pe,
  minute: pe,
  second: pe,
  hourCycle: "h23",
  timeZoneName: on
}, Wg = {
  year: pe,
  month: pe,
  day: pe,
  hour: pe,
  minute: pe
}, Hg = {
  year: pe,
  month: pe,
  day: pe,
  hour: pe,
  minute: pe,
  second: pe
}, Yg = {
  year: pe,
  month: On,
  day: pe,
  hour: pe,
  minute: pe
}, jg = {
  year: pe,
  month: On,
  day: pe,
  hour: pe,
  minute: pe,
  second: pe
}, qk = {
  year: pe,
  month: On,
  day: pe,
  weekday: On,
  hour: pe,
  minute: pe
}, qg = {
  year: pe,
  month: on,
  day: pe,
  hour: pe,
  minute: pe,
  timeZoneName: On
}, Ug = {
  year: pe,
  month: on,
  day: pe,
  hour: pe,
  minute: pe,
  second: pe,
  timeZoneName: On
}, Xg = {
  year: pe,
  month: on,
  day: pe,
  weekday: on,
  hour: pe,
  minute: pe,
  timeZoneName: on
}, Gg = {
  year: pe,
  month: on,
  day: pe,
  weekday: on,
  hour: pe,
  minute: pe,
  second: pe,
  timeZoneName: on
};
class ra {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ri();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ri();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ri();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(e, n) {
    throw new ri();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, n) {
    throw new ri();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(e) {
    throw new ri();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    throw new ri();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ri();
  }
}
let fl = null;
class Po extends ra {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return fl === null && (fl = new Po()), fl;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(e, { format: n, locale: i }) {
    return a0(e, n, i);
  }
  /** @override **/
  formatOffset(e, n) {
    return Lr(this.offset(e), n);
  }
  /** @override **/
  offset(e) {
    return -new Date(e).getTimezoneOffset();
  }
  /** @override **/
  equals(e) {
    return e.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
const Yu = /* @__PURE__ */ new Map();
function Uk(t) {
  let e = Yu.get(t);
  return e === void 0 && (e = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  }), Yu.set(t, e)), e;
}
const Xk = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function Gk(t, e) {
  const n = t.format(e).replace(/\u200E/g, ""), i = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(n), [, s, r, a, o, l, u, c] = i;
  return [a, s, r, o, l, u, c];
}
function Zk(t, e) {
  const n = t.formatToParts(e), i = [];
  for (let s = 0; s < n.length; s++) {
    const { type: r, value: a } = n[s], o = Xk[r];
    r === "era" ? i[o] = a : Pe(o) || (i[o] = parseInt(a, 10));
  }
  return i;
}
const hl = /* @__PURE__ */ new Map();
class ei extends ra {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(e) {
    let n = hl.get(e);
    return n === void 0 && hl.set(e, n = new ei(e)), n;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    hl.clear(), Yu.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(e) {
    return this.isValidZone(e);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(e) {
    if (!e)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: e }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(e) {
    super(), this.zoneName = e, this.valid = ei.isValidZone(e);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !1;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(e, { format: n, locale: i }) {
    return a0(e, n, i, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, n) {
    return Lr(this.offset(e), n);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(e) {
    if (!this.valid) return NaN;
    const n = new Date(e);
    if (isNaN(n)) return NaN;
    const i = Uk(this.name);
    let [s, r, a, o, l, u, c] = i.formatToParts ? Zk(i, n) : Gk(i, n);
    o === "BC" && (s = -Math.abs(s) + 1);
    const f = Ao({
      year: s,
      month: r,
      day: a,
      hour: l === 24 ? 0 : l,
      minute: u,
      second: c,
      millisecond: 0
    });
    let h = +n;
    const m = h % 1e3;
    return h -= m >= 0 ? m : 1e3 + m, (f - h) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    return e.type === "iana" && e.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let lh = {};
function Kk(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let i = lh[n];
  return i || (i = new Intl.ListFormat(t, e), lh[n] = i), i;
}
const ju = /* @__PURE__ */ new Map();
function qu(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let i = ju.get(n);
  return i === void 0 && (i = new Intl.DateTimeFormat(t, e), ju.set(n, i)), i;
}
const Uu = /* @__PURE__ */ new Map();
function Qk(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let i = Uu.get(n);
  return i === void 0 && (i = new Intl.NumberFormat(t, e), Uu.set(n, i)), i;
}
const Xu = /* @__PURE__ */ new Map();
function Jk(t, e = {}) {
  const { base: n, ...i } = e, s = JSON.stringify([t, i]);
  let r = Xu.get(s);
  return r === void 0 && (r = new Intl.RelativeTimeFormat(t, e), Xu.set(s, r)), r;
}
let Or = null;
function e2() {
  return Or || (Or = new Intl.DateTimeFormat().resolvedOptions().locale, Or);
}
const Gu = /* @__PURE__ */ new Map();
function Zg(t) {
  let e = Gu.get(t);
  return e === void 0 && (e = new Intl.DateTimeFormat(t).resolvedOptions(), Gu.set(t, e)), e;
}
const Zu = /* @__PURE__ */ new Map();
function t2(t) {
  let e = Zu.get(t);
  if (!e) {
    const n = new Intl.Locale(t);
    e = "getWeekInfo" in n ? n.getWeekInfo() : n.weekInfo, "minimalDays" in e || (e = { ...Kg, ...e }), Zu.set(t, e);
  }
  return e;
}
function n2(t) {
  const e = t.indexOf("-x-");
  e !== -1 && (t = t.substring(0, e));
  const n = t.indexOf("-u-");
  if (n === -1)
    return [t];
  {
    let i, s;
    try {
      i = qu(t).resolvedOptions(), s = t;
    } catch {
      const l = t.substring(0, n);
      i = qu(l).resolvedOptions(), s = l;
    }
    const { numberingSystem: r, calendar: a } = i;
    return [s, r, a];
  }
}
function i2(t, e, n) {
  return (n || e) && (t.includes("-u-") || (t += "-u"), n && (t += `-ca-${n}`), e && (t += `-nu-${e}`)), t;
}
function s2(t) {
  const e = [];
  for (let n = 1; n <= 12; n++) {
    const i = ke.utc(2009, n, 1);
    e.push(t(i));
  }
  return e;
}
function r2(t) {
  const e = [];
  for (let n = 1; n <= 7; n++) {
    const i = ke.utc(2016, 11, 13 + n);
    e.push(t(i));
  }
  return e;
}
function Ea(t, e, n, i) {
  const s = t.listingMode();
  return s === "error" ? null : s === "en" ? n(e) : i(e);
}
function a2(t) {
  return t.numberingSystem && t.numberingSystem !== "latn" ? !1 : t.numberingSystem === "latn" || !t.locale || t.locale.startsWith("en") || Zg(t.locale).numberingSystem === "latn";
}
class o2 {
  constructor(e, n, i) {
    this.padTo = i.padTo || 0, this.floor = i.floor || !1;
    const { padTo: s, floor: r, ...a } = i;
    if (!n || Object.keys(a).length > 0) {
      const o = { useGrouping: !1, ...i };
      i.padTo > 0 && (o.minimumIntegerDigits = i.padTo), this.inf = Qk(e, o);
    }
  }
  format(e) {
    if (this.inf) {
      const n = this.floor ? Math.floor(e) : e;
      return this.inf.format(n);
    } else {
      const n = this.floor ? Math.floor(e) : Qc(e, 3);
      return kt(n, this.padTo);
    }
  }
}
class l2 {
  constructor(e, n, i) {
    this.opts = i, this.originalZone = void 0;
    let s;
    if (this.opts.timeZone)
      this.dt = e;
    else if (e.zone.type === "fixed") {
      const a = -1 * (e.offset / 60), o = a >= 0 ? `Etc/GMT+${a}` : `Etc/GMT${a}`;
      e.offset !== 0 && ei.create(o).valid ? (s = o, this.dt = e) : (s = "UTC", this.dt = e.offset === 0 ? e : e.setZone("UTC").plus({ minutes: e.offset }), this.originalZone = e.zone);
    } else e.zone.type === "system" ? this.dt = e : e.zone.type === "iana" ? (this.dt = e, s = e.zone.name) : (s = "UTC", this.dt = e.setZone("UTC").plus({ minutes: e.offset }), this.originalZone = e.zone);
    const r = { ...this.opts };
    r.timeZone = r.timeZone || s, this.dtf = qu(n, r);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: e }) => e).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const e = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? e.map((n) => {
      if (n.type === "timeZoneName") {
        const i = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...n,
          value: i
        };
      } else
        return n;
    }) : e;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class u2 {
  constructor(e, n, i) {
    this.opts = { style: "long", ...i }, !n && s0() && (this.rtf = Jk(e, i));
  }
  format(e, n) {
    return this.rtf ? this.rtf.format(e, n) : A2(n, e, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(e, n) {
    return this.rtf ? this.rtf.formatToParts(e, n) : [];
  }
}
const Kg = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class qe {
  static fromOpts(e) {
    return qe.create(
      e.locale,
      e.numberingSystem,
      e.outputCalendar,
      e.weekSettings,
      e.defaultToEN
    );
  }
  static create(e, n, i, s, r = !1) {
    const a = e || ft.defaultLocale, o = a || (r ? "en-US" : e2()), l = n || ft.defaultNumberingSystem, u = i || ft.defaultOutputCalendar, c = Qu(s) || ft.defaultWeekSettings;
    return new qe(o, l, u, c, a);
  }
  static resetCache() {
    Or = null, ju.clear(), Uu.clear(), Xu.clear(), Gu.clear(), Zu.clear();
  }
  static fromObject({ locale: e, numberingSystem: n, outputCalendar: i, weekSettings: s } = {}) {
    return qe.create(e, n, i, s);
  }
  constructor(e, n, i, s, r) {
    const [a, o, l] = n2(e);
    this.locale = a, this.numberingSystem = n || o || null, this.outputCalendar = i || l || null, this.weekSettings = s, this.intl = i2(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = r, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = a2(this)), this.fastNumbersCached;
  }
  listingMode() {
    const e = this.isEnglish(), n = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return e && n ? "en" : "intl";
  }
  clone(e) {
    return !e || Object.getOwnPropertyNames(e).length === 0 ? this : qe.create(
      e.locale || this.specifiedLocale,
      e.numberingSystem || this.numberingSystem,
      e.outputCalendar || this.outputCalendar,
      Qu(e.weekSettings) || this.weekSettings,
      e.defaultToEN || !1
    );
  }
  redefaultToEN(e = {}) {
    return this.clone({ ...e, defaultToEN: !0 });
  }
  redefaultToSystem(e = {}) {
    return this.clone({ ...e, defaultToEN: !1 });
  }
  months(e, n = !1) {
    return Ea(this, e, u0, () => {
      const i = n ? { month: e, day: "numeric" } : { month: e }, s = n ? "format" : "standalone";
      return this.monthsCache[s][e] || (this.monthsCache[s][e] = s2((r) => this.extract(r, i, "month"))), this.monthsCache[s][e];
    });
  }
  weekdays(e, n = !1) {
    return Ea(this, e, f0, () => {
      const i = n ? { weekday: e, year: "numeric", month: "long", day: "numeric" } : { weekday: e }, s = n ? "format" : "standalone";
      return this.weekdaysCache[s][e] || (this.weekdaysCache[s][e] = r2(
        (r) => this.extract(r, i, "weekday")
      )), this.weekdaysCache[s][e];
    });
  }
  meridiems() {
    return Ea(
      this,
      void 0,
      () => h0,
      () => {
        if (!this.meridiemCache) {
          const e = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [ke.utc(2016, 11, 13, 9), ke.utc(2016, 11, 13, 19)].map(
            (n) => this.extract(n, e, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(e) {
    return Ea(this, e, m0, () => {
      const n = { era: e };
      return this.eraCache[e] || (this.eraCache[e] = [ke.utc(-40, 1, 1), ke.utc(2017, 1, 1)].map(
        (i) => this.extract(i, n, "era")
      )), this.eraCache[e];
    });
  }
  extract(e, n, i) {
    const s = this.dtFormatter(e, n), r = s.formatToParts(), a = r.find((o) => o.type.toLowerCase() === i);
    return a ? a.value : null;
  }
  numberFormatter(e = {}) {
    return new o2(this.intl, e.forceSimple || this.fastNumbers, e);
  }
  dtFormatter(e, n = {}) {
    return new l2(e, this.intl, n);
  }
  relFormatter(e = {}) {
    return new u2(this.intl, this.isEnglish(), e);
  }
  listFormatter(e = {}) {
    return Kk(this.intl, e);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || Zg(this.intl).locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : r0() ? t2(this.locale) : Kg;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(e) {
    return this.locale === e.locale && this.numberingSystem === e.numberingSystem && this.outputCalendar === e.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let ml = null;
class qt extends ra {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return ml === null && (ml = new qt(0)), ml;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(e) {
    return e === 0 ? qt.utcInstance : new qt(e);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(e) {
    if (e) {
      const n = e.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (n)
        return new qt(Eo(n[1], n[2]));
    }
    return null;
  }
  constructor(e) {
    super(), this.fixed = e;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Lr(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${Lr(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, n) {
    return Lr(this.fixed, n);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !0;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    return e.type === "fixed" && e.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return !0;
  }
}
class c2 extends ra {
  constructor(e) {
    super(), this.zoneName = e;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function mi(t, e) {
  if (Pe(t) || t === null)
    return e;
  if (t instanceof ra)
    return t;
  if (g2(t)) {
    const n = t.toLowerCase();
    return n === "default" ? e : n === "local" || n === "system" ? Po.instance : n === "utc" || n === "gmt" ? qt.utcInstance : qt.parseSpecifier(n) || ei.create(t);
  } else return Mi(t) ? qt.instance(t) : typeof t == "object" && "offset" in t && typeof t.offset == "function" ? t : new c2(t);
}
const Xc = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, uh = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, d2 = Xc.hanidec.replace(/[\[|\]]/g, "").split("");
function f2(t) {
  let e = parseInt(t, 10);
  if (isNaN(e)) {
    e = "";
    for (let n = 0; n < t.length; n++) {
      const i = t.charCodeAt(n);
      if (t[n].search(Xc.hanidec) !== -1)
        e += d2.indexOf(t[n]);
      else
        for (const s in uh) {
          const [r, a] = uh[s];
          i >= r && i <= a && (e += i - r);
        }
    }
    return parseInt(e, 10);
  } else
    return e;
}
const Ku = /* @__PURE__ */ new Map();
function h2() {
  Ku.clear();
}
function gn({ numberingSystem: t }, e = "") {
  const n = t || "latn";
  let i = Ku.get(n);
  i === void 0 && (i = /* @__PURE__ */ new Map(), Ku.set(n, i));
  let s = i.get(e);
  return s === void 0 && (s = new RegExp(`${Xc[n]}${e}`), i.set(e, s)), s;
}
let ch = () => Date.now(), dh = "system", fh = null, hh = null, mh = null, ph = 60, gh, yh = null;
class ft {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return ch;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(e) {
    ch = e;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(e) {
    dh = e;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return mi(dh, Po.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return fh;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(e) {
    fh = e;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return hh;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(e) {
    hh = e;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return mh;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(e) {
    mh = e;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return yh;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(e) {
    yh = Qu(e);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return ph;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(e) {
    ph = e % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return gh;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(e) {
    gh = e;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    qe.resetCache(), ei.resetCache(), ke.resetCache(), h2();
  }
}
class xn {
  constructor(e, n) {
    this.reason = e, this.explanation = n;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const Qg = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], Jg = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function hn(t, e) {
  return new xn(
    "unit out of range",
    `you specified ${e} (of type ${typeof e}) as a ${t}, which is invalid`
  );
}
function Gc(t, e, n) {
  const i = new Date(Date.UTC(t, e - 1, n));
  t < 100 && t >= 0 && i.setUTCFullYear(i.getUTCFullYear() - 1900);
  const s = i.getUTCDay();
  return s === 0 ? 7 : s;
}
function e0(t, e, n) {
  return n + (aa(t) ? Jg : Qg)[e - 1];
}
function t0(t, e) {
  const n = aa(t) ? Jg : Qg, i = n.findIndex((r) => r < e), s = e - n[i];
  return { month: i + 1, day: s };
}
function Zc(t, e) {
  return (t - e + 7) % 7 + 1;
}
function mo(t, e = 4, n = 1) {
  const { year: i, month: s, day: r } = t, a = e0(i, s, r), o = Zc(Gc(i, s, r), n);
  let l = Math.floor((a - o + 14 - e) / 7), u;
  return l < 1 ? (u = i - 1, l = Xr(u, e, n)) : l > Xr(i, e, n) ? (u = i + 1, l = 1) : u = i, { weekYear: u, weekNumber: l, weekday: o, ...$o(t) };
}
function vh(t, e = 4, n = 1) {
  const { weekYear: i, weekNumber: s, weekday: r } = t, a = Zc(Gc(i, 1, e), n), o = Rs(i);
  let l = s * 7 + r - a - 7 + e, u;
  l < 1 ? (u = i - 1, l += Rs(u)) : l > o ? (u = i + 1, l -= Rs(i)) : u = i;
  const { month: c, day: d } = t0(u, l);
  return { year: u, month: c, day: d, ...$o(t) };
}
function pl(t) {
  const { year: e, month: n, day: i } = t, s = e0(e, n, i);
  return { year: e, ordinal: s, ...$o(t) };
}
function bh(t) {
  const { year: e, ordinal: n } = t, { month: i, day: s } = t0(e, n);
  return { year: e, month: i, day: s, ...$o(t) };
}
function wh(t, e) {
  if (!Pe(t.localWeekday) || !Pe(t.localWeekNumber) || !Pe(t.localWeekYear)) {
    if (!Pe(t.weekday) || !Pe(t.weekNumber) || !Pe(t.weekYear))
      throw new Ts(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return Pe(t.localWeekday) || (t.weekday = t.localWeekday), Pe(t.localWeekNumber) || (t.weekNumber = t.localWeekNumber), Pe(t.localWeekYear) || (t.weekYear = t.localWeekYear), delete t.localWeekday, delete t.localWeekNumber, delete t.localWeekYear, {
      minDaysInFirstWeek: e.getMinDaysInFirstWeek(),
      startOfWeek: e.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function m2(t, e = 4, n = 1) {
  const i = Co(t.weekYear), s = mn(
    t.weekNumber,
    1,
    Xr(t.weekYear, e, n)
  ), r = mn(t.weekday, 1, 7);
  return i ? s ? r ? !1 : hn("weekday", t.weekday) : hn("week", t.weekNumber) : hn("weekYear", t.weekYear);
}
function p2(t) {
  const e = Co(t.year), n = mn(t.ordinal, 1, Rs(t.year));
  return e ? n ? !1 : hn("ordinal", t.ordinal) : hn("year", t.year);
}
function n0(t) {
  const e = Co(t.year), n = mn(t.month, 1, 12), i = mn(t.day, 1, po(t.year, t.month));
  return e ? n ? i ? !1 : hn("day", t.day) : hn("month", t.month) : hn("year", t.year);
}
function i0(t) {
  const { hour: e, minute: n, second: i, millisecond: s } = t, r = mn(e, 0, 23) || e === 24 && n === 0 && i === 0 && s === 0, a = mn(n, 0, 59), o = mn(i, 0, 59), l = mn(s, 0, 999);
  return r ? a ? o ? l ? !1 : hn("millisecond", s) : hn("second", i) : hn("minute", n) : hn("hour", e);
}
function Pe(t) {
  return typeof t > "u";
}
function Mi(t) {
  return typeof t == "number";
}
function Co(t) {
  return typeof t == "number" && t % 1 === 0;
}
function g2(t) {
  return typeof t == "string";
}
function y2(t) {
  return Object.prototype.toString.call(t) === "[object Date]";
}
function s0() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function r0() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function v2(t) {
  return Array.isArray(t) ? t : [t];
}
function xh(t, e, n) {
  if (t.length !== 0)
    return t.reduce((i, s) => {
      const r = [e(s), s];
      return i && n(i[0], r[0]) === i[0] ? i : r;
    }, null)[1];
}
function b2(t, e) {
  return e.reduce((n, i) => (n[i] = t[i], n), {});
}
function qs(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function Qu(t) {
  if (t == null)
    return null;
  if (typeof t != "object")
    throw new Nt("Week settings must be an object");
  if (!mn(t.firstDay, 1, 7) || !mn(t.minimalDays, 1, 7) || !Array.isArray(t.weekend) || t.weekend.some((e) => !mn(e, 1, 7)))
    throw new Nt("Invalid week settings");
  return {
    firstDay: t.firstDay,
    minimalDays: t.minimalDays,
    weekend: Array.from(t.weekend)
  };
}
function mn(t, e, n) {
  return Co(t) && t >= e && t <= n;
}
function w2(t, e) {
  return t - e * Math.floor(t / e);
}
function kt(t, e = 2) {
  const n = t < 0;
  let i;
  return n ? i = "-" + ("" + -t).padStart(e, "0") : i = ("" + t).padStart(e, "0"), i;
}
function fi(t) {
  if (!(Pe(t) || t === null || t === ""))
    return parseInt(t, 10);
}
function Wi(t) {
  if (!(Pe(t) || t === null || t === ""))
    return parseFloat(t);
}
function Kc(t) {
  if (!(Pe(t) || t === null || t === "")) {
    const e = parseFloat("0." + t) * 1e3;
    return Math.floor(e);
  }
}
function Qc(t, e, n = !1) {
  const i = 10 ** e;
  return (n ? Math.trunc : Math.round)(t * i) / i;
}
function aa(t) {
  return t % 4 === 0 && (t % 100 !== 0 || t % 400 === 0);
}
function Rs(t) {
  return aa(t) ? 366 : 365;
}
function po(t, e) {
  const n = w2(e - 1, 12) + 1, i = t + (e - n) / 12;
  return n === 2 ? aa(i) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][n - 1];
}
function Ao(t) {
  let e = Date.UTC(
    t.year,
    t.month - 1,
    t.day,
    t.hour,
    t.minute,
    t.second,
    t.millisecond
  );
  return t.year < 100 && t.year >= 0 && (e = new Date(e), e.setUTCFullYear(t.year, t.month - 1, t.day)), +e;
}
function _h(t, e, n) {
  return -Zc(Gc(t, 1, e), n) + e - 1;
}
function Xr(t, e = 4, n = 1) {
  const i = _h(t, e, n), s = _h(t + 1, e, n);
  return (Rs(t) - i + s) / 7;
}
function Ju(t) {
  return t > 99 ? t : t > ft.twoDigitCutoffYear ? 1900 + t : 2e3 + t;
}
function a0(t, e, n, i = null) {
  const s = new Date(t), r = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  i && (r.timeZone = i);
  const a = { timeZoneName: e, ...r }, o = new Intl.DateTimeFormat(n, a).formatToParts(s).find((l) => l.type.toLowerCase() === "timezonename");
  return o ? o.value : null;
}
function Eo(t, e) {
  let n = parseInt(t, 10);
  Number.isNaN(n) && (n = 0);
  const i = parseInt(e, 10) || 0, s = n < 0 || Object.is(n, -0) ? -i : i;
  return n * 60 + s;
}
function o0(t) {
  const e = Number(t);
  if (typeof t == "boolean" || t === "" || Number.isNaN(e))
    throw new Nt(`Invalid unit value ${t}`);
  return e;
}
function go(t, e) {
  const n = {};
  for (const i in t)
    if (qs(t, i)) {
      const s = t[i];
      if (s == null) continue;
      n[e(i)] = o0(s);
    }
  return n;
}
function Lr(t, e) {
  const n = Math.trunc(Math.abs(t / 60)), i = Math.trunc(Math.abs(t % 60)), s = t >= 0 ? "+" : "-";
  switch (e) {
    case "short":
      return `${s}${kt(n, 2)}:${kt(i, 2)}`;
    case "narrow":
      return `${s}${n}${i > 0 ? `:${i}` : ""}`;
    case "techie":
      return `${s}${kt(n, 2)}${kt(i, 2)}`;
    default:
      throw new RangeError(`Value format ${e} is out of range for property format`);
  }
}
function $o(t) {
  return b2(t, ["hour", "minute", "second", "millisecond"]);
}
const x2 = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], l0 = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], _2 = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function u0(t) {
  switch (t) {
    case "narrow":
      return [..._2];
    case "short":
      return [...l0];
    case "long":
      return [...x2];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const c0 = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], d0 = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], k2 = ["M", "T", "W", "T", "F", "S", "S"];
function f0(t) {
  switch (t) {
    case "narrow":
      return [...k2];
    case "short":
      return [...d0];
    case "long":
      return [...c0];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const h0 = ["AM", "PM"], M2 = ["Before Christ", "Anno Domini"], S2 = ["BC", "AD"], O2 = ["B", "A"];
function m0(t) {
  switch (t) {
    case "narrow":
      return [...O2];
    case "short":
      return [...S2];
    case "long":
      return [...M2];
    default:
      return null;
  }
}
function D2(t) {
  return h0[t.hour < 12 ? 0 : 1];
}
function T2(t, e) {
  return f0(e)[t.weekday - 1];
}
function P2(t, e) {
  return u0(e)[t.month - 1];
}
function C2(t, e) {
  return m0(e)[t.year < 0 ? 0 : 1];
}
function A2(t, e, n = "always", i = !1) {
  const s = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, r = ["hours", "minutes", "seconds"].indexOf(t) === -1;
  if (n === "auto" && r) {
    const d = t === "days";
    switch (e) {
      case 1:
        return d ? "tomorrow" : `next ${s[t][0]}`;
      case -1:
        return d ? "yesterday" : `last ${s[t][0]}`;
      case 0:
        return d ? "today" : `this ${s[t][0]}`;
    }
  }
  const a = Object.is(e, -0) || e < 0, o = Math.abs(e), l = o === 1, u = s[t], c = i ? l ? u[1] : u[2] || u[1] : l ? s[t][0] : t;
  return a ? `${o} ${c} ago` : `in ${o} ${c}`;
}
function kh(t, e) {
  let n = "";
  for (const i of t)
    i.literal ? n += i.val : n += e(i.val);
  return n;
}
const E2 = {
  D: ho,
  DD: Ag,
  DDD: Eg,
  DDDD: $g,
  t: Rg,
  tt: Lg,
  ttt: Ig,
  tttt: Fg,
  T: Vg,
  TT: Ng,
  TTT: Bg,
  TTTT: zg,
  f: Wg,
  ff: Yg,
  fff: qg,
  ffff: Xg,
  F: Hg,
  FF: jg,
  FFF: Ug,
  FFFF: Gg
};
class zt {
  static create(e, n = {}) {
    return new zt(e, n);
  }
  static parseFormat(e) {
    let n = null, i = "", s = !1;
    const r = [];
    for (let a = 0; a < e.length; a++) {
      const o = e.charAt(a);
      o === "'" ? (i.length > 0 && r.push({ literal: s || /^\s+$/.test(i), val: i }), n = null, i = "", s = !s) : s || o === n ? i += o : (i.length > 0 && r.push({ literal: /^\s+$/.test(i), val: i }), i = o, n = o);
    }
    return i.length > 0 && r.push({ literal: s || /^\s+$/.test(i), val: i }), r;
  }
  static macroTokenToFormatOpts(e) {
    return E2[e];
  }
  constructor(e, n) {
    this.opts = n, this.loc = e, this.systemLoc = null;
  }
  formatWithSystemDefault(e, n) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(e, { ...this.opts, ...n }).format();
  }
  dtFormatter(e, n = {}) {
    return this.loc.dtFormatter(e, { ...this.opts, ...n });
  }
  formatDateTime(e, n) {
    return this.dtFormatter(e, n).format();
  }
  formatDateTimeParts(e, n) {
    return this.dtFormatter(e, n).formatToParts();
  }
  formatInterval(e, n) {
    return this.dtFormatter(e.start, n).dtf.formatRange(e.start.toJSDate(), e.end.toJSDate());
  }
  resolvedOptions(e, n) {
    return this.dtFormatter(e, n).resolvedOptions();
  }
  num(e, n = 0) {
    if (this.opts.forceSimple)
      return kt(e, n);
    const i = { ...this.opts };
    return n > 0 && (i.padTo = n), this.loc.numberFormatter(i).format(e);
  }
  formatDateTimeFromString(e, n) {
    const i = this.loc.listingMode() === "en", s = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", r = (h, m) => this.loc.extract(e, h, m), a = (h) => e.isOffsetFixed && e.offset === 0 && h.allowZ ? "Z" : e.isValid ? e.zone.formatOffset(e.ts, h.format) : "", o = () => i ? D2(e) : r({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), l = (h, m) => i ? P2(e, h) : r(m ? { month: h } : { month: h, day: "numeric" }, "month"), u = (h, m) => i ? T2(e, h) : r(
      m ? { weekday: h } : { weekday: h, month: "long", day: "numeric" },
      "weekday"
    ), c = (h) => {
      const m = zt.macroTokenToFormatOpts(h);
      return m ? this.formatWithSystemDefault(e, m) : h;
    }, d = (h) => i ? C2(e, h) : r({ era: h }, "era"), f = (h) => {
      switch (h) {
        // ms
        case "S":
          return this.num(e.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(e.millisecond, 3);
        // seconds
        case "s":
          return this.num(e.second);
        case "ss":
          return this.num(e.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(e.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(e.millisecond / 100));
        // minutes
        case "m":
          return this.num(e.minute);
        case "mm":
          return this.num(e.minute, 2);
        // hours
        case "h":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12);
        case "hh":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12, 2);
        case "H":
          return this.num(e.hour);
        case "HH":
          return this.num(e.hour, 2);
        // offset
        case "Z":
          return a({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return a({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return a({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return e.zone.offsetName(e.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return e.zone.offsetName(e.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return e.zoneName;
        // meridiems
        case "a":
          return o();
        // dates
        case "d":
          return s ? r({ day: "numeric" }, "day") : this.num(e.day);
        case "dd":
          return s ? r({ day: "2-digit" }, "day") : this.num(e.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(e.weekday);
        case "ccc":
          return u("short", !0);
        case "cccc":
          return u("long", !0);
        case "ccccc":
          return u("narrow", !0);
        // weekdays - format
        case "E":
          return this.num(e.weekday);
        case "EEE":
          return u("short", !1);
        case "EEEE":
          return u("long", !1);
        case "EEEEE":
          return u("narrow", !1);
        // months - standalone
        case "L":
          return s ? r({ month: "numeric", day: "numeric" }, "month") : this.num(e.month);
        case "LL":
          return s ? r({ month: "2-digit", day: "numeric" }, "month") : this.num(e.month, 2);
        case "LLL":
          return l("short", !0);
        case "LLLL":
          return l("long", !0);
        case "LLLLL":
          return l("narrow", !0);
        // months - format
        case "M":
          return s ? r({ month: "numeric" }, "month") : this.num(e.month);
        case "MM":
          return s ? r({ month: "2-digit" }, "month") : this.num(e.month, 2);
        case "MMM":
          return l("short", !1);
        case "MMMM":
          return l("long", !1);
        case "MMMMM":
          return l("narrow", !1);
        // years
        case "y":
          return s ? r({ year: "numeric" }, "year") : this.num(e.year);
        case "yy":
          return s ? r({ year: "2-digit" }, "year") : this.num(e.year.toString().slice(-2), 2);
        case "yyyy":
          return s ? r({ year: "numeric" }, "year") : this.num(e.year, 4);
        case "yyyyyy":
          return s ? r({ year: "numeric" }, "year") : this.num(e.year, 6);
        // eras
        case "G":
          return d("short");
        case "GG":
          return d("long");
        case "GGGGG":
          return d("narrow");
        case "kk":
          return this.num(e.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(e.weekYear, 4);
        case "W":
          return this.num(e.weekNumber);
        case "WW":
          return this.num(e.weekNumber, 2);
        case "n":
          return this.num(e.localWeekNumber);
        case "nn":
          return this.num(e.localWeekNumber, 2);
        case "ii":
          return this.num(e.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(e.localWeekYear, 4);
        case "o":
          return this.num(e.ordinal);
        case "ooo":
          return this.num(e.ordinal, 3);
        case "q":
          return this.num(e.quarter);
        case "qq":
          return this.num(e.quarter, 2);
        case "X":
          return this.num(Math.floor(e.ts / 1e3));
        case "x":
          return this.num(e.ts);
        default:
          return c(h);
      }
    };
    return kh(zt.parseFormat(n), f);
  }
  formatDurationFromString(e, n) {
    const i = (l) => {
      switch (l[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, s = (l) => (u) => {
      const c = i(u);
      return c ? this.num(l.get(c), u.length) : u;
    }, r = zt.parseFormat(n), a = r.reduce(
      (l, { literal: u, val: c }) => u ? l : l.concat(c),
      []
    ), o = e.shiftTo(...a.map(i).filter((l) => l));
    return kh(r, s(o));
  }
}
const p0 = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function nr(...t) {
  const e = t.reduce((n, i) => n + i.source, "");
  return RegExp(`^${e}$`);
}
function ir(...t) {
  return (e) => t.reduce(
    ([n, i, s], r) => {
      const [a, o, l] = r(e, s);
      return [{ ...n, ...a }, o || i, l];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function sr(t, ...e) {
  if (t == null)
    return [null, null];
  for (const [n, i] of e) {
    const s = n.exec(t);
    if (s)
      return i(s);
  }
  return [null, null];
}
function g0(...t) {
  return (e, n) => {
    const i = {};
    let s;
    for (s = 0; s < t.length; s++)
      i[t[s]] = fi(e[n + s]);
    return [i, null, n + s];
  };
}
const y0 = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, $2 = `(?:${y0.source}?(?:\\[(${p0.source})\\])?)?`, Jc = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, v0 = RegExp(`${Jc.source}${$2}`), ed = RegExp(`(?:T${v0.source})?`), R2 = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, L2 = /(\d{4})-?W(\d\d)(?:-?(\d))?/, I2 = /(\d{4})-?(\d{3})/, F2 = g0("weekYear", "weekNumber", "weekDay"), V2 = g0("year", "ordinal"), N2 = /(\d{4})-(\d\d)-(\d\d)/, b0 = RegExp(
  `${Jc.source} ?(?:${y0.source}|(${p0.source}))?`
), B2 = RegExp(`(?: ${b0.source})?`);
function Ls(t, e, n) {
  const i = t[e];
  return Pe(i) ? n : fi(i);
}
function z2(t, e) {
  return [{
    year: Ls(t, e),
    month: Ls(t, e + 1, 1),
    day: Ls(t, e + 2, 1)
  }, null, e + 3];
}
function rr(t, e) {
  return [{
    hours: Ls(t, e, 0),
    minutes: Ls(t, e + 1, 0),
    seconds: Ls(t, e + 2, 0),
    milliseconds: Kc(t[e + 3])
  }, null, e + 4];
}
function oa(t, e) {
  const n = !t[e] && !t[e + 1], i = Eo(t[e + 1], t[e + 2]), s = n ? null : qt.instance(i);
  return [{}, s, e + 3];
}
function la(t, e) {
  const n = t[e] ? ei.create(t[e]) : null;
  return [{}, n, e + 1];
}
const W2 = RegExp(`^T?${Jc.source}$`), H2 = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function Y2(t) {
  const [e, n, i, s, r, a, o, l, u] = t, c = e[0] === "-", d = l && l[0] === "-", f = (h, m = !1) => h !== void 0 && (m || h && c) ? -h : h;
  return [
    {
      years: f(Wi(n)),
      months: f(Wi(i)),
      weeks: f(Wi(s)),
      days: f(Wi(r)),
      hours: f(Wi(a)),
      minutes: f(Wi(o)),
      seconds: f(Wi(l), l === "-0"),
      milliseconds: f(Kc(u), d)
    }
  ];
}
const j2 = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function td(t, e, n, i, s, r, a) {
  const o = {
    year: e.length === 2 ? Ju(fi(e)) : fi(e),
    month: l0.indexOf(n) + 1,
    day: fi(i),
    hour: fi(s),
    minute: fi(r)
  };
  return a && (o.second = fi(a)), t && (o.weekday = t.length > 3 ? c0.indexOf(t) + 1 : d0.indexOf(t) + 1), o;
}
const q2 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function U2(t) {
  const [
    ,
    e,
    n,
    i,
    s,
    r,
    a,
    o,
    l,
    u,
    c,
    d
  ] = t, f = td(e, s, i, n, r, a, o);
  let h;
  return l ? h = j2[l] : u ? h = 0 : h = Eo(c, d), [f, new qt(h)];
}
function X2(t) {
  return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const G2 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, Z2 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, K2 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function Mh(t) {
  const [, e, n, i, s, r, a, o] = t;
  return [td(e, s, i, n, r, a, o), qt.utcInstance];
}
function Q2(t) {
  const [, e, n, i, s, r, a, o] = t;
  return [td(e, o, n, i, s, r, a), qt.utcInstance];
}
const J2 = nr(R2, ed), eM = nr(L2, ed), tM = nr(I2, ed), nM = nr(v0), w0 = ir(
  z2,
  rr,
  oa,
  la
), iM = ir(
  F2,
  rr,
  oa,
  la
), sM = ir(
  V2,
  rr,
  oa,
  la
), rM = ir(
  rr,
  oa,
  la
);
function aM(t) {
  return sr(
    t,
    [J2, w0],
    [eM, iM],
    [tM, sM],
    [nM, rM]
  );
}
function oM(t) {
  return sr(X2(t), [q2, U2]);
}
function lM(t) {
  return sr(
    t,
    [G2, Mh],
    [Z2, Mh],
    [K2, Q2]
  );
}
function uM(t) {
  return sr(t, [H2, Y2]);
}
const cM = ir(rr);
function dM(t) {
  return sr(t, [W2, cM]);
}
const fM = nr(N2, B2), hM = nr(b0), mM = ir(
  rr,
  oa,
  la
);
function pM(t) {
  return sr(
    t,
    [fM, w0],
    [hM, mM]
  );
}
const Sh = "Invalid Duration", x0 = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, gM = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...x0
}, un = 146097 / 400, ws = 146097 / 4800, yM = {
  years: {
    quarters: 4,
    months: 12,
    weeks: un / 7,
    days: un,
    hours: un * 24,
    minutes: un * 24 * 60,
    seconds: un * 24 * 60 * 60,
    milliseconds: un * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: un / 28,
    days: un / 4,
    hours: un * 24 / 4,
    minutes: un * 24 * 60 / 4,
    seconds: un * 24 * 60 * 60 / 4,
    milliseconds: un * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: ws / 7,
    days: ws,
    hours: ws * 24,
    minutes: ws * 24 * 60,
    seconds: ws * 24 * 60 * 60,
    milliseconds: ws * 24 * 60 * 60 * 1e3
  },
  ...x0
}, Ui = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], vM = Ui.slice(0).reverse();
function ai(t, e, n = !1) {
  const i = {
    values: n ? e.values : { ...t.values, ...e.values || {} },
    loc: t.loc.clone(e.loc),
    conversionAccuracy: e.conversionAccuracy || t.conversionAccuracy,
    matrix: e.matrix || t.matrix
  };
  return new Be(i);
}
function _0(t, e) {
  let n = e.milliseconds ?? 0;
  for (const i of vM.slice(1))
    e[i] && (n += e[i] * t[i].milliseconds);
  return n;
}
function Oh(t, e) {
  const n = _0(t, e) < 0 ? -1 : 1;
  Ui.reduceRight((i, s) => {
    if (Pe(e[s]))
      return i;
    if (i) {
      const r = e[i] * n, a = t[s][i], o = Math.floor(r / a);
      e[s] += o * n, e[i] -= o * a * n;
    }
    return s;
  }, null), Ui.reduce((i, s) => {
    if (Pe(e[s]))
      return i;
    if (i) {
      const r = e[i] % 1;
      e[i] -= r, e[s] += r * t[i][s];
    }
    return s;
  }, null);
}
function bM(t) {
  const e = {};
  for (const [n, i] of Object.entries(t))
    i !== 0 && (e[n] = i);
  return e;
}
class Be {
  /**
   * @private
   */
  constructor(e) {
    const n = e.conversionAccuracy === "longterm" || !1;
    let i = n ? yM : gM;
    e.matrix && (i = e.matrix), this.values = e.values, this.loc = e.loc || qe.create(), this.conversionAccuracy = n ? "longterm" : "casual", this.invalid = e.invalid || null, this.matrix = i, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(e, n) {
    return Be.fromObject({ milliseconds: e }, n);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(e, n = {}) {
    if (e == null || typeof e != "object")
      throw new Nt(
        `Duration.fromObject: argument expected to be an object, got ${e === null ? "null" : typeof e}`
      );
    return new Be({
      values: go(e, Be.normalizeUnit),
      loc: qe.fromObject(n),
      conversionAccuracy: n.conversionAccuracy,
      matrix: n.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(e) {
    if (Mi(e))
      return Be.fromMillis(e);
    if (Be.isDuration(e))
      return e;
    if (typeof e == "object")
      return Be.fromObject(e);
    throw new Nt(
      `Unknown duration argument ${e} of type ${typeof e}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(e, n) {
    const [i] = uM(e);
    return i ? Be.fromObject(i, n) : Be.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(e, n) {
    const [i] = dM(e);
    return i ? Be.fromObject(i, n) : Be.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new Nt("need to specify a reason the Duration is invalid");
    const i = e instanceof xn ? e : new xn(e, n);
    if (ft.throwOnInvalid)
      throw new Yk(i);
    return new Be({ invalid: i });
  }
  /**
   * @private
   */
  static normalizeUnit(e) {
    const n = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[e && e.toLowerCase()];
    if (!n) throw new Cg(e);
    return n;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(e) {
    return e && e.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(e, n = {}) {
    const i = {
      ...n,
      floor: n.round !== !1 && n.floor !== !1
    };
    return this.isValid ? zt.create(this.loc, i).formatDurationFromString(this, e) : Sh;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(e = {}) {
    if (!this.isValid) return Sh;
    const n = Ui.map((i) => {
      const s = this.values[i];
      return Pe(s) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...e, unit: i.slice(0, -1) }).format(s);
    }).filter((i) => i);
    return this.loc.listFormatter({ type: "conjunction", style: e.listStyle || "narrow", ...e }).format(n);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let e = "P";
    return this.years !== 0 && (e += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (e += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (e += this.weeks + "W"), this.days !== 0 && (e += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (e += "T"), this.hours !== 0 && (e += this.hours + "H"), this.minutes !== 0 && (e += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (e += Qc(this.seconds + this.milliseconds / 1e3, 3) + "S"), e === "P" && (e += "T0S"), e;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(e = {}) {
    if (!this.isValid) return null;
    const n = this.toMillis();
    return n < 0 || n >= 864e5 ? null : (e = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...e,
      includeOffset: !1
    }, ke.fromMillis(n, { zone: "UTC" }).toISOTime(e));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? _0(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(e) {
    if (!this.isValid) return this;
    const n = Be.fromDurationLike(e), i = {};
    for (const s of Ui)
      (qs(n.values, s) || qs(this.values, s)) && (i[s] = n.get(s) + this.get(s));
    return ai(this, { values: i }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(e) {
    if (!this.isValid) return this;
    const n = Be.fromDurationLike(e);
    return this.plus(n.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(e) {
    if (!this.isValid) return this;
    const n = {};
    for (const i of Object.keys(this.values))
      n[i] = o0(e(this.values[i], i));
    return ai(this, { values: n }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(e) {
    return this[Be.normalizeUnit(e)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(e) {
    if (!this.isValid) return this;
    const n = { ...this.values, ...go(e, Be.normalizeUnit) };
    return ai(this, { values: n });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: e, numberingSystem: n, conversionAccuracy: i, matrix: s } = {}) {
    const a = { loc: this.loc.clone({ locale: e, numberingSystem: n }), matrix: s, conversionAccuracy: i };
    return ai(this, a);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(e) {
    return this.isValid ? this.shiftTo(e).get(e) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const e = this.toObject();
    return Oh(this.matrix, e), ai(this, { values: e }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const e = bM(this.normalize().shiftToAll().toObject());
    return ai(this, { values: e }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...e) {
    if (!this.isValid) return this;
    if (e.length === 0)
      return this;
    e = e.map((a) => Be.normalizeUnit(a));
    const n = {}, i = {}, s = this.toObject();
    let r;
    for (const a of Ui)
      if (e.indexOf(a) >= 0) {
        r = a;
        let o = 0;
        for (const u in i)
          o += this.matrix[u][a] * i[u], i[u] = 0;
        Mi(s[a]) && (o += s[a]);
        const l = Math.trunc(o);
        n[a] = l, i[a] = (o * 1e3 - l * 1e3) / 1e3;
      } else Mi(s[a]) && (i[a] = s[a]);
    for (const a in i)
      i[a] !== 0 && (n[r] += a === r ? i[a] : i[a] / this.matrix[r][a]);
    return Oh(this.matrix, n), ai(this, { values: n }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const e = {};
    for (const n of Object.keys(this.values))
      e[n] = this.values[n] === 0 ? 0 : -this.values[n];
    return ai(this, { values: e }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(e) {
    if (!this.isValid || !e.isValid || !this.loc.equals(e.loc))
      return !1;
    function n(i, s) {
      return i === void 0 || i === 0 ? s === void 0 || s === 0 : i === s;
    }
    for (const i of Ui)
      if (!n(this.values[i], e.values[i]))
        return !1;
    return !0;
  }
}
const xs = "Invalid Interval";
function wM(t, e) {
  return !t || !t.isValid ? dt.invalid("missing or invalid start") : !e || !e.isValid ? dt.invalid("missing or invalid end") : e < t ? dt.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${t.toISO()} and end=${e.toISO()}`
  ) : null;
}
class dt {
  /**
   * @private
   */
  constructor(e) {
    this.s = e.start, this.e = e.end, this.invalid = e.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new Nt("need to specify a reason the Interval is invalid");
    const i = e instanceof xn ? e : new xn(e, n);
    if (ft.throwOnInvalid)
      throw new Hk(i);
    return new dt({ invalid: i });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(e, n) {
    const i = gr(e), s = gr(n), r = wM(i, s);
    return r ?? new dt({
      start: i,
      end: s
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(e, n) {
    const i = Be.fromDurationLike(n), s = gr(e);
    return dt.fromDateTimes(s, s.plus(i));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(e, n) {
    const i = Be.fromDurationLike(n), s = gr(e);
    return dt.fromDateTimes(s.minus(i), s);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(e, n) {
    const [i, s] = (e || "").split("/", 2);
    if (i && s) {
      let r, a;
      try {
        r = ke.fromISO(i, n), a = r.isValid;
      } catch {
        a = !1;
      }
      let o, l;
      try {
        o = ke.fromISO(s, n), l = o.isValid;
      } catch {
        l = !1;
      }
      if (a && l)
        return dt.fromDateTimes(r, o);
      if (a) {
        const u = Be.fromISO(s, n);
        if (u.isValid)
          return dt.after(r, u);
      } else if (l) {
        const u = Be.fromISO(i, n);
        if (u.isValid)
          return dt.before(o, u);
      }
    }
    return dt.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(e) {
    return e && e.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid && this.e ? this.e.minus(1) : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(e = "milliseconds") {
    return this.isValid ? this.toDuration(e).get(e) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(e = "milliseconds", n) {
    if (!this.isValid) return NaN;
    const i = this.start.startOf(e, n);
    let s;
    return n != null && n.useLocaleWeeks ? s = this.end.reconfigure({ locale: i.locale }) : s = this.end, s = s.startOf(e, n), Math.floor(s.diff(i, e).get(e)) + (s.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(e) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, e) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(e) {
    return this.isValid ? this.s > e : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(e) {
    return this.isValid ? this.e <= e : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(e) {
    return this.isValid ? this.s <= e && this.e > e : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: e, end: n } = {}) {
    return this.isValid ? dt.fromDateTimes(e || this.s, n || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...e) {
    if (!this.isValid) return [];
    const n = e.map(gr).filter((a) => this.contains(a)).sort((a, o) => a.toMillis() - o.toMillis()), i = [];
    let { s } = this, r = 0;
    for (; s < this.e; ) {
      const a = n[r] || this.e, o = +a > +this.e ? this.e : a;
      i.push(dt.fromDateTimes(s, o)), s = o, r += 1;
    }
    return i;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(e) {
    const n = Be.fromDurationLike(e);
    if (!this.isValid || !n.isValid || n.as("milliseconds") === 0)
      return [];
    let { s: i } = this, s = 1, r;
    const a = [];
    for (; i < this.e; ) {
      const o = this.start.plus(n.mapUnits((l) => l * s));
      r = +o > +this.e ? this.e : o, a.push(dt.fromDateTimes(i, r)), i = r, s += 1;
    }
    return a;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(e) {
    return this.isValid ? this.splitBy(this.length() / e).slice(0, e) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(e) {
    return this.e > e.s && this.s < e.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(e) {
    return this.isValid ? +this.e == +e.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(e) {
    return this.isValid ? +e.e == +this.s : !1;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(e) {
    return this.isValid ? this.s <= e.s && this.e >= e.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(e) {
    return !this.isValid || !e.isValid ? !1 : this.s.equals(e.s) && this.e.equals(e.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(e) {
    if (!this.isValid) return this;
    const n = this.s > e.s ? this.s : e.s, i = this.e < e.e ? this.e : e.e;
    return n >= i ? null : dt.fromDateTimes(n, i);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(e) {
    if (!this.isValid) return this;
    const n = this.s < e.s ? this.s : e.s, i = this.e > e.e ? this.e : e.e;
    return dt.fromDateTimes(n, i);
  }
  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(e) {
    const [n, i] = e.sort((s, r) => s.s - r.s).reduce(
      ([s, r], a) => r ? r.overlaps(a) || r.abutsStart(a) ? [s, r.union(a)] : [s.concat([r]), a] : [s, a],
      [[], null]
    );
    return i && n.push(i), n;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(e) {
    let n = null, i = 0;
    const s = [], r = e.map((l) => [
      { time: l.s, type: "s" },
      { time: l.e, type: "e" }
    ]), a = Array.prototype.concat(...r), o = a.sort((l, u) => l.time - u.time);
    for (const l of o)
      i += l.type === "s" ? 1 : -1, i === 1 ? n = l.time : (n && +n != +l.time && s.push(dt.fromDateTimes(n, l.time)), n = null);
    return dt.merge(s);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...e) {
    return dt.xor([this].concat(e)).map((n) => this.intersection(n)).filter((n) => n && !n.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : xs;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(e = ho, n = {}) {
    return this.isValid ? zt.create(this.s.loc.clone(n), e).formatInterval(this) : xs;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(e) {
    return this.isValid ? `${this.s.toISO(e)}/${this.e.toISO(e)}` : xs;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : xs;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(e) {
    return this.isValid ? `${this.s.toISOTime(e)}/${this.e.toISOTime(e)}` : xs;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(e, { separator: n = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(e)}${n}${this.e.toFormat(e)}` : xs;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(e, n) {
    return this.isValid ? this.e.diff(this.s, e, n) : Be.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(e) {
    return dt.fromDateTimes(e(this.s), e(this.e));
  }
}
class $a {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(e = ft.defaultZone) {
    const n = ke.now().setZone(e).set({ month: 12 });
    return !e.isUniversal && n.offset !== n.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(e) {
    return ei.isValidZone(e);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(e) {
    return mi(e, ft.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: e = null, locObj: n = null } = {}) {
    return (n || qe.create(e)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: e = null, locObj: n = null } = {}) {
    return (n || qe.create(e)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: e = null, locObj: n = null } = {}) {
    return (n || qe.create(e)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(e = "long", { locale: n = null, numberingSystem: i = null, locObj: s = null, outputCalendar: r = "gregory" } = {}) {
    return (s || qe.create(n, i, r)).months(e);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(e = "long", { locale: n = null, numberingSystem: i = null, locObj: s = null, outputCalendar: r = "gregory" } = {}) {
    return (s || qe.create(n, i, r)).months(e, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(e = "long", { locale: n = null, numberingSystem: i = null, locObj: s = null } = {}) {
    return (s || qe.create(n, i, null)).weekdays(e);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(e = "long", { locale: n = null, numberingSystem: i = null, locObj: s = null } = {}) {
    return (s || qe.create(n, i, null)).weekdays(e, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: e = null } = {}) {
    return qe.create(e).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(e = "short", { locale: n = null } = {}) {
    return qe.create(n, null, "gregory").eras(e);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: s0(), localeWeek: r0() };
  }
}
function Dh(t, e) {
  const n = (s) => s.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), i = n(e) - n(t);
  return Math.floor(Be.fromMillis(i).as("days"));
}
function xM(t, e, n) {
  const i = [
    ["years", (l, u) => u.year - l.year],
    ["quarters", (l, u) => u.quarter - l.quarter + (u.year - l.year) * 4],
    ["months", (l, u) => u.month - l.month + (u.year - l.year) * 12],
    [
      "weeks",
      (l, u) => {
        const c = Dh(l, u);
        return (c - c % 7) / 7;
      }
    ],
    ["days", Dh]
  ], s = {}, r = t;
  let a, o;
  for (const [l, u] of i)
    n.indexOf(l) >= 0 && (a = l, s[l] = u(t, e), o = r.plus(s), o > e ? (s[l]--, t = r.plus(s), t > e && (o = t, s[l]--, t = r.plus(s))) : t = o);
  return [t, s, o, a];
}
function _M(t, e, n, i) {
  let [s, r, a, o] = xM(t, e, n);
  const l = e - s, u = n.filter(
    (d) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(d) >= 0
  );
  u.length === 0 && (a < e && (a = s.plus({ [o]: 1 })), a !== s && (r[o] = (r[o] || 0) + l / (a - s)));
  const c = Be.fromObject(r, i);
  return u.length > 0 ? Be.fromMillis(l, i).shiftTo(...u).plus(c) : c;
}
const kM = "missing Intl.DateTimeFormat.formatToParts support";
function Ye(t, e = (n) => n) {
  return { regex: t, deser: ([n]) => e(f2(n)) };
}
const MM = " ", k0 = `[ ${MM}]`, M0 = new RegExp(k0, "g");
function SM(t) {
  return t.replace(/\./g, "\\.?").replace(M0, k0);
}
function Th(t) {
  return t.replace(/\./g, "").replace(M0, " ").toLowerCase();
}
function yn(t, e) {
  return t === null ? null : {
    regex: RegExp(t.map(SM).join("|")),
    deser: ([n]) => t.findIndex((i) => Th(n) === Th(i)) + e
  };
}
function Ph(t, e) {
  return { regex: t, deser: ([, n, i]) => Eo(n, i), groups: e };
}
function Ra(t) {
  return { regex: t, deser: ([e]) => e };
}
function OM(t) {
  return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function DM(t, e) {
  const n = gn(e), i = gn(e, "{2}"), s = gn(e, "{3}"), r = gn(e, "{4}"), a = gn(e, "{6}"), o = gn(e, "{1,2}"), l = gn(e, "{1,3}"), u = gn(e, "{1,6}"), c = gn(e, "{1,9}"), d = gn(e, "{2,4}"), f = gn(e, "{4,6}"), h = (g) => ({ regex: RegExp(OM(g.val)), deser: ([y]) => y, literal: !0 }), p = ((g) => {
    if (t.literal)
      return h(g);
    switch (g.val) {
      // era
      case "G":
        return yn(e.eras("short"), 0);
      case "GG":
        return yn(e.eras("long"), 0);
      // years
      case "y":
        return Ye(u);
      case "yy":
        return Ye(d, Ju);
      case "yyyy":
        return Ye(r);
      case "yyyyy":
        return Ye(f);
      case "yyyyyy":
        return Ye(a);
      // months
      case "M":
        return Ye(o);
      case "MM":
        return Ye(i);
      case "MMM":
        return yn(e.months("short", !0), 1);
      case "MMMM":
        return yn(e.months("long", !0), 1);
      case "L":
        return Ye(o);
      case "LL":
        return Ye(i);
      case "LLL":
        return yn(e.months("short", !1), 1);
      case "LLLL":
        return yn(e.months("long", !1), 1);
      // dates
      case "d":
        return Ye(o);
      case "dd":
        return Ye(i);
      // ordinals
      case "o":
        return Ye(l);
      case "ooo":
        return Ye(s);
      // time
      case "HH":
        return Ye(i);
      case "H":
        return Ye(o);
      case "hh":
        return Ye(i);
      case "h":
        return Ye(o);
      case "mm":
        return Ye(i);
      case "m":
        return Ye(o);
      case "q":
        return Ye(o);
      case "qq":
        return Ye(i);
      case "s":
        return Ye(o);
      case "ss":
        return Ye(i);
      case "S":
        return Ye(l);
      case "SSS":
        return Ye(s);
      case "u":
        return Ra(c);
      case "uu":
        return Ra(o);
      case "uuu":
        return Ye(n);
      // meridiem
      case "a":
        return yn(e.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return Ye(r);
      case "kk":
        return Ye(d, Ju);
      // weekNumber (W)
      case "W":
        return Ye(o);
      case "WW":
        return Ye(i);
      // weekdays
      case "E":
      case "c":
        return Ye(n);
      case "EEE":
        return yn(e.weekdays("short", !1), 1);
      case "EEEE":
        return yn(e.weekdays("long", !1), 1);
      case "ccc":
        return yn(e.weekdays("short", !0), 1);
      case "cccc":
        return yn(e.weekdays("long", !0), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return Ph(new RegExp(`([+-]${o.source})(?::(${i.source}))?`), 2);
      case "ZZZ":
        return Ph(new RegExp(`([+-]${o.source})(${i.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return Ra(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return Ra(/[^\S\n\r]/);
      default:
        return h(g);
    }
  })(t) || {
    invalidReason: kM
  };
  return p.token = t, p;
}
const TM = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function PM(t, e, n) {
  const { type: i, value: s } = t;
  if (i === "literal") {
    const l = /^\s+$/.test(s);
    return {
      literal: !l,
      val: l ? " " : s
    };
  }
  const r = e[i];
  let a = i;
  i === "hour" && (e.hour12 != null ? a = e.hour12 ? "hour12" : "hour24" : e.hourCycle != null ? e.hourCycle === "h11" || e.hourCycle === "h12" ? a = "hour12" : a = "hour24" : a = n.hour12 ? "hour12" : "hour24");
  let o = TM[a];
  if (typeof o == "object" && (o = o[r]), o)
    return {
      literal: !1,
      val: o
    };
}
function CM(t) {
  return [`^${t.map((n) => n.regex).reduce((n, i) => `${n}(${i.source})`, "")}$`, t];
}
function AM(t, e, n) {
  const i = t.match(e);
  if (i) {
    const s = {};
    let r = 1;
    for (const a in n)
      if (qs(n, a)) {
        const o = n[a], l = o.groups ? o.groups + 1 : 1;
        !o.literal && o.token && (s[o.token.val[0]] = o.deser(i.slice(r, r + l))), r += l;
      }
    return [i, s];
  } else
    return [i, {}];
}
function EM(t) {
  const e = (r) => {
    switch (r) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let n = null, i;
  return Pe(t.z) || (n = ei.create(t.z)), Pe(t.Z) || (n || (n = new qt(t.Z)), i = t.Z), Pe(t.q) || (t.M = (t.q - 1) * 3 + 1), Pe(t.h) || (t.h < 12 && t.a === 1 ? t.h += 12 : t.h === 12 && t.a === 0 && (t.h = 0)), t.G === 0 && t.y && (t.y = -t.y), Pe(t.u) || (t.S = Kc(t.u)), [Object.keys(t).reduce((r, a) => {
    const o = e(a);
    return o && (r[o] = t[a]), r;
  }, {}), n, i];
}
let gl = null;
function $M() {
  return gl || (gl = ke.fromMillis(1555555555555)), gl;
}
function RM(t, e) {
  if (t.literal)
    return t;
  const n = zt.macroTokenToFormatOpts(t.val), i = T0(n, e);
  return i == null || i.includes(void 0) ? t : i;
}
function S0(t, e) {
  return Array.prototype.concat(...t.map((n) => RM(n, e)));
}
class O0 {
  constructor(e, n) {
    if (this.locale = e, this.format = n, this.tokens = S0(zt.parseFormat(n), e), this.units = this.tokens.map((i) => DM(i, e)), this.disqualifyingUnit = this.units.find((i) => i.invalidReason), !this.disqualifyingUnit) {
      const [i, s] = CM(this.units);
      this.regex = RegExp(i, "i"), this.handlers = s;
    }
  }
  explainFromTokens(e) {
    if (this.isValid) {
      const [n, i] = AM(e, this.regex, this.handlers), [s, r, a] = i ? EM(i) : [null, null, void 0];
      if (qs(i, "a") && qs(i, "H"))
        throw new Ts(
          "Can't include meridiem when specifying 24-hour format"
        );
      return {
        input: e,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: n,
        matches: i,
        result: s,
        zone: r,
        specificOffset: a
      };
    } else
      return { input: e, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function D0(t, e, n) {
  return new O0(t, n).explainFromTokens(e);
}
function LM(t, e, n) {
  const { result: i, zone: s, specificOffset: r, invalidReason: a } = D0(t, e, n);
  return [i, s, r, a];
}
function T0(t, e) {
  if (!t)
    return null;
  const i = zt.create(e, t).dtFormatter($M()), s = i.formatToParts(), r = i.resolvedOptions();
  return s.map((a) => PM(a, t, r));
}
const yl = "Invalid DateTime", Ch = 864e13;
function Dr(t) {
  return new xn("unsupported zone", `the zone "${t.name}" is not supported`);
}
function vl(t) {
  return t.weekData === null && (t.weekData = mo(t.c)), t.weekData;
}
function bl(t) {
  return t.localWeekData === null && (t.localWeekData = mo(
    t.c,
    t.loc.getMinDaysInFirstWeek(),
    t.loc.getStartOfWeek()
  )), t.localWeekData;
}
function Hi(t, e) {
  const n = {
    ts: t.ts,
    zone: t.zone,
    c: t.c,
    o: t.o,
    loc: t.loc,
    invalid: t.invalid
  };
  return new ke({ ...n, ...e, old: n });
}
function P0(t, e, n) {
  let i = t - e * 60 * 1e3;
  const s = n.offset(i);
  if (e === s)
    return [i, e];
  i -= (s - e) * 60 * 1e3;
  const r = n.offset(i);
  return s === r ? [i, s] : [t - Math.min(s, r) * 60 * 1e3, Math.max(s, r)];
}
function La(t, e) {
  t += e * 60 * 1e3;
  const n = new Date(t);
  return {
    year: n.getUTCFullYear(),
    month: n.getUTCMonth() + 1,
    day: n.getUTCDate(),
    hour: n.getUTCHours(),
    minute: n.getUTCMinutes(),
    second: n.getUTCSeconds(),
    millisecond: n.getUTCMilliseconds()
  };
}
function Ka(t, e, n) {
  return P0(Ao(t), e, n);
}
function Ah(t, e) {
  const n = t.o, i = t.c.year + Math.trunc(e.years), s = t.c.month + Math.trunc(e.months) + Math.trunc(e.quarters) * 3, r = {
    ...t.c,
    year: i,
    month: s,
    day: Math.min(t.c.day, po(i, s)) + Math.trunc(e.days) + Math.trunc(e.weeks) * 7
  }, a = Be.fromObject({
    years: e.years - Math.trunc(e.years),
    quarters: e.quarters - Math.trunc(e.quarters),
    months: e.months - Math.trunc(e.months),
    weeks: e.weeks - Math.trunc(e.weeks),
    days: e.days - Math.trunc(e.days),
    hours: e.hours,
    minutes: e.minutes,
    seconds: e.seconds,
    milliseconds: e.milliseconds
  }).as("milliseconds"), o = Ao(r);
  let [l, u] = P0(o, n, t.zone);
  return a !== 0 && (l += a, u = t.zone.offset(l)), { ts: l, o: u };
}
function _s(t, e, n, i, s, r) {
  const { setZone: a, zone: o } = n;
  if (t && Object.keys(t).length !== 0 || e) {
    const l = e || o, u = ke.fromObject(t, {
      ...n,
      zone: l,
      specificOffset: r
    });
    return a ? u : u.setZone(o);
  } else
    return ke.invalid(
      new xn("unparsable", `the input "${s}" can't be parsed as ${i}`)
    );
}
function Ia(t, e, n = !0) {
  return t.isValid ? zt.create(qe.create("en-US"), {
    allowZ: n,
    forceSimple: !0
  }).formatDateTimeFromString(t, e) : null;
}
function wl(t, e) {
  const n = t.c.year > 9999 || t.c.year < 0;
  let i = "";
  return n && t.c.year >= 0 && (i += "+"), i += kt(t.c.year, n ? 6 : 4), e ? (i += "-", i += kt(t.c.month), i += "-", i += kt(t.c.day)) : (i += kt(t.c.month), i += kt(t.c.day)), i;
}
function Eh(t, e, n, i, s, r) {
  let a = kt(t.c.hour);
  return e ? (a += ":", a += kt(t.c.minute), (t.c.millisecond !== 0 || t.c.second !== 0 || !n) && (a += ":")) : a += kt(t.c.minute), (t.c.millisecond !== 0 || t.c.second !== 0 || !n) && (a += kt(t.c.second), (t.c.millisecond !== 0 || !i) && (a += ".", a += kt(t.c.millisecond, 3))), s && (t.isOffsetFixed && t.offset === 0 && !r ? a += "Z" : t.o < 0 ? (a += "-", a += kt(Math.trunc(-t.o / 60)), a += ":", a += kt(Math.trunc(-t.o % 60))) : (a += "+", a += kt(Math.trunc(t.o / 60)), a += ":", a += kt(Math.trunc(t.o % 60)))), r && (a += "[" + t.zone.ianaName + "]"), a;
}
const C0 = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, IM = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, FM = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, A0 = ["year", "month", "day", "hour", "minute", "second", "millisecond"], VM = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], NM = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function BM(t) {
  const e = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[t.toLowerCase()];
  if (!e) throw new Cg(t);
  return e;
}
function $h(t) {
  switch (t.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return BM(t);
  }
}
function zM(t) {
  if (Tr === void 0 && (Tr = ft.now()), t.type !== "iana")
    return t.offset(Tr);
  const e = t.name;
  let n = ec.get(e);
  return n === void 0 && (n = t.offset(Tr), ec.set(e, n)), n;
}
function Rh(t, e) {
  const n = mi(e.zone, ft.defaultZone);
  if (!n.isValid)
    return ke.invalid(Dr(n));
  const i = qe.fromObject(e);
  let s, r;
  if (Pe(t.year))
    s = ft.now();
  else {
    for (const l of A0)
      Pe(t[l]) && (t[l] = C0[l]);
    const a = n0(t) || i0(t);
    if (a)
      return ke.invalid(a);
    const o = zM(n);
    [s, r] = Ka(t, o, n);
  }
  return new ke({ ts: s, zone: n, loc: i, o: r });
}
function Lh(t, e, n) {
  const i = Pe(n.round) ? !0 : n.round, s = (a, o) => (a = Qc(a, i || n.calendary ? 0 : 2, !0), e.loc.clone(n).relFormatter(n).format(a, o)), r = (a) => n.calendary ? e.hasSame(t, a) ? 0 : e.startOf(a).diff(t.startOf(a), a).get(a) : e.diff(t, a).get(a);
  if (n.unit)
    return s(r(n.unit), n.unit);
  for (const a of n.units) {
    const o = r(a);
    if (Math.abs(o) >= 1)
      return s(o, a);
  }
  return s(t > e ? -0 : 0, n.units[n.units.length - 1]);
}
function Ih(t) {
  let e = {}, n;
  return t.length > 0 && typeof t[t.length - 1] == "object" ? (e = t[t.length - 1], n = Array.from(t).slice(0, t.length - 1)) : n = Array.from(t), [e, n];
}
let Tr;
const ec = /* @__PURE__ */ new Map();
class ke {
  /**
   * @access private
   */
  constructor(e) {
    const n = e.zone || ft.defaultZone;
    let i = e.invalid || (Number.isNaN(e.ts) ? new xn("invalid input") : null) || (n.isValid ? null : Dr(n));
    this.ts = Pe(e.ts) ? ft.now() : e.ts;
    let s = null, r = null;
    if (!i)
      if (e.old && e.old.ts === this.ts && e.old.zone.equals(n))
        [s, r] = [e.old.c, e.old.o];
      else {
        const o = Mi(e.o) && !e.old ? e.o : n.offset(this.ts);
        s = La(this.ts, o), i = Number.isNaN(s.year) ? new xn("invalid input") : null, s = i ? null : s, r = i ? null : o;
      }
    this._zone = n, this.loc = e.loc || qe.create(), this.invalid = i, this.weekData = null, this.localWeekData = null, this.c = s, this.o = r, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new ke({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [e, n] = Ih(arguments), [i, s, r, a, o, l, u] = n;
    return Rh({ year: i, month: s, day: r, hour: a, minute: o, second: l, millisecond: u }, e);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [e, n] = Ih(arguments), [i, s, r, a, o, l, u] = n;
    return e.zone = qt.utcInstance, Rh({ year: i, month: s, day: r, hour: a, minute: o, second: l, millisecond: u }, e);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(e, n = {}) {
    const i = y2(e) ? e.valueOf() : NaN;
    if (Number.isNaN(i))
      return ke.invalid("invalid input");
    const s = mi(n.zone, ft.defaultZone);
    return s.isValid ? new ke({
      ts: i,
      zone: s,
      loc: qe.fromObject(n)
    }) : ke.invalid(Dr(s));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(e, n = {}) {
    if (Mi(e))
      return e < -Ch || e > Ch ? ke.invalid("Timestamp out of range") : new ke({
        ts: e,
        zone: mi(n.zone, ft.defaultZone),
        loc: qe.fromObject(n)
      });
    throw new Nt(
      `fromMillis requires a numerical input, but received a ${typeof e} with value ${e}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(e, n = {}) {
    if (Mi(e))
      return new ke({
        ts: e * 1e3,
        zone: mi(n.zone, ft.defaultZone),
        loc: qe.fromObject(n)
      });
    throw new Nt("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(e, n = {}) {
    e = e || {};
    const i = mi(n.zone, ft.defaultZone);
    if (!i.isValid)
      return ke.invalid(Dr(i));
    const s = qe.fromObject(n), r = go(e, $h), { minDaysInFirstWeek: a, startOfWeek: o } = wh(r, s), l = ft.now(), u = Pe(n.specificOffset) ? i.offset(l) : n.specificOffset, c = !Pe(r.ordinal), d = !Pe(r.year), f = !Pe(r.month) || !Pe(r.day), h = d || f, m = r.weekYear || r.weekNumber;
    if ((h || c) && m)
      throw new Ts(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (f && c)
      throw new Ts("Can't mix ordinal dates with month/day");
    const p = m || r.weekday && !h;
    let g, y, v = La(l, u);
    p ? (g = VM, y = IM, v = mo(v, a, o)) : c ? (g = NM, y = FM, v = pl(v)) : (g = A0, y = C0);
    let b = !1;
    for (const $ of g) {
      const B = r[$];
      Pe(B) ? b ? r[$] = y[$] : r[$] = v[$] : b = !0;
    }
    const _ = p ? m2(r, a, o) : c ? p2(r) : n0(r), M = _ || i0(r);
    if (M)
      return ke.invalid(M);
    const A = p ? vh(r, a, o) : c ? bh(r) : r, [E, I] = Ka(A, u, i), S = new ke({
      ts: E,
      zone: i,
      o: I,
      loc: s
    });
    return r.weekday && h && e.weekday !== S.weekday ? ke.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${r.weekday} and a date of ${S.toISO()}`
    ) : S.isValid ? S : ke.invalid(S.invalid);
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(e, n = {}) {
    const [i, s] = aM(e);
    return _s(i, s, n, "ISO 8601", e);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(e, n = {}) {
    const [i, s] = oM(e);
    return _s(i, s, n, "RFC 2822", e);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(e, n = {}) {
    const [i, s] = lM(e);
    return _s(i, s, n, "HTTP", n);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(e, n, i = {}) {
    if (Pe(e) || Pe(n))
      throw new Nt("fromFormat requires an input string and a format");
    const { locale: s = null, numberingSystem: r = null } = i, a = qe.fromOpts({
      locale: s,
      numberingSystem: r,
      defaultToEN: !0
    }), [o, l, u, c] = LM(a, e, n);
    return c ? ke.invalid(c) : _s(o, l, i, `format ${n}`, e, u);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(e, n, i = {}) {
    return ke.fromFormat(e, n, i);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(e, n = {}) {
    const [i, s] = pM(e);
    return _s(i, s, n, "SQL", e);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new Nt("need to specify a reason the DateTime is invalid");
    const i = e instanceof xn ? e : new xn(e, n);
    if (ft.throwOnInvalid)
      throw new Wk(i);
    return new ke({ invalid: i });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(e) {
    return e && e.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(e, n = {}) {
    const i = T0(e, qe.fromObject(n));
    return i ? i.map((s) => s ? s.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(e, n = {}) {
    return S0(zt.parseFormat(e), qe.fromObject(n)).map((s) => s.val).join("");
  }
  static resetCache() {
    Tr = void 0, ec.clear();
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(e) {
    return this[e];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? vl(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? vl(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? vl(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? bl(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? bl(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? bl(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? pl(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? $a.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? $a.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? $a.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? $a.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const e = 864e5, n = 6e4, i = Ao(this.c), s = this.zone.offset(i - e), r = this.zone.offset(i + e), a = this.zone.offset(i - s * n), o = this.zone.offset(i - r * n);
    if (a === o)
      return [this];
    const l = i - a * n, u = i - o * n, c = La(l, a), d = La(u, o);
    return c.hour === d.hour && c.minute === d.minute && c.second === d.second && c.millisecond === d.millisecond ? [Hi(this, { ts: l }), Hi(this, { ts: u })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return aa(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return po(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? Rs(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? Xr(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? Xr(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(e = {}) {
    const { locale: n, numberingSystem: i, calendar: s } = zt.create(
      this.loc.clone(e),
      e
    ).resolvedOptions(this);
    return { locale: n, numberingSystem: i, outputCalendar: s };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(e = 0, n = {}) {
    return this.setZone(qt.instance(e), n);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(ft.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(e, { keepLocalTime: n = !1, keepCalendarTime: i = !1 } = {}) {
    if (e = mi(e, ft.defaultZone), e.equals(this.zone))
      return this;
    if (e.isValid) {
      let s = this.ts;
      if (n || i) {
        const r = e.offset(this.ts), a = this.toObject();
        [s] = Ka(a, r, e);
      }
      return Hi(this, { ts: s, zone: e });
    } else
      return ke.invalid(Dr(e));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: e, numberingSystem: n, outputCalendar: i } = {}) {
    const s = this.loc.clone({ locale: e, numberingSystem: n, outputCalendar: i });
    return Hi(this, { loc: s });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(e) {
    return this.reconfigure({ locale: e });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(e) {
    if (!this.isValid) return this;
    const n = go(e, $h), { minDaysInFirstWeek: i, startOfWeek: s } = wh(n, this.loc), r = !Pe(n.weekYear) || !Pe(n.weekNumber) || !Pe(n.weekday), a = !Pe(n.ordinal), o = !Pe(n.year), l = !Pe(n.month) || !Pe(n.day), u = o || l, c = n.weekYear || n.weekNumber;
    if ((u || a) && c)
      throw new Ts(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (l && a)
      throw new Ts("Can't mix ordinal dates with month/day");
    let d;
    r ? d = vh(
      { ...mo(this.c, i, s), ...n },
      i,
      s
    ) : Pe(n.ordinal) ? (d = { ...this.toObject(), ...n }, Pe(n.day) && (d.day = Math.min(po(d.year, d.month), d.day))) : d = bh({ ...pl(this.c), ...n });
    const [f, h] = Ka(d, this.o, this.zone);
    return Hi(this, { ts: f, o: h });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(e) {
    if (!this.isValid) return this;
    const n = Be.fromDurationLike(e);
    return Hi(this, Ah(this, n));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(e) {
    if (!this.isValid) return this;
    const n = Be.fromDurationLike(e).negate();
    return Hi(this, Ah(this, n));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(e, { useLocaleWeeks: n = !1 } = {}) {
    if (!this.isValid) return this;
    const i = {}, s = Be.normalizeUnit(e);
    switch (s) {
      case "years":
        i.month = 1;
      // falls through
      case "quarters":
      case "months":
        i.day = 1;
      // falls through
      case "weeks":
      case "days":
        i.hour = 0;
      // falls through
      case "hours":
        i.minute = 0;
      // falls through
      case "minutes":
        i.second = 0;
      // falls through
      case "seconds":
        i.millisecond = 0;
        break;
    }
    if (s === "weeks")
      if (n) {
        const r = this.loc.getStartOfWeek(), { weekday: a } = this;
        a < r && (i.weekNumber = this.weekNumber - 1), i.weekday = r;
      } else
        i.weekday = 1;
    if (s === "quarters") {
      const r = Math.ceil(this.month / 3);
      i.month = (r - 1) * 3 + 1;
    }
    return this.set(i);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(e, n) {
    return this.isValid ? this.plus({ [e]: 1 }).startOf(e, n).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(e, n = {}) {
    return this.isValid ? zt.create(this.loc.redefaultToEN(n)).formatDateTimeFromString(this, e) : yl;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(e = ho, n = {}) {
    return this.isValid ? zt.create(this.loc.clone(n), e).formatDateTime(this) : yl;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(e = {}) {
    return this.isValid ? zt.create(this.loc.clone(e), e).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string|null}
   */
  toISO({
    format: e = "extended",
    suppressSeconds: n = !1,
    suppressMilliseconds: i = !1,
    includeOffset: s = !0,
    extendedZone: r = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const a = e === "extended";
    let o = wl(this, a);
    return o += "T", o += Eh(this, a, n, i, s, r), o;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string|null}
   */
  toISODate({ format: e = "extended" } = {}) {
    return this.isValid ? wl(this, e === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return Ia(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: e = !1,
    suppressSeconds: n = !1,
    includeOffset: i = !0,
    includePrefix: s = !1,
    extendedZone: r = !1,
    format: a = "extended"
  } = {}) {
    return this.isValid ? (s ? "T" : "") + Eh(
      this,
      a === "extended",
      n,
      e,
      i,
      r
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return Ia(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return Ia(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    return this.isValid ? wl(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: e = !0, includeZone: n = !1, includeOffsetSpace: i = !0 } = {}) {
    let s = "HH:mm:ss.SSS";
    return (n || e) && (i && (s += " "), n ? s += "z" : e && (s += "ZZ")), Ia(this, s, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(e = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(e)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : yl;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(e = {}) {
    if (!this.isValid) return {};
    const n = { ...this.c };
    return e.includeConfig && (n.outputCalendar = this.outputCalendar, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(e, n = "milliseconds", i = {}) {
    if (!this.isValid || !e.isValid)
      return Be.invalid("created by diffing an invalid DateTime");
    const s = { locale: this.locale, numberingSystem: this.numberingSystem, ...i }, r = v2(n).map(Be.normalizeUnit), a = e.valueOf() > this.valueOf(), o = a ? this : e, l = a ? e : this, u = _M(o, l, r, s);
    return a ? u.negate() : u;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(e = "milliseconds", n = {}) {
    return this.diff(ke.now(), e, n);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(e) {
    return this.isValid ? dt.fromDateTimes(this, e) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(e, n, i) {
    if (!this.isValid) return !1;
    const s = e.valueOf(), r = this.setZone(e.zone, { keepLocalTime: !0 });
    return r.startOf(n, i) <= s && s <= r.endOf(n, i);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(e) {
    return this.isValid && e.isValid && this.valueOf() === e.valueOf() && this.zone.equals(e.zone) && this.loc.equals(e.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(e = {}) {
    if (!this.isValid) return null;
    const n = e.base || ke.fromObject({}, { zone: this.zone }), i = e.padding ? this < n ? -e.padding : e.padding : 0;
    let s = ["years", "months", "days", "hours", "minutes", "seconds"], r = e.unit;
    return Array.isArray(e.unit) && (s = e.unit, r = void 0), Lh(n, this.plus(i), {
      ...e,
      numeric: "always",
      units: s,
      unit: r
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(e = {}) {
    return this.isValid ? Lh(e.base || ke.fromObject({}, { zone: this.zone }), this, {
      ...e,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...e) {
    if (!e.every(ke.isDateTime))
      throw new Nt("min requires all arguments be DateTimes");
    return xh(e, (n) => n.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...e) {
    if (!e.every(ke.isDateTime))
      throw new Nt("max requires all arguments be DateTimes");
    return xh(e, (n) => n.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(e, n, i = {}) {
    const { locale: s = null, numberingSystem: r = null } = i, a = qe.fromOpts({
      locale: s,
      numberingSystem: r,
      defaultToEN: !0
    });
    return D0(a, e, n);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(e, n, i = {}) {
    return ke.fromFormatExplain(e, n, i);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(e, n = {}) {
    const { locale: i = null, numberingSystem: s = null } = n, r = qe.fromOpts({
      locale: i,
      numberingSystem: s,
      defaultToEN: !0
    });
    return new O0(r, e);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(e, n, i = {}) {
    if (Pe(e) || Pe(n))
      throw new Nt(
        "fromFormatParser requires an input string and a format parser"
      );
    const { locale: s = null, numberingSystem: r = null } = i, a = qe.fromOpts({
      locale: s,
      numberingSystem: r,
      defaultToEN: !0
    });
    if (!a.equals(n.locale))
      throw new Nt(
        `fromFormatParser called with a locale of ${a}, but the format parser was created for ${n.locale}`
      );
    const { result: o, zone: l, specificOffset: u, invalidReason: c } = n.explainFromTokens(e);
    return c ? ke.invalid(c) : _s(
      o,
      l,
      i,
      `format ${n.format}`,
      e,
      u
    );
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return ho;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return Ag;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return jk;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return Eg;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return $g;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return Rg;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return Lg;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return Ig;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return Fg;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return Vg;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return Ng;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return Bg;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return zg;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return Wg;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return Hg;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return Yg;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return jg;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return qk;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return qg;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return Ug;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return Xg;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return Gg;
  }
}
function gr(t) {
  if (ke.isDateTime(t))
    return t;
  if (t && t.valueOf && Mi(t.valueOf()))
    return ke.fromJSDate(t);
  if (t && typeof t == "object")
    return ke.fromObject(t);
  throw new Nt(
    `Unknown datetime argument: ${t}, of type ${typeof t}`
  );
}
/*!
 * chartjs-adapter-luxon v1.3.1
 * https://www.chartjs.org
 * (c) 2023 chartjs-adapter-luxon Contributors
 * Released under the MIT license
 */
const WM = {
  datetime: ke.DATETIME_MED_WITH_SECONDS,
  millisecond: "h:mm:ss.SSS a",
  second: ke.TIME_WITH_SECONDS,
  minute: ke.TIME_SIMPLE,
  hour: { hour: "numeric" },
  day: { day: "numeric", month: "short" },
  week: "DD",
  month: { month: "short", year: "numeric" },
  quarter: "'Q'q - yyyy",
  year: { year: "numeric" }
};
og._date.override({
  _id: "luxon",
  // DEBUG
  /**
   * @private
   */
  _create: function(t) {
    return ke.fromMillis(t, this.options);
  },
  init(t) {
    this.options.locale || (this.options.locale = t.locale);
  },
  formats: function() {
    return WM;
  },
  parse: function(t, e) {
    const n = this.options, i = typeof t;
    return t === null || i === "undefined" ? null : (i === "number" ? t = this._create(t) : i === "string" ? typeof e == "string" ? t = ke.fromFormat(t, e, n) : t = ke.fromISO(t, n) : t instanceof Date ? t = ke.fromJSDate(t, n) : i === "object" && !(t instanceof ke) && (t = ke.fromObject(t, n)), t.isValid ? t.valueOf() : null);
  },
  format: function(t, e) {
    const n = this._create(t);
    return typeof e == "string" ? n.toFormat(e) : n.toLocaleString(e);
  },
  add: function(t, e, n) {
    const i = {};
    return i[n] = e, this._create(t).plus(i).valueOf();
  },
  diff: function(t, e, n) {
    return this._create(t).diff(this._create(e)).as(n).valueOf();
  },
  startOf: function(t, e, n) {
    if (e === "isoWeek") {
      n = Math.trunc(Math.min(Math.max(0, n), 6));
      const i = this._create(t);
      return i.minus({ days: (i.weekday - n + 7) % 7 }).startOf("day").valueOf();
    }
    return e ? this._create(t).startOf(e).valueOf() : t;
  },
  endOf: function(t, e) {
    return this._create(t).endOf(e).valueOf();
  }
});
/*!
* chartjs-plugin-annotation v3.1.0
* https://www.chartjs.org/chartjs-plugin-annotation/index
 * (c) 2024 chartjs-plugin-annotation Contributors
 * Released under the MIT License
 */
const Fh = {
  modes: {
    /**
     * Point mode returns all elements that hit test based on the event position
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @return {AnnotationElement[]} - elements that are found
     */
    point(t, e) {
      return Qa(t, e, { intersect: !0 });
    },
    /**
     * Nearest mode returns the element closest to the event position
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found (only 1 element)
     */
    nearest(t, e, n) {
      return jM(t, e, n);
    },
    /**
     * x mode returns the elements that hit-test at the current x coordinate
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */
    x(t, e, n) {
      return Qa(t, e, { intersect: n.intersect, axis: "x" });
    },
    /**
     * y mode returns the elements that hit-test at the current y coordinate
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */
    y(t, e, n) {
      return Qa(t, e, { intersect: n.intersect, axis: "y" });
    }
  }
};
function nd(t, e, n) {
  return (Fh.modes[n.mode] || Fh.modes.nearest)(t, e, n);
}
function HM(t, e, n) {
  return n !== "x" && n !== "y" ? t.inRange(e.x, e.y, "x", !0) || t.inRange(e.x, e.y, "y", !0) : t.inRange(e.x, e.y, n, !0);
}
function YM(t, e, n) {
  return n === "x" ? { x: t.x, y: e.y } : n === "y" ? { x: e.x, y: t.y } : e;
}
function Qa(t, e, n) {
  return t.filter((i) => n.intersect ? i.inRange(e.x, e.y) : HM(i, e, n.axis));
}
function jM(t, e, n) {
  let i = Number.POSITIVE_INFINITY;
  return Qa(t, e, n).reduce((s, r) => {
    const a = r.getCenterPoint(), o = YM(e, a, n.axis), l = Ws(e, o);
    return l < i ? (s = [r], i = l) : l === i && s.push(r), s;
  }, []).sort((s, r) => s._index - r._index).slice(0, 1);
}
function hs(t, e, n) {
  const i = Math.cos(n), s = Math.sin(n), r = e.x, a = e.y;
  return {
    x: r + i * (t.x - r) - s * (t.y - a),
    y: a + s * (t.x - r) + i * (t.y - a)
  };
}
const qM = (t, e) => e > t || t.length > e.length && t.slice(0, e.length) === e, Xi = 1e-3, Ro = (t, e, n) => Math.min(n, Math.max(e, t)), E0 = (t, e) => t.value >= t.start - e && t.value <= t.end + e;
function UM(t, e, n) {
  for (const i of Object.keys(t))
    t[i] = Ro(t[i], e, n);
  return t;
}
function XM(t, e, n, i) {
  return !t || !e || n <= 0 ? !1 : Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2) <= Math.pow(n + i, 2);
}
function $0(t, { x: e, y: n, x2: i, y2: s }, r, { borderWidth: a, hitTolerance: o }) {
  const l = (a + o) / 2, u = t.x >= e - l - Xi && t.x <= i + l + Xi, c = t.y >= n - l - Xi && t.y <= s + l + Xi;
  return r === "x" ? u : (r === "y" || u) && c;
}
function R0(t, { rect: e, center: n }, i, { rotation: s, borderWidth: r, hitTolerance: a }) {
  const o = hs(t, n, St(-s));
  return $0(o, e, i, { borderWidth: r, hitTolerance: a });
}
function ms(t, e) {
  const { centerX: n, centerY: i } = t.getProps(["centerX", "centerY"], e);
  return { x: n, y: i };
}
function GM(t, e, n, i = !0) {
  const s = n.split(".");
  let r = 0;
  for (const a of e.split(".")) {
    const o = s[r++];
    if (parseInt(a, 10) < parseInt(o, 10))
      break;
    if (qM(o, a)) {
      if (i)
        throw new Error(`${t} v${n} is not supported. v${e} or newer is required.`);
      return !1;
    }
  }
  return !0;
}
const L0 = (t) => typeof t == "string" && t.endsWith("%"), I0 = (t) => parseFloat(t) / 100, F0 = (t) => Ro(I0(t), 0, 1), yr = (t, e) => ({ x: t, y: e, x2: t, y2: e, width: 0, height: 0 }), ZM = {
  box: (t) => yr(t.centerX, t.centerY),
  doughnutLabel: (t) => yr(t.centerX, t.centerY),
  ellipse: (t) => ({ centerX: t.centerX, centerY: t.centerX, radius: 0, width: 0, height: 0 }),
  label: (t) => yr(t.centerX, t.centerY),
  line: (t) => yr(t.x, t.y),
  point: (t) => ({ centerX: t.centerX, centerY: t.centerY, radius: 0, width: 0, height: 0 }),
  polygon: (t) => yr(t.centerX, t.centerY)
};
function id(t, e) {
  return e === "start" ? 0 : e === "end" ? t : L0(e) ? F0(e) * t : t / 2;
}
function Ei(t, e, n = !0) {
  return typeof e == "number" ? e : L0(e) ? (n ? F0(e) : I0(e)) * t : t;
}
function KM(t, e) {
  const { x: n, width: i } = t, s = e.textAlign;
  return s === "center" ? n + i / 2 : s === "end" || s === "right" ? n + i : n;
}
function V0(t, e, { borderWidth: n, position: i, xAdjust: s, yAdjust: r }, a) {
  const o = Ae(a), l = e.width + (o ? a.width : 0) + n, u = e.height + (o ? a.height : 0) + n, c = sd(i), d = Vh(t.x, l, s, c.x), f = Vh(t.y, u, r, c.y);
  return {
    x: d,
    y: f,
    x2: d + l,
    y2: f + u,
    width: l,
    height: u,
    centerX: d + l / 2,
    centerY: f + u / 2
  };
}
function sd(t, e = "center") {
  return Ae(t) ? {
    x: De(t.x, e),
    y: De(t.y, e)
  } : (t = De(t, e), {
    x: t,
    y: t
  });
}
const N0 = (t, e) => t && t.autoFit && e < 1;
function B0(t, e) {
  const n = t.font, i = Ue(n) ? n : [n];
  return N0(t, e) ? i.map(function(s) {
    const r = mt(s);
    return r.size = Math.floor(s.size * e), r.lineHeight = s.lineHeight, mt(r);
  }) : i.map((s) => mt(s));
}
function z0(t) {
  return t && (en(t.xValue) || en(t.yValue));
}
function Vh(t, e, n = 0, i) {
  return t - id(e, i) + n;
}
function ar(t, e, n) {
  const i = n.init;
  if (i) {
    if (i === !0)
      return H0(e, n);
  } else return;
  return QM(t, e, n);
}
function W0(t, e, n) {
  let i = !1;
  return e.forEach((s) => {
    Qt(t[s]) ? (i = !0, n[s] = t[s]) : en(n[s]) && delete n[s];
  }), i;
}
function H0(t, e) {
  const n = e.type || "line";
  return ZM[n](t);
}
function QM(t, e, n) {
  const i = Ze(n.init, [{ chart: t, properties: e, options: n }]);
  if (i === !0)
    return H0(e, n);
  if (Ae(i))
    return i;
}
const xl = /* @__PURE__ */ new Map(), JM = (t) => isNaN(t) || t <= 0, eS = (t) => t.reduce(function(e, n) {
  return e += n.string, e;
}, "");
function Lo(t) {
  if (t && typeof t == "object") {
    const e = t.toString();
    return e === "[object HTMLImageElement]" || e === "[object HTMLCanvasElement]";
  }
}
function Io(t, { x: e, y: n }, i) {
  i && (t.translate(e, n), t.rotate(St(i)), t.translate(-e, -n));
}
function ti(t, e) {
  if (e && e.borderWidth)
    return t.lineCap = e.borderCapStyle || "butt", t.setLineDash(e.borderDash), t.lineDashOffset = e.borderDashOffset, t.lineJoin = e.borderJoinStyle || "miter", t.lineWidth = e.borderWidth, t.strokeStyle = e.borderColor, !0;
}
function or(t, e) {
  t.shadowColor = e.backgroundShadowColor, t.shadowBlur = e.shadowBlur, t.shadowOffsetX = e.shadowOffsetX, t.shadowOffsetY = e.shadowOffsetY;
}
function Fo(t, e) {
  const n = e.content;
  if (Lo(n))
    return {
      width: Ei(n.width, e.width),
      height: Ei(n.height, e.height)
    };
  const i = B0(e), s = e.textStrokeWidth, r = Ue(n) ? n : [n], a = r.join() + eS(i) + s + (t._measureText ? "-spriting" : "");
  return xl.has(a) || xl.set(a, sS(t, r, i, s)), xl.get(a);
}
function Y0(t, e, n) {
  const { x: i, y: s, width: r, height: a } = e;
  t.save(), or(t, n);
  const o = ti(t, n);
  t.fillStyle = n.backgroundColor, t.beginPath(), Hs(t, {
    x: i,
    y: s,
    w: r,
    h: a,
    radius: UM(ki(n.borderRadius), 0, Math.min(r, a) / 2)
  }), t.closePath(), t.fill(), o && (t.shadowColor = n.borderShadowColor, t.stroke()), t.restore();
}
function j0(t, e, n, i) {
  const s = n.content;
  if (Lo(s)) {
    t.save(), t.globalAlpha = oS(n.opacity, s.style.opacity), t.drawImage(s, e.x, e.y, e.width, e.height), t.restore();
    return;
  }
  const r = Ue(s) ? s : [s], a = B0(n, i), o = n.color, l = Ue(o) ? o : [o], u = KM(e, n), c = e.y + n.textStrokeWidth / 2;
  t.save(), t.textBaseline = "middle", t.textAlign = n.textAlign, tS(t, n) && rS(t, { x: u, y: c }, r, a), aS(t, { x: u, y: c }, r, { fonts: a, colors: l }), t.restore();
}
function tS(t, e) {
  if (e.textStrokeWidth > 0)
    return t.lineJoin = "round", t.miterLimit = 2, t.lineWidth = e.textStrokeWidth, t.strokeStyle = e.textStrokeColor, !0;
}
function nS(t, e, n, i) {
  const { radius: s, options: r } = e, a = r.pointStyle, o = r.rotation;
  let l = (o || 0) * Rc;
  if (Lo(a)) {
    t.save(), t.translate(n, i), t.rotate(l), t.drawImage(a, -a.width / 2, -a.height / 2, a.width, a.height), t.restore();
    return;
  }
  JM(s) || iS(t, { x: n, y: i, radius: s, rotation: o, style: a, rad: l });
}
function iS(t, { x: e, y: n, radius: i, rotation: s, style: r, rad: a }) {
  let o, l, u, c;
  switch (t.beginPath(), r) {
    // Default includes circle
    default:
      t.arc(e, n, i, 0, nt), t.closePath();
      break;
    case "triangle":
      t.moveTo(e + Math.sin(a) * i, n - Math.cos(a) * i), a += ro, t.lineTo(e + Math.sin(a) * i, n - Math.cos(a) * i), a += ro, t.lineTo(e + Math.sin(a) * i, n - Math.cos(a) * i), t.closePath();
      break;
    case "rectRounded":
      c = i * 0.516, u = i - c, o = Math.cos(a + dn) * u, l = Math.sin(a + dn) * u, t.arc(e - o, n - l, c, a - Ne, a - rt), t.arc(e + l, n - o, c, a - rt, a), t.arc(e + o, n + l, c, a, a + rt), t.arc(e - l, n + o, c, a + rt, a + Ne), t.closePath();
      break;
    case "rect":
      if (!s) {
        u = Math.SQRT1_2 * i, t.rect(e - u, n - u, 2 * u, 2 * u);
        break;
      }
      a += dn;
    /* falls through */
    case "rectRot":
      o = Math.cos(a) * i, l = Math.sin(a) * i, t.moveTo(e - o, n - l), t.lineTo(e + l, n - o), t.lineTo(e + o, n + l), t.lineTo(e - l, n + o), t.closePath();
      break;
    case "crossRot":
      a += dn;
    /* falls through */
    case "cross":
      o = Math.cos(a) * i, l = Math.sin(a) * i, t.moveTo(e - o, n - l), t.lineTo(e + o, n + l), t.moveTo(e + l, n - o), t.lineTo(e - l, n + o);
      break;
    case "star":
      o = Math.cos(a) * i, l = Math.sin(a) * i, t.moveTo(e - o, n - l), t.lineTo(e + o, n + l), t.moveTo(e + l, n - o), t.lineTo(e - l, n + o), a += dn, o = Math.cos(a) * i, l = Math.sin(a) * i, t.moveTo(e - o, n - l), t.lineTo(e + o, n + l), t.moveTo(e + l, n - o), t.lineTo(e - l, n + o);
      break;
    case "line":
      o = Math.cos(a) * i, l = Math.sin(a) * i, t.moveTo(e - o, n - l), t.lineTo(e + o, n + l);
      break;
    case "dash":
      t.moveTo(e, n), t.lineTo(e + Math.cos(a) * i, n + Math.sin(a) * i);
      break;
  }
  t.fill();
}
function sS(t, e, n, i) {
  t.save();
  const s = e.length;
  let r = 0, a = i;
  for (let o = 0; o < s; o++) {
    const l = n[Math.min(o, n.length - 1)];
    t.font = l.string;
    const u = e[o];
    r = Math.max(r, t.measureText(u).width + i), a += l.lineHeight;
  }
  return t.restore(), { width: r, height: a };
}
function rS(t, { x: e, y: n }, i, s) {
  t.beginPath();
  let r = 0;
  i.forEach(function(a, o) {
    const l = s[Math.min(o, s.length - 1)], u = l.lineHeight;
    t.font = l.string, t.strokeText(a, e, n + u / 2 + r), r += u;
  }), t.stroke();
}
function aS(t, { x: e, y: n }, i, { fonts: s, colors: r }) {
  let a = 0;
  i.forEach(function(o, l) {
    const u = r[Math.min(l, r.length - 1)], c = s[Math.min(l, s.length - 1)], d = c.lineHeight;
    t.beginPath(), t.font = c.string, t.fillStyle = u, t.fillText(o, e, n + d / 2 + a), a += d, t.fill();
  });
}
function oS(t, e) {
  const n = Ai(t) ? t : e;
  return Ai(n) ? Ro(n, 0, 1) : 1;
}
const q0 = ["left", "bottom", "top", "right"];
function lS(t, e) {
  const { pointX: n, pointY: i, options: s } = e, r = s.callout, a = r && r.display && hS(e, r);
  if (!a || pS(e, r, a))
    return;
  if (t.save(), t.beginPath(), !ti(t, r))
    return t.restore();
  const { separatorStart: l, separatorEnd: u } = uS(e, a), { sideStart: c, sideEnd: d } = dS(e, a, l);
  (r.margin > 0 || s.borderWidth === 0) && (t.moveTo(l.x, l.y), t.lineTo(u.x, u.y)), t.moveTo(c.x, c.y), t.lineTo(d.x, d.y);
  const f = hs({ x: n, y: i }, e.getCenterPoint(), St(-e.rotation));
  t.lineTo(f.x, f.y), t.stroke(), t.restore();
}
function uS(t, e) {
  const { x: n, y: i, x2: s, y2: r } = t, a = cS(t, e);
  let o, l;
  return e === "left" || e === "right" ? (o = { x: n + a, y: i }, l = { x: o.x, y: r }) : (o = { x: n, y: i + a }, l = { x: s, y: o.y }), { separatorStart: o, separatorEnd: l };
}
function cS(t, e) {
  const { width: n, height: i, options: s } = t, r = s.callout.margin + s.borderWidth / 2;
  return e === "right" ? n + r : e === "bottom" ? i + r : -r;
}
function dS(t, e, n) {
  const { y: i, width: s, height: r, options: a } = t, o = a.callout.start, l = fS(e, a.callout);
  let u, c;
  return e === "left" || e === "right" ? (u = { x: n.x, y: i + Ei(r, o) }, c = { x: u.x + l, y: u.y }) : (u = { x: n.x + Ei(s, o), y: n.y }, c = { x: u.x, y: u.y + l }), { sideStart: u, sideEnd: c };
}
function fS(t, e) {
  const n = e.side;
  return t === "left" || t === "top" ? -n : n;
}
function hS(t, e) {
  const n = e.position;
  return q0.includes(n) ? n : mS(t, e);
}
function mS(t, e) {
  const { x: n, y: i, x2: s, y2: r, width: a, height: o, pointX: l, pointY: u, centerX: c, centerY: d, rotation: f } = t, h = { x: c, y: d }, m = e.start, p = Ei(a, m), g = Ei(o, m), y = [n, n + p, n + p, s], v = [i + g, r, i, r], b = [];
  for (let _ = 0; _ < 4; _++) {
    const M = hs({ x: y[_], y: v[_] }, h, St(f));
    b.push({
      position: q0[_],
      distance: Ws(M, { x: l, y: u })
    });
  }
  return b.sort((_, M) => _.distance - M.distance)[0].position;
}
function pS(t, e, n) {
  const { pointX: i, pointY: s } = t, r = e.margin;
  let a = i, o = s;
  return n === "left" ? a += r : n === "right" ? a -= r : n === "top" ? o += r : n === "bottom" && (o -= r), t.inRange(a, o);
}
const Nh = {
  xScaleID: { min: "xMin", max: "xMax", start: "left", end: "right", startProp: "x", endProp: "x2" },
  yScaleID: { min: "yMin", max: "yMax", start: "bottom", end: "top", startProp: "y", endProp: "y2" }
};
function Us(t, e, n) {
  return e = typeof e == "number" ? e : t.parse(e), ot(e) ? t.getPixelForValue(e) : n;
}
function as(t, e, n) {
  const i = e[n];
  if (i || n === "scaleID")
    return i;
  const s = n.charAt(0), r = Object.values(t).filter((a) => a.axis && a.axis === s);
  return r.length ? r[0].id : s;
}
function U0(t, e) {
  if (t) {
    const n = t.options.reverse, i = Us(t, e.min, n ? e.end : e.start), s = Us(t, e.max, n ? e.start : e.end);
    return {
      start: i,
      end: s
    };
  }
}
function X0(t, e) {
  const { chartArea: n, scales: i } = t, s = i[as(i, e, "xScaleID")], r = i[as(i, e, "yScaleID")];
  let a = n.width / 2, o = n.height / 2;
  return s && (a = Us(s, e.xValue, s.left + s.width / 2)), r && (o = Us(r, e.yValue, r.top + r.height / 2)), { x: a, y: o };
}
function rd(t, e) {
  const n = t.scales, i = n[as(n, e, "xScaleID")], s = n[as(n, e, "yScaleID")];
  if (!i && !s)
    return {};
  let { left: r, right: a } = i || t.chartArea, { top: o, bottom: l } = s || t.chartArea;
  const u = Bh(i, { min: e.xMin, max: e.xMax, start: r, end: a });
  r = u.start, a = u.end;
  const c = Bh(s, { min: e.yMin, max: e.yMax, start: l, end: o });
  return o = c.start, l = c.end, {
    x: r,
    y: o,
    x2: a,
    y2: l,
    width: a - r,
    height: l - o,
    centerX: r + (a - r) / 2,
    centerY: o + (l - o) / 2
  };
}
function G0(t, e) {
  if (!z0(e)) {
    const n = rd(t, e);
    let i = e.radius;
    (!i || isNaN(i)) && (i = Math.min(n.width, n.height) / 2, e.radius = i);
    const s = i * 2, r = n.centerX + e.xAdjust, a = n.centerY + e.yAdjust;
    return {
      x: r - i,
      y: a - i,
      x2: r + i,
      y2: a + i,
      centerX: r,
      centerY: a,
      width: s,
      height: s,
      radius: i
    };
  }
  return yS(t, e);
}
function gS(t, e) {
  const { scales: n, chartArea: i } = t, s = n[e.scaleID], r = { x: i.left, y: i.top, x2: i.right, y2: i.bottom };
  return s ? vS(s, r, e) : bS(n, r, e), r;
}
function Z0(t, e) {
  const n = rd(t, e);
  return n.initProperties = ar(t, n, e), n.elements = [{
    type: "label",
    optionScope: "label",
    properties: _S(t, n, e),
    initProperties: n.initProperties
  }], n;
}
function yS(t, e) {
  const n = X0(t, e), i = e.radius * 2;
  return {
    x: n.x - e.radius + e.xAdjust,
    y: n.y - e.radius + e.yAdjust,
    x2: n.x + e.radius + e.xAdjust,
    y2: n.y + e.radius + e.yAdjust,
    centerX: n.x + e.xAdjust,
    centerY: n.y + e.yAdjust,
    radius: e.radius,
    width: i,
    height: i
  };
}
function Bh(t, e) {
  const n = U0(t, e) || e;
  return {
    start: Math.min(n.start, n.end),
    end: Math.max(n.start, n.end)
  };
}
function vS(t, e, n) {
  const i = Us(t, n.value, NaN), s = Us(t, n.endValue, i);
  t.isHorizontal() ? (e.x = i, e.x2 = s) : (e.y = i, e.y2 = s);
}
function bS(t, e, n) {
  for (const i of Object.keys(Nh)) {
    const s = t[as(t, n, i)];
    if (s) {
      const { min: r, max: a, start: o, end: l, startProp: u, endProp: c } = Nh[i], d = U0(s, { min: n[r], max: n[a], start: s[o], end: s[l] });
      e[u] = d.start, e[c] = d.end;
    }
  }
}
function wS({ properties: t, options: e }, n, i, s) {
  const { x: r, x2: a, width: o } = t;
  return K0({ start: r, end: a, borderWidth: e.borderWidth }, {
    position: i.x,
    padding: { start: s.left, end: s.right },
    adjust: e.label.xAdjust,
    size: n.width
  });
}
function xS({ properties: t, options: e }, n, i, s) {
  const { y: r, y2: a, height: o } = t;
  return K0({ start: r, end: a, borderWidth: e.borderWidth }, {
    position: i.y,
    padding: { start: s.top, end: s.bottom },
    adjust: e.label.yAdjust,
    size: n.height
  });
}
function K0(t, e) {
  const { start: n, end: i, borderWidth: s } = t, { position: r, padding: { start: a, end: o }, adjust: l } = e, u = i - s - n - a - o - e.size;
  return n + s / 2 + l + id(u, r);
}
function _S(t, e, n) {
  const i = n.label;
  i.backgroundColor = "transparent", i.callout.display = !1;
  const s = sd(i.position), r = Ot(i.padding), a = Fo(t.ctx, i), o = wS({ properties: e, options: n }, a, s, r), l = xS({ properties: e, options: n }, a, s, r), u = a.width + r.width, c = a.height + r.height;
  return {
    x: o,
    y: l,
    x2: o + u,
    y2: l + c,
    width: u,
    height: c,
    centerX: o + u / 2,
    centerY: l + c / 2,
    rotation: i.rotation
  };
}
const tc = ["enter", "leave"], ad = tc.concat("click");
function kS(t, e, n) {
  e.listened = W0(n, ad, e.listeners), e.moveListened = !1, tc.forEach((i) => {
    Qt(n[i]) && (e.moveListened = !0);
  }), (!e.listened || !e.moveListened) && e.annotations.forEach((i) => {
    !e.listened && Qt(i.click) && (e.listened = !0), e.moveListened || tc.forEach((s) => {
      Qt(i[s]) && (e.listened = !0, e.moveListened = !0);
    });
  });
}
function MS(t, e, n) {
  if (t.listened)
    switch (e.type) {
      case "mousemove":
      case "mouseout":
        return SS(t, e, n);
      case "click":
        return OS(t, e, n);
    }
}
function SS(t, e, n) {
  if (!t.moveListened)
    return;
  let i;
  e.type === "mousemove" ? i = nd(t.visibleElements, e, n.interaction) : i = [];
  const s = t.hovered;
  t.hovered = i;
  const r = { state: t, event: e };
  let a = zh(r, "leave", s, i);
  return zh(r, "enter", i, s) || a;
}
function zh({ state: t, event: e }, n, i, s) {
  let r;
  for (const a of i)
    s.indexOf(a) < 0 && (r = Q0(a.options[n] || t.listeners[n], a, e) || r);
  return r;
}
function OS(t, e, n) {
  const i = t.listeners, s = nd(t.visibleElements, e, n.interaction);
  let r;
  for (const a of s)
    r = Q0(a.options.click || i.click, a, e) || r;
  return r;
}
function Q0(t, e, n) {
  return Ze(t, [e.$context, n]) === !0;
}
const yo = ["afterDraw", "beforeDraw"];
function DS(t, e, n) {
  const i = e.visibleElements;
  e.hooked = W0(n, yo, e.hooks), e.hooked || i.forEach((s) => {
    e.hooked || yo.forEach((r) => {
      Qt(s.options[r]) && (e.hooked = !0);
    });
  });
}
function Wh(t, e, n) {
  if (t.hooked) {
    const i = e.options[n] || t.hooks[n];
    return Ze(i, [e.$context]);
  }
}
function TS(t, e, n) {
  const i = $S(t.scales, e, n);
  let s = Hh(e, i, "min", "suggestedMin");
  s = Hh(e, i, "max", "suggestedMax") || s, s && Qt(e.handleTickRangeOptions) && e.handleTickRangeOptions();
}
function PS(t, e) {
  for (const n of t)
    AS(n, e);
}
function Hh(t, e, n, i) {
  if (ot(e[n]) && !CS(t.options, n, i)) {
    const s = t[n] !== e[n];
    return t[n] = e[n], s;
  }
}
function CS(t, e, n) {
  return en(t[e]) || en(t[n]);
}
function AS(t, e) {
  for (const n of ["scaleID", "xScaleID", "yScaleID"]) {
    const i = as(e, t, n);
    i && !e[i] && ES(t, n) && console.warn(`No scale found with id '${i}' for annotation '${t.id}'`);
  }
}
function ES(t, e) {
  if (e === "scaleID")
    return !0;
  const n = e.charAt(0);
  for (const i of ["Min", "Max", "Value"])
    if (en(t[n + i]))
      return !0;
  return !1;
}
function $S(t, e, n) {
  const i = e.axis, s = e.id, r = i + "ScaleID", a = {
    min: De(e.min, Number.NEGATIVE_INFINITY),
    max: De(e.max, Number.POSITIVE_INFINITY)
  };
  for (const o of n)
    o.scaleID === s ? Yh(o, e, ["value", "endValue"], a) : as(t, o, r) === s && Yh(o, e, [i + "Min", i + "Max", i + "Value"], a);
  return a;
}
function Yh(t, e, n, i) {
  for (const s of n) {
    const r = t[s];
    if (en(r)) {
      const a = e.parse(r);
      i.min = Math.min(i.min, a), i.max = Math.max(i.max, a);
    }
  }
}
class lr extends Ht {
  inRange(e, n, i, s) {
    const { x: r, y: a } = hs({ x: e, y: n }, this.getCenterPoint(s), St(-this.options.rotation));
    return $0({ x: r, y: a }, this.getProps(["x", "y", "x2", "y2"], s), i, this.options);
  }
  getCenterPoint(e) {
    return ms(this, e);
  }
  draw(e) {
    e.save(), Io(e, this.getCenterPoint(), this.options.rotation), Y0(e, this, this.options), e.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(e, n) {
    return Z0(e, n);
  }
}
lr.id = "boxAnnotation";
lr.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderRadius: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  init: void 0,
  hitTolerance: 0,
  label: {
    backgroundColor: "transparent",
    borderWidth: 0,
    callout: {
      display: !1
    },
    color: "black",
    content: null,
    display: !1,
    drawTime: void 0,
    font: {
      family: void 0,
      lineHeight: void 0,
      size: void 0,
      style: void 0,
      weight: "bold"
    },
    height: void 0,
    hitTolerance: void 0,
    opacity: void 0,
    padding: 6,
    position: "center",
    rotation: void 0,
    textAlign: "start",
    textStrokeColor: void 0,
    textStrokeWidth: 0,
    width: void 0,
    xAdjust: 0,
    yAdjust: 0,
    z: void 0
  },
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
lr.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
lr.descriptors = {
  label: {
    _fallback: !0
  }
};
class Vo extends Ht {
  inRange(e, n, i, s) {
    return R0(
      { x: e, y: n },
      { rect: this.getProps(["x", "y", "x2", "y2"], s), center: this.getCenterPoint(s) },
      i,
      { rotation: this.rotation, borderWidth: 0, hitTolerance: this.options.hitTolerance }
    );
  }
  getCenterPoint(e) {
    return ms(this, e);
  }
  draw(e) {
    const n = this.options;
    !n.display || !n.content || (NS(e, this), e.save(), Io(e, this.getCenterPoint(), this.rotation), j0(e, this, n, this._fitRatio), e.restore());
  }
  resolveElementProperties(e, n) {
    const i = RS(e, n);
    if (!i)
      return {};
    const { controllerMeta: s, point: r, radius: a } = IS(e, n, i);
    let o = Fo(e.ctx, n);
    const l = FS(o, a);
    N0(n, l) && (o = { width: o.width * l, height: o.height * l });
    const { position: u, xAdjust: c, yAdjust: d } = n, f = V0(r, o, { borderWidth: 0, position: u, xAdjust: c, yAdjust: d });
    return {
      initProperties: ar(e, f, n),
      ...f,
      ...s,
      rotation: n.rotation,
      _fitRatio: l
    };
  }
}
Vo.id = "doughnutLabelAnnotation";
Vo.defaults = {
  autoFit: !0,
  autoHide: !0,
  backgroundColor: "transparent",
  backgroundShadowColor: "transparent",
  borderColor: "transparent",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderShadowColor: "transparent",
  borderWidth: 0,
  color: "black",
  content: null,
  display: !0,
  font: {
    family: void 0,
    lineHeight: void 0,
    size: void 0,
    style: void 0,
    weight: void 0
  },
  height: void 0,
  hitTolerance: 0,
  init: void 0,
  opacity: void 0,
  position: "center",
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  spacing: 1,
  textAlign: "center",
  textStrokeColor: void 0,
  textStrokeWidth: 0,
  width: void 0,
  xAdjust: 0,
  yAdjust: 0
};
Vo.defaultRoutes = {};
function RS(t, e) {
  return t.getSortedVisibleDatasetMetas().reduce(function(n, i) {
    const s = i.controller;
    return s instanceof yi && LS(t, e, i.data) && (!n || s.innerRadius < n.controller.innerRadius) && s.options.circumference >= 90 ? i : n;
  }, void 0);
}
function LS(t, e, n) {
  if (!e.autoHide)
    return !0;
  for (let i = 0; i < n.length; i++)
    if (!n[i].hidden && t.getDataVisibility(i))
      return !0;
}
function IS({ chartArea: t }, e, n) {
  const { left: i, top: s, right: r, bottom: a } = t, { innerRadius: o, offsetX: l, offsetY: u } = n.controller, c = (i + r) / 2 + l, d = (s + a) / 2 + u, f = {
    left: Math.max(c - o, i),
    right: Math.min(c + o, r),
    top: Math.max(d - o, s),
    bottom: Math.min(d + o, a)
  }, h = {
    x: (f.left + f.right) / 2,
    y: (f.top + f.bottom) / 2
  }, m = e.spacing + e.borderWidth / 2, p = o - m, g = h.y > d, y = g ? s + m : a - m, v = VS(y, c, d, p);
  return {
    controllerMeta: {
      _centerX: c,
      _centerY: d,
      _radius: p,
      _counterclockwise: g,
      ...v
    },
    point: h,
    radius: Math.min(o, Math.min(f.right - f.left, f.bottom - f.top) / 2)
  };
}
function FS({ width: t, height: e }, n) {
  const i = Math.sqrt(Math.pow(t, 2) + Math.pow(e, 2));
  return n * 2 / i;
}
function VS(t, e, n, i) {
  const s = Math.pow(n - t, 2), r = Math.pow(i, 2), a = e * -2, o = Math.pow(e, 2) + s - r, l = Math.pow(a, 2) - 4 * o;
  if (l <= 0)
    return {
      _startAngle: 0,
      _endAngle: nt
    };
  const u = (-a - Math.sqrt(l)) / 2, c = (-a + Math.sqrt(l)) / 2;
  return {
    _startAngle: ao({ x: e, y: n }, { x: u, y: t }).angle,
    _endAngle: ao({ x: e, y: n }, { x: c, y: t }).angle
  };
}
function NS(t, e) {
  const { _centerX: n, _centerY: i, _radius: s, _startAngle: r, _endAngle: a, _counterclockwise: o, options: l } = e;
  t.save();
  const u = ti(t, l);
  t.fillStyle = l.backgroundColor, t.beginPath(), t.arc(n, i, s, r, a, o), t.closePath(), t.fill(), u && t.stroke(), t.restore();
}
class ua extends Ht {
  inRange(e, n, i, s) {
    return R0(
      { x: e, y: n },
      { rect: this.getProps(["x", "y", "x2", "y2"], s), center: this.getCenterPoint(s) },
      i,
      { rotation: this.rotation, borderWidth: this.options.borderWidth, hitTolerance: this.options.hitTolerance }
    );
  }
  getCenterPoint(e) {
    return ms(this, e);
  }
  draw(e) {
    const n = this.options, i = !en(this._visible) || this._visible;
    !n.display || !n.content || !i || (e.save(), Io(e, this.getCenterPoint(), this.rotation), lS(e, this), Y0(e, this, n), j0(e, BS(this), n), e.restore());
  }
  resolveElementProperties(e, n) {
    let i;
    if (z0(n))
      i = X0(e, n);
    else {
      const { centerX: o, centerY: l } = rd(e, n);
      i = { x: o, y: l };
    }
    const s = Ot(n.padding), r = Fo(e.ctx, n), a = V0(i, r, n, s);
    return {
      initProperties: ar(e, a, n),
      pointX: i.x,
      pointY: i.y,
      ...a,
      rotation: n.rotation
    };
  }
}
ua.id = "labelAnnotation";
ua.defaults = {
  adjustScaleRange: !0,
  backgroundColor: "transparent",
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderRadius: 0,
  borderShadowColor: "transparent",
  borderWidth: 0,
  callout: {
    borderCapStyle: "butt",
    borderColor: void 0,
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 1,
    display: !1,
    margin: 5,
    position: "auto",
    side: 5,
    start: "50%"
  },
  color: "black",
  content: null,
  display: !0,
  font: {
    family: void 0,
    lineHeight: void 0,
    size: void 0,
    style: void 0,
    weight: void 0
  },
  height: void 0,
  hitTolerance: 0,
  init: void 0,
  opacity: void 0,
  padding: 6,
  position: "center",
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  textAlign: "center",
  textStrokeColor: void 0,
  textStrokeWidth: 0,
  width: void 0,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
ua.defaultRoutes = {
  borderColor: "color"
};
function BS({ x: t, y: e, width: n, height: i, options: s }) {
  const r = s.borderWidth / 2, a = Ot(s.padding);
  return {
    x: t + a.left + r,
    y: e + a.top + r,
    width: n - a.left - a.right - s.borderWidth,
    height: i - a.top - a.bottom - s.borderWidth
  };
}
const od = (t, e, n) => ({ x: t.x + n * (e.x - t.x), y: t.y + n * (e.y - t.y) }), nc = (t, e, n) => od(e, n, Math.abs((t - e.y) / (n.y - e.y))).x, jh = (t, e, n) => od(e, n, Math.abs((t - e.x) / (n.x - e.x))).y, Pr = (t) => t * t, zS = (t, e, { x: n, y: i, x2: s, y2: r }, a) => a === "y" ? { start: Math.min(i, r), end: Math.max(i, r), value: e } : { start: Math.min(n, s), end: Math.max(n, s), value: t }, qh = (t, e, n, i) => (1 - i) * (1 - i) * t + 2 * (1 - i) * i * e + i * i * n, ic = (t, e, n, i) => ({ x: qh(t.x, e.x, n.x, i), y: qh(t.y, e.y, n.y, i) }), Uh = (t, e, n, i) => 2 * (1 - i) * (e - t) + 2 * i * (n - e), Xh = (t, e, n, i) => -Math.atan2(Uh(t.x, e.x, n.x, i), Uh(t.y, e.y, n.y, i)) + 0.5 * Ne;
class ca extends Ht {
  inRange(e, n, i, s) {
    const r = (this.options.borderWidth + this.options.hitTolerance) / 2;
    if (i !== "x" && i !== "y") {
      const a = { mouseX: e, mouseY: n }, { path: o, ctx: l } = this;
      if (o) {
        ti(l, this.options), l.lineWidth += this.options.hitTolerance;
        const { chart: c } = this.$context, d = e * c.currentDevicePixelRatio, f = n * c.currentDevicePixelRatio, h = l.isPointInStroke(o, d, f) || sc(this, a, s);
        return l.restore(), h;
      }
      const u = Pr(r);
      return jS(this, a, u, s) || sc(this, a, s);
    }
    return WS(this, { mouseX: e, mouseY: n }, i, { hitSize: r, useFinalPosition: s });
  }
  getCenterPoint(e) {
    return ms(this, e);
  }
  draw(e) {
    const { x: n, y: i, x2: s, y2: r, cp: a, options: o } = this;
    if (e.save(), !ti(e, o))
      return e.restore();
    or(e, o);
    const l = Math.sqrt(Math.pow(s - n, 2) + Math.pow(r - i, 2));
    if (o.curve && a)
      return JS(e, this, a, l), e.restore();
    const { startOpts: u, endOpts: c, startAdjust: d, endAdjust: f } = J0(this), h = Math.atan2(r - i, s - n);
    e.translate(n, i), e.rotate(h), e.beginPath(), e.moveTo(0 + d, 0), e.lineTo(l - f, 0), e.shadowColor = o.borderShadowColor, e.stroke(), rc(e, 0, d, u), rc(e, l, -f, c), e.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(e, n) {
    const i = gS(e, n), { x: s, y: r, x2: a, y2: o } = i, l = HS(i, e.chartArea), u = l ? YS({ x: s, y: r }, { x: a, y: o }, e.chartArea) : { x: s, y: r, x2: a, y2: o, width: Math.abs(a - s), height: Math.abs(o - r) };
    if (u.centerX = (a + s) / 2, u.centerY = (o + r) / 2, u.initProperties = ar(e, u, n), n.curve) {
      const d = { x: u.x, y: u.y }, f = { x: u.x2, y: u.y2 };
      u.cp = QS(u, n, Ws(d, f));
    }
    const c = qS(e, u, n.label);
    return c._visible = l, u.elements = [{
      type: "label",
      optionScope: "label",
      properties: c,
      initProperties: u.initProperties
    }], u;
  }
}
ca.id = "lineAnnotation";
const Gh = {
  backgroundColor: void 0,
  backgroundShadowColor: void 0,
  borderColor: void 0,
  borderDash: void 0,
  borderDashOffset: void 0,
  borderShadowColor: void 0,
  borderWidth: void 0,
  display: void 0,
  fill: void 0,
  length: void 0,
  shadowBlur: void 0,
  shadowOffsetX: void 0,
  shadowOffsetY: void 0,
  width: void 0
};
ca.defaults = {
  adjustScaleRange: !0,
  arrowHeads: {
    display: !1,
    end: Object.assign({}, Gh),
    fill: !1,
    length: 12,
    start: Object.assign({}, Gh),
    width: 6
  },
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 2,
  curve: !1,
  controlPoint: {
    y: "-50%"
  },
  display: !0,
  endValue: void 0,
  init: void 0,
  hitTolerance: 0,
  label: {
    backgroundColor: "rgba(0,0,0,0.8)",
    backgroundShadowColor: "transparent",
    borderCapStyle: "butt",
    borderColor: "black",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderRadius: 6,
    borderShadowColor: "transparent",
    borderWidth: 0,
    callout: Object.assign({}, ua.defaults.callout),
    color: "#fff",
    content: null,
    display: !1,
    drawTime: void 0,
    font: {
      family: void 0,
      lineHeight: void 0,
      size: void 0,
      style: void 0,
      weight: "bold"
    },
    height: void 0,
    hitTolerance: void 0,
    opacity: void 0,
    padding: 6,
    position: "center",
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    textAlign: "center",
    textStrokeColor: void 0,
    textStrokeWidth: 0,
    width: void 0,
    xAdjust: 0,
    yAdjust: 0,
    z: void 0
  },
  scaleID: void 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  value: void 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
ca.descriptors = {
  arrowHeads: {
    start: {
      _fallback: !0
    },
    end: {
      _fallback: !0
    },
    _fallback: !0
  }
};
ca.defaultRoutes = {
  borderColor: "color"
};
function WS(t, { mouseX: e, mouseY: n }, i, { hitSize: s, useFinalPosition: r }) {
  const a = zS(e, n, t.getProps(["x", "y", "x2", "y2"], r), i);
  return E0(a, s) || sc(t, { mouseX: e, mouseY: n }, r, i);
}
function HS({ x: t, y: e, x2: n, y2: i }, { top: s, right: r, bottom: a, left: o }) {
  return !(t < o && n < o || t > r && n > r || e < s && i < s || e > a && i > a);
}
function Zh({ x: t, y: e }, n, { top: i, right: s, bottom: r, left: a }) {
  return t < a && (e = jh(a, { x: t, y: e }, n), t = a), t > s && (e = jh(s, { x: t, y: e }, n), t = s), e < i && (t = nc(i, { x: t, y: e }, n), e = i), e > r && (t = nc(r, { x: t, y: e }, n), e = r), { x: t, y: e };
}
function YS(t, e, n) {
  const { x: i, y: s } = Zh(t, e, n), { x: r, y: a } = Zh(e, t, n);
  return { x: i, y: s, x2: r, y2: a, width: Math.abs(r - i), height: Math.abs(a - s) };
}
function jS(t, { mouseX: e, mouseY: n }, i = Xi, s) {
  const { x: r, y: a, x2: o, y2: l } = t.getProps(["x", "y", "x2", "y2"], s), u = o - r, c = l - a, d = Pr(u) + Pr(c), f = d === 0 ? -1 : ((e - r) * u + (n - a) * c) / d;
  let h, m;
  return f < 0 ? (h = r, m = a) : f > 1 ? (h = o, m = l) : (h = r + f * u, m = a + f * c), Pr(e - h) + Pr(n - m) <= i;
}
function sc(t, { mouseX: e, mouseY: n }, i, s) {
  const r = t.label;
  return r.options.display && r.inRange(e, n, s, i);
}
function qS(t, e, n) {
  const i = n.borderWidth, s = Ot(n.padding), r = Fo(t.ctx, n), a = r.width + s.width + i, o = r.height + s.height + i;
  return XS(e, n, { width: a, height: o, padding: s }, t.chartArea);
}
function US(t) {
  const { x: e, y: n, x2: i, y2: s } = t, r = Math.atan2(s - n, i - e);
  return r > Ne / 2 ? r - Ne : r < Ne / -2 ? r + Ne : r;
}
function XS(t, e, n, i) {
  const { width: s, height: r, padding: a } = n, { xAdjust: o, yAdjust: l } = e, u = { x: t.x, y: t.y }, c = { x: t.x2, y: t.y2 }, d = e.rotation === "auto" ? US(t) : St(e.rotation), f = GS(s, r, d), h = ZS(t, e, { labelSize: f, padding: a }, i), m = t.cp ? ic(u, t.cp, c, h) : od(u, c, h), p = { size: f.w, min: i.left, max: i.right, padding: a.left }, g = { size: f.h, min: i.top, max: i.bottom, padding: a.top }, y = Qh(m.x, p) + o, v = Qh(m.y, g) + l;
  return {
    x: y - s / 2,
    y: v - r / 2,
    x2: y + s / 2,
    y2: v + r / 2,
    centerX: y,
    centerY: v,
    pointX: m.x,
    pointY: m.y,
    width: s,
    height: r,
    rotation: So(d)
  };
}
function GS(t, e, n) {
  const i = Math.cos(n), s = Math.sin(n);
  return {
    w: Math.abs(t * i) + Math.abs(e * s),
    h: Math.abs(t * s) + Math.abs(e * i)
  };
}
function ZS(t, e, n, i) {
  let s;
  const r = KS(t, i);
  return e.position === "start" ? s = Kh({ w: t.x2 - t.x, h: t.y2 - t.y }, n, e, r) : e.position === "end" ? s = 1 - Kh({ w: t.x - t.x2, h: t.y - t.y2 }, n, e, r) : s = id(1, e.position), s;
}
function Kh(t, e, n, i) {
  const { labelSize: s, padding: r } = e, a = t.w * i.dx, o = t.h * i.dy, l = a > 0 && (s.w / 2 + r.left - i.x) / a, u = o > 0 && (s.h / 2 + r.top - i.y) / o;
  return Ro(Math.max(l, u), 0, 0.25);
}
function KS(t, e) {
  const { x: n, x2: i, y: s, y2: r } = t, a = Math.min(s, r) - e.top, o = Math.min(n, i) - e.left, l = e.bottom - Math.max(s, r), u = e.right - Math.max(n, i);
  return {
    x: Math.min(o, u),
    y: Math.min(a, l),
    dx: o <= u ? 1 : -1,
    dy: a <= l ? 1 : -1
  };
}
function Qh(t, e) {
  const { size: n, min: i, max: s, padding: r } = e, a = n / 2;
  return n > s - i ? (s + i) / 2 : (i >= t - r - a && (t = i + r + a), s <= t + r + a && (t = s - r - a), t);
}
function J0(t) {
  const e = t.options, n = e.arrowHeads && e.arrowHeads.start, i = e.arrowHeads && e.arrowHeads.end;
  return {
    startOpts: n,
    endOpts: i,
    startAdjust: Jh(t, n),
    endAdjust: Jh(t, i)
  };
}
function Jh(t, e) {
  if (!e || !e.display)
    return 0;
  const { length: n, width: i } = e, s = t.options.borderWidth / 2, r = { x: n, y: i + s };
  return Math.abs(nc(0, r, { x: 0, y: s }));
}
function rc(t, e, n, i) {
  if (!i || !i.display)
    return;
  const { length: s, width: r, fill: a, backgroundColor: o, borderColor: l } = i, u = Math.abs(e - s) + n;
  t.beginPath(), or(t, i), ti(t, i), t.moveTo(u, -r), t.lineTo(e + n, 0), t.lineTo(u, r), a === !0 ? (t.fillStyle = o || l, t.closePath(), t.fill(), t.shadowColor = "transparent") : t.shadowColor = i.borderShadowColor, t.stroke();
}
function QS(t, e, n) {
  const { x: i, y: s, x2: r, y2: a, centerX: o, centerY: l } = t, u = Math.atan2(a - s, r - i), c = sd(e.controlPoint, 0), d = {
    x: o + Ei(n, c.x, !1),
    y: l + Ei(n, c.y, !1)
  };
  return hs(d, { x: o, y: l }, u);
}
function em(t, { x: e, y: n }, { angle: i, adjust: s }, r) {
  !r || !r.display || (t.save(), t.translate(e, n), t.rotate(i), rc(t, 0, -s, r), t.restore());
}
function JS(t, e, n, i) {
  const { x: s, y: r, x2: a, y2: o, options: l } = e, { startOpts: u, endOpts: c, startAdjust: d, endAdjust: f } = J0(e), h = { x: s, y: r }, m = { x: a, y: o }, p = Xh(h, n, m, 0), g = Xh(h, n, m, 1) - Ne, y = ic(h, n, m, d / i), v = ic(h, n, m, 1 - f / i), b = new Path2D();
  t.beginPath(), b.moveTo(y.x, y.y), b.quadraticCurveTo(n.x, n.y, v.x, v.y), t.shadowColor = l.borderShadowColor, t.stroke(b), e.path = b, e.ctx = t, em(t, y, { angle: p, adjust: d }, u), em(t, v, { angle: g, adjust: f }, c);
}
class da extends Ht {
  inRange(e, n, i, s) {
    const r = this.options.rotation, a = (this.options.borderWidth + this.options.hitTolerance) / 2;
    if (i !== "x" && i !== "y")
      return eO({ x: e, y: n }, this.getProps(["width", "height", "centerX", "centerY"], s), r, a);
    const { x: o, y: l, x2: u, y2: c } = this.getProps(["x", "y", "x2", "y2"], s), d = i === "y" ? { start: l, end: c } : { start: o, end: u }, f = hs({ x: e, y: n }, this.getCenterPoint(s), St(-r));
    return f[i] >= d.start - a - Xi && f[i] <= d.end + a + Xi;
  }
  getCenterPoint(e) {
    return ms(this, e);
  }
  draw(e) {
    const { width: n, height: i, centerX: s, centerY: r, options: a } = this;
    e.save(), Io(e, this.getCenterPoint(), a.rotation), or(e, this.options), e.beginPath(), e.fillStyle = a.backgroundColor;
    const o = ti(e, a);
    e.ellipse(s, r, i / 2, n / 2, Ne / 2, 0, 2 * Ne), e.fill(), o && (e.shadowColor = a.borderShadowColor, e.stroke()), e.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(e, n) {
    return Z0(e, n);
  }
}
da.id = "ellipseAnnotation";
da.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  hitTolerance: 0,
  init: void 0,
  label: Object.assign({}, lr.defaults.label),
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
da.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
da.descriptors = {
  label: {
    _fallback: !0
  }
};
function eO(t, e, n, i) {
  const { width: s, height: r, centerX: a, centerY: o } = e, l = s / 2, u = r / 2;
  if (l <= 0 || u <= 0)
    return !1;
  const c = St(n || 0), d = Math.cos(c), f = Math.sin(c), h = Math.pow(d * (t.x - a) + f * (t.y - o), 2), m = Math.pow(f * (t.x - a) - d * (t.y - o), 2);
  return h / Math.pow(l + i, 2) + m / Math.pow(u + i, 2) <= 1.0001;
}
class No extends Ht {
  inRange(e, n, i, s) {
    const { x: r, y: a, x2: o, y2: l, width: u } = this.getProps(["x", "y", "x2", "y2", "width"], s), c = (this.options.borderWidth + this.options.hitTolerance) / 2;
    return i !== "x" && i !== "y" ? XM({ x: e, y: n }, this.getCenterPoint(s), u / 2, c) : E0(i === "y" ? { start: a, end: l, value: n } : { start: r, end: o, value: e }, c);
  }
  getCenterPoint(e) {
    return ms(this, e);
  }
  draw(e) {
    const n = this.options, i = n.borderWidth;
    if (n.radius < 0.1)
      return;
    e.save(), e.fillStyle = n.backgroundColor, or(e, n);
    const s = ti(e, n);
    nS(e, this, this.centerX, this.centerY), s && !Lo(n.pointStyle) && (e.shadowColor = n.borderShadowColor, e.stroke()), e.restore(), n.borderWidth = i;
  }
  resolveElementProperties(e, n) {
    const i = G0(e, n);
    return i.initProperties = ar(e, i, n), i;
  }
}
No.id = "pointAnnotation";
No.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  hitTolerance: 0,
  init: void 0,
  pointStyle: "circle",
  radius: 10,
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
No.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
class Bo extends Ht {
  inRange(e, n, i, s) {
    if (i !== "x" && i !== "y")
      return this.options.radius >= 0.1 && this.elements.length > 1 && nO(this.elements, e, n, s);
    const r = hs({ x: e, y: n }, this.getCenterPoint(s), St(-this.options.rotation)), a = this.elements.map((u) => i === "y" ? u.bY : u.bX), o = Math.min(...a), l = Math.max(...a);
    return r[i] >= o && r[i] <= l;
  }
  getCenterPoint(e) {
    return ms(this, e);
  }
  draw(e) {
    const { elements: n, options: i } = this;
    e.save(), e.beginPath(), e.fillStyle = i.backgroundColor, or(e, i);
    const s = ti(e, i);
    let r = !0;
    for (const a of n)
      r ? (e.moveTo(a.x, a.y), r = !1) : e.lineTo(a.x, a.y);
    e.closePath(), e.fill(), s && (e.shadowColor = i.borderShadowColor, e.stroke()), e.restore();
  }
  resolveElementProperties(e, n) {
    const i = G0(e, n), { sides: s, rotation: r } = n, a = [], o = 2 * Ne / s;
    let l = r * Rc;
    for (let u = 0; u < s; u++, l += o) {
      const c = tO(i, n, l);
      c.initProperties = ar(e, i, n), a.push(c);
    }
    return i.elements = a, i;
  }
}
Bo.id = "polygonAnnotation";
Bo.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  hitTolerance: 0,
  init: void 0,
  point: {
    radius: 0
  },
  radius: 10,
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  sides: 3,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
Bo.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
function tO({ centerX: t, centerY: e }, { radius: n, borderWidth: i, hitTolerance: s }, r) {
  const a = (i + s) / 2, o = Math.sin(r), l = Math.cos(r), u = { x: t + o * n, y: e - l * n };
  return {
    type: "point",
    optionScope: "point",
    properties: {
      x: u.x,
      y: u.y,
      centerX: u.x,
      centerY: u.y,
      bX: t + o * (n + a),
      bY: e - l * (n + a)
    }
  };
}
function nO(t, e, n, i) {
  let s = !1, r = t[t.length - 1].getProps(["bX", "bY"], i);
  for (const a of t) {
    const o = a.getProps(["bX", "bY"], i);
    o.bY > n != r.bY > n && e < (r.bX - o.bX) * (n - o.bY) / (r.bY - o.bY) + o.bX && (s = !s), r = o;
  }
  return s;
}
const Si = {
  box: lr,
  doughnutLabel: Vo,
  ellipse: da,
  label: ua,
  line: ca,
  point: No,
  polygon: Bo
};
Object.keys(Si).forEach((t) => {
  at.describe(`elements.${Si[t].id}`, {
    _fallback: "plugins.annotation.common"
  });
});
const iO = {
  update: Object.assign
}, sO = ad.concat(yo), tm = (t, e) => Ae(e) ? oc(t, e) : t, ac = (t) => t === "color" || t === "font";
function ld(t = "line") {
  return Si[t] ? t : (console.warn(`Unknown annotation type: '${t}', defaulting to 'line'`), "line");
}
function rO(t, e, n, i) {
  const s = oO(t, n.animations, i), r = e.annotations, a = cO(e.elements, r);
  for (let o = 0; o < r.length; o++) {
    const l = r[o], u = ey(a, o, l.type), c = l.setContext(uO(t, u, a, l)), d = u.resolveElementProperties(t, c);
    d.skip = aO(d), "elements" in d && (lO(u, d.elements, c, s), delete d.elements), en(u.x) || Object.assign(u, d), Object.assign(u, d.initProperties), d.options = ty(c), s.update(u, d);
  }
}
function aO(t) {
  return isNaN(t.x) || isNaN(t.y);
}
function oO(t, e, n) {
  return n === "reset" || n === "none" || n === "resize" ? iO : new Yc(t, e);
}
function lO(t, e, n, i) {
  const s = t.elements || (t.elements = []);
  s.length = e.length;
  for (let r = 0; r < e.length; r++) {
    const a = e[r], o = a.properties, l = ey(s, r, a.type, a.initProperties), u = n[a.optionScope].override(a);
    o.options = ty(u), i.update(l, o);
  }
}
function ey(t, e, n, i) {
  const s = Si[ld(n)];
  let r = t[e];
  return (!r || !(r instanceof s)) && (r = t[e] = new s(), Object.assign(r, i)), r;
}
function ty(t) {
  const e = Si[ld(t.type)], n = {};
  n.id = t.id, n.type = t.type, n.drawTime = t.drawTime, Object.assign(
    n,
    oc(t, e.defaults),
    oc(t, e.defaultRoutes)
  );
  for (const i of sO)
    n[i] = t[i];
  return n;
}
function oc(t, e) {
  const n = {};
  for (const i of Object.keys(e)) {
    const s = e[i], r = t[i];
    ac(i) && Ue(r) ? n[i] = r.map((a) => tm(a, s)) : n[i] = tm(r, s);
  }
  return n;
}
function uO(t, e, n, i) {
  return e.$context || (e.$context = Object.assign(Object.create(t.getContext()), {
    element: e,
    get elements() {
      return n.filter((s) => s && s.options);
    },
    id: i.id,
    type: "annotation"
  }));
}
function cO(t, e) {
  const n = e.length, i = t.length;
  if (i < n) {
    const s = n - i;
    t.splice(i, 0, ...new Array(s));
  } else i > n && t.splice(n, i - n);
  return t;
}
var dO = "3.1.0";
const ci = /* @__PURE__ */ new Map(), nm = (t) => t.type !== "doughnutLabel", fO = ad.concat(yo);
var hO = {
  id: "annotation",
  version: dO,
  beforeRegister() {
    GM("chart.js", "4.0", Ji.version);
  },
  afterRegister() {
    Ji.register(Si);
  },
  afterUnregister() {
    Ji.unregister(Si);
  },
  beforeInit(t) {
    ci.set(t, {
      annotations: [],
      elements: [],
      visibleElements: [],
      listeners: {},
      listened: !1,
      moveListened: !1,
      hooks: {},
      hooked: !1,
      hovered: []
    });
  },
  beforeUpdate(t, e, n) {
    const i = ci.get(t), s = i.annotations = [];
    let r = n.annotations;
    Ae(r) ? Object.keys(r).forEach((a) => {
      const o = r[a];
      Ae(o) && (o.id = a, s.push(o));
    }) : Ue(r) && s.push(...r), PS(s.filter(nm), t.scales);
  },
  afterDataLimits(t, e) {
    const n = ci.get(t);
    TS(t, e.scale, n.annotations.filter(nm).filter((i) => i.display && i.adjustScaleRange));
  },
  afterUpdate(t, e, n) {
    const i = ci.get(t);
    kS(t, i, n), rO(t, i, n, e.mode), i.visibleElements = i.elements.filter((s) => !s.skip && s.options.display), DS(t, i, n);
  },
  beforeDatasetsDraw(t, e, n) {
    vr(t, "beforeDatasetsDraw", n.clip);
  },
  afterDatasetsDraw(t, e, n) {
    vr(t, "afterDatasetsDraw", n.clip);
  },
  beforeDatasetDraw(t, e, n) {
    vr(t, e.index, n.clip);
  },
  beforeDraw(t, e, n) {
    vr(t, "beforeDraw", n.clip);
  },
  afterDraw(t, e, n) {
    vr(t, "afterDraw", n.clip);
  },
  beforeEvent(t, e, n) {
    const i = ci.get(t);
    MS(i, e.event, n) && (e.changed = !0);
  },
  afterDestroy(t) {
    ci.delete(t);
  },
  getAnnotations(t) {
    const e = ci.get(t);
    return e ? e.elements : [];
  },
  // only for testing
  _getAnnotationElementsAtEventForMode(t, e, n) {
    return nd(t, e, n);
  },
  defaults: {
    animations: {
      numbers: {
        properties: ["x", "y", "x2", "y2", "width", "height", "centerX", "centerY", "pointX", "pointY", "radius"],
        type: "number"
      },
      colors: {
        properties: ["backgroundColor", "borderColor"],
        type: "color"
      }
    },
    clip: !0,
    interaction: {
      mode: void 0,
      axis: void 0,
      intersect: void 0
    },
    common: {
      drawTime: "afterDatasetsDraw",
      init: !1,
      label: {}
    }
  },
  descriptors: {
    _indexable: !1,
    _scriptable: (t) => !fO.includes(t) && t !== "init",
    annotations: {
      _allKeys: !1,
      _fallback: (t, e) => `elements.${Si[ld(e.type)].id}`
    },
    interaction: {
      _fallback: !0
    },
    common: {
      label: {
        _indexable: ac,
        _fallback: !0
      },
      _indexable: ac
    }
  },
  additionalOptionScopes: [""]
};
function vr(t, e, n) {
  const { ctx: i, chartArea: s } = t, r = ci.get(t);
  n && na(i, s);
  const a = mO(r.visibleElements, e).sort((o, l) => o.element.options.z - l.element.options.z);
  for (const o of a)
    pO(i, s, r, o);
  n && ia(i);
}
function mO(t, e) {
  const n = [];
  for (const i of t)
    if (i.options.drawTime === e && n.push({ element: i, main: !0 }), i.elements && i.elements.length)
      for (const s of i.elements)
        s.options.display && s.options.drawTime === e && n.push({ element: s });
  return n;
}
function pO(t, e, n, i) {
  const s = i.element;
  i.main ? (Wh(n, s, "beforeDraw"), s.draw(t, e), Wh(n, s, "afterDraw")) : s.draw(t, e);
}
function gO(t, e, n) {
  const i = {};
  [...new Set(Object.values(t).map((o) => o.axis))].forEach((o) => {
    i[o] = { min: 0, max: 0 };
  }), Object.values(e).forEach((o) => {
    Object.entries(o).forEach(([l, u]) => {
      if (!t[l])
        return;
      u *= t[l].rescale ?? 1;
      const c = i[t[l].axis];
      u < c.min && (c.min = u), u > c.max && (c.max = u);
    });
  });
  const r = Object.values(i).map((o) => [
    o.min / (o.max - o.min),
    o.max / (o.max - o.min)
  ]).reduce(
    (o, [l, u]) => (l < o.min && (o.min = l), u > o.max && (o.max = u), o),
    { min: 0, max: 0 }
  );
  let a = {
    min: 1,
    max: 1
  };
  if (n) {
    const o = Object.keys(i)[0], l = i[o], u = l.max - l.min;
    a.min = Math.floor(u * r.min / n) * n / (u * r.min), a.max = Math.ceil(u * r.max / n) * n / (u * r.max);
  }
  return Object.values(i).forEach((o) => {
    const l = o.max - o.min;
    o.min = l * r.min * a.min, o.max = l * r.max * a.max;
  }), i;
}
function _l(t, e, n, i) {
  let s = n ? gb(t, n, e ?? 0) : zr(t, e ?? 0);
  return i ? i.replace("_", s) : s;
}
function lc(t, e) {
  const n = { ...t };
  for (const i in e)
    e[i] instanceof Object && i in t ? n[i] = lc(t[i], e[i]) : n[i] = e[i];
  return n;
}
function ny(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var kl = {}, Ml = {}, Sl = {}, im;
function iy() {
  return im || (im = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(n) {
      if (n = `${n}`, n === "0")
        return "0";
      if (/^[+-]?(\d+|\d*\.\d+)(e[+-]?\d+)?(%|\w+)?$/.test(n))
        return n.replace(/^[+-]?/, (s) => s === "-" ? "" : "-");
      let i = [
        "var",
        "calc",
        "min",
        "max",
        "clamp"
      ];
      for (const s of i)
        if (n.includes(`${s}(`))
          return `calc(${n} * -1)`;
    }
  }(Sl)), Sl;
}
var Ol = {}, sm;
function yO() {
  return sm || (sm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    const e = [
      "preflight",
      "container",
      "accessibility",
      "pointerEvents",
      "visibility",
      "position",
      "inset",
      "isolation",
      "zIndex",
      "order",
      "gridColumn",
      "gridColumnStart",
      "gridColumnEnd",
      "gridRow",
      "gridRowStart",
      "gridRowEnd",
      "float",
      "clear",
      "margin",
      "boxSizing",
      "lineClamp",
      "display",
      "aspectRatio",
      "size",
      "height",
      "maxHeight",
      "minHeight",
      "width",
      "minWidth",
      "maxWidth",
      "flex",
      "flexShrink",
      "flexGrow",
      "flexBasis",
      "tableLayout",
      "captionSide",
      "borderCollapse",
      "borderSpacing",
      "transformOrigin",
      "translate",
      "rotate",
      "skew",
      "scale",
      "transform",
      "animation",
      "cursor",
      "touchAction",
      "userSelect",
      "resize",
      "scrollSnapType",
      "scrollSnapAlign",
      "scrollSnapStop",
      "scrollMargin",
      "scrollPadding",
      "listStylePosition",
      "listStyleType",
      "listStyleImage",
      "appearance",
      "columns",
      "breakBefore",
      "breakInside",
      "breakAfter",
      "gridAutoColumns",
      "gridAutoFlow",
      "gridAutoRows",
      "gridTemplateColumns",
      "gridTemplateRows",
      "flexDirection",
      "flexWrap",
      "placeContent",
      "placeItems",
      "alignContent",
      "alignItems",
      "justifyContent",
      "justifyItems",
      "gap",
      "space",
      "divideWidth",
      "divideStyle",
      "divideColor",
      "divideOpacity",
      "placeSelf",
      "alignSelf",
      "justifySelf",
      "overflow",
      "overscrollBehavior",
      "scrollBehavior",
      "textOverflow",
      "hyphens",
      "whitespace",
      "textWrap",
      "wordBreak",
      "borderRadius",
      "borderWidth",
      "borderStyle",
      "borderColor",
      "borderOpacity",
      "backgroundColor",
      "backgroundOpacity",
      "backgroundImage",
      "gradientColorStops",
      "boxDecorationBreak",
      "backgroundSize",
      "backgroundAttachment",
      "backgroundClip",
      "backgroundPosition",
      "backgroundRepeat",
      "backgroundOrigin",
      "fill",
      "stroke",
      "strokeWidth",
      "objectFit",
      "objectPosition",
      "padding",
      "textAlign",
      "textIndent",
      "verticalAlign",
      "fontFamily",
      "fontSize",
      "fontWeight",
      "textTransform",
      "fontStyle",
      "fontVariantNumeric",
      "lineHeight",
      "letterSpacing",
      "textColor",
      "textOpacity",
      "textDecoration",
      "textDecorationColor",
      "textDecorationStyle",
      "textDecorationThickness",
      "textUnderlineOffset",
      "fontSmoothing",
      "placeholderColor",
      "placeholderOpacity",
      "caretColor",
      "accentColor",
      "opacity",
      "backgroundBlendMode",
      "mixBlendMode",
      "boxShadow",
      "boxShadowColor",
      "outlineStyle",
      "outlineWidth",
      "outlineOffset",
      "outlineColor",
      "ringWidth",
      "ringColor",
      "ringOpacity",
      "ringOffsetWidth",
      "ringOffsetColor",
      "blur",
      "brightness",
      "contrast",
      "dropShadow",
      "grayscale",
      "hueRotate",
      "invert",
      "saturate",
      "sepia",
      "filter",
      "backdropBlur",
      "backdropBrightness",
      "backdropContrast",
      "backdropGrayscale",
      "backdropHueRotate",
      "backdropInvert",
      "backdropOpacity",
      "backdropSaturate",
      "backdropSepia",
      "backdropFilter",
      "transitionProperty",
      "transitionDelay",
      "transitionDuration",
      "transitionTimingFunction",
      "willChange",
      "contain",
      "content",
      "forcedColorAdjust"
    ];
  }(Ol)), Ol;
}
var Dl = {}, rm;
function vO() {
  return rm || (rm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(n, i) {
      return n === void 0 ? i : Array.isArray(n) ? n : [
        ...new Set(i.filter((r) => n !== !1 && n[r] !== !1).concat(Object.keys(n).filter((r) => n[r] !== !1)))
      ];
    }
  }(Dl)), Dl;
}
var Tl = {}, Pl = {}, Fa = { exports: {} }, am;
function sy() {
  if (am) return Fa.exports;
  am = 1;
  var t = String, e = function() {
    return { isColorSupported: !1, reset: t, bold: t, dim: t, italic: t, underline: t, inverse: t, hidden: t, strikethrough: t, black: t, red: t, green: t, yellow: t, blue: t, magenta: t, cyan: t, white: t, gray: t, bgBlack: t, bgRed: t, bgGreen: t, bgYellow: t, bgBlue: t, bgMagenta: t, bgCyan: t, bgWhite: t, blackBright: t, redBright: t, greenBright: t, yellowBright: t, blueBright: t, magentaBright: t, cyanBright: t, whiteBright: t, bgBlackBright: t, bgRedBright: t, bgGreenBright: t, bgYellowBright: t, bgBlueBright: t, bgMagentaBright: t, bgCyanBright: t, bgWhiteBright: t };
  };
  return Fa.exports = e(), Fa.exports.createColors = e, Fa.exports;
}
var om;
function ud() {
  return om || (om = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function e(l, u) {
      for (var c in u) Object.defineProperty(l, c, {
        enumerable: !0,
        get: u[c]
      });
    }
    e(t, {
      dim: function() {
        return a;
      },
      default: function() {
        return o;
      }
    });
    const n = /* @__PURE__ */ i(/* @__PURE__ */ sy());
    function i(l) {
      return l && l.__esModule ? l : {
        default: l
      };
    }
    let s = /* @__PURE__ */ new Set();
    function r(l, u, c) {
      typeof process < "u" && process.env.JEST_WORKER_ID || c && s.has(c) || (c && s.add(c), console.warn(""), u.forEach((d) => console.warn(l, "-", d)));
    }
    function a(l) {
      return n.default.dim(l);
    }
    const o = {
      info(l, u) {
        r(n.default.bold(n.default.cyan("info")), ...Array.isArray(l) ? [
          l
        ] : [
          u,
          l
        ]);
      },
      warn(l, u) {
        r(n.default.bold(n.default.yellow("warn")), ...Array.isArray(l) ? [
          l
        ] : [
          u,
          l
        ]);
      },
      risk(l, u) {
        r(n.default.bold(n.default.magenta("risk")), ...Array.isArray(l) ? [
          l
        ] : [
          u,
          l
        ]);
      }
    };
  }(Pl)), Pl;
}
var lm;
function ry() {
  return lm || (lm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const e = /* @__PURE__ */ n(ud());
    function n(r) {
      return r && r.__esModule ? r : {
        default: r
      };
    }
    function i({ version: r, from: a, to: o }) {
      e.default.warn(`${a}-color-renamed`, [
        `As of Tailwind CSS ${r}, \`${a}\` has been renamed to \`${o}\`.`,
        "Update your configuration file to silence this warning."
      ]);
    }
    const s = {
      inherit: "inherit",
      current: "currentColor",
      transparent: "transparent",
      black: "#000",
      white: "#fff",
      slate: {
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a",
        950: "#020617"
      },
      gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
        950: "#030712"
      },
      zinc: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b",
        950: "#09090b"
      },
      neutral: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717",
        950: "#0a0a0a"
      },
      stone: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917",
        950: "#0c0a09"
      },
      red: {
        50: "#fef2f2",
        100: "#fee2e2",
        200: "#fecaca",
        300: "#fca5a5",
        400: "#f87171",
        500: "#ef4444",
        600: "#dc2626",
        700: "#b91c1c",
        800: "#991b1b",
        900: "#7f1d1d",
        950: "#450a0a"
      },
      orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12",
        950: "#431407"
      },
      amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f",
        950: "#451a03"
      },
      yellow: {
        50: "#fefce8",
        100: "#fef9c3",
        200: "#fef08a",
        300: "#fde047",
        400: "#facc15",
        500: "#eab308",
        600: "#ca8a04",
        700: "#a16207",
        800: "#854d0e",
        900: "#713f12",
        950: "#422006"
      },
      lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314",
        950: "#1a2e05"
      },
      green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#bbf7d0",
        300: "#86efac",
        400: "#4ade80",
        500: "#22c55e",
        600: "#16a34a",
        700: "#15803d",
        800: "#166534",
        900: "#14532d",
        950: "#052e16"
      },
      emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b",
        950: "#022c22"
      },
      teal: {
        50: "#f0fdfa",
        100: "#ccfbf1",
        200: "#99f6e4",
        300: "#5eead4",
        400: "#2dd4bf",
        500: "#14b8a6",
        600: "#0d9488",
        700: "#0f766e",
        800: "#115e59",
        900: "#134e4a",
        950: "#042f2e"
      },
      cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63",
        950: "#083344"
      },
      sky: {
        50: "#f0f9ff",
        100: "#e0f2fe",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e",
        950: "#082f49"
      },
      blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
        950: "#172554"
      },
      indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81",
        950: "#1e1b4b"
      },
      violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95",
        950: "#2e1065"
      },
      purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d8b4fe",
        400: "#c084fc",
        500: "#a855f7",
        600: "#9333ea",
        700: "#7e22ce",
        800: "#6b21a8",
        900: "#581c87",
        950: "#3b0764"
      },
      fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75",
        950: "#4a044e"
      },
      pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fbcfe8",
        300: "#f9a8d4",
        400: "#f472b6",
        500: "#ec4899",
        600: "#db2777",
        700: "#be185d",
        800: "#9d174d",
        900: "#831843",
        950: "#500724"
      },
      rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337",
        950: "#4c0519"
      },
      get lightBlue() {
        return i({
          version: "v2.2",
          from: "lightBlue",
          to: "sky"
        }), this.sky;
      },
      get warmGray() {
        return i({
          version: "v3.0",
          from: "warmGray",
          to: "stone"
        }), this.stone;
      },
      get trueGray() {
        return i({
          version: "v3.0",
          from: "trueGray",
          to: "neutral"
        }), this.neutral;
      },
      get coolGray() {
        return i({
          version: "v3.0",
          from: "coolGray",
          to: "gray"
        }), this.gray;
      },
      get blueGray() {
        return i({
          version: "v3.0",
          from: "blueGray",
          to: "slate"
        }), this.slate;
      }
    };
  }(Tl)), Tl;
}
var Cl = {}, um;
function bO() {
  return um || (um = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "defaults", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(n, ...i) {
      for (let a of i) {
        for (let o in a) {
          var s;
          !(n == null || (s = n.hasOwnProperty) === null || s === void 0) && s.call(n, o) || (n[o] = a[o]);
        }
        for (let o of Object.getOwnPropertySymbols(a)) {
          var r;
          !(n == null || (r = n.hasOwnProperty) === null || r === void 0) && r.call(n, o) || (n[o] = a[o]);
        }
      }
      return n;
    }
  }(Cl)), Cl;
}
var Al = {}, cm;
function wO() {
  return cm || (cm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "toPath", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(n) {
      if (Array.isArray(n)) return n;
      let i = n.split("[").length - 1, s = n.split("]").length - 1;
      if (i !== s)
        throw new Error(`Path is invalid. Has unbalanced brackets: ${n}`);
      return n.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
    }
  }(Al)), Al;
}
var El = {}, $l = {}, dm;
function cd() {
  return dm || (dm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function e(d, f) {
      for (var h in f) Object.defineProperty(d, h, {
        enumerable: !0,
        get: f[h]
      });
    }
    e(t, {
      flagEnabled: function() {
        return o;
      },
      issueFlagNotices: function() {
        return u;
      },
      default: function() {
        return c;
      }
    });
    const n = /* @__PURE__ */ s(/* @__PURE__ */ sy()), i = /* @__PURE__ */ s(ud());
    function s(d) {
      return d && d.__esModule ? d : {
        default: d
      };
    }
    let r = {
      optimizeUniversalDefaults: !1,
      generalizedModifiers: !0,
      disableColorOpacityUtilitiesByDefault: !1,
      relativeContentPathsByDefault: !1
    }, a = {
      future: [
        "hoverOnlyWhenSupported",
        "respectDefaultRingColorOpacity",
        "disableColorOpacityUtilitiesByDefault",
        "relativeContentPathsByDefault"
      ],
      experimental: [
        "optimizeUniversalDefaults",
        "generalizedModifiers"
      ]
    };
    function o(d, f) {
      if (a.future.includes(f)) {
        var h, m, p;
        return d.future === "all" || ((p = (m = d == null || (h = d.future) === null || h === void 0 ? void 0 : h[f]) !== null && m !== void 0 ? m : r[f]) !== null && p !== void 0 ? p : !1);
      }
      if (a.experimental.includes(f)) {
        var g, y, v;
        return d.experimental === "all" || ((v = (y = d == null || (g = d.experimental) === null || g === void 0 ? void 0 : g[f]) !== null && y !== void 0 ? y : r[f]) !== null && v !== void 0 ? v : !1);
      }
      return !1;
    }
    function l(d) {
      if (d.experimental === "all")
        return a.experimental;
      var f;
      return Object.keys((f = d == null ? void 0 : d.experimental) !== null && f !== void 0 ? f : {}).filter((h) => a.experimental.includes(h) && d.experimental[h]);
    }
    function u(d) {
      if (process.env.JEST_WORKER_ID === void 0 && l(d).length > 0) {
        let f = l(d).map((h) => n.default.yellow(h)).join(", ");
        i.default.warn("experimental-flags-enabled", [
          `You have enabled experimental features: ${f}`,
          "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."
        ]);
      }
    }
    const c = a;
  }($l)), $l;
}
var fm;
function xO() {
  return fm || (fm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "normalizeConfig", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const e = cd(), n = /* @__PURE__ */ s(ud());
    function i(a) {
      if (typeof WeakMap != "function") return null;
      var o = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
      return (i = function(u) {
        return u ? l : o;
      })(a);
    }
    function s(a, o) {
      if (a && a.__esModule)
        return a;
      if (a === null || typeof a != "object" && typeof a != "function")
        return {
          default: a
        };
      var l = i(o);
      if (l && l.has(a))
        return l.get(a);
      var u = {}, c = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var d in a)
        if (d !== "default" && Object.prototype.hasOwnProperty.call(a, d)) {
          var f = c ? Object.getOwnPropertyDescriptor(a, d) : null;
          f && (f.get || f.set) ? Object.defineProperty(u, d, f) : u[d] = a[d];
        }
      return u.default = a, l && l.set(a, u), u;
    }
    function r(a) {
      if ((() => {
        if (a.purge || !a.content || !Array.isArray(a.content) && !(typeof a.content == "object" && a.content !== null))
          return !1;
        if (Array.isArray(a.content))
          return a.content.every((u) => typeof u == "string" ? !0 : !(typeof (u == null ? void 0 : u.raw) != "string" || u != null && u.extension && typeof (u == null ? void 0 : u.extension) != "string"));
        if (typeof a.content == "object" && a.content !== null) {
          if (Object.keys(a.content).some((u) => ![
            "files",
            "relative",
            "extract",
            "transform"
          ].includes(u)))
            return !1;
          if (Array.isArray(a.content.files)) {
            if (!a.content.files.every((u) => typeof u == "string" ? !0 : !(typeof (u == null ? void 0 : u.raw) != "string" || u != null && u.extension && typeof (u == null ? void 0 : u.extension) != "string")))
              return !1;
            if (typeof a.content.extract == "object") {
              for (let u of Object.values(a.content.extract))
                if (typeof u != "function")
                  return !1;
            } else if (!(a.content.extract === void 0 || typeof a.content.extract == "function"))
              return !1;
            if (typeof a.content.transform == "object") {
              for (let u of Object.values(a.content.transform))
                if (typeof u != "function")
                  return !1;
            } else if (!(a.content.transform === void 0 || typeof a.content.transform == "function"))
              return !1;
            if (typeof a.content.relative != "boolean" && typeof a.content.relative < "u")
              return !1;
          }
          return !0;
        }
        return !1;
      })() || n.default.warn("purge-deprecation", [
        "The `purge`/`content` options have changed in Tailwind CSS v3.0.",
        "Update your configuration file to eliminate this warning.",
        "https://tailwindcss.com/docs/upgrade-guide#configure-content-sources"
      ]), a.safelist = (() => {
        var u;
        let { content: c, purge: d, safelist: f } = a;
        return Array.isArray(f) ? f : Array.isArray(c == null ? void 0 : c.safelist) ? c.safelist : Array.isArray(d == null ? void 0 : d.safelist) ? d.safelist : Array.isArray(d == null || (u = d.options) === null || u === void 0 ? void 0 : u.safelist) ? d.options.safelist : [];
      })(), a.blocklist = (() => {
        let { blocklist: u } = a;
        if (Array.isArray(u)) {
          if (u.every((c) => typeof c == "string"))
            return u;
          n.default.warn("blocklist-invalid", [
            "The `blocklist` option must be an array of strings.",
            "https://tailwindcss.com/docs/content-configuration#discarding-classes"
          ]);
        }
        return [];
      })(), typeof a.prefix == "function")
        n.default.warn("prefix-function", [
          "As of Tailwind CSS v3.0, `prefix` cannot be a function.",
          "Update `prefix` in your configuration to be a string to eliminate this warning.",
          "https://tailwindcss.com/docs/upgrade-guide#prefix-cannot-be-a-function"
        ]), a.prefix = "";
      else {
        var l;
        a.prefix = (l = a.prefix) !== null && l !== void 0 ? l : "";
      }
      a.content = {
        relative: (() => {
          let { content: u } = a;
          return u != null && u.relative ? u.relative : (0, e.flagEnabled)(a, "relativeContentPathsByDefault");
        })(),
        files: (() => {
          let { content: u, purge: c } = a;
          return Array.isArray(c) ? c : Array.isArray(c == null ? void 0 : c.content) ? c.content : Array.isArray(u) ? u : Array.isArray(u == null ? void 0 : u.content) ? u.content : Array.isArray(u == null ? void 0 : u.files) ? u.files : [];
        })(),
        extract: (() => {
          let u = (() => {
            var f, h, m, p, g, y, v, b, _, M;
            return !((f = a.purge) === null || f === void 0) && f.extract ? a.purge.extract : !((h = a.content) === null || h === void 0) && h.extract ? a.content.extract : !((m = a.purge) === null || m === void 0 || (p = m.extract) === null || p === void 0) && p.DEFAULT ? a.purge.extract.DEFAULT : !((g = a.content) === null || g === void 0 || (y = g.extract) === null || y === void 0) && y.DEFAULT ? a.content.extract.DEFAULT : !((v = a.purge) === null || v === void 0 || (b = v.options) === null || b === void 0) && b.extractors ? a.purge.options.extractors : !((_ = a.content) === null || _ === void 0 || (M = _.options) === null || M === void 0) && M.extractors ? a.content.options.extractors : {};
          })(), c = {}, d = (() => {
            var f, h, m, p;
            if (!((f = a.purge) === null || f === void 0 || (h = f.options) === null || h === void 0) && h.defaultExtractor)
              return a.purge.options.defaultExtractor;
            if (!((m = a.content) === null || m === void 0 || (p = m.options) === null || p === void 0) && p.defaultExtractor)
              return a.content.options.defaultExtractor;
          })();
          if (d !== void 0 && (c.DEFAULT = d), typeof u == "function")
            c.DEFAULT = u;
          else if (Array.isArray(u))
            for (let { extensions: f, extractor: h } of u ?? [])
              for (let m of f)
                c[m] = h;
          else typeof u == "object" && u !== null && Object.assign(c, u);
          return c;
        })(),
        transform: (() => {
          let u = (() => {
            var d, f, h, m, p, g;
            return !((d = a.purge) === null || d === void 0) && d.transform ? a.purge.transform : !((f = a.content) === null || f === void 0) && f.transform ? a.content.transform : !((h = a.purge) === null || h === void 0 || (m = h.transform) === null || m === void 0) && m.DEFAULT ? a.purge.transform.DEFAULT : !((p = a.content) === null || p === void 0 || (g = p.transform) === null || g === void 0) && g.DEFAULT ? a.content.transform.DEFAULT : {};
          })(), c = {};
          return typeof u == "function" ? c.DEFAULT = u : typeof u == "object" && u !== null && Object.assign(c, u), c;
        })()
      };
      for (let u of a.content.files)
        if (typeof u == "string" && /{([^,]*?)}/g.test(u)) {
          n.default.warn("invalid-glob-braces", [
            `The glob pattern ${(0, n.dim)(u)} in your Tailwind CSS configuration is invalid.`,
            `Update it to ${(0, n.dim)(u.replace(/{([^,]*?)}/g, "$1"))} to silence this warning.`
          ]);
          break;
        }
      return a;
    }
  }(El)), El;
}
var Rl = {}, hm;
function _O() {
  return hm || (hm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(n) {
      if (Object.prototype.toString.call(n) !== "[object Object]")
        return !1;
      const i = Object.getPrototypeOf(n);
      return i === null || Object.getPrototypeOf(i) === null;
    }
  }(Rl)), Rl;
}
var Ll = {}, mm;
function ay() {
  return mm || (mm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "cloneDeep", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(n) {
      return Array.isArray(n) ? n.map((i) => e(i)) : typeof n == "object" && n !== null ? Object.fromEntries(Object.entries(n).map(([i, s]) => [
        i,
        e(s)
      ])) : n;
    }
  }(Ll)), Ll;
}
var Il = {}, Fl = {}, pm;
function kO() {
  return pm || (pm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(n) {
      return n.replace(/\\,/g, "\\2c ");
    }
  }(Fl)), Fl;
}
var Vl = {}, Nl = {}, Bl = {}, gm;
function MO() {
  return gm || (gm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    const e = {
      aliceblue: [
        240,
        248,
        255
      ],
      antiquewhite: [
        250,
        235,
        215
      ],
      aqua: [
        0,
        255,
        255
      ],
      aquamarine: [
        127,
        255,
        212
      ],
      azure: [
        240,
        255,
        255
      ],
      beige: [
        245,
        245,
        220
      ],
      bisque: [
        255,
        228,
        196
      ],
      black: [
        0,
        0,
        0
      ],
      blanchedalmond: [
        255,
        235,
        205
      ],
      blue: [
        0,
        0,
        255
      ],
      blueviolet: [
        138,
        43,
        226
      ],
      brown: [
        165,
        42,
        42
      ],
      burlywood: [
        222,
        184,
        135
      ],
      cadetblue: [
        95,
        158,
        160
      ],
      chartreuse: [
        127,
        255,
        0
      ],
      chocolate: [
        210,
        105,
        30
      ],
      coral: [
        255,
        127,
        80
      ],
      cornflowerblue: [
        100,
        149,
        237
      ],
      cornsilk: [
        255,
        248,
        220
      ],
      crimson: [
        220,
        20,
        60
      ],
      cyan: [
        0,
        255,
        255
      ],
      darkblue: [
        0,
        0,
        139
      ],
      darkcyan: [
        0,
        139,
        139
      ],
      darkgoldenrod: [
        184,
        134,
        11
      ],
      darkgray: [
        169,
        169,
        169
      ],
      darkgreen: [
        0,
        100,
        0
      ],
      darkgrey: [
        169,
        169,
        169
      ],
      darkkhaki: [
        189,
        183,
        107
      ],
      darkmagenta: [
        139,
        0,
        139
      ],
      darkolivegreen: [
        85,
        107,
        47
      ],
      darkorange: [
        255,
        140,
        0
      ],
      darkorchid: [
        153,
        50,
        204
      ],
      darkred: [
        139,
        0,
        0
      ],
      darksalmon: [
        233,
        150,
        122
      ],
      darkseagreen: [
        143,
        188,
        143
      ],
      darkslateblue: [
        72,
        61,
        139
      ],
      darkslategray: [
        47,
        79,
        79
      ],
      darkslategrey: [
        47,
        79,
        79
      ],
      darkturquoise: [
        0,
        206,
        209
      ],
      darkviolet: [
        148,
        0,
        211
      ],
      deeppink: [
        255,
        20,
        147
      ],
      deepskyblue: [
        0,
        191,
        255
      ],
      dimgray: [
        105,
        105,
        105
      ],
      dimgrey: [
        105,
        105,
        105
      ],
      dodgerblue: [
        30,
        144,
        255
      ],
      firebrick: [
        178,
        34,
        34
      ],
      floralwhite: [
        255,
        250,
        240
      ],
      forestgreen: [
        34,
        139,
        34
      ],
      fuchsia: [
        255,
        0,
        255
      ],
      gainsboro: [
        220,
        220,
        220
      ],
      ghostwhite: [
        248,
        248,
        255
      ],
      gold: [
        255,
        215,
        0
      ],
      goldenrod: [
        218,
        165,
        32
      ],
      gray: [
        128,
        128,
        128
      ],
      green: [
        0,
        128,
        0
      ],
      greenyellow: [
        173,
        255,
        47
      ],
      grey: [
        128,
        128,
        128
      ],
      honeydew: [
        240,
        255,
        240
      ],
      hotpink: [
        255,
        105,
        180
      ],
      indianred: [
        205,
        92,
        92
      ],
      indigo: [
        75,
        0,
        130
      ],
      ivory: [
        255,
        255,
        240
      ],
      khaki: [
        240,
        230,
        140
      ],
      lavender: [
        230,
        230,
        250
      ],
      lavenderblush: [
        255,
        240,
        245
      ],
      lawngreen: [
        124,
        252,
        0
      ],
      lemonchiffon: [
        255,
        250,
        205
      ],
      lightblue: [
        173,
        216,
        230
      ],
      lightcoral: [
        240,
        128,
        128
      ],
      lightcyan: [
        224,
        255,
        255
      ],
      lightgoldenrodyellow: [
        250,
        250,
        210
      ],
      lightgray: [
        211,
        211,
        211
      ],
      lightgreen: [
        144,
        238,
        144
      ],
      lightgrey: [
        211,
        211,
        211
      ],
      lightpink: [
        255,
        182,
        193
      ],
      lightsalmon: [
        255,
        160,
        122
      ],
      lightseagreen: [
        32,
        178,
        170
      ],
      lightskyblue: [
        135,
        206,
        250
      ],
      lightslategray: [
        119,
        136,
        153
      ],
      lightslategrey: [
        119,
        136,
        153
      ],
      lightsteelblue: [
        176,
        196,
        222
      ],
      lightyellow: [
        255,
        255,
        224
      ],
      lime: [
        0,
        255,
        0
      ],
      limegreen: [
        50,
        205,
        50
      ],
      linen: [
        250,
        240,
        230
      ],
      magenta: [
        255,
        0,
        255
      ],
      maroon: [
        128,
        0,
        0
      ],
      mediumaquamarine: [
        102,
        205,
        170
      ],
      mediumblue: [
        0,
        0,
        205
      ],
      mediumorchid: [
        186,
        85,
        211
      ],
      mediumpurple: [
        147,
        112,
        219
      ],
      mediumseagreen: [
        60,
        179,
        113
      ],
      mediumslateblue: [
        123,
        104,
        238
      ],
      mediumspringgreen: [
        0,
        250,
        154
      ],
      mediumturquoise: [
        72,
        209,
        204
      ],
      mediumvioletred: [
        199,
        21,
        133
      ],
      midnightblue: [
        25,
        25,
        112
      ],
      mintcream: [
        245,
        255,
        250
      ],
      mistyrose: [
        255,
        228,
        225
      ],
      moccasin: [
        255,
        228,
        181
      ],
      navajowhite: [
        255,
        222,
        173
      ],
      navy: [
        0,
        0,
        128
      ],
      oldlace: [
        253,
        245,
        230
      ],
      olive: [
        128,
        128,
        0
      ],
      olivedrab: [
        107,
        142,
        35
      ],
      orange: [
        255,
        165,
        0
      ],
      orangered: [
        255,
        69,
        0
      ],
      orchid: [
        218,
        112,
        214
      ],
      palegoldenrod: [
        238,
        232,
        170
      ],
      palegreen: [
        152,
        251,
        152
      ],
      paleturquoise: [
        175,
        238,
        238
      ],
      palevioletred: [
        219,
        112,
        147
      ],
      papayawhip: [
        255,
        239,
        213
      ],
      peachpuff: [
        255,
        218,
        185
      ],
      peru: [
        205,
        133,
        63
      ],
      pink: [
        255,
        192,
        203
      ],
      plum: [
        221,
        160,
        221
      ],
      powderblue: [
        176,
        224,
        230
      ],
      purple: [
        128,
        0,
        128
      ],
      rebeccapurple: [
        102,
        51,
        153
      ],
      red: [
        255,
        0,
        0
      ],
      rosybrown: [
        188,
        143,
        143
      ],
      royalblue: [
        65,
        105,
        225
      ],
      saddlebrown: [
        139,
        69,
        19
      ],
      salmon: [
        250,
        128,
        114
      ],
      sandybrown: [
        244,
        164,
        96
      ],
      seagreen: [
        46,
        139,
        87
      ],
      seashell: [
        255,
        245,
        238
      ],
      sienna: [
        160,
        82,
        45
      ],
      silver: [
        192,
        192,
        192
      ],
      skyblue: [
        135,
        206,
        235
      ],
      slateblue: [
        106,
        90,
        205
      ],
      slategray: [
        112,
        128,
        144
      ],
      slategrey: [
        112,
        128,
        144
      ],
      snow: [
        255,
        250,
        250
      ],
      springgreen: [
        0,
        255,
        127
      ],
      steelblue: [
        70,
        130,
        180
      ],
      tan: [
        210,
        180,
        140
      ],
      teal: [
        0,
        128,
        128
      ],
      thistle: [
        216,
        191,
        216
      ],
      tomato: [
        255,
        99,
        71
      ],
      turquoise: [
        64,
        224,
        208
      ],
      violet: [
        238,
        130,
        238
      ],
      wheat: [
        245,
        222,
        179
      ],
      white: [
        255,
        255,
        255
      ],
      whitesmoke: [
        245,
        245,
        245
      ],
      yellow: [
        255,
        255,
        0
      ],
      yellowgreen: [
        154,
        205,
        50
      ]
    };
  }(Bl)), Bl;
}
var ym;
function oy() {
  return ym || (ym = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function e(m, p) {
      for (var g in p) Object.defineProperty(m, g, {
        enumerable: !0,
        get: p[g]
      });
    }
    e(t, {
      parseColor: function() {
        return f;
      },
      formatColor: function() {
        return h;
      }
    });
    const n = /* @__PURE__ */ i(MO());
    function i(m) {
      return m && m.__esModule ? m : {
        default: m
      };
    }
    let s = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, r = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, a = /(?:\d+|\d*\.\d+)%?/, o = /(?:\s*,\s*|\s+)/, l = /\s*[,/]\s*/, u = /var\(--(?:[^ )]*?)(?:,(?:[^ )]*?|var\(--[^ )]*?\)))?\)/, c = new RegExp(`^(rgba?)\\(\\s*(${a.source}|${u.source})(?:${o.source}(${a.source}|${u.source}))?(?:${o.source}(${a.source}|${u.source}))?(?:${l.source}(${a.source}|${u.source}))?\\s*\\)$`), d = new RegExp(`^(hsla?)\\(\\s*((?:${a.source})(?:deg|rad|grad|turn)?|${u.source})(?:${o.source}(${a.source}|${u.source}))?(?:${o.source}(${a.source}|${u.source}))?(?:${l.source}(${a.source}|${u.source}))?\\s*\\)$`);
    function f(m, { loose: p = !1 } = {}) {
      var g, y;
      if (typeof m != "string")
        return null;
      if (m = m.trim(), m === "transparent")
        return {
          mode: "rgb",
          color: [
            "0",
            "0",
            "0"
          ],
          alpha: "0"
        };
      if (m in n.default)
        return {
          mode: "rgb",
          color: n.default[m].map((A) => A.toString())
        };
      let v = m.replace(r, (A, E, I, S, $) => [
        "#",
        E,
        E,
        I,
        I,
        S,
        S,
        $ ? $ + $ : ""
      ].join("")).match(s);
      if (v !== null)
        return {
          mode: "rgb",
          color: [
            parseInt(v[1], 16),
            parseInt(v[2], 16),
            parseInt(v[3], 16)
          ].map((A) => A.toString()),
          alpha: v[4] ? (parseInt(v[4], 16) / 255).toString() : void 0
        };
      var b;
      let _ = (b = m.match(c)) !== null && b !== void 0 ? b : m.match(d);
      if (_ === null)
        return null;
      let M = [
        _[2],
        _[3],
        _[4]
      ].filter(Boolean).map((A) => A.toString());
      return M.length === 2 && M[0].startsWith("var(") ? {
        mode: _[1],
        color: [
          M[0]
        ],
        alpha: M[1]
      } : !p && M.length !== 3 || M.length < 3 && !M.some((A) => /^var\(.*?\)$/.test(A)) ? null : {
        mode: _[1],
        color: M,
        alpha: (g = _[5]) === null || g === void 0 || (y = g.toString) === null || y === void 0 ? void 0 : y.call(g)
      };
    }
    function h({ mode: m, color: p, alpha: g }) {
      let y = g !== void 0;
      return m === "rgba" || m === "hsla" ? `${m}(${p.join(", ")}${y ? `, ${g}` : ""})` : `${m}(${p.join(" ")}${y ? ` / ${g}` : ""})`;
    }
  }(Nl)), Nl;
}
var vm;
function ly() {
  return vm || (vm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function e(r, a) {
      for (var o in a) Object.defineProperty(r, o, {
        enumerable: !0,
        get: a[o]
      });
    }
    e(t, {
      withAlphaValue: function() {
        return i;
      },
      default: function() {
        return s;
      }
    });
    const n = oy();
    function i(r, a, o) {
      if (typeof r == "function")
        return r({
          opacityValue: a
        });
      let l = (0, n.parseColor)(r, {
        loose: !0
      });
      return l === null ? o : (0, n.formatColor)({
        ...l,
        alpha: a
      });
    }
    function s({ color: r, property: a, variable: o }) {
      let l = [].concat(a);
      if (typeof r == "function")
        return {
          [o]: "1",
          ...Object.fromEntries(l.map((c) => [
            c,
            r({
              opacityVariable: o,
              opacityValue: `var(${o}, 1)`
            })
          ]))
        };
      const u = (0, n.parseColor)(r);
      return u === null ? Object.fromEntries(l.map((c) => [
        c,
        r
      ])) : u.alpha !== void 0 ? Object.fromEntries(l.map((c) => [
        c,
        r
      ])) : {
        [o]: "1",
        ...Object.fromEntries(l.map((c) => [
          c,
          (0, n.formatColor)({
            ...u,
            alpha: `var(${o}, 1)`
          })
        ]))
      };
    }
  }(Vl)), Vl;
}
var zl = {}, Wl = {}, Hl = {}, bm;
function dd() {
  return bm || (bm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "splitAtTopLevelOnly", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(n, i) {
      let s = [], r = [], a = 0, o = !1;
      for (let l = 0; l < n.length; l++) {
        let u = n[l];
        s.length === 0 && u === i[0] && !o && (i.length === 1 || n.slice(l, l + i.length) === i) && (r.push(n.slice(a, l)), a = l + i.length), o = o ? !1 : u === "\\", u === "(" || u === "[" || u === "{" ? s.push(u) : (u === ")" && s[s.length - 1] === "(" || u === "]" && s[s.length - 1] === "[" || u === "}" && s[s.length - 1] === "{") && s.pop();
      }
      return r.push(n.slice(a)), r;
    }
  }(Hl)), Hl;
}
var wm;
function SO() {
  return wm || (wm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function e(l, u) {
      for (var c in u) Object.defineProperty(l, c, {
        enumerable: !0,
        get: u[c]
      });
    }
    e(t, {
      parseBoxShadowValue: function() {
        return a;
      },
      formatBoxShadowValue: function() {
        return o;
      }
    });
    const n = dd();
    let i = /* @__PURE__ */ new Set([
      "inset",
      "inherit",
      "initial",
      "revert",
      "unset"
    ]), s = /\ +(?![^(]*\))/g, r = /^-?(\d+|\.\d+)(.*?)$/g;
    function a(l) {
      return (0, n.splitAtTopLevelOnly)(l, ",").map((c) => {
        let d = c.trim(), f = {
          raw: d
        }, h = d.split(s), m = /* @__PURE__ */ new Set();
        for (let p of h)
          r.lastIndex = 0, !m.has("KEYWORD") && i.has(p) ? (f.keyword = p, m.add("KEYWORD")) : r.test(p) ? m.has("X") ? m.has("Y") ? m.has("BLUR") ? m.has("SPREAD") || (f.spread = p, m.add("SPREAD")) : (f.blur = p, m.add("BLUR")) : (f.y = p, m.add("Y")) : (f.x = p, m.add("X")) : f.color ? (f.unknown || (f.unknown = []), f.unknown.push(p)) : f.color = p;
        return f.valid = f.x !== void 0 && f.y !== void 0, f;
      });
    }
    function o(l) {
      return l.map((u) => u.valid ? [
        u.keyword,
        u.x,
        u.y,
        u.blur,
        u.spread,
        u.color
      ].filter(Boolean).join(" ") : u.raw).join(", ");
    }
  }(Wl)), Wl;
}
var xm;
function uy() {
  return xm || (xm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function e(D, N) {
      for (var L in N) Object.defineProperty(D, L, {
        enumerable: !0,
        get: N[L]
      });
    }
    e(t, {
      normalize: function() {
        return l;
      },
      normalizeAttributeSelectors: function() {
        return u;
      },
      url: function() {
        return d;
      },
      number: function() {
        return f;
      },
      percentage: function() {
        return h;
      },
      length: function() {
        return g;
      },
      lineWidth: function() {
        return v;
      },
      shadow: function() {
        return b;
      },
      color: function() {
        return _;
      },
      image: function() {
        return M;
      },
      gradient: function() {
        return E;
      },
      position: function() {
        return S;
      },
      familyName: function() {
        return $;
      },
      genericName: function() {
        return V;
      },
      absoluteSize: function() {
        return P;
      },
      relativeSize: function() {
        return k;
      }
    });
    const n = oy(), i = SO(), s = dd();
    let r = [
      "min",
      "max",
      "clamp",
      "calc"
    ];
    function a(D) {
      return r.some((N) => new RegExp(`^${N}\\(.*\\)`).test(D));
    }
    const o = /* @__PURE__ */ new Set([
      // Concrete properties
      "scroll-timeline-name",
      "timeline-scope",
      "view-timeline-name",
      "font-palette",
      "anchor-name",
      "anchor-scope",
      "position-anchor",
      "position-try-options",
      // Shorthand properties
      "scroll-timeline",
      "animation-timeline",
      "view-timeline",
      "position-try"
    ]);
    function l(D, N = null, L = !0) {
      let z = N && o.has(N.property);
      return D.startsWith("--") && !z ? `var(${D})` : D.includes("url(") ? D.split(/(url\(.*?\))/g).filter(Boolean).map((W) => /^url\(.*?\)$/.test(W) ? W : l(W, N, !1)).join("") : (D = D.replace(/([^\\])_+/g, (W, ae) => ae + " ".repeat(W.length - 1)).replace(/^_/g, " ").replace(/\\_/g, "_"), L && (D = D.trim()), D = c(D), D);
    }
    function u(D) {
      return D.includes("=") && (D = D.replace(/(=.*)/g, (N, L) => {
        if (L[1] === "'" || L[1] === '"')
          return L;
        if (L.length > 2) {
          let z = L[L.length - 1];
          if (L[L.length - 2] === " " && (z === "i" || z === "I" || z === "s" || z === "S"))
            return `="${L.slice(1, -2)}" ${L[L.length - 1]}`;
        }
        return `="${L.slice(1)}"`;
      })), D;
    }
    function c(D) {
      let N = [
        "theme"
      ], L = [
        "min-content",
        "max-content",
        "fit-content",
        // Env
        "safe-area-inset-top",
        "safe-area-inset-right",
        "safe-area-inset-bottom",
        "safe-area-inset-left",
        "titlebar-area-x",
        "titlebar-area-y",
        "titlebar-area-width",
        "titlebar-area-height",
        "keyboard-inset-top",
        "keyboard-inset-right",
        "keyboard-inset-bottom",
        "keyboard-inset-left",
        "keyboard-inset-width",
        "keyboard-inset-height",
        "radial-gradient",
        "linear-gradient",
        "conic-gradient",
        "repeating-radial-gradient",
        "repeating-linear-gradient",
        "repeating-conic-gradient",
        "anchor-size"
      ];
      return D.replace(/(calc|min|max|clamp)\(.+\)/g, (z) => {
        let W = "";
        function ae() {
          let F = W.trimEnd();
          return F[F.length - 1];
        }
        for (let F = 0; F < z.length; F++) {
          let H = function(w) {
            return w.split("").every((Y, ue) => z[F + ue] === Y);
          }, Q = function(w) {
            let Y = 1 / 0;
            for (let ze of w) {
              let K = z.indexOf(ze, F);
              K !== -1 && K < Y && (Y = K);
            }
            let ue = z.slice(F, Y);
            return F += ue.length - 1, ue;
          }, ne = z[F];
          if (H("var"))
            W += Q([
              ")",
              ","
            ]);
          else if (L.some((w) => H(w))) {
            let w = L.find((Y) => H(Y));
            W += w, F += w.length - 1;
          } else N.some((w) => H(w)) ? W += Q([
            ")"
          ]) : H("[") ? W += Q([
            "]"
          ]) : [
            "+",
            "-",
            "*",
            "/"
          ].includes(ne) && ![
            "(",
            "+",
            "-",
            "*",
            "/",
            ","
          ].includes(ae()) ? W += ` ${ne} ` : W += ne;
        }
        return W.replace(/\s+/g, " ");
      });
    }
    function d(D) {
      return D.startsWith("url(");
    }
    function f(D) {
      return !isNaN(Number(D)) || a(D);
    }
    function h(D) {
      return D.endsWith("%") && f(D.slice(0, -1)) || a(D);
    }
    let p = `(?:${[
      "cm",
      "mm",
      "Q",
      "in",
      "pc",
      "pt",
      "px",
      "em",
      "ex",
      "ch",
      "rem",
      "lh",
      "rlh",
      "vw",
      "vh",
      "vmin",
      "vmax",
      "vb",
      "vi",
      "svw",
      "svh",
      "lvw",
      "lvh",
      "dvw",
      "dvh",
      "cqw",
      "cqh",
      "cqi",
      "cqb",
      "cqmin",
      "cqmax"
    ].join("|")})`;
    function g(D) {
      return D === "0" || new RegExp(`^[+-]?[0-9]*.?[0-9]+(?:[eE][+-]?[0-9]+)?${p}$`).test(D) || a(D);
    }
    let y = /* @__PURE__ */ new Set([
      "thin",
      "medium",
      "thick"
    ]);
    function v(D) {
      return y.has(D);
    }
    function b(D) {
      let N = (0, i.parseBoxShadowValue)(l(D));
      for (let L of N)
        if (!L.valid)
          return !1;
      return !0;
    }
    function _(D) {
      let N = 0;
      return (0, s.splitAtTopLevelOnly)(D, "_").every((z) => (z = l(z), z.startsWith("var(") ? !0 : (0, n.parseColor)(z, {
        loose: !0
      }) !== null ? (N++, !0) : !1)) ? N > 0 : !1;
    }
    function M(D) {
      let N = 0;
      return (0, s.splitAtTopLevelOnly)(D, ",").every((z) => (z = l(z), z.startsWith("var(") ? !0 : d(z) || E(z) || [
        "element(",
        "image(",
        "cross-fade(",
        "image-set("
      ].some((W) => z.startsWith(W)) ? (N++, !0) : !1)) ? N > 0 : !1;
    }
    let A = /* @__PURE__ */ new Set([
      "conic-gradient",
      "linear-gradient",
      "radial-gradient",
      "repeating-conic-gradient",
      "repeating-linear-gradient",
      "repeating-radial-gradient"
    ]);
    function E(D) {
      D = l(D);
      for (let N of A)
        if (D.startsWith(`${N}(`))
          return !0;
      return !1;
    }
    let I = /* @__PURE__ */ new Set([
      "center",
      "top",
      "right",
      "bottom",
      "left"
    ]);
    function S(D) {
      let N = 0;
      return (0, s.splitAtTopLevelOnly)(D, "_").every((z) => (z = l(z), z.startsWith("var(") ? !0 : I.has(z) || g(z) || h(z) ? (N++, !0) : !1)) ? N > 0 : !1;
    }
    function $(D) {
      let N = 0;
      return (0, s.splitAtTopLevelOnly)(D, ",").every((z) => (z = l(z), z.startsWith("var(") ? !0 : z.includes(" ") && !/(['"])([^"']+)\1/g.test(z) || /^\d/g.test(z) ? !1 : (N++, !0))) ? N > 0 : !1;
    }
    let B = /* @__PURE__ */ new Set([
      "serif",
      "sans-serif",
      "monospace",
      "cursive",
      "fantasy",
      "system-ui",
      "ui-serif",
      "ui-sans-serif",
      "ui-monospace",
      "ui-rounded",
      "math",
      "emoji",
      "fangsong"
    ]);
    function V(D) {
      return B.has(D);
    }
    let G = /* @__PURE__ */ new Set([
      "xx-small",
      "x-small",
      "small",
      "medium",
      "large",
      "x-large",
      "xx-large",
      "xxx-large"
    ]);
    function P(D) {
      return G.has(D);
    }
    let x = /* @__PURE__ */ new Set([
      "larger",
      "smaller"
    ]);
    function k(D) {
      return x.has(D);
    }
  }(zl)), zl;
}
var Yl = {}, _m;
function OO() {
  return _m || (_m = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "backgroundSize", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const e = uy(), n = dd();
    function i(s) {
      let r = [
        "cover",
        "contain"
      ];
      return (0, n.splitAtTopLevelOnly)(s, ",").every((a) => {
        let o = (0, n.splitAtTopLevelOnly)(a, "_").filter(Boolean);
        return o.length === 1 && r.includes(o[0]) ? !0 : o.length !== 1 && o.length !== 2 ? !1 : o.every((l) => (0, e.length)(l) || (0, e.percentage)(l) || l === "auto");
      });
    }
  }(Yl)), Yl;
}
var km;
function DO() {
  return km || (km = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function e(S, $) {
      for (var B in $) Object.defineProperty(S, B, {
        enumerable: !0,
        get: $[B]
      });
    }
    e(t, {
      updateAllClasses: function() {
        return u;
      },
      asValue: function() {
        return f;
      },
      parseColorFormat: function() {
        return p;
      },
      asColor: function() {
        return y;
      },
      asLookupValue: function() {
        return v;
      },
      typeMap: function() {
        return _;
      },
      coerceValue: function() {
        return E;
      },
      getMatchingTypes: function() {
        return I;
      }
    });
    const n = /* @__PURE__ */ l(kO()), i = ly(), s = uy(), r = /* @__PURE__ */ l(iy()), a = OO(), o = cd();
    function l(S) {
      return S && S.__esModule ? S : {
        default: S
      };
    }
    function u(S, $) {
      S.walkClasses((B) => {
        B.value = $(B.value), B.raws && B.raws.value && (B.raws.value = (0, n.default)(B.raws.value));
      });
    }
    function c(S, $) {
      if (!h(S))
        return;
      let B = S.slice(1, -1);
      if ($(B))
        return (0, s.normalize)(B);
    }
    function d(S, $ = {}, B) {
      let V = $[S];
      if (V !== void 0)
        return (0, r.default)(V);
      if (h(S)) {
        let G = c(S, B);
        return G === void 0 ? void 0 : (0, r.default)(G);
      }
    }
    function f(S, $ = {}, { validate: B = () => !0 } = {}) {
      var V;
      let G = (V = $.values) === null || V === void 0 ? void 0 : V[S];
      return G !== void 0 ? G : $.supportsNegativeValues && S.startsWith("-") ? d(S.slice(1), $.values, B) : c(S, B);
    }
    function h(S) {
      return S.startsWith("[") && S.endsWith("]");
    }
    function m(S) {
      let $ = S.lastIndexOf("/"), B = S.lastIndexOf("[", $), V = S.indexOf("]", $);
      return S[$ - 1] === "]" || S[$ + 1] === "[" || B !== -1 && V !== -1 && B < $ && $ < V && ($ = S.lastIndexOf("/", B)), $ === -1 || $ === S.length - 1 ? [
        S,
        void 0
      ] : h(S) && !S.includes("]/[") ? [
        S,
        void 0
      ] : [
        S.slice(0, $),
        S.slice($ + 1)
      ];
    }
    function p(S) {
      if (typeof S == "string" && S.includes("<alpha-value>")) {
        let $ = S;
        return ({ opacityValue: B = 1 }) => $.replace(/<alpha-value>/g, B);
      }
      return S;
    }
    function g(S) {
      return (0, s.normalize)(S.slice(1, -1));
    }
    function y(S, $ = {}, { tailwindConfig: B = {} } = {}) {
      var V;
      if (((V = $.values) === null || V === void 0 ? void 0 : V[S]) !== void 0) {
        var G;
        return p((G = $.values) === null || G === void 0 ? void 0 : G[S]);
      }
      let [P, x] = m(S);
      if (x !== void 0) {
        var k, D, N, L;
        let z = (L = (k = $.values) === null || k === void 0 ? void 0 : k[P]) !== null && L !== void 0 ? L : h(P) ? P.slice(1, -1) : void 0;
        return z === void 0 ? void 0 : (z = p(z), h(x) ? (0, i.withAlphaValue)(z, g(x)) : ((D = B.theme) === null || D === void 0 || (N = D.opacity) === null || N === void 0 ? void 0 : N[x]) === void 0 ? void 0 : (0, i.withAlphaValue)(z, B.theme.opacity[x]));
      }
      return f(S, $, {
        validate: s.color
      });
    }
    function v(S, $ = {}) {
      var B;
      return (B = $.values) === null || B === void 0 ? void 0 : B[S];
    }
    function b(S) {
      return ($, B) => f($, B, {
        validate: S
      });
    }
    let _ = {
      any: f,
      color: y,
      url: b(s.url),
      image: b(s.image),
      length: b(s.length),
      percentage: b(s.percentage),
      position: b(s.position),
      lookup: v,
      "generic-name": b(s.genericName),
      "family-name": b(s.familyName),
      number: b(s.number),
      "line-width": b(s.lineWidth),
      "absolute-size": b(s.absoluteSize),
      "relative-size": b(s.relativeSize),
      shadow: b(s.shadow),
      size: b(a.backgroundSize)
    }, M = Object.keys(_);
    function A(S, $) {
      let B = S.indexOf($);
      return B === -1 ? [
        void 0,
        S
      ] : [
        S.slice(0, B),
        S.slice(B + 1)
      ];
    }
    function E(S, $, B, V) {
      if (B.values && $ in B.values)
        for (let { type: P } of S ?? []) {
          let x = _[P]($, B, {
            tailwindConfig: V
          });
          if (x !== void 0)
            return [
              x,
              P,
              null
            ];
        }
      if (h($)) {
        let P = $.slice(1, -1), [x, k] = A(P, ":");
        if (!/^[\w-_]+$/g.test(x))
          k = P;
        else if (x !== void 0 && !M.includes(x))
          return [];
        if (k.length > 0 && M.includes(x))
          return [
            f(`[${k}]`, B),
            x,
            null
          ];
      }
      let G = I(S, $, B, V);
      for (let P of G)
        return P;
      return [];
    }
    function* I(S, $, B, V) {
      let G = (0, o.flagEnabled)(V, "generalizedModifiers"), [P, x] = m($);
      if (G && B.modifiers != null && (B.modifiers === "any" || typeof B.modifiers == "object" && (x && h(x) || x in B.modifiers)) || (P = $, x = void 0), x !== void 0 && P === "" && (P = "DEFAULT"), x !== void 0 && typeof B.modifiers == "object") {
        var D, N;
        let L = (N = (D = B.modifiers) === null || D === void 0 ? void 0 : D[x]) !== null && N !== void 0 ? N : null;
        L !== null ? x = L : h(x) && (x = g(x));
      }
      for (let { type: L } of S ?? []) {
        let z = _[L](P, B, {
          tailwindConfig: V
        });
        z !== void 0 && (yield [
          z,
          L,
          x ?? null
        ]);
      }
    }
  }(Il)), Il;
}
var jl = {}, Mm;
function TO() {
  return Mm || (Mm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(n) {
      return typeof n == "function" ? n({}) : n;
    }
  }(jl)), jl;
}
var Sm;
function PO() {
  return Sm || (Sm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return B;
      }
    });
    const e = /* @__PURE__ */ h(iy()), n = /* @__PURE__ */ h(yO()), i = /* @__PURE__ */ h(vO()), s = /* @__PURE__ */ h(ry()), r = bO(), a = wO(), o = xO(), l = /* @__PURE__ */ h(_O()), u = ay(), c = DO(), d = ly(), f = /* @__PURE__ */ h(TO());
    function h(V) {
      return V && V.__esModule ? V : {
        default: V
      };
    }
    function m(V) {
      return typeof V == "function";
    }
    function p(V, ...G) {
      let P = G.pop();
      for (let x of G)
        for (let k in x) {
          let D = P(V[k], x[k]);
          D === void 0 ? (0, l.default)(V[k]) && (0, l.default)(x[k]) ? V[k] = p({}, V[k], x[k], P) : V[k] = x[k] : V[k] = D;
        }
      return V;
    }
    const g = {
      colors: s.default,
      negative(V) {
        return Object.keys(V).filter((G) => V[G] !== "0").reduce((G, P) => {
          let x = (0, e.default)(V[P]);
          return x !== void 0 && (G[`-${P}`] = x), G;
        }, {});
      },
      breakpoints(V) {
        return Object.keys(V).filter((G) => typeof V[G] == "string").reduce((G, P) => ({
          ...G,
          [`screen-${P}`]: V[P]
        }), {});
      }
    };
    function y(V, ...G) {
      return m(V) ? V(...G) : V;
    }
    function v(V) {
      return V.reduce((G, { extend: P }) => p(G, P, (x, k) => x === void 0 ? [
        k
      ] : Array.isArray(x) ? [
        k,
        ...x
      ] : [
        k,
        x
      ]), {});
    }
    function b(V) {
      return {
        ...V.reduce((G, P) => (0, r.defaults)(G, P), {}),
        // In order to resolve n config objects, we combine all of their `extend` properties
        // into arrays instead of objects so they aren't overridden.
        extend: v(V)
      };
    }
    function _(V, G) {
      if (Array.isArray(V) && (0, l.default)(V[0]))
        return V.concat(G);
      if (Array.isArray(G) && (0, l.default)(G[0]) && (0, l.default)(V))
        return [
          V,
          ...G
        ];
      if (Array.isArray(G))
        return G;
    }
    function M({ extend: V, ...G }) {
      return p(G, V, (P, x) => !m(P) && !x.some(m) ? p({}, P, ...x, _) : (k, D) => p({}, ...[
        P,
        ...x
      ].map((N) => y(N, k, D)), _));
    }
    function* A(V) {
      let G = (0, a.toPath)(V);
      if (G.length === 0 || (yield G, Array.isArray(V)))
        return;
      let P = /^(.*?)\s*\/\s*([^/]+)$/, x = V.match(P);
      if (x !== null) {
        let [, k, D] = x, N = (0, a.toPath)(k);
        N.alpha = D, yield N;
      }
    }
    function E(V) {
      const G = (P, x) => {
        for (const k of A(P)) {
          let D = 0, N = V;
          for (; N != null && D < k.length; )
            N = N[k[D++]], N = m(N) && (k.alpha === void 0 || D <= k.length - 1) ? N(G, g) : N;
          if (N !== void 0) {
            if (k.alpha !== void 0) {
              let L = (0, c.parseColorFormat)(N);
              return (0, d.withAlphaValue)(L, k.alpha, (0, f.default)(L));
            }
            return (0, l.default)(N) ? (0, u.cloneDeep)(N) : N;
          }
        }
        return x;
      };
      return Object.assign(G, {
        theme: G,
        ...g
      }), Object.keys(V).reduce((P, x) => (P[x] = m(V[x]) ? V[x](G, g) : V[x], P), {});
    }
    function I(V) {
      let G = [];
      return V.forEach((P) => {
        G = [
          ...G,
          P
        ];
        var x;
        const k = (x = P == null ? void 0 : P.plugins) !== null && x !== void 0 ? x : [];
        k.length !== 0 && k.forEach((D) => {
          D.__isOptionsFunction && (D = D());
          var N;
          G = [
            ...G,
            ...I([
              (N = D == null ? void 0 : D.config) !== null && N !== void 0 ? N : {}
            ])
          ];
        });
      }), G;
    }
    function S(V) {
      return [
        ...V
      ].reduceRight((P, x) => m(x) ? x({
        corePlugins: P
      }) : (0, i.default)(x, P), n.default);
    }
    function $(V) {
      return [
        ...V
      ].reduceRight((P, x) => [
        ...P,
        ...x
      ], []);
    }
    function B(V) {
      let G = [
        ...I(V),
        {
          prefix: "",
          important: !1,
          separator: ":"
        }
      ];
      var P, x;
      return (0, o.normalizeConfig)((0, r.defaults)({
        theme: E(M(b(G.map((k) => (P = k == null ? void 0 : k.theme) !== null && P !== void 0 ? P : {})))),
        corePlugins: S(G.map((k) => k.corePlugins)),
        plugins: $(V.map((k) => (x = k == null ? void 0 : k.plugins) !== null && x !== void 0 ? x : []))
      }, ...G));
    }
  }(Ml)), Ml;
}
var ql = {}, Ul, Om;
function cy() {
  return Om || (Om = 1, Ul = {
    content: [],
    presets: [],
    darkMode: "media",
    // or 'class'
    theme: {
      accentColor: ({ theme: t }) => ({
        ...t("colors"),
        auto: "auto"
      }),
      animation: {
        none: "none",
        spin: "spin 1s linear infinite",
        ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
        pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
        bounce: "bounce 1s infinite"
      },
      aria: {
        busy: 'busy="true"',
        checked: 'checked="true"',
        disabled: 'disabled="true"',
        expanded: 'expanded="true"',
        hidden: 'hidden="true"',
        pressed: 'pressed="true"',
        readonly: 'readonly="true"',
        required: 'required="true"',
        selected: 'selected="true"'
      },
      aspectRatio: {
        auto: "auto",
        square: "1 / 1",
        video: "16 / 9"
      },
      backdropBlur: ({ theme: t }) => t("blur"),
      backdropBrightness: ({ theme: t }) => t("brightness"),
      backdropContrast: ({ theme: t }) => t("contrast"),
      backdropGrayscale: ({ theme: t }) => t("grayscale"),
      backdropHueRotate: ({ theme: t }) => t("hueRotate"),
      backdropInvert: ({ theme: t }) => t("invert"),
      backdropOpacity: ({ theme: t }) => t("opacity"),
      backdropSaturate: ({ theme: t }) => t("saturate"),
      backdropSepia: ({ theme: t }) => t("sepia"),
      backgroundColor: ({ theme: t }) => t("colors"),
      backgroundImage: {
        none: "none",
        "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
        "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
        "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
        "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
        "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
        "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
        "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
        "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
      },
      backgroundOpacity: ({ theme: t }) => t("opacity"),
      backgroundPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      backgroundSize: {
        auto: "auto",
        cover: "cover",
        contain: "contain"
      },
      blur: {
        0: "0",
        none: "",
        sm: "4px",
        DEFAULT: "8px",
        md: "12px",
        lg: "16px",
        xl: "24px",
        "2xl": "40px",
        "3xl": "64px"
      },
      borderColor: ({ theme: t }) => ({
        ...t("colors"),
        DEFAULT: t("colors.gray.200", "currentColor")
      }),
      borderOpacity: ({ theme: t }) => t("opacity"),
      borderRadius: {
        none: "0px",
        sm: "0.125rem",
        DEFAULT: "0.25rem",
        md: "0.375rem",
        lg: "0.5rem",
        xl: "0.75rem",
        "2xl": "1rem",
        "3xl": "1.5rem",
        full: "9999px"
      },
      borderSpacing: ({ theme: t }) => ({
        ...t("spacing")
      }),
      borderWidth: {
        DEFAULT: "1px",
        0: "0px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      boxShadow: {
        sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
        DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
        md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
        xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
        "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
        inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
        none: "none"
      },
      boxShadowColor: ({ theme: t }) => t("colors"),
      brightness: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      caretColor: ({ theme: t }) => t("colors"),
      colors: ({ colors: t }) => ({
        inherit: t.inherit,
        current: t.current,
        transparent: t.transparent,
        black: t.black,
        white: t.white,
        slate: t.slate,
        gray: t.gray,
        zinc: t.zinc,
        neutral: t.neutral,
        stone: t.stone,
        red: t.red,
        orange: t.orange,
        amber: t.amber,
        yellow: t.yellow,
        lime: t.lime,
        green: t.green,
        emerald: t.emerald,
        teal: t.teal,
        cyan: t.cyan,
        sky: t.sky,
        blue: t.blue,
        indigo: t.indigo,
        violet: t.violet,
        purple: t.purple,
        fuchsia: t.fuchsia,
        pink: t.pink,
        rose: t.rose
      }),
      columns: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        "3xs": "16rem",
        "2xs": "18rem",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem"
      },
      container: {},
      content: {
        none: "none"
      },
      contrast: {
        0: "0",
        50: ".5",
        75: ".75",
        100: "1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      cursor: {
        auto: "auto",
        default: "default",
        pointer: "pointer",
        wait: "wait",
        text: "text",
        move: "move",
        help: "help",
        "not-allowed": "not-allowed",
        none: "none",
        "context-menu": "context-menu",
        progress: "progress",
        cell: "cell",
        crosshair: "crosshair",
        "vertical-text": "vertical-text",
        alias: "alias",
        copy: "copy",
        "no-drop": "no-drop",
        grab: "grab",
        grabbing: "grabbing",
        "all-scroll": "all-scroll",
        "col-resize": "col-resize",
        "row-resize": "row-resize",
        "n-resize": "n-resize",
        "e-resize": "e-resize",
        "s-resize": "s-resize",
        "w-resize": "w-resize",
        "ne-resize": "ne-resize",
        "nw-resize": "nw-resize",
        "se-resize": "se-resize",
        "sw-resize": "sw-resize",
        "ew-resize": "ew-resize",
        "ns-resize": "ns-resize",
        "nesw-resize": "nesw-resize",
        "nwse-resize": "nwse-resize",
        "zoom-in": "zoom-in",
        "zoom-out": "zoom-out"
      },
      divideColor: ({ theme: t }) => t("borderColor"),
      divideOpacity: ({ theme: t }) => t("borderOpacity"),
      divideWidth: ({ theme: t }) => t("borderWidth"),
      dropShadow: {
        sm: "0 1px 1px rgb(0 0 0 / 0.05)",
        DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
        md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
        lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
        xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
        "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
        none: "0 0 #0000"
      },
      fill: ({ theme: t }) => ({
        none: "none",
        ...t("colors")
      }),
      flex: {
        1: "1 1 0%",
        auto: "1 1 auto",
        initial: "0 1 auto",
        none: "none"
      },
      flexBasis: ({ theme: t }) => ({
        auto: "auto",
        ...t("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%"
      }),
      flexGrow: {
        0: "0",
        DEFAULT: "1"
      },
      flexShrink: {
        0: "0",
        DEFAULT: "1"
      },
      fontFamily: {
        sans: [
          "ui-sans-serif",
          "system-ui",
          "sans-serif",
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
          '"Noto Color Emoji"'
        ],
        serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
        mono: [
          "ui-monospace",
          "SFMono-Regular",
          "Menlo",
          "Monaco",
          "Consolas",
          '"Liberation Mono"',
          '"Courier New"',
          "monospace"
        ]
      },
      fontSize: {
        xs: ["0.75rem", { lineHeight: "1rem" }],
        sm: ["0.875rem", { lineHeight: "1.25rem" }],
        base: ["1rem", { lineHeight: "1.5rem" }],
        lg: ["1.125rem", { lineHeight: "1.75rem" }],
        xl: ["1.25rem", { lineHeight: "1.75rem" }],
        "2xl": ["1.5rem", { lineHeight: "2rem" }],
        "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
        "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
        "5xl": ["3rem", { lineHeight: "1" }],
        "6xl": ["3.75rem", { lineHeight: "1" }],
        "7xl": ["4.5rem", { lineHeight: "1" }],
        "8xl": ["6rem", { lineHeight: "1" }],
        "9xl": ["8rem", { lineHeight: "1" }]
      },
      fontWeight: {
        thin: "100",
        extralight: "200",
        light: "300",
        normal: "400",
        medium: "500",
        semibold: "600",
        bold: "700",
        extrabold: "800",
        black: "900"
      },
      gap: ({ theme: t }) => t("spacing"),
      gradientColorStops: ({ theme: t }) => t("colors"),
      gradientColorStopPositions: {
        "0%": "0%",
        "5%": "5%",
        "10%": "10%",
        "15%": "15%",
        "20%": "20%",
        "25%": "25%",
        "30%": "30%",
        "35%": "35%",
        "40%": "40%",
        "45%": "45%",
        "50%": "50%",
        "55%": "55%",
        "60%": "60%",
        "65%": "65%",
        "70%": "70%",
        "75%": "75%",
        "80%": "80%",
        "85%": "85%",
        "90%": "90%",
        "95%": "95%",
        "100%": "100%"
      },
      grayscale: {
        0: "0",
        DEFAULT: "100%"
      },
      gridAutoColumns: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridAutoRows: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridColumn: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridColumnEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridColumnStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRow: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridRowEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRowStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridTemplateColumns: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      gridTemplateRows: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      height: ({ theme: t }) => ({
        auto: "auto",
        ...t("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      hueRotate: {
        0: "0deg",
        15: "15deg",
        30: "30deg",
        60: "60deg",
        90: "90deg",
        180: "180deg"
      },
      inset: ({ theme: t }) => ({
        auto: "auto",
        ...t("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      invert: {
        0: "0",
        DEFAULT: "100%"
      },
      keyframes: {
        spin: {
          to: {
            transform: "rotate(360deg)"
          }
        },
        ping: {
          "75%, 100%": {
            transform: "scale(2)",
            opacity: "0"
          }
        },
        pulse: {
          "50%": {
            opacity: ".5"
          }
        },
        bounce: {
          "0%, 100%": {
            transform: "translateY(-25%)",
            animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
          },
          "50%": {
            transform: "none",
            animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
          }
        }
      },
      letterSpacing: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0em",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
      },
      lineHeight: {
        none: "1",
        tight: "1.25",
        snug: "1.375",
        normal: "1.5",
        relaxed: "1.625",
        loose: "2",
        3: ".75rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem"
      },
      listStyleType: {
        none: "none",
        disc: "disc",
        decimal: "decimal"
      },
      listStyleImage: {
        none: "none"
      },
      margin: ({ theme: t }) => ({
        auto: "auto",
        ...t("spacing")
      }),
      lineClamp: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6"
      },
      maxHeight: ({ theme: t }) => ({
        ...t("spacing"),
        none: "none",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      maxWidth: ({ theme: t, breakpoints: e }) => ({
        ...t("spacing"),
        none: "none",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content",
        prose: "65ch",
        ...e(t("screens"))
      }),
      minHeight: ({ theme: t }) => ({
        ...t("spacing"),
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      minWidth: ({ theme: t }) => ({
        ...t("spacing"),
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      objectPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      opacity: {
        0: "0",
        5: "0.05",
        10: "0.1",
        15: "0.15",
        20: "0.2",
        25: "0.25",
        30: "0.3",
        35: "0.35",
        40: "0.4",
        45: "0.45",
        50: "0.5",
        55: "0.55",
        60: "0.6",
        65: "0.65",
        70: "0.7",
        75: "0.75",
        80: "0.8",
        85: "0.85",
        90: "0.9",
        95: "0.95",
        100: "1"
      },
      order: {
        first: "-9999",
        last: "9999",
        none: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12"
      },
      outlineColor: ({ theme: t }) => t("colors"),
      outlineOffset: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      outlineWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      padding: ({ theme: t }) => t("spacing"),
      placeholderColor: ({ theme: t }) => t("colors"),
      placeholderOpacity: ({ theme: t }) => t("opacity"),
      ringColor: ({ theme: t }) => ({
        DEFAULT: t("colors.blue.500", "#3b82f6"),
        ...t("colors")
      }),
      ringOffsetColor: ({ theme: t }) => t("colors"),
      ringOffsetWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      ringOpacity: ({ theme: t }) => ({
        DEFAULT: "0.5",
        ...t("opacity")
      }),
      ringWidth: {
        DEFAULT: "3px",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      rotate: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg",
        45: "45deg",
        90: "90deg",
        180: "180deg"
      },
      saturate: {
        0: "0",
        50: ".5",
        100: "1",
        150: "1.5",
        200: "2"
      },
      scale: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5"
      },
      screens: {
        sm: "640px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        "2xl": "1536px"
      },
      scrollMargin: ({ theme: t }) => ({
        ...t("spacing")
      }),
      scrollPadding: ({ theme: t }) => t("spacing"),
      sepia: {
        0: "0",
        DEFAULT: "100%"
      },
      skew: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg"
      },
      space: ({ theme: t }) => ({
        ...t("spacing")
      }),
      spacing: {
        px: "1px",
        0: "0px",
        0.5: "0.125rem",
        1: "0.25rem",
        1.5: "0.375rem",
        2: "0.5rem",
        2.5: "0.625rem",
        3: "0.75rem",
        3.5: "0.875rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem",
        11: "2.75rem",
        12: "3rem",
        14: "3.5rem",
        16: "4rem",
        20: "5rem",
        24: "6rem",
        28: "7rem",
        32: "8rem",
        36: "9rem",
        40: "10rem",
        44: "11rem",
        48: "12rem",
        52: "13rem",
        56: "14rem",
        60: "15rem",
        64: "16rem",
        72: "18rem",
        80: "20rem",
        96: "24rem"
      },
      stroke: ({ theme: t }) => ({
        none: "none",
        ...t("colors")
      }),
      strokeWidth: {
        0: "0",
        1: "1",
        2: "2"
      },
      supports: {},
      data: {},
      textColor: ({ theme: t }) => t("colors"),
      textDecorationColor: ({ theme: t }) => t("colors"),
      textDecorationThickness: {
        auto: "auto",
        "from-font": "from-font",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      textIndent: ({ theme: t }) => ({
        ...t("spacing")
      }),
      textOpacity: ({ theme: t }) => t("opacity"),
      textUnderlineOffset: {
        auto: "auto",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      transformOrigin: {
        center: "center",
        top: "top",
        "top-right": "top right",
        right: "right",
        "bottom-right": "bottom right",
        bottom: "bottom",
        "bottom-left": "bottom left",
        left: "left",
        "top-left": "top left"
      },
      transitionDelay: {
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionDuration: {
        DEFAULT: "150ms",
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionProperty: {
        none: "none",
        all: "all",
        DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
        colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
        opacity: "opacity",
        shadow: "box-shadow",
        transform: "transform"
      },
      transitionTimingFunction: {
        DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
        linear: "linear",
        in: "cubic-bezier(0.4, 0, 1, 1)",
        out: "cubic-bezier(0, 0, 0.2, 1)",
        "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
      },
      translate: ({ theme: t }) => ({
        ...t("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      size: ({ theme: t }) => ({
        auto: "auto",
        ...t("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      width: ({ theme: t }) => ({
        auto: "auto",
        ...t("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        screen: "100vw",
        svw: "100svw",
        lvw: "100lvw",
        dvw: "100dvw",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      willChange: {
        auto: "auto",
        scroll: "scroll-position",
        contents: "contents",
        transform: "transform"
      },
      zIndex: {
        auto: "auto",
        0: "0",
        10: "10",
        20: "20",
        30: "30",
        40: "40",
        50: "50"
      }
    },
    plugins: []
  }), Ul;
}
var Dm;
function CO() {
  return Dm || (Dm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const e = /* @__PURE__ */ i(cy()), n = cd();
    function i(r) {
      return r && r.__esModule ? r : {
        default: r
      };
    }
    function s(r) {
      var a;
      const o = ((a = r == null ? void 0 : r.presets) !== null && a !== void 0 ? a : [
        e.default
      ]).slice().reverse().flatMap((c) => s(c instanceof Function ? c() : c)), l = {
        // Add experimental configs here...
        respectDefaultRingColorOpacity: {
          theme: {
            ringColor: ({ theme: c }) => ({
              DEFAULT: "#3b82f67f",
              ...c("colors")
            })
          }
        },
        disableColorOpacityUtilitiesByDefault: {
          corePlugins: {
            backgroundOpacity: !1,
            borderOpacity: !1,
            divideOpacity: !1,
            placeholderOpacity: !1,
            ringOpacity: !1,
            textOpacity: !1
          }
        }
      }, u = Object.keys(l).filter((c) => (0, n.flagEnabled)(r, c)).map((c) => l[c]);
      return [
        r,
        ...u,
        ...o
      ];
    }
  }(ql)), ql;
}
var Tm;
function AO() {
  return Tm || (Tm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const e = /* @__PURE__ */ i(PO()), n = /* @__PURE__ */ i(CO());
    function i(r) {
      return r && r.__esModule ? r : {
        default: r
      };
    }
    function s(...r) {
      let [, ...a] = (0, n.default)(r[0]);
      return (0, e.default)([
        ...r,
        ...a
      ]);
    }
  }(kl)), kl;
}
var Xl, Pm;
function EO() {
  if (Pm) return Xl;
  Pm = 1;
  let t = AO();
  return Xl = (t.__esModule ? t : { default: t }).default, Xl;
}
var $O = EO();
const RO = /* @__PURE__ */ ny($O);
var Gl, Cm;
function LO() {
  return Cm || (Cm = 1, Gl = {
    aqua: /#00ffff(ff)?(?!\w)|#0ff(f)?(?!\w)/gi,
    azure: /#f0ffff(ff)?(?!\w)/gi,
    beige: /#f5f5dc(ff)?(?!\w)/gi,
    bisque: /#ffe4c4(ff)?(?!\w)/gi,
    black: /#000000(ff)?(?!\w)|#000(f)?(?!\w)/gi,
    blue: /#0000ff(ff)?(?!\w)|#00f(f)?(?!\w)/gi,
    brown: /#a52a2a(ff)?(?!\w)/gi,
    coral: /#ff7f50(ff)?(?!\w)/gi,
    cornsilk: /#fff8dc(ff)?(?!\w)/gi,
    crimson: /#dc143c(ff)?(?!\w)/gi,
    cyan: /#00ffff(ff)?(?!\w)|#0ff(f)?(?!\w)/gi,
    darkblue: /#00008b(ff)?(?!\w)/gi,
    darkcyan: /#008b8b(ff)?(?!\w)/gi,
    darkgrey: /#a9a9a9(ff)?(?!\w)/gi,
    darkred: /#8b0000(ff)?(?!\w)/gi,
    deeppink: /#ff1493(ff)?(?!\w)/gi,
    dimgrey: /#696969(ff)?(?!\w)/gi,
    gold: /#ffd700(ff)?(?!\w)/gi,
    green: /#008000(ff)?(?!\w)/gi,
    grey: /#808080(ff)?(?!\w)/gi,
    honeydew: /#f0fff0(ff)?(?!\w)/gi,
    hotpink: /#ff69b4(ff)?(?!\w)/gi,
    indigo: /#4b0082(ff)?(?!\w)/gi,
    ivory: /#fffff0(ff)?(?!\w)/gi,
    khaki: /#f0e68c(ff)?(?!\w)/gi,
    lavender: /#e6e6fa(ff)?(?!\w)/gi,
    lime: /#00ff00(ff)?(?!\w)|#0f0(f)?(?!\w)/gi,
    linen: /#faf0e6(ff)?(?!\w)/gi,
    maroon: /#800000(ff)?(?!\w)/gi,
    moccasin: /#ffe4b5(ff)?(?!\w)/gi,
    navy: /#000080(ff)?(?!\w)/gi,
    oldlace: /#fdf5e6(ff)?(?!\w)/gi,
    olive: /#808000(ff)?(?!\w)/gi,
    orange: /#ffa500(ff)?(?!\w)/gi,
    orchid: /#da70d6(ff)?(?!\w)/gi,
    peru: /#cd853f(ff)?(?!\w)/gi,
    pink: /#ffc0cb(ff)?(?!\w)/gi,
    plum: /#dda0dd(ff)?(?!\w)/gi,
    purple: /#800080(ff)?(?!\w)/gi,
    red: /#ff0000(ff)?(?!\w)|#f00(f)?(?!\w)/gi,
    salmon: /#fa8072(ff)?(?!\w)/gi,
    seagreen: /#2e8b57(ff)?(?!\w)/gi,
    seashell: /#fff5ee(ff)?(?!\w)/gi,
    sienna: /#a0522d(ff)?(?!\w)/gi,
    silver: /#c0c0c0(ff)?(?!\w)/gi,
    skyblue: /#87ceeb(ff)?(?!\w)/gi,
    snow: /#fffafa(ff)?(?!\w)/gi,
    tan: /#d2b48c(ff)?(?!\w)/gi,
    teal: /#008080(ff)?(?!\w)/gi,
    thistle: /#d8bfd8(ff)?(?!\w)/gi,
    tomato: /#ff6347(ff)?(?!\w)/gi,
    violet: /#ee82ee(ff)?(?!\w)/gi,
    wheat: /#f5deb3(ff)?(?!\w)/gi,
    white: /#ffffff(ff)?(?!\w)|#fff(f)?(?!\w)/gi
  }), Gl;
}
var Zl, Am;
function IO() {
  if (Am) return Zl;
  Am = 1;
  var t = LO(), e = {
    whitespace: /\s+/g,
    urlHexPairs: /%[\dA-F]{2}/g,
    quotes: /"/g
  };
  function n(o) {
    return o.trim().replace(e.whitespace, " ");
  }
  function i(o) {
    return encodeURIComponent(o).replace(e.urlHexPairs, r);
  }
  function s(o) {
    return Object.keys(t).forEach(function(l) {
      t[l].test(o) && (o = o.replace(t[l], l));
    }), o;
  }
  function r(o) {
    switch (o) {
      // Browsers tolerate these characters, and they're frequent
      case "%20":
        return " ";
      case "%3D":
        return "=";
      case "%3A":
        return ":";
      case "%2F":
        return "/";
      default:
        return o.toLowerCase();
    }
  }
  function a(o) {
    if (typeof o != "string")
      throw new TypeError("Expected a string, but received " + typeof o);
    o.charCodeAt(0) === 65279 && (o = o.slice(1));
    var l = s(n(o)).replace(e.quotes, "'");
    return "data:image/svg+xml," + i(l);
  }
  return a.toSrcset = function(l) {
    return a(l).replace(/ /g, "%20");
  }, Zl = a, Zl;
}
var Kl = {}, Ql = {}, Em;
function FO() {
  return Em || (Em = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    function e(i, s) {
      return {
        handler: i,
        config: s
      };
    }
    e.withOptions = function(i, s = () => ({})) {
      const r = function(a) {
        return {
          __options: a,
          handler: i(a),
          config: s(a)
        };
      };
      return r.__isOptionsFunction = !0, r.__pluginFunction = i, r.__configFunction = s, r;
    };
    const n = e;
  }(Ql)), Ql;
}
var $m;
function VO() {
  return $m || ($m = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const e = /* @__PURE__ */ n(FO());
    function n(s) {
      return s && s.__esModule ? s : {
        default: s
      };
    }
    const i = e.default;
  }(Kl)), Kl;
}
var Jl, Rm;
function NO() {
  if (Rm) return Jl;
  Rm = 1;
  let t = VO();
  return Jl = (t.__esModule ? t : { default: t }).default, Jl;
}
var eu = {}, Lm;
function BO() {
  return Lm || (Lm = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const e = ay(), n = /* @__PURE__ */ i(cy());
    function i(r) {
      return r && r.__esModule ? r : {
        default: r
      };
    }
    const s = (0, e.cloneDeep)(n.default.theme);
  }(eu)), eu;
}
var tu, Im;
function zO() {
  if (Im) return tu;
  Im = 1;
  let t = BO();
  return tu = (t.__esModule ? t : { default: t }).default, tu;
}
var nu, Fm;
function WO() {
  if (Fm) return nu;
  Fm = 1;
  let t = ry();
  return nu = (t.__esModule ? t : { default: t }).default, nu;
}
var iu, Vm;
function HO() {
  if (Vm) return iu;
  Vm = 1;
  const t = IO(), e = NO(), n = zO(), i = WO(), [s, { lineHeight: r }] = n.fontSize.base, { spacing: a, borderWidth: o, borderRadius: l } = n;
  function u(d, f) {
    return d.replace("<alpha-value>", `var(${f}, 1)`);
  }
  return iu = e.withOptions(function(d = { strategy: void 0 }) {
    return function({ addBase: f, addComponents: h, theme: m }) {
      function p(b, _) {
        let M = m(b);
        return !M || M.includes("var(") ? _ : M.replace("<alpha-value>", "1");
      }
      const g = d.strategy === void 0 ? ["base", "class"] : [d.strategy], y = [
        {
          base: [
            "[type='text']",
            "input:where(:not([type]))",
            "[type='email']",
            "[type='url']",
            "[type='password']",
            "[type='number']",
            "[type='date']",
            "[type='datetime-local']",
            "[type='month']",
            "[type='search']",
            "[type='tel']",
            "[type='time']",
            "[type='week']",
            "[multiple]",
            "textarea",
            "select"
          ],
          class: [".form-input", ".form-textarea", ".form-select", ".form-multiselect"],
          styles: {
            appearance: "none",
            "background-color": "#fff",
            "border-color": u(
              m("colors.gray.500", i.gray[500]),
              "--tw-border-opacity"
            ),
            "border-width": o.DEFAULT,
            "border-radius": l.none,
            "padding-top": a[2],
            "padding-right": a[3],
            "padding-bottom": a[2],
            "padding-left": a[3],
            "font-size": s,
            "line-height": r,
            "--tw-shadow": "0 0 #0000",
            "&:focus": {
              outline: "2px solid transparent",
              "outline-offset": "2px",
              "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
              "--tw-ring-offset-width": "0px",
              "--tw-ring-offset-color": "#fff",
              "--tw-ring-color": u(
                m("colors.blue.600", i.blue[600]),
                "--tw-ring-opacity"
              ),
              "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
              "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
              "box-shadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)",
              "border-color": u(
                m("colors.blue.600", i.blue[600]),
                "--tw-border-opacity"
              )
            }
          }
        },
        {
          base: ["input::placeholder", "textarea::placeholder"],
          class: [".form-input::placeholder", ".form-textarea::placeholder"],
          styles: {
            color: u(m("colors.gray.500", i.gray[500]), "--tw-text-opacity"),
            opacity: "1"
          }
        },
        {
          base: ["::-webkit-datetime-edit-fields-wrapper"],
          class: [".form-input::-webkit-datetime-edit-fields-wrapper"],
          styles: {
            padding: "0"
          }
        },
        {
          // Unfortunate hack until https://bugs.webkit.org/show_bug.cgi?id=198959 is fixed.
          // This sucks because users can't change line-height with a utility on date inputs now.
          // Reference: https://github.com/twbs/bootstrap/pull/31993
          base: ["::-webkit-date-and-time-value"],
          class: [".form-input::-webkit-date-and-time-value"],
          styles: {
            "min-height": "1.5em"
          }
        },
        {
          // In Safari on iOS date and time inputs are centered instead of left-aligned and can't be
          // changed with `text-align` utilities on the input by default. Resetting this to `inherit`
          // makes them left-aligned by default and makes it possible to override the alignment with
          // utility classes without using an arbitrary variant to target the pseudo-elements.
          base: ["::-webkit-date-and-time-value"],
          class: [".form-input::-webkit-date-and-time-value"],
          styles: {
            "text-align": "inherit"
          }
        },
        {
          // In Safari on macOS date time inputs that are set to `display: block` have unexpected
          // extra bottom spacing. This can be corrected by setting the `::-webkit-datetime-edit`
          // pseudo-element to `display: inline-flex`, instead of the browser default of
          // `display: inline-block`.
          base: ["::-webkit-datetime-edit"],
          class: [".form-input::-webkit-datetime-edit"],
          styles: {
            display: "inline-flex"
          }
        },
        {
          // In Safari on macOS date time inputs are 4px taller than normal inputs
          // This is because there is extra padding on the datetime-edit and datetime-edit-{part}-field pseudo elements
          // See https://github.com/tailwindlabs/tailwindcss-forms/issues/95
          base: [
            "::-webkit-datetime-edit",
            "::-webkit-datetime-edit-year-field",
            "::-webkit-datetime-edit-month-field",
            "::-webkit-datetime-edit-day-field",
            "::-webkit-datetime-edit-hour-field",
            "::-webkit-datetime-edit-minute-field",
            "::-webkit-datetime-edit-second-field",
            "::-webkit-datetime-edit-millisecond-field",
            "::-webkit-datetime-edit-meridiem-field"
          ],
          class: [
            ".form-input::-webkit-datetime-edit",
            ".form-input::-webkit-datetime-edit-year-field",
            ".form-input::-webkit-datetime-edit-month-field",
            ".form-input::-webkit-datetime-edit-day-field",
            ".form-input::-webkit-datetime-edit-hour-field",
            ".form-input::-webkit-datetime-edit-minute-field",
            ".form-input::-webkit-datetime-edit-second-field",
            ".form-input::-webkit-datetime-edit-millisecond-field",
            ".form-input::-webkit-datetime-edit-meridiem-field"
          ],
          styles: {
            "padding-top": 0,
            "padding-bottom": 0
          }
        },
        {
          base: ["select"],
          class: [".form-select"],
          styles: {
            "background-image": `url("${t(
              `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path stroke="${p(
                "colors.gray.500",
                i.gray[500]
              )}" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 8l4 4 4-4"/></svg>`
            )}")`,
            "background-position": `right ${a[2]} center`,
            "background-repeat": "no-repeat",
            "background-size": "1.5em 1.5em",
            "padding-right": a[10],
            "print-color-adjust": "exact"
          }
        },
        {
          base: ["[multiple]", '[size]:where(select:not([size="1"]))'],
          class: ['.form-select:where([size]:not([size="1"]))'],
          styles: {
            "background-image": "initial",
            "background-position": "initial",
            "background-repeat": "unset",
            "background-size": "initial",
            "padding-right": a[3],
            "print-color-adjust": "unset"
          }
        },
        {
          base: ["[type='checkbox']", "[type='radio']"],
          class: [".form-checkbox", ".form-radio"],
          styles: {
            appearance: "none",
            padding: "0",
            "print-color-adjust": "exact",
            display: "inline-block",
            "vertical-align": "middle",
            "background-origin": "border-box",
            "user-select": "none",
            "flex-shrink": "0",
            height: a[4],
            width: a[4],
            color: u(m("colors.blue.600", i.blue[600]), "--tw-text-opacity"),
            "background-color": "#fff",
            "border-color": u(
              m("colors.gray.500", i.gray[500]),
              "--tw-border-opacity"
            ),
            "border-width": o.DEFAULT,
            "--tw-shadow": "0 0 #0000"
          }
        },
        {
          base: ["[type='checkbox']"],
          class: [".form-checkbox"],
          styles: {
            "border-radius": l.none
          }
        },
        {
          base: ["[type='radio']"],
          class: [".form-radio"],
          styles: {
            "border-radius": "100%"
          }
        },
        {
          base: ["[type='checkbox']:focus", "[type='radio']:focus"],
          class: [".form-checkbox:focus", ".form-radio:focus"],
          styles: {
            outline: "2px solid transparent",
            "outline-offset": "2px",
            "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
            "--tw-ring-offset-width": "2px",
            "--tw-ring-offset-color": "#fff",
            "--tw-ring-color": u(
              m("colors.blue.600", i.blue[600]),
              "--tw-ring-opacity"
            ),
            "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
            "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
            "box-shadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)"
          }
        },
        {
          base: ["[type='checkbox']:checked", "[type='radio']:checked"],
          class: [".form-checkbox:checked", ".form-radio:checked"],
          styles: {
            "border-color": "transparent",
            "background-color": "currentColor",
            "background-size": "100% 100%",
            "background-position": "center",
            "background-repeat": "no-repeat"
          }
        },
        {
          base: ["[type='checkbox']:checked"],
          class: [".form-checkbox:checked"],
          styles: {
            "background-image": `url("${t(
              '<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><path d="M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z"/></svg>'
            )}")`,
            "@media (forced-colors: active) ": {
              appearance: "auto"
            }
          }
        },
        {
          base: ["[type='radio']:checked"],
          class: [".form-radio:checked"],
          styles: {
            "background-image": `url("${t(
              '<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="3"/></svg>'
            )}")`,
            "@media (forced-colors: active) ": {
              appearance: "auto"
            }
          }
        },
        {
          base: [
            "[type='checkbox']:checked:hover",
            "[type='checkbox']:checked:focus",
            "[type='radio']:checked:hover",
            "[type='radio']:checked:focus"
          ],
          class: [
            ".form-checkbox:checked:hover",
            ".form-checkbox:checked:focus",
            ".form-radio:checked:hover",
            ".form-radio:checked:focus"
          ],
          styles: {
            "border-color": "transparent",
            "background-color": "currentColor"
          }
        },
        {
          base: ["[type='checkbox']:indeterminate"],
          class: [".form-checkbox:indeterminate"],
          styles: {
            "background-image": `url("${t(
              '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h8"/></svg>'
            )}")`,
            "border-color": "transparent",
            "background-color": "currentColor",
            "background-size": "100% 100%",
            "background-position": "center",
            "background-repeat": "no-repeat",
            "@media (forced-colors: active) ": {
              appearance: "auto"
            }
          }
        },
        {
          base: ["[type='checkbox']:indeterminate:hover", "[type='checkbox']:indeterminate:focus"],
          class: [".form-checkbox:indeterminate:hover", ".form-checkbox:indeterminate:focus"],
          styles: {
            "border-color": "transparent",
            "background-color": "currentColor"
          }
        },
        {
          base: ["[type='file']"],
          class: null,
          styles: {
            background: "unset",
            "border-color": "inherit",
            "border-width": "0",
            "border-radius": "0",
            padding: "0",
            "font-size": "unset",
            "line-height": "inherit"
          }
        },
        {
          base: ["[type='file']:focus"],
          class: null,
          styles: {
            outline: ["1px solid ButtonText", "1px auto -webkit-focus-ring-color"]
          }
        }
      ], v = (b) => y.map((_) => _[b] === null ? null : { [_[b]]: _.styles }).filter(Boolean);
      g.includes("base") && f(v("base")), g.includes("class") && h(v("class"));
    };
  }), iu;
}
var YO = HO();
const jO = /* @__PURE__ */ ny(YO), qO = {
  content: ["./index.html", "./src/**/*.{vue,js,cjs,mjs,mdx}"],
  theme: {
    colors: {
      transparent: "transparent",
      current: "currentColor",
      black: "#000",
      white: "#fff",
      primary: {
        50: "#F3E5F5",
        100: "#E1BEE7",
        200: "#CE93D8",
        300: "#BA68C8",
        400: "#AB47BC",
        500: "#9C27B0",
        DEFAULT: "#9C27B0",
        600: "#8E24AA",
        700: "#7B1FA2",
        800: "#6A1B9A",
        900: "#4A148C"
      },
      gray: {
        50: "#F3F5F6",
        100: "#DEE4E8",
        200: "#C8D3D9",
        300: "#849197",
        400: "#627076",
        500: "#3F4E55",
        DEFAULT: "#3F4E55",
        600: "#39474D",
        700: "#344146",
        800: "#2F3B40",
        900: "#2B363A"
      },
      success: {
        50: "#E1EFE3",
        100: "#C8E6CE",
        200: "#AEDDB9",
        300: "#7ACA8E",
        400: "#47B863",
        500: "#13A538",
        DEFAULT: "#13A538",
        600: "#188D3C",
        700: "#1C753F",
        800: "#205D43",
        900: "#244546"
      },
      danger: {
        50: "#FBD2D2",
        100: "#F9C6C6",
        200: "#F7BABA",
        300: "#F2A2A2",
        400: "#E97171",
        500: "#D61010",
        DEFAULT: "#D61010",
        600: "#C30F0F",
        700: "#B10E0E",
        800: "#A10D0D",
        900: "#920C0C"
      },
      info: {
        50: "#FFF4CC",
        100: "#FFEFB3",
        200: "#FFE999",
        300: "#FFDE66",
        400: "#FFD333",
        500: "#FFC700",
        DEFAULT: "#FFC700",
        600: "#E8B500",
        700: "#D3A500",
        800: "#C09600",
        900: "#AF8800"
      }
    },
    boxShadow: {
      sm: "0  1px  2px   0   rgba(0, 0, 0, 0.08)",
      DEFAULT: "0  1px  2px  -1px rgba(0, 0, 0, 0.10), 0  1px  3px  0   rgba(0, 0, 0, 0.10)",
      md: "0  2px  4px  -2px rgba(0, 0, 0, 0.05), 0  4px  6px -1px rgba(0, 0, 0, 0.10)",
      lg: "0  4px  6px   0   rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.10)",
      xl: "0 10px 10px   0   rgba(0, 0, 0, 0.04), 0 20px 25px -5px rgba(0, 0, 0, 0.10)",
      "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
    },
    extend: {
      fontFamily: {
        sans: ["Aeonik", "Avenir", "ui-sans-serif"]
      }
    }
  },
  plugins: [jO]
}, { theme: dy } = RO(qO), UO = dy.colors, XO = dy.fontFamily.sans;
"" + XO.join("', '");
const fy = 6048e5, GO = 864e5, ZO = 6e4, hy = 36e5, KO = 1e3, Nm = Symbol.for("constructDateFrom");
function Qe(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && Nm in t ? t[Nm](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function _e(t, e) {
  return Qe(e || t, t);
}
function fn(t, e, n) {
  const i = _e(t, n == null ? void 0 : n.in);
  return isNaN(e) ? Qe((n == null ? void 0 : n.in) || t, NaN) : (e && i.setDate(i.getDate() + e), i);
}
function kn(t, e, n) {
  const i = _e(t, n == null ? void 0 : n.in);
  if (isNaN(e)) return Qe(t, NaN);
  if (!e)
    return i;
  const s = i.getDate(), r = Qe(t, i.getTime());
  r.setMonth(i.getMonth() + e + 1, 0);
  const a = r.getDate();
  return s >= a ? r : (i.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    s
  ), i);
}
function Ps(t, e, n) {
  const {
    years: i = 0,
    months: s = 0,
    weeks: r = 0,
    days: a = 0,
    hours: o = 0,
    minutes: l = 0,
    seconds: u = 0
  } = e, c = _e(t, n == null ? void 0 : n.in), d = s || i ? kn(c, s + i * 12) : c, f = a || r ? fn(d, a + r * 7) : d, h = l + o * 60, p = (u + h * 60) * 1e3;
  return Qe(t, +f + p);
}
function QO(t, e, n) {
  return Qe(t, +_e(t) + e);
}
function JO(t, e, n) {
  return QO(t, e * hy);
}
let eD = {};
function ps() {
  return eD;
}
function Dn(t, e) {
  var o, l, u, c;
  const n = ps(), i = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((c = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = _e(t, e == null ? void 0 : e.in), r = s.getDay(), a = (r < i ? 7 : 0) + r - i;
  return s.setDate(s.getDate() - a), s.setHours(0, 0, 0, 0), s;
}
function $i(t, e) {
  return Dn(t, { ...e, weekStartsOn: 1 });
}
function my(t, e) {
  const n = _e(t, e == null ? void 0 : e.in), i = n.getFullYear(), s = Qe(n, 0);
  s.setFullYear(i + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const r = $i(s), a = Qe(n, 0);
  a.setFullYear(i, 0, 4), a.setHours(0, 0, 0, 0);
  const o = $i(a);
  return n.getTime() >= r.getTime() ? i + 1 : n.getTime() >= o.getTime() ? i : i - 1;
}
function vo(t) {
  const e = _e(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function fa(t, ...e) {
  const n = Qe.bind(
    null,
    e.find((i) => typeof i == "object")
  );
  return e.map(n);
}
function uc(t, e) {
  const n = _e(t, e == null ? void 0 : e.in);
  return n.setHours(0, 0, 0, 0), n;
}
function fd(t, e, n) {
  const [i, s] = fa(
    n == null ? void 0 : n.in,
    t,
    e
  ), r = uc(i), a = uc(s), o = +r - vo(r), l = +a - vo(a);
  return Math.round((o - l) / GO);
}
function tD(t, e) {
  const n = my(t, e), i = Qe(t, 0);
  return i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0), $i(i);
}
function nD(t, e, n) {
  return kn(t, e * 3, n);
}
function hd(t, e, n) {
  return kn(t, e * 12, n);
}
function Bm(t, e) {
  const n = +_e(t) - +_e(e);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function py(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Ir(t) {
  return !(!py(t) && typeof t != "number" || isNaN(+_e(t)));
}
function zm(t, e) {
  const n = _e(t, e == null ? void 0 : e.in);
  return Math.trunc(n.getMonth() / 3) + 1;
}
function iD(t, e, n) {
  const [i, s] = fa(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return i.getFullYear() - s.getFullYear();
}
function sD(t, e, n) {
  const [i, s] = fa(
    n == null ? void 0 : n.in,
    t,
    e
  ), r = Bm(i, s), a = Math.abs(iD(i, s));
  i.setFullYear(1584), s.setFullYear(1584);
  const o = Bm(i, s) === -r, l = r * (a - +o);
  return l === 0 ? 0 : l;
}
function gy(t, e) {
  const [n, i] = fa(t, e.start, e.end);
  return { start: n, end: i };
}
function yy(t, e) {
  const { start: n, end: i } = gy(e == null ? void 0 : e.in, t);
  let s = +n > +i;
  const r = s ? +n : +i, a = s ? i : n;
  a.setHours(0, 0, 0, 0);
  let o = 1;
  const l = [];
  for (; +a <= r; )
    l.push(Qe(n, a)), a.setDate(a.getDate() + o), a.setHours(0, 0, 0, 0);
  return s ? l.reverse() : l;
}
function Gi(t, e) {
  const n = _e(t, e == null ? void 0 : e.in), i = n.getMonth(), s = i - i % 3;
  return n.setMonth(s, 1), n.setHours(0, 0, 0, 0), n;
}
function rD(t, e) {
  const { start: n, end: i } = gy(e == null ? void 0 : e.in, t);
  let s = +n > +i;
  const r = s ? +Gi(n) : +Gi(i);
  let a = Gi(s ? i : n), o = 1;
  const l = [];
  for (; +a <= r; )
    l.push(Qe(n, a)), a = nD(a, o);
  return s ? l.reverse() : l;
}
function cc(t, e) {
  const n = _e(t, e == null ? void 0 : e.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function vy(t, e) {
  const n = _e(t, e == null ? void 0 : e.in), i = n.getFullYear();
  return n.setFullYear(i + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function os(t, e) {
  const n = _e(t, e == null ? void 0 : e.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function by(t, e) {
  var o, l, u, c;
  const n = ps(), i = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((c = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = _e(t, e == null ? void 0 : e.in), r = s.getDay(), a = (r < i ? -7 : 0) + 6 - (r - i);
  return s.setDate(s.getDate() + a), s.setHours(23, 59, 59, 999), s;
}
function Wm(t, e) {
  const n = _e(t, e == null ? void 0 : e.in), i = n.getMonth(), s = i - i % 3 + 3;
  return n.setMonth(s, 0), n.setHours(23, 59, 59, 999), n;
}
const aD = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, oD = (t, e, n) => {
  let i;
  const s = aD[t];
  return typeof s == "string" ? i = s : e === 1 ? i = s.one : i = s.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + i : i + " ago" : i;
};
function Is(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const lD = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, uD = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, cD = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, dD = {
  date: Is({
    formats: lD,
    defaultWidth: "full"
  }),
  time: Is({
    formats: uD,
    defaultWidth: "full"
  }),
  dateTime: Is({
    formats: cD,
    defaultWidth: "full"
  })
}, fD = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, hD = (t, e, n, i) => fD[t];
function Rn(t) {
  return (e, n) => {
    const i = n != null && n.context ? String(n.context) : "standalone";
    let s;
    if (i === "formatting" && t.formattingValues) {
      const a = t.defaultFormattingWidth || t.defaultWidth, o = n != null && n.width ? String(n.width) : a;
      s = t.formattingValues[o] || t.formattingValues[a];
    } else {
      const a = t.defaultWidth, o = n != null && n.width ? String(n.width) : t.defaultWidth;
      s = t.values[o] || t.values[a];
    }
    const r = t.argumentCallback ? t.argumentCallback(e) : e;
    return s[r];
  };
}
const mD = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, pD = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, gD = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, yD = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, vD = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, bD = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, wD = (t, e) => {
  const n = Number(t), i = n % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, xD = {
  ordinalNumber: wD,
  era: Rn({
    values: mD,
    defaultWidth: "wide"
  }),
  quarter: Rn({
    values: pD,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: Rn({
    values: gD,
    defaultWidth: "wide"
  }),
  day: Rn({
    values: yD,
    defaultWidth: "wide"
  }),
  dayPeriod: Rn({
    values: vD,
    defaultWidth: "wide",
    formattingValues: bD,
    defaultFormattingWidth: "wide"
  })
};
function Ln(t) {
  return (e, n = {}) => {
    const i = n.width, s = i && t.matchPatterns[i] || t.matchPatterns[t.defaultMatchWidth], r = e.match(s);
    if (!r)
      return null;
    const a = r[0], o = i && t.parsePatterns[i] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(o) ? kD(o, (d) => d.test(a)) : (
      // [TODO] -- I challenge you to fix the type
      _D(o, (d) => d.test(a))
    );
    let u;
    u = t.valueCallback ? t.valueCallback(l) : l, u = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(u)
    ) : u;
    const c = e.slice(a.length);
    return { value: u, rest: c };
  };
}
function _D(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function kD(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function wy(t) {
  return (e, n = {}) => {
    const i = e.match(t.matchPattern);
    if (!i) return null;
    const s = i[0], r = e.match(t.parsePattern);
    if (!r) return null;
    let a = t.valueCallback ? t.valueCallback(r[0]) : r[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const o = e.slice(s.length);
    return { value: a, rest: o };
  };
}
const MD = /^(\d+)(th|st|nd|rd)?/i, SD = /\d+/i, OD = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, DD = {
  any: [/^b/i, /^(a|c)/i]
}, TD = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, PD = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, CD = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, AD = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, ED = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, $D = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, RD = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, LD = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ID = {
  ordinalNumber: wy({
    matchPattern: MD,
    parsePattern: SD,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Ln({
    matchPatterns: OD,
    defaultMatchWidth: "wide",
    parsePatterns: DD,
    defaultParseWidth: "any"
  }),
  quarter: Ln({
    matchPatterns: TD,
    defaultMatchWidth: "wide",
    parsePatterns: PD,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Ln({
    matchPatterns: CD,
    defaultMatchWidth: "wide",
    parsePatterns: AD,
    defaultParseWidth: "any"
  }),
  day: Ln({
    matchPatterns: ED,
    defaultMatchWidth: "wide",
    parsePatterns: $D,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ln({
    matchPatterns: RD,
    defaultMatchWidth: "any",
    parsePatterns: LD,
    defaultParseWidth: "any"
  })
}, xy = {
  code: "en-US",
  formatDistance: oD,
  formatLong: dD,
  formatRelative: hD,
  localize: xD,
  match: ID,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function _y(t, e) {
  const n = _e(t, e == null ? void 0 : e.in);
  return fd(n, os(n)) + 1;
}
function md(t, e) {
  const n = _e(t, e == null ? void 0 : e.in), i = +$i(n) - +tD(n);
  return Math.round(i / fy) + 1;
}
function pd(t, e) {
  var c, d, f, h;
  const n = _e(t, e == null ? void 0 : e.in), i = n.getFullYear(), s = ps(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((d = (c = e == null ? void 0 : e.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((h = (f = s.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, a = Qe((e == null ? void 0 : e.in) || t, 0);
  a.setFullYear(i + 1, 0, r), a.setHours(0, 0, 0, 0);
  const o = Dn(a, e), l = Qe((e == null ? void 0 : e.in) || t, 0);
  l.setFullYear(i, 0, r), l.setHours(0, 0, 0, 0);
  const u = Dn(l, e);
  return +n >= +o ? i + 1 : +n >= +u ? i : i - 1;
}
function FD(t, e) {
  var o, l, u, c;
  const n = ps(), i = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((l = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((c = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, s = pd(t, e), r = Qe((e == null ? void 0 : e.in) || t, 0);
  return r.setFullYear(s, 0, i), r.setHours(0, 0, 0, 0), Dn(r, e);
}
function gd(t, e) {
  const n = _e(t, e == null ? void 0 : e.in), i = +Dn(n, e) - +FD(n, e);
  return Math.round(i / fy) + 1;
}
function Ge(t, e) {
  const n = t < 0 ? "-" : "", i = Math.abs(t).toString().padStart(e, "0");
  return n + i;
}
const oi = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), i = n > 0 ? n : 1 - n;
    return Ge(e === "yy" ? i % 100 : i, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : Ge(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return Ge(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return Ge(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return Ge(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return Ge(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return Ge(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, i = t.getMilliseconds(), s = Math.trunc(
      i * Math.pow(10, n - 3)
    );
    return Ge(s, e.length);
  }
}, ks = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Hm = {
  // Era
  G: function(t, e, n) {
    const i = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(i, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(i, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(i, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const i = t.getFullYear(), s = i > 0 ? i : 1 - i;
      return n.ordinalNumber(s, { unit: "year" });
    }
    return oi.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, i) {
    const s = pd(t, i), r = s > 0 ? s : 1 - s;
    if (e === "YY") {
      const a = r % 100;
      return Ge(a, 2);
    }
    return e === "Yo" ? n.ordinalNumber(r, { unit: "year" }) : Ge(r, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = my(t);
    return Ge(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return Ge(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const i = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(i);
      // 01, 02, 03, 04
      case "QQ":
        return Ge(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(i, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const i = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(i);
      // 01, 02, 03, 04
      case "qq":
        return Ge(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(i, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const i = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return oi.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(i + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(i, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(i, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const i = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(i + 1);
      // 01, 02, ..., 12
      case "LL":
        return Ge(i + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(i + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(i, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(i, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, i) {
    const s = gd(t, i);
    return e === "wo" ? n.ordinalNumber(s, { unit: "week" }) : Ge(s, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const i = md(t);
    return e === "Io" ? n.ordinalNumber(i, { unit: "week" }) : Ge(i, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : oi.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const i = _y(t);
    return e === "Do" ? n.ordinalNumber(i, { unit: "dayOfYear" }) : Ge(i, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const i = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, i) {
    const s = t.getDay(), r = (s - i.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(r);
      // Padded numerical value
      case "ee":
        return Ge(r, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(r, { unit: "day" });
      case "eee":
        return n.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(s, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(s, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, i) {
    const s = t.getDay(), r = (s - i.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(r);
      // Padded numerical value
      case "cc":
        return Ge(r, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(r, { unit: "day" });
      case "ccc":
        return n.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(s, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(s, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const i = t.getDay(), s = i === 0 ? 7 : i;
    switch (e) {
      // 2
      case "i":
        return String(s);
      // 02
      case "ii":
        return Ge(s, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(s, { unit: "day" });
      // Tue
      case "iii":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const s = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const i = t.getHours();
    let s;
    switch (i === 12 ? s = ks.noon : i === 0 ? s = ks.midnight : s = i / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const i = t.getHours();
    let s;
    switch (i >= 17 ? s = ks.evening : i >= 12 ? s = ks.afternoon : i >= 4 ? s = ks.morning : s = ks.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let i = t.getHours() % 12;
      return i === 0 && (i = 12), n.ordinalNumber(i, { unit: "hour" });
    }
    return oi.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : oi.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const i = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(i, { unit: "hour" }) : Ge(i, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let i = t.getHours();
    return i === 0 && (i = 24), e === "ko" ? n.ordinalNumber(i, { unit: "hour" }) : Ge(i, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : oi.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : oi.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return oi.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const i = t.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return jm(i);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return ji(i);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return ji(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const i = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return jm(i);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return ji(i);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return ji(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const i = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ym(i, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + ji(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const i = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ym(i, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + ji(i, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const i = Math.trunc(+t / 1e3);
    return Ge(i, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return Ge(+t, e.length);
  }
};
function Ym(t, e = "") {
  const n = t > 0 ? "-" : "+", i = Math.abs(t), s = Math.trunc(i / 60), r = i % 60;
  return r === 0 ? n + String(s) : n + String(s) + e + Ge(r, 2);
}
function jm(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + Ge(Math.abs(t) / 60, 2) : ji(t, e);
}
function ji(t, e = "") {
  const n = t > 0 ? "-" : "+", i = Math.abs(t), s = Ge(Math.trunc(i / 60), 2), r = Ge(i % 60, 2);
  return n + s + e + r;
}
const qm = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, ky = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, VD = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], i = n[1], s = n[2];
  if (!s)
    return qm(t, e);
  let r;
  switch (i) {
    case "P":
      r = e.dateTime({ width: "short" });
      break;
    case "PP":
      r = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      r = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      r = e.dateTime({ width: "full" });
      break;
  }
  return r.replace("{{date}}", qm(i, e)).replace("{{time}}", ky(s, e));
}, dc = {
  p: ky,
  P: VD
}, ND = /^D+$/, BD = /^Y+$/, zD = ["D", "DD", "YY", "YYYY"];
function My(t) {
  return ND.test(t);
}
function Sy(t) {
  return BD.test(t);
}
function fc(t, e, n) {
  const i = WD(t, e, n);
  if (console.warn(i), zD.includes(t)) throw new RangeError(i);
}
function WD(t, e, n) {
  const i = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${i} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const HD = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, YD = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, jD = /^'([^]*?)'?$/, qD = /''/g, UD = /[a-zA-Z]/;
function Lt(t, e, n) {
  var c, d, f, h, m, p, g, y;
  const i = ps(), s = (n == null ? void 0 : n.locale) ?? i.locale ?? xy, r = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((h = (f = i.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, a = (n == null ? void 0 : n.weekStartsOn) ?? ((p = (m = n == null ? void 0 : n.locale) == null ? void 0 : m.options) == null ? void 0 : p.weekStartsOn) ?? i.weekStartsOn ?? ((y = (g = i.locale) == null ? void 0 : g.options) == null ? void 0 : y.weekStartsOn) ?? 0, o = _e(t, n == null ? void 0 : n.in);
  if (!Ir(o))
    throw new RangeError("Invalid time value");
  let l = e.match(YD).map((v) => {
    const b = v[0];
    if (b === "p" || b === "P") {
      const _ = dc[b];
      return _(v, s.formatLong);
    }
    return v;
  }).join("").match(HD).map((v) => {
    if (v === "''")
      return { isToken: !1, value: "'" };
    const b = v[0];
    if (b === "'")
      return { isToken: !1, value: XD(v) };
    if (Hm[b])
      return { isToken: !0, value: v };
    if (b.match(UD))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + b + "`"
      );
    return { isToken: !1, value: v };
  });
  s.localize.preprocessor && (l = s.localize.preprocessor(o, l));
  const u = {
    firstWeekContainsDate: r,
    weekStartsOn: a,
    locale: s
  };
  return l.map((v) => {
    if (!v.isToken) return v.value;
    const b = v.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Sy(b) || !(n != null && n.useAdditionalDayOfYearTokens) && My(b)) && fc(b, e, String(t));
    const _ = Hm[b[0]];
    return _(o, b, s.localize, u);
  }).join("");
}
function XD(t) {
  const e = t.match(jD);
  return e ? e[1].replace(qD, "'") : t;
}
function GD(t, e) {
  return _e(t, e == null ? void 0 : e.in).getDay();
}
function Oy(t, e) {
  const n = _e(t, e == null ? void 0 : e.in), i = n.getFullYear(), s = n.getMonth(), r = Qe(n, 0);
  return r.setFullYear(i, s + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
function ZD(t, e) {
  const i = _e(t, e == null ? void 0 : e.in).getFullYear();
  return i % 400 === 0 || i % 4 === 0 && i % 100 !== 0;
}
function KD(t, e) {
  const n = _e(t, e == null ? void 0 : e.in);
  return Number.isNaN(+n) ? NaN : ZD(n) ? 366 : 365;
}
function QD() {
  return Object.assign({}, ps());
}
function ni(t, e) {
  return _e(t, e == null ? void 0 : e.in).getHours();
}
function JD(t, e) {
  const n = _e(t, e == null ? void 0 : e.in).getDay();
  return n === 0 ? 7 : n;
}
function Ri(t, e) {
  return _e(t, e == null ? void 0 : e.in).getMinutes();
}
function Fe(t, e) {
  return _e(t, e == null ? void 0 : e.in).getMonth();
}
function Xs(t) {
  return _e(t).getSeconds();
}
function su(t, e) {
  const n = _e(t, e == null ? void 0 : e.in), i = n.getMonth();
  return n.setFullYear(n.getFullYear(), i + 1, 0), n.setHours(0, 0, 0, 0), _e(n, e == null ? void 0 : e.in);
}
function Oe(t, e) {
  return _e(t, e == null ? void 0 : e.in).getFullYear();
}
function ls(t, e) {
  return +_e(t) > +_e(e);
}
function Gs(t, e) {
  return +_e(t) < +_e(e);
}
function Cs(t, e) {
  return +_e(t) == +_e(e);
}
function eT(t, e) {
  const n = tT(e) ? new e(0) : Qe(e, 0);
  return n.setFullYear(t.getFullYear(), t.getMonth(), t.getDate()), n.setHours(
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  ), n;
}
function tT(t) {
  var e;
  return typeof t == "function" && ((e = t.prototype) == null ? void 0 : e.constructor) === t;
}
const nT = 10;
class Dy {
  constructor() {
    X(this, "subPriority", 0);
  }
  validate(e, n) {
    return !0;
  }
}
class iT extends Dy {
  constructor(e, n, i, s, r) {
    super(), this.value = e, this.validateValue = n, this.setValue = i, this.priority = s, r && (this.subPriority = r);
  }
  validate(e, n) {
    return this.validateValue(e, this.value, n);
  }
  set(e, n, i) {
    return this.setValue(e, n, this.value, i);
  }
}
class sT extends Dy {
  constructor(n, i) {
    super();
    X(this, "priority", nT);
    X(this, "subPriority", -1);
    this.context = n || ((s) => Qe(i, s));
  }
  set(n, i) {
    return i.timestampIsSet ? n : Qe(n, eT(n, this.context));
  }
}
class je {
  run(e, n, i, s) {
    const r = this.parse(e, n, i, s);
    return r ? {
      setter: new iT(
        r.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: r.rest
    } : null;
  }
  validate(e, n, i) {
    return !0;
  }
}
class rT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 140);
    X(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, i, s) {
    switch (i) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return s.era(n, { width: "abbreviated" }) || s.era(n, { width: "narrow" });
      // A, B
      case "GGGGG":
        return s.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return s.era(n, { width: "wide" }) || s.era(n, { width: "abbreviated" }) || s.era(n, { width: "narrow" });
    }
  }
  set(n, i, s) {
    return i.era = s, n.setFullYear(s, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const wt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, In = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function xt(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function ut(t, e) {
  const n = e.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: e.slice(n[0].length)
  } : null;
}
function Fn(t, e) {
  const n = e.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const i = n[1] === "+" ? 1 : -1, s = n[2] ? parseInt(n[2], 10) : 0, r = n[3] ? parseInt(n[3], 10) : 0, a = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: i * (s * hy + r * ZO + a * KO),
    rest: e.slice(n[0].length)
  };
}
function Ty(t) {
  return ut(wt.anyDigitsSigned, t);
}
function pt(t, e) {
  switch (t) {
    case 1:
      return ut(wt.singleDigit, e);
    case 2:
      return ut(wt.twoDigits, e);
    case 3:
      return ut(wt.threeDigits, e);
    case 4:
      return ut(wt.fourDigits, e);
    default:
      return ut(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function bo(t, e) {
  switch (t) {
    case 1:
      return ut(wt.singleDigitSigned, e);
    case 2:
      return ut(wt.twoDigitsSigned, e);
    case 3:
      return ut(wt.threeDigitsSigned, e);
    case 4:
      return ut(wt.fourDigitsSigned, e);
    default:
      return ut(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function yd(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Py(t, e) {
  const n = e > 0, i = n ? e : 1 - e;
  let s;
  if (i <= 50)
    s = t || 100;
  else {
    const r = i + 50, a = Math.trunc(r / 100) * 100, o = t >= r % 100;
    s = t + a - (o ? 100 : 0);
  }
  return n ? s : 1 - s;
}
function Cy(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
class aT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 130);
    X(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, i, s) {
    const r = (a) => ({
      year: a,
      isTwoDigitYear: i === "yy"
    });
    switch (i) {
      case "y":
        return xt(pt(4, n), r);
      case "yo":
        return xt(
          s.ordinalNumber(n, {
            unit: "year"
          }),
          r
        );
      default:
        return xt(pt(i.length, n), r);
    }
  }
  validate(n, i) {
    return i.isTwoDigitYear || i.year > 0;
  }
  set(n, i, s) {
    const r = n.getFullYear();
    if (s.isTwoDigitYear) {
      const o = Py(
        s.year,
        r
      );
      return n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const a = !("era" in i) || i.era === 1 ? s.year : 1 - s.year;
    return n.setFullYear(a, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class oT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 130);
    X(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, i, s) {
    const r = (a) => ({
      year: a,
      isTwoDigitYear: i === "YY"
    });
    switch (i) {
      case "Y":
        return xt(pt(4, n), r);
      case "Yo":
        return xt(
          s.ordinalNumber(n, {
            unit: "year"
          }),
          r
        );
      default:
        return xt(pt(i.length, n), r);
    }
  }
  validate(n, i) {
    return i.isTwoDigitYear || i.year > 0;
  }
  set(n, i, s, r) {
    const a = pd(n, r);
    if (s.isTwoDigitYear) {
      const l = Py(
        s.year,
        a
      );
      return n.setFullYear(
        l,
        0,
        r.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), Dn(n, r);
    }
    const o = !("era" in i) || i.era === 1 ? s.year : 1 - s.year;
    return n.setFullYear(o, 0, r.firstWeekContainsDate), n.setHours(0, 0, 0, 0), Dn(n, r);
  }
}
class lT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 130);
    X(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i) {
    return bo(i === "R" ? 4 : i.length, n);
  }
  set(n, i, s) {
    const r = Qe(n, 0);
    return r.setFullYear(s, 0, 4), r.setHours(0, 0, 0, 0), $i(r);
  }
}
class uT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 130);
    X(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, i) {
    return bo(i === "u" ? 4 : i.length, n);
  }
  set(n, i, s) {
    return n.setFullYear(s, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class cT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 120);
    X(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, s) {
    switch (i) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return pt(i.length, n);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return s.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return s.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return s.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return s.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || s.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 4;
  }
  set(n, i, s) {
    return n.setMonth((s - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class dT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 120);
    X(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, s) {
    switch (i) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return pt(i.length, n);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return s.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return s.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return s.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return s.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || s.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 4;
  }
  set(n, i, s) {
    return n.setMonth((s - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class fT extends je {
  constructor() {
    super(...arguments);
    X(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    X(this, "priority", 110);
  }
  parse(n, i, s) {
    const r = (a) => a - 1;
    switch (i) {
      // 1, 2, ..., 12
      case "M":
        return xt(
          ut(wt.month, n),
          r
        );
      // 01, 02, ..., 12
      case "MM":
        return xt(pt(2, n), r);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return xt(
          s.ordinalNumber(n, {
            unit: "month"
          }),
          r
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return s.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(n, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return s.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return s.month(n, { width: "wide", context: "formatting" }) || s.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 11;
  }
  set(n, i, s) {
    return n.setMonth(s, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class hT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 110);
    X(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, s) {
    const r = (a) => a - 1;
    switch (i) {
      // 1, 2, ..., 12
      case "L":
        return xt(
          ut(wt.month, n),
          r
        );
      // 01, 02, ..., 12
      case "LL":
        return xt(pt(2, n), r);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return xt(
          s.ordinalNumber(n, {
            unit: "month"
          }),
          r
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return s.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(n, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return s.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return s.month(n, { width: "wide", context: "standalone" }) || s.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 11;
  }
  set(n, i, s) {
    return n.setMonth(s, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function mT(t, e, n) {
  const i = _e(t, n == null ? void 0 : n.in), s = gd(i, n) - e;
  return i.setDate(i.getDate() - s * 7), _e(i, n == null ? void 0 : n.in);
}
class pT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 100);
    X(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, i, s) {
    switch (i) {
      case "w":
        return ut(wt.week, n);
      case "wo":
        return s.ordinalNumber(n, { unit: "week" });
      default:
        return pt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 53;
  }
  set(n, i, s, r) {
    return Dn(mT(n, s, r), r);
  }
}
function gT(t, e, n) {
  const i = _e(t, n == null ? void 0 : n.in), s = md(i, n) - e;
  return i.setDate(i.getDate() - s * 7), i;
}
class yT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 100);
    X(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, s) {
    switch (i) {
      case "I":
        return ut(wt.week, n);
      case "Io":
        return s.ordinalNumber(n, { unit: "week" });
      default:
        return pt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 53;
  }
  set(n, i, s) {
    return $i(gT(n, s));
  }
}
const vT = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], bT = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class wT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 90);
    X(this, "subPriority", 1);
    X(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, s) {
    switch (i) {
      case "d":
        return ut(wt.date, n);
      case "do":
        return s.ordinalNumber(n, { unit: "date" });
      default:
        return pt(i.length, n);
    }
  }
  validate(n, i) {
    const s = n.getFullYear(), r = Cy(s), a = n.getMonth();
    return r ? i >= 1 && i <= bT[a] : i >= 1 && i <= vT[a];
  }
  set(n, i, s) {
    return n.setDate(s), n.setHours(0, 0, 0, 0), n;
  }
}
class xT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 90);
    X(this, "subpriority", 1);
    X(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, s) {
    switch (i) {
      case "D":
      case "DD":
        return ut(wt.dayOfYear, n);
      case "Do":
        return s.ordinalNumber(n, { unit: "date" });
      default:
        return pt(i.length, n);
    }
  }
  validate(n, i) {
    const s = n.getFullYear();
    return Cy(s) ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
  }
  set(n, i, s) {
    return n.setMonth(0, s), n.setHours(0, 0, 0, 0), n;
  }
}
function vd(t, e, n) {
  var d, f, h, m;
  const i = ps(), s = (n == null ? void 0 : n.weekStartsOn) ?? ((f = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? i.weekStartsOn ?? ((m = (h = i.locale) == null ? void 0 : h.options) == null ? void 0 : m.weekStartsOn) ?? 0, r = _e(t, n == null ? void 0 : n.in), a = r.getDay(), l = (e % 7 + 7) % 7, u = 7 - s, c = e < 0 || e > 6 ? e - (a + u) % 7 : (l + u) % 7 - (a + u) % 7;
  return fn(r, c, n);
}
class _T extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 90);
    X(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, i, s) {
    switch (i) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return s.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(n, { width: "short", context: "formatting" }) || s.day(n, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return s.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return s.day(n, { width: "short", context: "formatting" }) || s.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return s.day(n, { width: "wide", context: "formatting" }) || s.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(n, { width: "short", context: "formatting" }) || s.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 6;
  }
  set(n, i, s, r) {
    return n = vd(n, s, r), n.setHours(0, 0, 0, 0), n;
  }
}
class kT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 90);
    X(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, s, r) {
    const a = (o) => {
      const l = Math.floor((o - 1) / 7) * 7;
      return (o + r.weekStartsOn + 6) % 7 + l;
    };
    switch (i) {
      // 3
      case "e":
      case "ee":
        return xt(pt(i.length, n), a);
      // 3rd
      case "eo":
        return xt(
          s.ordinalNumber(n, {
            unit: "day"
          }),
          a
        );
      // Tue
      case "eee":
        return s.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(n, { width: "short", context: "formatting" }) || s.day(n, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return s.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return s.day(n, { width: "short", context: "formatting" }) || s.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return s.day(n, { width: "wide", context: "formatting" }) || s.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(n, { width: "short", context: "formatting" }) || s.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 6;
  }
  set(n, i, s, r) {
    return n = vd(n, s, r), n.setHours(0, 0, 0, 0), n;
  }
}
class MT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 90);
    X(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, i, s, r) {
    const a = (o) => {
      const l = Math.floor((o - 1) / 7) * 7;
      return (o + r.weekStartsOn + 6) % 7 + l;
    };
    switch (i) {
      // 3
      case "c":
      case "cc":
        return xt(pt(i.length, n), a);
      // 3rd
      case "co":
        return xt(
          s.ordinalNumber(n, {
            unit: "day"
          }),
          a
        );
      // Tue
      case "ccc":
        return s.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(n, { width: "short", context: "standalone" }) || s.day(n, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return s.day(n, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return s.day(n, { width: "short", context: "standalone" }) || s.day(n, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return s.day(n, { width: "wide", context: "standalone" }) || s.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(n, { width: "short", context: "standalone" }) || s.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 6;
  }
  set(n, i, s, r) {
    return n = vd(n, s, r), n.setHours(0, 0, 0, 0), n;
  }
}
function ST(t, e, n) {
  const i = _e(t, n == null ? void 0 : n.in), s = JD(i, n), r = e - s;
  return fn(i, r, n);
}
class OT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 90);
    X(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, s) {
    const r = (a) => a === 0 ? 7 : a;
    switch (i) {
      // 2
      case "i":
      case "ii":
        return pt(i.length, n);
      // 2nd
      case "io":
        return s.ordinalNumber(n, { unit: "day" });
      // Tue
      case "iii":
        return xt(
          s.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(n, {
            width: "short",
            context: "formatting"
          }) || s.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      // T
      case "iiiii":
        return xt(
          s.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      // Tu
      case "iiiiii":
        return xt(
          s.day(n, {
            width: "short",
            context: "formatting"
          }) || s.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      // Tuesday
      case "iiii":
      default:
        return xt(
          s.day(n, {
            width: "wide",
            context: "formatting"
          }) || s.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(n, {
            width: "short",
            context: "formatting"
          }) || s.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 7;
  }
  set(n, i, s) {
    return n = ST(n, s), n.setHours(0, 0, 0, 0), n;
  }
}
class DT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 80);
    X(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, i, s) {
    switch (i) {
      case "a":
      case "aa":
      case "aaa":
        return s.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, i, s) {
    return n.setHours(yd(s), 0, 0, 0), n;
  }
}
class TT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 80);
    X(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, i, s) {
    switch (i) {
      case "b":
      case "bb":
      case "bbb":
        return s.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, i, s) {
    return n.setHours(yd(s), 0, 0, 0), n;
  }
}
class PT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 80);
    X(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, i, s) {
    switch (i) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, i, s) {
    return n.setHours(yd(s), 0, 0, 0), n;
  }
}
class CT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 70);
    X(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, i, s) {
    switch (i) {
      case "h":
        return ut(wt.hour12h, n);
      case "ho":
        return s.ordinalNumber(n, { unit: "hour" });
      default:
        return pt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 12;
  }
  set(n, i, s) {
    const r = n.getHours() >= 12;
    return r && s < 12 ? n.setHours(s + 12, 0, 0, 0) : !r && s === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(s, 0, 0, 0), n;
  }
}
class AT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 70);
    X(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, i, s) {
    switch (i) {
      case "H":
        return ut(wt.hour23h, n);
      case "Ho":
        return s.ordinalNumber(n, { unit: "hour" });
      default:
        return pt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 23;
  }
  set(n, i, s) {
    return n.setHours(s, 0, 0, 0), n;
  }
}
class ET extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 70);
    X(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, i, s) {
    switch (i) {
      case "K":
        return ut(wt.hour11h, n);
      case "Ko":
        return s.ordinalNumber(n, { unit: "hour" });
      default:
        return pt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 11;
  }
  set(n, i, s) {
    return n.getHours() >= 12 && s < 12 ? n.setHours(s + 12, 0, 0, 0) : n.setHours(s, 0, 0, 0), n;
  }
}
class $T extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 70);
    X(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, i, s) {
    switch (i) {
      case "k":
        return ut(wt.hour24h, n);
      case "ko":
        return s.ordinalNumber(n, { unit: "hour" });
      default:
        return pt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 24;
  }
  set(n, i, s) {
    const r = s <= 24 ? s % 24 : s;
    return n.setHours(r, 0, 0, 0), n;
  }
}
class RT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 60);
    X(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, i, s) {
    switch (i) {
      case "m":
        return ut(wt.minute, n);
      case "mo":
        return s.ordinalNumber(n, { unit: "minute" });
      default:
        return pt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 59;
  }
  set(n, i, s) {
    return n.setMinutes(s, 0, 0), n;
  }
}
class LT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 50);
    X(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, i, s) {
    switch (i) {
      case "s":
        return ut(wt.second, n);
      case "so":
        return s.ordinalNumber(n, { unit: "second" });
      default:
        return pt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 59;
  }
  set(n, i, s) {
    return n.setSeconds(s, 0), n;
  }
}
class IT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 30);
    X(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, i) {
    const s = (r) => Math.trunc(r * Math.pow(10, -i.length + 3));
    return xt(pt(i.length, n), s);
  }
  set(n, i, s) {
    return n.setMilliseconds(s), n;
  }
}
class FT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 10);
    X(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, i) {
    switch (i) {
      case "X":
        return Fn(
          In.basicOptionalMinutes,
          n
        );
      case "XX":
        return Fn(In.basic, n);
      case "XXXX":
        return Fn(
          In.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return Fn(
          In.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return Fn(In.extended, n);
    }
  }
  set(n, i, s) {
    return i.timestampIsSet ? n : Qe(
      n,
      n.getTime() - vo(n) - s
    );
  }
}
class VT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 10);
    X(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, i) {
    switch (i) {
      case "x":
        return Fn(
          In.basicOptionalMinutes,
          n
        );
      case "xx":
        return Fn(In.basic, n);
      case "xxxx":
        return Fn(
          In.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return Fn(
          In.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return Fn(In.extended, n);
    }
  }
  set(n, i, s) {
    return i.timestampIsSet ? n : Qe(
      n,
      n.getTime() - vo(n) - s
    );
  }
}
class NT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 40);
    X(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Ty(n);
  }
  set(n, i, s) {
    return [Qe(n, s * 1e3), { timestampIsSet: !0 }];
  }
}
class BT extends je {
  constructor() {
    super(...arguments);
    X(this, "priority", 20);
    X(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Ty(n);
  }
  set(n, i, s) {
    return [Qe(n, s), { timestampIsSet: !0 }];
  }
}
const zT = {
  G: new rT(),
  y: new aT(),
  Y: new oT(),
  R: new lT(),
  u: new uT(),
  Q: new cT(),
  q: new dT(),
  M: new fT(),
  L: new hT(),
  w: new pT(),
  I: new yT(),
  d: new wT(),
  D: new xT(),
  E: new _T(),
  e: new kT(),
  c: new MT(),
  i: new OT(),
  a: new DT(),
  b: new TT(),
  B: new PT(),
  h: new CT(),
  H: new AT(),
  K: new ET(),
  k: new $T(),
  m: new RT(),
  s: new LT(),
  S: new IT(),
  X: new FT(),
  x: new VT(),
  t: new NT(),
  T: new BT()
}, WT = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, HT = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, YT = /^'([^]*?)'?$/, jT = /''/g, qT = /\S/, UT = /[a-zA-Z]/;
function hc(t, e, n, i) {
  var g, y, v, b, _, M, A, E;
  const s = () => Qe((i == null ? void 0 : i.in) || n, NaN), r = QD(), a = (i == null ? void 0 : i.locale) ?? r.locale ?? xy, o = (i == null ? void 0 : i.firstWeekContainsDate) ?? ((y = (g = i == null ? void 0 : i.locale) == null ? void 0 : g.options) == null ? void 0 : y.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((b = (v = r.locale) == null ? void 0 : v.options) == null ? void 0 : b.firstWeekContainsDate) ?? 1, l = (i == null ? void 0 : i.weekStartsOn) ?? ((M = (_ = i == null ? void 0 : i.locale) == null ? void 0 : _.options) == null ? void 0 : M.weekStartsOn) ?? r.weekStartsOn ?? ((E = (A = r.locale) == null ? void 0 : A.options) == null ? void 0 : E.weekStartsOn) ?? 0;
  if (!e)
    return t ? s() : _e(n, i == null ? void 0 : i.in);
  const u = {
    firstWeekContainsDate: o,
    weekStartsOn: l,
    locale: a
  }, c = [new sT(i == null ? void 0 : i.in, n)], d = e.match(HT).map((I) => {
    const S = I[0];
    if (S in dc) {
      const $ = dc[S];
      return $(I, a.formatLong);
    }
    return I;
  }).join("").match(WT), f = [];
  for (let I of d) {
    !(i != null && i.useAdditionalWeekYearTokens) && Sy(I) && fc(I, e, t), !(i != null && i.useAdditionalDayOfYearTokens) && My(I) && fc(I, e, t);
    const S = I[0], $ = zT[S];
    if ($) {
      const { incompatibleTokens: B } = $;
      if (Array.isArray(B)) {
        const G = f.find(
          (P) => B.includes(P.token) || P.token === S
        );
        if (G)
          throw new RangeError(
            `The format string mustn't contain \`${G.fullToken}\` and \`${I}\` at the same time`
          );
      } else if ($.incompatibleTokens === "*" && f.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${I}\` and any other token at the same time`
        );
      f.push({ token: S, fullToken: I });
      const V = $.run(
        t,
        I,
        a.match,
        u
      );
      if (!V)
        return s();
      c.push(V.setter), t = V.rest;
    } else {
      if (S.match(UT))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + S + "`"
        );
      if (I === "''" ? I = "'" : S === "'" && (I = XT(I)), t.indexOf(I) === 0)
        t = t.slice(I.length);
      else
        return s();
    }
  }
  if (t.length > 0 && qT.test(t))
    return s();
  const h = c.map((I) => I.priority).sort((I, S) => S - I).filter((I, S, $) => $.indexOf(I) === S).map(
    (I) => c.filter((S) => S.priority === I).sort((S, $) => $.subPriority - S.subPriority)
  ).map((I) => I[0]);
  let m = _e(n, i == null ? void 0 : i.in);
  if (isNaN(+m)) return s();
  const p = {};
  for (const I of h) {
    if (!I.validate(m, u))
      return s();
    const S = I.set(m, p, u);
    Array.isArray(S) ? (m = S[0], Object.assign(p, S[1])) : m = S;
  }
  return m;
}
function XT(t) {
  return t.match(YT)[1].replace(jT, "'");
}
function Um(t, e, n) {
  const [i, s] = fa(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return +Gi(i) == +Gi(s);
}
function Fr(t, e, n) {
  return fn(t, -e, n);
}
function GT(t, e) {
  const n = e == null ? void 0 : e.weekStartsOn, i = _e(t, e == null ? void 0 : e.in), s = i.getDay(), r = (s < n ? -7 : 0) + 6 - (s - n);
  return i.setHours(0, 0, 0, 0), i.setDate(i.getDate() + r), i;
}
function Xm(t, e) {
  return GT(t, { ...e, weekStartsOn: 1 });
}
function ru(t, e) {
  const n = _e(t, e == null ? void 0 : e.in), i = n.getFullYear();
  return n.setFullYear(i + 1, 0, 0), n.setHours(0, 0, 0, 0), n;
}
function Ay(t, e, n) {
  const i = _e(t, n == null ? void 0 : n.in), s = i.getFullYear(), r = i.getDate(), a = Qe(t, 0);
  a.setFullYear(s, e, 15), a.setHours(0, 0, 0, 0);
  const o = Oy(a);
  return i.setMonth(e, Math.min(r, o)), i;
}
function Je(t, e, n) {
  let i = _e(t, n == null ? void 0 : n.in);
  return isNaN(+i) ? Qe(t, NaN) : (e.year != null && i.setFullYear(e.year), e.month != null && (i = Ay(i, e.month)), e.date != null && i.setDate(e.date), e.hours != null && i.setHours(e.hours), e.minutes != null && i.setMinutes(e.minutes), e.seconds != null && i.setSeconds(e.seconds), e.milliseconds != null && i.setMilliseconds(e.milliseconds), i);
}
function ZT(t, e, n) {
  const i = _e(t, n == null ? void 0 : n.in);
  return i.setHours(e), i;
}
function Ey(t, e, n) {
  const i = _e(t, n == null ? void 0 : n.in);
  return i.setMilliseconds(e), i;
}
function KT(t, e, n) {
  const i = _e(t, n == null ? void 0 : n.in);
  return i.setMinutes(e), i;
}
function $y(t, e, n) {
  const i = _e(t, n == null ? void 0 : n.in);
  return i.setSeconds(e), i;
}
function Vn(t, e, n) {
  const i = _e(t, n == null ? void 0 : n.in);
  return isNaN(+i) ? Qe(t, NaN) : (i.setFullYear(e), i);
}
function Gm(t) {
  return uc(Date.now(), t);
}
function Zs(t, e, n) {
  return kn(t, -e, n);
}
function qi(t, e, n) {
  const {
    years: i = 0,
    months: s = 0,
    weeks: r = 0,
    days: a = 0,
    hours: o = 0,
    minutes: l = 0,
    seconds: u = 0
  } = e, c = Zs(t, s + i * 12, n), d = Fr(c, a + r * 7, n), f = l + o * 60, m = (u + f * 60) * 1e3;
  return Qe(t, +d - m);
}
function Ry(t, e, n) {
  return hd(t, -e, n);
}
const QT = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, JT = (t, e, n) => {
  let i;
  const s = QT[t];
  return typeof s == "string" ? i = s : e === 1 ? i = s.one : i = s.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "over " + i : i + " geleden" : i;
}, eP = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, tP = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, nP = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, iP = {
  date: Is({
    formats: eP,
    defaultWidth: "full"
  }),
  time: Is({
    formats: tP,
    defaultWidth: "full"
  }),
  dateTime: Is({
    formats: nP,
    defaultWidth: "full"
  })
}, sP = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, rP = (t, e, n, i) => sP[t], aP = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, oP = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, lP = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, uP = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag"
  ]
}, cP = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, dP = (t, e) => Number(t) + "e", fP = {
  ordinalNumber: dP,
  era: Rn({
    values: aP,
    defaultWidth: "wide"
  }),
  quarter: Rn({
    values: oP,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: Rn({
    values: lP,
    defaultWidth: "wide"
  }),
  day: Rn({
    values: uP,
    defaultWidth: "wide"
  }),
  dayPeriod: Rn({
    values: cP,
    defaultWidth: "wide"
  })
}, hP = /^(\d+)e?/i, mP = /\d+/i, pP = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, gP = {
  any: [/^v/, /^n/]
}, yP = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, vP = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, bP = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, wP = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mei/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i
  ]
}, xP = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, _P = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, kP = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, MP = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, SP = {
  ordinalNumber: wy({
    matchPattern: hP,
    parsePattern: mP,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Ln({
    matchPatterns: pP,
    defaultMatchWidth: "wide",
    parsePatterns: gP,
    defaultParseWidth: "any"
  }),
  quarter: Ln({
    matchPatterns: yP,
    defaultMatchWidth: "wide",
    parsePatterns: vP,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Ln({
    matchPatterns: bP,
    defaultMatchWidth: "wide",
    parsePatterns: wP,
    defaultParseWidth: "any"
  }),
  day: Ln({
    matchPatterns: xP,
    defaultMatchWidth: "wide",
    parsePatterns: _P,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ln({
    matchPatterns: kP,
    defaultMatchWidth: "any",
    parsePatterns: MP,
    defaultParseWidth: "any"
  })
}, hi = {
  code: "nl",
  formatDistance: JT,
  formatLong: iP,
  formatRelative: rP,
  localize: fP,
  match: SP,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, OP = { class: "bg-gray-100 px-4 py-2" }, DP = { class: "font-medium" }, TP = { class: "m-2 flex flex-col gap-2" }, PP = {
  key: 0,
  class: "flex flex-col gap-2 px-2"
}, CP = { class: "font-bold" }, AP = { class: "flex items-center gap-1 text-sm text-gray" }, EP = {
  key: 1,
  class: "flex flex-col gap-2"
}, $P = { class: "text-sm font-bold" }, RP = { class: "flex flex-wrap items-center gap-1 text-xs" }, LP = { class: "font-medium" }, IP = { class: "flex shrink-0 items-center gap-0.5" }, FP = {
  __name: "TimeseriesChartTooltip",
  props: {
    /**
     * Tooltip object provided by Chart.js tooltip plugin.
     */
    tooltip: {
      type: Object,
      required: !0
    },
    /**
     * Position of the tooltip in pixels with the following structure:
     * { x: ..., y: ... }
     */
    position: {
      type: Object,
      required: !0
    },
    /**
     * Axis Object from the `axes` property of a TimeseriesChart.
     */
    chartAxes: {
      type: Object,
      required: !0
    },
    annotationData: {
      type: Array,
      default: null
    }
  },
  setup(t) {
    const e = t, n = ee(), i = ee(), s = ee(""), r = ee([]), a = ee([]), { floatingStyles: o } = Pc(n, i, {
      whileElementsMounted: Oc,
      placement: "right",
      middleware: [Dc(20), Tc({ padding: 120 }), Tp({ padding: 12 })]
    });
    function l(f, h = 0) {
      n.value = {
        getBoundingClientRect() {
          return {
            width: h,
            height: 0,
            x: f.x - h,
            y: f.y,
            top: f.y,
            left: f.x - h,
            right: f.x,
            bottom: f.y
          };
        }
      };
    }
    function u(f, h) {
      s.value = Lt(h, "d MMM y, HH:mm", {
        locale: hi
      }), r.value = f.chart.data.datasets.filter((m) => m.label.search(/_glow$/) === -1).map((m) => {
        const p = m.data.find((y) => y.x === h), g = e.chartAxes[m.yAxisID];
        return p && {
          label: m.label,
          value: _l(
            p.y,
            m.serie.precision,
            g.unit,
            g.format
          ),
          backgroundColor: m.backgroundColor,
          borderColor: m.borderColor
        };
      }).filter((m) => m);
    }
    function c(f, h) {
      if (!e.annotationData) {
        a.value = null;
        return;
      }
      a.value = f.map((m) => {
        const { data: p, ...g } = m, y = p.find((v) => h >= v.datetimeStart && h < v.datetimeStop);
        return y && {
          label: g.label,
          colorScale: g.colorScale,
          value: y.value || y.value === 0 ? _l(
            y.value,
            g.precision,
            g.unit,
            g.format
          ) : null,
          timeStart: Lt(y.datetimeStart, "HH:mm", { locale: hi }),
          timeStop: Lt(y.datetimeStop, "HH:mm", { locale: hi })
        };
      }).filter((m) => m);
    }
    function d(f, h) {
      s.value = Lt(h[0], "d MMM y", {
        locale: hi
      });
      const m = f.dataPoints[0].dataset.serie, p = f.dataPoints[0].raw.value;
      a.value = [
        {
          label: m.label,
          colorScale: m.colorScale,
          value: p || p === 0 ? _l(p, m.precision, m.unit, m.format) : null,
          timeStart: Lt(h[0], "HH:mm", { locale: hi }),
          timeStop: Lt(h[1], "HH:mm", { locale: hi })
        }
      ];
    }
    return ct(
      () => e.position,
      (f) => {
        const h = e.tooltip.dataPoints[0].raw.x;
        e.tooltip.isAnnotation ? (l(f, e.tooltip.dataPoints[0].element.width), d(e.tooltip, h)) : (l(f), u(e.tooltip, h), c(e.annotationData, h));
      },
      { immediate: !0 }
    ), (f, h) => (O(), Se(yp, {
      ref_key: "tooltipRef",
      ref: i,
      class: "pointer-events-none absolute left-0 top-0 z-50 w-48 overflow-clip rounded-lg border-none text-gray-900",
      style: tt(C(o))
    }, {
      default: be(() => [
        J("div", OP, [
          J("div", DP, ve(s.value), 1)
        ]),
        J("div", TP, [
          r.value.length ? (O(), R("div", PP, [
            (O(!0), R(ye, null, Te(r.value, (m) => (O(), R("div", {
              key: m.label
            }, [
              J("p", CP, ve(m.value), 1),
              J("div", AP, [
                J("div", {
                  class: "size-3 shrink-0 rounded-full border-2",
                  style: tt({
                    backgroundColor: m.backgroundColor,
                    borderColor: m.borderColor
                  })
                }, null, 4),
                J("span", null, ve(m.label), 1)
              ])
            ]))), 128))
          ])) : U("", !0),
          t.annotationData ? (O(), R("div", EP, [
            (O(!0), R(ye, null, Te(a.value, (m) => (O(), R("div", {
              key: m.label,
              class: "rounded p-2",
              style: tt({
                backgroundColor: m.colorScale[50],
                color: m.colorScale[900]
              })
            }, [
              J("p", $P, ve(m.value), 1),
              J("div", RP, [
                J("p", LP, ve(m.label), 1),
                J("div", IP, [
                  Ce(Xt, {
                    name: "time",
                    class: "text-sm"
                  }),
                  J("span", null, ve(m.timeStart) + " - " + ve(m.timeStop), 1)
                ])
              ])
            ], 4))), 128))
          ])) : U("", !0)
        ])
      ]),
      _: 1
    }, 8, ["style"]));
  }
}, VP = { class: "flex h-full w-full flex-col justify-stretch" }, NP = { class: "flex flex-1" }, BP = {
  key: 0,
  class: "flex w-4 items-center justify-center"
}, zP = { class: "-rotate-90 whitespace-nowrap text-xs font-normal text-gray-400 md:text-sm" }, WP = { class: "relative flex-1" }, HP = {
  key: 1,
  class: "flex w-4 items-center justify-center"
}, YP = { class: "rotate-90 whitespace-nowrap text-xs font-normal text-gray-400 md:text-sm" }, jP = { class: "mt-2 flex flex-wrap justify-between gap-2 border-t border-gray-200 pt-3 md:mt-3 md:pt-5" }, qP = { class: "flex gap-4" }, UP = ["onClick"], XP = { class: "text-xs text-gray-900 decoration-2 md:text-sm" }, GP = {
  key: 0,
  class: "border-l border-gray-200"
}, ZP = { key: 0 }, au = 50, Va = 300, Ms = 500, Zm = 700, KP = 900, QP = 3, JP = 3, eC = 2, tC = 0.4, Km = 3, Qm = 8, wE = {
  __name: "TimeseriesChart",
  props: {
    /**
     * Type of chart to display. Supported types are: `line`, `step`, `area` and
     * `bar`.
     */
    chartType: {
      type: String,
      default: "line",
      validator: (t) => ["line", "step", "area", "bar"].includes(t)
    },
    /**
     * Object specifying the properties for each series found in the `data` prop.
     * This also dictates the order of the data sets. Series missing from this
     * prop are not displayed in the chart.
     *
     * Can have the following properties:
     * - label (string): Displayed in the legend
     * - axis (string): The y-axis to which the series belongs, corresponds to the
     *   key of the `axes` prop
     * - colorScale (object): Tailwind-like color scale to use for the series
     * - precision (int): Number of decimal places to display in the tooltip (the
     *   unit is determined by the axis)
     *
     * Example:
     * {
     *   production: { label: "Production", axis: "energy", colorScale:
     *     colors.gray,
     *   },
     *   revenue: ...
     * }
     */
    series: {
      type: Object,
      required: !0
    },
    /**
     * Object specifying the properties for each y-axis. The keys of this object
     * must match the `axis` property of the series in the `series` prop. The
     * order of the axes is determined by the order of the keys.
     *
     * Can have the following properties:
     * - title (string): Displayed next to the axis
     * - unit (string): Scale the axis and shows SI-prefixed unit in the label
     * - precision (int): Number of decimal places to display in the tick labels
     * - limits (int[2]): Array with the min and max timestamps of the axis
     * - format (string): Format of the tick label, with '_' as a placeholder
     *
     * Example:
     * {
     *   energy: {
     *     title: "Energy",
     *     format: "€ _",
     *     precision: 2,
     *   },
     *   ...
     * }
     *
     * None of the axis properties are required, but the axis key itself is.
     */
    axes: {
      type: Object,
      required: !0
    },
    /**
     * Object representing the data to be displayed in the chart.
     * - Top-level keys represent x-values
     * - Second-level keys represent series' y-values, only shown if a matching
     *   entry in the 'series' prop is present.
     *
     * Example:
     * {
     *   "2020-01-01": {
     *     production: 100,
     *     revenue: 200,
     *   },
     *   ...
     * }
     */
    data: {
      type: Object,
      required: !0
    },
    /**
     * Optional array of time window series to display as timeline annotations
     * below the chart. Each series is an object with the following properties:
     * - data (array): Array of objects with a 'datetimeStart', 'datetimeStop' and
     *   optional 'value' property.
     * - label (string): Displayed at the start of the timeline
     * - colorScale (object): Tailwind-like color scale to use for the series
     * - unit (string): Show scaled and SI-prefixed value in the tooltip
     * - precision (int): Number of decimal places to display in the tooltip
     * - format (stiring): Format of the value label, with '_' as a placeholder
     *
     * Example:
     * [
     *   {
     *     label: "Offset volume",
     *     colorScale: colors.danger,
     *     unit: "m3",
     *     precision: 2,
     *     data: [
     *       {
     *         datetimeStart: "2020-01-01T00:00:00",
     *         datetimeStop: "2020-01-02T00:00:00",
     *         value: 100,
     *       },
     *       ...
     *     ],
     *   },
     *   ...
     * ]
     */
    annotationData: {
      type: Array,
      default: null
    },
    /**
     * Array with the min and max datetimes of the x-axis. If null, the limits are
     * determined by the data.
     */
    xLimits: {
      type: Array,
      default: () => [null, null]
    },
    /**
     * Time unit to use for the x-axis. Supported units are in the Chart.js docs
     */
    timeUnit: {
      type: String,
      default: null
    },
    /**
     * Whether to align the y-axes at zero. This is useful when comparing
     * different series with different scales.
     */
    alignedAxes: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = ee(), i = ee(), s = ee(), r = {
      responsive: !0,
      maintainAspectRatio: !1,
      animation: !1,
      scales: {
        x: {
          type: "time",
          time: {
            displayFormats: {
              hour: "HH:mm",
              day: "MMM dd",
              month: "MMM",
              year: "y"
            }
          },
          ticks: {
            maxRotation: 0,
            autoSkipPadding: 20
          },
          grid: {
            display: !1
          },
          border: {
            display: !1
          }
        }
      },
      plugins: {
        legend: {
          display: !1
        },
        tooltip: {
          enabled: !1
        },
        annotation: {
          annotations: {
            cursor: {
              type: "line",
              drawTime: "afterDatasetsDraw",
              borderColor: UO.gray[Va],
              borderWidth: 1
            }
          }
        }
      }
    }, a = ee(), o = er({}), l = ee(), u = ee({}), c = Z(() => [...new Set(Object.values(e.series).map((x) => x.axis))]), d = Z(() => {
      const x = {};
      return v.value.datasets.forEach(({ key: k, serie: D }) => {
        x[k] = D;
      }), x;
    }), f = Z(() => gO(e.series, e.data, a.value)), h = Z(() => {
      var k;
      let x = (k = e.axes[c.value[0]]) == null ? void 0 : k.title;
      return o[c.value[0]] && (x += ` (${o[c.value[0]].symbol})`), x;
    }), m = Z(() => {
      var k;
      let x = (k = e.axes[c.value[1]]) == null ? void 0 : k.title;
      return o[c.value[1]] && (x += ` (${o[c.value[1]].symbol})`), x;
    });
    function p(x, k, D) {
      return e.alignedAxes ? f.value[x][D] : k.limits ? k.limits[D === "min" ? 0 : 1] : null;
    }
    function g(x, k) {
      return x === "area" || k.secondary ? k.colorScale[Va] : k.colorScale[Ms];
    }
    function y(x, k) {
      const D = x[x.length - 1];
      x.push({
        ...D,
        label: `${k.label}_glow`,
        order: 1,
        pointHitRadius: null,
        borderColor: k.colorScale[Va] + "7F",
        // 50% opacity
        borderWidth: 14,
        borderJoinStyle: "round"
      });
    }
    const v = Z(() => {
      const x = [];
      for (const [k, D] of Object.entries(e.series)) {
        const N = D.type ?? e.chartType, L = b(k, D);
        L.length > 0 && (x.push(_(k, D, N, L)), D.secondary && ["line", "step"].includes(N) && y(x, D));
      }
      return { datasets: x };
    });
    function b(x, k) {
      const D = [];
      return Object.entries(e.data).forEach(([N, L]) => {
        if (x in L) {
          const z = L[x] === null ? null : L[x] * (k.rescale ?? 1);
          D.push({
            x: N,
            y: z
          });
        }
      }), D;
    }
    function _(x, k, D, N) {
      return {
        key: x,
        serie: k,
        label: k.label,
        data: N,
        yAxisID: k.axis,
        stack: k.stack,
        fill: D === "area" ? "origin" : !1,
        stepped: D === "step",
        type: D === "bar" ? "bar" : "line",
        pointRadius: 0,
        pointHitRadius: 40,
        borderColor: k.colorScale[Ms],
        borderWidth: $(D, k),
        borderRadius: 8,
        tension: D === "step" ? tC : null,
        backgroundColor: g(D, k),
        hoverBackgroundColor: k.colorScale[Zm],
        barPercentage: 1,
        hidden: u.value[x]
      };
    }
    const M = Z(() => {
      const x = {};
      return c.value.forEach((k, D) => {
        const N = e.axes[k];
        x[k] = {
          afterBuildTicks: (L) => {
            if (!e.alignedAxes)
              return;
            const z = L.ticks;
            if (D > 0 && z.length > Km) {
              const W = z[2].value - z[1].value, ae = z.length - 1, F = z[1].value - z[0].value > W ? z[1].value - W : void 0;
              z[0].value = F;
              const H = z[ae].value - z[ae - 1].value > W ? z[ae - 1].value + W : void 0;
              z[ae].value = H;
            }
          },
          afterUpdate: (L) => {
            const z = L.ticks;
            if (N.unit) {
              const W = z.map((Q) => Math.abs(Q.value)).filter(Number), ae = W.length ? Math.max(...W) : 0, [F, H] = Ap(ae, N.unit);
              o[k] = { scale: F, symbol: H };
            }
            e.alignedAxes && L.id === c.value[0] && !a.value && z.length > Km && (a.value = z[2].value - z[1].value);
          },
          // Show no more than 2 y-axes
          display: D < 2,
          max: p(k, N, "max"),
          min: p(k, N, "min"),
          position: D === 0 ? "left" : "right",
          ticks: {
            callback: (L, z, W) => I(k, L, W),
            padding: 20
          },
          grid: {
            display: D === 0,
            color: "#C8D3D9",
            lineWidth: 1,
            tickLength: 0
          },
          border: {
            dash: [8, 4],
            display: !1
          }
        };
      }), x;
    }), A = Z(() => {
      const x = lc(r, {
        scales: {
          x: {
            min: e.xLimits[0],
            max: e.xLimits[1],
            time: {
              unit: e.timeUnit
            }
          }
        },
        plugins: {
          tooltip: {
            external: S
          },
          annotation: {
            annotations: {
              annotationBox: {
                type: "box",
                display: !!B.value,
                drawTime: "beforeDraw",
                ...B.value
              },
              cursor: {
                display: !!n.value,
                xMin: n.value,
                xMax: n.value
              }
            }
          }
        }
      });
      return x.scales = { ...x.scales, ...M.value }, x;
    });
    function E(x) {
      for (let k = 0; k < x.length - 1; k++)
        if (Math.abs(x[k].value - x[k + 1].value) < 1)
          return !0;
      return !1;
    }
    function I(x, k, D) {
      var W;
      const N = e.axes[x], L = E(D) ? N.precision ?? 2 : N.precision ?? 0;
      o[x] && (k *= o[x].scale);
      const z = zr(k, L);
      return ((W = N.format) == null ? void 0 : W.replace("_", z)) || z;
    }
    function S(x, k = !1) {
      const D = x.tooltip;
      if (D.isAnnotation = k, D.opacity) {
        const { caretX: N, caretY: L } = D, { left: z, top: W } = x.chart.canvas.getBoundingClientRect();
        i.value = D, s.value = {
          x: N + z,
          y: L + W
        }, k || (n.value = D.dataPoints[0].raw.x);
      } else
        i.value = null, n.value = null;
    }
    function $(x, k) {
      return x === "bar" ? k.secondary ? QP : 0 : x === "line" ? JP : eC;
    }
    ct(
      () => [e.series, e.data],
      () => {
        a.value = null;
      }
    ), Ji.register(hO);
    const B = ee(), V = Z(() => {
      const x = [];
      for (const k of e.annotationData)
        x.push({
          serie: k,
          label: k.label,
          backgroundColor: k.colorScale[Ms],
          hoverBackgroundColor: k.colorScale[Zm],
          data: k.data.map((D) => ({
            x: [D.datetimeStart, D.datetimeStop],
            y: k.label,
            value: D.value
          }))
        });
      return { datasets: x };
    }), G = Z(() => {
      var x, k, D, N, L;
      return lc(r, {
        indexAxis: "y",
        interaction: {
          mode: "nearestBar"
        },
        scales: {
          x: {
            display: !1,
            min: (x = l.value) == null ? void 0 : x.chart.scales.x.min,
            max: (k = l.value) == null ? void 0 : k.chart.scales.x.max
          },
          y: {
            stacked: !0,
            display: !1
          }
        },
        datasets: {
          bar: {
            borderSkipped: !1,
            barThickness: Qm
          }
        },
        layout: {
          padding: {
            left: (D = l.value) == null ? void 0 : D.chart.chartArea.left,
            right: ((N = l.value) == null ? void 0 : N.chart.width) - ((L = l.value) == null ? void 0 : L.chart.chartArea.right)
          }
        },
        plugins: {
          tooltip: {
            external: P
          },
          annotation: {
            annotations: {
              cursor: {
                display: !!n.value && V.value.datasets.length,
                xMin: n.value,
                xMax: n.value
              }
            }
          }
        }
      });
    });
    function P(x) {
      const k = x.tooltip;
      k.opacity ? B.value = {
        xMin: k.dataPoints[0].raw.x[0],
        xMax: k.dataPoints[0].raw.x[1],
        backgroundColor: k.dataPoints[0].dataset.serie.colorScale[au],
        borderColor: k.dataPoints[0].dataset.serie.colorScale[Ms]
      } : B.value = null, S(x, !0);
    }
    return Eu.modes.nearestBar = function(x, k, D, N) {
      const L = di(k, x);
      let z = Number.POSITIVE_INFINITY, W = [];
      return Eu.evaluateInteractionItems(
        x,
        null,
        L,
        (ae, F, H) => {
          if (ae.inYRange(L.y, N))
            for (const ne of [ae.base, ae.base + ae.width]) {
              const w = Math.abs(ne - L.x);
              w < z && (z = w, W = [{ element: ae, datasetIndex: F, index: H }]);
            }
        }
      ), W;
    }, (x, k) => {
      var D, N;
      return O(), R("div", VP, [
        i.value ? (O(), Se(FP, {
          key: 0,
          tooltip: i.value,
          position: s.value,
          "chart-axes": t.axes,
          "annotation-data": t.annotationData
        }, null, 8, ["tooltip", "position", "chart-axes", "annotation-data"])) : U("", !0),
        J("div", NP, [
          h.value ? (O(), R("div", BP, [
            J("span", zP, [
              te(x.$slots, "left-axis-title", { title: h.value }, () => [
                He(ve(h.value), 1)
              ])
            ])
          ])) : U("", !0),
          J("div", WP, [
            (O(), Se(C(oh), {
              ref_key: "chartRef",
              ref: l,
              key: t.chartType == "bar" ? "bar" : "line",
              data: v.value,
              options: A.value,
              type: t.chartType === "bar" ? "bar" : "line",
              class: "!print:h-auto !print:w-auto absolute print:max-h-full print:min-h-full print:max-w-full"
            }, null, 8, ["data", "options", "type"]))
          ]),
          m.value ? (O(), R("div", HP, [
            J("span", YP, [
              te(x.$slots, "right-axis-title", { title: m.value }, () => [
                He(ve(m.value), 1)
              ])
            ])
          ])) : U("", !0)
        ]),
        t.annotationData ? (O(), R("div", {
          key: 1,
          class: "group relative",
          style: tt({ height: t.annotationData.length * 1.5 + "rem" })
        }, [
          J("div", {
            class: "pointer-events-none absolute flex size-full flex-col justify-around",
            style: tt({
              "padding-right": ((D = l.value) == null ? void 0 : D.chart.width) - ((N = l.value) == null ? void 0 : N.chart.chartArea.right) + "px"
            })
          }, [
            (O(!0), R(ye, null, Te(t.annotationData, (L, z) => (O(), R("div", {
              key: z,
              class: "flex items-center"
            }, [
              J("span", {
                class: "z-10 max-w-max whitespace-nowrap rounded-md px-1 py-0.5 text-xs text-gray-900 group-hover:w-12 group-hover:truncate",
                style: tt({
                  color: L.colorScale[KP],
                  backgroundColor: L.colorScale[au]
                })
              }, ve(L.label), 5),
              J("div", {
                class: "w-full rounded-r-full",
                style: tt({
                  backgroundColor: L.colorScale[au],
                  height: Qm + 1 + "px"
                })
              }, null, 4)
            ]))), 128))
          ], 4),
          Ce(C(oh), {
            type: "bar",
            data: V.value,
            options: G.value,
            class: me(["absolute w-full", {
              "ml-4": !!h.value,
              "mr-4": !!m.value
            }])
          }, null, 8, ["data", "options", "class"])
        ], 4)) : U("", !0),
        J("div", jP, [
          J("ul", qP, [
            (O(!0), R(ye, null, Te(d.value, (L, z) => (O(), R("li", {
              key: z,
              class: me(["flex cursor-pointer items-center", [
                L.axis === c.value[0] ? "order-first" : "order-last",
                u.value[z] ? "opacity-50" : ""
              ]]),
              onClick: (W) => u.value[z] = !u.value[z]
            }, [
              J("div", {
                class: "mr-1.5 size-2 shrink-0 rounded-full md:mr-2 md:size-3",
                style: tt({
                  backgroundColor: L.secondary ? L.colorScale[Va] : L.colorScale[Ms],
                  borderColor: L.colorScale[Ms],
                  borderWidth: "2px"
                })
              }, null, 4),
              J("span", XP, [
                te(x.$slots, z, {
                  label: L.label
                }, () => [
                  He(ve(L.label), 1)
                ])
              ])
            ], 10, UP))), 128)),
            c.value.length > 1 ? (O(), R("li", GP)) : U("", !0)
          ]),
          x.$slots["legend-message"] ? (O(), R("div", ZP, [
            te(x.$slots, "legend-message")
          ])) : U("", !0)
        ])
      ]);
    };
  }
};
let nC = 0;
function ur() {
  return "UID" + nC++;
}
const iC = {
  key: 0,
  class: "text-xs font-medium uppercase tracking-wide text-gray-400"
}, sC = ["for"], rC = ["id", "value"], aC = ["for"], oC = ["onClick"], lC = { class: "flex w-5 items-center" }, uC = {
  key: 1,
  class: "flex items-center truncate"
}, cC = {
  key: 0,
  class: "w-5"
}, dC = ["id", "value", ".indeterminate"], Jm = {
  __name: "InputItems",
  props: /* @__PURE__ */ Mn({
    /**
     * Must have the following structure:
     * [
     *   { label: "label", value: "value" },
     *   ...
     * ]
     *
     * An item can optionally have a 'parent' key that references another item's
     * label key. This will group the item under the referenced item.
     *
     * Items can be hidden or disabled by adding a 'hidden' or 'disabled' boolean
     * property respectively.
     */
    items: {
      type: Array,
      required: !0,
      validator: (t) => t.every((e) => Object.hasOwn(e, "label") && Object.hasOwn(e, "value"))
    },
    /**
     * Render each items as a card, allowing for more complex slot content.
     */
    useCards: Boolean,
    /**
     * If false, only one items can be selected at a time.
     */
    multiSelect: Boolean,
    /**
     * Disable selection of group headers.
     */
    allOpen: Boolean,
    /**
     * Unfolds all groups, no matter the state of 'openGroups'
     */
    forceAllOpen: Boolean
  }, {
    modelValue: {
      type: Array,
      default: () => []
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, n = Hn(t, "modelValue"), i = ee({}), s = ee({}), r = ur();
    let a = !1;
    const o = Z(() => {
      const g = /* @__PURE__ */ new Set();
      for (const v of e.items)
        v.parent && g.add(v.parent);
      const y = {};
      for (const v of g) {
        const b = e.items.findIndex((_) => _.label === v);
        if (b === -1)
          throw new Error("Parent item not found");
        if (e.items[b].parent)
          throw new Error("Parent item cannot have a parent");
        y[v] = b;
      }
      return y;
    }), l = Z(() => e.items.map((g, y) => {
      const v = o.value[g.label] !== void 0, b = v && !e.useCards ? e.items.every(
        (M) => M.parent !== g.label || M.hidden
      ) && g.hidden : g.hidden, _ = g.parent ? [o.value[g.parent], y] : [y, 0];
      return { ...g, isParent: v, hidden: b, order: _ };
    }).sort((g, y) => g.order[0] - y.order[0] || g.order[1] - y.order[1])), u = Z(() => l.value.map((g) => n.value.includes(g.value) ? "bg-primary-50 hover:bg-primary-100" : g.disabled ? "" : "hover:bg-gray-50"));
    function c(g) {
      i.value[g] = !i.value[g];
    }
    function d(g) {
      var v;
      const y = g[g.length - 1];
      if (y === void 0)
        s.value = {};
      else {
        a = !0, n.value = [y];
        const b = (v = e.items.find((_) => _.value === y)) == null ? void 0 : v.parent;
        s.value = b ? { [b]: !0 } : {};
      }
    }
    function f(g, y) {
      const v = e.items.reduce((b, _) => {
        const M = g.includes(_.value), A = y == null ? void 0 : y.includes(_.value);
        return M && !A ? b.set(_, !0) : !M && A && b.set(_, !1), b;
      }, /* @__PURE__ */ new Map());
      return new Map(
        [...v.entries()].sort((b, _) => !!_[0].parent - !!b[0].parent)
      );
    }
    function h(g, y, v) {
      const b = e.items.find((_) => _.label === g.parent);
      if (!v.includes(b) && !b.disabled) {
        const _ = e.items.every(
          (A) => A.parent !== b.label || n.value.includes(A.value)
        ), M = e.items.every(
          (A) => A.parent !== b.label || !n.value.includes(A.value)
        );
        _ ? (y.add(b.value), s.value[b.label] = !1) : (y.delete(b.value), s.value[b.label] = !M), v.push(b);
      }
    }
    function m(g, y, v) {
      const b = e.items.filter((_) => _.parent === g.label);
      for (const _ of b)
        y && !_.disabled ? v.add(_.value) : v.delete(_.value);
    }
    function p(g, y) {
      const v = f(g, y), b = new Set(g), _ = [];
      for (const [M, A] of v)
        M.parent ? h(M, b, _) : m(M, A, b);
      return [...b];
    }
    return ct(
      n,
      (g, y) => {
        a ? a = !1 : e.multiSelect ? e.useCards || (a = !0, n.value = p(g, y)) : d(g);
      },
      { immediate: !0 }
    ), _t(() => {
      if (e.allOpen)
        for (const g of l.value)
          g.isParent && (i.value[g.label] = !0);
    }), (g, y) => (O(), R("div", {
      class: me(t.useCards ? "space-y-2" : "space-y-1")
    }, [
      g.$slots.title ? (O(), R("p", iC, [
        te(g.$slots, "title")
      ])) : U("", !0),
      (O(!0), R(ye, null, Te(l.value, (v, b) => (O(), R("div", { key: b }, [
        t.useCards ? Tt((O(), R("label", {
          key: 0,
          for: `${C(r)}-${b}`
        }, [
          J("div", {
            class: me([
              "rounded-lg border p-3 ring-primary hover:bg-gray-50",
              n.value.includes(v.value) ? "border-transparent text-primary ring-2" : "border-gray-100"
            ])
          }, [
            te(g.$slots, v.label, {}, () => [
              Ce(As, null, {
                default: be(() => [
                  He(ve(v.label), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            Tt(J("input", {
              id: `${C(r)}-${b}`,
              "onUpdate:modelValue": y[0] || (y[0] = (_) => n.value = _),
              type: "checkbox",
              value: v.value
            }, null, 8, rC), [
              [sn, !1],
              [Mu, n.value]
            ])
          ], 2)
        ], 8, sC)), [
          [sn, !v.hidden]
        ]) : Tt((O(), R("label", {
          key: 1,
          for: `${C(r)}-${b}`,
          class: me(["flex h-10 items-center justify-between rounded-lg px-4", u.value[b]])
        }, [
          v.isParent ? (O(), R("div", {
            key: 0,
            class: "group flex cursor-pointer items-center truncate",
            onClick: et((_) => c(v.label), ["prevent"])
          }, [
            J("div", lC, [
              Ce(Xt, {
                name: i.value[v.label] || t.forceAllOpen ? "arrow-down-s" : "arrow-right-s",
                filled: "",
                class: "text-lg text-gray-400 group-hover:text-primary"
              }, null, 8, ["name"])
            ]),
            Ce(As, { class: "truncate group-hover:text-primary" }, {
              default: be(() => [
                te(g.$slots, v.label, {}, () => [
                  He(ve(v.label), 1)
                ])
              ]),
              _: 2
            }, 1024)
          ], 8, oC)) : (O(), R("div", uC, [
            v.parent ? (O(), R("div", cC)) : U("", !0),
            Ce(As, { class: "truncate" }, {
              default: be(() => [
                te(g.$slots, v.label, {}, () => [
                  He(ve(v.label), 1)
                ])
              ]),
              _: 2
            }, 1024)
          ])),
          v.disabled ? U("", !0) : Tt((O(), R("input", {
            key: 2,
            id: `${C(r)}-${b}`,
            "onUpdate:modelValue": y[1] || (y[1] = (_) => n.value = _),
            type: "checkbox",
            value: v.value,
            ".indeterminate": s.value[v.label],
            class: me(["ml-1 w-4 border border-gray-300 bg-white text-primary-700 focus:ring-0 focus:ring-offset-0", t.multiSelect ? "rounded" : "rounded-full"])
          }, null, 42, dC)), [
            [Mu, n.value]
          ])
        ], 10, aC)), [
          [
            sn,
            !v.hidden && (!v.parent || i.value[v.parent] || t.forceAllOpen)
          ]
        ])
      ]))), 128))
    ], 2));
  }
};
function fC(t) {
  return [...new Intl.Segmenter([], { granularity: "word" }).segment(t)].filter((i) => i.isWordLike).map((i) => i.segment);
}
function hC(t, e, n, i) {
  e = e.toLowerCase();
  const s = fC(e);
  let r;
  return t.filter((a) => (r = i ? i(a) : a, r = r.toLowerCase(), s.every((o) => r.includes(o))));
}
const mC = { class: "flex flex-col gap-2" }, pC = ["for"], gC = { class: "flex h-10 items-center gap-2" }, yC = ["id", "type", "disabled", "placeholder"], vC = {
  key: 0,
  class: "order-first flex items-center whitespace-nowrap border-r border-gray-300 bg-gray-50 peer-has-[:focus]:border-primary peer-has-[:focus]:bg-primary-50"
}, bC = {
  key: 1,
  class: "flex items-center whitespace-nowrap border-l border-gray-300 bg-gray-50 peer-has-[:focus]:border-primary peer-has-[:focus]:bg-primary-50"
}, wC = {
  __name: "InputField",
  props: /* @__PURE__ */ Mn({
    type: {
      type: String,
      default: "text"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    helperText: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    iconFilled: {
      type: Boolean,
      default: !1
    },
    stateError: {
      type: Boolean,
      default: !1
    },
    stateSuccess: {
      type: Boolean,
      default: !1
    }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Mn(["blur", "focus"], ["update:modelValue"]),
  setup(t, { expose: e }) {
    const n = Hn(t, "modelValue"), i = ur(), s = ee(!1);
    function r() {
      document.getElementById(i).focus();
    }
    function a() {
      s.value = !s.value;
    }
    function o() {
      n.value = "";
    }
    return e({
      focus: r,
      clear: o
    }), (l, u) => (O(), R("div", mC, [
      t.label ? (O(), R("label", {
        key: 0,
        for: C(i),
        class: "text-sm font-medium"
      }, [
        He(ve(t.label) + " ", 1),
        l.$slots.labelSuffix ? te(l.$slots, "labelSuffix", { key: 0 }) : U("", !0)
      ], 8, pC)) : U("", !0),
      J("div", gC, [
        J("div", {
          class: "flex w-full overflow-hidden rounded-lg border border-gray-300 bg-white *:px-3 *:py-2 has-[:focus]:border-primary",
          onClick: r
        }, [
          J("div", {
            class: me([
              "peer flex w-full items-center gap-2 text-gray-400 has-[:disabled]:bg-gray-50",
              t.stateError ? "bg-danger-50" : t.stateSuccess ? "bg-success-50" : ""
            ])
          }, [
            t.icon ? (O(), Se(Xt, {
              key: 0,
              name: t.icon,
              filled: t.iconFilled,
              class: "text-lg text-gray-900",
              onClick: o
            }, null, 8, ["name", "filled"])) : U("", !0),
            Tt(J("input", {
              id: C(i),
              "onUpdate:modelValue": u[0] || (u[0] = (c) => n.value = c),
              type: s.value ? "text" : t.type,
              class: me([
                "w-full border-0 bg-transparent p-0 placeholder:text-gray-400 focus:ring-0 focus:ring-offset-0",
                t.stateError ? "text-danger-700" : t.stateSuccess ? "text-success-700" : "text-gray-900"
              ]),
              disabled: t.disabled,
              placeholder: t.placeholder,
              onBlur: u[1] || (u[1] = (c) => l.$emit("blur")),
              onFocus: u[2] || (u[2] = (c) => l.$emit("focus"))
            }, null, 42, yC), [
              [uv, n.value]
            ]),
            t.type === "password" ? (O(), Se(Xt, {
              key: 1,
              name: s.value ? "eye-off" : "eye",
              class: "text-2xl hover:text-gray-900",
              onClick: a
            }, null, 8, ["name"])) : n.value && !t.disabled ? (O(), Se(Xt, {
              key: 2,
              name: "close",
              class: "text-2xl hover:text-gray-900",
              onClick: o
            })) : U("", !0)
          ], 2),
          l.$slots.addonLeft ? (O(), R("div", vC, [
            te(l.$slots, "addonLeft")
          ])) : U("", !0),
          l.$slots.addonRight ? (O(), R("div", bC, [
            te(l.$slots, "addonRight")
          ])) : U("", !0)
        ]),
        te(l.$slots, "default")
      ]),
      t.helperText ? (O(), R("div", {
        key: 1,
        class: me([
          "text-sm",
          t.stateError ? "text-danger-600" : t.stateSuccess ? "text-success-600" : "text-gray-500"
        ]),
        onClick: r
      }, ve(t.helperText), 3)) : U("", !0)
    ]));
  }
}, xC = { class: "max-h-[300px] overflow-y-auto p-4" }, _C = {
  key: 1,
  class: "flex justify-center italic"
}, xE = {
  __name: "InputItemsFilter",
  props: /* @__PURE__ */ Mn({
    ...Jm.props,
    /**
     * Callback to customize the search string for each item. Should be a function
     * that takes an item, an entry from the 'items' prop, and returns a string.
     * The resulting string will be used to filter the items on the search query.
     *
     * Defaults to a concatenation of the item's 'label' and 'parent' properties.
     */
    searchStringCallback: {
      type: Function,
      default: (t) => `${t.label} ${t.parent ?? ""}`
    }
  }, {
    modelValue: {
      type: Array,
      default: () => []
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t, { expose: e }) {
    const n = t, i = Hn(t, "modelValue");
    e({
      focusSearch: o
    });
    const s = ee(""), r = ee(null), a = Z(() => {
      const l = hC(
        n.items,
        s.value,
        !1,
        n.searchStringCallback
      );
      return n.items.map((u) => ({
        ...u,
        hidden: !l.includes(u)
      }));
    });
    function o() {
      r.value.focus();
    }
    return (l, u) => (O(), R(ye, null, [
      Ce(wC, {
        ref_key: "inputRef",
        ref: r,
        modelValue: s.value,
        "onUpdate:modelValue": u[0] || (u[0] = (c) => s.value = c),
        icon: "search",
        class: "p-4"
      }, null, 8, ["modelValue"]),
      Ce(Mv),
      J("div", xC, [
        a.value.length > 0 ? (O(), Se(Jm, {
          key: 0,
          modelValue: i.value,
          "onUpdate:modelValue": u[1] || (u[1] = (c) => i.value = c),
          items: a.value,
          "use-cards": l.useCards,
          "multi-select": l.multiSelect,
          "all-open": l.allOpen,
          "force-all-open": l.forceAllOpen || s.value.length > 0
        }, It({ _: 2 }, [
          Te(l.$slots, (c, d) => ({
            name: d,
            fn: be((f) => [
              te(l.$slots, d, Pt(jt(f)))
            ])
          }))
        ]), 1032, ["modelValue", "items", "use-cards", "multi-select", "all-open", "force-all-open"])) : (O(), R("p", _C, "No results"))
      ])
    ], 64));
  }
};
function kC(t) {
  return bc() ? (wc(t), !0) : !1;
}
const ou = /* @__PURE__ */ new WeakMap(), MC = (...t) => {
  var e;
  const n = t[0], i = (e = _o()) == null ? void 0 : e.proxy;
  if (i == null && !pp())
    throw new Error("injectLocal must be called in setup");
  return i && ou.has(i) && n in ou.get(i) ? ou.get(i)[n] : cv(...t);
}, SC = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const OC = Object.prototype.toString, DC = (t) => OC.call(t) === "[object Object]";
function ep(t) {
  return t.endsWith("rem") ? Number.parseFloat(t) * 16 : Number.parseFloat(t);
}
function lu(t) {
  return Array.isArray(t) ? t : [t];
}
function TC(t) {
  return _o();
}
function PC(t, e = !0, n) {
  TC() ? _t(t, n) : e ? t() : Gt(t);
}
function CC(t, e, n) {
  return ct(
    t,
    e,
    {
      ...n,
      immediate: !0
    }
  );
}
const bd = SC ? window : void 0;
function AC(t) {
  var e;
  const n = Zi(t);
  return (e = n == null ? void 0 : n.$el) != null ? e : n;
}
function mc(...t) {
  const e = [], n = () => {
    e.forEach((o) => o()), e.length = 0;
  }, i = (o, l, u, c) => (o.addEventListener(l, u, c), () => o.removeEventListener(l, u, c)), s = Z(() => {
    const o = lu(Zi(t[0])).filter((l) => l != null);
    return o.every((l) => typeof l != "string") ? o : void 0;
  }), r = CC(
    () => {
      var o, l;
      return [
        (l = (o = s.value) == null ? void 0 : o.map((u) => AC(u))) != null ? l : [bd].filter((u) => u != null),
        lu(Zi(s.value ? t[1] : t[0])),
        lu(C(s.value ? t[2] : t[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        Zi(s.value ? t[3] : t[2])
      ];
    },
    ([o, l, u, c]) => {
      if (n(), !(o != null && o.length) || !(l != null && l.length) || !(u != null && u.length))
        return;
      const d = DC(c) ? { ...c } : c;
      e.push(
        ...o.flatMap(
          (f) => l.flatMap(
            (h) => u.map((m) => i(f, h, m, d))
          )
        )
      );
    },
    { flush: "post" }
  ), a = () => {
    r(), n();
  };
  return kC(n), a;
}
function EC() {
  const t = xi(!1), e = _o();
  return e && _t(() => {
    t.value = !0;
  }, e), t;
}
function $C(t) {
  const e = EC();
  return Z(() => (e.value, !!t()));
}
const RC = Symbol("vueuse-ssr-width");
function LC() {
  const t = pp() ? MC(RC, null) : null;
  return typeof t == "number" ? t : void 0;
}
function IC(t, e = {}) {
  const { window: n = bd, ssrWidth: i = LC() } = e, s = $C(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), r = xi(typeof i == "number"), a = xi(), o = xi(!1), l = (u) => {
    o.value = u.matches;
  };
  return dv(() => {
    if (r.value) {
      r.value = !s.value;
      const u = Zi(t).split(",");
      o.value = u.some((c) => {
        const d = c.includes("not all"), f = c.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), h = c.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let m = !!(f || h);
        return f && m && (m = i >= ep(f[1])), h && m && (m = i <= ep(h[1])), d ? !m : m;
      });
      return;
    }
    s.value && (a.value = n.matchMedia(Zi(t)), o.value = a.value.matches);
  }), mc(a, "change", l, { passive: !0 }), Z(() => o.value);
}
function FC(t = {}) {
  const {
    window: e = bd,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: i = Number.POSITIVE_INFINITY,
    listenOrientation: s = !0,
    includeScrollbar: r = !0,
    type: a = "inner"
  } = t, o = xi(n), l = xi(i), u = () => {
    if (e)
      if (a === "outer")
        o.value = e.outerWidth, l.value = e.outerHeight;
      else if (a === "visual" && e.visualViewport) {
        const { width: d, height: f, scale: h } = e.visualViewport;
        o.value = Math.round(d * h), l.value = Math.round(f * h);
      } else r ? (o.value = e.innerWidth, l.value = e.innerHeight) : (o.value = e.document.documentElement.clientWidth, l.value = e.document.documentElement.clientHeight);
  };
  u(), PC(u);
  const c = { passive: !0 };
  if (mc("resize", u, c), e && a === "visual" && e.visualViewport && mc(e.visualViewport, "resize", u, c), s) {
    const d = IC("(orientation: portrait)");
    ct(d, () => u());
  }
  return { width: o, height: l };
}
function cr() {
  const t = fv();
  return O(), R(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img",
      ...t
    },
    [
      J("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      J("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      J("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      J("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
cr.compatConfig = {
  MODE: 3
};
function Ly() {
  return O(), R(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      J("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      J("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Ly.compatConfig = {
  MODE: 3
};
function wd() {
  return O(), R(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      J("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
wd.compatConfig = {
  MODE: 3
};
function xd() {
  return O(), R(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      J("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
xd.compatConfig = {
  MODE: 3
};
function _d() {
  return O(), R(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      J("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      J("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
_d.compatConfig = {
  MODE: 3
};
function kd() {
  return O(), R(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      J("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
kd.compatConfig = {
  MODE: 3
};
function Md() {
  return O(), R(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      J("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Md.compatConfig = {
  MODE: 3
};
const Jt = (t, e) => e ? new Date(t.toLocaleString("en-US", { timeZone: e })) : new Date(t), Sd = (t, e, n) => pc(t, e, n) || se(), VC = (t, e, n) => {
  const i = e.dateInTz ? Jt(new Date(t), e.dateInTz) : se(t);
  return n ? $t(i, !0) : i;
}, pc = (t, e, n) => {
  if (!t) return null;
  const i = n ? $t(se(t), !0) : se(t);
  return e ? e.exactMatch ? VC(t, e, n) : Jt(i, e.timezone) : i;
}, NC = (t) => {
  const e = new Date(t.getFullYear(), 0, 1).getTimezoneOffset();
  return t.getTimezoneOffset() < e;
}, BC = (t, e) => {
  if (!t) return 0;
  const n = /* @__PURE__ */ new Date(), i = new Date(n.toLocaleString("en-US", { timeZone: "UTC" })), s = new Date(n.toLocaleString("en-US", { timeZone: t })), r = (NC(e ?? s) ? s : e ?? s).getTimezoneOffset() / 60;
  return (+i - +s) / (1e3 * 60 * 60) - r;
};
var vn = /* @__PURE__ */ ((t) => (t.month = "month", t.year = "year", t))(vn || {}), bn = /* @__PURE__ */ ((t) => (t.top = "top", t.bottom = "bottom", t))(bn || {}), es = /* @__PURE__ */ ((t) => (t.header = "header", t.calendar = "calendar", t.timePicker = "timePicker", t))(es || {}), Bt = /* @__PURE__ */ ((t) => (t.month = "month", t.year = "year", t.calendar = "calendar", t.time = "time", t.minutes = "minutes", t.hours = "hours", t.seconds = "seconds", t))(Bt || {});
const zC = ["timestamp", "date", "iso"];
var Yt = /* @__PURE__ */ ((t) => (t.up = "up", t.down = "down", t.left = "left", t.right = "right", t))(Yt || {}), st = /* @__PURE__ */ ((t) => (t.arrowUp = "ArrowUp", t.arrowDown = "ArrowDown", t.arrowLeft = "ArrowLeft", t.arrowRight = "ArrowRight", t.enter = "Enter", t.space = " ", t.esc = "Escape", t.tab = "Tab", t.home = "Home", t.end = "End", t.pageUp = "PageUp", t.pageDown = "PageDown", t))(st || {}), Fs = /* @__PURE__ */ ((t) => (t.MONTH_AND_YEAR = "MM-yyyy", t.YEAR = "yyyy", t.DATE = "dd-MM-yyyy", t))(Fs || {});
function tp(t) {
  return (e) => {
    const n = new Intl.DateTimeFormat(t, {
      weekday: "short",
      timeZone: "UTC"
    }).format(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`));
    return t === "ar" ? n.slice(2, 5) : n.slice(0, 2);
  };
}
function WC(t) {
  return (e) => Lt(Jt(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: t });
}
const HC = (t, e, n) => {
  const i = [1, 2, 3, 4, 5, 6, 7];
  let s;
  if (t !== null)
    try {
      s = i.map(WC(t));
    } catch {
      s = i.map(tp(e));
    }
  else
    s = i.map(tp(e));
  const r = s.slice(0, n), a = s.slice(n + 1, s.length);
  return [s[n]].concat(...a).concat(...r);
}, Od = (t, e, n) => {
  const i = [];
  for (let s = +t[0]; s <= +t[1]; s++)
    i.push({ value: +s, text: Ny(s, e) });
  return n ? i.reverse() : i;
}, Iy = (t, e, n) => {
  const i = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((r) => {
    const a = r < 10 ? `0${r}` : r;
    return /* @__PURE__ */ new Date(`2017-${a}-01T00:00:00+00:00`);
  });
  if (t !== null)
    try {
      const r = n === "long" ? "LLLL" : "LLL";
      return i.map((a, o) => {
        const l = Lt(Jt(a, "UTC"), r, { locale: t });
        return {
          text: l.charAt(0).toUpperCase() + l.substring(1),
          value: o
        };
      });
    } catch {
    }
  const s = new Intl.DateTimeFormat(e, { month: n, timeZone: "UTC" });
  return i.map((r, a) => {
    const o = s.format(r);
    return {
      text: o.charAt(0).toUpperCase() + o.substring(1),
      value: a
    };
  });
}, YC = (t) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][t], Mt = (t) => {
  const e = C(t);
  return e != null && e.$el ? e == null ? void 0 : e.$el : e;
}, jC = (t) => ({ type: "dot", ...t ?? {} }), Fy = (t) => Array.isArray(t) ? !!t[0] && !!t[1] : !1, Dd = {
  prop: (t) => `"${t}" prop must be enabled!`,
  dateArr: (t) => `You need to use array as "model-value" binding in order to support "${t}"`
}, At = (t) => t, np = (t) => t === 0 ? t : !t || isNaN(+t) ? null : +t, ip = (t) => t === null, Vy = (t) => {
  if (t)
    return [...t.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, qC = (t) => {
  const e = [], n = (i) => i.filter((s) => s);
  for (let i = 0; i < t.length; i += 3) {
    const s = [t[i], t[i + 1], t[i + 2]];
    e.push(n(s));
  }
  return e;
}, Gr = (t, e, n) => {
  const i = n != null, s = e != null;
  if (!i && !s) return !1;
  const r = +n, a = +e;
  return i && s ? +t > r || +t < a : i ? +t > r : s ? +t < a : !1;
}, Ks = (t, e) => qC(t).map((n) => n.map((i) => {
  const { active: s, disabled: r, isBetween: a, highlighted: o } = e(i);
  return {
    ...i,
    active: s,
    disabled: r,
    className: {
      dp__overlay_cell_active: s,
      dp__overlay_cell: !s,
      dp__overlay_cell_disabled: r,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: r && s,
      dp__cell_in_between: a,
      "dp--highlighted": o
    }
  };
})), Oi = (t, e, n = !1) => {
  t && e.allowStopPropagation && (n && t.stopImmediatePropagation(), t.stopPropagation());
}, UC = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function XC(t, e) {
  let n = [...document.querySelectorAll(UC())];
  n = n.filter((s) => !t.contains(s) || s.hasAttribute("data-datepicker-instance"));
  const i = n.indexOf(t);
  if (i >= 0 && (e ? i - 1 >= 0 : i + 1 <= n.length))
    return n[i + (e ? -1 : 1)];
}
const gc = (t, e) => t == null ? void 0 : t.querySelector(`[data-dp-element="${e}"]`), Ny = (t, e) => new Intl.NumberFormat(e, { useGrouping: !1, style: "decimal" }).format(t), Td = (t, e) => Lt(t, e ?? Fs.DATE), uu = (t) => Array.isArray(t), wo = (t, e, n) => e.get(Td(t, n)), GC = (t, e) => t ? e ? e instanceof Map ? !!wo(t, e) : e(se(t)) : !1 : !0, Ut = (t, e, n = !1, i) => {
  if (t.key === st.enter || t.key === st.space)
    return n && t.preventDefault(), e();
  if (i) return i(t);
}, ZC = () => "ontouchstart" in window || navigator.maxTouchPoints > 0, By = (t, e) => t ? Fs.MONTH_AND_YEAR : e ? Fs.YEAR : Fs.DATE, zy = (t) => t < 10 ? `0${t}` : t, sp = (t, e, n, i, s, r) => {
  const a = hc(t, e.slice(0, t.length), /* @__PURE__ */ new Date(), { locale: r });
  return Ir(a) && py(a) ? i || s ? a : Je(a, {
    hours: +n.hours,
    minutes: +(n == null ? void 0 : n.minutes),
    seconds: +(n == null ? void 0 : n.seconds),
    milliseconds: 0
  }) : null;
}, KC = (t, e, n, i, s, r) => {
  const a = Array.isArray(n) ? n[0] : n;
  if (typeof e == "string")
    return sp(t, e, a, i, s, r);
  if (Array.isArray(e)) {
    let o = null;
    for (const l of e)
      if (o = sp(t, l, a, i, s, r), o)
        break;
    return o;
  }
  return typeof e == "function" ? e(t) : null;
}, se = (t) => t ? new Date(t) : /* @__PURE__ */ new Date(), QC = (t, e, n) => {
  if (e) {
    const s = (t.getMonth() + 1).toString().padStart(2, "0"), r = t.getDate().toString().padStart(2, "0"), a = t.getHours().toString().padStart(2, "0"), o = t.getMinutes().toString().padStart(2, "0"), l = n ? t.getSeconds().toString().padStart(2, "0") : "00";
    return `${t.getFullYear()}-${s}-${r}T${a}:${o}:${l}.000Z`;
  }
  const i = Date.UTC(
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate(),
    t.getUTCHours(),
    t.getUTCMinutes(),
    t.getUTCSeconds()
  );
  return new Date(i).toISOString();
}, $t = (t, e) => {
  const n = se(JSON.parse(JSON.stringify(t))), i = Je(n, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return e ? cc(i) : i;
}, Di = (t, e, n, i) => {
  let s = t ? se(t) : se();
  return (e || e === 0) && (s = ZT(s, +e)), (n || n === 0) && (s = KT(s, +n)), (i || i === 0) && (s = $y(s, +i)), Ey(s, 0);
}, ht = (t, e) => !t || !e ? !1 : Gs($t(t), $t(e)), Ve = (t, e) => !t || !e ? !1 : Cs($t(t), $t(e)), vt = (t, e) => !t || !e ? !1 : ls($t(t), $t(e)), Zr = (t, e, n) => t != null && t[0] && t != null && t[1] ? vt(n, t[0]) && ht(n, t[1]) : t != null && t[0] && e ? vt(n, t[0]) && ht(n, e) || ht(n, t[0]) && vt(n, e) : !1, wn = (t) => {
  const e = Je(new Date(t), { date: 1 });
  return $t(e);
}, cu = (t, e, n) => e && (n || n === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((i) => i === e ? [i, n] : [i, isNaN(+t[i]) ? void 0 : +t[i]])
) : {
  hours: isNaN(+t.hours) ? void 0 : +t.hours,
  minutes: isNaN(+t.minutes) ? void 0 : +t.minutes,
  seconds: isNaN(+t.seconds) ? void 0 : +t.seconds
}, ts = (t) => ({
  hours: ni(t),
  minutes: Ri(t),
  seconds: Xs(t)
}), Wy = (t, e) => {
  if (e) {
    const n = Oe(se(e));
    if (n > t) return 12;
    if (n === t) return Fe(se(e));
  }
}, Hy = (t, e) => {
  if (e) {
    const n = Oe(se(e));
    return n < t ? -1 : n === t ? Fe(se(e)) : void 0;
  }
}, Qs = (t) => {
  if (t) return Oe(se(t));
}, Yy = (t, e) => {
  const n = vt(t, e) ? e : t, i = vt(e, t) ? e : t;
  return yy({ start: n, end: i });
}, JC = (t) => {
  const e = kn(t, 1);
  return { month: Fe(e), year: Oe(e) };
}, Gn = (t, e) => {
  const n = Dn(t, { weekStartsOn: +e }), i = by(t, { weekStartsOn: +e });
  return [n, i];
}, jy = (t, e) => {
  const n = {
    hours: ni(se()),
    minutes: Ri(se()),
    seconds: e ? Xs(se()) : 0
  };
  return Object.assign(n, t);
}, wi = (t, e, n) => [Je(se(t), { date: 1 }), Je(se(), { month: e, year: n, date: 1 })], Jn = (t, e, n) => {
  let i = t ? se(t) : se();
  return (e || e === 0) && (i = Ay(i, e)), n && (i = Vn(i, n)), i;
}, qy = (t, e, n, i, s) => {
  if (!i || s && !e || !s && !n) return !1;
  const r = s ? kn(t, 1) : Zs(t, 1), a = [Fe(r), Oe(r)];
  return s ? !tA(...a, e) : !eA(...a, n);
}, eA = (t, e, n) => ht(...wi(n, t, e)) || Ve(...wi(n, t, e)), tA = (t, e, n) => vt(...wi(n, t, e)) || Ve(...wi(n, t, e)), Uy = (t, e, n, i, s, r, a) => {
  if (typeof e == "function" && !a) return e(t);
  const o = n ? { locale: n } : void 0;
  return Array.isArray(t) ? `${Lt(t[0], r, o)}${s && !t[1] ? "" : i}${t[1] ? Lt(t[1], r, o) : ""}` : Lt(t, r, o);
}, Ss = (t) => {
  if (t) return null;
  throw new Error(Dd.prop("partial-range"));
}, Na = (t, e) => {
  if (e) return t();
  throw new Error(Dd.prop("range"));
}, yc = (t) => Array.isArray(t) ? Ir(t[0]) && (t[1] ? Ir(t[1]) : !0) : t ? Ir(t) : !1, nA = (t, e) => Je(e ?? se(), {
  hours: +t.hours || 0,
  minutes: +t.minutes || 0,
  seconds: +t.seconds || 0
}), du = (t, e, n, i) => {
  if (!t) return !0;
  if (i) {
    const s = n === "max" ? Gs(t, e) : ls(t, e), r = { seconds: 0, milliseconds: 0 };
    return s || Cs(Je(t, r), Je(e, r));
  }
  return n === "max" ? t.getTime() <= e.getTime() : t.getTime() >= e.getTime();
}, fu = (t, e, n) => t ? nA(t, e) : se(n ?? e), rp = (t, e, n, i, s) => {
  if (Array.isArray(i)) {
    const a = fu(t, i[0], e), o = fu(t, i[1], e);
    return du(i[0], a, n, !!e) && du(i[1], o, n, !!e) && s;
  }
  const r = fu(t, i, e);
  return du(i, r, n, !!e) && s;
}, hu = (t) => Je(se(), ts(t)), iA = (t, e, n) => {
  if (t instanceof Map) {
    const i = `${zy(n + 1)}-${e}`;
    return t.size ? t.has(i) : !1;
  }
  return typeof t == "function" ? t($t(Je(se(), { month: n, year: e }), !0)) : !1;
}, sA = (t, e, n) => {
  if (t instanceof Map) {
    const i = `${zy(n + 1)}-${e}`;
    return t.size ? t.has(i) : !0;
  }
  return !0;
}, Xy = (t, e, n) => typeof t == "function" ? t({ month: e, year: n }) : !!t.months.find((i) => i.month === e && i.year === n), Pd = (t, e) => typeof t == "function" ? t(e) : t.years.includes(e), vc = (t) => `dp-${Lt(t, "yyyy-MM-dd")}`, ap = (t, e) => {
  const n = Fr($t(e), t), i = fn($t(e), t);
  return { before: n, after: i };
}, br = er({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), Gy = () => {
  const t = (n) => {
    br.menuFocused = n;
  }, e = (n) => {
    br.shiftKeyInMenu !== n && (br.shiftKeyInMenu = n);
  };
  return {
    control: Z(() => ({ shiftKeyInMenu: br.shiftKeyInMenu, menuFocused: br.menuFocused })),
    setMenuFocused: t,
    setShiftKey: e
  };
}, it = er({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), mu = ee(null), Ba = ee(!1), pu = ee(!1), gu = ee(!1), yu = ee(!1), Ft = ee(0), yt = ee(0), Ii = () => {
  const t = Z(() => Ba.value ? [...it.selectionGrid, it.actionRow].filter((d) => d.length) : pu.value ? [
    ...it.timePicker[0],
    ...it.timePicker[1],
    yu.value ? [] : [mu.value],
    it.actionRow
  ].filter((d) => d.length) : gu.value ? [...it.monthPicker, it.actionRow] : [it.monthYear, ...it.calendar, it.time, it.actionRow].filter((d) => d.length)), e = (d) => {
    Ft.value = d ? Ft.value + 1 : Ft.value - 1;
    let f = null;
    t.value[yt.value] && (f = t.value[yt.value][Ft.value]), !f && t.value[yt.value + (d ? 1 : -1)] ? (yt.value = yt.value + (d ? 1 : -1), Ft.value = d ? 0 : t.value[yt.value].length - 1) : f || (Ft.value = d ? Ft.value - 1 : Ft.value + 1);
  }, n = (d) => {
    yt.value === 0 && !d || yt.value === t.value.length && d || (yt.value = d ? yt.value + 1 : yt.value - 1, t.value[yt.value] ? t.value[yt.value] && !t.value[yt.value][Ft.value] && Ft.value !== 0 && (Ft.value = t.value[yt.value].length - 1) : yt.value = d ? yt.value - 1 : yt.value + 1);
  }, i = (d) => {
    let f = null;
    t.value[yt.value] && (f = t.value[yt.value][Ft.value]), f ? f.focus({ preventScroll: !Ba.value }) : Ft.value = d ? Ft.value - 1 : Ft.value + 1;
  }, s = () => {
    e(!0), i(!0);
  }, r = () => {
    e(!1), i(!1);
  }, a = () => {
    n(!1), i(!0);
  }, o = () => {
    n(!0), i(!0);
  }, l = (d, f) => {
    it[f] = d;
  }, u = (d, f) => {
    it[f] = d;
  }, c = () => {
    Ft.value = 0, yt.value = 0;
  };
  return {
    buildMatrix: l,
    buildMultiLevelMatrix: u,
    setTimePickerBackRef: (d) => {
      mu.value = d;
    },
    setSelectionGrid: (d) => {
      Ba.value = d, c(), d || (it.selectionGrid = []);
    },
    setTimePicker: (d, f = !1) => {
      pu.value = d, yu.value = f, c(), d || (it.timePicker[0] = [], it.timePicker[1] = []);
    },
    setTimePickerElements: (d, f = 0) => {
      it.timePicker[f] = d;
    },
    arrowRight: s,
    arrowLeft: r,
    arrowUp: a,
    arrowDown: o,
    clearArrowNav: () => {
      it.monthYear = [], it.calendar = [], it.time = [], it.actionRow = [], it.selectionGrid = [], it.timePicker[0] = [], it.timePicker[1] = [], Ba.value = !1, pu.value = !1, yu.value = !1, gu.value = !1, c(), mu.value = null;
    },
    setMonthPicker: (d) => {
      gu.value = d, c();
    },
    refSets: it
    // exposed for testing
  };
}, op = (t) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...t ?? {}
}), rA = (t) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (e) => `Increment ${e}`,
  decrementValue: (e) => `Decrement ${e}`,
  openTpOverlay: (e) => `Open ${e} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (e) => `Month picker${e ? " overlay" : ""}`,
  yearPicker: (e) => `Year picker${e ? " overlay" : ""}`,
  timeOverlay: (e) => `${e} overlay`,
  ...t ?? {}
}), lp = (t) => t ? typeof t == "boolean" ? t ? 2 : 0 : +t >= 2 ? +t : 2 : 0, aA = (t) => {
  const e = typeof t == "object" && t, n = {
    static: !0,
    solo: !1
  };
  if (!t) return { ...n, count: lp(!1) };
  const i = e ? t : {}, s = e ? i.count ?? !0 : t, r = lp(s);
  return Object.assign(n, i, { count: r });
}, oA = (t, e, n) => t || (typeof n == "string" ? n : e), lA = (t) => typeof t == "boolean" ? t ? op({}) : !1 : op(t), uA = (t) => {
  const e = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: "open",
    selectOnFocus: !1,
    rangeSeparator: " - ",
    escClose: !0
  };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : { ...e, enabled: t };
}, cA = (t) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...t ?? {}
}), dA = (t) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...t ?? {}
}), fA = (t) => {
  const e = { input: !1 };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : {
    enabled: t,
    ...e
  };
}, hA = (t) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, timeArrowHoldThreshold: 0, shadowDom: !1, mobileBreakpoint: 600, setDateOnMenuClose: !1, ...t ?? {} }), mA = (t) => {
  const e = {
    dates: Array.isArray(t) ? t.map((n) => se(n)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof t == "function" ? t : { ...e, ...t ?? {} };
}, pA = (t) => typeof t == "object" ? {
  type: (t == null ? void 0 : t.type) ?? "local",
  hideOnOffsetDates: (t == null ? void 0 : t.hideOnOffsetDates) ?? !1
} : {
  type: t,
  hideOnOffsetDates: !1
}, gA = (t) => {
  const e = {
    noDisabledRange: !1,
    showLastInRange: !0,
    minMaxRawRange: !1,
    partialRange: !0,
    disableTimeRangeValidation: !1,
    maxRange: void 0,
    minRange: void 0,
    autoRange: void 0,
    fixedStart: !1,
    fixedEnd: !1
  };
  return typeof t == "object" ? { enabled: !0, ...e, ...t } : {
    enabled: t,
    ...e
  };
}, yA = (t) => t ? typeof t == "string" ? {
  timezone: t,
  exactMatch: !1,
  dateInTz: void 0,
  emitTimezone: void 0,
  convertModel: !0
} : {
  timezone: t.timezone,
  exactMatch: t.exactMatch ?? !1,
  dateInTz: t.dateInTz ?? void 0,
  emitTimezone: t.emitTimezone ?? void 0,
  convertModel: t.convertModel ?? !0
} : { timezone: void 0, exactMatch: !1, emitTimezone: void 0 }, vu = (t, e, n, i) => new Map(
  t.map((s) => {
    const r = Sd(s, e, i);
    return [Td(r, n), r];
  })
), vA = (t, e) => t.length ? new Map(
  t.map((n) => {
    const i = Sd(n.date, e);
    return [Td(i, Fs.DATE), n];
  })
) : null, bA = (t) => {
  var e;
  const n = By(t.isMonthPicker, t.isYearPicker);
  return {
    minDate: pc(t.minDate, t.timezone, t.isSpecific),
    maxDate: pc(t.maxDate, t.timezone, t.isSpecific),
    disabledDates: uu(t.disabledDates) ? vu(t.disabledDates, t.timezone, n, t.isSpecific) : t.disabledDates,
    allowedDates: uu(t.allowedDates) ? vu(t.allowedDates, t.timezone, n, t.isSpecific) : null,
    highlight: typeof t.highlight == "object" && uu((e = t.highlight) == null ? void 0 : e.dates) ? vu(t.highlight.dates, t.timezone, n) : t.highlight,
    markers: vA(t.markers, t.timezone)
  };
}, wA = (t) => typeof t == "boolean" ? { enabled: t, dragSelect: !0, limit: null } : {
  enabled: !!t,
  limit: t.limit ? +t.limit : null,
  dragSelect: t.dragSelect ?? !0
}, xA = (t) => ({
  ...Object.fromEntries(
    Object.keys(t).map((e) => {
      const n = e, i = t[n], s = typeof t[n] == "string" ? { [i]: !0 } : Object.fromEntries(i.map((r) => [r, !0]));
      return [e, s];
    })
  )
}), lt = (t) => {
  const e = () => {
    const A = t.enableSeconds ? ":ss" : "", E = t.enableMinutes ? ":mm" : "";
    return t.is24 ? `HH${E}${A}` : `hh${E}${A} aa`;
  }, n = () => {
    var A;
    return t.format ? t.format : t.monthPicker ? "MM/yyyy" : t.timePicker ? e() : t.weekPicker ? `${((A = g.value) == null ? void 0 : A.type) === "iso" ? "II" : "ww"}-RR` : t.yearPicker ? "yyyy" : t.quarterPicker ? "QQQ/yyyy" : t.enableTimePicker ? `MM/dd/yyyy, ${e()}` : "MM/dd/yyyy";
  }, i = (A) => jy(A, t.enableSeconds), s = () => _.value.enabled ? t.startTime && Array.isArray(t.startTime) ? [i(t.startTime[0]), i(t.startTime[1])] : null : t.startTime && !Array.isArray(t.startTime) ? i(t.startTime) : null, r = Z(() => aA(t.multiCalendars)), a = Z(() => s()), o = Z(() => rA(t.ariaLabels)), l = Z(() => cA(t.filters)), u = Z(() => lA(t.transitions)), c = Z(() => dA(t.actionRow)), d = Z(
    () => oA(t.previewFormat, t.format, n())
  ), f = Z(() => uA(t.textInput)), h = Z(() => fA(t.inline)), m = Z(() => hA(t.config)), p = Z(() => mA(t.highlight)), g = Z(() => pA(t.weekNumbers)), y = Z(() => yA(t.timezone)), v = Z(() => wA(t.multiDates)), b = Z(
    () => bA({
      minDate: t.minDate,
      maxDate: t.maxDate,
      disabledDates: t.disabledDates,
      allowedDates: t.allowedDates,
      highlight: p.value,
      markers: t.markers,
      timezone: y.value,
      isSpecific: t.monthPicker || t.yearPicker || t.quarterPicker,
      isMonthPicker: t.monthPicker,
      isYearPicker: t.yearPicker
    })
  ), _ = Z(() => gA(t.range)), M = Z(() => xA(t.ui));
  return {
    defaultedTransitions: u,
    defaultedMultiCalendars: r,
    defaultedStartTime: a,
    defaultedAriaLabels: o,
    defaultedFilters: l,
    defaultedActionRow: c,
    defaultedPreviewFormat: d,
    defaultedTextInput: f,
    defaultedInline: h,
    defaultedConfig: m,
    defaultedHighlight: p,
    defaultedWeekNumbers: g,
    defaultedRange: _,
    propDates: b,
    defaultedTz: y,
    defaultedMultiDates: v,
    defaultedUI: M,
    getDefaultPattern: n,
    getDefaultStartTime: s,
    handleEventPropagation: (A) => {
      m.value.allowStopPropagation && A.stopPropagation(), m.value.allowPreventDefault && A.preventDefault();
    }
  };
}, _A = (t, e, n) => {
  const i = ee(), { defaultedTextInput: s, defaultedRange: r, defaultedTz: a, defaultedMultiDates: o, getDefaultPattern: l } = lt(e), u = ee(""), c = Nr(e, "format"), d = Nr(e, "formatLocale");
  ct(
    i,
    () => {
      typeof e.onInternalModelChange == "function" && t("internal-model-change", i.value, ne(!0));
    },
    { deep: !0 }
  ), ct(r, (w, Y) => {
    w.enabled !== Y.enabled && (i.value = null);
  }), ct(c, () => {
    N();
  });
  const f = (w) => a.value.timezone && a.value.convertModel ? Jt(w, a.value.timezone) : w, h = (w) => {
    if (a.value.timezone && a.value.convertModel) {
      const Y = BC(a.value.timezone, w);
      return JO(w, Y);
    }
    return w;
  }, m = (w, Y, ue = !1) => Uy(
    w,
    e.format,
    e.formatLocale,
    s.value.rangeSeparator,
    e.modelAuto,
    Y ?? l(),
    ue
  ), p = (w) => w ? e.modelType ? z(w) : {
    hours: ni(w),
    minutes: Ri(w),
    seconds: e.enableSeconds ? Xs(w) : 0
  } : null, g = (w) => e.modelType ? z(w) : { month: Fe(w), year: Oe(w) }, y = (w) => Array.isArray(w) ? o.value.enabled ? w.map((Y) => v(Y, Vn(se(), Y))) : Na(
    () => [
      Vn(se(), w[0]),
      w[1] ? Vn(se(), w[1]) : Ss(r.value.partialRange)
    ],
    r.value.enabled
  ) : Vn(se(), +w), v = (w, Y) => (typeof w == "string" || typeof w == "number") && e.modelType ? L(w) : Y, b = (w) => Array.isArray(w) ? [
    v(
      w[0],
      Di(null, +w[0].hours, +w[0].minutes, w[0].seconds)
    ),
    v(
      w[1],
      Di(null, +w[1].hours, +w[1].minutes, w[1].seconds)
    )
  ] : v(w, Di(null, w.hours, w.minutes, w.seconds)), _ = (w) => {
    const Y = Je(se(), { date: 1 });
    return Array.isArray(w) ? o.value.enabled ? w.map((ue) => v(ue, Jn(Y, +ue.month, +ue.year))) : Na(
      () => [
        v(w[0], Jn(Y, +w[0].month, +w[0].year)),
        v(
          w[1],
          w[1] ? Jn(Y, +w[1].month, +w[1].year) : Ss(r.value.partialRange)
        )
      ],
      r.value.enabled
    ) : v(w, Jn(Y, +w.month, +w.year));
  }, M = (w) => {
    if (Array.isArray(w))
      return w.map((Y) => L(Y));
    throw new Error(Dd.dateArr("multi-dates"));
  }, A = (w) => {
    if (Array.isArray(w) && r.value.enabled) {
      const Y = w[0], ue = w[1];
      return [
        se(Array.isArray(Y) ? Y[0] : null),
        Array.isArray(ue) && ue.length ? se(ue[0]) : null
      ];
    }
    return se(w[0]);
  }, E = (w) => e.modelAuto ? Array.isArray(w) ? [L(w[0]), L(w[1])] : e.autoApply ? [L(w)] : [L(w), null] : Array.isArray(w) ? Na(
    () => w[1] ? [
      L(w[0]),
      w[1] ? L(w[1]) : Ss(r.value.partialRange)
    ] : [L(w[0])],
    r.value.enabled
  ) : L(w), I = () => {
    Array.isArray(i.value) && r.value.enabled && i.value.length === 1 && i.value.push(Ss(r.value.partialRange));
  }, S = () => {
    const w = i.value;
    return [
      z(w[0]),
      w[1] ? z(w[1]) : Ss(r.value.partialRange)
    ];
  }, $ = () => Array.isArray(i.value) ? i.value[1] ? S() : z(At(i.value[0])) : [], B = () => (i.value || []).map((w) => z(w)), V = (w = !1) => (w || I(), e.modelAuto ? $() : o.value.enabled ? B() : Array.isArray(i.value) ? Na(() => S(), r.value.enabled) : z(At(i.value))), G = (w) => !w || Array.isArray(w) && !w.length ? null : e.timePicker ? b(At(w)) : e.monthPicker ? _(At(w)) : e.yearPicker ? y(At(w)) : o.value.enabled ? M(At(w)) : e.weekPicker ? A(At(w)) : E(At(w)), P = (w) => {
    const Y = G(w);
    yc(At(Y)) ? (i.value = At(Y), N()) : (i.value = null, u.value = "");
  }, x = () => {
    const w = (Y) => Lt(Y, s.value.format);
    return `${w(i.value[0])} ${s.value.rangeSeparator} ${i.value[1] ? w(i.value[1]) : ""}`;
  }, k = () => n.value && i.value ? Array.isArray(i.value) ? x() : Lt(i.value, s.value.format) : m(i.value), D = () => i.value ? o.value.enabled ? i.value.map((w) => m(w)).join("; ") : s.value.enabled && typeof s.value.format == "string" ? k() : m(i.value) : "", N = () => {
    !e.format || typeof e.format == "string" || s.value.enabled && typeof s.value.format == "string" ? u.value = D() : u.value = e.format(i.value);
  }, L = (w) => {
    if (e.utc) {
      const Y = new Date(w);
      return e.utc === "preserve" ? new Date(Y.getTime() + Y.getTimezoneOffset() * 6e4) : Y;
    }
    return e.modelType ? zC.includes(e.modelType) ? f(new Date(w)) : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? f(
      hc(w, l(), /* @__PURE__ */ new Date(), { locale: d.value })
    ) : f(
      hc(w, e.modelType, /* @__PURE__ */ new Date(), { locale: d.value })
    ) : f(new Date(w));
  }, z = (w) => w ? e.utc ? QC(w, e.utc === "preserve", e.enableSeconds) : e.modelType ? e.modelType === "timestamp" ? +h(w) : e.modelType === "iso" ? h(w).toISOString() : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? m(h(w)) : m(h(w), e.modelType, !0) : h(w) : "", W = (w, Y = !1, ue = !1) => {
    if (ue) return w;
    if (t("update:model-value", w), a.value.emitTimezone && Y) {
      const ze = Array.isArray(w) ? w.map((K) => Jt(At(K), a.value.emitTimezone)) : Jt(At(w), a.value.emitTimezone);
      t("update:model-timezone-value", ze);
    }
  }, ae = (w) => Array.isArray(i.value) ? o.value.enabled ? i.value.map((Y) => w(Y)) : [
    w(i.value[0]),
    i.value[1] ? w(i.value[1]) : Ss(r.value.partialRange)
  ] : w(At(i.value)), F = () => {
    if (Array.isArray(i.value)) {
      const w = Gn(i.value[0], e.weekStart), Y = i.value[1] ? Gn(i.value[1], e.weekStart) : [];
      return [w.map((ue) => se(ue)), Y.map((ue) => se(ue))];
    }
    return Gn(i.value, e.weekStart).map((w) => se(w));
  }, H = (w, Y) => W(At(ae(w)), !1, Y), Q = (w) => {
    const Y = F();
    return w ? Y : t("update:model-value", F());
  }, ne = (w = !1) => (w || N(), e.monthPicker ? H(g, w) : e.timePicker ? H(p, w) : e.yearPicker ? H(Oe, w) : e.weekPicker ? Q(w) : W(V(w), !0, w));
  return {
    inputValue: u,
    internalModelValue: i,
    checkBeforeEmit: () => i.value ? r.value.enabled ? r.value.partialRange ? i.value.length >= 1 : i.value.length === 2 : !!i.value : !1,
    parseExternalModelValue: P,
    formatInputValue: N,
    emitModelValue: ne
  };
}, kA = (t, e) => {
  const { defaultedFilters: n, propDates: i } = lt(t), { validateMonthYearInRange: s } = Fi(t), r = (c, d) => {
    let f = c;
    return n.value.months.includes(Fe(f)) ? (f = d ? kn(c, 1) : Zs(c, 1), r(f, d)) : f;
  }, a = (c, d) => {
    let f = c;
    return n.value.years.includes(Oe(f)) ? (f = d ? hd(c, 1) : Ry(c, 1), a(f, d)) : f;
  }, o = (c, d = !1) => {
    const f = Je(se(), { month: t.month, year: t.year });
    let h = c ? kn(f, 1) : Zs(f, 1);
    t.disableYearSelect && (h = Vn(h, t.year));
    let m = Fe(h), p = Oe(h);
    n.value.months.includes(m) && (h = r(h, c), m = Fe(h), p = Oe(h)), n.value.years.includes(p) && (h = a(h, c), p = Oe(h)), s(m, p, c, t.preventMinMaxNavigation) && l(m, p, d);
  }, l = (c, d, f) => {
    e("update-month-year", { month: c, year: d, fromNav: f });
  }, u = Z(() => (c) => qy(
    Je(se(), { month: t.month, year: t.year }),
    i.value.maxDate,
    i.value.minDate,
    t.preventMinMaxNavigation,
    c
  ));
  return { handleMonthYearChange: o, isDisabled: u, updateMonthYear: l };
}, zo = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: [Boolean, String], default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  alwaysClearable: { type: Boolean, default: !1 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 },
  ui: { type: Object, default: () => ({}) }
}, Tn = {
  ...zo,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: !1 },
  isMobile: { type: Boolean, default: void 0 }
}, MA = ["title"], SA = ["disabled"], OA = /* @__PURE__ */ Rt({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...Tn
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(t, { emit: e }) {
    const n = e, i = t, {
      defaultedActionRow: s,
      defaultedPreviewFormat: r,
      defaultedMultiCalendars: a,
      defaultedTextInput: o,
      defaultedInline: l,
      defaultedRange: u,
      defaultedMultiDates: c
    } = lt(i), { isTimeValid: d, isMonthValid: f } = Fi(i), { buildMatrix: h } = Ii(), m = ee(null), p = ee(null), g = ee(!1), y = ee({}), v = ee(null), b = ee(null);
    _t(() => {
      i.arrowNavigation && h([Mt(m), Mt(p)], "actionRow"), _(), window.addEventListener("resize", _);
    }), us(() => {
      window.removeEventListener("resize", _);
    });
    const _ = () => {
      g.value = !1, setTimeout(() => {
        var P, x;
        const k = (P = v.value) == null ? void 0 : P.getBoundingClientRect(), D = (x = b.value) == null ? void 0 : x.getBoundingClientRect();
        k && D && (y.value.maxWidth = `${D.width - k.width - 20}px`), g.value = !0;
      }, 0);
    }, M = Z(() => u.value.enabled && !u.value.partialRange && i.internalModelValue ? i.internalModelValue.length === 2 : !0), A = Z(
      () => !d.value(i.internalModelValue) || !f.value(i.internalModelValue) || !M.value
    ), E = () => {
      const P = r.value;
      return i.timePicker || i.monthPicker, P(At(i.internalModelValue));
    }, I = () => {
      const P = i.internalModelValue;
      return a.value.count > 0 ? `${S(P[0])} - ${S(P[1])}` : [S(P[0]), S(P[1])];
    }, S = (P) => Uy(
      P,
      r.value,
      i.formatLocale,
      o.value.rangeSeparator,
      i.modelAuto,
      r.value
    ), $ = Z(() => !i.internalModelValue || !i.menuMount ? "" : typeof r.value == "string" ? Array.isArray(i.internalModelValue) ? i.internalModelValue.length === 2 && i.internalModelValue[1] ? I() : c.value.enabled ? i.internalModelValue.map((P) => `${S(P)}`) : i.modelAuto ? `${S(i.internalModelValue[0])}` : `${S(i.internalModelValue[0])} -` : S(i.internalModelValue) : E()), B = () => c.value.enabled ? "; " : " - ", V = Z(
      () => Array.isArray($.value) ? $.value.join(B()) : $.value
    ), G = () => {
      d.value(i.internalModelValue) && f.value(i.internalModelValue) && M.value ? n("select-date") : n("invalid-select");
    };
    return (P, x) => (O(), R("div", {
      ref_key: "actionRowRef",
      ref: b,
      class: "dp__action_row"
    }, [
      P.$slots["action-row"] ? te(P.$slots, "action-row", Pt(bt({ key: 0 }, {
        internalModelValue: P.internalModelValue,
        disabled: A.value,
        selectDate: () => P.$emit("select-date"),
        closePicker: () => P.$emit("close-picker")
      }))) : (O(), R(ye, { key: 1 }, [
        C(s).showPreview ? (O(), R("div", {
          key: 0,
          class: "dp__selection_preview",
          title: V.value,
          style: tt(y.value)
        }, [
          P.$slots["action-preview"] && g.value ? te(P.$slots, "action-preview", {
            key: 0,
            value: P.internalModelValue
          }) : U("", !0),
          !P.$slots["action-preview"] && g.value ? (O(), R(ye, { key: 1 }, [
            He(ve(V.value), 1)
          ], 64)) : U("", !0)
        ], 12, MA)) : U("", !0),
        J("div", {
          ref_key: "actionBtnContainer",
          ref: v,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          P.$slots["action-buttons"] ? te(P.$slots, "action-buttons", {
            key: 0,
            value: P.internalModelValue
          }) : U("", !0),
          P.$slots["action-buttons"] ? U("", !0) : (O(), R(ye, { key: 1 }, [
            !C(l).enabled && C(s).showCancel ? (O(), R("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: m,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: x[0] || (x[0] = (k) => P.$emit("close-picker")),
              onKeydown: x[1] || (x[1] = (k) => C(Ut)(k, () => P.$emit("close-picker")))
            }, ve(P.cancelText), 545)) : U("", !0),
            C(s).showNow ? (O(), R("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: x[2] || (x[2] = (k) => P.$emit("select-now")),
              onKeydown: x[3] || (x[3] = (k) => C(Ut)(k, () => P.$emit("select-now")))
            }, ve(P.nowButtonLabel), 33)) : U("", !0),
            C(s).showSelect ? (O(), R("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: p,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: A.value,
              "data-test-id": "select-button",
              onKeydown: x[4] || (x[4] = (k) => C(Ut)(k, () => G())),
              onClick: G
            }, ve(P.selectText), 41, SA)) : U("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), DA = ["role", "aria-label", "tabindex"], TA = { class: "dp__selection_grid_header" }, PA = ["aria-selected", "aria-disabled", "data-test-id", "onClick", "onKeydown", "onMouseover"], CA = ["aria-label"], ha = /* @__PURE__ */ Rt({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {},
    overlayLabel: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(t, { expose: e, emit: n }) {
    const { setSelectionGrid: i, buildMultiLevelMatrix: s, setMonthPicker: r } = Ii(), a = n, o = t, { defaultedAriaLabels: l, defaultedTextInput: u, defaultedConfig: c, handleEventPropagation: d } = lt(
      o
    ), { hideNavigationButtons: f } = Yo(), h = ee(!1), m = ee(null), p = ee(null), g = ee([]), y = ee(), v = ee(null), b = ee(0), _ = ee(null);
    hv(() => {
      m.value = null;
    }), _t(() => {
      Gt().then(() => V()), o.noOverlayFocus || A(), M(!0);
    }), us(() => M(!1));
    const M = (F) => {
      var H;
      o.arrowNavigation && ((H = o.headerRefs) != null && H.length ? r(F) : i(F));
    }, A = () => {
      var F;
      const H = Mt(p);
      H && (u.value.enabled || (m.value ? (F = m.value) == null || F.focus({ preventScroll: !0 }) : H.focus({ preventScroll: !0 })), h.value = H.clientHeight < H.scrollHeight);
    }, E = Z(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !o.useRelative,
        "dp--overlay-relative": o.useRelative
      })
    ), I = Z(
      () => o.useRelative ? { height: `${o.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), S = Z(() => ({
      dp__overlay_col: !0
    })), $ = Z(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: h.value,
        dp__button_bottom: o.isLast
      })
    ), B = Z(() => {
      var F, H;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((F = o.items) == null ? void 0 : F.length) <= 6,
        dp__container_block: ((H = o.items) == null ? void 0 : H.length) > 6
      };
    });
    ct(
      () => o.items,
      () => V(!1),
      { deep: !0 }
    );
    const V = (F = !0) => {
      Gt().then(() => {
        const H = Mt(m), Q = Mt(p), ne = Mt(v), w = Mt(_), Y = ne ? ne.getBoundingClientRect().height : 0;
        Q && (Q.getBoundingClientRect().height ? b.value = Q.getBoundingClientRect().height - Y : b.value = c.value.modeHeight - Y), H && w && F && (w.scrollTop = H.offsetTop - w.offsetTop - (b.value / 2 - H.getBoundingClientRect().height) - Y);
      });
    }, G = (F) => {
      F.disabled || a("selected", F.value);
    }, P = () => {
      a("toggle"), a("reset-flow");
    }, x = (F) => {
      o.escClose && (P(), d(F));
    }, k = (F, H, Q, ne) => {
      F && ((H.active || H.value === o.focusValue) && (m.value = F), o.arrowNavigation && (Array.isArray(g.value[Q]) ? g.value[Q][ne] = F : g.value[Q] = [F], D()));
    }, D = () => {
      var F, H;
      const Q = (F = o.headerRefs) != null && F.length ? [o.headerRefs].concat(g.value) : g.value.concat([o.skipButtonRef ? [] : [v.value]]);
      s(At(Q), (H = o.headerRefs) != null && H.length ? "monthPicker" : "selectionGrid");
    }, N = (F) => {
      o.arrowNavigation || Oi(F, c.value, !0);
    }, L = (F) => {
      y.value = F, a("hover-value", F);
    }, z = () => {
      if (P(), !o.isLast) {
        const F = gc(o.menuWrapRef ?? null, "action-row");
        if (F) {
          const H = Vy(F);
          H == null || H.focus();
        }
      }
    }, W = (F) => {
      switch (F.key) {
        case st.esc:
          return x(F);
        case st.arrowLeft:
          return N(F);
        case st.arrowRight:
          return N(F);
        case st.arrowUp:
          return N(F);
        case st.arrowDown:
          return N(F);
        default:
          return;
      }
    }, ae = (F) => {
      if (F.key === st.enter) return P();
      if (F.key === st.tab) return z();
    };
    return e({ focusGrid: A }), (F, H) => {
      var Q;
      return O(), R("div", {
        ref_key: "gridWrapRef",
        ref: p,
        class: me(E.value),
        style: tt(I.value),
        role: F.useRelative ? void 0 : "dialog",
        "aria-label": F.overlayLabel,
        tabindex: F.useRelative ? void 0 : "0",
        onKeydown: W,
        onClick: H[0] || (H[0] = et(() => {
        }, ["prevent"]))
      }, [
        J("div", {
          ref_key: "containerRef",
          ref: _,
          class: me(B.value),
          style: tt({ "--dp-overlay-height": `${b.value}px` }),
          role: "grid"
        }, [
          J("div", TA, [
            te(F.$slots, "header")
          ]),
          F.$slots.overlay ? te(F.$slots, "overlay", { key: 0 }) : (O(!0), R(ye, { key: 1 }, Te(F.items, (ne, w) => (O(), R("div", {
            key: w,
            class: me(["dp__overlay_row", { dp__flex_row: F.items.length >= 3 }]),
            role: "row"
          }, [
            (O(!0), R(ye, null, Te(ne, (Y, ue) => (O(), R("div", {
              key: Y.value,
              ref_for: !0,
              ref: (ze) => k(ze, Y, w, ue),
              role: "gridcell",
              class: me(S.value),
              "aria-selected": Y.active || void 0,
              "aria-disabled": Y.disabled || void 0,
              tabindex: "0",
              "data-test-id": Y.text,
              onClick: et((ze) => G(Y), ["prevent"]),
              onKeydown: (ze) => C(Ut)(ze, () => G(Y), !0),
              onMouseover: (ze) => L(Y.value)
            }, [
              J("div", {
                class: me(Y.className)
              }, [
                F.$slots.item ? te(F.$slots, "item", {
                  key: 0,
                  item: Y
                }) : U("", !0),
                F.$slots.item ? U("", !0) : (O(), R(ye, { key: 1 }, [
                  He(ve(Y.text), 1)
                ], 64))
              ], 2)
            ], 42, PA))), 128))
          ], 2))), 128))
        ], 6),
        F.$slots["button-icon"] ? Tt((O(), R("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: v,
          type: "button",
          "aria-label": (Q = C(l)) == null ? void 0 : Q.toggleOverlay,
          class: me($.value),
          tabindex: "0",
          onClick: P,
          onKeydown: ae
        }, [
          te(F.$slots, "button-icon")
        ], 42, CA)), [
          [sn, !C(f)(F.hideNavigation, F.type)]
        ]) : U("", !0)
      ], 46, DA);
    };
  }
}), AA = ["data-dp-mobile"], Wo = /* @__PURE__ */ Rt({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean },
    isMobile: { type: Boolean }
  },
  setup(t) {
    const e = t, n = Z(
      () => e.multiCalendars > 0 ? [...Array(e.multiCalendars).keys()] : [0]
    ), i = Z(() => ({
      dp__instance_calendar: e.multiCalendars > 0
    }));
    return (s, r) => (O(), R("div", {
      class: me({
        dp__menu_inner: !s.stretch,
        "dp--menu--inner-stretched": s.stretch,
        dp__flex_display: s.multiCalendars > 0,
        "dp--flex-display-collapsed": s.collapse
      }),
      "data-dp-mobile": s.isMobile
    }, [
      (O(!0), R(ye, null, Te(n.value, (a, o) => (O(), R("div", {
        key: a,
        class: me(i.value)
      }, [
        te(s.$slots, "default", {
          instance: a,
          index: o
        })
      ], 2))), 128))
    ], 10, AA));
  }
}), EA = ["data-dp-element", "aria-label", "aria-disabled"], Vr = /* @__PURE__ */ Rt({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(t, { emit: e }) {
    const n = e, i = ee(null);
    return _t(() => n("set-ref", i)), (s, r) => (O(), R("button", {
      ref_key: "elRef",
      ref: i,
      type: "button",
      "data-dp-element": s.elName,
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": s.ariaLabel,
      "aria-disabled": s.disabled || void 0,
      onClick: r[0] || (r[0] = (a) => s.$emit("activate")),
      onKeydown: r[1] || (r[1] = (a) => C(Ut)(a, () => s.$emit("activate"), !0))
    }, [
      J("span", {
        class: me(["dp__inner_nav", { dp__inner_nav_disabled: s.disabled }])
      }, [
        te(s.$slots, "default")
      ], 2)
    ], 40, EA));
  }
}), $A = ["aria-label", "data-test-id"], Zy = /* @__PURE__ */ Rt({
  __name: "YearModePicker",
  props: {
    ...Tn,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(t, { emit: e }) {
    const n = e, i = t, { showRightIcon: s, showLeftIcon: r } = Yo(), { defaultedConfig: a, defaultedMultiCalendars: o, defaultedAriaLabels: l, defaultedTransitions: u, defaultedUI: c } = lt(i), { showTransition: d, transitionName: f } = ma(u), h = ee(!1), m = (y = !1, v) => {
      h.value = !h.value, n("toggle-year-picker", { flow: y, show: v });
    }, p = (y) => {
      h.value = !1, n("year-select", y);
    }, g = (y = !1) => {
      n("handle-year", y);
    };
    return (y, v) => {
      var b, _, M, A, E;
      return O(), R(ye, null, [
        J("div", {
          class: me(["dp--year-mode-picker", { "dp--hidden-el": h.value }])
        }, [
          C(r)(C(o), t.instance) ? (O(), Se(Vr, {
            key: 0,
            ref: "mpPrevIconRef",
            "aria-label": (b = C(l)) == null ? void 0 : b.prevYear,
            disabled: t.isDisabled(!1),
            class: me((_ = C(c)) == null ? void 0 : _.navBtnPrev),
            onActivate: v[0] || (v[0] = (I) => g(!1))
          }, {
            default: be(() => [
              y.$slots["arrow-left"] ? te(y.$slots, "arrow-left", { key: 0 }) : U("", !0),
              y.$slots["arrow-left"] ? U("", !0) : (O(), Se(C(wd), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : U("", !0),
          J("button", {
            ref: "mpYearButtonRef",
            class: "dp__btn dp--year-select",
            type: "button",
            "aria-label": `${t.year}-${(M = C(l)) == null ? void 0 : M.openYearsOverlay}`,
            "data-test-id": `year-mode-btn-${t.instance}`,
            onClick: v[1] || (v[1] = () => m(!1)),
            onKeydown: v[2] || (v[2] = cn(() => m(!1), ["enter"]))
          }, [
            y.$slots.year ? te(y.$slots, "year", {
              key: 0,
              year: t.year
            }) : U("", !0),
            y.$slots.year ? U("", !0) : (O(), R(ye, { key: 1 }, [
              He(ve(t.year), 1)
            ], 64))
          ], 40, $A),
          C(s)(C(o), t.instance) ? (O(), Se(Vr, {
            key: 1,
            ref: "mpNextIconRef",
            "aria-label": (A = C(l)) == null ? void 0 : A.nextYear,
            disabled: t.isDisabled(!0),
            class: me((E = C(c)) == null ? void 0 : E.navBtnNext),
            onActivate: v[3] || (v[3] = (I) => g(!0))
          }, {
            default: be(() => [
              y.$slots["arrow-right"] ? te(y.$slots, "arrow-right", { key: 0 }) : U("", !0),
              y.$slots["arrow-right"] ? U("", !0) : (O(), Se(C(xd), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : U("", !0)
        ], 2),
        Ce(Bn, {
          name: C(f)(t.showYearPicker),
          css: C(d)
        }, {
          default: be(() => {
            var I, S;
            return [
              t.showYearPicker ? (O(), Se(ha, {
                key: 0,
                items: t.items,
                "text-input": y.textInput,
                "esc-close": y.escClose,
                config: y.config,
                "is-last": y.autoApply && !C(a).keepActionRow,
                "hide-navigation": y.hideNavigation,
                "aria-labels": y.ariaLabels,
                "overlay-label": (S = (I = C(l)) == null ? void 0 : I.yearPicker) == null ? void 0 : S.call(I, !0),
                type: "year",
                onToggle: m,
                onSelected: v[4] || (v[4] = ($) => p($))
              }, It({
                "button-icon": be(() => [
                  y.$slots["calendar-icon"] ? te(y.$slots, "calendar-icon", { key: 0 }) : U("", !0),
                  y.$slots["calendar-icon"] ? U("", !0) : (O(), Se(C(cr), { key: 1 }))
                ]),
                _: 2
              }, [
                y.$slots["year-overlay-value"] ? {
                  name: "item",
                  fn: be(({ item: $ }) => [
                    te(y.$slots, "year-overlay-value", {
                      text: $.text,
                      value: $.value
                    })
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels", "overlay-label"])) : U("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 64);
    };
  }
}), Cd = (t, e, n) => {
  if (e.value && Array.isArray(e.value))
    if (e.value.some((i) => Ve(t, i))) {
      const i = e.value.filter((s) => !Ve(s, t));
      e.value = i.length ? i : null;
    } else (n && +n > e.value.length || !n) && e.value.push(t);
  else
    e.value = [t];
}, Ad = (t, e, n) => {
  let i = t.value ? t.value.slice() : [];
  return i.length === 2 && i[1] !== null && (i = []), i.length ? (ht(e, i[0]) ? i.unshift(e) : i[1] = e, n("range-end", e)) : (i = [e], n("range-start", e)), i;
}, Ho = (t, e, n, i) => {
  t && (t[0] && t[1] && n && e("auto-apply"), t[0] && !t[1] && i && n && e("auto-apply"));
}, Ky = (t) => {
  Array.isArray(t.value) && t.value.length <= 2 && t.range ? t.modelValue.value = t.value.map((e) => Jt(se(e), t.timezone)) : Array.isArray(t.value) || (t.modelValue.value = Jt(se(t.value), t.timezone));
}, Qy = (t, e, n, i) => Array.isArray(e.value) && (e.value.length === 2 || e.value.length === 1 && i.value.partialRange) ? i.value.fixedStart && (vt(t, e.value[0]) || Ve(t, e.value[0])) ? [e.value[0], t] : i.value.fixedEnd && (ht(t, e.value[1]) || Ve(t, e.value[1])) ? [t, e.value[1]] : (n("invalid-fixed-range", t), e.value) : [], Jy = ({
  multiCalendars: t,
  range: e,
  highlight: n,
  propDates: i,
  calendars: s,
  modelValue: r,
  props: a,
  filters: o,
  year: l,
  month: u,
  emit: c
}) => {
  const d = Z(() => Od(a.yearRange, a.locale, a.reverseYears)), f = ee([!1]), h = Z(() => ($, B) => {
    const V = Je(wn(/* @__PURE__ */ new Date()), {
      month: u.value($),
      year: l.value($)
    }), G = B ? vy(V) : os(V);
    return qy(
      G,
      i.value.maxDate,
      i.value.minDate,
      a.preventMinMaxNavigation,
      B
    );
  }), m = () => Array.isArray(r.value) && t.value.solo && r.value[1], p = () => {
    for (let $ = 0; $ < t.value.count; $++)
      if ($ === 0)
        s.value[$] = s.value[0];
      else if ($ === t.value.count - 1 && m())
        s.value[$] = {
          month: Fe(r.value[1]),
          year: Oe(r.value[1])
        };
      else {
        const B = Je(se(), s.value[$ - 1]);
        s.value[$] = { month: Fe(B), year: Oe(hd(B, 1)) };
      }
  }, g = ($) => {
    if (!$) return p();
    const B = Je(se(), s.value[$]);
    return s.value[0].year = Oe(Ry(B, t.value.count - 1)), p();
  }, y = ($, B) => {
    const V = sD(B, $);
    return e.value.showLastInRange && V > 1 ? B : $;
  }, v = ($) => a.focusStartDate || t.value.solo ? $[0] : $[1] ? y($[0], $[1]) : $[0], b = () => {
    if (r.value) {
      const $ = Array.isArray(r.value) ? v(r.value) : r.value;
      s.value[0] = { month: Fe($), year: Oe($) };
    }
  }, _ = () => {
    b(), t.value.count && p();
  };
  ct(r, ($, B) => {
    a.isTextInputDate && JSON.stringify($ ?? {}) !== JSON.stringify(B ?? {}) && _();
  }), _t(() => {
    _();
  });
  const M = ($, B) => {
    s.value[B].year = $, c("update-month-year", { instance: B, year: $, month: s.value[B].month }), t.value.count && !t.value.solo && g(B);
  }, A = Z(() => ($) => Ks(d.value, (B) => {
    var V;
    const G = l.value($) === B.value, P = Gr(
      B.value,
      Qs(i.value.minDate),
      Qs(i.value.maxDate)
    ) || ((V = o.value.years) == null ? void 0 : V.includes(l.value($))), x = Pd(n.value, B.value);
    return { active: G, disabled: P, highlighted: x };
  })), E = ($, B) => {
    M($, B), S(B);
  }, I = ($, B = !1) => {
    if (!h.value($, B)) {
      const V = B ? l.value($) + 1 : l.value($) - 1;
      M(V, $);
    }
  }, S = ($, B = !1, V) => {
    B || c("reset-flow"), V !== void 0 ? f.value[$] = V : f.value[$] = !f.value[$], f.value[$] ? c("overlay-toggle", { open: !0, overlay: Bt.year }) : (c("overlay-closed"), c("overlay-toggle", { open: !1, overlay: Bt.year }));
  };
  return {
    isDisabled: h,
    groupedYears: A,
    showYearPicker: f,
    selectYear: M,
    toggleYearPicker: S,
    handleYearSelect: E,
    handleYear: I
  };
}, RA = (t, e) => {
  const {
    defaultedMultiCalendars: n,
    defaultedAriaLabels: i,
    defaultedTransitions: s,
    defaultedConfig: r,
    defaultedRange: a,
    defaultedHighlight: o,
    propDates: l,
    defaultedTz: u,
    defaultedFilters: c,
    defaultedMultiDates: d
  } = lt(t), f = () => {
    t.isTextInputDate && _(Oe(se(t.startDate)), 0);
  }, { modelValue: h, year: m, month: p, calendars: g } = pa(t, e, f), y = Z(() => Iy(t.formatLocale, t.locale, t.monthNameFormat)), v = ee(null), { checkMinMaxRange: b } = Fi(t), {
    selectYear: _,
    groupedYears: M,
    showYearPicker: A,
    toggleYearPicker: E,
    handleYearSelect: I,
    handleYear: S,
    isDisabled: $
  } = Jy({
    modelValue: h,
    multiCalendars: n,
    range: a,
    highlight: o,
    calendars: g,
    year: m,
    propDates: l,
    month: p,
    filters: c,
    props: t,
    emit: e
  });
  _t(() => {
    t.startDate && (h.value && t.focusStartDate || !h.value) && _(Oe(se(t.startDate)), 0);
  });
  const B = (H) => H ? { month: Fe(H), year: Oe(H) } : { month: null, year: null }, V = () => h.value ? Array.isArray(h.value) ? h.value.map((H) => B(H)) : B(h.value) : B(), G = (H, Q) => {
    const ne = g.value[H], w = V();
    return Array.isArray(w) ? w.some((Y) => Y.year === (ne == null ? void 0 : ne.year) && Y.month === Q) : (ne == null ? void 0 : ne.year) === w.year && Q === w.month;
  }, P = (H, Q, ne) => {
    var w, Y;
    const ue = V();
    return Array.isArray(ue) ? m.value(Q) === ((w = ue[ne]) == null ? void 0 : w.year) && H === ((Y = ue[ne]) == null ? void 0 : Y.month) : !1;
  }, x = (H, Q) => {
    if (a.value.enabled) {
      const ne = V();
      if (Array.isArray(h.value) && Array.isArray(ne)) {
        const w = P(H, Q, 0) || P(H, Q, 1), Y = Jn(wn(se()), H, m.value(Q));
        return Zr(h.value, v.value, Y) && !w;
      }
      return !1;
    }
    return !1;
  }, k = Z(() => (H) => Ks(y.value, (Q) => {
    var ne;
    const w = G(H, Q.value), Y = Gr(
      Q.value,
      Wy(m.value(H), l.value.minDate),
      Hy(m.value(H), l.value.maxDate)
    ) || iA(l.value.disabledDates, m.value(H), Q.value) || ((ne = c.value.months) == null ? void 0 : ne.includes(Q.value)) || !sA(l.value.allowedDates, m.value(H), Q.value), ue = x(Q.value, H), ze = Xy(o.value, Q.value, m.value(H));
    return { active: w, disabled: Y, isBetween: ue, highlighted: ze };
  })), D = (H, Q) => Jn(wn(se()), H, m.value(Q)), N = (H, Q) => {
    const ne = h.value ? h.value : wn(/* @__PURE__ */ new Date());
    h.value = Jn(ne, H, m.value(Q)), e("auto-apply"), e("update-flow-step");
  }, L = (H, Q) => {
    const ne = D(H, Q);
    a.value.fixedEnd || a.value.fixedStart ? h.value = Qy(ne, h, e, a) : h.value ? b(ne, h.value) && (h.value = Ad(h, D(H, Q), e)) : h.value = [D(H, Q)], Gt().then(() => {
      Ho(h.value, e, t.autoApply, t.modelAuto);
    });
  }, z = (H, Q) => {
    Cd(D(H, Q), h, d.value.limit), e("auto-apply", !0);
  }, W = (H, Q) => (g.value[Q].month = H, F(Q, g.value[Q].year, H), d.value.enabled ? z(H, Q) : a.value.enabled ? L(H, Q) : N(H, Q)), ae = (H, Q) => {
    _(H, Q), F(Q, H, null);
  }, F = (H, Q, ne) => {
    let w = ne;
    if (!w && w !== 0) {
      const Y = V();
      w = Array.isArray(Y) ? Y[H].month : Y.month;
    }
    e("update-month-year", { instance: H, year: Q, month: w });
  };
  return {
    groupedMonths: k,
    groupedYears: M,
    year: m,
    isDisabled: $,
    defaultedMultiCalendars: n,
    defaultedAriaLabels: i,
    defaultedTransitions: s,
    defaultedConfig: r,
    showYearPicker: A,
    modelValue: h,
    presetDate: (H, Q) => {
      Ky({
        value: H,
        modelValue: h,
        range: a.value.enabled,
        timezone: Q ? void 0 : u.value.timezone
      }), e("auto-apply");
    },
    setHoverDate: (H, Q) => {
      v.value = D(H, Q);
    },
    selectMonth: W,
    selectYear: ae,
    toggleYearPicker: E,
    handleYearSelect: I,
    handleYear: S,
    getModelMonthYear: V
  };
}, LA = /* @__PURE__ */ Rt({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...Tn
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const i = n, s = cs(), r = rn(s, "yearMode"), a = t;
    _t(() => {
      a.shadow || i("mount", null);
    });
    const {
      groupedMonths: o,
      groupedYears: l,
      year: u,
      isDisabled: c,
      defaultedMultiCalendars: d,
      defaultedConfig: f,
      showYearPicker: h,
      modelValue: m,
      presetDate: p,
      setHoverDate: g,
      selectMonth: y,
      selectYear: v,
      toggleYearPicker: b,
      handleYearSelect: _,
      handleYear: M,
      getModelMonthYear: A
    } = RA(a, i);
    return e({ getSidebarProps: () => ({
      modelValue: m,
      year: u,
      getModelMonthYear: A,
      selectMonth: y,
      selectYear: v,
      handleYear: M
    }), presetDate: p, toggleYearPicker: (E) => b(0, E) }), (E, I) => (O(), Se(Wo, {
      "multi-calendars": C(d).count,
      collapse: E.collapse,
      stretch: "",
      "is-mobile": E.isMobile
    }, {
      default: be(({ instance: S }) => [
        E.$slots["top-extra"] ? te(E.$slots, "top-extra", {
          key: 0,
          value: E.internalModelValue
        }) : U("", !0),
        E.$slots["month-year"] ? te(E.$slots, "month-year", Pt(bt({ key: 1 }, {
          year: C(u),
          months: C(o)(S),
          years: C(l)(S),
          selectMonth: C(y),
          selectYear: C(v),
          instance: S
        }))) : (O(), Se(ha, {
          key: 2,
          items: C(o)(S),
          "arrow-navigation": E.arrowNavigation,
          "is-last": E.autoApply && !C(f).keepActionRow,
          "esc-close": E.escClose,
          height: C(f).modeHeight,
          config: E.config,
          "no-overlay-focus": !!(E.noOverlayFocus || E.textInput),
          "use-relative": "",
          type: "month",
          onSelected: ($) => C(y)($, S),
          onHoverValue: ($) => C(g)($, S)
        }, It({
          header: be(() => [
            Ce(Zy, bt(E.$props, {
              items: C(l)(S),
              instance: S,
              "show-year-picker": C(h)[S],
              year: C(u)(S),
              "is-disabled": ($) => C(c)(S, $),
              onHandleYear: ($) => C(M)(S, $),
              onYearSelect: ($) => C(_)($, S),
              onToggleYearPicker: ($) => C(b)(S, $ == null ? void 0 : $.flow, $ == null ? void 0 : $.show)
            }), It({ _: 2 }, [
              Te(C(r), ($, B) => ({
                name: $,
                fn: be((V) => [
                  te(E.$slots, $, Pt(jt(V)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          E.$slots["month-overlay-value"] ? {
            name: "item",
            fn: be(({ item: $ }) => [
              te(E.$slots, "month-overlay-value", {
                text: $.text,
                value: $.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), IA = (t, e) => {
  const n = () => {
    t.isTextInputDate && (c.value = Oe(se(t.startDate)));
  }, { modelValue: i } = pa(t, e, n), s = ee(null), { defaultedHighlight: r, defaultedMultiDates: a, defaultedFilters: o, defaultedRange: l, propDates: u } = lt(t), c = ee();
  _t(() => {
    t.startDate && (i.value && t.focusStartDate || !i.value) && (c.value = Oe(se(t.startDate)));
  });
  const d = (y) => Array.isArray(i.value) ? i.value.some((v) => Oe(v) === y) : i.value ? Oe(i.value) === y : !1, f = (y) => l.value.enabled && Array.isArray(i.value) ? Zr(i.value, s.value, g(y)) : !1, h = (y) => u.value.allowedDates instanceof Map ? u.value.allowedDates.size ? u.value.allowedDates.has(`${y}`) : !1 : !0, m = (y) => u.value.disabledDates instanceof Map ? u.value.disabledDates.size ? u.value.disabledDates.has(`${y}`) : !1 : !0, p = Z(() => Ks(Od(t.yearRange, t.locale, t.reverseYears), (y) => {
    const v = d(y.value), b = Gr(
      y.value,
      Qs(u.value.minDate),
      Qs(u.value.maxDate)
    ) || o.value.years.includes(y.value) || !h(y.value) || m(y.value), _ = f(y.value) && !v, M = Pd(r.value, y.value);
    return { active: v, disabled: b, isBetween: _, highlighted: M };
  })), g = (y) => Vn(wn(os(/* @__PURE__ */ new Date())), y);
  return {
    groupedYears: p,
    modelValue: i,
    focusYear: c,
    setHoverValue: (y) => {
      s.value = Vn(wn(/* @__PURE__ */ new Date()), y);
    },
    selectYear: (y) => {
      var v;
      if (e("update-month-year", { instance: 0, year: y }), a.value.enabled)
        return i.value ? Array.isArray(i.value) && (((v = i.value) == null ? void 0 : v.map((b) => Oe(b))).includes(y) ? i.value = i.value.filter((b) => Oe(b) !== y) : i.value.push(Vn($t(se()), y))) : i.value = [Vn($t(os(se())), y)], e("auto-apply", !0);
      l.value.enabled ? (i.value = Ad(i, g(y), e), Gt().then(() => {
        Ho(i.value, e, t.autoApply, t.modelAuto);
      })) : (i.value = g(y), e("auto-apply"));
    }
  };
}, FA = /* @__PURE__ */ Rt({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...Tn
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(t, { expose: e, emit: n }) {
    const i = n, s = t, { groupedYears: r, modelValue: a, focusYear: o, selectYear: l, setHoverValue: u } = IA(s, i), { defaultedConfig: c } = lt(s);
    return e({ getSidebarProps: () => ({
      modelValue: a,
      selectYear: l
    }) }), (d, f) => (O(), R("div", null, [
      d.$slots["top-extra"] ? te(d.$slots, "top-extra", {
        key: 0,
        value: d.internalModelValue
      }) : U("", !0),
      d.$slots["month-year"] ? te(d.$slots, "month-year", Pt(bt({ key: 1 }, {
        years: C(r),
        selectYear: C(l)
      }))) : (O(), Se(ha, {
        key: 2,
        items: C(r),
        "is-last": d.autoApply && !C(c).keepActionRow,
        height: C(c).modeHeight,
        config: d.config,
        "no-overlay-focus": !!(d.noOverlayFocus || d.textInput),
        "focus-value": C(o),
        type: "year",
        "use-relative": "",
        onSelected: C(l),
        onHoverValue: C(u)
      }, It({ _: 2 }, [
        d.$slots["year-overlay-value"] ? {
          name: "item",
          fn: be(({ item: h }) => [
            te(d.$slots, "year-overlay-value", {
              text: h.text,
              value: h.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), VA = {
  key: 0,
  class: "dp__time_input"
}, NA = ["data-compact", "data-collapsed"], BA = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], zA = ["aria-label", "disabled", "data-test-id", "onKeydown", "onClick"], WA = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], HA = { key: 0 }, YA = ["aria-label", "data-compact"], jA = /* @__PURE__ */ Rt({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...Tn
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: n }) {
    const i = n, s = t, { setTimePickerElements: r, setTimePickerBackRef: a } = Ii(), {
      defaultedAriaLabels: o,
      defaultedTransitions: l,
      defaultedFilters: u,
      defaultedConfig: c,
      defaultedRange: d,
      defaultedMultiCalendars: f
    } = lt(s), { transitionName: h, showTransition: m } = ma(l), p = er({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), g = ee("AM"), y = ee(null), v = ee([]), b = ee(), _ = ee(!1);
    _t(() => {
      i("mounted");
    });
    const M = (T) => Je(/* @__PURE__ */ new Date(), {
      hours: T.hours,
      minutes: T.minutes,
      seconds: s.enableSeconds ? T.seconds : 0,
      milliseconds: 0
    }), A = Z(
      () => (T) => L(T, s[T]) || I(T, s[T])
    ), E = Z(() => ({ hours: s.hours, minutes: s.minutes, seconds: s.seconds })), I = (T, le) => d.value.enabled && !d.value.disableTimeRangeValidation ? !s.validateTime(T, le) : !1, S = (T, le) => {
      if (d.value.enabled && !d.value.disableTimeRangeValidation) {
        const de = le ? +s[`${T}Increment`] : -+s[`${T}Increment`], fe = s[T] + de;
        return !s.validateTime(T, fe);
      }
      return !1;
    }, $ = Z(() => (T) => !H(+s[T] + +s[`${T}Increment`], T) || S(T, !0)), B = Z(() => (T) => !H(+s[T] - +s[`${T}Increment`], T) || S(T, !1)), V = (T, le) => Ps(Je(se(), T), le), G = (T, le) => qi(Je(se(), T), le), P = Z(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !s.timePickerInline,
        dp__time_col_reg_block: !s.enableSeconds && s.is24 && !s.timePickerInline,
        dp__time_col_reg_inline: !s.enableSeconds && s.is24 && s.timePickerInline,
        dp__time_col_reg_with_button: !s.enableSeconds && !s.is24,
        dp__time_col_sec: s.enableSeconds && s.is24,
        dp__time_col_sec_with_button: s.enableSeconds && !s.is24
      })
    ), x = Z(
      () => s.timePickerInline && d.value.enabled && !f.value.count
    ), k = Z(() => {
      const T = [{ type: "hours" }];
      return s.enableMinutes && T.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), s.enableSeconds && T.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), T;
    }), D = Z(() => k.value.filter((T) => !T.separator)), N = Z(() => (T) => {
      if (T === "hours") {
        const le = ze(+s.hours);
        return { text: le < 10 ? `0${le}` : `${le}`, value: le };
      }
      return { text: s[T] < 10 ? `0${s[T]}` : `${s[T]}`, value: s[T] };
    }), L = (T, le) => {
      var de;
      if (!s.disabledTimesConfig) return !1;
      const fe = s.disabledTimesConfig(s.order, T === "hours" ? le : void 0);
      return fe[T] ? !!((de = fe[T]) != null && de.includes(le)) : !0;
    }, z = (T, le) => le !== "hours" || g.value === "AM" ? T : T + 12, W = (T) => {
      const le = s.is24 ? 24 : 12, de = T === "hours" ? le : 60, fe = +s[`${T}GridIncrement`], Le = T === "hours" && !s.is24 ? fe : 0, $e = [];
      for (let Xe = Le; Xe < de; Xe += fe)
        $e.push({ value: s.is24 ? Xe : z(Xe, T), text: Xe < 10 ? `0${Xe}` : `${Xe}` });
      return T === "hours" && !s.is24 && $e.unshift({ value: g.value === "PM" ? 12 : 0, text: "12" }), Ks($e, (Xe) => ({ active: !1, disabled: u.value.times[T].includes(Xe.value) || !H(Xe.value, T) || L(T, Xe.value) || I(T, Xe.value) }));
    }, ae = (T) => T >= 0 ? T : 59, F = (T) => T >= 0 ? T : 23, H = (T, le) => {
      const de = s.minTime ? M(cu(s.minTime)) : null, fe = s.maxTime ? M(cu(s.maxTime)) : null, Le = M(
        cu(
          E.value,
          le,
          le === "minutes" || le === "seconds" ? ae(T) : F(T)
        )
      );
      return de && fe ? (Gs(Le, fe) || Cs(Le, fe)) && (ls(Le, de) || Cs(Le, de)) : de ? ls(Le, de) || Cs(Le, de) : fe ? Gs(Le, fe) || Cs(Le, fe) : !0;
    }, Q = (T) => s[`no${T[0].toUpperCase() + T.slice(1)}Overlay`], ne = (T) => {
      Q(T) || (p[T] = !p[T], p[T] ? (_.value = !0, i("overlay-opened", T)) : (_.value = !1, i("overlay-closed", T)));
    }, w = (T) => T === "hours" ? ni : T === "minutes" ? Ri : Xs, Y = () => {
      b.value && clearTimeout(b.value);
    }, ue = (T, le = !0, de) => {
      const fe = le ? V : G, Le = le ? +s[`${T}Increment`] : -+s[`${T}Increment`];
      H(+s[T] + Le, T) && i(
        `update:${T}`,
        w(T)(fe({ [T]: +s[T] }, { [T]: +s[`${T}Increment`] }))
      ), !(de != null && de.keyboard) && c.value.timeArrowHoldThreshold && (b.value = setTimeout(() => {
        ue(T, le);
      }, c.value.timeArrowHoldThreshold));
    }, ze = (T) => s.is24 ? T : (T >= 12 ? g.value = "PM" : g.value = "AM", YC(T)), K = () => {
      g.value === "PM" ? (g.value = "AM", i("update:hours", s.hours - 12)) : (g.value = "PM", i("update:hours", s.hours + 12)), i("am-pm-change", g.value);
    }, Ee = (T) => {
      p[T] = !0;
    }, re = (T, le, de) => {
      if (T && s.arrowNavigation) {
        Array.isArray(v.value[le]) ? v.value[le][de] = T : v.value[le] = [T];
        const fe = v.value.reduce(
          (Le, $e) => $e.map((Xe, gt) => [...Le[gt] || [], $e[gt]]),
          []
        );
        a(s.closeTimePickerBtn), y.value && (fe[1] = fe[1].concat(y.value)), r(fe, s.order);
      }
    }, ce = (T, le) => (ne(T), i(`update:${T}`, le));
    return e({ openChildCmp: Ee }), (T, le) => {
      var de;
      return T.disabled ? U("", !0) : (O(), R("div", VA, [
        (O(!0), R(ye, null, Te(k.value, (fe, Le) => {
          var $e, Xe, gt;
          return O(), R("div", {
            key: Le,
            class: me(P.value),
            "data-compact": x.value && !T.enableSeconds,
            "data-collapsed": x.value && T.enableSeconds
          }, [
            fe.separator ? (O(), R(ye, { key: 0 }, [
              _.value ? U("", !0) : (O(), R(ye, { key: 0 }, [
                He(":")
              ], 64))
            ], 64)) : (O(), R(ye, { key: 1 }, [
              J("button", {
                ref_for: !0,
                ref: (j) => re(j, Le, 0),
                type: "button",
                class: me({
                  dp__btn: !0,
                  dp__inc_dec_button: !T.timePickerInline,
                  dp__inc_dec_button_inline: T.timePickerInline,
                  dp__tp_inline_btn_top: T.timePickerInline,
                  dp__inc_dec_button_disabled: $.value(fe.type),
                  "dp--hidden-el": _.value
                }),
                "data-test-id": `${fe.type}-time-inc-btn-${s.order}`,
                "aria-label": ($e = C(o)) == null ? void 0 : $e.incrementValue(fe.type),
                tabindex: "0",
                onKeydown: (j) => C(Ut)(j, () => ue(fe.type, !0, { keyboard: !0 }), !0),
                onClick: (j) => C(c).timeArrowHoldThreshold ? void 0 : ue(fe.type, !0),
                onMousedown: (j) => C(c).timeArrowHoldThreshold ? ue(fe.type, !0) : void 0,
                onMouseup: Y
              }, [
                s.timePickerInline ? (O(), R(ye, { key: 1 }, [
                  T.$slots["tp-inline-arrow-up"] ? te(T.$slots, "tp-inline-arrow-up", { key: 0 }) : (O(), R(ye, { key: 1 }, [
                    le[2] || (le[2] = J("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    le[3] || (le[3] = J("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (O(), R(ye, { key: 0 }, [
                  T.$slots["arrow-up"] ? te(T.$slots, "arrow-up", { key: 0 }) : U("", !0),
                  T.$slots["arrow-up"] ? U("", !0) : (O(), Se(C(kd), { key: 1 }))
                ], 64))
              ], 42, BA),
              J("button", {
                ref_for: !0,
                ref: (j) => re(j, Le, 1),
                type: "button",
                "aria-label": `${N.value(fe.type).text}-${(Xe = C(o)) == null ? void 0 : Xe.openTpOverlay(fe.type)}`,
                class: me({
                  dp__time_display: !0,
                  dp__time_display_block: !T.timePickerInline,
                  dp__time_display_inline: T.timePickerInline,
                  "dp--time-invalid": A.value(fe.type),
                  "dp--time-overlay-btn": !A.value(fe.type),
                  "dp--hidden-el": _.value
                }),
                disabled: Q(fe.type),
                tabindex: "0",
                "data-test-id": `${fe.type}-toggle-overlay-btn-${s.order}`,
                onKeydown: (j) => C(Ut)(j, () => ne(fe.type), !0),
                onClick: (j) => ne(fe.type)
              }, [
                T.$slots[fe.type] ? te(T.$slots, fe.type, {
                  key: 0,
                  text: N.value(fe.type).text,
                  value: N.value(fe.type).value
                }) : U("", !0),
                T.$slots[fe.type] ? U("", !0) : (O(), R(ye, { key: 1 }, [
                  He(ve(N.value(fe.type).text), 1)
                ], 64))
              ], 42, zA),
              J("button", {
                ref_for: !0,
                ref: (j) => re(j, Le, 2),
                type: "button",
                class: me({
                  dp__btn: !0,
                  dp__inc_dec_button: !T.timePickerInline,
                  dp__inc_dec_button_inline: T.timePickerInline,
                  dp__tp_inline_btn_bottom: T.timePickerInline,
                  dp__inc_dec_button_disabled: B.value(fe.type),
                  "dp--hidden-el": _.value
                }),
                "data-test-id": `${fe.type}-time-dec-btn-${s.order}`,
                "aria-label": (gt = C(o)) == null ? void 0 : gt.decrementValue(fe.type),
                tabindex: "0",
                onKeydown: (j) => C(Ut)(j, () => ue(fe.type, !1, { keyboard: !0 }), !0),
                onClick: (j) => C(c).timeArrowHoldThreshold ? void 0 : ue(fe.type, !1),
                onMousedown: (j) => C(c).timeArrowHoldThreshold ? ue(fe.type, !1) : void 0,
                onMouseup: Y
              }, [
                s.timePickerInline ? (O(), R(ye, { key: 1 }, [
                  T.$slots["tp-inline-arrow-down"] ? te(T.$slots, "tp-inline-arrow-down", { key: 0 }) : (O(), R(ye, { key: 1 }, [
                    le[4] || (le[4] = J("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    le[5] || (le[5] = J("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (O(), R(ye, { key: 0 }, [
                  T.$slots["arrow-down"] ? te(T.$slots, "arrow-down", { key: 0 }) : U("", !0),
                  T.$slots["arrow-down"] ? U("", !0) : (O(), Se(C(Md), { key: 1 }))
                ], 64))
              ], 42, WA)
            ], 64))
          ], 10, NA);
        }), 128)),
        T.is24 ? U("", !0) : (O(), R("div", HA, [
          T.$slots["am-pm-button"] ? te(T.$slots, "am-pm-button", {
            key: 0,
            toggle: K,
            value: g.value
          }) : U("", !0),
          T.$slots["am-pm-button"] ? U("", !0) : (O(), R("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: y,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (de = C(o)) == null ? void 0 : de.amPmButton,
            tabindex: "0",
            "data-compact": x.value,
            onClick: K,
            onKeydown: le[0] || (le[0] = (fe) => C(Ut)(fe, () => K(), !0))
          }, ve(g.value), 41, YA))
        ])),
        (O(!0), R(ye, null, Te(D.value, (fe, Le) => (O(), Se(Bn, {
          key: Le,
          name: C(h)(p[fe.type]),
          css: C(m)
        }, {
          default: be(() => {
            var $e, Xe;
            return [
              p[fe.type] ? (O(), Se(ha, {
                key: 0,
                items: W(fe.type),
                "is-last": T.autoApply && !C(c).keepActionRow,
                "esc-close": T.escClose,
                type: fe.type,
                "text-input": T.textInput,
                config: T.config,
                "arrow-navigation": T.arrowNavigation,
                "aria-labels": T.ariaLabels,
                "overlay-label": (Xe = ($e = C(o)).timeOverlay) == null ? void 0 : Xe.call($e, fe.type),
                onSelected: (gt) => ce(fe.type, gt),
                onToggle: (gt) => ne(fe.type),
                onResetFlow: le[1] || (le[1] = (gt) => T.$emit("reset-flow"))
              }, It({
                "button-icon": be(() => [
                  T.$slots["clock-icon"] ? te(T.$slots, "clock-icon", { key: 0 }) : U("", !0),
                  T.$slots["clock-icon"] ? U("", !0) : (O(), Se(Js(T.timePickerInline ? C(cr) : C(_d)), { key: 1 }))
                ]),
                _: 2
              }, [
                T.$slots[`${fe.type}-overlay-value`] ? {
                  name: "item",
                  fn: be(({ item: gt }) => [
                    te(T.$slots, `${fe.type}-overlay-value`, {
                      text: gt.text,
                      value: gt.value
                    })
                  ]),
                  key: "0"
                } : void 0,
                T.$slots[`${fe.type}-overlay-header`] ? {
                  name: "header",
                  fn: be(() => [
                    te(T.$slots, `${fe.type}-overlay-header`, {
                      toggle: () => ne(fe.type)
                    })
                  ]),
                  key: "1"
                } : void 0
              ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : U("", !0)
            ];
          }),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), qA = ["data-dp-mobile"], UA = ["aria-label", "tabindex"], XA = ["role", "aria-label", "tabindex"], GA = ["aria-label"], ev = /* @__PURE__ */ Rt({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...Tn
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: n }) {
    const i = n, s = t, { buildMatrix: r, setTimePicker: a } = Ii(), o = cs(), { defaultedTransitions: l, defaultedAriaLabels: u, defaultedTextInput: c, defaultedConfig: d, defaultedRange: f } = lt(s), { transitionName: h, showTransition: m } = ma(l), { hideNavigationButtons: p } = Yo(), g = ee(null), y = ee(null), v = ee([]), b = ee(null), _ = ee(!1);
    _t(() => {
      i("mount"), !s.timePicker && s.arrowNavigation ? r([Mt(g.value)], "time") : a(!0, s.timePicker);
    });
    const M = Z(() => f.value.enabled && s.modelAuto ? Fy(s.internalModelValue) : !0), A = ee(!1), E = (L) => ({
      hours: Array.isArray(s.hours) ? s.hours[L] : s.hours,
      minutes: Array.isArray(s.minutes) ? s.minutes[L] : s.minutes,
      seconds: Array.isArray(s.seconds) ? s.seconds[L] : s.seconds
    }), I = Z(() => {
      const L = [];
      if (f.value.enabled)
        for (let z = 0; z < 2; z++)
          L.push(E(z));
      else
        L.push(E(0));
      return L;
    }), S = (L, z = !1, W = "") => {
      z || i("reset-flow"), A.value = L, i(L ? "overlay-opened" : "overlay-closed", Bt.time), s.arrowNavigation && a(L), Gt(() => {
        W !== "" && v.value[0] && v.value[0].openChildCmp(W);
      });
    }, $ = Z(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: s.autoApply && !d.value.keepActionRow
    })), B = rn(o, "timePicker"), V = (L, z, W) => f.value.enabled ? z === 0 ? [L, I.value[1][W]] : [I.value[0][W], L] : L, G = (L) => {
      i("update:hours", L);
    }, P = (L) => {
      i("update:minutes", L);
    }, x = (L) => {
      i("update:seconds", L);
    }, k = () => {
      if (b.value && !c.value.enabled && !s.noOverlayFocus) {
        const L = Vy(b.value);
        L && L.focus({ preventScroll: !0 });
      }
    }, D = (L) => {
      _.value = !1, i("overlay-closed", L);
    }, N = (L) => {
      _.value = !0, i("overlay-opened", L);
    };
    return e({ toggleTimePicker: S }), (L, z) => {
      var W;
      return O(), R("div", {
        class: "dp--tp-wrap",
        "data-dp-mobile": L.isMobile
      }, [
        !L.timePicker && !L.timePickerInline ? Tt((O(), R("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: g,
          type: "button",
          class: me({ ...$.value, "dp--hidden-el": A.value }),
          "aria-label": (W = C(u)) == null ? void 0 : W.openTimePicker,
          tabindex: L.noOverlayFocus ? void 0 : 0,
          "data-test-id": "open-time-picker-btn",
          onKeydown: z[0] || (z[0] = (ae) => C(Ut)(ae, () => S(!0))),
          onClick: z[1] || (z[1] = (ae) => S(!0))
        }, [
          L.$slots["clock-icon"] ? te(L.$slots, "clock-icon", { key: 0 }) : U("", !0),
          L.$slots["clock-icon"] ? U("", !0) : (O(), Se(C(_d), { key: 1 }))
        ], 42, UA)), [
          [sn, !C(p)(L.hideNavigation, "time")]
        ]) : U("", !0),
        Ce(Bn, {
          name: C(h)(A.value),
          css: C(m) && !L.timePickerInline
        }, {
          default: be(() => {
            var ae, F;
            return [
              A.value || L.timePicker || L.timePickerInline ? (O(), R("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: b,
                role: L.timePickerInline ? void 0 : "dialog",
                class: me({
                  dp__overlay: !L.timePickerInline,
                  "dp--overlay-absolute": !s.timePicker && !L.timePickerInline,
                  "dp--overlay-relative": s.timePicker
                }),
                style: tt(L.timePicker ? { height: `${C(d).modeHeight}px` } : void 0),
                "aria-label": (ae = C(u)) == null ? void 0 : ae.timePicker,
                tabindex: L.timePickerInline ? void 0 : 0
              }, [
                J("div", {
                  class: me(
                    L.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  L.$slots["time-picker-overlay"] ? te(L.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: t.hours,
                    minutes: t.minutes,
                    seconds: t.seconds,
                    setHours: G,
                    setMinutes: P,
                    setSeconds: x
                  }) : U("", !0),
                  L.$slots["time-picker-overlay"] ? U("", !0) : (O(), R("div", {
                    key: 1,
                    class: me(L.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (O(!0), R(ye, null, Te(I.value, (H, Q) => Tt((O(), Se(jA, bt({
                      key: Q,
                      ref_for: !0
                    }, {
                      ...L.$props,
                      order: Q,
                      hours: H.hours,
                      minutes: H.minutes,
                      seconds: H.seconds,
                      closeTimePickerBtn: y.value,
                      disabledTimesConfig: t.disabledTimesConfig,
                      disabled: Q === 0 ? C(f).fixedStart : C(f).fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: v,
                      "validate-time": (ne, w) => t.validateTime(ne, V(w, Q, ne)),
                      "onUpdate:hours": (ne) => G(V(ne, Q, "hours")),
                      "onUpdate:minutes": (ne) => P(V(ne, Q, "minutes")),
                      "onUpdate:seconds": (ne) => x(V(ne, Q, "seconds")),
                      onMounted: k,
                      onOverlayClosed: D,
                      onOverlayOpened: N,
                      onAmPmChange: z[2] || (z[2] = (ne) => L.$emit("am-pm-change", ne))
                    }), It({ _: 2 }, [
                      Te(C(B), (ne, w) => ({
                        name: ne,
                        fn: be((Y) => [
                          te(L.$slots, ne, bt({ ref_for: !0 }, Y))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [sn, Q === 0 ? !0 : M.value]
                    ])), 128))
                  ], 2)),
                  !L.timePicker && !L.timePickerInline ? Tt((O(), R("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: y,
                    type: "button",
                    class: me({ ...$.value, "dp--hidden-el": _.value }),
                    "aria-label": (F = C(u)) == null ? void 0 : F.closeTimePicker,
                    tabindex: "0",
                    onKeydown: z[3] || (z[3] = (H) => C(Ut)(H, () => S(!1))),
                    onClick: z[4] || (z[4] = (H) => S(!1))
                  }, [
                    L.$slots["calendar-icon"] ? te(L.$slots, "calendar-icon", { key: 0 }) : U("", !0),
                    L.$slots["calendar-icon"] ? U("", !0) : (O(), Se(C(cr), { key: 1 }))
                  ], 42, GA)), [
                    [sn, !C(p)(L.hideNavigation, "time")]
                  ]) : U("", !0)
                ], 2)
              ], 14, XA)) : U("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 8, qA);
    };
  }
}), tv = (t, e, n, i) => {
  const { defaultedRange: s } = lt(t), r = (b, _) => Array.isArray(e[b]) ? e[b][_] : e[b], a = (b) => t.enableSeconds ? Array.isArray(e.seconds) ? e.seconds[b] : e.seconds : 0, o = (b, _) => b ? _ !== void 0 ? Di(b, r("hours", _), r("minutes", _), a(_)) : Di(b, e.hours, e.minutes, a()) : $y(se(), a(_)), l = (b, _) => {
    e[b] = _;
  }, u = Z(() => t.modelAuto && s.value.enabled ? Array.isArray(n.value) ? n.value.length > 1 : !1 : s.value.enabled), c = (b, _) => {
    const M = Object.fromEntries(
      Object.keys(e).map((A) => A === b ? [A, _] : [A, e[A]].slice())
    );
    if (u.value && !s.value.disableTimeRangeValidation) {
      const A = (I) => n.value ? Di(
        n.value[I],
        M.hours[I],
        M.minutes[I],
        M.seconds[I]
      ) : null, E = (I) => Ey(n.value[I], 0);
      return !(Ve(A(0), A(1)) && (ls(A(0), E(1)) || Gs(A(1), E(0))));
    }
    return !0;
  }, d = (b, _) => {
    c(b, _) && (l(b, _), i && i());
  }, f = (b) => {
    d("hours", b);
  }, h = (b) => {
    d("minutes", b);
  }, m = (b) => {
    d("seconds", b);
  }, p = (b, _, M, A) => {
    _ && f(b), !_ && !M && h(b), M && m(b), n.value && A(n.value);
  }, g = (b) => {
    if (b) {
      const _ = Array.isArray(b), M = _ ? [+b[0].hours, +b[1].hours] : +b.hours, A = _ ? [+b[0].minutes, +b[1].minutes] : +b.minutes, E = _ ? [+b[0].seconds, +b[1].seconds] : +b.seconds;
      l("hours", M), l("minutes", A), t.enableSeconds && l("seconds", E);
    }
  }, y = (b, _) => {
    const M = {
      hours: Array.isArray(e.hours) ? e.hours[b] : e.hours,
      disabledArr: []
    };
    return (_ || _ === 0) && (M.hours = _), Array.isArray(t.disabledTimes) && (M.disabledArr = s.value.enabled && Array.isArray(t.disabledTimes[b]) ? t.disabledTimes[b] : t.disabledTimes), M;
  }, v = Z(() => (b, _) => {
    var M;
    if (Array.isArray(t.disabledTimes)) {
      const { disabledArr: A, hours: E } = y(b, _), I = A.filter((S) => +S.hours === E);
      return ((M = I[0]) == null ? void 0 : M.minutes) === "*" ? { hours: [E], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (I == null ? void 0 : I.map((S) => +S.minutes)) ?? [],
        seconds: (I == null ? void 0 : I.map((S) => S.seconds ? +S.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: l,
    updateHours: f,
    updateMinutes: h,
    updateSeconds: m,
    getSetDateTime: o,
    updateTimeValues: p,
    getSecondsValue: a,
    assignStartTime: g,
    validateTime: c,
    disabledTimesConfig: v
  };
}, ZA = (t, e) => {
  const n = () => {
    t.isTextInputDate && _();
  }, { modelValue: i, time: s } = pa(t, e, n), { defaultedStartTime: r, defaultedRange: a, defaultedTz: o } = lt(t), { updateTimeValues: l, getSetDateTime: u, setTime: c, assignStartTime: d, disabledTimesConfig: f, validateTime: h } = tv(t, s, i, m);
  function m() {
    e("update-flow-step");
  }
  const p = (A) => {
    const { hours: E, minutes: I, seconds: S } = A;
    return { hours: +E, minutes: +I, seconds: S ? +S : 0 };
  }, g = () => {
    if (t.startTime) {
      if (Array.isArray(t.startTime)) {
        const E = p(t.startTime[0]), I = p(t.startTime[1]);
        return [Je(se(), E), Je(se(), I)];
      }
      const A = p(t.startTime);
      return Je(se(), A);
    }
    return a.value.enabled ? [null, null] : null;
  }, y = () => {
    if (a.value.enabled) {
      const [A, E] = g();
      i.value = [
        Jt(u(A, 0), o.value.timezone),
        Jt(u(E, 1), o.value.timezone)
      ];
    } else
      i.value = Jt(u(g()), o.value.timezone);
  }, v = (A) => Array.isArray(A) ? [ts(se(A[0])), ts(se(A[1]))] : [ts(A ?? se())], b = (A, E, I) => {
    c("hours", A), c("minutes", E), c("seconds", t.enableSeconds ? I : 0);
  }, _ = () => {
    const [A, E] = v(i.value);
    return a.value.enabled ? b(
      [A.hours, E.hours],
      [A.minutes, E.minutes],
      [A.seconds, E.seconds]
    ) : b(A.hours, A.minutes, A.seconds);
  };
  _t(() => {
    if (!t.shadow)
      return d(r.value), i.value ? _() : y();
  });
  const M = () => {
    Array.isArray(i.value) ? i.value = i.value.map((A, E) => A && u(A, E)) : i.value = u(i.value), e("time-update");
  };
  return {
    modelValue: i,
    time: s,
    disabledTimesConfig: f,
    updateTime: (A, E = !0, I = !1) => {
      l(A, E, I, M);
    },
    validateTime: h
  };
}, KA = /* @__PURE__ */ Rt({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...Tn
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const i = n, s = t, r = cs(), a = rn(r, "timePicker"), o = ee(null), { time: l, modelValue: u, disabledTimesConfig: c, updateTime: d, validateTime: f } = ZA(s, i);
    return _t(() => {
      s.shadow || i("mount", null);
    }), e({ getSidebarProps: () => ({
      modelValue: u,
      time: l,
      updateTime: d
    }), toggleTimePicker: (h, m = !1, p = "") => {
      var g;
      (g = o.value) == null || g.toggleTimePicker(h, m, p);
    } }), (h, m) => (O(), Se(Wo, {
      "multi-calendars": 0,
      stretch: "",
      "is-mobile": h.isMobile
    }, {
      default: be(() => [
        Ce(ev, bt({
          ref_key: "tpRef",
          ref: o
        }, h.$props, {
          hours: C(l).hours,
          minutes: C(l).minutes,
          seconds: C(l).seconds,
          "internal-model-value": h.internalModelValue,
          "disabled-times-config": C(c),
          "validate-time": C(f),
          "onUpdate:hours": m[0] || (m[0] = (p) => C(d)(p)),
          "onUpdate:minutes": m[1] || (m[1] = (p) => C(d)(p, !1)),
          "onUpdate:seconds": m[2] || (m[2] = (p) => C(d)(p, !1, !0)),
          onAmPmChange: m[3] || (m[3] = (p) => h.$emit("am-pm-change", p)),
          onResetFlow: m[4] || (m[4] = (p) => h.$emit("reset-flow")),
          onOverlayClosed: m[5] || (m[5] = (p) => h.$emit("overlay-toggle", { open: !1, overlay: p })),
          onOverlayOpened: m[6] || (m[6] = (p) => h.$emit("overlay-toggle", { open: !0, overlay: p }))
        }), It({ _: 2 }, [
          Te(C(a), (p, g) => ({
            name: p,
            fn: be((y) => [
              te(h.$slots, p, Pt(jt(y)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }, 8, ["is-mobile"]));
  }
}), QA = { class: "dp--header-wrap" }, JA = {
  key: 0,
  class: "dp__month_year_wrap"
}, e5 = { key: 0 }, t5 = { class: "dp__month_year_wrap" }, n5 = ["data-dp-element", "aria-label", "data-test-id", "onClick", "onKeydown"], i5 = /* @__PURE__ */ Rt({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...Tn
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(t, { expose: e, emit: n }) {
    const i = n, s = t, {
      defaultedTransitions: r,
      defaultedAriaLabels: a,
      defaultedMultiCalendars: o,
      defaultedFilters: l,
      defaultedConfig: u,
      defaultedHighlight: c,
      propDates: d,
      defaultedUI: f
    } = lt(s), { transitionName: h, showTransition: m } = ma(r), { buildMatrix: p } = Ii(), { handleMonthYearChange: g, isDisabled: y, updateMonthYear: v } = kA(s, i), { showLeftIcon: b, showRightIcon: _ } = Yo(), M = ee(!1), A = ee(!1), E = ee(!1), I = ee([null, null, null, null]);
    _t(() => {
      i("mount");
    });
    const S = (F) => ({
      get: () => s[F],
      set: (H) => {
        const Q = F === vn.month ? vn.year : vn.month;
        i("update-month-year", { [F]: H, [Q]: s[Q] }), F === vn.month ? D(!0) : N(!0);
      }
    }), $ = Z(S(vn.month)), B = Z(S(vn.year)), V = Z(() => (F) => ({
      month: s.month,
      year: s.year,
      items: F === vn.month ? s.months : s.years,
      instance: s.instance,
      updateMonthYear: v,
      toggle: F === vn.month ? D : N
    })), G = Z(() => s.months.find((H) => H.value === s.month) || { text: "", value: 0 }), P = Z(() => Ks(s.months, (F) => {
      const H = s.month === F.value, Q = Gr(
        F.value,
        Wy(s.year, d.value.minDate),
        Hy(s.year, d.value.maxDate)
      ) || l.value.months.includes(F.value), ne = Xy(c.value, F.value, s.year);
      return { active: H, disabled: Q, highlighted: ne };
    })), x = Z(() => Ks(s.years, (F) => {
      const H = s.year === F.value, Q = Gr(
        F.value,
        Qs(d.value.minDate),
        Qs(d.value.maxDate)
      ) || l.value.years.includes(F.value), ne = Pd(c.value, F.value);
      return { active: H, disabled: Q, highlighted: ne };
    })), k = (F, H, Q) => {
      Q !== void 0 ? F.value = Q : F.value = !F.value, F.value ? (E.value = !0, i("overlay-opened", H)) : (E.value = !1, i("overlay-closed", H));
    }, D = (F = !1, H) => {
      L(F), k(M, Bt.month, H);
    }, N = (F = !1, H) => {
      L(F), k(A, Bt.year, H);
    }, L = (F) => {
      F || i("reset-flow");
    }, z = (F, H) => {
      s.arrowNavigation && (I.value[H] = Mt(F), p(I.value, "monthYear"));
    }, W = Z(() => {
      var F, H, Q, ne, w, Y;
      return [
        {
          type: vn.month,
          index: 1,
          toggle: D,
          modelValue: $.value,
          updateModelValue: (ue) => $.value = ue,
          text: G.value.text,
          showSelectionGrid: M.value,
          items: P.value,
          ariaLabel: (F = a.value) == null ? void 0 : F.openMonthsOverlay,
          overlayLabel: ((Q = (H = a.value).monthPicker) == null ? void 0 : Q.call(H, !0)) ?? void 0
        },
        {
          type: vn.year,
          index: 2,
          toggle: N,
          modelValue: B.value,
          updateModelValue: (ue) => B.value = ue,
          text: Ny(s.year, s.locale),
          showSelectionGrid: A.value,
          items: x.value,
          ariaLabel: (ne = a.value) == null ? void 0 : ne.openYearsOverlay,
          overlayLabel: ((Y = (w = a.value).yearPicker) == null ? void 0 : Y.call(w, !0)) ?? void 0
        }
      ];
    }), ae = Z(() => s.disableYearSelect ? [W.value[0]] : s.yearFirst ? [...W.value].reverse() : W.value);
    return e({
      toggleMonthPicker: D,
      toggleYearPicker: N,
      handleMonthYearChange: g
    }), (F, H) => {
      var Q, ne, w, Y, ue, ze;
      return O(), R("div", QA, [
        F.$slots["month-year"] ? (O(), R("div", JA, [
          te(F.$slots, "month-year", Pt(jt({
            month: t.month,
            year: t.year,
            months: t.months,
            years: t.years,
            updateMonthYear: C(v),
            handleMonthYearChange: C(g),
            instance: t.instance,
            isDisabled: C(y)
          })))
        ])) : (O(), R(ye, { key: 1 }, [
          F.$slots["top-extra"] ? (O(), R("div", e5, [
            te(F.$slots, "top-extra", { value: F.internalModelValue })
          ])) : U("", !0),
          J("div", t5, [
            C(b)(C(o), t.instance) && !F.vertical ? (O(), Se(Vr, {
              key: 0,
              "aria-label": (Q = C(a)) == null ? void 0 : Q.prevMonth,
              disabled: C(y)(!1),
              class: me((ne = C(f)) == null ? void 0 : ne.navBtnPrev),
              "el-name": "action-prev",
              onActivate: H[0] || (H[0] = (K) => C(g)(!1, !0)),
              onSetRef: H[1] || (H[1] = (K) => z(K, 0))
            }, {
              default: be(() => [
                F.$slots["arrow-left"] ? te(F.$slots, "arrow-left", { key: 0 }) : U("", !0),
                F.$slots["arrow-left"] ? U("", !0) : (O(), Se(C(wd), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : U("", !0),
            J("div", {
              class: me(["dp__month_year_wrap", {
                dp__year_disable_select: F.disableYearSelect
              }])
            }, [
              (O(!0), R(ye, null, Te(ae.value, (K, Ee) => (O(), R(ye, {
                key: K.type
              }, [
                J("button", {
                  ref_for: !0,
                  ref: (re) => z(re, Ee + 1),
                  type: "button",
                  "data-dp-element": `overlay-${K.type}`,
                  class: me(["dp__btn dp__month_year_select", { "dp--hidden-el": E.value }]),
                  "aria-label": `${K.text}-${K.ariaLabel}`,
                  "data-test-id": `${K.type}-toggle-overlay-${t.instance}`,
                  onClick: K.toggle,
                  onKeydown: (re) => C(Ut)(re, () => K.toggle(), !0)
                }, [
                  F.$slots[K.type] ? te(F.$slots, K.type, {
                    key: 0,
                    text: K.text,
                    value: s[K.type]
                  }) : U("", !0),
                  F.$slots[K.type] ? U("", !0) : (O(), R(ye, { key: 1 }, [
                    He(ve(K.text), 1)
                  ], 64))
                ], 42, n5),
                Ce(Bn, {
                  name: C(h)(K.showSelectionGrid),
                  css: C(m)
                }, {
                  default: be(() => [
                    K.showSelectionGrid ? (O(), Se(ha, {
                      key: 0,
                      items: K.items,
                      "arrow-navigation": F.arrowNavigation,
                      "hide-navigation": F.hideNavigation,
                      "is-last": F.autoApply && !C(u).keepActionRow,
                      "skip-button-ref": !1,
                      config: F.config,
                      type: K.type,
                      "header-refs": [],
                      "esc-close": F.escClose,
                      "menu-wrap-ref": F.menuWrapRef,
                      "text-input": F.textInput,
                      "aria-labels": F.ariaLabels,
                      "overlay-label": K.overlayLabel,
                      onSelected: K.updateModelValue,
                      onToggle: K.toggle
                    }, It({
                      "button-icon": be(() => [
                        F.$slots["calendar-icon"] ? te(F.$slots, "calendar-icon", { key: 0 }) : U("", !0),
                        F.$slots["calendar-icon"] ? U("", !0) : (O(), Se(C(cr), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      F.$slots[`${K.type}-overlay-value`] ? {
                        name: "item",
                        fn: be(({ item: re }) => [
                          te(F.$slots, `${K.type}-overlay-value`, {
                            text: re.text,
                            value: re.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      F.$slots[`${K.type}-overlay`] ? {
                        name: "overlay",
                        fn: be(() => [
                          te(F.$slots, `${K.type}-overlay`, bt({ ref_for: !0 }, V.value(K.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      F.$slots[`${K.type}-overlay-header`] ? {
                        name: "header",
                        fn: be(() => [
                          te(F.$slots, `${K.type}-overlay-header`, {
                            toggle: K.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : U("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            C(b)(C(o), t.instance) && F.vertical ? (O(), Se(Vr, {
              key: 1,
              "aria-label": (w = C(a)) == null ? void 0 : w.prevMonth,
              "el-name": "action-prev",
              disabled: C(y)(!1),
              class: me((Y = C(f)) == null ? void 0 : Y.navBtnPrev),
              onActivate: H[2] || (H[2] = (K) => C(g)(!1, !0))
            }, {
              default: be(() => [
                F.$slots["arrow-up"] ? te(F.$slots, "arrow-up", { key: 0 }) : U("", !0),
                F.$slots["arrow-up"] ? U("", !0) : (O(), Se(C(kd), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : U("", !0),
            C(_)(C(o), t.instance) ? (O(), Se(Vr, {
              key: 2,
              ref: "rightIcon",
              "el-name": "action-next",
              disabled: C(y)(!0),
              "aria-label": (ue = C(a)) == null ? void 0 : ue.nextMonth,
              class: me((ze = C(f)) == null ? void 0 : ze.navBtnNext),
              onActivate: H[3] || (H[3] = (K) => C(g)(!0, !0)),
              onSetRef: H[4] || (H[4] = (K) => z(K, F.disableYearSelect ? 2 : 3))
            }, {
              default: be(() => [
                F.$slots[F.vertical ? "arrow-down" : "arrow-right"] ? te(F.$slots, F.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : U("", !0),
                F.$slots[F.vertical ? "arrow-down" : "arrow-right"] ? U("", !0) : (O(), Se(Js(F.vertical ? C(Md) : C(xd)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : U("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), s5 = {
  class: "dp__calendar_header",
  role: "row"
}, r5 = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, a5 = ["aria-label"], o5 = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, l5 = { class: "dp__cell_inner" }, u5 = ["id", "aria-pressed", "aria-disabled", "aria-label", "tabindex", "data-test-id", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], c5 = /* @__PURE__ */ Rt({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...Tn
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(t, { expose: e, emit: n }) {
    const i = n, s = t, { buildMultiLevelMatrix: r } = Ii(), {
      defaultedTransitions: a,
      defaultedConfig: o,
      defaultedAriaLabels: l,
      defaultedMultiCalendars: u,
      defaultedWeekNumbers: c,
      defaultedMultiDates: d,
      defaultedUI: f
    } = lt(s), h = ee(null), m = ee({
      bottom: "",
      left: "",
      transform: ""
    }), p = ee([]), g = ee(null), y = ee(!0), v = ee(""), b = ee({ startX: 0, endX: 0, startY: 0, endY: 0 }), _ = ee([]), M = ee({ left: "50%" }), A = ee(!1), E = Z(() => s.calendar ? s.calendar(s.mappedDates) : s.mappedDates), I = Z(() => s.dayNames ? Array.isArray(s.dayNames) ? s.dayNames : s.dayNames(s.locale, +s.weekStart) : HC(s.formatLocale, s.locale, +s.weekStart));
    _t(() => {
      i("mount", { cmp: "calendar", refs: p }), o.value.noSwipe || g.value && (g.value.addEventListener("touchstart", z, { passive: !1 }), g.value.addEventListener("touchend", W, { passive: !1 }), g.value.addEventListener("touchmove", ae, { passive: !1 })), s.monthChangeOnScroll && g.value && g.value.addEventListener("wheel", Q, { passive: !1 });
    }), us(() => {
      o.value.noSwipe || g.value && (g.value.removeEventListener("touchstart", z), g.value.removeEventListener("touchend", W), g.value.removeEventListener("touchmove", ae)), s.monthChangeOnScroll && g.value && g.value.removeEventListener("wheel", Q);
    });
    const S = (K) => K ? s.vertical ? "vNext" : "next" : s.vertical ? "vPrevious" : "previous", $ = (K, Ee) => {
      if (s.transitions) {
        const re = $t(Jn(se(), s.month, s.year));
        v.value = vt($t(Jn(se(), K, Ee)), re) ? a.value[S(!0)] : a.value[S(!1)], y.value = !1, Gt(() => {
          y.value = !0;
        });
      }
    }, B = Z(
      () => ({
        ...f.value.calendar ?? {}
      })
    ), V = Z(() => (K) => {
      const Ee = jC(K);
      return {
        dp__marker_dot: Ee.type === "dot",
        dp__marker_line: Ee.type === "line"
      };
    }), G = Z(() => (K) => Ve(K, h.value)), P = Z(() => ({
      dp__calendar: !0,
      dp__calendar_next: u.value.count > 0 && s.instance !== 0
    })), x = Z(() => (K) => s.hideOffsetDates ? K.current : !0), k = async (K, Ee) => {
      const { width: re, height: ce } = K.getBoundingClientRect();
      h.value = Ee.value;
      let T = { left: `${re / 2}px` }, le = -50;
      if (await Gt(), _.value[0]) {
        const { left: de, width: fe } = _.value[0].getBoundingClientRect();
        de < 0 && (T = { left: "0" }, le = 0, M.value.left = `${re / 2}px`), window.innerWidth < de + fe && (T = { right: "0" }, le = 0, M.value.left = `${fe - re / 2}px`);
      }
      m.value = {
        bottom: `${ce}px`,
        ...T,
        transform: `translateX(${le}%)`
      };
    }, D = async (K, Ee, re) => {
      var ce, T, le;
      const de = Mt(p.value[Ee][re]);
      de && ((ce = K.marker) != null && ce.customPosition && (le = (T = K.marker) == null ? void 0 : T.tooltip) != null && le.length ? m.value = K.marker.customPosition(de) : await k(de, K), i("tooltip-open", K.marker));
    }, N = async (K, Ee, re) => {
      var ce, T;
      if (A.value && d.value.enabled && d.value.dragSelect)
        return i("select-date", K);
      if (i("set-hover-date", K), (T = (ce = K.marker) == null ? void 0 : ce.tooltip) != null && T.length) {
        if (s.hideOffsetDates && !K.current) return;
        await D(K, Ee, re);
      }
    }, L = (K) => {
      h.value && (h.value = null, m.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), i("tooltip-close", K.marker));
    }, z = (K) => {
      b.value.startX = K.changedTouches[0].screenX, b.value.startY = K.changedTouches[0].screenY;
    }, W = (K) => {
      b.value.endX = K.changedTouches[0].screenX, b.value.endY = K.changedTouches[0].screenY, F();
    }, ae = (K) => {
      s.vertical && !s.inline && K.preventDefault();
    }, F = () => {
      const K = s.vertical ? "Y" : "X";
      Math.abs(b.value[`start${K}`] - b.value[`end${K}`]) > 10 && i("handle-swipe", b.value[`start${K}`] > b.value[`end${K}`] ? "right" : "left");
    }, H = (K, Ee, re) => {
      K && (Array.isArray(p.value[Ee]) ? p.value[Ee][re] = K : p.value[Ee] = [K]), s.arrowNavigation && r(p.value, "calendar");
    }, Q = (K) => {
      s.monthChangeOnScroll && (K.preventDefault(), i("handle-scroll", K));
    }, ne = (K) => c.value.type === "local" ? gd(K.value, { weekStartsOn: +s.weekStart }) : c.value.type === "iso" ? md(K.value) : typeof c.value.type == "function" ? c.value.type(K.value) : "", w = (K) => {
      const Ee = K[0];
      return c.value.hideOnOffsetDates ? K.some((re) => re.current) ? ne(Ee) : "" : ne(Ee);
    }, Y = (K, Ee, re = !0) => {
      !re && ZC() || (!d.value.enabled || o.value.allowPreventDefault) && (Oi(K, o.value), i("select-date", Ee));
    }, ue = (K) => {
      Oi(K, o.value);
    }, ze = (K) => {
      d.value.enabled && d.value.dragSelect ? (A.value = !0, i("select-date", K)) : d.value.enabled && i("select-date", K);
    };
    return e({ triggerTransition: $ }), (K, Ee) => (O(), R("div", {
      class: me(P.value)
    }, [
      J("div", {
        ref_key: "calendarWrapRef",
        ref: g,
        class: me(B.value),
        role: "grid"
      }, [
        J("div", s5, [
          K.weekNumbers ? (O(), R("div", r5, ve(K.weekNumName), 1)) : U("", !0),
          (O(!0), R(ye, null, Te(I.value, (re, ce) => {
            var T, le;
            return O(), R("div", {
              key: ce,
              class: "dp__calendar_header_item",
              role: "gridcell",
              "data-test-id": "calendar-header",
              "aria-label": (le = (T = C(l)) == null ? void 0 : T.weekDay) == null ? void 0 : le.call(T, ce)
            }, [
              K.$slots["calendar-header"] ? te(K.$slots, "calendar-header", {
                key: 0,
                day: re,
                index: ce
              }) : U("", !0),
              K.$slots["calendar-header"] ? U("", !0) : (O(), R(ye, { key: 1 }, [
                He(ve(re), 1)
              ], 64))
            ], 8, a5);
          }), 128))
        ]),
        Ee[2] || (Ee[2] = J("div", { class: "dp__calendar_header_separator" }, null, -1)),
        Ce(Bn, {
          name: v.value,
          css: !!K.transitions
        }, {
          default: be(() => [
            y.value ? (O(), R("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: Ee[1] || (Ee[1] = (re) => A.value = !1)
            }, [
              (O(!0), R(ye, null, Te(E.value, (re, ce) => (O(), R("div", {
                key: ce,
                class: "dp__calendar_row",
                role: "row"
              }, [
                K.weekNumbers ? (O(), R("div", o5, [
                  J("div", l5, ve(w(re.days)), 1)
                ])) : U("", !0),
                (O(!0), R(ye, null, Te(re.days, (T, le) => {
                  var de, fe, Le;
                  return O(), R("div", {
                    id: C(vc)(T.value),
                    ref_for: !0,
                    ref: ($e) => H($e, ce, le),
                    key: le + ce,
                    role: "gridcell",
                    class: "dp__calendar_item",
                    "aria-pressed": (T.classData.dp__active_date || T.classData.dp__range_start || T.classData.dp__range_start) ?? void 0,
                    "aria-disabled": T.classData.dp__cell_disabled || void 0,
                    "aria-label": (fe = (de = C(l)) == null ? void 0 : de.day) == null ? void 0 : fe.call(de, T),
                    tabindex: !T.current && K.hideOffsetDates ? void 0 : 0,
                    "data-test-id": C(vc)(T.value),
                    onClick: et(($e) => Y($e, T), ["prevent"]),
                    onTouchend: ($e) => Y($e, T, !1),
                    onKeydown: ($e) => C(Ut)($e, () => K.$emit("select-date", T)),
                    onMouseenter: ($e) => N(T, ce, le),
                    onMouseleave: ($e) => L(T),
                    onMousedown: ($e) => ze(T),
                    onMouseup: Ee[0] || (Ee[0] = ($e) => A.value = !1)
                  }, [
                    J("div", {
                      class: me(["dp__cell_inner", T.classData])
                    }, [
                      K.$slots.day && x.value(T) ? te(K.$slots, "day", {
                        key: 0,
                        day: +T.text,
                        date: T.value
                      }) : U("", !0),
                      K.$slots.day ? U("", !0) : (O(), R(ye, { key: 1 }, [
                        He(ve(T.text), 1)
                      ], 64)),
                      T.marker && x.value(T) ? (O(), R(ye, { key: 2 }, [
                        K.$slots.marker ? te(K.$slots, "marker", {
                          key: 0,
                          marker: T.marker,
                          day: +T.text,
                          date: T.value
                        }) : (O(), R("div", {
                          key: 1,
                          class: me(V.value(T.marker)),
                          style: tt(T.marker.color ? { backgroundColor: T.marker.color } : {})
                        }, null, 6))
                      ], 64)) : U("", !0),
                      G.value(T.value) ? (O(), R("div", {
                        key: 3,
                        ref_for: !0,
                        ref_key: "activeTooltip",
                        ref: _,
                        class: "dp__marker_tooltip",
                        style: tt(m.value)
                      }, [
                        (Le = T.marker) != null && Le.tooltip ? (O(), R("div", {
                          key: 0,
                          class: "dp__tooltip_content",
                          onClick: ue
                        }, [
                          (O(!0), R(ye, null, Te(T.marker.tooltip, ($e, Xe) => (O(), R("div", {
                            key: Xe,
                            class: "dp__tooltip_text"
                          }, [
                            K.$slots["marker-tooltip"] ? te(K.$slots, "marker-tooltip", {
                              key: 0,
                              tooltip: $e,
                              day: T.value
                            }) : U("", !0),
                            K.$slots["marker-tooltip"] ? U("", !0) : (O(), R(ye, { key: 1 }, [
                              J("div", {
                                class: "dp__tooltip_mark",
                                style: tt($e.color ? { backgroundColor: $e.color } : {})
                              }, null, 4),
                              J("div", null, ve($e.text), 1)
                            ], 64))
                          ]))), 128)),
                          J("div", {
                            class: "dp__arrow_bottom_tp",
                            style: tt(M.value)
                          }, null, 4)
                        ])) : U("", !0)
                      ], 4)) : U("", !0)
                    ], 2)
                  ], 40, u5);
                }), 128))
              ]))), 128))
            ], 32)) : U("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), up = (t) => Array.isArray(t), d5 = (t, e, n, i) => {
  const s = ee([]), r = ee(/* @__PURE__ */ new Date()), a = ee(), o = () => W(t.isTextInputDate), { modelValue: l, calendars: u, time: c, today: d } = pa(t, e, o), {
    defaultedMultiCalendars: f,
    defaultedStartTime: h,
    defaultedRange: m,
    defaultedConfig: p,
    defaultedTz: g,
    propDates: y,
    defaultedMultiDates: v
  } = lt(t), { validateMonthYearInRange: b, isDisabled: _, isDateRangeAllowed: M, checkMinMaxRange: A } = Fi(t), { updateTimeValues: E, getSetDateTime: I, setTime: S, assignStartTime: $, validateTime: B, disabledTimesConfig: V } = tv(t, c, l, i), G = Z(
    () => (q) => u.value[q] ? u.value[q].month : 0
  ), P = Z(
    () => (q) => u.value[q] ? u.value[q].year : 0
  ), x = (q) => !p.value.keepViewOnOffsetClick || q ? !0 : !a.value, k = (q, oe, Me, Re = !1) => {
    var ie, ge;
    x(Re) && (u.value[q] || (u.value[q] = { month: 0, year: 0 }), u.value[q].month = ip(oe) ? (ie = u.value[q]) == null ? void 0 : ie.month : oe, u.value[q].year = ip(Me) ? (ge = u.value[q]) == null ? void 0 : ge.year : Me);
  }, D = () => {
    t.autoApply && e("select-date");
  }, N = () => {
    h.value && $(h.value);
  };
  _t(() => {
    t.shadow || (l.value || (Ee(), N()), W(!0), t.focusStartDate && t.startDate && Ee());
  });
  const L = Z(() => {
    var q;
    return (q = t.flow) != null && q.length && !t.partialFlow ? t.flowStep === t.flow.length : !0;
  }), z = () => {
    t.autoApply && L.value && e("auto-apply", t.partialFlow ? t.flowStep !== t.flow.length : !1);
  }, W = (q = !1) => {
    if (l.value)
      return Array.isArray(l.value) ? (s.value = l.value, Y(q)) : H(l.value, q);
    if (f.value.count && q && !t.startDate)
      return F(se(), q);
  }, ae = () => Array.isArray(l.value) && m.value.enabled ? Fe(l.value[0]) === Fe(l.value[1] ?? l.value[0]) : !1, F = (q = /* @__PURE__ */ new Date(), oe = !1) => {
    if ((!f.value.count || !f.value.static || oe) && k(0, Fe(q), Oe(q)), f.value.count && (!l.value || ae() || !f.value.solo) && (!f.value.solo || oe))
      for (let Me = 1; Me < f.value.count; Me++) {
        const Re = Je(se(), { month: G.value(Me - 1), year: P.value(Me - 1) }), ie = Ps(Re, { months: 1 });
        u.value[Me] = { month: Fe(ie), year: Oe(ie) };
      }
  }, H = (q, oe) => {
    F(q), S("hours", ni(q)), S("minutes", Ri(q)), S("seconds", Xs(q)), f.value.count && oe && K();
  }, Q = (q) => {
    if (f.value.count) {
      if (f.value.solo) return 0;
      const oe = Fe(q[0]), Me = Fe(q[1]);
      return Math.abs(Me - oe) < f.value.count ? 0 : 1;
    }
    return 1;
  }, ne = (q, oe) => {
    q[1] && m.value.showLastInRange ? F(q[Q(q)], oe) : F(q[0], oe);
    const Me = (Re, ie) => [
      Re(q[0]),
      q[1] ? Re(q[1]) : c[ie][1]
    ];
    S("hours", Me(ni, "hours")), S("minutes", Me(Ri, "minutes")), S("seconds", Me(Xs, "seconds"));
  }, w = (q, oe) => {
    if ((m.value.enabled || t.weekPicker) && !v.value.enabled)
      return ne(q, oe);
    if (v.value.enabled && oe) {
      const Me = q[q.length - 1];
      return H(Me, oe);
    }
  }, Y = (q) => {
    const oe = l.value;
    w(oe, q), f.value.count && f.value.solo && K();
  }, ue = (q, oe) => {
    const Me = Je(se(), { month: G.value(oe), year: P.value(oe) }), Re = q < 0 ? kn(Me, 1) : Zs(Me, 1);
    b(Fe(Re), Oe(Re), q < 0, t.preventMinMaxNavigation) && (k(oe, Fe(Re), Oe(Re)), e("update-month-year", { instance: oe, month: Fe(Re), year: Oe(Re) }), f.value.count && !f.value.solo && ze(oe), n());
  }, ze = (q) => {
    for (let oe = q - 1; oe >= 0; oe--) {
      const Me = Zs(Je(se(), { month: G.value(oe + 1), year: P.value(oe + 1) }), 1);
      k(oe, Fe(Me), Oe(Me));
    }
    for (let oe = q + 1; oe <= f.value.count - 1; oe++) {
      const Me = kn(Je(se(), { month: G.value(oe - 1), year: P.value(oe - 1) }), 1);
      k(oe, Fe(Me), Oe(Me));
    }
  }, K = () => {
    if (Array.isArray(l.value) && l.value.length === 2) {
      const q = se(
        se(l.value[1] ? l.value[1] : kn(l.value[0], 1))
      ), [oe, Me] = [Fe(l.value[0]), Oe(l.value[0])], [Re, ie] = [Fe(l.value[1]), Oe(l.value[1])];
      (oe !== Re || oe === Re && Me !== ie) && f.value.solo && k(1, Fe(q), Oe(q));
    } else l.value && !Array.isArray(l.value) && (k(0, Fe(l.value), Oe(l.value)), F(se()));
  }, Ee = () => {
    t.startDate && (k(0, Fe(se(t.startDate)), Oe(se(t.startDate))), f.value.count && ze(0));
  }, re = (q, oe) => {
    if (t.monthChangeOnScroll) {
      const Me = (/* @__PURE__ */ new Date()).getTime() - r.value.getTime(), Re = Math.abs(q.deltaY);
      let ie = 500;
      Re > 1 && (ie = 100), Re > 100 && (ie = 0), Me > ie && (r.value = /* @__PURE__ */ new Date(), ue(t.monthChangeOnScroll !== "inverse" ? -q.deltaY : q.deltaY, oe));
    }
  }, ce = (q, oe, Me = !1) => {
    t.monthChangeOnArrows && t.vertical === Me && T(q, oe);
  }, T = (q, oe) => {
    ue(q === "right" ? -1 : 1, oe);
  }, le = (q) => {
    if (y.value.markers)
      return wo(q.value, y.value.markers);
  }, de = (q, oe) => {
    switch (t.sixWeeks === !0 ? "append" : t.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [q == 0, !0];
      case "fair":
        return [q == 0 || oe > q, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, fe = (q, oe, Me, Re) => {
    if (t.sixWeeks && q.length < 6) {
      const ie = 6 - q.length, ge = (oe.getDay() + 7 - Re) % 7, xe = 6 - (Me.getDay() + 7 - Re) % 7, [Yn, An] = de(ge, xe);
      for (let Vi = 1; Vi <= ie; Vi++)
        if (An ? !!(Vi % 2) == Yn : Yn) {
          const si = q[0].days[0], Ko = Le(fn(si.value, -7), Fe(oe));
          q.unshift({ days: Ko });
        } else {
          const si = q[q.length - 1], Ko = si.days[si.days.length - 1], sv = Le(fn(Ko.value, 1), Fe(oe));
          q.push({ days: sv });
        }
    }
    return q;
  }, Le = (q, oe) => {
    const Me = se(q), Re = [];
    for (let ie = 0; ie < 7; ie++) {
      const ge = fn(Me, ie), xe = Fe(ge) !== oe;
      Re.push({
        text: t.hideOffsetDates && xe ? "" : ge.getDate(),
        value: ge,
        current: !xe,
        classData: {}
      });
    }
    return Re;
  }, $e = (q, oe) => {
    const Me = [], Re = new Date(oe, q), ie = new Date(oe, q + 1, 0), ge = t.weekStart, xe = Dn(Re, { weekStartsOn: ge }), Yn = (An) => {
      const Vi = Le(An, q);
      if (Me.push({ days: Vi }), !Me[Me.length - 1].days.some(
        (si) => Ve($t(si.value), $t(ie))
      )) {
        const si = fn(An, 7);
        Yn(si);
      }
    };
    return Yn(xe), fe(Me, Re, ie, ge);
  }, Xe = (q) => {
    const oe = Di(se(q.value), c.hours, c.minutes, we());
    e("date-update", oe), v.value.enabled ? Cd(oe, l, v.value.limit) : l.value = oe, i(), Gt().then(() => {
      z();
    });
  }, gt = (q) => m.value.noDisabledRange ? Yy(s.value[0], q).some((oe) => _(oe)) : !1, j = () => {
    s.value = l.value ? l.value.slice() : [], s.value.length === 2 && !(m.value.fixedStart || m.value.fixedEnd) && (s.value = []);
  }, he = (q, oe) => {
    const Me = [
      se(q.value),
      fn(se(q.value), +m.value.autoRange)
    ];
    M(Me) ? (oe && We(q.value), s.value = Me) : e("invalid-date", q.value);
  }, We = (q) => {
    const oe = Fe(se(q)), Me = Oe(se(q));
    if (k(0, oe, Me), f.value.count > 0)
      for (let Re = 1; Re < f.value.count; Re++) {
        const ie = JC(
          Je(se(q), { year: P.value(Re - 1), month: G.value(Re - 1) })
        );
        k(Re, ie.month, ie.year);
      }
  }, Dt = (q) => {
    if (gt(q.value) || !A(q.value, l.value, m.value.fixedStart ? 0 : 1))
      return e("invalid-date", q.value);
    s.value = Qy(se(q.value), l, e, m);
  }, Pn = (q, oe) => {
    if (j(), m.value.autoRange) return he(q, oe);
    if (m.value.fixedStart || m.value.fixedEnd) return Dt(q);
    s.value[0] ? A(se(q.value), l.value) && !gt(q.value) ? ht(se(q.value), se(s.value[0])) ? (s.value.unshift(se(q.value)), e("range-end", s.value[0])) : (s.value[1] = se(q.value), e("range-end", s.value[1])) : (t.autoApply && e("auto-apply-invalid", q.value), e("invalid-date", q.value)) : (s.value[0] = se(q.value), e("range-start", s.value[0]));
  }, we = (q = !0) => t.enableSeconds ? Array.isArray(c.seconds) ? q ? c.seconds[0] : c.seconds[1] : c.seconds : 0, Ct = (q) => {
    s.value[q] = Di(
      s.value[q],
      c.hours[q],
      c.minutes[q],
      we(q !== 1)
    );
  }, Cn = () => {
    var q, oe;
    s.value[0] && s.value[1] && +((q = s.value) == null ? void 0 : q[0]) > +((oe = s.value) == null ? void 0 : oe[1]) && (s.value.reverse(), e("range-start", s.value[0]), e("range-end", s.value[1]));
  }, jo = () => {
    s.value.length && (s.value[0] && !s.value[1] ? Ct(0) : (Ct(0), Ct(1), i()), Cn(), l.value = s.value.slice(), Ho(s.value, e, t.autoApply, t.modelAuto));
  }, ga = (q, oe = !1) => {
    if (_(q.value) || !q.current && t.hideOffsetDates) return e("invalid-date", q.value);
    if (a.value = JSON.parse(JSON.stringify(q)), !m.value.enabled) return Xe(q);
    up(c.hours) && up(c.minutes) && !v.value.enabled && (Pn(q, oe), jo());
  }, qo = (q, oe) => {
    var Me;
    k(q, oe.month, oe.year, !0), f.value.count && !f.value.solo && ze(q), e("update-month-year", { instance: q, month: oe.month, year: oe.year }), n(f.value.solo ? q : void 0);
    const Re = (Me = t.flow) != null && Me.length ? t.flow[t.flowStep] : void 0;
    !oe.fromNav && (Re === Bt.month || Re === Bt.year) && i();
  }, Uo = (q, oe) => {
    Ky({
      value: q,
      modelValue: l,
      range: m.value.enabled,
      timezone: oe ? void 0 : g.value.timezone
    }), D(), t.multiCalendars && Gt().then(() => W(!0));
  }, Xo = () => {
    const q = Sd(se(), g.value);
    !m.value.enabled && !v.value.enabled ? l.value = q : l.value && Array.isArray(l.value) && l.value[0] ? v.value.enabled ? l.value = [...l.value, q] : l.value = ht(q, l.value[0]) ? [q, l.value[0]] : [l.value[0], q] : l.value = [q], D();
  }, Go = () => {
    if (Array.isArray(l.value))
      if (v.value.enabled) {
        const q = Zo();
        l.value[l.value.length - 1] = I(q);
      } else
        l.value = l.value.map((q, oe) => q && I(q, oe));
    else
      l.value = I(l.value);
    e("time-update");
  }, Zo = () => Array.isArray(l.value) && l.value.length ? l.value[l.value.length - 1] : null;
  return {
    calendars: u,
    modelValue: l,
    month: G,
    year: P,
    time: c,
    disabledTimesConfig: V,
    today: d,
    validateTime: B,
    getCalendarDays: $e,
    getMarker: le,
    handleScroll: re,
    handleSwipe: T,
    handleArrow: ce,
    selectDate: ga,
    updateMonthYear: qo,
    presetDate: Uo,
    selectCurrentDate: Xo,
    updateTime: (q, oe = !0, Me = !1) => {
      E(q, oe, Me, Go);
    },
    assignMonthAndYear: F,
    setStartTime: N
  };
}, f5 = { key: 0 }, h5 = /* @__PURE__ */ Rt({
  __name: "DatePicker",
  props: {
    ...Tn
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const i = n, s = t, {
      calendars: r,
      month: a,
      year: o,
      modelValue: l,
      time: u,
      disabledTimesConfig: c,
      today: d,
      validateTime: f,
      getCalendarDays: h,
      getMarker: m,
      handleArrow: p,
      handleScroll: g,
      handleSwipe: y,
      selectDate: v,
      updateMonthYear: b,
      presetDate: _,
      selectCurrentDate: M,
      updateTime: A,
      assignMonthAndYear: E,
      setStartTime: I
    } = d5(s, i, ae, F), S = cs(), { setHoverDate: $, getDayClassData: B, clearHoverDate: V } = C5(l, s), { defaultedMultiCalendars: G } = lt(s), P = ee([]), x = ee([]), k = ee(null), D = rn(S, "calendar"), N = rn(S, "monthYear"), L = rn(S, "timePicker"), z = (re) => {
      s.shadow || i("mount", re);
    };
    ct(
      r,
      () => {
        s.shadow || setTimeout(() => {
          i("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    ), ct(
      G,
      (re, ce) => {
        re.count - ce.count > 0 && E();
      },
      { deep: !0 }
    );
    const W = Z(() => (re) => h(a.value(re), o.value(re)).map((ce) => ({
      ...ce,
      days: ce.days.map((T) => (T.marker = m(T), T.classData = B(T), T))
    })));
    function ae(re) {
      var ce;
      re || re === 0 ? (ce = x.value[re]) == null || ce.triggerTransition(a.value(re), o.value(re)) : x.value.forEach((T, le) => T.triggerTransition(a.value(le), o.value(le)));
    }
    function F() {
      i("update-flow-step");
    }
    const H = (re, ce = !1) => {
      v(re, ce), s.spaceConfirm && i("select-date");
    }, Q = (re, ce, T = 0) => {
      var le;
      (le = P.value[T]) == null || le.toggleMonthPicker(re, ce);
    }, ne = (re, ce, T = 0) => {
      var le;
      (le = P.value[T]) == null || le.toggleYearPicker(re, ce);
    }, w = (re, ce, T) => {
      var le;
      (le = k.value) == null || le.toggleTimePicker(re, ce, T);
    }, Y = (re, ce) => {
      var T;
      if (!s.range) {
        const le = l.value ? l.value : d, de = ce ? new Date(ce) : le, fe = re ? Dn(de, { weekStartsOn: 1 }) : by(de, { weekStartsOn: 1 });
        v({
          value: fe,
          current: Fe(de) === a.value(0),
          text: "",
          classData: {}
        }), (T = document.getElementById(vc(fe))) == null || T.focus();
      }
    }, ue = (re) => {
      var ce;
      (ce = P.value[0]) == null || ce.handleMonthYearChange(re, !0);
    }, ze = (re) => {
      b(0, { month: a.value(0), year: o.value(0) + (re ? 1 : -1), fromNav: !0 });
    }, K = (re, ce) => {
      re === Bt.time && i(`time-picker-${ce ? "open" : "close"}`), i("overlay-toggle", { open: ce, overlay: re });
    }, Ee = (re) => {
      i("overlay-toggle", { open: !1, overlay: re }), i("focus-menu");
    };
    return e({
      clearHoverDate: V,
      presetDate: _,
      selectCurrentDate: M,
      toggleMonthPicker: Q,
      toggleYearPicker: ne,
      toggleTimePicker: w,
      handleArrow: p,
      updateMonthYear: b,
      getSidebarProps: () => ({
        modelValue: l,
        month: a,
        year: o,
        time: u,
        updateTime: A,
        updateMonthYear: b,
        selectDate: v,
        presetDate: _
      }),
      changeMonth: ue,
      changeYear: ze,
      selectWeekDate: Y,
      setStartTime: I
    }), (re, ce) => (O(), R(ye, null, [
      Ce(Wo, {
        "multi-calendars": C(G).count,
        collapse: re.collapse,
        "is-mobile": re.isMobile
      }, {
        default: be(({ instance: T, index: le }) => [
          re.disableMonthYearSelect ? U("", !0) : (O(), Se(i5, bt({
            key: 0,
            ref: (de) => {
              de && (P.value[le] = de);
            },
            months: C(Iy)(re.formatLocale, re.locale, re.monthNameFormat),
            years: C(Od)(re.yearRange, re.locale, re.reverseYears),
            month: C(a)(T),
            year: C(o)(T),
            instance: T
          }, re.$props, {
            onMount: ce[0] || (ce[0] = (de) => z(C(es).header)),
            onResetFlow: ce[1] || (ce[1] = (de) => re.$emit("reset-flow")),
            onUpdateMonthYear: (de) => C(b)(T, de),
            onOverlayClosed: Ee,
            onOverlayOpened: ce[2] || (ce[2] = (de) => re.$emit("overlay-toggle", { open: !0, overlay: de }))
          }), It({ _: 2 }, [
            Te(C(N), (de, fe) => ({
              name: de,
              fn: be((Le) => [
                te(re.$slots, de, Pt(jt(Le)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          Ce(c5, bt({
            ref: (de) => {
              de && (x.value[le] = de);
            },
            "mapped-dates": W.value(T),
            month: C(a)(T),
            year: C(o)(T),
            instance: T
          }, re.$props, {
            onSelectDate: (de) => C(v)(de, T !== 1),
            onHandleSpace: (de) => H(de, T !== 1),
            onSetHoverDate: ce[3] || (ce[3] = (de) => C($)(de)),
            onHandleScroll: (de) => C(g)(de, T),
            onHandleSwipe: (de) => C(y)(de, T),
            onMount: ce[4] || (ce[4] = (de) => z(C(es).calendar)),
            onResetFlow: ce[5] || (ce[5] = (de) => re.$emit("reset-flow")),
            onTooltipOpen: ce[6] || (ce[6] = (de) => re.$emit("tooltip-open", de)),
            onTooltipClose: ce[7] || (ce[7] = (de) => re.$emit("tooltip-close", de))
          }), It({ _: 2 }, [
            Te(C(D), (de, fe) => ({
              name: de,
              fn: be((Le) => [
                te(re.$slots, de, Pt(jt({ ...Le })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse", "is-mobile"]),
      re.enableTimePicker ? (O(), R("div", f5, [
        re.$slots["time-picker"] ? te(re.$slots, "time-picker", Pt(bt({ key: 0 }, { time: C(u), updateTime: C(A) }))) : (O(), Se(ev, bt({
          key: 1,
          ref_key: "timePickerRef",
          ref: k
        }, re.$props, {
          hours: C(u).hours,
          minutes: C(u).minutes,
          seconds: C(u).seconds,
          "internal-model-value": re.internalModelValue,
          "disabled-times-config": C(c),
          "validate-time": C(f),
          onMount: ce[8] || (ce[8] = (T) => z(C(es).timePicker)),
          "onUpdate:hours": ce[9] || (ce[9] = (T) => C(A)(T)),
          "onUpdate:minutes": ce[10] || (ce[10] = (T) => C(A)(T, !1)),
          "onUpdate:seconds": ce[11] || (ce[11] = (T) => C(A)(T, !1, !0)),
          onResetFlow: ce[12] || (ce[12] = (T) => re.$emit("reset-flow")),
          onOverlayClosed: ce[13] || (ce[13] = (T) => K(T, !1)),
          onOverlayOpened: ce[14] || (ce[14] = (T) => K(T, !0)),
          onAmPmChange: ce[15] || (ce[15] = (T) => re.$emit("am-pm-change", T))
        }), It({ _: 2 }, [
          Te(C(L), (T, le) => ({
            name: T,
            fn: be((de) => [
              te(re.$slots, T, Pt(jt(de)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : U("", !0)
    ], 64));
  }
}), m5 = (t, e) => {
  const n = ee(), {
    defaultedMultiCalendars: i,
    defaultedConfig: s,
    defaultedHighlight: r,
    defaultedRange: a,
    propDates: o,
    defaultedFilters: l,
    defaultedMultiDates: u
  } = lt(t), { modelValue: c, year: d, month: f, calendars: h } = pa(t, e), { isDisabled: m } = Fi(t), { selectYear: p, groupedYears: g, showYearPicker: y, isDisabled: v, toggleYearPicker: b, handleYearSelect: _, handleYear: M } = Jy({
    modelValue: c,
    multiCalendars: i,
    range: a,
    highlight: r,
    calendars: h,
    propDates: o,
    month: f,
    year: d,
    filters: l,
    props: t,
    emit: e
  }), A = (x, k) => [x, k].map((D) => Lt(D, "MMMM", { locale: t.formatLocale })).join("-"), E = Z(() => (x) => c.value ? Array.isArray(c.value) ? c.value.some((k) => Um(x, k)) : Um(c.value, x) : !1), I = (x) => {
    if (a.value.enabled) {
      if (Array.isArray(c.value)) {
        const k = Ve(x, c.value[0]) || Ve(x, c.value[1]);
        return Zr(c.value, n.value, x) && !k;
      }
      return !1;
    }
    return !1;
  }, S = (x, k) => x.quarter === zm(k) && x.year === Oe(k), $ = (x) => typeof r.value == "function" ? r.value({ quarter: zm(x), year: Oe(x) }) : !!r.value.quarters.find((k) => S(k, x)), B = Z(() => (x) => {
    const k = Je(/* @__PURE__ */ new Date(), { year: d.value(x) });
    return rD({
      start: os(k),
      end: vy(k)
    }).map((D) => {
      const N = Gi(D), L = Wm(D), z = m(D), W = I(N), ae = $(N);
      return {
        text: A(N, L),
        value: N,
        active: E.value(N),
        highlighted: ae,
        disabled: z,
        isBetween: W
      };
    });
  }), V = (x) => {
    Cd(x, c, u.value.limit), e("auto-apply", !0);
  }, G = (x) => {
    c.value = Ad(c, x, e), Ho(c.value, e, t.autoApply, t.modelAuto);
  }, P = (x) => {
    c.value = x, e("auto-apply");
  };
  return {
    defaultedConfig: s,
    defaultedMultiCalendars: i,
    groupedYears: g,
    year: d,
    isDisabled: v,
    quarters: B,
    showYearPicker: y,
    modelValue: c,
    setHoverDate: (x) => {
      n.value = x;
    },
    selectYear: p,
    selectQuarter: (x, k, D) => {
      if (!D)
        return h.value[k].month = Fe(Wm(x)), u.value.enabled ? V(x) : a.value.enabled ? G(x) : P(x);
    },
    toggleYearPicker: b,
    handleYearSelect: _,
    handleYear: M
  };
}, p5 = { class: "dp--quarter-items" }, g5 = ["data-test-id", "disabled", "onClick", "onMouseover"], y5 = /* @__PURE__ */ Rt({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...Tn
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(t, { expose: e, emit: n }) {
    const i = n, s = t, r = cs(), a = rn(r, "yearMode"), {
      defaultedMultiCalendars: o,
      defaultedConfig: l,
      groupedYears: u,
      year: c,
      isDisabled: d,
      quarters: f,
      modelValue: h,
      showYearPicker: m,
      setHoverDate: p,
      selectQuarter: g,
      toggleYearPicker: y,
      handleYearSelect: v,
      handleYear: b
    } = m5(s, i);
    return e({ getSidebarProps: () => ({
      modelValue: h,
      year: c,
      selectQuarter: g,
      handleYearSelect: v,
      handleYear: b
    }) }), (_, M) => (O(), Se(Wo, {
      "multi-calendars": C(o).count,
      collapse: _.collapse,
      stretch: "",
      "is-mobile": _.isMobile
    }, {
      default: be(({ instance: A }) => [
        J("div", {
          class: "dp-quarter-picker-wrap",
          style: tt({ minHeight: `${C(l).modeHeight}px` })
        }, [
          _.$slots["top-extra"] ? te(_.$slots, "top-extra", {
            key: 0,
            value: _.internalModelValue
          }) : U("", !0),
          J("div", null, [
            Ce(Zy, bt(_.$props, {
              items: C(u)(A),
              instance: A,
              "show-year-picker": C(m)[A],
              year: C(c)(A),
              "is-disabled": (E) => C(d)(A, E),
              onHandleYear: (E) => C(b)(A, E),
              onYearSelect: (E) => C(v)(E, A),
              onToggleYearPicker: (E) => C(y)(A, E == null ? void 0 : E.flow, E == null ? void 0 : E.show)
            }), It({ _: 2 }, [
              Te(C(a), (E, I) => ({
                name: E,
                fn: be((S) => [
                  te(_.$slots, E, Pt(jt(S)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          J("div", p5, [
            (O(!0), R(ye, null, Te(C(f)(A), (E, I) => (O(), R("div", { key: I }, [
              J("button", {
                type: "button",
                class: me(["dp--qr-btn", {
                  "dp--qr-btn-active": E.active,
                  "dp--qr-btn-between": E.isBetween,
                  "dp--qr-btn-disabled": E.disabled,
                  "dp--highlighted": E.highlighted
                }]),
                "data-test-id": E.value,
                disabled: E.disabled,
                onClick: (S) => C(g)(E.value, A, E.disabled),
                onMouseover: (S) => C(p)(E.value)
              }, [
                _.$slots.quarter ? te(_.$slots, "quarter", {
                  key: 0,
                  value: E.value,
                  text: E.text
                }) : (O(), R(ye, { key: 1 }, [
                  He(ve(E.text), 1)
                ], 64))
              ], 42, g5)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), nv = (t, e) => {
  const n = ee(0);
  _t(() => {
    i(), window.addEventListener("resize", i, { passive: !0 });
  }), us(() => {
    window.removeEventListener("resize", i);
  });
  const i = () => {
    n.value = window.document.documentElement.clientWidth;
  };
  return {
    isMobile: Z(
      () => n.value <= t.value.mobileBreakpoint && !e ? !0 : void 0
    )
  };
}, v5 = ["id", "tabindex", "role", "aria-label"], b5 = {
  key: 0,
  class: "dp--menu-load-container"
}, w5 = {
  key: 1,
  class: "dp--menu-header"
}, x5 = ["data-dp-mobile"], _5 = {
  key: 0,
  class: "dp__sidebar_left"
}, k5 = ["data-dp-mobile"], M5 = ["data-test-id", "data-dp-mobile", "onClick", "onKeydown"], S5 = {
  key: 2,
  class: "dp__sidebar_right"
}, O5 = {
  key: 3,
  class: "dp__action_extra"
}, cp = /* @__PURE__ */ Rt({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...zo,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "menu-blur"
  ],
  setup(t, { expose: e, emit: n }) {
    const i = n, s = t, r = ee(null), a = Z(() => {
      const { openOnTop: j, ...he } = s;
      return {
        ...he,
        isMobile: g.value,
        flowStep: G.value,
        menuWrapRef: r.value
      };
    }), { setMenuFocused: o, setShiftKey: l, control: u } = Gy(), c = cs(), { defaultedTextInput: d, defaultedInline: f, defaultedConfig: h, defaultedUI: m, handleEventPropagation: p } = lt(s), { isMobile: g } = nv(h, s.shadow), y = ee(null), v = ee(0), b = ee(null), _ = ee(!1), M = ee(null), A = ee(!1), E = (j) => {
      A.value = !0, h.value.allowPreventDefault && j.preventDefault(), Oi(j, h.value, !0);
    };
    _t(() => {
      if (!s.shadow) {
        _.value = !0, I(), window.addEventListener("resize", I);
        const j = Mt(r);
        j && !d.value.enabled && !f.value.enabled && (o(!0), z()), j && (j.addEventListener("pointerdown", E), j.addEventListener("mousedown", E));
      }
      document.addEventListener("mousedown", gt);
    }), us(() => {
      window.removeEventListener("resize", I), document.removeEventListener("mousedown", gt);
      const j = Mt(r);
      j && (j.removeEventListener("pointerdown", E), j.removeEventListener("mousedown", E));
    });
    const I = () => {
      const j = Mt(b);
      j && (v.value = j.getBoundingClientRect().width);
    }, { arrowRight: S, arrowLeft: $, arrowDown: B, arrowUp: V } = Ii(), { flowStep: G, updateFlowStep: P, childMount: x, resetFlow: k, handleFlow: D } = A5(s, i, M), N = Z(() => s.monthPicker ? LA : s.yearPicker ? FA : s.timePicker ? KA : s.quarterPicker ? y5 : h5), L = Z(() => {
      var j;
      if (h.value.arrowLeft) return h.value.arrowLeft;
      const he = (j = r.value) == null ? void 0 : j.getBoundingClientRect(), We = s.getInputRect();
      return (We == null ? void 0 : We.width) < (v == null ? void 0 : v.value) && (We == null ? void 0 : We.left) <= ((he == null ? void 0 : he.left) ?? 0) ? `${(We == null ? void 0 : We.width) / 2}px` : (We == null ? void 0 : We.right) >= ((he == null ? void 0 : he.right) ?? 0) && (We == null ? void 0 : We.width) < (v == null ? void 0 : v.value) ? `${(v == null ? void 0 : v.value) - (We == null ? void 0 : We.width) / 2}px` : "50%";
    }), z = () => {
      const j = Mt(r);
      j && j.focus({ preventScroll: !0 });
    }, W = Z(() => {
      var j;
      return ((j = M.value) == null ? void 0 : j.getSidebarProps()) || {};
    }), ae = () => {
      s.openOnTop && i("recalculate-position");
    }, F = rn(c, "action"), H = Z(() => s.monthPicker || s.yearPicker ? rn(c, "monthYear") : s.timePicker ? rn(c, "timePicker") : rn(c, "shared")), Q = Z(() => s.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), ne = Z(() => ({
      dp__menu_disabled: s.disabled,
      dp__menu_readonly: s.readonly,
      "dp-menu-loading": s.loading
    })), w = Z(
      () => ({
        dp__menu: !0,
        dp__menu_index: !f.value.enabled,
        dp__relative: f.value.enabled,
        ...m.value.menu ?? {}
      })
    ), Y = (j) => {
      Oi(j, h.value, !0);
    }, ue = (j) => {
      s.escClose && (i("close-picker"), p(j));
    }, ze = (j) => {
      if (s.arrowNavigation) {
        if (j === Yt.up) return V();
        if (j === Yt.down) return B();
        if (j === Yt.left) return $();
        if (j === Yt.right) return S();
      } else j === Yt.left || j === Yt.up ? T("handleArrow", Yt.left, 0, j === Yt.up) : T("handleArrow", Yt.right, 0, j === Yt.down);
    }, K = (j) => {
      l(j.shiftKey), !s.disableMonthYearSelect && j.code === st.tab && j.target.classList.contains("dp__menu") && u.value.shiftKeyInMenu && (j.preventDefault(), Oi(j, h.value, !0), i("close-picker"));
    }, Ee = () => {
      z(), i("time-picker-close");
    }, re = (j) => {
      var he, We, Dt;
      (he = M.value) == null || he.toggleTimePicker(!1, !1), (We = M.value) == null || We.toggleMonthPicker(!1, !1, j), (Dt = M.value) == null || Dt.toggleYearPicker(!1, !1, j);
    }, ce = (j, he = 0) => {
      var We, Dt, Pn;
      return j === "month" ? (We = M.value) == null ? void 0 : We.toggleMonthPicker(!1, !0, he) : j === "year" ? (Dt = M.value) == null ? void 0 : Dt.toggleYearPicker(!1, !0, he) : j === "time" ? (Pn = M.value) == null ? void 0 : Pn.toggleTimePicker(!0, !1) : re(he);
    }, T = (j, ...he) => {
      var We, Dt;
      (We = M.value) != null && We[j] && ((Dt = M.value) == null || Dt[j](...he));
    }, le = () => {
      T("selectCurrentDate");
    }, de = (j, he) => {
      T("presetDate", Zi(j), he);
    }, fe = () => {
      T("clearHoverDate");
    }, Le = (j, he) => {
      T("updateMonthYear", j, he);
    }, $e = (j, he) => {
      j.preventDefault(), ze(he);
    }, Xe = (j) => {
      var he, We, Dt;
      if (K(j), j.key === st.home || j.key === st.end)
        return T(
          "selectWeekDate",
          j.key === st.home,
          j.target.getAttribute("id")
        );
      switch ((j.key === st.pageUp || j.key === st.pageDown) && (j.shiftKey ? (T("changeYear", j.key === st.pageUp), (he = gc(r.value, "overlay-year")) == null || he.focus()) : (T("changeMonth", j.key === st.pageUp), (We = gc(r.value, j.key === st.pageUp ? "action-prev" : "action-next")) == null || We.focus()), j.target.getAttribute("id") && ((Dt = r.value) == null || Dt.focus({ preventScroll: !0 }))), j.key) {
        case st.esc:
          return ue(j);
        case st.arrowLeft:
          return $e(j, Yt.left);
        case st.arrowRight:
          return $e(j, Yt.right);
        case st.arrowUp:
          return $e(j, Yt.up);
        case st.arrowDown:
          return $e(j, Yt.down);
        default:
          return;
      }
    }, gt = (j) => {
      var he;
      f.value.enabled && !f.value.input && !((he = r.value) != null && he.contains(j.target)) && A.value && (A.value = !1, i("menu-blur"));
    };
    return e({
      updateMonthYear: Le,
      switchView: ce,
      handleFlow: D,
      onValueCleared: () => {
        var j, he;
        (he = (j = M.value) == null ? void 0 : j.setStartTime) == null || he.call(j);
      }
    }), (j, he) => {
      var We, Dt, Pn;
      return O(), R("div", {
        id: j.uid ? `dp-menu-${j.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: r,
        tabindex: C(f).enabled ? void 0 : "0",
        role: C(f).enabled ? void 0 : "dialog",
        "aria-label": (We = j.ariaLabels) == null ? void 0 : We.menu,
        class: me(w.value),
        style: tt({ "--dp-arrow-left": L.value }),
        onMouseleave: fe,
        onClick: Y,
        onKeydown: Xe
      }, [
        (j.disabled || j.readonly) && C(f).enabled || j.loading ? (O(), R("div", {
          key: 0,
          class: me(ne.value)
        }, [
          j.loading ? (O(), R("div", b5, he[19] || (he[19] = [
            J("span", { class: "dp--menu-loader" }, null, -1)
          ]))) : U("", !0)
        ], 2)) : U("", !0),
        j.$slots["menu-header"] ? (O(), R("div", w5, [
          te(j.$slots, "menu-header")
        ])) : U("", !0),
        !C(f).enabled && !j.teleportCenter ? (O(), R("div", {
          key: 2,
          class: me(Q.value)
        }, null, 2)) : U("", !0),
        J("div", {
          ref_key: "innerMenuRef",
          ref: b,
          class: me({
            dp__menu_content_wrapper: ((Dt = j.presetDates) == null ? void 0 : Dt.length) || !!j.$slots["left-sidebar"] || !!j.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": t.collapse && (((Pn = j.presetDates) == null ? void 0 : Pn.length) || !!j.$slots["left-sidebar"] || !!j.$slots["right-sidebar"])
          }),
          "data-dp-mobile": C(g),
          style: tt({ "--dp-menu-width": `${v.value}px` })
        }, [
          j.$slots["left-sidebar"] ? (O(), R("div", _5, [
            te(j.$slots, "left-sidebar", Pt(jt(W.value)))
          ])) : U("", !0),
          j.presetDates.length ? (O(), R("div", {
            key: 1,
            class: me({ "dp--preset-dates-collapsed": t.collapse, "dp--preset-dates": !0 }),
            "data-dp-mobile": C(g)
          }, [
            (O(!0), R(ye, null, Te(j.presetDates, (we, Ct) => (O(), R(ye, { key: Ct }, [
              we.slot ? te(j.$slots, we.slot, {
                key: 0,
                presetDate: de,
                label: we.label,
                value: we.value
              }) : (O(), R("button", {
                key: 1,
                type: "button",
                style: tt(we.style || {}),
                class: me(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": t.collapse }]),
                "data-test-id": we.testId ?? void 0,
                "data-dp-mobile": C(g),
                onClick: et((Cn) => de(we.value, we.noTz), ["prevent"]),
                onKeydown: (Cn) => C(Ut)(Cn, () => de(we.value, we.noTz), !0)
              }, ve(we.label), 47, M5))
            ], 64))), 128))
          ], 10, k5)) : U("", !0),
          J("div", {
            ref_key: "calendarWrapperRef",
            ref: y,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (O(), Se(Js(N.value), bt({
              ref_key: "dynCmpRef",
              ref: M
            }, a.value, {
              "flow-step": C(G),
              onMount: C(x),
              onUpdateFlowStep: C(P),
              onResetFlow: C(k),
              onFocusMenu: z,
              onSelectDate: he[0] || (he[0] = (we) => j.$emit("select-date")),
              onDateUpdate: he[1] || (he[1] = (we) => j.$emit("date-update", we)),
              onTooltipOpen: he[2] || (he[2] = (we) => j.$emit("tooltip-open", we)),
              onTooltipClose: he[3] || (he[3] = (we) => j.$emit("tooltip-close", we)),
              onAutoApply: he[4] || (he[4] = (we) => j.$emit("auto-apply", we)),
              onRangeStart: he[5] || (he[5] = (we) => j.$emit("range-start", we)),
              onRangeEnd: he[6] || (he[6] = (we) => j.$emit("range-end", we)),
              onInvalidFixedRange: he[7] || (he[7] = (we) => j.$emit("invalid-fixed-range", we)),
              onTimeUpdate: he[8] || (he[8] = (we) => j.$emit("time-update")),
              onAmPmChange: he[9] || (he[9] = (we) => j.$emit("am-pm-change", we)),
              onTimePickerOpen: he[10] || (he[10] = (we) => j.$emit("time-picker-open", we)),
              onTimePickerClose: Ee,
              onRecalculatePosition: ae,
              onUpdateMonthYear: he[11] || (he[11] = (we) => j.$emit("update-month-year", we)),
              onAutoApplyInvalid: he[12] || (he[12] = (we) => j.$emit("auto-apply-invalid", we)),
              onInvalidDate: he[13] || (he[13] = (we) => j.$emit("invalid-date", we)),
              onOverlayToggle: he[14] || (he[14] = (we) => j.$emit("overlay-toggle", we)),
              "onUpdate:internalModelValue": he[15] || (he[15] = (we) => j.$emit("update:internal-model-value", we))
            }), It({ _: 2 }, [
              Te(H.value, (we, Ct) => ({
                name: we,
                fn: be((Cn) => [
                  te(j.$slots, we, Pt(jt({ ...Cn })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          j.$slots["right-sidebar"] ? (O(), R("div", S5, [
            te(j.$slots, "right-sidebar", Pt(jt(W.value)))
          ])) : U("", !0),
          j.$slots["action-extra"] ? (O(), R("div", O5, [
            j.$slots["action-extra"] ? te(j.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: le
            }) : U("", !0)
          ])) : U("", !0)
        ], 14, x5),
        !j.autoApply || C(h).keepActionRow ? (O(), Se(OA, bt({
          key: 3,
          "menu-mount": _.value
        }, a.value, {
          "calendar-width": v.value,
          onClosePicker: he[16] || (he[16] = (we) => j.$emit("close-picker")),
          onSelectDate: he[17] || (he[17] = (we) => j.$emit("select-date")),
          onInvalidSelect: he[18] || (he[18] = (we) => j.$emit("invalid-select")),
          onSelectNow: le
        }), It({ _: 2 }, [
          Te(C(F), (we, Ct) => ({
            name: we,
            fn: be((Cn) => [
              te(j.$slots, we, Pt(jt({ ...Cn })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : U("", !0)
      ], 46, v5);
    };
  }
});
var Ds = /* @__PURE__ */ ((t) => (t.center = "center", t.left = "left", t.right = "right", t))(Ds || {});
const D5 = ({
  menuRef: t,
  menuRefInner: e,
  inputRef: n,
  pickerWrapperRef: i,
  inline: s,
  emit: r,
  props: a,
  slots: o
}) => {
  const { defaultedConfig: l } = lt(a), u = ee({}), c = ee(!1), d = ee({
    top: "0",
    left: "0"
  }), f = ee(!1), h = Nr(a, "teleportCenter");
  ct(h, () => {
    d.value = JSON.parse(JSON.stringify({})), M();
  });
  const m = (k) => {
    if (a.teleport) {
      const D = k.getBoundingClientRect();
      return {
        left: D.left + window.scrollX,
        top: D.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, p = (k, D) => {
    d.value.left = `${k + D - u.value.width}px`;
  }, g = (k) => {
    d.value.left = `${k}px`;
  }, y = (k, D) => {
    a.position === Ds.left && g(k), a.position === Ds.right && p(k, D), a.position === Ds.center && (d.value.left = `${k + D / 2 - u.value.width / 2}px`);
  }, v = (k) => {
    const { width: D, height: N } = k.getBoundingClientRect(), { top: L, left: z } = m(k);
    return { top: +L, left: +z, width: D, height: N };
  }, b = () => {
    d.value.left = "50%", d.value.top = "50%", d.value.transform = "translate(-50%, -50%)", d.value.position = "fixed", delete d.value.opacity;
  }, _ = () => {
    const k = Mt(n);
    d.value = a.altPosition(k);
  }, M = (k = !0) => {
    var D;
    if (!s.value.enabled) {
      if (h.value) return b();
      if (a.altPosition !== null) return _();
      if (k) {
        const N = a.teleport ? (D = e.value) == null ? void 0 : D.$el : t.value;
        N && (u.value = N.getBoundingClientRect()), r("recalculate-position");
      }
      return V();
    }
  }, A = ({ inputEl: k, left: D, width: N }) => {
    window.screen.width > 768 && !c.value && y(D, N), S(k);
  }, E = (k) => {
    const { top: D, left: N, height: L, width: z } = v(k);
    d.value.top = `${L + D + +a.offset}px`, f.value = !1, c.value || (d.value.left = `${N + z / 2 - u.value.width / 2}px`), A({ inputEl: k, left: N, width: z });
  }, I = (k) => {
    const { top: D, left: N, width: L } = v(k);
    d.value.top = `${D - +a.offset - u.value.height}px`, f.value = !0, A({ inputEl: k, left: N, width: L });
  }, S = (k) => {
    if (a.autoPosition) {
      const { left: D, width: N } = v(k), { left: L, right: z } = u.value;
      if (!c.value) {
        if (Math.abs(L) !== Math.abs(z)) {
          if (L <= 0)
            return c.value = !0, g(D);
          if (z >= document.documentElement.clientWidth)
            return c.value = !0, p(D, N);
        }
        return y(D, N);
      }
    }
  }, $ = () => {
    const k = Mt(n);
    if (k) {
      if (a.autoPosition === bn.top) return bn.top;
      if (a.autoPosition === bn.bottom) return bn.bottom;
      const { height: D } = u.value, { top: N, height: L } = k.getBoundingClientRect(), z = window.innerHeight - N - L, W = N;
      return D <= z ? bn.bottom : D > z && D <= W ? bn.top : z >= W ? bn.bottom : bn.top;
    }
    return bn.bottom;
  }, B = (k) => $() === bn.bottom ? E(k) : I(k), V = () => {
    const k = Mt(n);
    if (k)
      return a.autoPosition ? B(k) : E(k);
  }, G = function(k) {
    if (k) {
      const D = k.scrollHeight > k.clientHeight, N = window.getComputedStyle(k).overflowY.indexOf("hidden") !== -1;
      return D && !N;
    }
    return !0;
  }, P = function(k) {
    return !k || k === document.body || k.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : G(k) ? k : P(
      k.assignedSlot && l.value.shadowDom ? k.assignedSlot.parentNode : k.parentNode
    );
  }, x = (k) => {
    if (k)
      switch (a.position) {
        case Ds.left:
          return { left: 0, transform: "translateX(0)" };
        case Ds.right:
          return { left: `${k.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${k.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: f,
    menuStyle: d,
    xCorrect: c,
    setMenuPosition: M,
    getScrollableParent: P,
    shadowRender: (k, D, N) => {
      var L, z, W;
      const ae = document.createElement("div"), F = (L = Mt(n)) == null ? void 0 : L.getBoundingClientRect();
      ae.setAttribute("id", "dp--temp-container");
      const H = (z = i.value) != null && z.clientWidth ? i.value : document.body;
      H.append(ae);
      const Q = x(F), ne = l.value.shadowDom ? Object.keys(o).filter(
        (Y) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(Y)
      ) : Object.keys(o), w = ku(
        D,
        {
          ...N,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...Q }
        },
        Object.fromEntries(ne.map((Y) => [Y, o[Y]]))
      );
      k != null && (w.appContext = k.appContext), $d(w, ae), u.value = (W = w.el) == null ? void 0 : W.getBoundingClientRect(), $d(null, ae), H.removeChild(ae);
    }
  };
}, li = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] },
  { name: "menu-header", use: ["menu"] }
], T5 = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], P5 = {
  all: () => li,
  monthYear: () => li.filter((t) => t.use.includes("month-year")),
  input: () => T5,
  timePicker: () => li.filter((t) => t.use.includes("time")),
  action: () => li.filter((t) => t.use.includes("action")),
  calendar: () => li.filter((t) => t.use.includes("calendar")),
  menu: () => li.filter((t) => t.use.includes("menu")),
  shared: () => li.filter((t) => t.use.includes("shared")),
  yearMode: () => li.filter((t) => t.use.includes("year-mode"))
}, rn = (t, e, n) => {
  const i = [];
  return P5[e]().forEach((s) => {
    t[s.name] && i.push(s.name);
  }), n != null && n.length && n.forEach((s) => {
    s.slot && i.push(s.slot);
  }), i;
}, ma = (t) => {
  const e = Z(() => (i) => t.value ? i ? t.value.open : t.value.close : ""), n = Z(() => (i) => t.value ? i ? t.value.menuAppearTop : t.value.menuAppearBottom : "");
  return { transitionName: e, showTransition: !!t.value, menuTransition: n };
}, pa = (t, e, n) => {
  const { defaultedRange: i, defaultedTz: s } = lt(t), r = se(Jt(se(), s.value.timezone)), a = ee([{ month: Fe(r), year: Oe(r) }]), o = (f) => {
    const h = {
      hours: ni(r),
      minutes: Ri(r),
      seconds: 0
    };
    return i.value.enabled ? [h[f], h[f]] : h[f];
  }, l = er({
    hours: o("hours"),
    minutes: o("minutes"),
    seconds: o("seconds")
  });
  ct(
    i,
    (f, h) => {
      f.enabled !== h.enabled && (l.hours = o("hours"), l.minutes = o("minutes"), l.seconds = o("seconds"));
    },
    { deep: !0 }
  );
  const u = Z({
    get: () => t.internalModelValue,
    set: (f) => {
      !t.readonly && !t.disabled && e("update:internal-model-value", f);
    }
  }), c = Z(
    () => (f) => a.value[f] ? a.value[f].month : 0
  ), d = Z(
    () => (f) => a.value[f] ? a.value[f].year : 0
  );
  return ct(
    u,
    (f, h) => {
      n && JSON.stringify(f ?? {}) !== JSON.stringify(h ?? {}) && n();
    },
    { deep: !0 }
  ), {
    calendars: a,
    time: l,
    modelValue: u,
    month: c,
    year: d,
    today: r
  };
}, C5 = (t, e) => {
  const {
    defaultedMultiCalendars: n,
    defaultedMultiDates: i,
    defaultedUI: s,
    defaultedHighlight: r,
    defaultedTz: a,
    propDates: o,
    defaultedRange: l
  } = lt(e), { isDisabled: u } = Fi(e), c = ee(null), d = ee(Jt(/* @__PURE__ */ new Date(), a.value.timezone)), f = (w) => {
    !w.current && e.hideOffsetDates || (c.value = w.value);
  }, h = () => {
    c.value = null;
  }, m = (w) => Array.isArray(t.value) && l.value.enabled && t.value[0] && c.value ? w ? vt(c.value, t.value[0]) : ht(c.value, t.value[0]) : !0, p = (w, Y) => {
    const ue = () => t.value ? Y ? t.value[0] || null : t.value[1] : null, ze = t.value && Array.isArray(t.value) ? ue() : null;
    return Ve(se(w.value), ze);
  }, g = (w) => {
    const Y = Array.isArray(t.value) ? t.value[0] : null;
    return w ? !ht(c.value ?? null, Y) : !0;
  }, y = (w, Y = !0) => (l.value.enabled || e.weekPicker) && Array.isArray(t.value) && t.value.length === 2 ? e.hideOffsetDates && !w.current ? !1 : Ve(se(w.value), t.value[Y ? 0 : 1]) : l.value.enabled ? p(w, Y) && g(Y) || Ve(w.value, Array.isArray(t.value) ? t.value[0] : null) && m(Y) : !1, v = (w, Y) => {
    if (Array.isArray(t.value) && t.value[0] && t.value.length === 1) {
      const ue = Ve(w.value, c.value);
      return Y ? vt(t.value[0], w.value) && ue : ht(t.value[0], w.value) && ue;
    }
    return !1;
  }, b = (w) => !t.value || e.hideOffsetDates && !w.current ? !1 : l.value.enabled ? e.modelAuto && Array.isArray(t.value) ? Ve(w.value, t.value[0] ? t.value[0] : d.value) : !1 : i.value.enabled && Array.isArray(t.value) ? t.value.some((Y) => Ve(Y, w.value)) : Ve(w.value, t.value ? t.value : d.value), _ = (w) => {
    if (l.value.autoRange || e.weekPicker) {
      if (c.value) {
        if (e.hideOffsetDates && !w.current) return !1;
        const Y = fn(c.value, +l.value.autoRange), ue = Gn(se(c.value), e.weekStart);
        return e.weekPicker ? Ve(ue[1], se(w.value)) : Ve(Y, se(w.value));
      }
      return !1;
    }
    return !1;
  }, M = (w) => {
    if (l.value.autoRange || e.weekPicker) {
      if (c.value) {
        const Y = fn(c.value, +l.value.autoRange);
        if (e.hideOffsetDates && !w.current) return !1;
        const ue = Gn(se(c.value), e.weekStart);
        return e.weekPicker ? vt(w.value, ue[0]) && ht(w.value, ue[1]) : vt(w.value, c.value) && ht(w.value, Y);
      }
      return !1;
    }
    return !1;
  }, A = (w) => {
    if (l.value.autoRange || e.weekPicker) {
      if (c.value) {
        if (e.hideOffsetDates && !w.current) return !1;
        const Y = Gn(se(c.value), e.weekStart);
        return e.weekPicker ? Ve(Y[0], w.value) : Ve(c.value, w.value);
      }
      return !1;
    }
    return !1;
  }, E = (w) => Zr(t.value, c.value, w.value), I = () => e.modelAuto && Array.isArray(e.internalModelValue) ? !!e.internalModelValue[0] : !1, S = () => e.modelAuto ? Fy(e.internalModelValue) : !0, $ = (w) => {
    if (e.weekPicker) return !1;
    const Y = l.value.enabled ? !y(w) && !y(w, !1) : !0;
    return !u(w.value) && !b(w) && !(!w.current && e.hideOffsetDates) && Y;
  }, B = (w) => l.value.enabled ? e.modelAuto ? I() && b(w) : !1 : b(w), V = (w) => r.value ? GC(w.value, o.value.highlight) : !1, G = (w) => {
    const Y = u(w.value);
    return Y && (typeof r.value == "function" ? !r.value(w.value, Y) : !r.value.options.highlightDisabled);
  }, P = (w) => {
    var Y;
    return typeof r.value == "function" ? r.value(w.value) : (Y = r.value.weekdays) == null ? void 0 : Y.includes(w.value.getDay());
  }, x = (w) => (l.value.enabled || e.weekPicker) && (!(n.value.count > 0) || w.current) && S() && !(!w.current && e.hideOffsetDates) && !b(w) ? E(w) : !1, k = (w) => {
    if (Array.isArray(t.value) && t.value.length === 1) {
      const { before: Y, after: ue } = ap(+l.value.maxRange, t.value[0]);
      return Gs(w.value, Y) || ls(w.value, ue);
    }
    return !1;
  }, D = (w) => {
    if (Array.isArray(t.value) && t.value.length === 1) {
      const { before: Y, after: ue } = ap(+l.value.minRange, t.value[0]);
      return Zr([Y, ue], t.value[0], w.value);
    }
    return !1;
  }, N = (w) => l.value.enabled && (l.value.maxRange || l.value.minRange) ? l.value.maxRange && l.value.minRange ? k(w) || D(w) : l.value.maxRange ? k(w) : D(w) : !1, L = (w) => {
    const { isRangeStart: Y, isRangeEnd: ue } = F(w), ze = l.value.enabled ? Y || ue : !1;
    return {
      dp__cell_offset: !w.current,
      dp__pointer: !e.disabled && !(!w.current && e.hideOffsetDates) && !u(w.value) && !N(w),
      dp__cell_disabled: u(w.value) || N(w),
      dp__cell_highlight: !G(w) && (V(w) || P(w)) && !B(w) && !ze && !A(w) && !(x(w) && e.weekPicker) && !ue,
      dp__cell_highlight_active: !G(w) && (V(w) || P(w)) && B(w),
      dp__today: !e.noToday && Ve(w.value, d.value) && w.current,
      "dp--past": ht(w.value, d.value),
      "dp--future": vt(w.value, d.value)
    };
  }, z = (w) => ({
    dp__active_date: B(w),
    dp__date_hover: $(w)
  }), W = (w) => {
    if (t.value && !Array.isArray(t.value)) {
      const Y = Gn(t.value, e.weekStart);
      return {
        ...Q(w),
        dp__range_start: Ve(Y[0], w.value),
        dp__range_end: Ve(Y[1], w.value),
        dp__range_between_week: vt(w.value, Y[0]) && ht(w.value, Y[1])
      };
    }
    return {
      ...Q(w)
    };
  }, ae = (w) => {
    if (t.value && Array.isArray(t.value)) {
      const Y = Gn(t.value[0], e.weekStart), ue = t.value[1] ? Gn(t.value[1], e.weekStart) : [];
      return {
        ...Q(w),
        dp__range_start: Ve(Y[0], w.value) || Ve(ue[0], w.value),
        dp__range_end: Ve(Y[1], w.value) || Ve(ue[1], w.value),
        dp__range_between_week: vt(w.value, Y[0]) && ht(w.value, Y[1]) || vt(w.value, ue[0]) && ht(w.value, ue[1]),
        dp__range_between: vt(w.value, Y[1]) && ht(w.value, ue[0])
      };
    }
    return {
      ...Q(w)
    };
  }, F = (w) => {
    const Y = n.value.count > 0 ? w.current && y(w) && S() : y(w) && S(), ue = n.value.count > 0 ? w.current && y(w, !1) && S() : y(w, !1) && S();
    return { isRangeStart: Y, isRangeEnd: ue };
  }, H = (w) => {
    const { isRangeStart: Y, isRangeEnd: ue } = F(w);
    return {
      dp__range_start: Y,
      dp__range_end: ue,
      dp__range_between: x(w),
      dp__date_hover: Ve(w.value, c.value) && !Y && !ue && !e.weekPicker,
      dp__date_hover_start: v(w, !0),
      dp__date_hover_end: v(w, !1)
    };
  }, Q = (w) => ({
    ...H(w),
    dp__cell_auto_range: M(w),
    dp__cell_auto_range_start: A(w),
    dp__cell_auto_range_end: _(w)
  }), ne = (w) => l.value.enabled ? l.value.autoRange ? Q(w) : e.modelAuto ? { ...z(w), ...H(w) } : e.weekPicker ? ae(w) : H(w) : e.weekPicker ? W(w) : z(w);
  return {
    setHoverDate: f,
    clearHoverDate: h,
    getDayClassData: (w) => e.hideOffsetDates && !w.current ? {} : {
      ...L(w),
      ...ne(w),
      [e.dayClass ? e.dayClass(w.value, e.internalModelValue) : ""]: !0,
      ...s.value.calendarCell ?? {}
    }
  };
}, Fi = (t) => {
  const { defaultedFilters: e, defaultedRange: n, propDates: i, defaultedMultiDates: s } = lt(t), r = (P) => i.value.disabledDates ? typeof i.value.disabledDates == "function" ? i.value.disabledDates(se(P)) : !!wo(P, i.value.disabledDates) : !1, a = (P) => i.value.maxDate ? t.yearPicker ? Oe(P) > Oe(i.value.maxDate) : vt(P, i.value.maxDate) : !1, o = (P) => i.value.minDate ? t.yearPicker ? Oe(P) < Oe(i.value.minDate) : ht(P, i.value.minDate) : !1, l = (P) => {
    const x = a(P), k = o(P), D = r(P), N = e.value.months.map((F) => +F).includes(Fe(P)), L = t.disabledWeekDays.length ? t.disabledWeekDays.some((F) => +F === GD(P)) : !1, z = h(P), W = Oe(P), ae = W < +t.yearRange[0] || W > +t.yearRange[1];
    return !(x || k || D || N || ae || L || z);
  }, u = (P, x) => ht(...wi(i.value.minDate, P, x)) || Ve(...wi(i.value.minDate, P, x)), c = (P, x) => vt(...wi(i.value.maxDate, P, x)) || Ve(...wi(i.value.maxDate, P, x)), d = (P, x, k) => {
    let D = !1;
    return i.value.maxDate && k && c(P, x) && (D = !0), i.value.minDate && !k && u(P, x) && (D = !0), D;
  }, f = (P, x, k, D) => {
    let N = !1;
    return D && (i.value.minDate || i.value.maxDate) ? i.value.minDate && i.value.maxDate ? N = d(P, x, k) : (i.value.minDate && u(P, x) || i.value.maxDate && c(P, x)) && (N = !0) : N = !0, N;
  }, h = (P) => Array.isArray(i.value.allowedDates) && !i.value.allowedDates.length ? !0 : i.value.allowedDates ? !wo(P, i.value.allowedDates, By(t.monthPicker, t.yearPicker)) : !1, m = (P) => !l(P), p = (P) => n.value.noDisabledRange ? !yy({ start: P[0], end: P[1] }).some((x) => m(x)) : !0, g = (P) => {
    if (P) {
      const x = Oe(P);
      return x >= +t.yearRange[0] && x <= t.yearRange[1];
    }
    return !0;
  }, y = (P, x) => !!(Array.isArray(P) && P[x] && (n.value.maxRange || n.value.minRange) && g(P[x])), v = (P, x, k = 0) => {
    if (y(x, k) && g(P)) {
      const D = fd(P, x[k]), N = Yy(x[k], P), L = N.length === 1 ? 0 : N.filter((W) => m(W)).length, z = Math.abs(D) - (n.value.minMaxRawRange ? 0 : L);
      if (n.value.minRange && n.value.maxRange)
        return z >= +n.value.minRange && z <= +n.value.maxRange;
      if (n.value.minRange) return z >= +n.value.minRange;
      if (n.value.maxRange) return z <= +n.value.maxRange;
    }
    return !0;
  }, b = () => !t.enableTimePicker || t.monthPicker || t.yearPicker || t.ignoreTimeValidation, _ = (P) => Array.isArray(P) ? [P[0] ? hu(P[0]) : null, P[1] ? hu(P[1]) : null] : hu(P), M = (P, x, k) => P.find(
    (D) => +D.hours === ni(x) && D.minutes === "*" ? !0 : +D.minutes === Ri(x) && +D.hours === ni(x)
  ) && k, A = (P, x, k) => {
    const [D, N] = P, [L, z] = x;
    return !M(D, L, k) && !M(N, z, k) && k;
  }, E = (P, x) => {
    const k = Array.isArray(x) ? x : [x];
    return Array.isArray(t.disabledTimes) ? Array.isArray(t.disabledTimes[0]) ? A(t.disabledTimes, k, P) : !k.some((D) => M(t.disabledTimes, D, P)) : P;
  }, I = (P, x) => {
    const k = Array.isArray(x) ? [ts(x[0]), x[1] ? ts(x[1]) : void 0] : ts(x), D = !t.disabledTimes(k);
    return P && D;
  }, S = (P, x) => t.disabledTimes ? Array.isArray(t.disabledTimes) ? E(x, P) : I(x, P) : x, $ = (P) => {
    let x = !0;
    if (!P || b()) return !0;
    const k = !i.value.minDate && !i.value.maxDate ? _(P) : P;
    return (t.maxTime || i.value.maxDate) && (x = rp(
      t.maxTime,
      i.value.maxDate,
      "max",
      At(k),
      x
    )), (t.minTime || i.value.minDate) && (x = rp(
      t.minTime,
      i.value.minDate,
      "min",
      At(k),
      x
    )), S(P, x);
  }, B = (P) => {
    if (!t.monthPicker) return !0;
    let x = !0;
    const k = se(wn(P));
    if (i.value.minDate && i.value.maxDate) {
      const D = se(wn(i.value.minDate)), N = se(wn(i.value.maxDate));
      return vt(k, D) && ht(k, N) || Ve(k, D) || Ve(k, N);
    }
    if (i.value.minDate) {
      const D = se(wn(i.value.minDate));
      x = vt(k, D) || Ve(k, D);
    }
    if (i.value.maxDate) {
      const D = se(wn(i.value.maxDate));
      x = ht(k, D) || Ve(k, D);
    }
    return x;
  }, V = Z(() => (P) => !t.enableTimePicker || t.ignoreTimeValidation ? !0 : $(P)), G = Z(() => (P) => t.monthPicker ? Array.isArray(P) && (n.value.enabled || s.value.enabled) ? !P.filter((x) => !B(x)).length : B(P) : !0);
  return {
    isDisabled: m,
    validateDate: l,
    validateMonthYearInRange: f,
    isDateRangeAllowed: p,
    checkMinMaxRange: v,
    isValidTime: $,
    isTimeValid: V,
    isMonthValid: G
  };
}, Yo = () => {
  const t = Z(() => (i, s) => i == null ? void 0 : i.includes(s)), e = Z(() => (i, s) => i.count ? i.solo ? !0 : s === 0 : !0), n = Z(() => (i, s) => i.count ? i.solo ? !0 : s === i.count - 1 : !0);
  return { hideNavigationButtons: t, showLeftIcon: e, showRightIcon: n };
}, A5 = (t, e, n) => {
  const i = ee(0), s = er({
    [es.timePicker]: !t.enableTimePicker || t.timePicker || t.monthPicker,
    [es.calendar]: !1,
    [es.header]: !1
  }), r = Z(() => t.monthPicker || t.timePicker), a = (d) => {
    var f;
    if ((f = t.flow) != null && f.length) {
      if (!d && r.value) return c();
      s[d] = !0, Object.keys(s).filter((h) => !s[h]).length || c();
    }
  }, o = () => {
    var d, f;
    (d = t.flow) != null && d.length && i.value !== -1 && (i.value += 1, e("flow-step", i.value), c()), ((f = t.flow) == null ? void 0 : f.length) === i.value && Gt().then(() => l());
  }, l = () => {
    i.value = -1;
  }, u = (d, f, ...h) => {
    var m, p;
    t.flow[i.value] === d && n.value && ((p = (m = n.value)[f]) == null || p.call(m, ...h));
  }, c = (d = 0) => {
    d && (i.value += d), u(Bt.month, "toggleMonthPicker", !0), u(Bt.year, "toggleYearPicker", !0), u(Bt.calendar, "toggleTimePicker", !1, !0), u(Bt.time, "toggleTimePicker", !0, !0);
    const f = t.flow[i.value];
    (f === Bt.hours || f === Bt.minutes || f === Bt.seconds) && u(f, "toggleTimePicker", !0, !0, f);
  };
  return { childMount: a, updateFlowStep: o, resetFlow: l, handleFlow: c, flowStep: i };
}, E5 = {
  key: 1,
  class: "dp__input_wrap"
}, $5 = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], R5 = {
  key: 2,
  class: "dp--clear-btn"
}, L5 = ["aria-label"], I5 = /* @__PURE__ */ Rt({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...zo
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur",
    "text-input"
  ],
  setup(t, { expose: e, emit: n }) {
    const i = n, s = t, {
      defaultedTextInput: r,
      defaultedAriaLabels: a,
      defaultedInline: o,
      defaultedConfig: l,
      defaultedRange: u,
      defaultedMultiDates: c,
      defaultedUI: d,
      getDefaultPattern: f,
      getDefaultStartTime: h
    } = lt(s), { checkMinMaxRange: m } = Fi(s), p = ee(), g = ee(null), y = ee(!1), v = ee(!1), b = Z(
      () => ({
        dp__pointer: !s.disabled && !s.readonly && !r.value.enabled,
        dp__disabled: s.disabled,
        dp__input_readonly: !r.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !s.hideInputIcon,
        dp__input_valid: typeof s.state == "boolean" ? s.state : !1,
        dp__input_invalid: typeof s.state == "boolean" ? !s.state : !1,
        dp__input_focus: y.value || s.isMenuOpen,
        dp__input_reg: !r.value.enabled,
        ...d.value.input ?? {}
      })
    ), _ = () => {
      i("set-input-date", null), s.clearable && s.autoApply && (i("set-empty-date"), p.value = null);
    }, M = (W) => {
      const ae = h();
      return KC(
        W,
        r.value.format ?? f(),
        ae ?? jy({}, s.enableSeconds),
        s.inputValue,
        v.value,
        s.formatLocale
      );
    }, A = (W) => {
      const { rangeSeparator: ae } = r.value, [F, H] = W.split(`${ae}`);
      if (F) {
        const Q = M(F.trim()), ne = H ? M(H.trim()) : void 0;
        if (ls(Q, ne)) return;
        const w = Q && ne ? [Q, ne] : [Q];
        m(ne, w, 0) && (p.value = Q ? w : null);
      }
    }, E = () => {
      v.value = !0;
    }, I = (W) => {
      if (u.value.enabled)
        A(W);
      else if (c.value.enabled) {
        const ae = W.split(";");
        p.value = ae.map((F) => M(F.trim())).filter((F) => F);
      } else
        p.value = M(W);
    }, S = (W) => {
      var ae;
      const F = typeof W == "string" ? W : (ae = W.target) == null ? void 0 : ae.value;
      F !== "" ? (r.value.openMenu && !s.isMenuOpen && i("open"), I(F), i("set-input-date", p.value)) : _(), v.value = !1, i("update:input-value", F), i("text-input", W, p.value);
    }, $ = (W) => {
      r.value.enabled ? (I(W.target.value), r.value.enterSubmit && yc(p.value) && s.inputValue !== "" ? (i("set-input-date", p.value, !0), p.value = null) : r.value.enterSubmit && s.inputValue === "" && (p.value = null, i("clear"))) : G(W);
    }, B = (W, ae) => {
      r.value.enabled && r.value.tabSubmit && !ae && I(W.target.value), r.value.tabSubmit && yc(p.value) && s.inputValue !== "" ? (i("set-input-date", p.value, !0, !0), p.value = null) : r.value.tabSubmit && s.inputValue === "" && (p.value = null, i("clear", !0));
    }, V = () => {
      y.value = !0, i("focus"), Gt().then(() => {
        var W;
        r.value.enabled && r.value.selectOnFocus && ((W = g.value) == null || W.select());
      });
    }, G = (W) => {
      if (Oi(W, l.value, !0), r.value.enabled && r.value.openMenu && !o.value.input) {
        if (r.value.openMenu === "open" && !s.isMenuOpen) return i("open");
        if (r.value.openMenu === "toggle") return i("toggle");
      } else r.value.enabled || i("toggle");
    }, P = () => {
      i("real-blur"), y.value = !1, (!s.isMenuOpen || o.value.enabled && o.value.input) && i("blur"), s.autoApply && r.value.enabled && p.value && !s.isMenuOpen && (i("set-input-date", p.value), i("select-date"), p.value = null);
    }, x = (W) => {
      Oi(W, l.value, !0), i("clear");
    }, k = () => {
      i("close");
    }, D = (W) => {
      if (W.key === "Tab" && B(W), W.key === "Enter" && $(W), W.key === "Escape" && r.value.escClose && k(), !r.value.enabled) {
        if (W.code === "Tab") return;
        W.preventDefault();
      }
    }, N = () => {
      var W;
      (W = g.value) == null || W.focus({ preventScroll: !0 });
    }, L = (W) => {
      p.value = W;
    }, z = (W) => {
      W.key === st.tab && B(W, !0);
    };
    return e({
      focusInput: N,
      setParsedDate: L
    }), (W, ae) => {
      var F, H, Q;
      return O(), R("div", { onClick: G }, [
        W.$slots.trigger && !W.$slots["dp-input"] && !C(o).enabled ? te(W.$slots, "trigger", { key: 0 }) : U("", !0),
        !W.$slots.trigger && (!C(o).enabled || C(o).input) ? (O(), R("div", E5, [
          W.$slots["dp-input"] && !W.$slots.trigger && (!C(o).enabled || C(o).enabled && C(o).input) ? te(W.$slots, "dp-input", {
            key: 0,
            value: t.inputValue,
            isMenuOpen: t.isMenuOpen,
            onInput: S,
            onEnter: $,
            onTab: B,
            onClear: x,
            onBlur: P,
            onKeypress: D,
            onPaste: E,
            onFocus: V,
            openMenu: () => W.$emit("open"),
            closeMenu: () => W.$emit("close"),
            toggleMenu: () => W.$emit("toggle")
          }) : U("", !0),
          W.$slots["dp-input"] ? U("", !0) : (O(), R("input", {
            key: 1,
            id: W.uid ? `dp-input-${W.uid}` : void 0,
            ref_key: "inputRef",
            ref: g,
            "data-test-id": "dp-input",
            name: W.name,
            class: me(b.value),
            inputmode: C(r).enabled ? "text" : "none",
            placeholder: W.placeholder,
            disabled: W.disabled,
            readonly: W.readonly,
            required: W.required,
            value: t.inputValue,
            autocomplete: W.autocomplete,
            "aria-label": (F = C(a)) == null ? void 0 : F.input,
            "aria-disabled": W.disabled || void 0,
            "aria-invalid": W.state === !1 ? !0 : void 0,
            onInput: S,
            onBlur: P,
            onFocus: V,
            onKeypress: D,
            onKeydown: ae[0] || (ae[0] = (ne) => D(ne)),
            onPaste: E
          }, null, 42, $5)),
          J("div", {
            onClick: ae[3] || (ae[3] = (ne) => i("toggle"))
          }, [
            W.$slots["input-icon"] && !W.hideInputIcon ? (O(), R("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: ae[1] || (ae[1] = (ne) => i("toggle"))
            }, [
              te(W.$slots, "input-icon")
            ])) : U("", !0),
            !W.$slots["input-icon"] && !W.hideInputIcon && !W.$slots["dp-input"] ? (O(), Se(C(cr), {
              key: 1,
              "aria-label": (H = C(a)) == null ? void 0 : H.calendarIcon,
              class: "dp__input_icon dp__input_icons",
              onClick: ae[2] || (ae[2] = (ne) => i("toggle"))
            }, null, 8, ["aria-label"])) : U("", !0)
          ]),
          W.$slots["clear-icon"] && (W.alwaysClearable || t.inputValue && W.clearable && !W.disabled && !W.readonly) ? (O(), R("span", R5, [
            te(W.$slots, "clear-icon", { clear: x })
          ])) : U("", !0),
          !W.$slots["clear-icon"] && (W.alwaysClearable || W.clearable && t.inputValue && !W.disabled && !W.readonly) ? (O(), R("button", {
            key: 3,
            "aria-label": (Q = C(a)) == null ? void 0 : Q.clearInput,
            class: "dp--clear-btn",
            type: "button",
            onKeydown: ae[4] || (ae[4] = (ne) => C(Ut)(ne, () => x(ne), !0, z)),
            onClick: ae[5] || (ae[5] = et((ne) => x(ne), ["prevent"]))
          }, [
            Ce(C(Ly), {
              class: "dp__input_icons",
              "data-test-id": "clear-icon"
            })
          ], 40, L5)) : U("", !0)
        ])) : U("", !0)
      ]);
    };
  }
}), F5 = typeof window < "u" ? window : void 0, bu = () => {
}, V5 = (t) => bc() ? (wc(t), !0) : !1, N5 = (t, e, n, i) => {
  if (!t) return bu;
  let s = bu;
  const r = ct(
    () => C(t),
    (o) => {
      s(), o && (o.removeEventListener(e, n), o.addEventListener(e, n, i), s = () => {
        o.removeEventListener(e, n, i), s = bu;
      });
    },
    { immediate: !0, flush: "post" }
  ), a = () => {
    r(), s();
  };
  return V5(a), a;
}, B5 = (t, e, n, i = {}) => {
  const { window: s = F5, event: r = "pointerdown" } = i;
  return s ? N5(s, r, (a) => {
    const o = Mt(t), l = Mt(e);
    !o || !l || o === a.target || a.composedPath().includes(o) || a.composedPath().includes(l) || n(a);
  }, { passive: !0 }) : void 0;
}, z5 = ["data-dp-mobile"], W5 = /* @__PURE__ */ Rt({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...zo
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "text-input"
  ],
  setup(t, { expose: e, emit: n }) {
    const i = n, s = t, r = cs(), a = ee(!1), o = Nr(s, "modelValue"), l = Nr(s, "timezone"), u = ee(null), c = ee(null), d = ee(null), f = ee(!1), h = ee(null), m = ee(!1), p = ee(!1), g = ee(!1), y = ee(!1), { setMenuFocused: v, setShiftKey: b } = Gy(), { clearArrowNav: _ } = Ii(), { validateDate: M, isValidTime: A } = Fi(s), {
      defaultedTransitions: E,
      defaultedTextInput: I,
      defaultedInline: S,
      defaultedConfig: $,
      defaultedRange: B,
      defaultedMultiDates: V
    } = lt(s), { menuTransition: G, showTransition: P } = ma(E), { isMobile: x } = nv($), k = _o();
    _t(() => {
      w(s.modelValue), Gt().then(() => {
        if (!S.value.enabled) {
          const ie = F(h.value);
          ie == null || ie.addEventListener("scroll", de), window == null || window.addEventListener("resize", fe);
        }
      }), S.value.enabled && (a.value = !0), window == null || window.addEventListener("keyup", Le), window == null || window.addEventListener("keydown", $e);
    }), us(() => {
      if (!S.value.enabled) {
        const ie = F(h.value);
        ie == null || ie.removeEventListener("scroll", de), window == null || window.removeEventListener("resize", fe);
      }
      window == null || window.removeEventListener("keyup", Le), window == null || window.removeEventListener("keydown", $e);
    });
    const D = rn(r, "all", s.presetDates), N = rn(r, "input");
    ct(
      [o, l],
      () => {
        w(o.value);
      },
      { deep: !0 }
    );
    const { openOnTop: L, menuStyle: z, xCorrect: W, setMenuPosition: ae, getScrollableParent: F, shadowRender: H } = D5({
      menuRef: u,
      menuRefInner: c,
      inputRef: d,
      pickerWrapperRef: h,
      inline: S,
      emit: i,
      props: s,
      slots: r
    }), {
      inputValue: Q,
      internalModelValue: ne,
      parseExternalModelValue: w,
      emitModelValue: Y,
      formatInputValue: ue,
      checkBeforeEmit: ze
    } = _A(i, s, f), K = Z(
      () => ({
        dp__main: !0,
        dp__theme_dark: s.dark,
        dp__theme_light: !s.dark,
        dp__flex_display: S.value.enabled,
        "dp--flex-display-collapsed": g.value,
        dp__flex_display_with_input: S.value.input
      })
    ), Ee = Z(() => s.dark ? "dp__theme_dark" : "dp__theme_light"), re = Z(() => s.teleport ? {
      to: typeof s.teleport == "boolean" ? "body" : s.teleport,
      disabled: !s.teleport || S.value.enabled
    } : {}), ce = Z(() => ({ class: "dp__outer_menu_wrap" })), T = Z(() => S.value.enabled && (s.timePicker || s.monthPicker || s.yearPicker || s.quarterPicker)), le = () => {
      var ie, ge;
      return ((ge = (ie = d.value) == null ? void 0 : ie.$el) == null ? void 0 : ge.getBoundingClientRect()) ?? { width: 0, left: 0, right: 0 };
    }, de = () => {
      a.value && ($.value.closeOnScroll ? Ct() : ae());
    }, fe = () => {
      var ie;
      a.value && ae();
      const ge = ((ie = c.value) == null ? void 0 : ie.$el.getBoundingClientRect().width) ?? 0;
      g.value = document.body.offsetWidth <= ge;
    }, Le = (ie) => {
      ie.key === "Tab" && !S.value.enabled && !s.teleport && $.value.tabOutClosesMenu && (h.value.contains(document.activeElement) || Ct()), p.value = ie.shiftKey;
    }, $e = (ie) => {
      p.value = ie.shiftKey;
    }, Xe = () => {
      !s.disabled && !s.readonly && (H(k, cp, s), ae(!1), a.value = !0, a.value && i("open"), a.value || we(), w(s.modelValue));
    }, gt = () => {
      var ie, ge;
      Q.value = "", we(), (ie = c.value) == null || ie.onValueCleared(), (ge = d.value) == null || ge.setParsedDate(null), i("update:model-value", null), i("update:model-timezone-value", null), i("cleared"), $.value.closeOnClearValue && Ct();
    }, j = () => {
      const ie = ne.value;
      return !ie || !Array.isArray(ie) && M(ie) ? !0 : Array.isArray(ie) ? V.value.enabled || ie.length === 2 && M(ie[0]) && M(ie[1]) ? !0 : B.value.partialRange && !s.timePicker ? M(ie[0]) : !1 : !1;
    }, he = () => {
      ze() && j() ? (Y(), Ct()) : i("invalid-select", ne.value);
    }, We = (ie) => {
      Dt(), Y(), $.value.closeOnAutoApply && !ie && Ct();
    }, Dt = () => {
      d.value && I.value.enabled && d.value.setParsedDate(ne.value);
    }, Pn = (ie = !1) => {
      s.autoApply && A(ne.value) && j() && (B.value.enabled && Array.isArray(ne.value) ? (B.value.partialRange || ne.value.length === 2) && We(ie) : We(ie));
    }, we = () => {
      I.value.enabled || (ne.value = null);
    }, Ct = (ie = !1) => {
      var ge, xe;
      ie && ne.value && $.value.setDateOnMenuClose && he(), S.value.enabled || (a.value && (a.value = !1, W.value = !1, v(!1), b(!1), _(), i("closed"), Q.value && w(o.value)), we(), i("blur"), (xe = (ge = c.value) == null ? void 0 : ge.$el) == null || xe.remove());
    }, Cn = (ie, ge, xe = !1) => {
      if (!ie) {
        ne.value = null;
        return;
      }
      const Yn = Array.isArray(ie) ? !ie.some((Vi) => !M(Vi)) : M(ie), An = A(ie);
      Yn && An ? (y.value = !0, ne.value = ie, ge ? (m.value = xe, he(), i("text-submit")) : s.autoApply && Pn(), Gt().then(() => {
        y.value = !1;
      })) : i("invalid-date", ie);
    }, jo = () => {
      s.autoApply && A(ne.value) && Y(), Dt();
    }, ga = () => a.value ? Ct() : Xe(), qo = (ie) => {
      ne.value = ie;
    }, Uo = () => {
      I.value.enabled && (f.value = !0, ue()), i("focus");
    }, Xo = () => {
      if (I.value.enabled && (f.value = !1, w(s.modelValue), m.value)) {
        const ie = XC(h.value, p.value);
        ie == null || ie.focus();
      }
      i("blur");
    }, Go = (ie) => {
      c.value && c.value.updateMonthYear(0, {
        month: np(ie.month),
        year: np(ie.year)
      });
    }, Zo = (ie) => {
      w(ie ?? s.modelValue);
    }, q = (ie, ge) => {
      var xe;
      (xe = c.value) == null || xe.switchView(ie, ge);
    }, oe = (ie, ge) => $.value.onClickOutside ? $.value.onClickOutside(ie, ge) : Ct(!0), Me = (ie = 0) => {
      var ge;
      (ge = c.value) == null || ge.handleFlow(ie);
    }, Re = () => u;
    return B5(
      u,
      d,
      (ie) => oe(j, ie)
    ), e({
      closeMenu: Ct,
      selectDate: he,
      clearValue: gt,
      openMenu: Xe,
      onScroll: de,
      formatInputValue: ue,
      // exposed for testing purposes
      updateInternalModelValue: qo,
      // modify internal modelValue
      setMonthYear: Go,
      parseModel: Zo,
      switchView: q,
      toggleMenu: ga,
      handleFlow: Me,
      getDpWrapMenuRef: Re
    }), (ie, ge) => (O(), R("div", {
      ref_key: "pickerWrapperRef",
      ref: h,
      class: me(K.value),
      "data-datepicker-instance": "",
      "data-dp-mobile": C(x)
    }, [
      Ce(I5, bt({
        ref_key: "inputRef",
        ref: d,
        "input-value": C(Q),
        "onUpdate:inputValue": ge[0] || (ge[0] = (xe) => Ed(Q) ? Q.value = xe : null),
        "is-menu-open": a.value
      }, ie.$props, {
        onClear: gt,
        onOpen: Xe,
        onSetInputDate: Cn,
        onSetEmptyDate: C(Y),
        onSelectDate: he,
        onToggle: ga,
        onClose: Ct,
        onFocus: Uo,
        onBlur: Xo,
        onRealBlur: ge[1] || (ge[1] = (xe) => f.value = !1),
        onTextInput: ge[2] || (ge[2] = (xe) => ie.$emit("text-input", xe))
      }), It({ _: 2 }, [
        Te(C(N), (xe, Yn) => ({
          name: xe,
          fn: be((An) => [
            te(ie.$slots, xe, Pt(jt(An)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (O(), Se(Js(ie.teleport ? hp : "div"), Pt(jt(re.value)), {
        default: be(() => [
          Ce(Bn, {
            name: C(G)(C(L)),
            css: C(P) && !C(S).enabled
          }, {
            default: be(() => [
              a.value ? (O(), R("div", bt({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: u
              }, ce.value, {
                class: { "dp--menu-wrapper": !C(S).enabled },
                style: C(S).enabled ? void 0 : C(z)
              }), [
                Ce(cp, bt({
                  ref_key: "dpMenuRef",
                  ref: c
                }, ie.$props, {
                  "internal-model-value": C(ne),
                  "onUpdate:internalModelValue": ge[3] || (ge[3] = (xe) => Ed(ne) ? ne.value = xe : null),
                  class: { [Ee.value]: !0, "dp--menu-wrapper": ie.teleport },
                  "open-on-top": C(L),
                  "no-overlay-focus": T.value,
                  collapse: g.value,
                  "get-input-rect": le,
                  "is-text-input-date": y.value,
                  onClosePicker: Ct,
                  onSelectDate: he,
                  onAutoApply: Pn,
                  onTimeUpdate: jo,
                  onFlowStep: ge[4] || (ge[4] = (xe) => ie.$emit("flow-step", xe)),
                  onUpdateMonthYear: ge[5] || (ge[5] = (xe) => ie.$emit("update-month-year", xe)),
                  onInvalidSelect: ge[6] || (ge[6] = (xe) => ie.$emit("invalid-select", C(ne))),
                  onAutoApplyInvalid: ge[7] || (ge[7] = (xe) => ie.$emit("invalid-select", xe)),
                  onInvalidFixedRange: ge[8] || (ge[8] = (xe) => ie.$emit("invalid-fixed-range", xe)),
                  onRecalculatePosition: C(ae),
                  onTooltipOpen: ge[9] || (ge[9] = (xe) => ie.$emit("tooltip-open", xe)),
                  onTooltipClose: ge[10] || (ge[10] = (xe) => ie.$emit("tooltip-close", xe)),
                  onTimePickerOpen: ge[11] || (ge[11] = (xe) => ie.$emit("time-picker-open", xe)),
                  onTimePickerClose: ge[12] || (ge[12] = (xe) => ie.$emit("time-picker-close", xe)),
                  onAmPmChange: ge[13] || (ge[13] = (xe) => ie.$emit("am-pm-change", xe)),
                  onRangeStart: ge[14] || (ge[14] = (xe) => ie.$emit("range-start", xe)),
                  onRangeEnd: ge[15] || (ge[15] = (xe) => ie.$emit("range-end", xe)),
                  onDateUpdate: ge[16] || (ge[16] = (xe) => ie.$emit("date-update", xe)),
                  onInvalidDate: ge[17] || (ge[17] = (xe) => ie.$emit("invalid-date", xe)),
                  onOverlayToggle: ge[18] || (ge[18] = (xe) => ie.$emit("overlay-toggle", xe)),
                  onMenuBlur: ge[19] || (ge[19] = (xe) => ie.$emit("blur"))
                }), It({ _: 2 }, [
                  Te(C(D), (xe, Yn) => ({
                    name: xe,
                    fn: be((An) => [
                      te(ie.$slots, xe, Pt(jt({ ...An })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : U("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 10, z5));
  }
}), xo = /* @__PURE__ */ (() => {
  const t = W5;
  return t.install = (e) => {
    e.component("Vue3DatePicker", t);
  }, t;
})(), H5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xo
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(H5).forEach(([t, e]) => {
  t !== "default" && (xo[t] = e);
});
const Y5 = { class: "space-y-2" }, j5 = {
  key: 0,
  class: "flex flex-col"
}, q5 = {
  key: 0,
  class: "font-medium"
}, U5 = {
  key: 1,
  class: "text-sm text-gray-400"
}, X5 = ["id", "disabled", "name", "value"], G5 = ["for"], Z5 = {
  __name: "RadioButtonList",
  props: /* @__PURE__ */ Mn({
    title: {
      type: String,
      default: null
    },
    subTitle: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      required: !0,
      /**
       * Must have the following structure:
       * the tooltip is optional
       * [
       *   { label: "label", value: "value", tooltip: "tooltip"},
       *   ...
       * ]
       */
      validator: (t) => t.every((e) => Object.hasOwn(e, "label") && Object.hasOwn(e, "value"))
    },
    variant: {
      type: String,
      default: "primary",
      validator: (t) => ["default", "primary"].includes(t)
    },
    helperText: {
      type: String,
      default: null
    },
    stateError: {
      type: Boolean,
      default: !1
    },
    stateSuccess: {
      type: Boolean,
      default: !1
    },
    allDisabled: {
      type: Boolean,
      default: !1
    }
  }, {
    modelValue: { type: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, n = Hn(t, "modelValue"), i = ur(), s = Z(() => {
      switch (e.variant) {
        case "primary":
          return "whitespace-nowrap h-10 rounded-lg px-4 hover:bg-primary-50 active:bg-primary-100 peer-checked:bg-primary peer-checked:text-white font-medium";
        default:
          return "";
      }
    }), r = Z(() => {
      switch (e.variant) {
        case "primary":
          return "peer hidden";
        default:
          return "border-gray-300 bg-gray-50 text-primary focus:ring-0 focus:ring-offset-0";
      }
    });
    return (a, o) => (O(), R("div", Y5, [
      t.title || t.subTitle ? (O(), R("div", j5, [
        t.title ? (O(), R("p", q5, ve(t.title), 1)) : U("", !0),
        t.subTitle ? (O(), R("p", U5, ve(t.subTitle), 1)) : U("", !0)
      ])) : U("", !0),
      (O(!0), R(ye, null, Te(t.items, (l, u) => (O(), R("div", {
        key: u,
        class: me({ "flex items-center gap-2": t.variant === "default" })
      }, [
        Tt(J("input", {
          id: `${C(i)}-radio-${u}`,
          "onUpdate:modelValue": o[0] || (o[0] = (c) => n.value = c),
          class: me(r.value),
          disabled: t.allDisabled,
          name: `${C(i)}-radio`,
          value: l.value,
          type: "radio"
        }, null, 10, X5), [
          [gp, n.value]
        ]),
        J("label", {
          for: `${C(i)}-radio-${u}`,
          class: me(["flex items-center", s.value])
        }, [
          te(a.$slots, l.label, {}, () => [
            He(ve(l.label), 1)
          ], !0)
        ], 10, G5)
      ], 2))), 128)),
      t.helperText ? (O(), R("div", {
        key: 1,
        class: me([
          "text-sm",
          t.stateError ? "text-danger-600" : t.stateSuccess ? "text-success-600" : "text-gray-500"
        ])
      }, ve(t.helperText), 3)) : U("", !0)
    ]));
  }
}, K5 = /* @__PURE__ */ pn(Z5, [["__scopeId", "data-v-bdc5c1d0"]]), Q5 = { class: "flex" }, J5 = { class: "preset-dates-container" }, e3 = 860, _E = {
  __name: "DatePicker",
  props: /* @__PURE__ */ Mn({
    /**
     * Whether to show the year picker instead of the date range picker.
     */
    yearPicker: Boolean,
    /**
     * An array of datetime objects representing 'breakpoints'; these are dates
     * that cannot be contained in the selected range, except for the start or end
     * date. This is useful for enforcing the selected range to be contained in
     * specific periods.
     */
    breakpoints: {
      type: Array,
      default: () => []
    },
    /**
     * Teleport the datepicker modal to a different DOM node. See Vue and
     * vue-datepicker docs on 'teleport'.
     */
    teleport: {
      type: [String, Boolean],
      default: !1
    }
  }, {
    modelValue: { type: Array },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Mn(["breakpointLimit"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const n = t, i = Hn(t, "modelValue"), s = e, r = /* @__PURE__ */ new Date(), a = { month: 11, day: 31 }, o = ee(null), l = ee(null), { width: u } = FC(), c = [
      {
        label: `Vandaag ${Lt(r, "dd MMM", { locale: hi })}`,
        value: [Gm(), Gm()]
      },
      {
        label: "Deze week",
        value: [$i(r), Xm(r)]
      },
      {
        label: "Vorige week",
        value: [
          $i(qi(r, { weeks: 1 })),
          Xm(qi(r, { weeks: 1 }))
        ]
      },
      {
        label: "Deze maand",
        value: [cc(r), su(r)]
      },
      {
        label: "Vorige maand",
        value: [
          cc(qi(r, { months: 1 })),
          su(qi(r, { months: 1 }))
        ]
      },
      {
        label: "Dit jaar",
        value: [os(r), ru(r)]
      },
      {
        label: "Vorig jaar",
        value: [
          os(qi(r, { years: 1 })),
          ru(qi(r, { years: 1 }))
        ]
      }
    ], d = Z(() => u.value < e3), f = Z({
      get: () => i.value ? Oe(i.value[0]) : null,
      set: (v) => {
        i.value = [
          new Date(v, 0, 1),
          new Date(v, a.month, a.day)
        ];
      }
    });
    function h(v) {
      return new Date(v.getFullYear(), v.getMonth(), v.getDate());
    }
    const m = Z(
      () => n.breakpoints.map(h).sort((v, b) => v - b)
    );
    function p(v) {
      let b;
      const _ = fd(i.value[1], i.value[0]) + 1, M = i.value[0].getDate() === 1 && _ === Oy(i.value[0]), A = _y(i.value[0]) === 1 && _ === KD(i.value[0]);
      if (M) {
        const E = Ps(i.value[0], { months: v });
        b = [E, su(E)];
      } else if (A) {
        const E = Ps(i.value[0], { years: v });
        b = [E, ru(E)];
      } else
        b = [
          Ps(i.value[0], { days: _ * v }),
          Ps(i.value[1], { days: _ * v })
        ];
      i.value = b;
    }
    function g(v) {
      if (m.value.length && (v != null && v[0]) && !(v != null && v[1])) {
        const b = m.value.findIndex((_) => v[0] < _);
        switch (b) {
          case -1:
            o.value = m.value[m.value.length - 1], l.value = null;
            break;
          case 0:
            o.value = null, l.value = Fr(m.value[0], 1);
            break;
          default:
            o.value = m.value[b - 1], l.value = Fr(m.value[b], 1);
        }
      } else
        o.value = null, l.value = null;
    }
    let y = !1;
    return ct(
      () => i.value,
      (v) => {
        if (y) {
          y = !1;
          return;
        }
        if (m.value.length && (v != null && v[1])) {
          const b = m.value.find(
            (_) => v[0] < _
          );
          b && v[1] > b && (y = !0, i.value = [v[0], Fr(b, 1)], s("breakpointLimit", b));
        }
      },
      { immediate: !0 }
    ), (v, b) => (O(), R("div", Q5, [
      Ce(Vs, {
        color: "secondary",
        narrow: "",
        flat: "right",
        onClick: b[0] || (b[0] = (_) => p(-1))
      }, {
        default: be(() => [
          Ce(Xt, {
            name: "arrow-left-s",
            class: "text-xl"
          })
        ]),
        _: 1
      }),
      t.yearPicker ? (O(), Se(C(xo), {
        key: 0,
        modelValue: f.value,
        "onUpdate:modelValue": b[1] || (b[1] = (_) => f.value = _),
        "year-picker": "",
        "enable-time-picker": !1,
        "action-row": {},
        "text-input": "",
        clearable: !1,
        "auto-apply": "",
        teleport: t.teleport
      }, null, 8, ["modelValue", "teleport"])) : (O(), Se(C(xo), {
        key: 1,
        modelValue: i.value,
        "onUpdate:modelValue": b[3] || (b[3] = (_) => i.value = _),
        range: "",
        "format-locale": C(hi),
        format: "dd-MM-yyyy",
        "month-name-format": "long",
        "enable-time-picker": !1,
        "action-row": {},
        "text-input": "",
        clearable: !1,
        "multi-calendars": !d.value,
        "auto-apply": "",
        teleport: t.teleport,
        config: { closeOnAutoApply: !1 },
        "min-date": o.value,
        "max-date": l.value,
        onInternalModelChange: g
      }, {
        "left-sidebar": be(() => [
          J("div", J5, [
            Ce(K5, {
              modelValue: i.value,
              "onUpdate:modelValue": b[2] || (b[2] = (_) => i.value = _),
              class: "preset-dates",
              items: c
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "format-locale", "multi-calendars", "teleport", "min-date", "max-date"])),
      Ce(Vs, {
        color: "secondary",
        narrow: "",
        flat: "left",
        onClick: b[4] || (b[4] = (_) => p(1))
      }, {
        default: be(() => [
          Ce(Xt, {
            name: "arrow-right-s",
            class: "text-xl"
          })
        ]),
        _: 1
      })
    ]));
  }
}, t3 = ["for"], n3 = ["id"], kE = {
  __name: "CheckboxItem",
  props: {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = Hn(t, "modelValue"), n = ur();
    return (i, s) => (O(), R("label", {
      class: "flex items-center gap-2",
      for: C(n)
    }, [
      Tt(J("input", {
        id: C(n),
        "onUpdate:modelValue": s[0] || (s[0] = (r) => e.value = r),
        class: "rounded border-gray-300 bg-gray-50 text-primary focus:ring-0 focus:ring-offset-0",
        type: "checkbox"
      }, null, 8, n3), [
        [Mu, e.value]
      ]),
      J("span", null, [
        te(i.$slots, "default")
      ])
    ], 8, t3));
  }
};
function wu(t) {
  return t === 0 ? !1 : Array.isArray(t) && t.length === 0 ? !0 : !t;
}
function i3(t) {
  return (...e) => !t(...e);
}
function s3(t, e) {
  return t === void 0 && (t = "undefined"), t === null && (t = "null"), t === !1 && (t = "false"), t.toString().toLowerCase().indexOf(e.trim()) !== -1;
}
function r3(t) {
  return t.filter((e) => !e.$isLabel);
}
function xu(t, e) {
  return (n) => n.reduce((i, s) => s[t] && s[t].length ? (i.push({
    $groupLabel: s[e],
    $isLabel: !0
  }), i.concat(s[t])) : i, []);
}
const dp = (...t) => (e) => t.reduce((n, i) => i(n), e);
var a3 = {
  data() {
    return {
      search: "",
      isOpen: !1,
      preferredOpenDirection: "below",
      optimizedHeight: this.maxHeight
    };
  },
  props: {
    /**
     * Decide whether to filter the results based on search query.
     * Useful for async filtering, where we search through more complex data.
     * @type {Boolean}
     */
    internalSearch: {
      type: Boolean,
      default: !0
    },
    /**
     * Array of available options: Objects, Strings or Integers.
     * If array of objects, visible label will default to option.label.
     * If `labal` prop is passed, label will equal option['label']
     * @type {Array}
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @default false
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
     * Key to compare objects
     * @default 'id'
     * @type {String}
     */
    trackBy: {
      type: String
    },
    /**
     * Label to look for in option Object
     * @default 'label'
     * @type {String}
     */
    label: {
      type: String
    },
    /**
     * Enable/disable search in options
     * @default true
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: !0
    },
    /**
     * Clear the search input after `)
     * @default true
     * @type {Boolean}
     */
    clearOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Hide already selected options
     * @default false
     * @type {Boolean}
     */
    hideSelected: {
      type: Boolean,
      default: !1
    },
    /**
     * Equivalent to the `placeholder` attribute on a `<select>` input.
     * @default 'Select option'
     * @type {String}
     */
    placeholder: {
      type: String,
      default: "Select option"
    },
    /**
     * Allow to remove all selected values
     * @default true
     * @type {Boolean}
     */
    allowEmpty: {
      type: Boolean,
      default: !0
    },
    /**
     * Reset this.internalValue, this.search after this.internalValue changes.
     * Useful if want to create a stateless dropdown.
     * @default false
     * @type {Boolean}
     */
    resetAfter: {
      type: Boolean,
      default: !1
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Function to interpolate the custom label
     * @default false
     * @type {Function}
     */
    customLabel: {
      type: Function,
      default(t, e) {
        return wu(t) ? "" : e ? t[e] : t;
      }
    },
    /**
     * Disable / Enable tagging
     * @default false
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: !1
    },
    /**
     * String to show when highlighting a potential tag
     * @default 'Press enter to create a tag'
     * @type {String}
    */
    tagPlaceholder: {
      type: String,
      default: "Press enter to create a tag"
    },
    /**
     * By default new tags will appear above the search results.
     * Changing to 'bottom' will revert this behaviour
     * and will proritize the search results
     * @default 'top'
     * @type {String}
    */
    tagPosition: {
      type: String,
      default: "top"
    },
    /**
     * Number of allowed selected options. No limit if 0.
     * @default 0
     * @type {Number}
    */
    max: {
      type: [Number, Boolean],
      default: !1
    },
    /**
     * Will be passed with all events as second param.
     * Useful for identifying events origin.
     * @default null
     * @type {String|Integer}
    */
    id: {
      default: null
    },
    /**
     * Limits the options displayed in the dropdown
     * to the first X options.
     * @default 1000
     * @type {Integer}
    */
    optionsLimit: {
      type: Number,
      default: 1e3
    },
    /**
     * Name of the property containing
     * the group values
     * @default 1000
     * @type {String}
    */
    groupValues: {
      type: String
    },
    /**
     * Name of the property containing
     * the group label
     * @default 1000
     * @type {String}
    */
    groupLabel: {
      type: String
    },
    /**
     * Allow to select all group values
     * by selecting the group label
     * @default false
     * @type {Boolean}
     */
    groupSelect: {
      type: Boolean,
      default: !1
    },
    /**
     * Array of keyboard keys to block
     * when selecting
     * @default 1000
     * @type {String}
    */
    blockKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Prevent from wiping up the search value
     * @default false
     * @type {Boolean}
    */
    preserveSearch: {
      type: Boolean,
      default: !1
    },
    /**
     * Select 1st options if value is empty
     * @default false
     * @type {Boolean}
    */
    preselectFirst: {
      type: Boolean,
      default: !1
    },
    /**
     * Prevent autofocus
     * @default false
     * @type {Boolean}
     */
    preventAutofocus: {
      type: Boolean,
      default: !1
    },
    /**
     * Allows a custom function for sorting search/filtered results.
     * @default null
     * @type {Function}
     */
    filteringSortFunc: {
      type: Function,
      default: null
    }
  },
  mounted() {
    !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
  },
  computed: {
    internalValue() {
      return this.modelValue || this.modelValue === 0 ? Array.isArray(this.modelValue) ? this.modelValue : [this.modelValue] : [];
    },
    filteredOptions() {
      const t = this.search || "", e = t.toLowerCase().trim();
      let n = this.options.concat();
      return this.internalSearch ? n = this.groupValues ? this.filterAndFlat(n, e, this.label) : this.filterOptions(n, e, this.label, this.customLabel) : n = this.groupValues ? xu(this.groupValues, this.groupLabel)(n) : n, n = this.hideSelected ? n.filter(i3(this.isSelected)) : n, this.taggable && e.length && !this.isExistingOption(e) && (this.tagPosition === "bottom" ? n.push({ isTag: !0, label: t }) : n.unshift({ isTag: !0, label: t })), n.slice(0, this.optionsLimit);
    },
    valueKeys() {
      return this.trackBy ? this.internalValue.map((t) => t[this.trackBy]) : this.internalValue;
    },
    optionKeys() {
      return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map((e) => this.customLabel(e, this.label).toString().toLowerCase());
    },
    currentOptionLabel() {
      return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
    }
  },
  watch: {
    internalValue: {
      handler() {
        this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("update:modelValue", this.multiple ? [] : null));
      },
      deep: !0
    },
    search() {
      this.$emit("search-change", this.search);
    }
  },
  emits: ["open", "search-change", "close", "select", "update:modelValue", "remove", "tag"],
  methods: {
    /**
     * Returns the internalValue in a way it can be emited to the parent
     * @returns {Object||Array||String||Integer}
     */
    getValue() {
      return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
    },
    /**
     * Filters and then flattens the options list
     * @param  {Array}
     * @return {Array} returns a filtered and flat options list
     */
    filterAndFlat(t, e, n) {
      return dp(
        this.filterGroups(e, n, this.groupValues, this.groupLabel, this.customLabel),
        xu(this.groupValues, this.groupLabel)
      )(t);
    },
    /**
     * Flattens and then strips the group labels from the options list
     * @param  {Array}
     * @return {Array} returns a flat options list without group labels
     */
    flatAndStrip(t) {
      return dp(
        xu(this.groupValues, this.groupLabel),
        r3
      )(t);
    },
    /**
     * Updates the search value
     * @param  {String}
     */
    updateSearch(t) {
      this.search = t;
    },
    /**
     * Finds out if the given query is already present
     * in the available options
     * @param  {String}
     * @return {Boolean} returns true if element is available
     */
    isExistingOption(t) {
      return this.options ? this.optionKeys.indexOf(t) > -1 : !1;
    },
    /**
     * Finds out if the given element is already present
     * in the result value
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is selected
     */
    isSelected(t) {
      const e = this.trackBy ? t[this.trackBy] : t;
      return this.valueKeys.indexOf(e) > -1;
    },
    /**
     * Finds out if the given option is disabled
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is disabled
     */
    isOptionDisabled(t) {
      return !!t.$isDisabled;
    },
    /**
     * Returns empty string when options is null/undefined
     * Returns tag query if option is tag.
     * Returns the customLabel() results and casts it to string.
     *
     * @param  {Object||String||Integer} Passed option
     * @returns {Object||String}
     */
    getOptionLabel(t) {
      if (wu(t)) return "";
      if (t.isTag) return t.label;
      if (t.$isLabel) return t.$groupLabel;
      const e = this.customLabel(t, this.label);
      return wu(e) ? "" : e;
    },
    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select(t, e) {
      if (t.$isLabel && this.groupSelect) {
        this.selectGroup(t);
        return;
      }
      if (!(this.blockKeys.indexOf(e) !== -1 || this.disabled || t.$isDisabled || t.$isLabel) && !(this.max && this.multiple && this.internalValue.length === this.max) && !(e === "Tab" && !this.pointerDirty)) {
        if (t.isTag)
          this.$emit("tag", t.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();
        else {
          if (this.isSelected(t)) {
            e !== "Tab" && this.removeElement(t);
            return;
          }
          this.multiple ? this.$emit("update:modelValue", this.internalValue.concat([t])) : this.$emit("update:modelValue", t), this.$emit("select", t, this.id), this.clearOnSelect && (this.search = "");
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Add the given group options to the list of selected options
     * If all group optiona are already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} group to select/deselect
     */
    selectGroup(t) {
      const e = this.options.find((n) => n[this.groupLabel] === t.$groupLabel);
      if (e) {
        if (this.wholeGroupSelected(e)) {
          this.$emit("remove", e[this.groupValues], this.id);
          const n = this.trackBy ? e[this.groupValues].map((s) => s[this.trackBy]) : e[this.groupValues], i = this.internalValue.filter(
            (s) => n.indexOf(this.trackBy ? s[this.trackBy] : s) === -1
          );
          this.$emit("update:modelValue", i);
        } else {
          const n = e[this.groupValues].filter(
            (i) => !(this.isOptionDisabled(i) || this.isSelected(i))
          );
          this.max && n.splice(this.max - this.internalValue.length), this.$emit("select", n, this.id), this.$emit(
            "update:modelValue",
            this.internalValue.concat(n)
          );
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Helper to identify if all values in a group are selected
     *
     * @param {Object} group to validated selected values against
     */
    wholeGroupSelected(t) {
      return t[this.groupValues].every(
        (e) => this.isSelected(e) || this.isOptionDisabled(e)
      );
    },
    /**
     * Helper to identify if all values in a group are disabled
     *
     * @param {Object} group to check for disabled values
     */
    wholeGroupDisabled(t) {
      return t[this.groupValues].every(this.isOptionDisabled);
    },
    /**
     * Removes the given option from the selected options.
     * Additionally checks this.allowEmpty prop if option can be removed when
     * it is the last selected option.
     *
     * @param  {type} option description
     * @return {type}        description
     */
    removeElement(t, e = !0) {
      if (this.disabled || t.$isDisabled) return;
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();
        return;
      }
      const n = typeof t == "object" ? this.valueKeys.indexOf(t[this.trackBy]) : this.valueKeys.indexOf(t);
      if (this.multiple) {
        const i = this.internalValue.slice(0, n).concat(this.internalValue.slice(n + 1));
        this.$emit("update:modelValue", i);
      } else
        this.$emit("update:modelValue", null);
      this.$emit("remove", t, this.id), this.closeOnSelect && e && this.deactivate();
    },
    /**
     * Calls this.removeElement() with the last element
     * from this.internalValue (selected element Array)
     *
     * @fires this#removeElement
     */
    removeLastElement() {
      this.blockKeys.indexOf("Delete") === -1 && this.search.length === 0 && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
    },
    /**
     * Opens the multiselect’s dropdown.
     * Sets this.isOpen to TRUE
     */
    activate() {
      this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && this.pointer === 0 && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.preventAutofocus || this.$nextTick(() => this.$refs.search && this.$refs.search.focus())) : this.preventAutofocus || typeof this.$el < "u" && this.$el.focus(), this.$emit("open", this.id));
    },
    /**
     * Closes the multiselect’s dropdown.
     * Sets this.isOpen to FALSE
     */
    deactivate() {
      this.isOpen && (this.isOpen = !1, this.searchable ? this.$refs.search !== null && typeof this.$refs.search < "u" && this.$refs.search.blur() : typeof this.$el < "u" && this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
    },
    /**
     * Call this.activate() or this.deactivate()
     * depending on this.isOpen value.
     *
     * @fires this#activate || this#deactivate
     * @property {Boolean} isOpen indicates if dropdown is open
     */
    toggle() {
      this.isOpen ? this.deactivate() : this.activate();
    },
    /**
     * Updates the hasEnoughSpace variable used for
     * detecting where to expand the dropdown
     */
    adjustPosition() {
      if (typeof window > "u") return;
      const t = this.$el.getBoundingClientRect().top, e = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      e > this.maxHeight || e > t || this.openDirection === "below" || this.openDirection === "bottom" ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(e - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(t - 40, this.maxHeight));
    },
    /**
     * Filters and sorts the options ready for selection
     * @param {Array} options
     * @param {String} search
     * @param {String} label
     * @param {Function} customLabel
     * @returns {Array}
     */
    filterOptions(t, e, n, i) {
      return e ? t.filter((s) => s3(i(s, n), e)).sort((s, r) => typeof this.filteringSortFunc == "function" ? this.filteringSortFunc(s, r) : i(s, n).length - i(r, n).length) : t;
    },
    /**
     *
     * @param {String} search
     * @param {String} label
     * @param {String} values
     * @param {String} groupLabel
     * @param {function} customLabel
     * @returns {function(*): *}
     */
    filterGroups(t, e, n, i, s) {
      return (r) => r.map((a) => {
        if (!a[n])
          return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];
        const o = this.filterOptions(a[n], t, e, s);
        return o.length ? {
          [i]: a[i],
          [n]: o
        } : [];
      });
    }
  }
}, o3 = {
  data() {
    return {
      pointer: 0,
      pointerDirty: !1
    };
  },
  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: !0
    },
    optionHeight: {
      type: Number,
      default: 40
    }
  },
  computed: {
    pointerPosition() {
      return this.pointer * this.optionHeight;
    },
    visibleElements() {
      return this.optimizedHeight / this.optionHeight;
    }
  },
  watch: {
    filteredOptions() {
      this.pointerAdjust();
    },
    isOpen() {
      this.pointerDirty = !1;
    },
    pointer() {
      this.$refs.search && this.$refs.search.setAttribute("aria-activedescendant", this.id + "-" + this.pointer.toString());
    }
  },
  methods: {
    optionHighlight(t, e) {
      return {
        "multiselect__option--highlight": t === this.pointer && this.showPointer,
        "multiselect__option--selected": this.isSelected(e)
      };
    },
    groupHighlight(t, e) {
      if (!this.groupSelect)
        return [
          "multiselect__option--disabled",
          { "multiselect__option--group": e.$isLabel }
        ];
      const n = this.options.find((i) => i[this.groupLabel] === e.$groupLabel);
      return n && !this.wholeGroupDisabled(n) ? [
        "multiselect__option--group",
        { "multiselect__option--highlight": t === this.pointer && this.showPointer },
        { "multiselect__option--group-selected": this.wholeGroupSelected(n) }
      ] : "multiselect__option--disabled";
    },
    addPointerElement({ key: t } = "Enter") {
      this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], t), this.pointerReset();
    },
    pointerForward() {
      this.pointer < this.filteredOptions.length - 1 && (this.pointer++, this.$refs.list.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
    },
    pointerBackward() {
      this.pointer > 0 ? (this.pointer--, this.$refs.list.scrollTop >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
    },
    pointerReset() {
      this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
    },
    pointerAdjust() {
      this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
    },
    pointerSet(t) {
      this.pointer = t, this.pointerDirty = !0;
    }
  }
}, iv = {
  name: "vue-multiselect",
  mixins: [a3, o3],
  compatConfig: {
    MODE: 3,
    ATTR_ENUMERATED_COERCION: !1
  },
  props: {
    /**
       * name attribute to match optional label element
       * @default ''
       * @type {String}
       */
    name: {
      type: String,
      default: ""
    },
    /**
       * Presets the selected options value.
       * @type {Object||Array||String||Integer}
       */
    modelValue: {
      type: null,
      default() {
        return [];
      }
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectLabel: {
      type: String,
      default: "Press enter to select"
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectGroupLabel: {
      type: String,
      default: "Press enter to select group"
    },
    /**
       * String to show next to selected option
       * @default 'Selected'
       * @type {String}
       */
    selectedLabel: {
      type: String,
      default: "Selected"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectLabel: {
      type: String,
      default: "Press enter to remove"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectGroupLabel: {
      type: String,
      default: "Press enter to deselect group"
    },
    /**
       * Decide whether to show pointer labels
       * @default true
       * @type {Boolean}
       */
    showLabels: {
      type: Boolean,
      default: !0
    },
    /**
       * Limit the display of selected options. The rest will be hidden within the limitText string.
       * @default 99999
       * @type {Integer}
       */
    limit: {
      type: Number,
      default: 99999
    },
    /**
       * Sets maxHeight style value of the dropdown
       * @default 300
       * @type {Integer}
       */
    maxHeight: {
      type: Number,
      default: 300
    },
    /**
       * Function that process the message shown when selected
       * elements pass the defined limit.
       * @default 'and * more'
       * @param {Int} count Number of elements more than limit
       * @type {Function}
       */
    limitText: {
      type: Function,
      default: (t) => `and ${t} more`
    },
    /**
       * Set true to trigger the loading spinner.
       * @default False
       * @type {Boolean}
       */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
       * Disables the multiselect if true.
       * @default false
       * @type {Boolean}
       */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Enables search input's spellcheck if true.
     * @default false
     * @type {Boolean}
     */
    spellcheck: {
      type: Boolean,
      default: !1
    },
    /**
       * Fixed opening direction
       * @default ''
       * @type {String}
       */
    openDirection: {
      type: String,
      default: ""
    },
    /**
       * Shows slot with message about empty options
       * @default true
       * @type {Boolean}
       */
    showNoOptions: {
      type: Boolean,
      default: !0
    },
    showNoResults: {
      type: Boolean,
      default: !0
    },
    tabindex: {
      type: Number,
      default: 0
    },
    /**
     * Adds Required attribute to the input element when there is no value selected
     * @default false
     * @type {Boolean}
     */
    required: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hasOptionGroup() {
      return this.groupValues && this.groupLabel && this.groupSelect;
    },
    isSingleLabelVisible() {
      return (this.singleValue || this.singleValue === 0) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
    },
    isPlaceholderVisible() {
      return !this.internalValue.length && (!this.searchable || !this.isOpen);
    },
    visibleValues() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    singleValue() {
      return this.internalValue[0];
    },
    deselectLabelText() {
      return this.showLabels ? this.deselectLabel : "";
    },
    deselectGroupLabelText() {
      return this.showLabels ? this.deselectGroupLabel : "";
    },
    selectLabelText() {
      return this.showLabels ? this.selectLabel : "";
    },
    selectGroupLabelText() {
      return this.showLabels ? this.selectGroupLabel : "";
    },
    selectedLabelText() {
      return this.showLabels ? this.selectedLabel : "";
    },
    inputStyle() {
      return this.searchable || this.multiple && this.modelValue && this.modelValue.length ? this.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" } : "";
    },
    contentStyle() {
      return this.options.length ? { display: "inline-block" } : { display: "block" };
    },
    isAbove() {
      return this.openDirection === "above" || this.openDirection === "top" ? !0 : this.openDirection === "below" || this.openDirection === "bottom" ? !1 : this.preferredOpenDirection === "above";
    },
    showSearchInput() {
      return this.searchable && (this.hasSingleSelectedSlot && (this.visibleSingleValue || this.visibleSingleValue === 0) ? this.isOpen : !0);
    },
    isRequired() {
      return this.required === !1 ? !1 : this.internalValue.length <= 0;
    }
  }
};
const l3 = ["tabindex", "aria-expanded", "aria-owns", "aria-activedescendant"], u3 = {
  ref: "tags",
  class: "multiselect__tags"
}, c3 = { class: "multiselect__tags-wrap" }, d3 = ["textContent"], f3 = ["onKeypress", "onMousedown"], h3 = ["textContent"], m3 = { class: "multiselect__spinner" }, p3 = ["name", "id", "spellcheck", "placeholder", "required", "value", "disabled", "tabindex", "aria-label", "aria-controls"], g3 = ["id", "aria-multiselectable"], y3 = { key: 0 }, v3 = { class: "multiselect__option" }, b3 = ["aria-selected", "id", "role"], w3 = ["onClick", "onMouseenter", "data-select", "data-selected", "data-deselect"], x3 = ["data-select", "data-deselect", "onMouseenter", "onMousedown"], _3 = { class: "multiselect__option" }, k3 = { class: "multiselect__option" };
function M3(t, e, n, i, s, r) {
  return O(), R("div", {
    tabindex: t.searchable ? -1 : n.tabindex,
    class: me([{ "multiselect--active": t.isOpen, "multiselect--disabled": n.disabled, "multiselect--above": r.isAbove, "multiselect--has-options-group": r.hasOptionGroup }, "multiselect"]),
    onFocus: e[14] || (e[14] = (a) => t.activate()),
    onBlur: e[15] || (e[15] = (a) => t.searchable ? !1 : t.deactivate()),
    onKeydown: [
      e[16] || (e[16] = cn(et((a) => t.pointerForward(), ["self", "prevent"]), ["down"])),
      e[17] || (e[17] = cn(et((a) => t.pointerBackward(), ["self", "prevent"]), ["up"]))
    ],
    onKeypress: e[18] || (e[18] = cn(et((a) => t.addPointerElement(a), ["stop", "self"]), ["enter", "tab"])),
    onKeyup: e[19] || (e[19] = cn((a) => t.deactivate(), ["esc"])),
    role: "combobox",
    "aria-expanded": t.isOpen,
    "aria-owns": "listbox-" + t.id,
    "aria-activedescendant": t.isOpen && t.pointer !== null ? t.id + "-" + t.pointer : null
  }, [
    te(t.$slots, "caret", { toggle: t.toggle }, () => [
      J(
        "div",
        {
          onMousedown: e[0] || (e[0] = et((a) => t.toggle(), ["prevent", "stop"])),
          class: "multiselect__select"
        },
        null,
        32
        /* NEED_HYDRATION */
      )
    ]),
    te(t.$slots, "clear", { search: t.search }),
    J(
      "div",
      u3,
      [
        te(t.$slots, "selection", {
          search: t.search,
          remove: t.removeElement,
          values: r.visibleValues,
          isOpen: t.isOpen
        }, () => [
          Tt(J(
            "div",
            c3,
            [
              (O(!0), R(
                ye,
                null,
                Te(r.visibleValues, (a, o) => te(t.$slots, "tag", {
                  option: a,
                  search: t.search,
                  remove: t.removeElement
                }, () => [
                  (O(), R(
                    "span",
                    {
                      class: "multiselect__tag",
                      key: o,
                      onMousedown: e[1] || (e[1] = et(() => {
                      }, ["prevent"]))
                    },
                    [
                      J("span", {
                        textContent: ve(t.getOptionLabel(a))
                      }, null, 8, d3),
                      J("i", {
                        tabindex: "1",
                        onKeypress: cn(et((l) => t.removeElement(a), ["prevent"]), ["enter"]),
                        onMousedown: et((l) => t.removeElement(a), ["prevent"]),
                        class: "multiselect__tag-icon"
                      }, null, 40, f3)
                    ],
                    32
                    /* NEED_HYDRATION */
                  ))
                ])),
                256
                /* UNKEYED_FRAGMENT */
              ))
            ],
            512
            /* NEED_PATCH */
          ), [
            [sn, r.visibleValues.length > 0]
          ]),
          t.internalValue && t.internalValue.length > n.limit ? te(t.$slots, "limit", { key: 0 }, () => [
            J("strong", {
              class: "multiselect__strong",
              textContent: ve(n.limitText(t.internalValue.length - n.limit))
            }, null, 8, h3)
          ]) : U("v-if", !0)
        ]),
        Ce(Bn, { name: "multiselect__loading" }, {
          default: be(() => [
            te(t.$slots, "loading", {}, () => [
              Tt(J(
                "div",
                m3,
                null,
                512
                /* NEED_PATCH */
              ), [
                [sn, n.loading]
              ])
            ])
          ]),
          _: 3
          /* FORWARDED */
        }),
        t.searchable ? (O(), R("input", {
          key: 0,
          ref: "search",
          name: n.name,
          id: t.id,
          type: "text",
          autocomplete: "off",
          spellcheck: n.spellcheck,
          placeholder: t.placeholder,
          required: r.isRequired,
          style: tt(r.inputStyle),
          value: t.search,
          disabled: n.disabled,
          tabindex: n.tabindex,
          "aria-label": n.name + "-searchbox",
          onInput: e[2] || (e[2] = (a) => t.updateSearch(a.target.value)),
          onFocus: e[3] || (e[3] = et((a) => t.activate(), ["prevent"])),
          onBlur: e[4] || (e[4] = et((a) => t.deactivate(), ["prevent"])),
          onKeyup: e[5] || (e[5] = cn((a) => t.deactivate(), ["esc"])),
          onKeydown: [
            e[6] || (e[6] = cn(et((a) => t.pointerForward(), ["prevent"]), ["down"])),
            e[7] || (e[7] = cn(et((a) => t.pointerBackward(), ["prevent"]), ["up"])),
            e[9] || (e[9] = cn(et((a) => t.removeLastElement(), ["stop"]), ["delete"]))
          ],
          onKeypress: e[8] || (e[8] = cn(et((a) => t.addPointerElement(a), ["prevent", "stop", "self"]), ["enter"])),
          class: "multiselect__input",
          "aria-controls": "listbox-" + t.id
        }, null, 44, p3)) : U("v-if", !0),
        r.isSingleLabelVisible ? (O(), R(
          "span",
          {
            key: 1,
            class: "multiselect__single",
            onMousedown: e[10] || (e[10] = et((...a) => t.toggle && t.toggle(...a), ["prevent"]))
          },
          [
            te(t.$slots, "singleLabel", { option: r.singleValue }, () => [
              He(
                ve(t.currentOptionLabel),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : U("v-if", !0),
        r.isPlaceholderVisible ? (O(), R(
          "span",
          {
            key: 2,
            class: "multiselect__placeholder",
            onMousedown: e[11] || (e[11] = et((...a) => t.toggle && t.toggle(...a), ["prevent"]))
          },
          [
            te(t.$slots, "placeholder", {}, () => [
              He(
                ve(t.placeholder),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : U("v-if", !0)
      ],
      512
      /* NEED_PATCH */
    ),
    Ce(Bn, {
      name: "multiselect",
      persisted: ""
    }, {
      default: be(() => [
        Tt(J(
          "div",
          {
            class: "multiselect__content-wrapper",
            onFocus: e[12] || (e[12] = (...a) => t.activate && t.activate(...a)),
            tabindex: "-1",
            onMousedown: e[13] || (e[13] = et(() => {
            }, ["prevent"])),
            style: tt({ maxHeight: t.optimizedHeight + "px" }),
            ref: "list"
          },
          [
            J("ul", {
              class: "multiselect__content",
              style: tt(r.contentStyle),
              role: "listbox",
              id: "listbox-" + t.id,
              "aria-multiselectable": t.multiple
            }, [
              te(t.$slots, "beforeList"),
              t.multiple && t.max === t.internalValue.length ? (O(), R("li", y3, [
                J("span", v3, [
                  te(t.$slots, "maxElements", {}, () => [
                    He(
                      "Maximum of " + ve(t.max) + " options selected. First remove a selected option to select another.",
                      1
                      /* TEXT */
                    )
                  ])
                ])
              ])) : U("v-if", !0),
              !t.max || t.internalValue.length < t.max ? (O(!0), R(
                ye,
                { key: 1 },
                Te(t.filteredOptions, (a, o) => (O(), R("li", {
                  class: "multiselect__element",
                  key: o,
                  "aria-selected": t.isSelected(a),
                  id: t.id + "-" + o,
                  role: a && (a.$isLabel || a.$isDisabled) ? null : "option"
                }, [
                  a && (a.$isLabel || a.$isDisabled) ? U("v-if", !0) : (O(), R("span", {
                    key: 0,
                    class: me([t.optionHighlight(o, a), "multiselect__option"]),
                    onClick: et((l) => t.select(a), ["stop"]),
                    onMouseenter: et((l) => t.pointerSet(o), ["self"]),
                    "data-select": a && a.isTag ? t.tagPlaceholder : r.selectLabelText,
                    "data-selected": r.selectedLabelText,
                    "data-deselect": r.deselectLabelText
                  }, [
                    te(t.$slots, "option", {
                      option: a,
                      search: t.search,
                      index: o
                    }, () => [
                      J(
                        "span",
                        null,
                        ve(t.getOptionLabel(a)),
                        1
                        /* TEXT */
                      )
                    ])
                  ], 42, w3)),
                  a && (a.$isLabel || a.$isDisabled) ? (O(), R("span", {
                    key: 1,
                    "data-select": t.groupSelect && r.selectGroupLabelText,
                    "data-deselect": t.groupSelect && r.deselectGroupLabelText,
                    class: me([t.groupHighlight(o, a), "multiselect__option"]),
                    onMouseenter: et((l) => t.groupSelect && t.pointerSet(o), ["self"]),
                    onMousedown: et((l) => t.selectGroup(a), ["prevent"])
                  }, [
                    te(t.$slots, "option", {
                      option: a,
                      search: t.search,
                      index: o
                    }, () => [
                      J(
                        "span",
                        null,
                        ve(t.getOptionLabel(a)),
                        1
                        /* TEXT */
                      )
                    ])
                  ], 42, x3)) : U("v-if", !0)
                ], 8, b3))),
                128
                /* KEYED_FRAGMENT */
              )) : U("v-if", !0),
              Tt(J(
                "li",
                null,
                [
                  J("span", _3, [
                    te(t.$slots, "noResult", { search: t.search }, () => [
                      e[20] || (e[20] = He("No elements found. Consider changing the search query."))
                    ])
                  ])
                ],
                512
                /* NEED_PATCH */
              ), [
                [sn, n.showNoResults && t.filteredOptions.length === 0 && t.search && !n.loading]
              ]),
              Tt(J(
                "li",
                null,
                [
                  J("span", k3, [
                    te(t.$slots, "noOptions", {}, () => [
                      e[21] || (e[21] = He("List is empty."))
                    ])
                  ])
                ],
                512
                /* NEED_PATCH */
              ), [
                [sn, n.showNoOptions && (t.options.length === 0 || r.hasOptionGroup === !0 && t.filteredOptions.length === 0) && !t.search && !n.loading]
              ]),
              te(t.$slots, "afterList")
            ], 12, g3)
          ],
          36
          /* STYLE, NEED_HYDRATION */
        ), [
          [sn, t.isOpen]
        ])
      ]),
      _: 3
      /* FORWARDED */
    })
  ], 42, l3);
}
iv.render = M3;
const S3 = { class: "flex flex-col gap-2" }, O3 = {
  key: 0,
  class: "text-sm font-medium"
}, ME = {
  __name: "InputSelect",
  props: /* @__PURE__ */ Mn({
    /**
     *  An array of options.  If array of objects, visible label will be the label prop.
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * toggles the search functionality
     */
    searchable: {
      type: Boolean,
      default: !1
    },
    /**
     * track-by is used to identify the option within the options list thus it’s value has to be unique.
     * In this example the name property is unique across all options,
     * so it can be used as track-by value.
     */
    trackBy: {
      type: String,
      default: ""
    },
    /**
     * label is used to display the option
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * text to display when no value has been selected
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     *   String to show when pointing to an option
     */
    selectLabel: {
      type: String,
      default: ""
    },
    /**
     * String to show when pointing to an already selected option
     */
    deselectLabel: {
      type: String,
      default: ""
    },
    /**
     *  String to show next to selected option
     */
    selectedLabel: {
      type: String,
      default: ""
    },
    selectTitle: {
      type: String,
      default: ""
    },
    helperText: {
      type: String,
      default: ""
    },
    stateError: {
      type: Boolean,
      default: !1
    },
    stateSuccess: {
      type: Boolean,
      default: !1
    }
  }, {
    modelValue: {
      type: [Object, Number, String]
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = Hn(t, "modelValue"), n = ur();
    return (i, s) => (O(), R("div", S3, [
      t.selectTitle ? (O(), R("p", O3, [
        He(ve(t.selectTitle) + " ", 1),
        i.$slots.labelSuffix ? te(i.$slots, "labelSuffix", { key: 0 }) : U("", !0)
      ])) : U("", !0),
      Ce(C(iv), {
        id: C(n),
        modelValue: e.value,
        "onUpdate:modelValue": s[0] || (s[0] = (r) => e.value = r),
        options: t.options,
        searchable: t.searchable,
        "track-by": t.trackBy,
        label: t.label,
        placeholder: t.placeholder,
        "select-label": t.selectLabel,
        "deselect-label": t.deselectLabel,
        "selected-label": t.selectedLabel,
        class: me({ "has-error": t.stateError })
      }, null, 8, ["id", "modelValue", "options", "searchable", "track-by", "label", "placeholder", "select-label", "deselect-label", "selected-label", "class"]),
      t.helperText ? (O(), R("div", {
        key: 1,
        class: me([
          "text-sm",
          t.stateError ? "text-danger-600" : t.stateSuccess ? "text-success-600" : "text-gray-500"
        ])
      }, ve(t.helperText), 3)) : U("", !0)
    ]));
  }
}, D3 = { class: "flex items-center" }, T3 = ["id", "name", "value", "onChange"], P3 = ["for"], SE = {
  __name: "RadioButton",
  props: {
    initialValue: {
      type: [String, Number, Boolean, Date],
      default: null
    },
    items: {
      type: Array,
      required: !0,
      /**
       * Must have the following structure:
       * [
       *   { label: "label", value: "value" },
       *   ...
       * ]
       */
      validator: (t) => t.every((e) => Object.hasOwn(e, "label") && Object.hasOwn(e, "value"))
    }
  },
  emits: {
    selectionChanged: null
  },
  setup(t, { expose: e, emit: n }) {
    const i = t, s = n;
    e({
      setSelection: o
    });
    const r = ee(i.initialValue), a = ur();
    function o(l) {
      r.value = l, s("selectionChanged", l);
    }
    return (l, u) => (O(), R("div", D3, [
      (O(!0), R(ye, null, Te(t.items, (c, d) => Tt((O(), R("input", {
        id: `${C(a)}-radio-${d}`,
        key: d,
        "onUpdate:modelValue": u[0] || (u[0] = (f) => r.value = f),
        type: "radio",
        name: `${C(a)}-radio`,
        value: c.value,
        class: "hidden",
        onChange: (f) => l.$emit("selectionChanged", c.value)
      }, null, 40, T3)), [
        [gp, r.value]
      ])), 128)),
      (O(!0), R(ye, null, Te(t.items, (c, d) => (O(), R("label", {
        key: d,
        for: `${C(a)}-radio-${d}`,
        class: me([
          "last-of-type:border-r-1 flex h-10 items-center justify-center border border-r-0 px-4 first-of-type:rounded-l-lg last-of-type:rounded-r-lg last-of-type:border-r",
          r.value == c.value ? "border-gray-900 bg-gray-900 text-white hover:bg-gray-700 active:bg-gray-600" : "border-gray-200 bg-white text-base hover:bg-gray-100 active:bg-gray-200"
        ])
      }, [
        Ce(As, { class: "flex items-center" }, {
          default: be(() => [
            te(l.$slots, c.value, {
              label: c.label
            }, () => [
              He(ve(c.label), 1)
            ])
          ]),
          _: 2
        }, 1024)
      ], 10, P3))), 128))
    ]));
  }
}, C3 = {
  key: 0,
  class: "flex h-6 w-[13px] justify-center"
}, A3 = ["onClick"], E3 = {
  key: 0,
  class: "size-[7px] rounded-full bg-primary-500"
}, OE = {
  __name: "VerticalStepper",
  props: /* @__PURE__ */ Mn({
    items: {
      type: Array,
      required: !0
    }
  }, {
    modelValue: {
      type: Number,
      default: 0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = Hn(t, "modelValue");
    function n(i, s) {
      i.disabled || (e.value = s);
    }
    return (i, s) => (O(), R("div", null, [
      (O(!0), R(ye, null, Te(t.items, (r, a) => (O(), R("div", { key: a }, [
        a > 0 ? (O(), R("div", C3, [
          J("div", {
            class: me(["h-full w-px", a > e.value ? "bg-gray-300" : "bg-primary-500"])
          }, null, 2)
        ])) : U("", !0),
        J("div", {
          class: me(["group flex h-[13px] items-center", r.disabled ? "text-gray-300" : "cursor-pointer"]),
          onClick: (o) => n(r, a)
        }, [
          J("div", {
            class: me(["flex size-[13px] items-center justify-center rounded-full border", [
              e.value >= a ? "border-primary-500" : "border-gray-300",
              { "bg-primary-500": r.done && e.value > a }
            ]])
          }, [
            a === e.value ? (O(), R("div", E3)) : r.done || r.error ? (O(), Se(Xt, {
              key: 1,
              name: r.error ? "close" : "check",
              class: me(
                a > e.value ? "text-gray-300" : r.done ? "text-white" : "text-primary-500"
              )
            }, null, 8, ["name", "class"])) : U("", !0)
          ], 2),
          J("div", {
            class: me(["ml-2 rounded-lg px-2 py-1", { "group-hover:bg-white": !r.disabled }])
          }, [
            J("p", null, ve(r.label), 1)
          ], 2)
        ], 10, A3)
      ]))), 128))
    ]));
  }
}, $3 = { class: "flex flex-col gap-4" }, R3 = { class: "flex gap-6 border-b border-gray-100" }, L3 = ["onClick"], DE = {
  __name: "TabbedViews",
  props: /* @__PURE__ */ Mn({
    /**
     * Array of labels and views for each tab:
     * [
     *   { name: "Tab A", view: ViewA },
     *   { name: "Tab B", view: ViewB },
     * ]
     */
    tabs: {
      type: Array,
      required: !0
    }
  }, {
    modelValue: {
      type: Number,
      default: 0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = Hn(t, "modelValue");
    return (n, i) => (O(), R("div", $3, [
      J("div", R3, [
        (O(!0), R(ye, null, Te(t.tabs, (s, r) => (O(), R("div", {
          key: r,
          class: me([
            "-mb-px border-b border-transparent py-4 font-medium hover:border-gray",
            e.value === r ? "cursor-default !border-primary text-primary" : "cursor-pointer"
          ]),
          onClick: (a) => e.value = r
        }, ve(s.name), 11, L3))), 128))
      ]),
      (O(), Se(Js(t.tabs[e.value].view)))
    ]));
  }
}, I3 = { class: "flex items-center border-b border-gray-100 bg-white" }, F3 = { class: "flex-1" }, V3 = ["alt", "src"], N3 = { class: "mt-1 text-xs font-medium uppercase text-gray-900" }, B3 = { class: "flex flex-1 items-center justify-end gap-4 px-4" }, z3 = { class: "font-medium" }, TE = {
  __name: "NavbarComponent",
  props: {
    link: {
      type: Object,
      default: () => ({
        name: "simulations"
      })
    },
    title: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: "repowered"
    },
    logoSubtitle: {
      type: String,
      default: "Battery Simulation Tool"
    },
    userName: {
      type: String,
      default: ""
    },
    isAuthenticated: {
      type: Boolean,
      required: !0
    }
  },
  emits: ["logout"],
  setup(t, { emit: e }) {
    const n = e;
    return (i, s) => {
      const r = mv("router-link");
      return O(), R("nav", I3, [
        J("div", F3, [
          Ce(r, {
            to: t.link,
            class: "flex h-16 w-fit cursor-pointer flex-col justify-center px-4 py-1 text-primary hover:bg-gray-100"
          }, {
            default: be(() => [
              J("img", {
                id: "logo",
                alt: `${t.theme} logo`,
                class: "max-h-6 w-auto",
                src: `/assets/theme/${t.theme}/logo.svg`
              }, null, 8, V3),
              J("p", N3, ve(t.logoSubtitle), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        J("p", null, ve(t.title), 1),
        J("div", B3, [
          t.isAuthenticated ? (O(), R(ye, { key: 0 }, [
            J("span", z3, [
              J("p", null, ve(t.userName), 1)
            ]),
            Ce(Vs, {
              color: "secondary",
              small: "",
              onClick: s[0] || (s[0] = (a) => n("logout"))
            }, {
              default: be(() => [
                Ce(Xt, {
                  name: "logout-box",
                  class: "mr-1 text-lg"
                }),
                s[1] || (s[1] = J("span", null, "Uitloggen", -1))
              ]),
              _: 1,
              __: [1]
            })
          ], 64)) : U("", !0)
        ])
      ]);
    };
  }
}, W3 = { class: "mb-4 flex overflow-hidden rounded-xl border border-gray-200" }, H3 = ["onClick"], PE = {
  __name: "BaseTabs",
  props: {
    tabs: {
      type: Array,
      required: !0
    }
  },
  emits: ["switch"],
  setup(t, { emit: e }) {
    const n = t, i = e, s = ee(n.tabs[0].id);
    function r(a) {
      s.value !== a.id && (s.value = a.id, i("switch", s.value));
    }
    return (a, o) => (O(), R("div", null, [
      J("div", W3, [
        (O(!0), R(ye, null, Te(t.tabs, (l) => (O(), R("div", {
          key: l,
          class: me([
            "grow p-2 text-center",
            l.id === s.value ? "bg-gray-900 text-white" : "cursor-pointer"
          ]),
          onClick: (u) => r(l)
        }, ve(l.name), 11, H3))), 128))
      ]),
      (O(!0), R(ye, null, Te(t.tabs, (l) => Tt((O(), R("div", {
        key: l.id
      }, [
        Ce(yp, { class: "mt-4 overflow-hidden" }, {
          default: be(() => [
            te(a.$slots, l.id)
          ]),
          _: 2
        }, 1024)
      ])), [
        [sn, l.id === s.value]
      ])), 128))
    ]));
  }
}, Y3 = {
  beforeMount(t, e) {
    function n(i) {
      t === i.target || t.contains(i.target) || (e.value(), i.stopPropagation());
    }
    t.clickOutsideEvent = n, document.addEventListener("click", n, !0);
  },
  unmounted(t) {
    document.removeEventListener("click", t.clickOutsideEvent, !0);
  }
}, j3 = { class: "flex items-center gap-1" }, q3 = ["onClick"], fp = 4, CE = {
  __name: "ContextMenu",
  props: /* @__PURE__ */ Mn({
    items: {
      type: Array,
      required: !0
    }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = Hn(t, "modelValue"), n = ee(), i = ee(), { floatingStyles: s } = Pc(n, i, {
      whileElementsMounted: Oc,
      placement: "bottom-start",
      middleware: [Dc(fp), Tc({ padding: fp })]
    });
    function r(a) {
      e.value = !1, a == null || a();
    }
    return (a, o) => (O(), R(ye, null, [
      J("div", {
        ref_key: "anchorRef",
        ref: n,
        class: "size-fit",
        onClick: o[0] || (o[0] = (l) => e.value = !0)
      }, [
        te(a.$slots, "trigger", {}, () => [
          Ce(Vs, bt(a.$attrs, { active: e.value }), {
            default: be(() => [
              J("div", j3, [
                te(a.$slots, "default", {}, () => [
                  o[2] || (o[2] = He("Open"))
                ]),
                Ce(Xt, {
                  filled: "",
                  name: "arrow-down-s"
                })
              ])
            ]),
            _: 3
          }, 16, ["active"])
        ])
      ], 512),
      e.value ? Tt((O(), R("div", {
        key: 0,
        ref_key: "tooltipRef",
        ref: i,
        class: "absolute z-10 min-w-32 overflow-hidden rounded-lg bg-white shadow",
        style: tt(C(s)),
        onKeydown: o[1] || (o[1] = cn((l) => e.value = !1, ["esc"]))
      }, [
        (O(!0), R(ye, null, Te(t.items, (l, u) => (O(), R("div", {
          key: u,
          class: me([
            l ? "flex cursor-pointer items-center gap-2 px-4 py-2 hover:bg-gray-100" : "border-t border-gray-200",
            l == null ? void 0 : l.classes
          ]),
          onClick: et((c) => r(l.action), ["stop"])
        }, [
          l ? (O(), R(ye, { key: 0 }, [
            l.icon ? (O(), Se(Xt, {
              key: 0,
              name: l.icon,
              filled: "",
              class: "text-xl"
            }, null, 8, ["name"])) : U("", !0),
            J("span", null, ve(l.label), 1)
          ], 64)) : U("", !0)
        ], 10, q3))), 128))
      ], 36)), [
        [C(Y3), () => e.value = !1]
      ]) : U("", !0)
    ], 64));
  }
}, U3 = {}, X3 = { class: "text-base font-normal text-gray-500" };
function G3(t, e) {
  return O(), R("div", X3, [
    te(t.$slots, "default")
  ]);
}
const AE = /* @__PURE__ */ pn(U3, [["render", G3]]), Z3 = {}, K3 = { class: "text-xl font-bold text-gray-500 md:text-2xl" };
function Q3(t, e) {
  return O(), R("h1", K3, [
    te(t.$slots, "default")
  ]);
}
const EE = /* @__PURE__ */ pn(Z3, [["render", Q3]]), J3 = {}, eE = { class: "border-b border-gray-200 pb-4 text-2xl font-medium md:text-5xl md:font-normal" };
function tE(t, e) {
  return O(), R("h1", eE, [
    te(t.$slots, "default")
  ]);
}
const $E = /* @__PURE__ */ pn(J3, [["render", tE]]), nE = {}, iE = { class: "text-base font-bold md:text-xl" };
function sE(t, e) {
  return O(), R("h3", iE, [
    te(t.$slots, "default")
  ]);
}
const RE = /* @__PURE__ */ pn(nE, [["render", sE]]), rE = {}, aE = { class: "text-lg font-medium md:text-2xl" };
function oE(t, e) {
  return O(), R("h2", aE, [
    te(t.$slots, "default")
  ]);
}
const LE = /* @__PURE__ */ pn(rE, [["render", oE]]), lE = {
  key: 1,
  class: "grid w-fit grid-cols-3 gap-[2px]"
}, uE = {
  __name: "LoadingWrapper",
  props: {
    error: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    compact: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    return (e, n) => t.error || t.loading ? (O(), R("div", {
      key: 0,
      class: me(["flex size-full items-center", t.compact ? "min-h-5" : "min-h-14 justify-center"])
    }, [
      t.error ? (O(), R("div", {
        key: 0,
        class: me(["flex items-center text-gray-400", t.compact ? "gap-1" : "flex-col"])
      }, [
        Ce(Xt, {
          name: "close-circle",
          filled: "",
          class: me(t.compact ? "text-xl" : "text-3xl")
        }, null, 8, ["class"]),
        n[0] || (n[0] = J("p", { class: "text-sm" }, "Niet beschikbaar", -1))
      ], 2)) : t.loading ? (O(), R("div", lE, [
        (O(!0), R(ye, null, Te(t.compact ? 3 : 9, (i) => (O(), R("div", {
          key: i,
          class: "pulse size-2 rounded-full bg-primary",
          style: tt({ animationDelay: `${(i - 1) % 3 / 3 - 1}s` })
        }, null, 4))), 128))
      ])) : U("", !0)
    ], 2)) : te(e.$slots, "default", { key: 1 }, void 0, !0);
  }
}, IE = /* @__PURE__ */ pn(uE, [["__scopeId", "data-v-b240a329"]]);
export {
  fE as BaseBadge,
  Vs as BaseButton,
  yp as BaseCard,
  Mv as BaseDivider,
  hE as BaseDrawer,
  Xt as BaseIcon,
  pE as BaseTable,
  PE as BaseTabs,
  mE as BaseTooltip,
  kE as CheckboxItem,
  CE as ContextMenu,
  _E as DatePicker,
  Tv as EscapeOverlay,
  wC as InputField,
  Jm as InputItems,
  xE as InputItemsFilter,
  ME as InputSelect,
  IE as LoadingWrapper,
  gE as MetricDisplay,
  TE as NavbarComponent,
  SE as RadioButton,
  K5 as RadioButtonList,
  yE as StatDisplayHorizontal,
  DE as TabbedViews,
  AE as TextDescription,
  EE as TextDrawerTitle,
  $E as TextHeader,
  As as TextLabel,
  RE as TextSubtitle,
  LE as TextTitle,
  wE as TimeseriesChart,
  OE as VerticalStepper
};
//# sourceMappingURL=ui-component-library.js.map
